/* tslint:disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ACCOUNT_HOLDER_STATUS {
  Active = "Active",
  Closed = "Closed",
  Inactive = "Inactive",
  Suspended = "Suspended",
}

export enum ALLERGEN {
  CELERY = "CELERY",
  CRUSTACEANS = "CRUSTACEANS",
  EGGS = "EGGS",
  FISH = "FISH",
  GLUTEN = "GLUTEN",
  LUPIN = "LUPIN",
  MILK = "MILK",
  MOLLUSCS = "MOLLUSCS",
  MUSTARD = "MUSTARD",
  NUTS = "NUTS",
  PEANUTS = "PEANUTS",
  SESAME = "SESAME",
  SOYBEANS = "SOYBEANS",
  SULPHITES = "SULPHITES",
  SULPHUR_DIOXIDE = "SULPHUR_DIOXIDE",
}

export enum AccountingProvider {
  BJORN_LUNDEN = "BJORN_LUNDEN",
  EXTERNAL = "EXTERNAL",
  FORTNOX = "FORTNOX",
  SIE = "SIE",
  VISMA = "VISMA",
  XERO = "XERO",
}

export enum AdyenEntityType {
  Business = "Business",
  Individual = "Individual",
  NonProfit = "NonProfit",
  Partnership = "Partnership",
  PublicCompany = "PublicCompany",
}

export enum AdyenShareholderType {
  Controller = "Controller",
  Owner = "Owner",
  Signatory = "Signatory",
}

export enum BAEMINGO_PRODUCT {
  ACCOUNTING = "ACCOUNTING",
  APP = "APP",
  BANK = "BANK",
  BOOKINGS = "BOOKINGS",
  CASH_DRAWER = "CASH_DRAWER",
  CUSTOMER_DISPLAY = "CUSTOMER_DISPLAY",
  EPOS = "EPOS",
  GIFTCARD = "GIFTCARD",
  HANDHELD_ORDER = "HANDHELD_ORDER",
  HANDHELD_PAY = "HANDHELD_PAY",
  HANDHELD_PRO = "HANDHELD_PRO",
  INSIGHTS = "INSIGHTS",
  INSIGHTS_YEAR = "INSIGHTS_YEAR",
  INVENTORY = "INVENTORY",
  KDS = "KDS",
  KIT_BASIC = "KIT_BASIC",
  KIT_EXTENDED = "KIT_EXTENDED",
  LIGHT = "LIGHT",
  LOYALTY_PRO = "LOYALTY_PRO",
  QSR = "QSR",
  RECEIPT_PAPER = "RECEIPT_PAPER",
  RECEIPT_PRINTER = "RECEIPT_PRINTER",
  S1F2 = "S1F2",
  STAFF_LEDGER = "STAFF_LEDGER",
  SUPPORT_SUNRISE = "SUPPORT_SUNRISE",
  SUPPORT_SUNSET = "SUPPORT_SUNSET",
  TABLET = "TABLET",
  TABLET_STAND = "TABLET_STAND",
  TSR = "TSR",
  WAITER_AID = "WAITER_AID",
  WASTE = "WASTE",
}

export enum BILL_PAYMENT_TYPE {
  EVERYTHING = "EVERYTHING",
  OWN_ITEMS = "OWN_ITEMS",
  PICK_ITEMS = "PICK_ITEMS",
  SPLIT_EQUAL = "SPLIT_EQUAL",
}

export enum CONTENT_STATUS {
  DISABLED = "DISABLED",
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
}

export enum CONTENT_TYPE {
  HERO = "HERO",
  NEWSLETTER = "NEWSLETTER",
  SIDEBAR = "SIDEBAR",
  VENUE = "VENUE",
}

export enum CURRENCY {
  AED = "AED",
  DKK = "DKK",
  EUR = "EUR",
  GBP = "GBP",
  NOK = "NOK",
  SEK = "SEK",
  TRY = "TRY",
  USD = "USD",
}

export enum DAY_OF_WEEK {
  FRIDAY = "FRIDAY",
  MONDAY = "MONDAY",
  SATURDAY = "SATURDAY",
  SUNDAY = "SUNDAY",
  THURSDAY = "THURSDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
}

export enum DEVICE_OS {
  ANDROID = "ANDROID",
  IOS = "IOS",
}

export enum DISCOUNT_TYPE {
  FIXED = "FIXED",
  PERCENTAGE = "PERCENTAGE",
  PRICE = "PRICE",
}

export enum GENERATED_REPORT_TYPE {
  INVENTORY = "INVENTORY",
  PAYOUTS = "PAYOUTS",
  SALES = "SALES",
  STAFF = "STAFF",
}

export enum GIFTCARD_STATUS {
  ACTIVE = "ACTIVE",
  EXPIRED = "EXPIRED",
  INACTIVE = "INACTIVE",
}

export enum HotelOperaEnvironmentStatus {
  ACTIVE = "ACTIVE",
  PENDING_BAEMINGO = "PENDING_BAEMINGO",
}

export enum INVOICE_ACCOUNT_PAYMENT_STATUS {
  PAID = "PAID",
  UNPAID = "UNPAID",
}

export enum ITEM_SIZE_TYPE {
  LE_CROISSANT_CUP_SIZE = "LE_CROISSANT_CUP_SIZE",
  PIZZABAKEREN_DEFAULT_PIZZA = "PIZZABAKEREN_DEFAULT_PIZZA",
}

export enum ImageOrderByInput {
  createdAt_ASC = "createdAt_ASC",
  createdAt_DESC = "createdAt_DESC",
  id_ASC = "id_ASC",
  id_DESC = "id_DESC",
  title_ASC = "title_ASC",
  title_DESC = "title_DESC",
  updatedAt_ASC = "updatedAt_ASC",
  updatedAt_DESC = "updatedAt_DESC",
}

export enum IntegrationsCustomerType {
  COMPANY = "COMPANY",
  PRIVATE = "PRIVATE",
  UNKNOWN = "UNKNOWN",
}

export enum InvoiceTargetType {
  COMPANY = "COMPANY",
  PRIVATE = "PRIVATE",
}

export enum LICENSE_PROVIDER {
  AFP = "AFP",
  BAEMINGO = "BAEMINGO",
  STRIPE = "STRIPE",
}

export enum LICENSE_STATUS {
  ACTIVE = "ACTIVE",
  CANCELLED = "CANCELLED",
  PAUSED = "PAUSED",
  UNPAID = "UNPAID",
}

export enum LOGIN_METHOD {
  BANKID = "BANKID",
  EMAIL = "EMAIL",
  PHONE = "PHONE",
}

export enum LOG_LEVEL {
  ACTION = "ACTION",
  DEBUG = "DEBUG",
  ERROR = "ERROR",
  FATAL = "FATAL",
  INFO = "INFO",
  TIMER = "TIMER",
  WARN = "WARN",
}

export enum LOG_TYPE {
  CREATE = "CREATE",
  DELETE = "DELETE",
  PROMOTE = "PROMOTE",
  READ = "READ",
  REJECT = "REJECT",
  UPDATE = "UPDATE",
  UPLOAD = "UPLOAD",
}

export enum MEMBERSHIP_PERIOD {
  MONTH = "MONTH",
  WEEK = "WEEK",
  YEAR = "YEAR",
}

export enum MEMBERSHIP_SOURCE_TYPE {
  CARD_TRADEIN = "CARD_TRADEIN",
  DEFAULT = "DEFAULT",
  POINTS = "POINTS",
  PROMO_CODE = "PROMO_CODE",
  VENUE_MANAGER = "VENUE_MANAGER",
}

export enum MODIFICATION_GROUP_TYPE {
  MULTIPLE = "MULTIPLE",
  SINGLE = "SINGLE",
}

export enum NOTIFICATION_TARGET {
  APP = "APP",
  OM = "OM",
}

export enum OFFER_CONTEXT {
  APP = "APP",
  POS = "POS",
}

export enum OFFER_TYPE {
  BUNDLE = "BUNDLE",
  ITEM_DISCOUNT = "ITEM_DISCOUNT",
  ORDER_DISCOUNT = "ORDER_DISCOUNT",
  STAGED_BUNDLE = "STAGED_BUNDLE",
  STAGED_INDIVIDUAL = "STAGED_INDIVIDUAL",
  VISUAL = "VISUAL",
}

export enum ONBOARDING_EVENT_STEP {
  ADDED_CATEGORIES = "ADDED_CATEGORIES",
  ADDED_COURSE_TYPES = "ADDED_COURSE_TYPES",
  ADDED_PRODUCTS = "ADDED_PRODUCTS",
  CLAIMED_DEVICE = "CLAIMED_DEVICE",
  CREATED_FLOOR_PLAN = "CREATED_FLOOR_PLAN",
  CREATED_POS_LAYOUT = "CREATED_POS_LAYOUT",
  CREATED_STAFF = "CREATED_STAFF",
  CREATED_STATION = "CREATED_STATION",
  FILLED_IN_COMPANY_INFORMATION = "FILLED_IN_COMPANY_INFORMATION",
  FIRST_SALE = "FIRST_SALE",
}

export enum ONBOARDING_EVENT_TYPE {
  CUSTOMIZATION = "CUSTOMIZATION",
  MOVEMENT_TOWARDS_FIRST_SALE = "MOVEMENT_TOWARDS_FIRST_SALE",
  ONBOARDING = "ONBOARDING",
}

export enum ORDER_ORIGIN {
  APP = "APP",
  EXPRESS = "EXPRESS",
  POS = "POS",
  THIRD_PARTY = "THIRD_PARTY",
}

export enum ORDER_STATUS {
  ACCEPTED = "ACCEPTED",
  CANCELLED = "CANCELLED",
  COMPLETED = "COMPLETED",
  DELIVERING = "DELIVERING",
  FINALIZING = "FINALIZING",
  PENDING = "PENDING",
  READY = "READY",
  REFUNDED = "REFUNDED",
  REJECTED = "REJECTED",
  SCHEDULED = "SCHEDULED",
}

export enum PAYMENT_STATUS {
  FAILED = "FAILED",
  PENDING = "PENDING",
  REFUNDED = "REFUNDED",
  SUCCESS = "SUCCESS",
}

export enum PERMISSION_SCOPE {
  ACCOUNTS = "ACCOUNTS",
  FINANCE = "FINANCE",
  INTEGRATIONS = "INTEGRATIONS",
  LOANS = "LOANS",
  MENUS = "MENUS",
  ORDERS = "ORDERS",
  POS_CUSTOMIZATION = "POS_CUSTOMIZATION",
  SETTINGS = "SETTINGS",
  STAFF = "STAFF",
}

export enum POINTS_SOURCE_TYPE {
  MANUAL_INPUT = "MANUAL_INPUT",
  PURCHASE = "PURCHASE",
  RECEIPT_SCAN = "RECEIPT_SCAN",
  VENUE_MANAGER = "VENUE_MANAGER",
}

export enum POS_DISCOUNT_SOURCE {
  MANAGER = "MANAGER",
  MEMBERSHIP = "MEMBERSHIP",
  TERMINAL = "TERMINAL",
}

export enum PRODUCT_TAG {
  API = "API",
  BACKOFFICE = "BACKOFFICE",
  EXPRESS = "EXPRESS",
  FINANCE = "FINANCE",
  HANDHELD = "HANDHELD",
  INTEGRATIONS = "INTEGRATIONS",
  KDS = "KDS",
  ONLINE_ORDERING = "ONLINE_ORDERING",
  QR = "QR",
  QSR = "QSR",
  TSR = "TSR",
}

export enum PRODUCT_TYPE {
  BOOKINGS = "BOOKINGS",
  CUSTOMER_DISPLAY = "CUSTOMER_DISPLAY",
  GIFTCARD = "GIFTCARD",
  HANDHELD_ORDER = "HANDHELD_ORDER",
  HANDHELD_PAY = "HANDHELD_PAY",
  HANDHELD_PRO = "HANDHELD_PRO",
  INSIGHTS = "INSIGHTS",
  INSIGHTS_YEAR = "INSIGHTS_YEAR",
  KDS = "KDS",
  MC_PRINT_2 = "MC_PRINT_2",
  MC_PRINT_3 = "MC_PRINT_3",
  PHYSICAL_GIFTCARD = "PHYSICAL_GIFTCARD",
  POS_PRO = "POS_PRO",
  QSR = "QSR",
  S1F2 = "S1F2",
  SUPPORT_SUNRISE = "SUPPORT_SUNRISE",
  TSR = "TSR",
  V400M = "V400M",
  ZETTLE_TERMINAL = "ZETTLE_TERMINAL",
}

export enum REJECT_REASON {
  CLOSING_SOON = "CLOSING_SOON",
  DELIVERY_IS_NOT_AVAILABLE = "DELIVERY_IS_NOT_AVAILABLE",
  NO_ANSWER = "NO_ANSWER",
  OUT_OF_SUPPLIES = "OUT_OF_SUPPLIES",
  TOO_MANY_ORDERS = "TOO_MANY_ORDERS",
}

export enum RELEASE_TYPE {
  FEATURE = "FEATURE",
  RELEASE_NOTES = "RELEASE_NOTES",
}

export enum REPORTING_CHANNEL {
  APP = "APP",
  EXPRESS = "EXPRESS",
  POS = "POS",
  THIRD_PARTY = "THIRD_PARTY",
}

export enum REPORT_TYPE {
  Z = "Z",
}

export enum ROLE {
  CONTENT_ADMIN = "CONTENT_ADMIN",
  REGULAR = "REGULAR",
  SUPER_ADMIN = "SUPER_ADMIN",
}

export enum SALES_REPORT_PERIOD {
  CUSTOM = "CUSTOM",
  DAY = "DAY",
  MONTH = "MONTH",
}

export enum SEGMENT_PERIOD {
  DAY = "DAY",
  MONTH = "MONTH",
  WEEK = "WEEK",
}

export enum SERVICE_TYPE {
  BOOKING = "BOOKING",
  DELIVERY = "DELIVERY",
  EAT_HERE = "EAT_HERE",
  INSTANT_BUY = "INSTANT_BUY",
  LOCAL_DELIVERY = "LOCAL_DELIVERY",
  POS = "POS",
  SHIPPED = "SHIPPED",
  TABLE_SERVICE = "TABLE_SERVICE",
  TAKE_AWAY = "TAKE_AWAY",
}

export enum SOCIAL_MEDIA {
  FACEBOOK = "FACEBOOK",
  INSTAGRAM = "INSTAGRAM",
}

export enum SOURCE_TYPE {
  ORDER = "ORDER",
  ORDER_REFUND = "ORDER_REFUND",
}

export enum STAFF_PERMISSIONS {
  ADD_ITEM_TO_TABLE = "ADD_ITEM_TO_TABLE",
  ANALYTICS = "ANALYTICS",
  ASSUME_ROLE = "ASSUME_ROLE",
  CLOSE_DAY = "CLOSE_DAY",
  CREATE_CHEQUE = "CREATE_CHEQUE",
  CREATE_INVOICE_TARGET = "CREATE_INVOICE_TARGET",
  GIFT_CARDS = "GIFT_CARDS",
  HISTORY = "HISTORY",
  INVOICE_PURCHASE = "INVOICE_PURCHASE",
  LOG_OUT = "LOG_OUT",
  MAKE_PAYMENT = "MAKE_PAYMENT",
  MANUAL_DISCOUNT = "MANUAL_DISCOUNT",
  PRESET_DISCOUNT = "PRESET_DISCOUNT",
  REFUND = "REFUND",
  REPORTS = "REPORTS",
  SETTINGS = "SETTINGS",
  VOID_PAYMENT = "VOID_PAYMENT",
}

export enum STATION_TYPE {
  DISPLAY = "DISPLAY",
  PRINTER = "PRINTER",
}

export enum STORE_STATUS {
  Active = "Active",
  Closed = "Closed",
  Inactive = "Inactive",
  InactiveWithModifications = "InactiveWithModifications",
  PENDING = "PENDING",
}

export enum SalesIntegration {
  GSTOCK = "GSTOCK",
  KIVRA = "KIVRA",
  LEAT = "LEAT",
  PERSONALKOLLEN = "PERSONALKOLLEN",
  WAITERAID = "WAITERAID",
}

export enum SalesServiceExporterType {
  CASPECO = "CASPECO",
  FORTNOX = "FORTNOX",
  GENERAL = "GENERAL",
  ITEMS = "ITEMS",
  JSON_BILLING_REPORT = "JSON_BILLING_REPORT",
  TRANSACTIONS = "TRANSACTIONS",
}

export enum SalesServiceLanguage {
  EN = "EN",
  SE = "SE",
}

export enum SalesServiceOrigin {
  APP = "APP",
  EXPRESS = "EXPRESS",
  POS = "POS",
}

export enum SalesServiceReportType {
  EXCEL = "EXCEL",
  JSON = "JSON",
}

export enum USER_ROLE {
  ADMIN = "ADMIN",
  AUTHOR = "AUTHOR",
  READER = "READER",
}

export enum VARIATION_CLASS {
  ALLERGENS = "ALLERGENS",
  ALTERNATE_INGREDIENTS = "ALTERNATE_INGREDIENTS",
  DEFAULT_INGREDIENTS = "DEFAULT_INGREDIENTS",
  EXTRA_INGREDIENTS = "EXTRA_INGREDIENTS",
  INGREDIENTS = "INGREDIENTS",
  SIZES = "SIZES",
}

export enum VARIATION_TYPE {
  MULTIPLE = "MULTIPLE",
  SINGLE = "SINGLE",
}

export enum VERIFICATION_STATUS {
  AWAITING_DATA = "AWAITING_DATA",
  DATA_PROVIDED = "DATA_PROVIDED",
  FAILED = "FAILED",
  INVALID_DATA = "INVALID_DATA",
  PASSED = "PASSED",
  PENDING = "PENDING",
  RETRY_LIMIT_REACHED = "RETRY_LIMIT_REACHED",
}

export interface AccessLevelCreateInput {
  id?: string ;
  name: string;
  permissions?: AccessLevelCreatepermissionsInput ;
  deleted?: boolean ;
  company: CompanyCreateOneWithoutAccessLevelsInput;
}

export interface AccessLevelCreateManyWithoutCompanyInput {
  create?: AccessLevelCreateWithoutCompanyInput[] ;
  connect?: AccessLevelWhereUniqueInput[] ;
}

export interface AccessLevelCreateOneInput {
  create?: AccessLevelCreateInput ;
  connect?: AccessLevelWhereUniqueInput ;
}

export interface AccessLevelCreateWithoutCompanyInput {
  id?: string ;
  name: string;
  permissions?: AccessLevelCreatepermissionsInput ;
  deleted?: boolean ;
}

export interface AccessLevelCreatepermissionsInput {
  set?: STAFF_PERMISSIONS[] ;
}

export interface AccessLevelScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  AND?: AccessLevelScalarWhereInput[] ;
  OR?: AccessLevelScalarWhereInput[] ;
  NOT?: AccessLevelScalarWhereInput[] ;
}

export interface AccessLevelUpdateDataInput {
  name?: string ;
  permissions?: AccessLevelUpdatepermissionsInput ;
  deleted?: boolean ;
  company?: CompanyUpdateOneRequiredWithoutAccessLevelsInput ;
}

export interface AccessLevelUpdateInput {
  name?: string ;
  permissions?: AccessLevelUpdatepermissionsInput ;
  deleted?: boolean ;
  company?: CompanyUpdateOneRequiredWithoutAccessLevelsInput ;
}

export interface AccessLevelUpdateManyDataInput {
  name?: string ;
  permissions?: AccessLevelUpdatepermissionsInput ;
  deleted?: boolean ;
}

export interface AccessLevelUpdateManyWithWhereNestedInput {
  where: AccessLevelScalarWhereInput;
  data: AccessLevelUpdateManyDataInput;
}

export interface AccessLevelUpdateManyWithoutCompanyInput {
  create?: AccessLevelCreateWithoutCompanyInput[] ;
  connect?: AccessLevelWhereUniqueInput[] ;
  set?: AccessLevelWhereUniqueInput[] ;
  disconnect?: AccessLevelWhereUniqueInput[] ;
  update?: AccessLevelUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: AccessLevelUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: AccessLevelScalarWhereInput[] ;
  updateMany?: AccessLevelUpdateManyWithWhereNestedInput[] ;
}

export interface AccessLevelUpdateOneRequiredInput {
  create?: AccessLevelCreateInput ;
  update?: AccessLevelUpdateDataInput ;
  upsert?: AccessLevelUpsertNestedInput ;
  connect?: AccessLevelWhereUniqueInput ;
}

export interface AccessLevelUpdateWithWhereUniqueWithoutCompanyInput {
  where: AccessLevelWhereUniqueInput;
  data: AccessLevelUpdateWithoutCompanyDataInput;
}

export interface AccessLevelUpdateWithoutCompanyDataInput {
  name?: string ;
  permissions?: AccessLevelUpdatepermissionsInput ;
  deleted?: boolean ;
}

export interface AccessLevelUpdatepermissionsInput {
  set?: STAFF_PERMISSIONS[] ;
}

export interface AccessLevelUpsertNestedInput {
  update: AccessLevelUpdateDataInput;
  create: AccessLevelCreateInput;
}

export interface AccessLevelUpsertWithWhereUniqueWithoutCompanyInput {
  where: AccessLevelWhereUniqueInput;
  update: AccessLevelUpdateWithoutCompanyDataInput;
  create: AccessLevelCreateWithoutCompanyInput;
}

export interface AccessLevelWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  company?: CompanyWhereInput ;
  AND?: AccessLevelWhereInput[] ;
  OR?: AccessLevelWhereInput[] ;
  NOT?: AccessLevelWhereInput[] ;
}

export interface AccessLevelWhereUniqueInput {
  id?: string ;
}

export interface AccessRightCreateInput {
  venueIds?: string[] ;
  companyIds?: string[] ;
  organisationIds?: string[] ;
  namespace: string;
  userName: string;
  userRole: USER_ROLE;
  userId: string;
}

export interface AccessRightDeleteInput {
  id: string;
}

export interface AccessRightUpdateInput {
  id: string;
  userId: string;
  venueIds?: string[] ;
  companyIds?: string[] ;
  organisationIds?: string[] ;
  userRole: USER_ROLE;
}

export interface ActionLogCreateOneWithoutLogInput {
  create?: ActionLogCreateWithoutLogInput ;
  connect?: ActionLogWhereUniqueInput ;
}

export interface ActionLogCreateWithoutLogInput {
  id?: string ;
  nodeId?: string ;
  type?: LOG_TYPE ;
}

export interface ActionLogUpdateOneWithoutLogInput {
  create?: ActionLogCreateWithoutLogInput ;
  update?: ActionLogUpdateWithoutLogDataInput ;
  upsert?: ActionLogUpsertWithoutLogInput ;
  disconnect?: boolean ;
  connect?: ActionLogWhereUniqueInput ;
}

export interface ActionLogUpdateWithoutLogDataInput {
  nodeId?: string ;
  type?: LOG_TYPE ;
}

export interface ActionLogUpsertWithoutLogInput {
  update: ActionLogUpdateWithoutLogDataInput;
  create: ActionLogCreateWithoutLogInput;
}

export interface ActionLogWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  nodeId?: string ;
  nodeId_not?: string ;
  nodeId_in?: string[] ;
  nodeId_not_in?: string[] ;
  nodeId_lt?: string ;
  nodeId_lte?: string ;
  nodeId_gt?: string ;
  nodeId_gte?: string ;
  nodeId_contains?: string ;
  nodeId_not_contains?: string ;
  nodeId_starts_with?: string ;
  nodeId_not_starts_with?: string ;
  nodeId_ends_with?: string ;
  nodeId_not_ends_with?: string ;
  type?: LOG_TYPE ;
  type_not?: LOG_TYPE ;
  type_in?: LOG_TYPE[] ;
  type_not_in?: LOG_TYPE[] ;
  log?: LogWhereInput ;
  AND?: ActionLogWhereInput[] ;
  OR?: ActionLogWhereInput[] ;
  NOT?: ActionLogWhereInput[] ;
}

export interface ActionLogWhereUniqueInput {
  id?: string ;
}

export interface AdyenAccountHolderInput {
  legalName: string;
  email: string;
  country: string;
  usePCIFlow?: boolean ;
  entityType: AdyenEntityType;
  shareholders: AdyenShareholder[];
}

export interface AdyenAssignTerminalInput {
  storeId?: string ;
  terminalId: string;
}

export interface AdyenBalanceStoreInput {
  legalEntityId: string;
  name: string;
  city: string;
  country: string;
  phoneNumber: string;
  splitConfigurationId: string;
  street: string;
  postalCode: string;
  venueId: string;
  companyId: string;
  type: string;
}

export interface AdyenFeeConfigInput {
  accountHolderId: string;
  amex: AdyenFeeInput;
  commercial: AdyenFeeInput;
  credit: AdyenFeeInput;
  debit: AdyenFeeInput;
  foreign: AdyenFeeInput;
  swish?: AdyenFeeInput ;
  vipps?: AdyenFeeInput ;
  klarna?: AdyenFeeInput ;
  emails?: string[] ;
  isDelayed?: boolean ;
  fixedMonthlyFee?: number ;
  publicThirdParty?: AdyenThirdPartyFeeInput ;
  hiddenThirdParty?: AdyenThirdPartyFeeInput ;
}

export interface AdyenFeeInput {
  fixed: number;
  relative: number;
}

export interface AdyenPDFReportInput {
  balanceAccountId: string;
  startDate: any;
  endDate: any;
  orgNumber?: string ;
  useRawEvents?: boolean ;
}

export interface AdyenSettingInput {
  type: string;
  value: boolean;
}

export interface AdyenShareholder {
  firstName: string;
  lastName: string;
  type: AdyenShareholderType;
  country: string;
  jobTitle?: string ;
}

export interface AdyenStoreInput {
  venueId: string;
  name: string;
  accountId: string;
  city: string;
  country: string;
  streetNumber: string;
  stateOrProvince: string;
  street: string;
  postalCode: string;
  phoneNumber: string;
  website?: string ;
  isEcommerce?: boolean ;
  serviceFeeConfigurationId: string;
}

export interface AdyenThirdPartyFeeInput {
  title: string;
  balanceAccountId: string;
  fee: AdyenFeeInput;
}

export interface AdyenUIInput {
  accountHolderId: string;
  domain: string;
  role?: string ;
}

export interface AppMetadataCreateOneWithoutCompanyInput {
  create?: AppMetadataCreateWithoutCompanyInput ;
  connect?: AppMetadataWhereUniqueInput ;
}

export interface AppMetadataCreateWithoutCompanyInput {
  id?: string ;
  au1day?: number ;
  au7day?: number ;
  au30day?: number ;
}

export interface AppMetadataUpdateOneWithoutCompanyInput {
  create?: AppMetadataCreateWithoutCompanyInput ;
  update?: AppMetadataUpdateWithoutCompanyDataInput ;
  upsert?: AppMetadataUpsertWithoutCompanyInput ;
  disconnect?: boolean ;
  connect?: AppMetadataWhereUniqueInput ;
}

export interface AppMetadataUpdateWithoutCompanyDataInput {
  au1day?: number ;
  au7day?: number ;
  au30day?: number ;
}

export interface AppMetadataUpsertWithoutCompanyInput {
  update: AppMetadataUpdateWithoutCompanyDataInput;
  create: AppMetadataCreateWithoutCompanyInput;
}

export interface AppMetadataWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  company?: CompanyWhereInput ;
  au1day?: number ;
  au1day_not?: number ;
  au1day_in?: number[] ;
  au1day_not_in?: number[] ;
  au1day_lt?: number ;
  au1day_lte?: number ;
  au1day_gt?: number ;
  au1day_gte?: number ;
  au7day?: number ;
  au7day_not?: number ;
  au7day_in?: number[] ;
  au7day_not_in?: number[] ;
  au7day_lt?: number ;
  au7day_lte?: number ;
  au7day_gt?: number ;
  au7day_gte?: number ;
  au30day?: number ;
  au30day_not?: number ;
  au30day_in?: number[] ;
  au30day_not_in?: number[] ;
  au30day_lt?: number ;
  au30day_lte?: number ;
  au30day_gt?: number ;
  au30day_gte?: number ;
  AND?: AppMetadataWhereInput[] ;
  OR?: AppMetadataWhereInput[] ;
  NOT?: AppMetadataWhereInput[] ;
}

export interface AppMetadataWhereUniqueInput {
  id?: string ;
}

export interface AppliedMenuAvailabilityInput {
  dayOfWeek?: DAY_OF_WEEK ;
  timeRange?: AppliedMenuAvailabilityTimeRangeInput ;
}

export interface AppliedMenuAvailabilityTimeRangeInput {
  start?: string ;
  end?: string ;
}

export interface AppliedMenuCreateManyWithoutMembershipLevelsInput {
  create?: AppliedMenuCreateWithoutMembershipLevelsInput[] ;
  connect?: AppliedMenuWhereUniqueInput[] ;
}

export interface AppliedMenuCreateManyWithoutMenuInput {
  create?: AppliedMenuCreateWithoutMenuInput[] ;
  connect?: AppliedMenuWhereUniqueInput[] ;
}

export interface AppliedMenuCreateManyWithoutVenueInput {
  create?: AppliedMenuCreateWithoutVenueInput[] ;
  connect?: AppliedMenuWhereUniqueInput[] ;
}

export interface AppliedMenuCreateWithoutMembershipLevelsInput {
  id?: string ;
  menu?: MenuCreateOneWithoutApplicationsInput ;
  serviceType: SERVICE_TYPE;
  venue?: VenueCreateOneWithoutMenusInput ;
}

export interface AppliedMenuCreateWithoutMenuInput {
  id?: string ;
  serviceType: SERVICE_TYPE;
  venue?: VenueCreateOneWithoutMenusInput ;
  membershipLevels?: MembershipLevelCreateManyWithoutMenusInput ;
}

export interface AppliedMenuCreateWithoutVenueInput {
  id?: string ;
  menu?: MenuCreateOneWithoutApplicationsInput ;
  serviceType: SERVICE_TYPE;
  membershipLevels?: MembershipLevelCreateManyWithoutMenusInput ;
}

export interface AppliedMenuScalarWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  serviceType?: SERVICE_TYPE ;
  serviceType_not?: SERVICE_TYPE ;
  serviceType_in?: SERVICE_TYPE[] ;
  serviceType_not_in?: SERVICE_TYPE[] ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  AND?: AppliedMenuScalarWhereInput[] ;
  OR?: AppliedMenuScalarWhereInput[] ;
  NOT?: AppliedMenuScalarWhereInput[] ;
}

export interface AppliedMenuUpdateManyDataInput {
  serviceType?: SERVICE_TYPE ;
}

export interface AppliedMenuUpdateManyWithWhereNestedInput {
  where: AppliedMenuScalarWhereInput;
  data: AppliedMenuUpdateManyDataInput;
}

export interface AppliedMenuUpdateManyWithoutMembershipLevelsInput {
  create?: AppliedMenuCreateWithoutMembershipLevelsInput[] ;
  connect?: AppliedMenuWhereUniqueInput[] ;
  set?: AppliedMenuWhereUniqueInput[] ;
  disconnect?: AppliedMenuWhereUniqueInput[] ;
  update?: AppliedMenuUpdateWithWhereUniqueWithoutMembershipLevelsInput[] ;
  upsert?: AppliedMenuUpsertWithWhereUniqueWithoutMembershipLevelsInput[] ;
  deleteMany?: AppliedMenuScalarWhereInput[] ;
  updateMany?: AppliedMenuUpdateManyWithWhereNestedInput[] ;
}

export interface AppliedMenuUpdateManyWithoutMenuInput {
  create?: AppliedMenuCreateWithoutMenuInput[] ;
  connect?: AppliedMenuWhereUniqueInput[] ;
  set?: AppliedMenuWhereUniqueInput[] ;
  disconnect?: AppliedMenuWhereUniqueInput[] ;
  update?: AppliedMenuUpdateWithWhereUniqueWithoutMenuInput[] ;
  upsert?: AppliedMenuUpsertWithWhereUniqueWithoutMenuInput[] ;
  deleteMany?: AppliedMenuScalarWhereInput[] ;
  updateMany?: AppliedMenuUpdateManyWithWhereNestedInput[] ;
}

export interface AppliedMenuUpdateManyWithoutVenueInput {
  create?: AppliedMenuCreateWithoutVenueInput[] ;
  connect?: AppliedMenuWhereUniqueInput[] ;
  set?: AppliedMenuWhereUniqueInput[] ;
  disconnect?: AppliedMenuWhereUniqueInput[] ;
  update?: AppliedMenuUpdateWithWhereUniqueWithoutVenueInput[] ;
  upsert?: AppliedMenuUpsertWithWhereUniqueWithoutVenueInput[] ;
  deleteMany?: AppliedMenuScalarWhereInput[] ;
  updateMany?: AppliedMenuUpdateManyWithWhereNestedInput[] ;
}

export interface AppliedMenuUpdateWithWhereUniqueWithoutMembershipLevelsInput {
  where: AppliedMenuWhereUniqueInput;
  data: AppliedMenuUpdateWithoutMembershipLevelsDataInput;
}

export interface AppliedMenuUpdateWithWhereUniqueWithoutMenuInput {
  where: AppliedMenuWhereUniqueInput;
  data: AppliedMenuUpdateWithoutMenuDataInput;
}

export interface AppliedMenuUpdateWithWhereUniqueWithoutVenueInput {
  where: AppliedMenuWhereUniqueInput;
  data: AppliedMenuUpdateWithoutVenueDataInput;
}

export interface AppliedMenuUpdateWithoutMembershipLevelsDataInput {
  menu?: MenuUpdateOneWithoutApplicationsInput ;
  serviceType?: SERVICE_TYPE ;
  venue?: VenueUpdateOneWithoutMenusInput ;
}

export interface AppliedMenuUpdateWithoutMenuDataInput {
  serviceType?: SERVICE_TYPE ;
  venue?: VenueUpdateOneWithoutMenusInput ;
  membershipLevels?: MembershipLevelUpdateManyWithoutMenusInput ;
}

export interface AppliedMenuUpdateWithoutVenueDataInput {
  menu?: MenuUpdateOneWithoutApplicationsInput ;
  serviceType?: SERVICE_TYPE ;
  membershipLevels?: MembershipLevelUpdateManyWithoutMenusInput ;
}

export interface AppliedMenuUpsertWithWhereUniqueWithoutMembershipLevelsInput {
  where: AppliedMenuWhereUniqueInput;
  update: AppliedMenuUpdateWithoutMembershipLevelsDataInput;
  create: AppliedMenuCreateWithoutMembershipLevelsInput;
}

export interface AppliedMenuUpsertWithWhereUniqueWithoutMenuInput {
  where: AppliedMenuWhereUniqueInput;
  update: AppliedMenuUpdateWithoutMenuDataInput;
  create: AppliedMenuCreateWithoutMenuInput;
}

export interface AppliedMenuUpsertWithWhereUniqueWithoutVenueInput {
  where: AppliedMenuWhereUniqueInput;
  update: AppliedMenuUpdateWithoutVenueDataInput;
  create: AppliedMenuCreateWithoutVenueInput;
}

export interface AppliedMenuWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  menu?: MenuWhereInput ;
  serviceType?: SERVICE_TYPE ;
  serviceType_not?: SERVICE_TYPE ;
  serviceType_in?: SERVICE_TYPE[] ;
  serviceType_not_in?: SERVICE_TYPE[] ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  venue?: VenueWhereInput ;
  membershipLevels_every?: MembershipLevelWhereInput ;
  membershipLevels_some?: MembershipLevelWhereInput ;
  membershipLevels_none?: MembershipLevelWhereInput ;
  AND?: AppliedMenuWhereInput[] ;
  OR?: AppliedMenuWhereInput[] ;
  NOT?: AppliedMenuWhereInput[] ;
}

export interface AppliedMenuWhereUniqueInput {
  id?: string ;
}

export interface AppliedVariationCreateManyWithoutGroupInput {
  create?: AppliedVariationCreateWithoutGroupInput[] ;
  connect?: AppliedVariationWhereUniqueInput[] ;
}

export interface AppliedVariationCreateManyWithoutItemInput {
  create?: AppliedVariationCreateWithoutItemInput[] ;
  connect?: AppliedVariationWhereUniqueInput[] ;
}

export interface AppliedVariationCreateManyWithoutVariationInput {
  create?: AppliedVariationCreateWithoutVariationInput[] ;
  connect?: AppliedVariationWhereUniqueInput[] ;
}

export interface AppliedVariationCreateWithoutGroupInput {
  default?: boolean ;
  id?: string ;
  item?: ItemCreateOneWithoutAppliedVariationsInput ;
  variation?: VariationCreateOneWithoutAppliedVariationsInput ;
  required?: boolean ;
  expandedByDefault?: boolean ;
}

export interface AppliedVariationCreateWithoutItemInput {
  default?: boolean ;
  id?: string ;
  variation?: VariationCreateOneWithoutAppliedVariationsInput ;
  group?: VariationGroupCreateOneWithoutApplicationsInput ;
  required?: boolean ;
  expandedByDefault?: boolean ;
}

export interface AppliedVariationCreateWithoutVariationInput {
  default?: boolean ;
  id?: string ;
  item?: ItemCreateOneWithoutAppliedVariationsInput ;
  group?: VariationGroupCreateOneWithoutApplicationsInput ;
  required?: boolean ;
  expandedByDefault?: boolean ;
}

export interface AppliedVariationScalarWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  default?: boolean ;
  default_not?: boolean ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  required?: boolean ;
  required_not?: boolean ;
  expandedByDefault?: boolean ;
  expandedByDefault_not?: boolean ;
  AND?: AppliedVariationScalarWhereInput[] ;
  OR?: AppliedVariationScalarWhereInput[] ;
  NOT?: AppliedVariationScalarWhereInput[] ;
}

export interface AppliedVariationUpdateManyDataInput {
  default?: boolean ;
  required?: boolean ;
  expandedByDefault?: boolean ;
}

export interface AppliedVariationUpdateManyWithWhereNestedInput {
  where: AppliedVariationScalarWhereInput;
  data: AppliedVariationUpdateManyDataInput;
}

export interface AppliedVariationUpdateManyWithoutGroupInput {
  create?: AppliedVariationCreateWithoutGroupInput[] ;
  connect?: AppliedVariationWhereUniqueInput[] ;
  set?: AppliedVariationWhereUniqueInput[] ;
  disconnect?: AppliedVariationWhereUniqueInput[] ;
  update?: AppliedVariationUpdateWithWhereUniqueWithoutGroupInput[] ;
  upsert?: AppliedVariationUpsertWithWhereUniqueWithoutGroupInput[] ;
  deleteMany?: AppliedVariationScalarWhereInput[] ;
  updateMany?: AppliedVariationUpdateManyWithWhereNestedInput[] ;
}

export interface AppliedVariationUpdateManyWithoutItemInput {
  create?: AppliedVariationCreateWithoutItemInput[] ;
  connect?: AppliedVariationWhereUniqueInput[] ;
  set?: AppliedVariationWhereUniqueInput[] ;
  disconnect?: AppliedVariationWhereUniqueInput[] ;
  update?: AppliedVariationUpdateWithWhereUniqueWithoutItemInput[] ;
  upsert?: AppliedVariationUpsertWithWhereUniqueWithoutItemInput[] ;
  deleteMany?: AppliedVariationScalarWhereInput[] ;
  updateMany?: AppliedVariationUpdateManyWithWhereNestedInput[] ;
}

export interface AppliedVariationUpdateManyWithoutVariationInput {
  create?: AppliedVariationCreateWithoutVariationInput[] ;
  connect?: AppliedVariationWhereUniqueInput[] ;
  set?: AppliedVariationWhereUniqueInput[] ;
  disconnect?: AppliedVariationWhereUniqueInput[] ;
  update?: AppliedVariationUpdateWithWhereUniqueWithoutVariationInput[] ;
  upsert?: AppliedVariationUpsertWithWhereUniqueWithoutVariationInput[] ;
  deleteMany?: AppliedVariationScalarWhereInput[] ;
  updateMany?: AppliedVariationUpdateManyWithWhereNestedInput[] ;
}

export interface AppliedVariationUpdateWithWhereUniqueWithoutGroupInput {
  where: AppliedVariationWhereUniqueInput;
  data: AppliedVariationUpdateWithoutGroupDataInput;
}

export interface AppliedVariationUpdateWithWhereUniqueWithoutItemInput {
  where: AppliedVariationWhereUniqueInput;
  data: AppliedVariationUpdateWithoutItemDataInput;
}

export interface AppliedVariationUpdateWithWhereUniqueWithoutVariationInput {
  where: AppliedVariationWhereUniqueInput;
  data: AppliedVariationUpdateWithoutVariationDataInput;
}

export interface AppliedVariationUpdateWithoutGroupDataInput {
  default?: boolean ;
  item?: ItemUpdateOneWithoutAppliedVariationsInput ;
  variation?: VariationUpdateOneWithoutAppliedVariationsInput ;
  required?: boolean ;
  expandedByDefault?: boolean ;
}

export interface AppliedVariationUpdateWithoutItemDataInput {
  default?: boolean ;
  variation?: VariationUpdateOneWithoutAppliedVariationsInput ;
  group?: VariationGroupUpdateOneWithoutApplicationsInput ;
  required?: boolean ;
  expandedByDefault?: boolean ;
}

export interface AppliedVariationUpdateWithoutVariationDataInput {
  default?: boolean ;
  item?: ItemUpdateOneWithoutAppliedVariationsInput ;
  group?: VariationGroupUpdateOneWithoutApplicationsInput ;
  required?: boolean ;
  expandedByDefault?: boolean ;
}

export interface AppliedVariationUpsertWithWhereUniqueWithoutGroupInput {
  where: AppliedVariationWhereUniqueInput;
  update: AppliedVariationUpdateWithoutGroupDataInput;
  create: AppliedVariationCreateWithoutGroupInput;
}

export interface AppliedVariationUpsertWithWhereUniqueWithoutItemInput {
  where: AppliedVariationWhereUniqueInput;
  update: AppliedVariationUpdateWithoutItemDataInput;
  create: AppliedVariationCreateWithoutItemInput;
}

export interface AppliedVariationUpsertWithWhereUniqueWithoutVariationInput {
  where: AppliedVariationWhereUniqueInput;
  update: AppliedVariationUpdateWithoutVariationDataInput;
  create: AppliedVariationCreateWithoutVariationInput;
}

export interface AppliedVariationWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  default?: boolean ;
  default_not?: boolean ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  item?: ItemWhereInput ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  variation?: VariationWhereInput ;
  group?: VariationGroupWhereInput ;
  required?: boolean ;
  required_not?: boolean ;
  expandedByDefault?: boolean ;
  expandedByDefault_not?: boolean ;
  AND?: AppliedVariationWhereInput[] ;
  OR?: AppliedVariationWhereInput[] ;
  NOT?: AppliedVariationWhereInput[] ;
}

export interface AppliedVariationWhereUniqueInput {
  id?: string ;
}

export interface ArticleMapCreateManyWithoutItemInput {
  create?: ArticleMapCreateWithoutItemInput[] ;
  connect?: ArticleMapWhereUniqueInput[] ;
}

export interface ArticleMapCreateOneWithoutSizeInput {
  create?: ArticleMapCreateWithoutSizeInput ;
  connect?: ArticleMapWhereUniqueInput ;
}

export interface ArticleMapCreateOneWithoutVariationInput {
  create?: ArticleMapCreateWithoutVariationInput ;
  connect?: ArticleMapWhereUniqueInput ;
}

export interface ArticleMapCreateWithoutItemInput {
  id?: string ;
  size?: ItemSizeCreateOneWithoutArticleMapInput ;
  variation?: VariationCreateOneWithoutArticleMapInput ;
  externalId: string;
}

export interface ArticleMapCreateWithoutSizeInput {
  id?: string ;
  item: ItemCreateOneWithoutArticleMapsInput;
  variation?: VariationCreateOneWithoutArticleMapInput ;
  externalId: string;
}

export interface ArticleMapCreateWithoutVariationInput {
  id?: string ;
  item: ItemCreateOneWithoutArticleMapsInput;
  size?: ItemSizeCreateOneWithoutArticleMapInput ;
  externalId: string;
}

export interface ArticleMapScalarWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  externalId?: string ;
  externalId_not?: string ;
  externalId_in?: string[] ;
  externalId_not_in?: string[] ;
  externalId_lt?: string ;
  externalId_lte?: string ;
  externalId_gt?: string ;
  externalId_gte?: string ;
  externalId_contains?: string ;
  externalId_not_contains?: string ;
  externalId_starts_with?: string ;
  externalId_not_starts_with?: string ;
  externalId_ends_with?: string ;
  externalId_not_ends_with?: string ;
  AND?: ArticleMapScalarWhereInput[] ;
  OR?: ArticleMapScalarWhereInput[] ;
  NOT?: ArticleMapScalarWhereInput[] ;
}

export interface ArticleMapUpdateManyDataInput {
  externalId?: string ;
}

export interface ArticleMapUpdateManyWithWhereNestedInput {
  where: ArticleMapScalarWhereInput;
  data: ArticleMapUpdateManyDataInput;
}

export interface ArticleMapUpdateManyWithoutItemInput {
  create?: ArticleMapCreateWithoutItemInput[] ;
  connect?: ArticleMapWhereUniqueInput[] ;
  set?: ArticleMapWhereUniqueInput[] ;
  disconnect?: ArticleMapWhereUniqueInput[] ;
  update?: ArticleMapUpdateWithWhereUniqueWithoutItemInput[] ;
  upsert?: ArticleMapUpsertWithWhereUniqueWithoutItemInput[] ;
  deleteMany?: ArticleMapScalarWhereInput[] ;
  updateMany?: ArticleMapUpdateManyWithWhereNestedInput[] ;
}

export interface ArticleMapUpdateOneWithoutSizeInput {
  create?: ArticleMapCreateWithoutSizeInput ;
  update?: ArticleMapUpdateWithoutSizeDataInput ;
  upsert?: ArticleMapUpsertWithoutSizeInput ;
  disconnect?: boolean ;
  connect?: ArticleMapWhereUniqueInput ;
}

export interface ArticleMapUpdateOneWithoutVariationInput {
  create?: ArticleMapCreateWithoutVariationInput ;
  update?: ArticleMapUpdateWithoutVariationDataInput ;
  upsert?: ArticleMapUpsertWithoutVariationInput ;
  disconnect?: boolean ;
  connect?: ArticleMapWhereUniqueInput ;
}

export interface ArticleMapUpdateWithWhereUniqueWithoutItemInput {
  where: ArticleMapWhereUniqueInput;
  data: ArticleMapUpdateWithoutItemDataInput;
}

export interface ArticleMapUpdateWithoutItemDataInput {
  size?: ItemSizeUpdateOneWithoutArticleMapInput ;
  variation?: VariationUpdateOneWithoutArticleMapInput ;
  externalId?: string ;
}

export interface ArticleMapUpdateWithoutSizeDataInput {
  item?: ItemUpdateOneRequiredWithoutArticleMapsInput ;
  variation?: VariationUpdateOneWithoutArticleMapInput ;
  externalId?: string ;
}

export interface ArticleMapUpdateWithoutVariationDataInput {
  item?: ItemUpdateOneRequiredWithoutArticleMapsInput ;
  size?: ItemSizeUpdateOneWithoutArticleMapInput ;
  externalId?: string ;
}

export interface ArticleMapUpsertWithWhereUniqueWithoutItemInput {
  where: ArticleMapWhereUniqueInput;
  update: ArticleMapUpdateWithoutItemDataInput;
  create: ArticleMapCreateWithoutItemInput;
}

export interface ArticleMapUpsertWithoutSizeInput {
  update: ArticleMapUpdateWithoutSizeDataInput;
  create: ArticleMapCreateWithoutSizeInput;
}

export interface ArticleMapUpsertWithoutVariationInput {
  update: ArticleMapUpdateWithoutVariationDataInput;
  create: ArticleMapCreateWithoutVariationInput;
}

export interface ArticleMapWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  item?: ItemWhereInput ;
  size?: ItemSizeWhereInput ;
  variation?: VariationWhereInput ;
  externalId?: string ;
  externalId_not?: string ;
  externalId_in?: string[] ;
  externalId_not_in?: string[] ;
  externalId_lt?: string ;
  externalId_lte?: string ;
  externalId_gt?: string ;
  externalId_gte?: string ;
  externalId_contains?: string ;
  externalId_not_contains?: string ;
  externalId_starts_with?: string ;
  externalId_not_starts_with?: string ;
  externalId_ends_with?: string ;
  externalId_not_ends_with?: string ;
  AND?: ArticleMapWhereInput[] ;
  OR?: ArticleMapWhereInput[] ;
  NOT?: ArticleMapWhereInput[] ;
}

export interface ArticleMapWhereUniqueInput {
  id?: string ;
}

export interface AssignCompanyToOrganizationInput {
  companyId: string;
  companyName: string;
  organizationId: string;
  users?: RelevantUserDataInput[] ;
}

export interface AssignUserToOrganizationInput {
  userId: string;
  organizationId: string;
}

export interface AvailabilityCreateManyWithoutOfferTokenInput {
  create?: AvailabilityCreateWithoutOfferTokenInput[] ;
  connect?: AvailabilityWhereUniqueInput[] ;
}

export interface AvailabilityCreateManyWithoutVenueInput {
  create?: AvailabilityCreateWithoutVenueInput[] ;
  connect?: AvailabilityWhereUniqueInput[] ;
}

export interface AvailabilityCreateWithoutOfferTokenInput {
  dayOfWeek?: DAY_OF_WEEK ;
  id?: string ;
  timeRange?: TimeRangeCreateOneWithoutAvailabilitiesInput ;
  venue?: VenueCreateOneWithoutAvailabilitiesInput ;
}

export interface AvailabilityCreateWithoutVenueInput {
  dayOfWeek?: DAY_OF_WEEK ;
  id?: string ;
  timeRange?: TimeRangeCreateOneWithoutAvailabilitiesInput ;
  offerToken?: OfferTokenCreateOneWithoutAvailabilitiesInput ;
}

export interface AvailabilityScalarWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  dayOfWeek?: DAY_OF_WEEK ;
  dayOfWeek_not?: DAY_OF_WEEK ;
  dayOfWeek_in?: DAY_OF_WEEK[] ;
  dayOfWeek_not_in?: DAY_OF_WEEK[] ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  AND?: AvailabilityScalarWhereInput[] ;
  OR?: AvailabilityScalarWhereInput[] ;
  NOT?: AvailabilityScalarWhereInput[] ;
}

export interface AvailabilityUpdateManyDataInput {
  dayOfWeek?: DAY_OF_WEEK ;
}

export interface AvailabilityUpdateManyWithWhereNestedInput {
  where: AvailabilityScalarWhereInput;
  data: AvailabilityUpdateManyDataInput;
}

export interface AvailabilityUpdateManyWithoutOfferTokenInput {
  create?: AvailabilityCreateWithoutOfferTokenInput[] ;
  connect?: AvailabilityWhereUniqueInput[] ;
  set?: AvailabilityWhereUniqueInput[] ;
  disconnect?: AvailabilityWhereUniqueInput[] ;
  update?: AvailabilityUpdateWithWhereUniqueWithoutOfferTokenInput[] ;
  upsert?: AvailabilityUpsertWithWhereUniqueWithoutOfferTokenInput[] ;
  deleteMany?: AvailabilityScalarWhereInput[] ;
  updateMany?: AvailabilityUpdateManyWithWhereNestedInput[] ;
}

export interface AvailabilityUpdateManyWithoutVenueInput {
  create?: AvailabilityCreateWithoutVenueInput[] ;
  connect?: AvailabilityWhereUniqueInput[] ;
  set?: AvailabilityWhereUniqueInput[] ;
  disconnect?: AvailabilityWhereUniqueInput[] ;
  update?: AvailabilityUpdateWithWhereUniqueWithoutVenueInput[] ;
  upsert?: AvailabilityUpsertWithWhereUniqueWithoutVenueInput[] ;
  deleteMany?: AvailabilityScalarWhereInput[] ;
  updateMany?: AvailabilityUpdateManyWithWhereNestedInput[] ;
}

export interface AvailabilityUpdateWithWhereUniqueWithoutOfferTokenInput {
  where: AvailabilityWhereUniqueInput;
  data: AvailabilityUpdateWithoutOfferTokenDataInput;
}

export interface AvailabilityUpdateWithWhereUniqueWithoutVenueInput {
  where: AvailabilityWhereUniqueInput;
  data: AvailabilityUpdateWithoutVenueDataInput;
}

export interface AvailabilityUpdateWithoutOfferTokenDataInput {
  dayOfWeek?: DAY_OF_WEEK ;
  timeRange?: TimeRangeUpdateOneWithoutAvailabilitiesInput ;
  venue?: VenueUpdateOneWithoutAvailabilitiesInput ;
}

export interface AvailabilityUpdateWithoutVenueDataInput {
  dayOfWeek?: DAY_OF_WEEK ;
  timeRange?: TimeRangeUpdateOneWithoutAvailabilitiesInput ;
  offerToken?: OfferTokenUpdateOneWithoutAvailabilitiesInput ;
}

export interface AvailabilityUpsertWithWhereUniqueWithoutOfferTokenInput {
  where: AvailabilityWhereUniqueInput;
  update: AvailabilityUpdateWithoutOfferTokenDataInput;
  create: AvailabilityCreateWithoutOfferTokenInput;
}

export interface AvailabilityUpsertWithWhereUniqueWithoutVenueInput {
  where: AvailabilityWhereUniqueInput;
  update: AvailabilityUpdateWithoutVenueDataInput;
  create: AvailabilityCreateWithoutVenueInput;
}

export interface AvailabilityWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  dayOfWeek?: DAY_OF_WEEK ;
  dayOfWeek_not?: DAY_OF_WEEK ;
  dayOfWeek_in?: DAY_OF_WEEK[] ;
  dayOfWeek_not_in?: DAY_OF_WEEK[] ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  timeRange?: TimeRangeWhereInput ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  venue?: VenueWhereInput ;
  offerToken?: OfferTokenWhereInput ;
  AND?: AvailabilityWhereInput[] ;
  OR?: AvailabilityWhereInput[] ;
  NOT?: AvailabilityWhereInput[] ;
}

export interface AvailabilityWhereUniqueInput {
  id?: string ;
}

export interface CampaignCreateManyWithoutDiscountsInput {
  create?: CampaignCreateWithoutDiscountsInput[] ;
  connect?: CampaignWhereUniqueInput[] ;
}

export interface CampaignCreateWithoutDiscountsInput {
  end: any;
  id?: string ;
  name: string;
  start: any;
  description: string;
}

export interface CampaignScalarWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  end?: any ;
  end_not?: any ;
  end_in?: any[] ;
  end_not_in?: any[] ;
  end_lt?: any ;
  end_lte?: any ;
  end_gt?: any ;
  end_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  start?: any ;
  start_not?: any ;
  start_in?: any[] ;
  start_not_in?: any[] ;
  start_lt?: any ;
  start_lte?: any ;
  start_gt?: any ;
  start_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  description?: string ;
  description_not?: string ;
  description_in?: string[] ;
  description_not_in?: string[] ;
  description_lt?: string ;
  description_lte?: string ;
  description_gt?: string ;
  description_gte?: string ;
  description_contains?: string ;
  description_not_contains?: string ;
  description_starts_with?: string ;
  description_not_starts_with?: string ;
  description_ends_with?: string ;
  description_not_ends_with?: string ;
  AND?: CampaignScalarWhereInput[] ;
  OR?: CampaignScalarWhereInput[] ;
  NOT?: CampaignScalarWhereInput[] ;
}

export interface CampaignUpdateManyDataInput {
  end?: any ;
  name?: string ;
  start?: any ;
  description?: string ;
}

export interface CampaignUpdateManyWithWhereNestedInput {
  where: CampaignScalarWhereInput;
  data: CampaignUpdateManyDataInput;
}

export interface CampaignUpdateManyWithoutDiscountsInput {
  create?: CampaignCreateWithoutDiscountsInput[] ;
  connect?: CampaignWhereUniqueInput[] ;
  set?: CampaignWhereUniqueInput[] ;
  disconnect?: CampaignWhereUniqueInput[] ;
  update?: CampaignUpdateWithWhereUniqueWithoutDiscountsInput[] ;
  upsert?: CampaignUpsertWithWhereUniqueWithoutDiscountsInput[] ;
  deleteMany?: CampaignScalarWhereInput[] ;
  updateMany?: CampaignUpdateManyWithWhereNestedInput[] ;
}

export interface CampaignUpdateWithWhereUniqueWithoutDiscountsInput {
  where: CampaignWhereUniqueInput;
  data: CampaignUpdateWithoutDiscountsDataInput;
}

export interface CampaignUpdateWithoutDiscountsDataInput {
  end?: any ;
  name?: string ;
  start?: any ;
  description?: string ;
}

export interface CampaignUpsertWithWhereUniqueWithoutDiscountsInput {
  where: CampaignWhereUniqueInput;
  update: CampaignUpdateWithoutDiscountsDataInput;
  create: CampaignCreateWithoutDiscountsInput;
}

export interface CampaignWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  discounts_every?: DiscountWhereInput ;
  discounts_some?: DiscountWhereInput ;
  discounts_none?: DiscountWhereInput ;
  end?: any ;
  end_not?: any ;
  end_in?: any[] ;
  end_not_in?: any[] ;
  end_lt?: any ;
  end_lte?: any ;
  end_gt?: any ;
  end_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  start?: any ;
  start_not?: any ;
  start_in?: any[] ;
  start_not_in?: any[] ;
  start_lt?: any ;
  start_lte?: any ;
  start_gt?: any ;
  start_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  description?: string ;
  description_not?: string ;
  description_in?: string[] ;
  description_not_in?: string[] ;
  description_lt?: string ;
  description_lte?: string ;
  description_gt?: string ;
  description_gte?: string ;
  description_contains?: string ;
  description_not_contains?: string ;
  description_starts_with?: string ;
  description_not_starts_with?: string ;
  description_ends_with?: string ;
  description_not_ends_with?: string ;
  AND?: CampaignWhereInput[] ;
  OR?: CampaignWhereInput[] ;
  NOT?: CampaignWhereInput[] ;
}

export interface CampaignWhereUniqueInput {
  id?: string ;
}

export interface CardDesignCreateManyWithoutCompanyInput {
  create?: CardDesignCreateWithoutCompanyInput[] ;
  connect?: CardDesignWhereUniqueInput[] ;
}

export interface CardDesignCreateOneWithoutMembershipsInput {
  create?: CardDesignCreateWithoutMembershipsInput ;
  connect?: CardDesignWhereUniqueInput ;
}

export interface CardDesignCreateWithoutCompanyInput {
  id?: string ;
  slug: string;
  memberships?: MembershipLevelCreateManyWithoutDesignInput ;
}

export interface CardDesignCreateWithoutMembershipsInput {
  id?: string ;
  slug: string;
  company: CompanyCreateOneWithoutCardDesignsInput;
}

export interface CardDesignScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  slug?: string ;
  slug_not?: string ;
  slug_in?: string[] ;
  slug_not_in?: string[] ;
  slug_lt?: string ;
  slug_lte?: string ;
  slug_gt?: string ;
  slug_gte?: string ;
  slug_contains?: string ;
  slug_not_contains?: string ;
  slug_starts_with?: string ;
  slug_not_starts_with?: string ;
  slug_ends_with?: string ;
  slug_not_ends_with?: string ;
  AND?: CardDesignScalarWhereInput[] ;
  OR?: CardDesignScalarWhereInput[] ;
  NOT?: CardDesignScalarWhereInput[] ;
}

export interface CardDesignUpdateManyDataInput {
  slug?: string ;
}

export interface CardDesignUpdateManyWithWhereNestedInput {
  where: CardDesignScalarWhereInput;
  data: CardDesignUpdateManyDataInput;
}

export interface CardDesignUpdateManyWithoutCompanyInput {
  create?: CardDesignCreateWithoutCompanyInput[] ;
  connect?: CardDesignWhereUniqueInput[] ;
  set?: CardDesignWhereUniqueInput[] ;
  disconnect?: CardDesignWhereUniqueInput[] ;
  update?: CardDesignUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: CardDesignUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: CardDesignScalarWhereInput[] ;
  updateMany?: CardDesignUpdateManyWithWhereNestedInput[] ;
}

export interface CardDesignUpdateOneWithoutMembershipsInput {
  create?: CardDesignCreateWithoutMembershipsInput ;
  update?: CardDesignUpdateWithoutMembershipsDataInput ;
  upsert?: CardDesignUpsertWithoutMembershipsInput ;
  disconnect?: boolean ;
  connect?: CardDesignWhereUniqueInput ;
}

export interface CardDesignUpdateWithWhereUniqueWithoutCompanyInput {
  where: CardDesignWhereUniqueInput;
  data: CardDesignUpdateWithoutCompanyDataInput;
}

export interface CardDesignUpdateWithoutCompanyDataInput {
  slug?: string ;
  memberships?: MembershipLevelUpdateManyWithoutDesignInput ;
}

export interface CardDesignUpdateWithoutMembershipsDataInput {
  slug?: string ;
  company?: CompanyUpdateOneRequiredWithoutCardDesignsInput ;
}

export interface CardDesignUpsertWithWhereUniqueWithoutCompanyInput {
  where: CardDesignWhereUniqueInput;
  update: CardDesignUpdateWithoutCompanyDataInput;
  create: CardDesignCreateWithoutCompanyInput;
}

export interface CardDesignUpsertWithoutMembershipsInput {
  update: CardDesignUpdateWithoutMembershipsDataInput;
  create: CardDesignCreateWithoutMembershipsInput;
}

export interface CardDesignWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  slug?: string ;
  slug_not?: string ;
  slug_in?: string[] ;
  slug_not_in?: string[] ;
  slug_lt?: string ;
  slug_lte?: string ;
  slug_gt?: string ;
  slug_gte?: string ;
  slug_contains?: string ;
  slug_not_contains?: string ;
  slug_starts_with?: string ;
  slug_not_starts_with?: string ;
  slug_ends_with?: string ;
  slug_not_ends_with?: string ;
  company?: CompanyWhereInput ;
  memberships_every?: MembershipLevelWhereInput ;
  memberships_some?: MembershipLevelWhereInput ;
  memberships_none?: MembershipLevelWhereInput ;
  AND?: CardDesignWhereInput[] ;
  OR?: CardDesignWhereInput[] ;
  NOT?: CardDesignWhereInput[] ;
}

export interface CardDesignWhereUniqueInput {
  id?: string ;
}

export interface CategoryCreateManyWithoutCompanyInput {
  create?: CategoryCreateWithoutCompanyInput[] ;
  connect?: CategoryWhereUniqueInput[] ;
}

export interface CategoryCreateManyWithoutCourseTypeInput {
  create?: CategoryCreateWithoutCourseTypeInput[] ;
  connect?: CategoryWhereUniqueInput[] ;
}

export interface CategoryCreateManyWithoutExpressPagesInput {
  create?: CategoryCreateWithoutExpressPagesInput[] ;
  connect?: CategoryWhereUniqueInput[] ;
}

export interface CategoryCreateManyWithoutImageInput {
  create?: CategoryCreateWithoutImageInput[] ;
  connect?: CategoryWhereUniqueInput[] ;
}

export interface CategoryCreateManyWithoutItemsInput {
  create?: CategoryCreateWithoutItemsInput[] ;
  connect?: CategoryWhereUniqueInput[] ;
}

export interface CategoryCreateManyWithoutOffersInput {
  create?: CategoryCreateWithoutOffersInput[] ;
  connect?: CategoryWhereUniqueInput[] ;
}

export interface CategoryCreateManyWithoutStationsInput {
  create?: CategoryCreateWithoutStationsInput[] ;
  connect?: CategoryWhereUniqueInput[] ;
}

export interface CategoryCreateOneWithoutDescriptionLangInput {
  create?: CategoryCreateWithoutDescriptionLangInput ;
  connect?: CategoryWhereUniqueInput ;
}

export interface CategoryCreateOneWithoutEntriesInput {
  create?: CategoryCreateWithoutEntriesInput ;
  connect?: CategoryWhereUniqueInput ;
}

export interface CategoryCreateOneWithoutItemGroupsInput {
  create?: CategoryCreateWithoutItemGroupsInput ;
  connect?: CategoryWhereUniqueInput ;
}

export interface CategoryCreateOneWithoutNameLangInput {
  create?: CategoryCreateWithoutNameLangInput ;
  connect?: CategoryWhereUniqueInput ;
}

export interface CategoryCreateWithoutCompanyInput {
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutCategoryDescriptionInput ;
  entries?: MenuEntryCreateManyWithoutCategoryInput ;
  id?: string ;
  image?: ImageCreateOneWithoutParentsInput ;
  img?: string ;
  items?: ItemCreateManyWithoutCategoriesInput ;
  name: string;
  color?: string ;
  nameLang?: TranslatedStringCreateOneWithoutCategoryNameInput ;
  order?: number ;
  deleted?: boolean ;
  itemGroups?: ItemGroupCreateManyWithoutCategoryInput ;
  stations?: StationCreateManyWithoutCategoriesInput ;
  tags?: CategoryCreatetagsInput ;
  expressPages?: ExpressPageCreateManyWithoutCategoriesInput ;
  parentId?: string ;
  offers?: OfferCreateManyWithoutCategoriesInput ;
  vatRate?: number ;
  courseType?: CourseTypeCreateOneWithoutCategoriesInput ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryCreateWithoutCourseTypeInput {
  company?: CompanyCreateOneWithoutCategoriesInput ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutCategoryDescriptionInput ;
  entries?: MenuEntryCreateManyWithoutCategoryInput ;
  id?: string ;
  image?: ImageCreateOneWithoutParentsInput ;
  img?: string ;
  items?: ItemCreateManyWithoutCategoriesInput ;
  name: string;
  color?: string ;
  nameLang?: TranslatedStringCreateOneWithoutCategoryNameInput ;
  order?: number ;
  deleted?: boolean ;
  itemGroups?: ItemGroupCreateManyWithoutCategoryInput ;
  stations?: StationCreateManyWithoutCategoriesInput ;
  tags?: CategoryCreatetagsInput ;
  expressPages?: ExpressPageCreateManyWithoutCategoriesInput ;
  parentId?: string ;
  offers?: OfferCreateManyWithoutCategoriesInput ;
  vatRate?: number ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryCreateWithoutDescriptionLangInput {
  company?: CompanyCreateOneWithoutCategoriesInput ;
  description?: string ;
  entries?: MenuEntryCreateManyWithoutCategoryInput ;
  id?: string ;
  image?: ImageCreateOneWithoutParentsInput ;
  img?: string ;
  items?: ItemCreateManyWithoutCategoriesInput ;
  name: string;
  color?: string ;
  nameLang?: TranslatedStringCreateOneWithoutCategoryNameInput ;
  order?: number ;
  deleted?: boolean ;
  itemGroups?: ItemGroupCreateManyWithoutCategoryInput ;
  stations?: StationCreateManyWithoutCategoriesInput ;
  tags?: CategoryCreatetagsInput ;
  expressPages?: ExpressPageCreateManyWithoutCategoriesInput ;
  parentId?: string ;
  offers?: OfferCreateManyWithoutCategoriesInput ;
  vatRate?: number ;
  courseType?: CourseTypeCreateOneWithoutCategoriesInput ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryCreateWithoutEntriesInput {
  company?: CompanyCreateOneWithoutCategoriesInput ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutCategoryDescriptionInput ;
  id?: string ;
  image?: ImageCreateOneWithoutParentsInput ;
  img?: string ;
  items?: ItemCreateManyWithoutCategoriesInput ;
  name: string;
  color?: string ;
  nameLang?: TranslatedStringCreateOneWithoutCategoryNameInput ;
  order?: number ;
  deleted?: boolean ;
  itemGroups?: ItemGroupCreateManyWithoutCategoryInput ;
  stations?: StationCreateManyWithoutCategoriesInput ;
  tags?: CategoryCreatetagsInput ;
  expressPages?: ExpressPageCreateManyWithoutCategoriesInput ;
  parentId?: string ;
  offers?: OfferCreateManyWithoutCategoriesInput ;
  vatRate?: number ;
  courseType?: CourseTypeCreateOneWithoutCategoriesInput ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryCreateWithoutExpressPagesInput {
  company?: CompanyCreateOneWithoutCategoriesInput ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutCategoryDescriptionInput ;
  entries?: MenuEntryCreateManyWithoutCategoryInput ;
  id?: string ;
  image?: ImageCreateOneWithoutParentsInput ;
  img?: string ;
  items?: ItemCreateManyWithoutCategoriesInput ;
  name: string;
  color?: string ;
  nameLang?: TranslatedStringCreateOneWithoutCategoryNameInput ;
  order?: number ;
  deleted?: boolean ;
  itemGroups?: ItemGroupCreateManyWithoutCategoryInput ;
  stations?: StationCreateManyWithoutCategoriesInput ;
  tags?: CategoryCreatetagsInput ;
  parentId?: string ;
  offers?: OfferCreateManyWithoutCategoriesInput ;
  vatRate?: number ;
  courseType?: CourseTypeCreateOneWithoutCategoriesInput ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryCreateWithoutImageInput {
  company?: CompanyCreateOneWithoutCategoriesInput ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutCategoryDescriptionInput ;
  entries?: MenuEntryCreateManyWithoutCategoryInput ;
  id?: string ;
  img?: string ;
  items?: ItemCreateManyWithoutCategoriesInput ;
  name: string;
  color?: string ;
  nameLang?: TranslatedStringCreateOneWithoutCategoryNameInput ;
  order?: number ;
  deleted?: boolean ;
  itemGroups?: ItemGroupCreateManyWithoutCategoryInput ;
  stations?: StationCreateManyWithoutCategoriesInput ;
  tags?: CategoryCreatetagsInput ;
  expressPages?: ExpressPageCreateManyWithoutCategoriesInput ;
  parentId?: string ;
  offers?: OfferCreateManyWithoutCategoriesInput ;
  vatRate?: number ;
  courseType?: CourseTypeCreateOneWithoutCategoriesInput ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryCreateWithoutItemGroupsInput {
  company?: CompanyCreateOneWithoutCategoriesInput ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutCategoryDescriptionInput ;
  entries?: MenuEntryCreateManyWithoutCategoryInput ;
  id?: string ;
  image?: ImageCreateOneWithoutParentsInput ;
  img?: string ;
  items?: ItemCreateManyWithoutCategoriesInput ;
  name: string;
  color?: string ;
  nameLang?: TranslatedStringCreateOneWithoutCategoryNameInput ;
  order?: number ;
  deleted?: boolean ;
  stations?: StationCreateManyWithoutCategoriesInput ;
  tags?: CategoryCreatetagsInput ;
  expressPages?: ExpressPageCreateManyWithoutCategoriesInput ;
  parentId?: string ;
  offers?: OfferCreateManyWithoutCategoriesInput ;
  vatRate?: number ;
  courseType?: CourseTypeCreateOneWithoutCategoriesInput ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryCreateWithoutItemsInput {
  company?: CompanyCreateOneWithoutCategoriesInput ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutCategoryDescriptionInput ;
  entries?: MenuEntryCreateManyWithoutCategoryInput ;
  id?: string ;
  image?: ImageCreateOneWithoutParentsInput ;
  img?: string ;
  name: string;
  color?: string ;
  nameLang?: TranslatedStringCreateOneWithoutCategoryNameInput ;
  order?: number ;
  deleted?: boolean ;
  itemGroups?: ItemGroupCreateManyWithoutCategoryInput ;
  stations?: StationCreateManyWithoutCategoriesInput ;
  tags?: CategoryCreatetagsInput ;
  expressPages?: ExpressPageCreateManyWithoutCategoriesInput ;
  parentId?: string ;
  offers?: OfferCreateManyWithoutCategoriesInput ;
  vatRate?: number ;
  courseType?: CourseTypeCreateOneWithoutCategoriesInput ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryCreateWithoutNameLangInput {
  company?: CompanyCreateOneWithoutCategoriesInput ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutCategoryDescriptionInput ;
  entries?: MenuEntryCreateManyWithoutCategoryInput ;
  id?: string ;
  image?: ImageCreateOneWithoutParentsInput ;
  img?: string ;
  items?: ItemCreateManyWithoutCategoriesInput ;
  name: string;
  color?: string ;
  order?: number ;
  deleted?: boolean ;
  itemGroups?: ItemGroupCreateManyWithoutCategoryInput ;
  stations?: StationCreateManyWithoutCategoriesInput ;
  tags?: CategoryCreatetagsInput ;
  expressPages?: ExpressPageCreateManyWithoutCategoriesInput ;
  parentId?: string ;
  offers?: OfferCreateManyWithoutCategoriesInput ;
  vatRate?: number ;
  courseType?: CourseTypeCreateOneWithoutCategoriesInput ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryCreateWithoutOffersInput {
  company?: CompanyCreateOneWithoutCategoriesInput ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutCategoryDescriptionInput ;
  entries?: MenuEntryCreateManyWithoutCategoryInput ;
  id?: string ;
  image?: ImageCreateOneWithoutParentsInput ;
  img?: string ;
  items?: ItemCreateManyWithoutCategoriesInput ;
  name: string;
  color?: string ;
  nameLang?: TranslatedStringCreateOneWithoutCategoryNameInput ;
  order?: number ;
  deleted?: boolean ;
  itemGroups?: ItemGroupCreateManyWithoutCategoryInput ;
  stations?: StationCreateManyWithoutCategoriesInput ;
  tags?: CategoryCreatetagsInput ;
  expressPages?: ExpressPageCreateManyWithoutCategoriesInput ;
  parentId?: string ;
  vatRate?: number ;
  courseType?: CourseTypeCreateOneWithoutCategoriesInput ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryCreateWithoutStationsInput {
  company?: CompanyCreateOneWithoutCategoriesInput ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutCategoryDescriptionInput ;
  entries?: MenuEntryCreateManyWithoutCategoryInput ;
  id?: string ;
  image?: ImageCreateOneWithoutParentsInput ;
  img?: string ;
  items?: ItemCreateManyWithoutCategoriesInput ;
  name: string;
  color?: string ;
  nameLang?: TranslatedStringCreateOneWithoutCategoryNameInput ;
  order?: number ;
  deleted?: boolean ;
  itemGroups?: ItemGroupCreateManyWithoutCategoryInput ;
  tags?: CategoryCreatetagsInput ;
  expressPages?: ExpressPageCreateManyWithoutCategoriesInput ;
  parentId?: string ;
  offers?: OfferCreateManyWithoutCategoriesInput ;
  vatRate?: number ;
  courseType?: CourseTypeCreateOneWithoutCategoriesInput ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryCreatetagsInput {
  set?: string[] ;
}

export interface CategoryScalarWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  description?: string ;
  description_not?: string ;
  description_in?: string[] ;
  description_not_in?: string[] ;
  description_lt?: string ;
  description_lte?: string ;
  description_gt?: string ;
  description_gte?: string ;
  description_contains?: string ;
  description_not_contains?: string ;
  description_starts_with?: string ;
  description_not_starts_with?: string ;
  description_ends_with?: string ;
  description_not_ends_with?: string ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  img?: string ;
  img_not?: string ;
  img_in?: string[] ;
  img_not_in?: string[] ;
  img_lt?: string ;
  img_lte?: string ;
  img_gt?: string ;
  img_gte?: string ;
  img_contains?: string ;
  img_not_contains?: string ;
  img_starts_with?: string ;
  img_not_starts_with?: string ;
  img_ends_with?: string ;
  img_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  color?: string ;
  color_not?: string ;
  color_in?: string[] ;
  color_not_in?: string[] ;
  color_lt?: string ;
  color_lte?: string ;
  color_gt?: string ;
  color_gte?: string ;
  color_contains?: string ;
  color_not_contains?: string ;
  color_starts_with?: string ;
  color_not_starts_with?: string ;
  color_ends_with?: string ;
  color_not_ends_with?: string ;
  order?: number ;
  order_not?: number ;
  order_in?: number[] ;
  order_not_in?: number[] ;
  order_lt?: number ;
  order_lte?: number ;
  order_gt?: number ;
  order_gte?: number ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  parentId?: string ;
  parentId_not?: string ;
  parentId_in?: string[] ;
  parentId_not_in?: string[] ;
  parentId_lt?: string ;
  parentId_lte?: string ;
  parentId_gt?: string ;
  parentId_gte?: string ;
  parentId_contains?: string ;
  parentId_not_contains?: string ;
  parentId_starts_with?: string ;
  parentId_not_starts_with?: string ;
  parentId_ends_with?: string ;
  parentId_not_ends_with?: string ;
  vatRate?: number ;
  vatRate_not?: number ;
  vatRate_in?: number[] ;
  vatRate_not_in?: number[] ;
  vatRate_lt?: number ;
  vatRate_lte?: number ;
  vatRate_gt?: number ;
  vatRate_gte?: number ;
  hideInCustomerOrderingFlows?: boolean ;
  hideInCustomerOrderingFlows_not?: boolean ;
  AND?: CategoryScalarWhereInput[] ;
  OR?: CategoryScalarWhereInput[] ;
  NOT?: CategoryScalarWhereInput[] ;
}

export interface CategoryUpdateInput {
  company?: CompanyUpdateOneWithoutCategoriesInput ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutCategoryDescriptionInput ;
  entries?: MenuEntryUpdateManyWithoutCategoryInput ;
  image?: ImageUpdateOneWithoutParentsInput ;
  img?: string ;
  items?: ItemUpdateManyWithoutCategoriesInput ;
  name?: string ;
  color?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutCategoryNameInput ;
  order?: number ;
  deleted?: boolean ;
  itemGroups?: ItemGroupUpdateManyWithoutCategoryInput ;
  stations?: StationUpdateManyWithoutCategoriesInput ;
  tags?: CategoryUpdatetagsInput ;
  expressPages?: ExpressPageUpdateManyWithoutCategoriesInput ;
  parentId?: string ;
  offers?: OfferUpdateManyWithoutCategoriesInput ;
  vatRate?: number ;
  courseType?: CourseTypeUpdateOneWithoutCategoriesInput ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryUpdateManyDataInput {
  description?: string ;
  img?: string ;
  name?: string ;
  color?: string ;
  order?: number ;
  deleted?: boolean ;
  tags?: CategoryUpdatetagsInput ;
  parentId?: string ;
  vatRate?: number ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryUpdateManyWithWhereNestedInput {
  where: CategoryScalarWhereInput;
  data: CategoryUpdateManyDataInput;
}

export interface CategoryUpdateManyWithoutCompanyInput {
  create?: CategoryCreateWithoutCompanyInput[] ;
  connect?: CategoryWhereUniqueInput[] ;
  set?: CategoryWhereUniqueInput[] ;
  disconnect?: CategoryWhereUniqueInput[] ;
  update?: CategoryUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: CategoryUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: CategoryScalarWhereInput[] ;
  updateMany?: CategoryUpdateManyWithWhereNestedInput[] ;
}

export interface CategoryUpdateManyWithoutCourseTypeInput {
  create?: CategoryCreateWithoutCourseTypeInput[] ;
  connect?: CategoryWhereUniqueInput[] ;
  set?: CategoryWhereUniqueInput[] ;
  disconnect?: CategoryWhereUniqueInput[] ;
  update?: CategoryUpdateWithWhereUniqueWithoutCourseTypeInput[] ;
  upsert?: CategoryUpsertWithWhereUniqueWithoutCourseTypeInput[] ;
  deleteMany?: CategoryScalarWhereInput[] ;
  updateMany?: CategoryUpdateManyWithWhereNestedInput[] ;
}

export interface CategoryUpdateManyWithoutExpressPagesInput {
  create?: CategoryCreateWithoutExpressPagesInput[] ;
  connect?: CategoryWhereUniqueInput[] ;
  set?: CategoryWhereUniqueInput[] ;
  disconnect?: CategoryWhereUniqueInput[] ;
  update?: CategoryUpdateWithWhereUniqueWithoutExpressPagesInput[] ;
  upsert?: CategoryUpsertWithWhereUniqueWithoutExpressPagesInput[] ;
  deleteMany?: CategoryScalarWhereInput[] ;
  updateMany?: CategoryUpdateManyWithWhereNestedInput[] ;
}

export interface CategoryUpdateManyWithoutImageInput {
  create?: CategoryCreateWithoutImageInput[] ;
  connect?: CategoryWhereUniqueInput[] ;
  set?: CategoryWhereUniqueInput[] ;
  disconnect?: CategoryWhereUniqueInput[] ;
  update?: CategoryUpdateWithWhereUniqueWithoutImageInput[] ;
  upsert?: CategoryUpsertWithWhereUniqueWithoutImageInput[] ;
  deleteMany?: CategoryScalarWhereInput[] ;
  updateMany?: CategoryUpdateManyWithWhereNestedInput[] ;
}

export interface CategoryUpdateManyWithoutItemsInput {
  create?: CategoryCreateWithoutItemsInput[] ;
  connect?: CategoryWhereUniqueInput[] ;
  set?: CategoryWhereUniqueInput[] ;
  disconnect?: CategoryWhereUniqueInput[] ;
  update?: CategoryUpdateWithWhereUniqueWithoutItemsInput[] ;
  upsert?: CategoryUpsertWithWhereUniqueWithoutItemsInput[] ;
  deleteMany?: CategoryScalarWhereInput[] ;
  updateMany?: CategoryUpdateManyWithWhereNestedInput[] ;
}

export interface CategoryUpdateManyWithoutOffersInput {
  create?: CategoryCreateWithoutOffersInput[] ;
  connect?: CategoryWhereUniqueInput[] ;
  set?: CategoryWhereUniqueInput[] ;
  disconnect?: CategoryWhereUniqueInput[] ;
  update?: CategoryUpdateWithWhereUniqueWithoutOffersInput[] ;
  upsert?: CategoryUpsertWithWhereUniqueWithoutOffersInput[] ;
  deleteMany?: CategoryScalarWhereInput[] ;
  updateMany?: CategoryUpdateManyWithWhereNestedInput[] ;
}

export interface CategoryUpdateManyWithoutStationsInput {
  create?: CategoryCreateWithoutStationsInput[] ;
  connect?: CategoryWhereUniqueInput[] ;
  set?: CategoryWhereUniqueInput[] ;
  disconnect?: CategoryWhereUniqueInput[] ;
  update?: CategoryUpdateWithWhereUniqueWithoutStationsInput[] ;
  upsert?: CategoryUpsertWithWhereUniqueWithoutStationsInput[] ;
  deleteMany?: CategoryScalarWhereInput[] ;
  updateMany?: CategoryUpdateManyWithWhereNestedInput[] ;
}

export interface CategoryUpdateOneWithoutDescriptionLangInput {
  create?: CategoryCreateWithoutDescriptionLangInput ;
  update?: CategoryUpdateWithoutDescriptionLangDataInput ;
  upsert?: CategoryUpsertWithoutDescriptionLangInput ;
  disconnect?: boolean ;
  connect?: CategoryWhereUniqueInput ;
}

export interface CategoryUpdateOneWithoutEntriesInput {
  create?: CategoryCreateWithoutEntriesInput ;
  update?: CategoryUpdateWithoutEntriesDataInput ;
  upsert?: CategoryUpsertWithoutEntriesInput ;
  disconnect?: boolean ;
  connect?: CategoryWhereUniqueInput ;
}

export interface CategoryUpdateOneWithoutItemGroupsInput {
  create?: CategoryCreateWithoutItemGroupsInput ;
  update?: CategoryUpdateWithoutItemGroupsDataInput ;
  upsert?: CategoryUpsertWithoutItemGroupsInput ;
  disconnect?: boolean ;
  connect?: CategoryWhereUniqueInput ;
}

export interface CategoryUpdateOneWithoutNameLangInput {
  create?: CategoryCreateWithoutNameLangInput ;
  update?: CategoryUpdateWithoutNameLangDataInput ;
  upsert?: CategoryUpsertWithoutNameLangInput ;
  disconnect?: boolean ;
  connect?: CategoryWhereUniqueInput ;
}

export interface CategoryUpdateWithWhereUniqueWithoutCompanyInput {
  where: CategoryWhereUniqueInput;
  data: CategoryUpdateWithoutCompanyDataInput;
}

export interface CategoryUpdateWithWhereUniqueWithoutCourseTypeInput {
  where: CategoryWhereUniqueInput;
  data: CategoryUpdateWithoutCourseTypeDataInput;
}

export interface CategoryUpdateWithWhereUniqueWithoutExpressPagesInput {
  where: CategoryWhereUniqueInput;
  data: CategoryUpdateWithoutExpressPagesDataInput;
}

export interface CategoryUpdateWithWhereUniqueWithoutImageInput {
  where: CategoryWhereUniqueInput;
  data: CategoryUpdateWithoutImageDataInput;
}

export interface CategoryUpdateWithWhereUniqueWithoutItemsInput {
  where: CategoryWhereUniqueInput;
  data: CategoryUpdateWithoutItemsDataInput;
}

export interface CategoryUpdateWithWhereUniqueWithoutOffersInput {
  where: CategoryWhereUniqueInput;
  data: CategoryUpdateWithoutOffersDataInput;
}

export interface CategoryUpdateWithWhereUniqueWithoutStationsInput {
  where: CategoryWhereUniqueInput;
  data: CategoryUpdateWithoutStationsDataInput;
}

export interface CategoryUpdateWithoutCompanyDataInput {
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutCategoryDescriptionInput ;
  entries?: MenuEntryUpdateManyWithoutCategoryInput ;
  image?: ImageUpdateOneWithoutParentsInput ;
  img?: string ;
  items?: ItemUpdateManyWithoutCategoriesInput ;
  name?: string ;
  color?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutCategoryNameInput ;
  order?: number ;
  deleted?: boolean ;
  itemGroups?: ItemGroupUpdateManyWithoutCategoryInput ;
  stations?: StationUpdateManyWithoutCategoriesInput ;
  tags?: CategoryUpdatetagsInput ;
  expressPages?: ExpressPageUpdateManyWithoutCategoriesInput ;
  parentId?: string ;
  offers?: OfferUpdateManyWithoutCategoriesInput ;
  vatRate?: number ;
  courseType?: CourseTypeUpdateOneWithoutCategoriesInput ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryUpdateWithoutCourseTypeDataInput {
  company?: CompanyUpdateOneWithoutCategoriesInput ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutCategoryDescriptionInput ;
  entries?: MenuEntryUpdateManyWithoutCategoryInput ;
  image?: ImageUpdateOneWithoutParentsInput ;
  img?: string ;
  items?: ItemUpdateManyWithoutCategoriesInput ;
  name?: string ;
  color?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutCategoryNameInput ;
  order?: number ;
  deleted?: boolean ;
  itemGroups?: ItemGroupUpdateManyWithoutCategoryInput ;
  stations?: StationUpdateManyWithoutCategoriesInput ;
  tags?: CategoryUpdatetagsInput ;
  expressPages?: ExpressPageUpdateManyWithoutCategoriesInput ;
  parentId?: string ;
  offers?: OfferUpdateManyWithoutCategoriesInput ;
  vatRate?: number ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryUpdateWithoutDescriptionLangDataInput {
  company?: CompanyUpdateOneWithoutCategoriesInput ;
  description?: string ;
  entries?: MenuEntryUpdateManyWithoutCategoryInput ;
  image?: ImageUpdateOneWithoutParentsInput ;
  img?: string ;
  items?: ItemUpdateManyWithoutCategoriesInput ;
  name?: string ;
  color?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutCategoryNameInput ;
  order?: number ;
  deleted?: boolean ;
  itemGroups?: ItemGroupUpdateManyWithoutCategoryInput ;
  stations?: StationUpdateManyWithoutCategoriesInput ;
  tags?: CategoryUpdatetagsInput ;
  expressPages?: ExpressPageUpdateManyWithoutCategoriesInput ;
  parentId?: string ;
  offers?: OfferUpdateManyWithoutCategoriesInput ;
  vatRate?: number ;
  courseType?: CourseTypeUpdateOneWithoutCategoriesInput ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryUpdateWithoutEntriesDataInput {
  company?: CompanyUpdateOneWithoutCategoriesInput ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutCategoryDescriptionInput ;
  image?: ImageUpdateOneWithoutParentsInput ;
  img?: string ;
  items?: ItemUpdateManyWithoutCategoriesInput ;
  name?: string ;
  color?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutCategoryNameInput ;
  order?: number ;
  deleted?: boolean ;
  itemGroups?: ItemGroupUpdateManyWithoutCategoryInput ;
  stations?: StationUpdateManyWithoutCategoriesInput ;
  tags?: CategoryUpdatetagsInput ;
  expressPages?: ExpressPageUpdateManyWithoutCategoriesInput ;
  parentId?: string ;
  offers?: OfferUpdateManyWithoutCategoriesInput ;
  vatRate?: number ;
  courseType?: CourseTypeUpdateOneWithoutCategoriesInput ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryUpdateWithoutExpressPagesDataInput {
  company?: CompanyUpdateOneWithoutCategoriesInput ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutCategoryDescriptionInput ;
  entries?: MenuEntryUpdateManyWithoutCategoryInput ;
  image?: ImageUpdateOneWithoutParentsInput ;
  img?: string ;
  items?: ItemUpdateManyWithoutCategoriesInput ;
  name?: string ;
  color?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutCategoryNameInput ;
  order?: number ;
  deleted?: boolean ;
  itemGroups?: ItemGroupUpdateManyWithoutCategoryInput ;
  stations?: StationUpdateManyWithoutCategoriesInput ;
  tags?: CategoryUpdatetagsInput ;
  parentId?: string ;
  offers?: OfferUpdateManyWithoutCategoriesInput ;
  vatRate?: number ;
  courseType?: CourseTypeUpdateOneWithoutCategoriesInput ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryUpdateWithoutImageDataInput {
  company?: CompanyUpdateOneWithoutCategoriesInput ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutCategoryDescriptionInput ;
  entries?: MenuEntryUpdateManyWithoutCategoryInput ;
  img?: string ;
  items?: ItemUpdateManyWithoutCategoriesInput ;
  name?: string ;
  color?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutCategoryNameInput ;
  order?: number ;
  deleted?: boolean ;
  itemGroups?: ItemGroupUpdateManyWithoutCategoryInput ;
  stations?: StationUpdateManyWithoutCategoriesInput ;
  tags?: CategoryUpdatetagsInput ;
  expressPages?: ExpressPageUpdateManyWithoutCategoriesInput ;
  parentId?: string ;
  offers?: OfferUpdateManyWithoutCategoriesInput ;
  vatRate?: number ;
  courseType?: CourseTypeUpdateOneWithoutCategoriesInput ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryUpdateWithoutItemGroupsDataInput {
  company?: CompanyUpdateOneWithoutCategoriesInput ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutCategoryDescriptionInput ;
  entries?: MenuEntryUpdateManyWithoutCategoryInput ;
  image?: ImageUpdateOneWithoutParentsInput ;
  img?: string ;
  items?: ItemUpdateManyWithoutCategoriesInput ;
  name?: string ;
  color?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutCategoryNameInput ;
  order?: number ;
  deleted?: boolean ;
  stations?: StationUpdateManyWithoutCategoriesInput ;
  tags?: CategoryUpdatetagsInput ;
  expressPages?: ExpressPageUpdateManyWithoutCategoriesInput ;
  parentId?: string ;
  offers?: OfferUpdateManyWithoutCategoriesInput ;
  vatRate?: number ;
  courseType?: CourseTypeUpdateOneWithoutCategoriesInput ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryUpdateWithoutItemsDataInput {
  company?: CompanyUpdateOneWithoutCategoriesInput ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutCategoryDescriptionInput ;
  entries?: MenuEntryUpdateManyWithoutCategoryInput ;
  image?: ImageUpdateOneWithoutParentsInput ;
  img?: string ;
  name?: string ;
  color?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutCategoryNameInput ;
  order?: number ;
  deleted?: boolean ;
  itemGroups?: ItemGroupUpdateManyWithoutCategoryInput ;
  stations?: StationUpdateManyWithoutCategoriesInput ;
  tags?: CategoryUpdatetagsInput ;
  expressPages?: ExpressPageUpdateManyWithoutCategoriesInput ;
  parentId?: string ;
  offers?: OfferUpdateManyWithoutCategoriesInput ;
  vatRate?: number ;
  courseType?: CourseTypeUpdateOneWithoutCategoriesInput ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryUpdateWithoutNameLangDataInput {
  company?: CompanyUpdateOneWithoutCategoriesInput ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutCategoryDescriptionInput ;
  entries?: MenuEntryUpdateManyWithoutCategoryInput ;
  image?: ImageUpdateOneWithoutParentsInput ;
  img?: string ;
  items?: ItemUpdateManyWithoutCategoriesInput ;
  name?: string ;
  color?: string ;
  order?: number ;
  deleted?: boolean ;
  itemGroups?: ItemGroupUpdateManyWithoutCategoryInput ;
  stations?: StationUpdateManyWithoutCategoriesInput ;
  tags?: CategoryUpdatetagsInput ;
  expressPages?: ExpressPageUpdateManyWithoutCategoriesInput ;
  parentId?: string ;
  offers?: OfferUpdateManyWithoutCategoriesInput ;
  vatRate?: number ;
  courseType?: CourseTypeUpdateOneWithoutCategoriesInput ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryUpdateWithoutOffersDataInput {
  company?: CompanyUpdateOneWithoutCategoriesInput ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutCategoryDescriptionInput ;
  entries?: MenuEntryUpdateManyWithoutCategoryInput ;
  image?: ImageUpdateOneWithoutParentsInput ;
  img?: string ;
  items?: ItemUpdateManyWithoutCategoriesInput ;
  name?: string ;
  color?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutCategoryNameInput ;
  order?: number ;
  deleted?: boolean ;
  itemGroups?: ItemGroupUpdateManyWithoutCategoryInput ;
  stations?: StationUpdateManyWithoutCategoriesInput ;
  tags?: CategoryUpdatetagsInput ;
  expressPages?: ExpressPageUpdateManyWithoutCategoriesInput ;
  parentId?: string ;
  vatRate?: number ;
  courseType?: CourseTypeUpdateOneWithoutCategoriesInput ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryUpdateWithoutStationsDataInput {
  company?: CompanyUpdateOneWithoutCategoriesInput ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutCategoryDescriptionInput ;
  entries?: MenuEntryUpdateManyWithoutCategoryInput ;
  image?: ImageUpdateOneWithoutParentsInput ;
  img?: string ;
  items?: ItemUpdateManyWithoutCategoriesInput ;
  name?: string ;
  color?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutCategoryNameInput ;
  order?: number ;
  deleted?: boolean ;
  itemGroups?: ItemGroupUpdateManyWithoutCategoryInput ;
  tags?: CategoryUpdatetagsInput ;
  expressPages?: ExpressPageUpdateManyWithoutCategoriesInput ;
  parentId?: string ;
  offers?: OfferUpdateManyWithoutCategoriesInput ;
  vatRate?: number ;
  courseType?: CourseTypeUpdateOneWithoutCategoriesInput ;
  hideInCustomerOrderingFlows?: boolean ;
}

export interface CategoryUpdatetagsInput {
  set?: string[] ;
}

export interface CategoryUpsertWithWhereUniqueWithoutCompanyInput {
  where: CategoryWhereUniqueInput;
  update: CategoryUpdateWithoutCompanyDataInput;
  create: CategoryCreateWithoutCompanyInput;
}

export interface CategoryUpsertWithWhereUniqueWithoutCourseTypeInput {
  where: CategoryWhereUniqueInput;
  update: CategoryUpdateWithoutCourseTypeDataInput;
  create: CategoryCreateWithoutCourseTypeInput;
}

export interface CategoryUpsertWithWhereUniqueWithoutExpressPagesInput {
  where: CategoryWhereUniqueInput;
  update: CategoryUpdateWithoutExpressPagesDataInput;
  create: CategoryCreateWithoutExpressPagesInput;
}

export interface CategoryUpsertWithWhereUniqueWithoutImageInput {
  where: CategoryWhereUniqueInput;
  update: CategoryUpdateWithoutImageDataInput;
  create: CategoryCreateWithoutImageInput;
}

export interface CategoryUpsertWithWhereUniqueWithoutItemsInput {
  where: CategoryWhereUniqueInput;
  update: CategoryUpdateWithoutItemsDataInput;
  create: CategoryCreateWithoutItemsInput;
}

export interface CategoryUpsertWithWhereUniqueWithoutOffersInput {
  where: CategoryWhereUniqueInput;
  update: CategoryUpdateWithoutOffersDataInput;
  create: CategoryCreateWithoutOffersInput;
}

export interface CategoryUpsertWithWhereUniqueWithoutStationsInput {
  where: CategoryWhereUniqueInput;
  update: CategoryUpdateWithoutStationsDataInput;
  create: CategoryCreateWithoutStationsInput;
}

export interface CategoryUpsertWithoutDescriptionLangInput {
  update: CategoryUpdateWithoutDescriptionLangDataInput;
  create: CategoryCreateWithoutDescriptionLangInput;
}

export interface CategoryUpsertWithoutEntriesInput {
  update: CategoryUpdateWithoutEntriesDataInput;
  create: CategoryCreateWithoutEntriesInput;
}

export interface CategoryUpsertWithoutItemGroupsInput {
  update: CategoryUpdateWithoutItemGroupsDataInput;
  create: CategoryCreateWithoutItemGroupsInput;
}

export interface CategoryUpsertWithoutNameLangInput {
  update: CategoryUpdateWithoutNameLangDataInput;
  create: CategoryCreateWithoutNameLangInput;
}

export interface CategoryWhereInput {
  company?: CompanyWhereInput ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  description?: string ;
  description_not?: string ;
  description_in?: string[] ;
  description_not_in?: string[] ;
  description_lt?: string ;
  description_lte?: string ;
  description_gt?: string ;
  description_gte?: string ;
  description_contains?: string ;
  description_not_contains?: string ;
  description_starts_with?: string ;
  description_not_starts_with?: string ;
  description_ends_with?: string ;
  description_not_ends_with?: string ;
  descriptionLang?: TranslatedStringWhereInput ;
  entries_every?: MenuEntryWhereInput ;
  entries_some?: MenuEntryWhereInput ;
  entries_none?: MenuEntryWhereInput ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  image?: ImageWhereInput ;
  img?: string ;
  img_not?: string ;
  img_in?: string[] ;
  img_not_in?: string[] ;
  img_lt?: string ;
  img_lte?: string ;
  img_gt?: string ;
  img_gte?: string ;
  img_contains?: string ;
  img_not_contains?: string ;
  img_starts_with?: string ;
  img_not_starts_with?: string ;
  img_ends_with?: string ;
  img_not_ends_with?: string ;
  items_every?: ItemWhereInput ;
  items_some?: ItemWhereInput ;
  items_none?: ItemWhereInput ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  color?: string ;
  color_not?: string ;
  color_in?: string[] ;
  color_not_in?: string[] ;
  color_lt?: string ;
  color_lte?: string ;
  color_gt?: string ;
  color_gte?: string ;
  color_contains?: string ;
  color_not_contains?: string ;
  color_starts_with?: string ;
  color_not_starts_with?: string ;
  color_ends_with?: string ;
  color_not_ends_with?: string ;
  nameLang?: TranslatedStringWhereInput ;
  order?: number ;
  order_not?: number ;
  order_in?: number[] ;
  order_not_in?: number[] ;
  order_lt?: number ;
  order_lte?: number ;
  order_gt?: number ;
  order_gte?: number ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  itemGroups_every?: ItemGroupWhereInput ;
  itemGroups_some?: ItemGroupWhereInput ;
  itemGroups_none?: ItemGroupWhereInput ;
  stations_every?: StationWhereInput ;
  stations_some?: StationWhereInput ;
  stations_none?: StationWhereInput ;
  expressPages_every?: ExpressPageWhereInput ;
  expressPages_some?: ExpressPageWhereInput ;
  expressPages_none?: ExpressPageWhereInput ;
  parentId?: string ;
  parentId_not?: string ;
  parentId_in?: string[] ;
  parentId_not_in?: string[] ;
  parentId_lt?: string ;
  parentId_lte?: string ;
  parentId_gt?: string ;
  parentId_gte?: string ;
  parentId_contains?: string ;
  parentId_not_contains?: string ;
  parentId_starts_with?: string ;
  parentId_not_starts_with?: string ;
  parentId_ends_with?: string ;
  parentId_not_ends_with?: string ;
  offers_every?: OfferWhereInput ;
  offers_some?: OfferWhereInput ;
  offers_none?: OfferWhereInput ;
  vatRate?: number ;
  vatRate_not?: number ;
  vatRate_in?: number[] ;
  vatRate_not_in?: number[] ;
  vatRate_lt?: number ;
  vatRate_lte?: number ;
  vatRate_gt?: number ;
  vatRate_gte?: number ;
  courseType?: CourseTypeWhereInput ;
  hideInCustomerOrderingFlows?: boolean ;
  hideInCustomerOrderingFlows_not?: boolean ;
  AND?: CategoryWhereInput[] ;
  OR?: CategoryWhereInput[] ;
  NOT?: CategoryWhereInput[] ;
}

export interface CategoryWhereUniqueInput {
  id?: string ;
}

export interface ChangeBalanceStoreStatusInput {
  storeId: string;
  status: string;
}

export interface CompanyCreateInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateManyWithoutReferralOfferInput {
  create?: CompanyCreateWithoutReferralOfferInput[] ;
  connect?: CompanyWhereUniqueInput[] ;
}

export interface CompanyCreateManyWithoutReferrerOfferInput {
  create?: CompanyCreateWithoutReferrerOfferInput[] ;
  connect?: CompanyWhereUniqueInput[] ;
}

export interface CompanyCreateOneWithoutAccessLevelsInput {
  create?: CompanyCreateWithoutAccessLevelsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutCardDesignsInput {
  create?: CompanyCreateWithoutCardDesignsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutCategoriesInput {
  create?: CompanyCreateWithoutCategoriesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutContentInput {
  create?: CompanyCreateWithoutContentInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutCourseTypesInput {
  create?: CompanyCreateWithoutCourseTypesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutDeliveryRatesInput {
  create?: CompanyCreateWithoutDeliveryRatesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutDiscountsInput {
  create?: CompanyCreateWithoutDiscountsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutExpensesInput {
  create?: CompanyCreateWithoutExpensesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutExpressPagesInput {
  create?: CompanyCreateWithoutExpressPagesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutFeedInput {
  create?: CompanyCreateWithoutFeedInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutFloorPlansInput {
  create?: CompanyCreateWithoutFloorPlansInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutImagesInput {
  create?: CompanyCreateWithoutImagesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutInvoiceTargetsInput {
  create?: CompanyCreateWithoutInvoiceTargetsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutItemSizesInput {
  create?: CompanyCreateWithoutItemSizesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutItemsInput {
  create?: CompanyCreateWithoutItemsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutLayoutsInput {
  create?: CompanyCreateWithoutLayoutsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutMembershipTradeinsInput {
  create?: CompanyCreateWithoutMembershipTradeinsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutMembershipsInput {
  create?: CompanyCreateWithoutMembershipsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutMenusInput {
  create?: CompanyCreateWithoutMenusInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutOfferYieldEventsInput {
  create?: CompanyCreateWithoutOfferYieldEventsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutOffersInput {
  create?: CompanyCreateWithoutOffersInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutPagesInput {
  create?: CompanyCreateWithoutPagesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutPaymentMethodsInput {
  create?: CompanyCreateWithoutPaymentMethodsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutPosCategoriesInput {
  create?: CompanyCreateWithoutPosCategoriesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutPosDevicesInput {
  create?: CompanyCreateWithoutPosDevicesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutPredefinedMessagesInput {
  create?: CompanyCreateWithoutPredefinedMessagesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutPromocodesInput {
  create?: CompanyCreateWithoutPromocodesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutReceiptTemplateInput {
  create?: CompanyCreateWithoutReceiptTemplateInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutReferralBodyInput {
  create?: CompanyCreateWithoutReferralBodyInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutReferralShareMessageInput {
  create?: CompanyCreateWithoutReferralShareMessageInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutReferralTitleInput {
  create?: CompanyCreateWithoutReferralTitleInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutSegmentsInput {
  create?: CompanyCreateWithoutSegmentsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutSocialMediaFeedInput {
  create?: CompanyCreateWithoutSocialMediaFeedInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutStaffsInput {
  create?: CompanyCreateWithoutStaffsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutStampCardsInput {
  create?: CompanyCreateWithoutStampCardsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutStationsInput {
  create?: CompanyCreateWithoutStationsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutUpsellsInput {
  create?: CompanyCreateWithoutUpsellsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutUsersInput {
  create?: CompanyCreateWithoutUsersInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutVariationGroupsInput {
  create?: CompanyCreateWithoutVariationGroupsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutVariationsInput {
  create?: CompanyCreateWithoutVariationsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutVenuesInput {
  create?: CompanyCreateWithoutVenuesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateOneWithoutZonesInput {
  create?: CompanyCreateWithoutZonesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyCreateWithoutAccessLevelsInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutCardDesignsInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutCategoriesInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutContentInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutCourseTypesInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutDeliveryRatesInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutDiscountsInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutExpensesInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutExpressPagesInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutFeedInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutFloorPlansInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutImagesInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutInvoiceTargetsInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutItemSizesInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutItemsInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutLayoutsInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutMembershipTradeinsInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutMembershipsInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutMenusInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutOfferYieldEventsInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutOffersInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutPagesInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutPaymentMethodsInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutPosCategoriesInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutPosDevicesInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutPredefinedMessagesInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutPromocodesInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutReceiptTemplateInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutReferralBodyInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutReferralOfferInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutReferralShareMessageInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutReferralTitleInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutReferrerOfferInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutSegmentsInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutSocialMediaFeedInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutStaffsInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutStampCardsInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutStationsInput {
  id?: string ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutUpsellsInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutUsersInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutVariationGroupsInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutVariationsInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutVenuesInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  zones?: ZoneCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreateWithoutZonesInput {
  id?: string ;
  stations?: StationCreateManyWithoutCompanyInput ;
  categories?: CategoryCreateManyWithoutCompanyInput ;
  metadata?: AppMetadataCreateOneWithoutCompanyInput ;
  discounts?: DiscountCreateManyWithoutCompanyInput ;
  memberships?: MembershipLevelCreateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemCreateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeCreateManyWithoutCompanyInput ;
  languages?: CompanyCreatelanguagesInput ;
  currencies?: CompanyCreatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuCreateManyWithoutCompanyInput ;
  name: string;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyCreatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignCreateManyWithoutCompanyInput ;
  promocodes?: PromoCodeCreateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferCreateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferCreateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringCreateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringCreateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageCreateManyWithoutCompanyInput ;
  posDevices?: POSDeviceCreateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedCreateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyCreateloginMethodsInput ;
  variations?: VariationCreateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupCreateManyWithoutCompanyInput ;
  venues?: VenueCreateManyWithoutCompanyInput ;
  offers?: OfferCreateManyWithoutCompanyInput ;
  users?: UserCreateManyWithoutCompanyInput ;
  stampCards?: StampCardCreateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentCreateManyWithoutCompanyInput ;
  code: string;
  content?: ContentCreateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationCreateManyWithoutCompanyInput ;
  terminals?: PosTerminalCreateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutCompanyInput ;
  layouts?: LayoutCreateManyWithoutCompanyInput ;
  pages?: PageCreateManyWithoutCompanyInput ;
  posCategories?: PosCategoryCreateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateCreateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelCreateManyWithoutCompanyInput ;
  staffs?: StaffCreateManyWithoutCompanyInput ;
  upsells?: UpsellCreateManyWithoutCompanyInput ;
  expressPages?: ExpressPageCreateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeCreateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanCreateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutCompanyInput ;
  expenses?: ExpenseCreateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyCreatecurrenciesInput {
  set?: CURRENCY[] ;
}

export interface CompanyCreatelanguagesInput {
  set?: string[] ;
}

export interface CompanyCreateloginMethodsInput {
  set?: LOGIN_METHOD[] ;
}

export interface CompanyCreatevisibleVMCategoriesInput {
  set?: string[] ;
}

export interface CompanyScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  useUntranslatedFields?: boolean ;
  useUntranslatedFields_not?: boolean ;
  defaultCurrency?: CURRENCY ;
  defaultCurrency_not?: CURRENCY ;
  defaultCurrency_in?: CURRENCY[] ;
  defaultCurrency_not_in?: CURRENCY[] ;
  defaultLanguage?: string ;
  defaultLanguage_not?: string ;
  defaultLanguage_in?: string[] ;
  defaultLanguage_not_in?: string[] ;
  defaultLanguage_lt?: string ;
  defaultLanguage_lte?: string ;
  defaultLanguage_gt?: string ;
  defaultLanguage_gte?: string ;
  defaultLanguage_contains?: string ;
  defaultLanguage_not_contains?: string ;
  defaultLanguage_starts_with?: string ;
  defaultLanguage_not_starts_with?: string ;
  defaultLanguage_ends_with?: string ;
  defaultLanguage_not_ends_with?: string ;
  defaultCountryCode?: string ;
  defaultCountryCode_not?: string ;
  defaultCountryCode_in?: string[] ;
  defaultCountryCode_not_in?: string[] ;
  defaultCountryCode_lt?: string ;
  defaultCountryCode_lte?: string ;
  defaultCountryCode_gt?: string ;
  defaultCountryCode_gte?: string ;
  defaultCountryCode_contains?: string ;
  defaultCountryCode_not_contains?: string ;
  defaultCountryCode_starts_with?: string ;
  defaultCountryCode_not_starts_with?: string ;
  defaultCountryCode_ends_with?: string ;
  defaultCountryCode_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  manualEndOfDay?: boolean ;
  manualEndOfDay_not?: boolean ;
  disableStackedDiscounts?: boolean ;
  disableStackedDiscounts_not?: boolean ;
  createdByCustomer?: boolean ;
  createdByCustomer_not?: boolean ;
  referralsEnabled?: boolean ;
  referralsEnabled_not?: boolean ;
  hasCashback?: boolean ;
  hasCashback_not?: boolean ;
  active?: boolean ;
  active_not?: boolean ;
  supportEmail?: string ;
  supportEmail_not?: string ;
  supportEmail_in?: string[] ;
  supportEmail_not_in?: string[] ;
  supportEmail_lt?: string ;
  supportEmail_lte?: string ;
  supportEmail_gt?: string ;
  supportEmail_gte?: string ;
  supportEmail_contains?: string ;
  supportEmail_not_contains?: string ;
  supportEmail_starts_with?: string ;
  supportEmail_not_starts_with?: string ;
  supportEmail_ends_with?: string ;
  supportEmail_not_ends_with?: string ;
  requiresEmail?: string ;
  requiresEmail_not?: string ;
  requiresEmail_in?: string[] ;
  requiresEmail_not_in?: string[] ;
  requiresEmail_lt?: string ;
  requiresEmail_lte?: string ;
  requiresEmail_gt?: string ;
  requiresEmail_gte?: string ;
  requiresEmail_contains?: string ;
  requiresEmail_not_contains?: string ;
  requiresEmail_starts_with?: string ;
  requiresEmail_not_starts_with?: string ;
  requiresEmail_ends_with?: string ;
  requiresEmail_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  legacySegmentation?: boolean ;
  legacySegmentation_not?: boolean ;
  code?: string ;
  code_not?: string ;
  code_in?: string[] ;
  code_not_in?: string[] ;
  code_lt?: string ;
  code_lte?: string ;
  code_gt?: string ;
  code_gte?: string ;
  code_contains?: string ;
  code_not_contains?: string ;
  code_starts_with?: string ;
  code_not_starts_with?: string ;
  code_ends_with?: string ;
  code_not_ends_with?: string ;
  hasMembershipCards?: boolean ;
  hasMembershipCards_not?: boolean ;
  membershipPointsPercentage?: number ;
  membershipPointsPercentage_not?: number ;
  membershipPointsPercentage_in?: number[] ;
  membershipPointsPercentage_not_in?: number[] ;
  membershipPointsPercentage_lt?: number ;
  membershipPointsPercentage_lte?: number ;
  membershipPointsPercentage_gt?: number ;
  membershipPointsPercentage_gte?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodType_not?: MEMBERSHIP_PERIOD ;
  evaluationPeriodType_in?: MEMBERSHIP_PERIOD[] ;
  evaluationPeriodType_not_in?: MEMBERSHIP_PERIOD[] ;
  evaluationPeriodValue?: number ;
  evaluationPeriodValue_not?: number ;
  evaluationPeriodValue_in?: number[] ;
  evaluationPeriodValue_not_in?: number[] ;
  evaluationPeriodValue_lt?: number ;
  evaluationPeriodValue_lte?: number ;
  evaluationPeriodValue_gt?: number ;
  evaluationPeriodValue_gte?: number ;
  evaluationEndMonth?: number ;
  evaluationEndMonth_not?: number ;
  evaluationEndMonth_in?: number[] ;
  evaluationEndMonth_not_in?: number[] ;
  evaluationEndMonth_lt?: number ;
  evaluationEndMonth_lte?: number ;
  evaluationEndMonth_gt?: number ;
  evaluationEndMonth_gte?: number ;
  hasPOS?: boolean ;
  hasPOS_not?: boolean ;
  hasPoints?: boolean ;
  hasPoints_not?: boolean ;
  hasTables?: boolean ;
  hasTables_not?: boolean ;
  hasAppOrders?: boolean ;
  hasAppOrders_not?: boolean ;
  hasKDS?: boolean ;
  hasKDS_not?: boolean ;
  hasCDS?: boolean ;
  hasCDS_not?: boolean ;
  hasExpress?: boolean ;
  hasExpress_not?: boolean ;
  hasInventory?: boolean ;
  hasInventory_not?: boolean ;
  brandPrimaryColor?: string ;
  brandPrimaryColor_not?: string ;
  brandPrimaryColor_in?: string[] ;
  brandPrimaryColor_not_in?: string[] ;
  brandPrimaryColor_lt?: string ;
  brandPrimaryColor_lte?: string ;
  brandPrimaryColor_gt?: string ;
  brandPrimaryColor_gte?: string ;
  brandPrimaryColor_contains?: string ;
  brandPrimaryColor_not_contains?: string ;
  brandPrimaryColor_starts_with?: string ;
  brandPrimaryColor_not_starts_with?: string ;
  brandPrimaryColor_ends_with?: string ;
  brandPrimaryColor_not_ends_with?: string ;
  brandSecondaryColor?: string ;
  brandSecondaryColor_not?: string ;
  brandSecondaryColor_in?: string[] ;
  brandSecondaryColor_not_in?: string[] ;
  brandSecondaryColor_lt?: string ;
  brandSecondaryColor_lte?: string ;
  brandSecondaryColor_gt?: string ;
  brandSecondaryColor_gte?: string ;
  brandSecondaryColor_contains?: string ;
  brandSecondaryColor_not_contains?: string ;
  brandSecondaryColor_starts_with?: string ;
  brandSecondaryColor_not_starts_with?: string ;
  brandSecondaryColor_ends_with?: string ;
  brandSecondaryColor_not_ends_with?: string ;
  extended?: boolean ;
  extended_not?: boolean ;
  serviceFee?: number ;
  serviceFee_not?: number ;
  serviceFee_in?: number[] ;
  serviceFee_not_in?: number[] ;
  serviceFee_lt?: number ;
  serviceFee_lte?: number ;
  serviceFee_gt?: number ;
  serviceFee_gte?: number ;
  timezone?: string ;
  timezone_not?: string ;
  timezone_in?: string[] ;
  timezone_not_in?: string[] ;
  timezone_lt?: string ;
  timezone_lte?: string ;
  timezone_gt?: string ;
  timezone_gte?: string ;
  timezone_contains?: string ;
  timezone_not_contains?: string ;
  timezone_starts_with?: string ;
  timezone_not_starts_with?: string ;
  timezone_ends_with?: string ;
  timezone_not_ends_with?: string ;
  defaultOrderStatus?: ORDER_STATUS ;
  defaultOrderStatus_not?: ORDER_STATUS ;
  defaultOrderStatus_in?: ORDER_STATUS[] ;
  defaultOrderStatus_not_in?: ORDER_STATUS[] ;
  usesAFP?: boolean ;
  usesAFP_not?: boolean ;
  AND?: CompanyScalarWhereInput[] ;
  OR?: CompanyScalarWhereInput[] ;
  NOT?: CompanyScalarWhereInput[] ;
}

export interface CompanyUpdateInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateManyDataInput {
  useUntranslatedFields?: boolean ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  referralsEnabled?: boolean ;
  hasCashback?: boolean ;
  active?: boolean ;
  supportEmail?: string ;
  requiresEmail?: string ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  legacySegmentation?: boolean ;
  code?: string ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  defaultOrderStatus?: ORDER_STATUS ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateManyWithWhereNestedInput {
  where: CompanyScalarWhereInput;
  data: CompanyUpdateManyDataInput;
}

export interface CompanyUpdateManyWithoutReferralOfferInput {
  create?: CompanyCreateWithoutReferralOfferInput[] ;
  connect?: CompanyWhereUniqueInput[] ;
  set?: CompanyWhereUniqueInput[] ;
  disconnect?: CompanyWhereUniqueInput[] ;
  update?: CompanyUpdateWithWhereUniqueWithoutReferralOfferInput[] ;
  upsert?: CompanyUpsertWithWhereUniqueWithoutReferralOfferInput[] ;
  deleteMany?: CompanyScalarWhereInput[] ;
  updateMany?: CompanyUpdateManyWithWhereNestedInput[] ;
}

export interface CompanyUpdateManyWithoutReferrerOfferInput {
  create?: CompanyCreateWithoutReferrerOfferInput[] ;
  connect?: CompanyWhereUniqueInput[] ;
  set?: CompanyWhereUniqueInput[] ;
  disconnect?: CompanyWhereUniqueInput[] ;
  update?: CompanyUpdateWithWhereUniqueWithoutReferrerOfferInput[] ;
  upsert?: CompanyUpsertWithWhereUniqueWithoutReferrerOfferInput[] ;
  deleteMany?: CompanyScalarWhereInput[] ;
  updateMany?: CompanyUpdateManyWithWhereNestedInput[] ;
}

export interface CompanyUpdateOneRequiredWithoutAccessLevelsInput {
  create?: CompanyCreateWithoutAccessLevelsInput ;
  update?: CompanyUpdateWithoutAccessLevelsDataInput ;
  upsert?: CompanyUpsertWithoutAccessLevelsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneRequiredWithoutCardDesignsInput {
  create?: CompanyCreateWithoutCardDesignsInput ;
  update?: CompanyUpdateWithoutCardDesignsDataInput ;
  upsert?: CompanyUpsertWithoutCardDesignsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneRequiredWithoutCourseTypesInput {
  create?: CompanyCreateWithoutCourseTypesInput ;
  update?: CompanyUpdateWithoutCourseTypesDataInput ;
  upsert?: CompanyUpsertWithoutCourseTypesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneRequiredWithoutExpensesInput {
  create?: CompanyCreateWithoutExpensesInput ;
  update?: CompanyUpdateWithoutExpensesDataInput ;
  upsert?: CompanyUpsertWithoutExpensesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneRequiredWithoutExpressPagesInput {
  create?: CompanyCreateWithoutExpressPagesInput ;
  update?: CompanyUpdateWithoutExpressPagesDataInput ;
  upsert?: CompanyUpsertWithoutExpressPagesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneRequiredWithoutFloorPlansInput {
  create?: CompanyCreateWithoutFloorPlansInput ;
  update?: CompanyUpdateWithoutFloorPlansDataInput ;
  upsert?: CompanyUpsertWithoutFloorPlansInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneRequiredWithoutInvoiceTargetsInput {
  create?: CompanyCreateWithoutInvoiceTargetsInput ;
  update?: CompanyUpdateWithoutInvoiceTargetsDataInput ;
  upsert?: CompanyUpsertWithoutInvoiceTargetsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneRequiredWithoutLayoutsInput {
  create?: CompanyCreateWithoutLayoutsInput ;
  update?: CompanyUpdateWithoutLayoutsDataInput ;
  upsert?: CompanyUpsertWithoutLayoutsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneRequiredWithoutMembershipTradeinsInput {
  create?: CompanyCreateWithoutMembershipTradeinsInput ;
  update?: CompanyUpdateWithoutMembershipTradeinsDataInput ;
  upsert?: CompanyUpsertWithoutMembershipTradeinsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneRequiredWithoutMembershipsInput {
  create?: CompanyCreateWithoutMembershipsInput ;
  update?: CompanyUpdateWithoutMembershipsDataInput ;
  upsert?: CompanyUpsertWithoutMembershipsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneRequiredWithoutOfferYieldEventsInput {
  create?: CompanyCreateWithoutOfferYieldEventsInput ;
  update?: CompanyUpdateWithoutOfferYieldEventsDataInput ;
  upsert?: CompanyUpsertWithoutOfferYieldEventsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneRequiredWithoutPagesInput {
  create?: CompanyCreateWithoutPagesInput ;
  update?: CompanyUpdateWithoutPagesDataInput ;
  upsert?: CompanyUpsertWithoutPagesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneRequiredWithoutPaymentMethodsInput {
  create?: CompanyCreateWithoutPaymentMethodsInput ;
  update?: CompanyUpdateWithoutPaymentMethodsDataInput ;
  upsert?: CompanyUpsertWithoutPaymentMethodsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneRequiredWithoutPosCategoriesInput {
  create?: CompanyCreateWithoutPosCategoriesInput ;
  update?: CompanyUpdateWithoutPosCategoriesDataInput ;
  upsert?: CompanyUpsertWithoutPosCategoriesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneRequiredWithoutPredefinedMessagesInput {
  create?: CompanyCreateWithoutPredefinedMessagesInput ;
  update?: CompanyUpdateWithoutPredefinedMessagesDataInput ;
  upsert?: CompanyUpsertWithoutPredefinedMessagesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneRequiredWithoutReceiptTemplateInput {
  create?: CompanyCreateWithoutReceiptTemplateInput ;
  update?: CompanyUpdateWithoutReceiptTemplateDataInput ;
  upsert?: CompanyUpsertWithoutReceiptTemplateInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneRequiredWithoutStaffsInput {
  create?: CompanyCreateWithoutStaffsInput ;
  update?: CompanyUpdateWithoutStaffsDataInput ;
  upsert?: CompanyUpsertWithoutStaffsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneRequiredWithoutStationsInput {
  create?: CompanyCreateWithoutStationsInput ;
  update?: CompanyUpdateWithoutStationsDataInput ;
  upsert?: CompanyUpsertWithoutStationsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneRequiredWithoutUpsellsInput {
  create?: CompanyCreateWithoutUpsellsInput ;
  update?: CompanyUpdateWithoutUpsellsDataInput ;
  upsert?: CompanyUpsertWithoutUpsellsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneRequiredWithoutUsersInput {
  create?: CompanyCreateWithoutUsersInput ;
  update?: CompanyUpdateWithoutUsersDataInput ;
  upsert?: CompanyUpsertWithoutUsersInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneRequiredWithoutVariationGroupsInput {
  create?: CompanyCreateWithoutVariationGroupsInput ;
  update?: CompanyUpdateWithoutVariationGroupsDataInput ;
  upsert?: CompanyUpsertWithoutVariationGroupsInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneRequiredWithoutZonesInput {
  create?: CompanyCreateWithoutZonesInput ;
  update?: CompanyUpdateWithoutZonesDataInput ;
  upsert?: CompanyUpsertWithoutZonesInput ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneWithoutCategoriesInput {
  create?: CompanyCreateWithoutCategoriesInput ;
  update?: CompanyUpdateWithoutCategoriesDataInput ;
  upsert?: CompanyUpsertWithoutCategoriesInput ;
  disconnect?: boolean ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneWithoutContentInput {
  create?: CompanyCreateWithoutContentInput ;
  update?: CompanyUpdateWithoutContentDataInput ;
  upsert?: CompanyUpsertWithoutContentInput ;
  disconnect?: boolean ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneWithoutDeliveryRatesInput {
  create?: CompanyCreateWithoutDeliveryRatesInput ;
  update?: CompanyUpdateWithoutDeliveryRatesDataInput ;
  upsert?: CompanyUpsertWithoutDeliveryRatesInput ;
  disconnect?: boolean ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneWithoutDiscountsInput {
  create?: CompanyCreateWithoutDiscountsInput ;
  update?: CompanyUpdateWithoutDiscountsDataInput ;
  upsert?: CompanyUpsertWithoutDiscountsInput ;
  disconnect?: boolean ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneWithoutFeedInput {
  create?: CompanyCreateWithoutFeedInput ;
  update?: CompanyUpdateWithoutFeedDataInput ;
  upsert?: CompanyUpsertWithoutFeedInput ;
  disconnect?: boolean ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneWithoutImagesInput {
  create?: CompanyCreateWithoutImagesInput ;
  update?: CompanyUpdateWithoutImagesDataInput ;
  upsert?: CompanyUpsertWithoutImagesInput ;
  disconnect?: boolean ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneWithoutItemSizesInput {
  create?: CompanyCreateWithoutItemSizesInput ;
  update?: CompanyUpdateWithoutItemSizesDataInput ;
  upsert?: CompanyUpsertWithoutItemSizesInput ;
  disconnect?: boolean ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneWithoutItemsInput {
  create?: CompanyCreateWithoutItemsInput ;
  update?: CompanyUpdateWithoutItemsDataInput ;
  upsert?: CompanyUpsertWithoutItemsInput ;
  disconnect?: boolean ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneWithoutMenusInput {
  create?: CompanyCreateWithoutMenusInput ;
  update?: CompanyUpdateWithoutMenusDataInput ;
  upsert?: CompanyUpsertWithoutMenusInput ;
  disconnect?: boolean ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneWithoutOffersInput {
  create?: CompanyCreateWithoutOffersInput ;
  update?: CompanyUpdateWithoutOffersDataInput ;
  upsert?: CompanyUpsertWithoutOffersInput ;
  disconnect?: boolean ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneWithoutPosDevicesInput {
  create?: CompanyCreateWithoutPosDevicesInput ;
  update?: CompanyUpdateWithoutPosDevicesDataInput ;
  upsert?: CompanyUpsertWithoutPosDevicesInput ;
  disconnect?: boolean ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneWithoutPromocodesInput {
  create?: CompanyCreateWithoutPromocodesInput ;
  update?: CompanyUpdateWithoutPromocodesDataInput ;
  upsert?: CompanyUpsertWithoutPromocodesInput ;
  disconnect?: boolean ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneWithoutReferralBodyInput {
  create?: CompanyCreateWithoutReferralBodyInput ;
  update?: CompanyUpdateWithoutReferralBodyDataInput ;
  upsert?: CompanyUpsertWithoutReferralBodyInput ;
  disconnect?: boolean ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneWithoutReferralShareMessageInput {
  create?: CompanyCreateWithoutReferralShareMessageInput ;
  update?: CompanyUpdateWithoutReferralShareMessageDataInput ;
  upsert?: CompanyUpsertWithoutReferralShareMessageInput ;
  disconnect?: boolean ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneWithoutReferralTitleInput {
  create?: CompanyCreateWithoutReferralTitleInput ;
  update?: CompanyUpdateWithoutReferralTitleDataInput ;
  upsert?: CompanyUpsertWithoutReferralTitleInput ;
  disconnect?: boolean ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneWithoutSegmentsInput {
  create?: CompanyCreateWithoutSegmentsInput ;
  update?: CompanyUpdateWithoutSegmentsDataInput ;
  upsert?: CompanyUpsertWithoutSegmentsInput ;
  disconnect?: boolean ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneWithoutSocialMediaFeedInput {
  create?: CompanyCreateWithoutSocialMediaFeedInput ;
  update?: CompanyUpdateWithoutSocialMediaFeedDataInput ;
  upsert?: CompanyUpsertWithoutSocialMediaFeedInput ;
  disconnect?: boolean ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneWithoutStampCardsInput {
  create?: CompanyCreateWithoutStampCardsInput ;
  update?: CompanyUpdateWithoutStampCardsDataInput ;
  upsert?: CompanyUpsertWithoutStampCardsInput ;
  disconnect?: boolean ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneWithoutVariationsInput {
  create?: CompanyCreateWithoutVariationsInput ;
  update?: CompanyUpdateWithoutVariationsDataInput ;
  upsert?: CompanyUpsertWithoutVariationsInput ;
  disconnect?: boolean ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateOneWithoutVenuesInput {
  create?: CompanyCreateWithoutVenuesInput ;
  update?: CompanyUpdateWithoutVenuesDataInput ;
  upsert?: CompanyUpsertWithoutVenuesInput ;
  disconnect?: boolean ;
  connect?: CompanyWhereUniqueInput ;
}

export interface CompanyUpdateWithWhereUniqueWithoutReferralOfferInput {
  where: CompanyWhereUniqueInput;
  data: CompanyUpdateWithoutReferralOfferDataInput;
}

export interface CompanyUpdateWithWhereUniqueWithoutReferrerOfferInput {
  where: CompanyWhereUniqueInput;
  data: CompanyUpdateWithoutReferrerOfferDataInput;
}

export interface CompanyUpdateWithoutAccessLevelsDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutCardDesignsDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutCategoriesDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutContentDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutCourseTypesDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutDeliveryRatesDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutDiscountsDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutExpensesDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutExpressPagesDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutFeedDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutFloorPlansDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutImagesDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutInvoiceTargetsDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutItemSizesDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutItemsDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutLayoutsDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutMembershipTradeinsDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutMembershipsDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutMenusDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutOfferYieldEventsDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutOffersDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutPagesDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutPaymentMethodsDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutPosCategoriesDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutPosDevicesDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutPredefinedMessagesDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutPromocodesDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutReceiptTemplateDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutReferralBodyDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutReferralOfferDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutReferralShareMessageDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutReferralTitleDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutReferrerOfferDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutSegmentsDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutSocialMediaFeedDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutStaffsDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutStampCardsDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutStationsDataInput {
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutUpsellsDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutUsersDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutVariationGroupsDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutVariationsDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutVenuesDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  zones?: ZoneUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdateWithoutZonesDataInput {
  stations?: StationUpdateManyWithoutCompanyInput ;
  categories?: CategoryUpdateManyWithoutCompanyInput ;
  metadata?: AppMetadataUpdateOneWithoutCompanyInput ;
  discounts?: DiscountUpdateManyWithoutCompanyInput ;
  memberships?: MembershipLevelUpdateManyWithoutCompanyInput ;
  useUntranslatedFields?: boolean ;
  items?: ItemUpdateManyWithoutCompanyInput ;
  itemSizes?: ItemSizeUpdateManyWithoutCompanyInput ;
  languages?: CompanyUpdatelanguagesInput ;
  currencies?: CompanyUpdatecurrenciesInput ;
  defaultCurrency?: CURRENCY ;
  defaultLanguage?: string ;
  defaultCountryCode?: string ;
  menus?: MenuUpdateManyWithoutCompanyInput ;
  name?: string ;
  manualEndOfDay?: boolean ;
  visibleVMCategories?: CompanyUpdatevisibleVMCategoriesInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutCompanyInput ;
  disableStackedDiscounts?: boolean ;
  createdByCustomer?: boolean ;
  cardDesigns?: CardDesignUpdateManyWithoutCompanyInput ;
  promocodes?: PromoCodeUpdateManyWithoutCompanyInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutCompanyInput ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutCompanyInput ;
  referralsEnabled?: boolean ;
  referralShareMessage?: TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput ;
  referralOffer?: OfferUpdateOneWithoutReferralOfferForCompanyInput ;
  referrerOffer?: OfferUpdateOneWithoutReferrerOfferForCompanyInput ;
  referralTitle?: TranslatedStringUpdateOneWithoutCompanyReferralTitleInput ;
  referralBody?: TranslatedStringUpdateOneWithoutCompanyReferralBodyInput ;
  hasCashback?: boolean ;
  active?: boolean ;
  images?: ImageUpdateManyWithoutCompanyInput ;
  posDevices?: POSDeviceUpdateManyWithoutCompanyInput ;
  supportEmail?: string ;
  requiresEmail?: string ;
  feed?: SocialMediaFeedUpdateManyWithoutCompanyInput ;
  socialMediaFeed?: SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput ;
  loginMethods?: CompanyUpdateloginMethodsInput ;
  variations?: VariationUpdateManyWithoutCompanyInput ;
  variationGroups?: VariationGroupUpdateManyWithoutCompanyInput ;
  venues?: VenueUpdateManyWithoutCompanyInput ;
  offers?: OfferUpdateManyWithoutCompanyInput ;
  users?: UserUpdateManyWithoutCompanyInput ;
  stampCards?: StampCardUpdateManyWithoutCompanyInput ;
  legacySegmentation?: boolean ;
  segments?: UserSegmentUpdateManyWithoutCompanyInput ;
  code?: string ;
  content?: ContentUpdateManyWithoutCompanyInput ;
  hasMembershipCards?: boolean ;
  membershipPointsPercentage?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodValue?: number ;
  evaluationEndMonth?: number ;
  integrations?: IntegrationUpdateManyWithoutCompanyInput ;
  terminals?: PosTerminalUpdateManyWithoutCompanyInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutCompanyInput ;
  hasPOS?: boolean ;
  hasPoints?: boolean ;
  hasTables?: boolean ;
  hasAppOrders?: boolean ;
  hasKDS?: boolean ;
  hasCDS?: boolean ;
  hasExpress?: boolean ;
  hasInventory?: boolean ;
  brandPrimaryColor?: string ;
  brandSecondaryColor?: string ;
  extended?: boolean ;
  serviceFee?: number ;
  timezone?: string ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutCompanyInput ;
  layouts?: LayoutUpdateManyWithoutCompanyInput ;
  pages?: PageUpdateManyWithoutCompanyInput ;
  posCategories?: PosCategoryUpdateManyWithoutCompanyInput ;
  receiptTemplate?: ReceiptTemplateUpdateManyWithoutCompanyInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  accessLevels?: AccessLevelUpdateManyWithoutCompanyInput ;
  staffs?: StaffUpdateManyWithoutCompanyInput ;
  upsells?: UpsellUpdateManyWithoutCompanyInput ;
  expressPages?: ExpressPageUpdateManyWithoutCompanyInput ;
  courseTypes?: CourseTypeUpdateManyWithoutCompanyInput ;
  floorPlans?: FloorPlanUpdateManyWithoutCompanyInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutCompanyInput ;
  expenses?: ExpenseUpdateManyWithoutCompanyInput ;
  usesAFP?: boolean ;
}

export interface CompanyUpdatecurrenciesInput {
  set?: CURRENCY[] ;
}

export interface CompanyUpdatelanguagesInput {
  set?: string[] ;
}

export interface CompanyUpdateloginMethodsInput {
  set?: LOGIN_METHOD[] ;
}

export interface CompanyUpdatevisibleVMCategoriesInput {
  set?: string[] ;
}

export interface CompanyUpsertWithWhereUniqueWithoutReferralOfferInput {
  where: CompanyWhereUniqueInput;
  update: CompanyUpdateWithoutReferralOfferDataInput;
  create: CompanyCreateWithoutReferralOfferInput;
}

export interface CompanyUpsertWithWhereUniqueWithoutReferrerOfferInput {
  where: CompanyWhereUniqueInput;
  update: CompanyUpdateWithoutReferrerOfferDataInput;
  create: CompanyCreateWithoutReferrerOfferInput;
}

export interface CompanyUpsertWithoutAccessLevelsInput {
  update: CompanyUpdateWithoutAccessLevelsDataInput;
  create: CompanyCreateWithoutAccessLevelsInput;
}

export interface CompanyUpsertWithoutCardDesignsInput {
  update: CompanyUpdateWithoutCardDesignsDataInput;
  create: CompanyCreateWithoutCardDesignsInput;
}

export interface CompanyUpsertWithoutCategoriesInput {
  update: CompanyUpdateWithoutCategoriesDataInput;
  create: CompanyCreateWithoutCategoriesInput;
}

export interface CompanyUpsertWithoutContentInput {
  update: CompanyUpdateWithoutContentDataInput;
  create: CompanyCreateWithoutContentInput;
}

export interface CompanyUpsertWithoutCourseTypesInput {
  update: CompanyUpdateWithoutCourseTypesDataInput;
  create: CompanyCreateWithoutCourseTypesInput;
}

export interface CompanyUpsertWithoutDeliveryRatesInput {
  update: CompanyUpdateWithoutDeliveryRatesDataInput;
  create: CompanyCreateWithoutDeliveryRatesInput;
}

export interface CompanyUpsertWithoutDiscountsInput {
  update: CompanyUpdateWithoutDiscountsDataInput;
  create: CompanyCreateWithoutDiscountsInput;
}

export interface CompanyUpsertWithoutExpensesInput {
  update: CompanyUpdateWithoutExpensesDataInput;
  create: CompanyCreateWithoutExpensesInput;
}

export interface CompanyUpsertWithoutExpressPagesInput {
  update: CompanyUpdateWithoutExpressPagesDataInput;
  create: CompanyCreateWithoutExpressPagesInput;
}

export interface CompanyUpsertWithoutFeedInput {
  update: CompanyUpdateWithoutFeedDataInput;
  create: CompanyCreateWithoutFeedInput;
}

export interface CompanyUpsertWithoutFloorPlansInput {
  update: CompanyUpdateWithoutFloorPlansDataInput;
  create: CompanyCreateWithoutFloorPlansInput;
}

export interface CompanyUpsertWithoutImagesInput {
  update: CompanyUpdateWithoutImagesDataInput;
  create: CompanyCreateWithoutImagesInput;
}

export interface CompanyUpsertWithoutInvoiceTargetsInput {
  update: CompanyUpdateWithoutInvoiceTargetsDataInput;
  create: CompanyCreateWithoutInvoiceTargetsInput;
}

export interface CompanyUpsertWithoutItemSizesInput {
  update: CompanyUpdateWithoutItemSizesDataInput;
  create: CompanyCreateWithoutItemSizesInput;
}

export interface CompanyUpsertWithoutItemsInput {
  update: CompanyUpdateWithoutItemsDataInput;
  create: CompanyCreateWithoutItemsInput;
}

export interface CompanyUpsertWithoutLayoutsInput {
  update: CompanyUpdateWithoutLayoutsDataInput;
  create: CompanyCreateWithoutLayoutsInput;
}

export interface CompanyUpsertWithoutMembershipTradeinsInput {
  update: CompanyUpdateWithoutMembershipTradeinsDataInput;
  create: CompanyCreateWithoutMembershipTradeinsInput;
}

export interface CompanyUpsertWithoutMembershipsInput {
  update: CompanyUpdateWithoutMembershipsDataInput;
  create: CompanyCreateWithoutMembershipsInput;
}

export interface CompanyUpsertWithoutMenusInput {
  update: CompanyUpdateWithoutMenusDataInput;
  create: CompanyCreateWithoutMenusInput;
}

export interface CompanyUpsertWithoutOfferYieldEventsInput {
  update: CompanyUpdateWithoutOfferYieldEventsDataInput;
  create: CompanyCreateWithoutOfferYieldEventsInput;
}

export interface CompanyUpsertWithoutOffersInput {
  update: CompanyUpdateWithoutOffersDataInput;
  create: CompanyCreateWithoutOffersInput;
}

export interface CompanyUpsertWithoutPagesInput {
  update: CompanyUpdateWithoutPagesDataInput;
  create: CompanyCreateWithoutPagesInput;
}

export interface CompanyUpsertWithoutPaymentMethodsInput {
  update: CompanyUpdateWithoutPaymentMethodsDataInput;
  create: CompanyCreateWithoutPaymentMethodsInput;
}

export interface CompanyUpsertWithoutPosCategoriesInput {
  update: CompanyUpdateWithoutPosCategoriesDataInput;
  create: CompanyCreateWithoutPosCategoriesInput;
}

export interface CompanyUpsertWithoutPosDevicesInput {
  update: CompanyUpdateWithoutPosDevicesDataInput;
  create: CompanyCreateWithoutPosDevicesInput;
}

export interface CompanyUpsertWithoutPredefinedMessagesInput {
  update: CompanyUpdateWithoutPredefinedMessagesDataInput;
  create: CompanyCreateWithoutPredefinedMessagesInput;
}

export interface CompanyUpsertWithoutPromocodesInput {
  update: CompanyUpdateWithoutPromocodesDataInput;
  create: CompanyCreateWithoutPromocodesInput;
}

export interface CompanyUpsertWithoutReceiptTemplateInput {
  update: CompanyUpdateWithoutReceiptTemplateDataInput;
  create: CompanyCreateWithoutReceiptTemplateInput;
}

export interface CompanyUpsertWithoutReferralBodyInput {
  update: CompanyUpdateWithoutReferralBodyDataInput;
  create: CompanyCreateWithoutReferralBodyInput;
}

export interface CompanyUpsertWithoutReferralShareMessageInput {
  update: CompanyUpdateWithoutReferralShareMessageDataInput;
  create: CompanyCreateWithoutReferralShareMessageInput;
}

export interface CompanyUpsertWithoutReferralTitleInput {
  update: CompanyUpdateWithoutReferralTitleDataInput;
  create: CompanyCreateWithoutReferralTitleInput;
}

export interface CompanyUpsertWithoutSegmentsInput {
  update: CompanyUpdateWithoutSegmentsDataInput;
  create: CompanyCreateWithoutSegmentsInput;
}

export interface CompanyUpsertWithoutSocialMediaFeedInput {
  update: CompanyUpdateWithoutSocialMediaFeedDataInput;
  create: CompanyCreateWithoutSocialMediaFeedInput;
}

export interface CompanyUpsertWithoutStaffsInput {
  update: CompanyUpdateWithoutStaffsDataInput;
  create: CompanyCreateWithoutStaffsInput;
}

export interface CompanyUpsertWithoutStampCardsInput {
  update: CompanyUpdateWithoutStampCardsDataInput;
  create: CompanyCreateWithoutStampCardsInput;
}

export interface CompanyUpsertWithoutStationsInput {
  update: CompanyUpdateWithoutStationsDataInput;
  create: CompanyCreateWithoutStationsInput;
}

export interface CompanyUpsertWithoutUpsellsInput {
  update: CompanyUpdateWithoutUpsellsDataInput;
  create: CompanyCreateWithoutUpsellsInput;
}

export interface CompanyUpsertWithoutUsersInput {
  update: CompanyUpdateWithoutUsersDataInput;
  create: CompanyCreateWithoutUsersInput;
}

export interface CompanyUpsertWithoutVariationGroupsInput {
  update: CompanyUpdateWithoutVariationGroupsDataInput;
  create: CompanyCreateWithoutVariationGroupsInput;
}

export interface CompanyUpsertWithoutVariationsInput {
  update: CompanyUpdateWithoutVariationsDataInput;
  create: CompanyCreateWithoutVariationsInput;
}

export interface CompanyUpsertWithoutVenuesInput {
  update: CompanyUpdateWithoutVenuesDataInput;
  create: CompanyCreateWithoutVenuesInput;
}

export interface CompanyUpsertWithoutZonesInput {
  update: CompanyUpdateWithoutZonesDataInput;
  create: CompanyCreateWithoutZonesInput;
}

export interface CompanyWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  stations_every?: StationWhereInput ;
  stations_some?: StationWhereInput ;
  stations_none?: StationWhereInput ;
  categories_every?: CategoryWhereInput ;
  categories_some?: CategoryWhereInput ;
  categories_none?: CategoryWhereInput ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  metadata?: AppMetadataWhereInput ;
  discounts_every?: DiscountWhereInput ;
  discounts_some?: DiscountWhereInput ;
  discounts_none?: DiscountWhereInput ;
  memberships_every?: MembershipLevelWhereInput ;
  memberships_some?: MembershipLevelWhereInput ;
  memberships_none?: MembershipLevelWhereInput ;
  useUntranslatedFields?: boolean ;
  useUntranslatedFields_not?: boolean ;
  items_every?: ItemWhereInput ;
  items_some?: ItemWhereInput ;
  items_none?: ItemWhereInput ;
  itemSizes_every?: ItemSizeWhereInput ;
  itemSizes_some?: ItemSizeWhereInput ;
  itemSizes_none?: ItemSizeWhereInput ;
  defaultCurrency?: CURRENCY ;
  defaultCurrency_not?: CURRENCY ;
  defaultCurrency_in?: CURRENCY[] ;
  defaultCurrency_not_in?: CURRENCY[] ;
  defaultLanguage?: string ;
  defaultLanguage_not?: string ;
  defaultLanguage_in?: string[] ;
  defaultLanguage_not_in?: string[] ;
  defaultLanguage_lt?: string ;
  defaultLanguage_lte?: string ;
  defaultLanguage_gt?: string ;
  defaultLanguage_gte?: string ;
  defaultLanguage_contains?: string ;
  defaultLanguage_not_contains?: string ;
  defaultLanguage_starts_with?: string ;
  defaultLanguage_not_starts_with?: string ;
  defaultLanguage_ends_with?: string ;
  defaultLanguage_not_ends_with?: string ;
  defaultCountryCode?: string ;
  defaultCountryCode_not?: string ;
  defaultCountryCode_in?: string[] ;
  defaultCountryCode_not_in?: string[] ;
  defaultCountryCode_lt?: string ;
  defaultCountryCode_lte?: string ;
  defaultCountryCode_gt?: string ;
  defaultCountryCode_gte?: string ;
  defaultCountryCode_contains?: string ;
  defaultCountryCode_not_contains?: string ;
  defaultCountryCode_starts_with?: string ;
  defaultCountryCode_not_starts_with?: string ;
  defaultCountryCode_ends_with?: string ;
  defaultCountryCode_not_ends_with?: string ;
  menus_every?: MenuWhereInput ;
  menus_some?: MenuWhereInput ;
  menus_none?: MenuWhereInput ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  manualEndOfDay?: boolean ;
  manualEndOfDay_not?: boolean ;
  paymentMethods_every?: PaymentMethodWhereInput ;
  paymentMethods_some?: PaymentMethodWhereInput ;
  paymentMethods_none?: PaymentMethodWhereInput ;
  disableStackedDiscounts?: boolean ;
  disableStackedDiscounts_not?: boolean ;
  createdByCustomer?: boolean ;
  createdByCustomer_not?: boolean ;
  cardDesigns_every?: CardDesignWhereInput ;
  cardDesigns_some?: CardDesignWhereInput ;
  cardDesigns_none?: CardDesignWhereInput ;
  promocodes_every?: PromoCodeWhereInput ;
  promocodes_some?: PromoCodeWhereInput ;
  promocodes_none?: PromoCodeWhereInput ;
  deliveryRates_every?: DeliveryRateWhereInput ;
  deliveryRates_some?: DeliveryRateWhereInput ;
  deliveryRates_none?: DeliveryRateWhereInput ;
  offerYieldEvents_every?: OfferYieldEventWhereInput ;
  offerYieldEvents_some?: OfferYieldEventWhereInput ;
  offerYieldEvents_none?: OfferYieldEventWhereInput ;
  referralsEnabled?: boolean ;
  referralsEnabled_not?: boolean ;
  referralShareMessage?: TranslatedStringWhereInput ;
  referralOffer?: OfferWhereInput ;
  referrerOffer?: OfferWhereInput ;
  referralTitle?: TranslatedStringWhereInput ;
  referralBody?: TranslatedStringWhereInput ;
  hasCashback?: boolean ;
  hasCashback_not?: boolean ;
  active?: boolean ;
  active_not?: boolean ;
  images_every?: ImageWhereInput ;
  images_some?: ImageWhereInput ;
  images_none?: ImageWhereInput ;
  posDevices_every?: POSDeviceWhereInput ;
  posDevices_some?: POSDeviceWhereInput ;
  posDevices_none?: POSDeviceWhereInput ;
  supportEmail?: string ;
  supportEmail_not?: string ;
  supportEmail_in?: string[] ;
  supportEmail_not_in?: string[] ;
  supportEmail_lt?: string ;
  supportEmail_lte?: string ;
  supportEmail_gt?: string ;
  supportEmail_gte?: string ;
  supportEmail_contains?: string ;
  supportEmail_not_contains?: string ;
  supportEmail_starts_with?: string ;
  supportEmail_not_starts_with?: string ;
  supportEmail_ends_with?: string ;
  supportEmail_not_ends_with?: string ;
  requiresEmail?: string ;
  requiresEmail_not?: string ;
  requiresEmail_in?: string[] ;
  requiresEmail_not_in?: string[] ;
  requiresEmail_lt?: string ;
  requiresEmail_lte?: string ;
  requiresEmail_gt?: string ;
  requiresEmail_gte?: string ;
  requiresEmail_contains?: string ;
  requiresEmail_not_contains?: string ;
  requiresEmail_starts_with?: string ;
  requiresEmail_not_starts_with?: string ;
  requiresEmail_ends_with?: string ;
  requiresEmail_not_ends_with?: string ;
  feed_every?: SocialMediaFeedWhereInput ;
  feed_some?: SocialMediaFeedWhereInput ;
  feed_none?: SocialMediaFeedWhereInput ;
  socialMediaFeed_every?: SocialMediaFeedWhereInput ;
  socialMediaFeed_some?: SocialMediaFeedWhereInput ;
  socialMediaFeed_none?: SocialMediaFeedWhereInput ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  variations_every?: VariationWhereInput ;
  variations_some?: VariationWhereInput ;
  variations_none?: VariationWhereInput ;
  variationGroups_every?: VariationGroupWhereInput ;
  variationGroups_some?: VariationGroupWhereInput ;
  variationGroups_none?: VariationGroupWhereInput ;
  venues_every?: VenueWhereInput ;
  venues_some?: VenueWhereInput ;
  venues_none?: VenueWhereInput ;
  offers_every?: OfferWhereInput ;
  offers_some?: OfferWhereInput ;
  offers_none?: OfferWhereInput ;
  users_every?: UserWhereInput ;
  users_some?: UserWhereInput ;
  users_none?: UserWhereInput ;
  stampCards_every?: StampCardWhereInput ;
  stampCards_some?: StampCardWhereInput ;
  stampCards_none?: StampCardWhereInput ;
  legacySegmentation?: boolean ;
  legacySegmentation_not?: boolean ;
  segments_every?: UserSegmentWhereInput ;
  segments_some?: UserSegmentWhereInput ;
  segments_none?: UserSegmentWhereInput ;
  code?: string ;
  code_not?: string ;
  code_in?: string[] ;
  code_not_in?: string[] ;
  code_lt?: string ;
  code_lte?: string ;
  code_gt?: string ;
  code_gte?: string ;
  code_contains?: string ;
  code_not_contains?: string ;
  code_starts_with?: string ;
  code_not_starts_with?: string ;
  code_ends_with?: string ;
  code_not_ends_with?: string ;
  content_every?: ContentWhereInput ;
  content_some?: ContentWhereInput ;
  content_none?: ContentWhereInput ;
  hasMembershipCards?: boolean ;
  hasMembershipCards_not?: boolean ;
  membershipPointsPercentage?: number ;
  membershipPointsPercentage_not?: number ;
  membershipPointsPercentage_in?: number[] ;
  membershipPointsPercentage_not_in?: number[] ;
  membershipPointsPercentage_lt?: number ;
  membershipPointsPercentage_lte?: number ;
  membershipPointsPercentage_gt?: number ;
  membershipPointsPercentage_gte?: number ;
  evaluationPeriodType?: MEMBERSHIP_PERIOD ;
  evaluationPeriodType_not?: MEMBERSHIP_PERIOD ;
  evaluationPeriodType_in?: MEMBERSHIP_PERIOD[] ;
  evaluationPeriodType_not_in?: MEMBERSHIP_PERIOD[] ;
  evaluationPeriodValue?: number ;
  evaluationPeriodValue_not?: number ;
  evaluationPeriodValue_in?: number[] ;
  evaluationPeriodValue_not_in?: number[] ;
  evaluationPeriodValue_lt?: number ;
  evaluationPeriodValue_lte?: number ;
  evaluationPeriodValue_gt?: number ;
  evaluationPeriodValue_gte?: number ;
  evaluationEndMonth?: number ;
  evaluationEndMonth_not?: number ;
  evaluationEndMonth_in?: number[] ;
  evaluationEndMonth_not_in?: number[] ;
  evaluationEndMonth_lt?: number ;
  evaluationEndMonth_lte?: number ;
  evaluationEndMonth_gt?: number ;
  evaluationEndMonth_gte?: number ;
  integrations_every?: IntegrationWhereInput ;
  integrations_some?: IntegrationWhereInput ;
  integrations_none?: IntegrationWhereInput ;
  terminals_every?: PosTerminalWhereInput ;
  terminals_some?: PosTerminalWhereInput ;
  terminals_none?: PosTerminalWhereInput ;
  membershipTradeins_every?: MembershipTradeinWhereInput ;
  membershipTradeins_some?: MembershipTradeinWhereInput ;
  membershipTradeins_none?: MembershipTradeinWhereInput ;
  hasPOS?: boolean ;
  hasPOS_not?: boolean ;
  hasPoints?: boolean ;
  hasPoints_not?: boolean ;
  hasTables?: boolean ;
  hasTables_not?: boolean ;
  hasAppOrders?: boolean ;
  hasAppOrders_not?: boolean ;
  hasKDS?: boolean ;
  hasKDS_not?: boolean ;
  hasCDS?: boolean ;
  hasCDS_not?: boolean ;
  hasExpress?: boolean ;
  hasExpress_not?: boolean ;
  hasInventory?: boolean ;
  hasInventory_not?: boolean ;
  brandPrimaryColor?: string ;
  brandPrimaryColor_not?: string ;
  brandPrimaryColor_in?: string[] ;
  brandPrimaryColor_not_in?: string[] ;
  brandPrimaryColor_lt?: string ;
  brandPrimaryColor_lte?: string ;
  brandPrimaryColor_gt?: string ;
  brandPrimaryColor_gte?: string ;
  brandPrimaryColor_contains?: string ;
  brandPrimaryColor_not_contains?: string ;
  brandPrimaryColor_starts_with?: string ;
  brandPrimaryColor_not_starts_with?: string ;
  brandPrimaryColor_ends_with?: string ;
  brandPrimaryColor_not_ends_with?: string ;
  brandSecondaryColor?: string ;
  brandSecondaryColor_not?: string ;
  brandSecondaryColor_in?: string[] ;
  brandSecondaryColor_not_in?: string[] ;
  brandSecondaryColor_lt?: string ;
  brandSecondaryColor_lte?: string ;
  brandSecondaryColor_gt?: string ;
  brandSecondaryColor_gte?: string ;
  brandSecondaryColor_contains?: string ;
  brandSecondaryColor_not_contains?: string ;
  brandSecondaryColor_starts_with?: string ;
  brandSecondaryColor_not_starts_with?: string ;
  brandSecondaryColor_ends_with?: string ;
  brandSecondaryColor_not_ends_with?: string ;
  extended?: boolean ;
  extended_not?: boolean ;
  serviceFee?: number ;
  serviceFee_not?: number ;
  serviceFee_in?: number[] ;
  serviceFee_not_in?: number[] ;
  serviceFee_lt?: number ;
  serviceFee_lte?: number ;
  serviceFee_gt?: number ;
  serviceFee_gte?: number ;
  timezone?: string ;
  timezone_not?: string ;
  timezone_in?: string[] ;
  timezone_not_in?: string[] ;
  timezone_lt?: string ;
  timezone_lte?: string ;
  timezone_gt?: string ;
  timezone_gte?: string ;
  timezone_contains?: string ;
  timezone_not_contains?: string ;
  timezone_starts_with?: string ;
  timezone_not_starts_with?: string ;
  timezone_ends_with?: string ;
  timezone_not_ends_with?: string ;
  invoiceTargets_every?: InvoiceTargetWhereInput ;
  invoiceTargets_some?: InvoiceTargetWhereInput ;
  invoiceTargets_none?: InvoiceTargetWhereInput ;
  layouts_every?: LayoutWhereInput ;
  layouts_some?: LayoutWhereInput ;
  layouts_none?: LayoutWhereInput ;
  pages_every?: PageWhereInput ;
  pages_some?: PageWhereInput ;
  pages_none?: PageWhereInput ;
  posCategories_every?: PosCategoryWhereInput ;
  posCategories_some?: PosCategoryWhereInput ;
  posCategories_none?: PosCategoryWhereInput ;
  receiptTemplate_every?: ReceiptTemplateWhereInput ;
  receiptTemplate_some?: ReceiptTemplateWhereInput ;
  receiptTemplate_none?: ReceiptTemplateWhereInput ;
  defaultOrderStatus?: ORDER_STATUS ;
  defaultOrderStatus_not?: ORDER_STATUS ;
  defaultOrderStatus_in?: ORDER_STATUS[] ;
  defaultOrderStatus_not_in?: ORDER_STATUS[] ;
  accessLevels_every?: AccessLevelWhereInput ;
  accessLevels_some?: AccessLevelWhereInput ;
  accessLevels_none?: AccessLevelWhereInput ;
  staffs_every?: StaffWhereInput ;
  staffs_some?: StaffWhereInput ;
  staffs_none?: StaffWhereInput ;
  upsells_every?: UpsellWhereInput ;
  upsells_some?: UpsellWhereInput ;
  upsells_none?: UpsellWhereInput ;
  expressPages_every?: ExpressPageWhereInput ;
  expressPages_some?: ExpressPageWhereInput ;
  expressPages_none?: ExpressPageWhereInput ;
  zones_every?: ZoneWhereInput ;
  zones_some?: ZoneWhereInput ;
  zones_none?: ZoneWhereInput ;
  courseTypes_every?: CourseTypeWhereInput ;
  courseTypes_some?: CourseTypeWhereInput ;
  courseTypes_none?: CourseTypeWhereInput ;
  floorPlans_every?: FloorPlanWhereInput ;
  floorPlans_some?: FloorPlanWhereInput ;
  floorPlans_none?: FloorPlanWhereInput ;
  predefinedMessages_every?: PredefinedMessageWhereInput ;
  predefinedMessages_some?: PredefinedMessageWhereInput ;
  predefinedMessages_none?: PredefinedMessageWhereInput ;
  expenses_every?: ExpenseWhereInput ;
  expenses_some?: ExpenseWhereInput ;
  expenses_none?: ExpenseWhereInput ;
  usesAFP?: boolean ;
  usesAFP_not?: boolean ;
  AND?: CompanyWhereInput[] ;
  OR?: CompanyWhereInput[] ;
  NOT?: CompanyWhereInput[] ;
}

export interface CompanyWhereUniqueInput {
  id?: string ;
}

export interface ConfigureVenueSalesInputData {
  name: string;
  timezone: string;
  language: SalesServiceLanguage;
  companyId: string;
  companyName: string;
  serviceFee?: number ;
  serviceFeeVAT?: number ;
  refundFee?: number ;
}

export interface ConfigureVenueSalesInputIZettle {
  iZettleVenueName?: string ;
}

export interface ConfigureVenueSalesInputValidators {
  IZETTLE?: ConfigureVenueSalesInputIZettle ;
  VAT?: any ;
  PAYMENT_PRICE?: any ;
  DUPLICATE_TRANSACTIONS?: any ;
}

export interface ContentCreateManyWithoutCompanyInput {
  create?: ContentCreateWithoutCompanyInput[] ;
  connect?: ContentWhereUniqueInput[] ;
}

export interface ContentCreateManyWithoutImageInput {
  create?: ContentCreateWithoutImageInput[] ;
  connect?: ContentWhereUniqueInput[] ;
}

export interface ContentCreateManyWithoutSegmentsInput {
  create?: ContentCreateWithoutSegmentsInput[] ;
  connect?: ContentWhereUniqueInput[] ;
}

export interface ContentCreateOneWithoutSubTitleInput {
  create?: ContentCreateWithoutSubTitleInput ;
  connect?: ContentWhereUniqueInput ;
}

export interface ContentCreateOneWithoutTextInput {
  create?: ContentCreateWithoutTextInput ;
  connect?: ContentWhereUniqueInput ;
}

export interface ContentCreateOneWithoutTitleInput {
  create?: ContentCreateWithoutTitleInput ;
  connect?: ContentWhereUniqueInput ;
}

export interface ContentCreateWithoutCompanyInput {
  id?: string ;
  slug: string;
  image?: ImageCreateOneWithoutContentInput ;
  title?: TranslatedStringCreateOneWithoutContentTitleInput ;
  subTitle?: TranslatedStringCreateOneWithoutContentSubTitleInput ;
  text?: TranslatedStringCreateOneWithoutContentTextInput ;
  segments?: UserSegmentCreateManyWithoutContentsInput ;
  showFrom?: any ;
  showUntil?: any ;
  status?: CONTENT_STATUS ;
  deleted?: boolean ;
  type?: ContentCreatetypeInput ;
}

export interface ContentCreateWithoutImageInput {
  id?: string ;
  slug: string;
  company?: CompanyCreateOneWithoutContentInput ;
  title?: TranslatedStringCreateOneWithoutContentTitleInput ;
  subTitle?: TranslatedStringCreateOneWithoutContentSubTitleInput ;
  text?: TranslatedStringCreateOneWithoutContentTextInput ;
  segments?: UserSegmentCreateManyWithoutContentsInput ;
  showFrom?: any ;
  showUntil?: any ;
  status?: CONTENT_STATUS ;
  deleted?: boolean ;
  type?: ContentCreatetypeInput ;
}

export interface ContentCreateWithoutSegmentsInput {
  id?: string ;
  slug: string;
  company?: CompanyCreateOneWithoutContentInput ;
  image?: ImageCreateOneWithoutContentInput ;
  title?: TranslatedStringCreateOneWithoutContentTitleInput ;
  subTitle?: TranslatedStringCreateOneWithoutContentSubTitleInput ;
  text?: TranslatedStringCreateOneWithoutContentTextInput ;
  showFrom?: any ;
  showUntil?: any ;
  status?: CONTENT_STATUS ;
  deleted?: boolean ;
  type?: ContentCreatetypeInput ;
}

export interface ContentCreateWithoutSubTitleInput {
  id?: string ;
  slug: string;
  company?: CompanyCreateOneWithoutContentInput ;
  image?: ImageCreateOneWithoutContentInput ;
  title?: TranslatedStringCreateOneWithoutContentTitleInput ;
  text?: TranslatedStringCreateOneWithoutContentTextInput ;
  segments?: UserSegmentCreateManyWithoutContentsInput ;
  showFrom?: any ;
  showUntil?: any ;
  status?: CONTENT_STATUS ;
  deleted?: boolean ;
  type?: ContentCreatetypeInput ;
}

export interface ContentCreateWithoutTextInput {
  id?: string ;
  slug: string;
  company?: CompanyCreateOneWithoutContentInput ;
  image?: ImageCreateOneWithoutContentInput ;
  title?: TranslatedStringCreateOneWithoutContentTitleInput ;
  subTitle?: TranslatedStringCreateOneWithoutContentSubTitleInput ;
  segments?: UserSegmentCreateManyWithoutContentsInput ;
  showFrom?: any ;
  showUntil?: any ;
  status?: CONTENT_STATUS ;
  deleted?: boolean ;
  type?: ContentCreatetypeInput ;
}

export interface ContentCreateWithoutTitleInput {
  id?: string ;
  slug: string;
  company?: CompanyCreateOneWithoutContentInput ;
  image?: ImageCreateOneWithoutContentInput ;
  subTitle?: TranslatedStringCreateOneWithoutContentSubTitleInput ;
  text?: TranslatedStringCreateOneWithoutContentTextInput ;
  segments?: UserSegmentCreateManyWithoutContentsInput ;
  showFrom?: any ;
  showUntil?: any ;
  status?: CONTENT_STATUS ;
  deleted?: boolean ;
  type?: ContentCreatetypeInput ;
}

export interface ContentCreatetypeInput {
  set?: CONTENT_TYPE[] ;
}

export interface ContentScalarWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  slug?: string ;
  slug_not?: string ;
  slug_in?: string[] ;
  slug_not_in?: string[] ;
  slug_lt?: string ;
  slug_lte?: string ;
  slug_gt?: string ;
  slug_gte?: string ;
  slug_contains?: string ;
  slug_not_contains?: string ;
  slug_starts_with?: string ;
  slug_not_starts_with?: string ;
  slug_ends_with?: string ;
  slug_not_ends_with?: string ;
  showFrom?: any ;
  showFrom_not?: any ;
  showFrom_in?: any[] ;
  showFrom_not_in?: any[] ;
  showFrom_lt?: any ;
  showFrom_lte?: any ;
  showFrom_gt?: any ;
  showFrom_gte?: any ;
  showUntil?: any ;
  showUntil_not?: any ;
  showUntil_in?: any[] ;
  showUntil_not_in?: any[] ;
  showUntil_lt?: any ;
  showUntil_lte?: any ;
  showUntil_gt?: any ;
  showUntil_gte?: any ;
  status?: CONTENT_STATUS ;
  status_not?: CONTENT_STATUS ;
  status_in?: CONTENT_STATUS[] ;
  status_not_in?: CONTENT_STATUS[] ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  AND?: ContentScalarWhereInput[] ;
  OR?: ContentScalarWhereInput[] ;
  NOT?: ContentScalarWhereInput[] ;
}

export interface ContentUpdateManyDataInput {
  slug?: string ;
  showFrom?: any ;
  showUntil?: any ;
  status?: CONTENT_STATUS ;
  deleted?: boolean ;
  type?: ContentUpdatetypeInput ;
}

export interface ContentUpdateManyWithWhereNestedInput {
  where: ContentScalarWhereInput;
  data: ContentUpdateManyDataInput;
}

export interface ContentUpdateManyWithoutCompanyInput {
  create?: ContentCreateWithoutCompanyInput[] ;
  connect?: ContentWhereUniqueInput[] ;
  set?: ContentWhereUniqueInput[] ;
  disconnect?: ContentWhereUniqueInput[] ;
  update?: ContentUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: ContentUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: ContentScalarWhereInput[] ;
  updateMany?: ContentUpdateManyWithWhereNestedInput[] ;
}

export interface ContentUpdateManyWithoutImageInput {
  create?: ContentCreateWithoutImageInput[] ;
  connect?: ContentWhereUniqueInput[] ;
  set?: ContentWhereUniqueInput[] ;
  disconnect?: ContentWhereUniqueInput[] ;
  update?: ContentUpdateWithWhereUniqueWithoutImageInput[] ;
  upsert?: ContentUpsertWithWhereUniqueWithoutImageInput[] ;
  deleteMany?: ContentScalarWhereInput[] ;
  updateMany?: ContentUpdateManyWithWhereNestedInput[] ;
}

export interface ContentUpdateManyWithoutSegmentsInput {
  create?: ContentCreateWithoutSegmentsInput[] ;
  connect?: ContentWhereUniqueInput[] ;
  set?: ContentWhereUniqueInput[] ;
  disconnect?: ContentWhereUniqueInput[] ;
  update?: ContentUpdateWithWhereUniqueWithoutSegmentsInput[] ;
  upsert?: ContentUpsertWithWhereUniqueWithoutSegmentsInput[] ;
  deleteMany?: ContentScalarWhereInput[] ;
  updateMany?: ContentUpdateManyWithWhereNestedInput[] ;
}

export interface ContentUpdateOneWithoutSubTitleInput {
  create?: ContentCreateWithoutSubTitleInput ;
  update?: ContentUpdateWithoutSubTitleDataInput ;
  upsert?: ContentUpsertWithoutSubTitleInput ;
  disconnect?: boolean ;
  connect?: ContentWhereUniqueInput ;
}

export interface ContentUpdateOneWithoutTextInput {
  create?: ContentCreateWithoutTextInput ;
  update?: ContentUpdateWithoutTextDataInput ;
  upsert?: ContentUpsertWithoutTextInput ;
  disconnect?: boolean ;
  connect?: ContentWhereUniqueInput ;
}

export interface ContentUpdateOneWithoutTitleInput {
  create?: ContentCreateWithoutTitleInput ;
  update?: ContentUpdateWithoutTitleDataInput ;
  upsert?: ContentUpsertWithoutTitleInput ;
  disconnect?: boolean ;
  connect?: ContentWhereUniqueInput ;
}

export interface ContentUpdateWithWhereUniqueWithoutCompanyInput {
  where: ContentWhereUniqueInput;
  data: ContentUpdateWithoutCompanyDataInput;
}

export interface ContentUpdateWithWhereUniqueWithoutImageInput {
  where: ContentWhereUniqueInput;
  data: ContentUpdateWithoutImageDataInput;
}

export interface ContentUpdateWithWhereUniqueWithoutSegmentsInput {
  where: ContentWhereUniqueInput;
  data: ContentUpdateWithoutSegmentsDataInput;
}

export interface ContentUpdateWithoutCompanyDataInput {
  slug?: string ;
  image?: ImageUpdateOneWithoutContentInput ;
  title?: TranslatedStringUpdateOneWithoutContentTitleInput ;
  subTitle?: TranslatedStringUpdateOneWithoutContentSubTitleInput ;
  text?: TranslatedStringUpdateOneWithoutContentTextInput ;
  segments?: UserSegmentUpdateManyWithoutContentsInput ;
  showFrom?: any ;
  showUntil?: any ;
  status?: CONTENT_STATUS ;
  deleted?: boolean ;
  type?: ContentUpdatetypeInput ;
}

export interface ContentUpdateWithoutImageDataInput {
  slug?: string ;
  company?: CompanyUpdateOneWithoutContentInput ;
  title?: TranslatedStringUpdateOneWithoutContentTitleInput ;
  subTitle?: TranslatedStringUpdateOneWithoutContentSubTitleInput ;
  text?: TranslatedStringUpdateOneWithoutContentTextInput ;
  segments?: UserSegmentUpdateManyWithoutContentsInput ;
  showFrom?: any ;
  showUntil?: any ;
  status?: CONTENT_STATUS ;
  deleted?: boolean ;
  type?: ContentUpdatetypeInput ;
}

export interface ContentUpdateWithoutSegmentsDataInput {
  slug?: string ;
  company?: CompanyUpdateOneWithoutContentInput ;
  image?: ImageUpdateOneWithoutContentInput ;
  title?: TranslatedStringUpdateOneWithoutContentTitleInput ;
  subTitle?: TranslatedStringUpdateOneWithoutContentSubTitleInput ;
  text?: TranslatedStringUpdateOneWithoutContentTextInput ;
  showFrom?: any ;
  showUntil?: any ;
  status?: CONTENT_STATUS ;
  deleted?: boolean ;
  type?: ContentUpdatetypeInput ;
}

export interface ContentUpdateWithoutSubTitleDataInput {
  slug?: string ;
  company?: CompanyUpdateOneWithoutContentInput ;
  image?: ImageUpdateOneWithoutContentInput ;
  title?: TranslatedStringUpdateOneWithoutContentTitleInput ;
  text?: TranslatedStringUpdateOneWithoutContentTextInput ;
  segments?: UserSegmentUpdateManyWithoutContentsInput ;
  showFrom?: any ;
  showUntil?: any ;
  status?: CONTENT_STATUS ;
  deleted?: boolean ;
  type?: ContentUpdatetypeInput ;
}

export interface ContentUpdateWithoutTextDataInput {
  slug?: string ;
  company?: CompanyUpdateOneWithoutContentInput ;
  image?: ImageUpdateOneWithoutContentInput ;
  title?: TranslatedStringUpdateOneWithoutContentTitleInput ;
  subTitle?: TranslatedStringUpdateOneWithoutContentSubTitleInput ;
  segments?: UserSegmentUpdateManyWithoutContentsInput ;
  showFrom?: any ;
  showUntil?: any ;
  status?: CONTENT_STATUS ;
  deleted?: boolean ;
  type?: ContentUpdatetypeInput ;
}

export interface ContentUpdateWithoutTitleDataInput {
  slug?: string ;
  company?: CompanyUpdateOneWithoutContentInput ;
  image?: ImageUpdateOneWithoutContentInput ;
  subTitle?: TranslatedStringUpdateOneWithoutContentSubTitleInput ;
  text?: TranslatedStringUpdateOneWithoutContentTextInput ;
  segments?: UserSegmentUpdateManyWithoutContentsInput ;
  showFrom?: any ;
  showUntil?: any ;
  status?: CONTENT_STATUS ;
  deleted?: boolean ;
  type?: ContentUpdatetypeInput ;
}

export interface ContentUpdatetypeInput {
  set?: CONTENT_TYPE[] ;
}

export interface ContentUpsertWithWhereUniqueWithoutCompanyInput {
  where: ContentWhereUniqueInput;
  update: ContentUpdateWithoutCompanyDataInput;
  create: ContentCreateWithoutCompanyInput;
}

export interface ContentUpsertWithWhereUniqueWithoutImageInput {
  where: ContentWhereUniqueInput;
  update: ContentUpdateWithoutImageDataInput;
  create: ContentCreateWithoutImageInput;
}

export interface ContentUpsertWithWhereUniqueWithoutSegmentsInput {
  where: ContentWhereUniqueInput;
  update: ContentUpdateWithoutSegmentsDataInput;
  create: ContentCreateWithoutSegmentsInput;
}

export interface ContentUpsertWithoutSubTitleInput {
  update: ContentUpdateWithoutSubTitleDataInput;
  create: ContentCreateWithoutSubTitleInput;
}

export interface ContentUpsertWithoutTextInput {
  update: ContentUpdateWithoutTextDataInput;
  create: ContentCreateWithoutTextInput;
}

export interface ContentUpsertWithoutTitleInput {
  update: ContentUpdateWithoutTitleDataInput;
  create: ContentCreateWithoutTitleInput;
}

export interface ContentWhereInput {
  types?: string[] ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  slug?: string ;
  slug_not?: string ;
  slug_in?: string[] ;
  slug_not_in?: string[] ;
  slug_lt?: string ;
  slug_lte?: string ;
  slug_gt?: string ;
  slug_gte?: string ;
  slug_contains?: string ;
  slug_not_contains?: string ;
  slug_starts_with?: string ;
  slug_not_starts_with?: string ;
  slug_ends_with?: string ;
  slug_not_ends_with?: string ;
  company?: CompanyWhereInput ;
  image?: ImageWhereInput ;
  title?: TranslatedStringWhereInput ;
  subTitle?: TranslatedStringWhereInput ;
  text?: TranslatedStringWhereInput ;
  segments_every?: UserSegmentWhereInput ;
  segments_some?: UserSegmentWhereInput ;
  segments_none?: UserSegmentWhereInput ;
  showFrom?: any ;
  showFrom_not?: any ;
  showFrom_in?: any[] ;
  showFrom_not_in?: any[] ;
  showFrom_lt?: any ;
  showFrom_lte?: any ;
  showFrom_gt?: any ;
  showFrom_gte?: any ;
  showUntil?: any ;
  showUntil_not?: any ;
  showUntil_in?: any[] ;
  showUntil_not_in?: any[] ;
  showUntil_lt?: any ;
  showUntil_lte?: any ;
  showUntil_gt?: any ;
  showUntil_gte?: any ;
  status?: CONTENT_STATUS ;
  status_not?: CONTENT_STATUS ;
  status_in?: CONTENT_STATUS[] ;
  status_not_in?: CONTENT_STATUS[] ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  AND?: ContentWhereInput[] ;
  OR?: ContentWhereInput[] ;
  NOT?: ContentWhereInput[] ;
}

export interface ContentWhereUniqueInput {
  id?: string ;
}

export interface CourseTypeCreateInput {
  id?: string ;
  company: CompanyCreateOneWithoutCourseTypesInput;
  items?: ItemCreateManyWithoutCourseTypeInput ;
  categories?: CategoryCreateManyWithoutCourseTypeInput ;
  deleted?: boolean ;
  name?: string ;
  color: string;
  label: string;
  order?: number ;
}

export interface CourseTypeCreateManyWithoutCompanyInput {
  create?: CourseTypeCreateWithoutCompanyInput[] ;
  connect?: CourseTypeWhereUniqueInput[] ;
}

export interface CourseTypeCreateOneWithoutCategoriesInput {
  create?: CourseTypeCreateWithoutCategoriesInput ;
  connect?: CourseTypeWhereUniqueInput ;
}

export interface CourseTypeCreateOneWithoutItemsInput {
  create?: CourseTypeCreateWithoutItemsInput ;
  connect?: CourseTypeWhereUniqueInput ;
}

export interface CourseTypeCreateWithoutCategoriesInput {
  id?: string ;
  company: CompanyCreateOneWithoutCourseTypesInput;
  items?: ItemCreateManyWithoutCourseTypeInput ;
  deleted?: boolean ;
  name?: string ;
  color: string;
  label: string;
  order?: number ;
}

export interface CourseTypeCreateWithoutCompanyInput {
  id?: string ;
  items?: ItemCreateManyWithoutCourseTypeInput ;
  categories?: CategoryCreateManyWithoutCourseTypeInput ;
  deleted?: boolean ;
  name?: string ;
  color: string;
  label: string;
  order?: number ;
}

export interface CourseTypeCreateWithoutItemsInput {
  id?: string ;
  company: CompanyCreateOneWithoutCourseTypesInput;
  categories?: CategoryCreateManyWithoutCourseTypeInput ;
  deleted?: boolean ;
  name?: string ;
  color: string;
  label: string;
  order?: number ;
}

export interface CourseTypeScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  color?: string ;
  color_not?: string ;
  color_in?: string[] ;
  color_not_in?: string[] ;
  color_lt?: string ;
  color_lte?: string ;
  color_gt?: string ;
  color_gte?: string ;
  color_contains?: string ;
  color_not_contains?: string ;
  color_starts_with?: string ;
  color_not_starts_with?: string ;
  color_ends_with?: string ;
  color_not_ends_with?: string ;
  label?: string ;
  label_not?: string ;
  label_in?: string[] ;
  label_not_in?: string[] ;
  label_lt?: string ;
  label_lte?: string ;
  label_gt?: string ;
  label_gte?: string ;
  label_contains?: string ;
  label_not_contains?: string ;
  label_starts_with?: string ;
  label_not_starts_with?: string ;
  label_ends_with?: string ;
  label_not_ends_with?: string ;
  order?: number ;
  order_not?: number ;
  order_in?: number[] ;
  order_not_in?: number[] ;
  order_lt?: number ;
  order_lte?: number ;
  order_gt?: number ;
  order_gte?: number ;
  AND?: CourseTypeScalarWhereInput[] ;
  OR?: CourseTypeScalarWhereInput[] ;
  NOT?: CourseTypeScalarWhereInput[] ;
}

export interface CourseTypeUpdateInput {
  company?: CompanyUpdateOneRequiredWithoutCourseTypesInput ;
  items?: ItemUpdateManyWithoutCourseTypeInput ;
  categories?: CategoryUpdateManyWithoutCourseTypeInput ;
  deleted?: boolean ;
  name?: string ;
  color?: string ;
  label?: string ;
  order?: number ;
}

export interface CourseTypeUpdateManyDataInput {
  deleted?: boolean ;
  name?: string ;
  color?: string ;
  label?: string ;
  order?: number ;
}

export interface CourseTypeUpdateManyWithWhereNestedInput {
  where: CourseTypeScalarWhereInput;
  data: CourseTypeUpdateManyDataInput;
}

export interface CourseTypeUpdateManyWithoutCompanyInput {
  create?: CourseTypeCreateWithoutCompanyInput[] ;
  connect?: CourseTypeWhereUniqueInput[] ;
  set?: CourseTypeWhereUniqueInput[] ;
  disconnect?: CourseTypeWhereUniqueInput[] ;
  update?: CourseTypeUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: CourseTypeUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: CourseTypeScalarWhereInput[] ;
  updateMany?: CourseTypeUpdateManyWithWhereNestedInput[] ;
}

export interface CourseTypeUpdateOneWithoutCategoriesInput {
  create?: CourseTypeCreateWithoutCategoriesInput ;
  update?: CourseTypeUpdateWithoutCategoriesDataInput ;
  upsert?: CourseTypeUpsertWithoutCategoriesInput ;
  disconnect?: boolean ;
  connect?: CourseTypeWhereUniqueInput ;
}

export interface CourseTypeUpdateOneWithoutItemsInput {
  create?: CourseTypeCreateWithoutItemsInput ;
  update?: CourseTypeUpdateWithoutItemsDataInput ;
  upsert?: CourseTypeUpsertWithoutItemsInput ;
  disconnect?: boolean ;
  connect?: CourseTypeWhereUniqueInput ;
}

export interface CourseTypeUpdateWithWhereUniqueWithoutCompanyInput {
  where: CourseTypeWhereUniqueInput;
  data: CourseTypeUpdateWithoutCompanyDataInput;
}

export interface CourseTypeUpdateWithoutCategoriesDataInput {
  company?: CompanyUpdateOneRequiredWithoutCourseTypesInput ;
  items?: ItemUpdateManyWithoutCourseTypeInput ;
  deleted?: boolean ;
  name?: string ;
  color?: string ;
  label?: string ;
  order?: number ;
}

export interface CourseTypeUpdateWithoutCompanyDataInput {
  items?: ItemUpdateManyWithoutCourseTypeInput ;
  categories?: CategoryUpdateManyWithoutCourseTypeInput ;
  deleted?: boolean ;
  name?: string ;
  color?: string ;
  label?: string ;
  order?: number ;
}

export interface CourseTypeUpdateWithoutItemsDataInput {
  company?: CompanyUpdateOneRequiredWithoutCourseTypesInput ;
  categories?: CategoryUpdateManyWithoutCourseTypeInput ;
  deleted?: boolean ;
  name?: string ;
  color?: string ;
  label?: string ;
  order?: number ;
}

export interface CourseTypeUpsertWithWhereUniqueWithoutCompanyInput {
  where: CourseTypeWhereUniqueInput;
  update: CourseTypeUpdateWithoutCompanyDataInput;
  create: CourseTypeCreateWithoutCompanyInput;
}

export interface CourseTypeUpsertWithoutCategoriesInput {
  update: CourseTypeUpdateWithoutCategoriesDataInput;
  create: CourseTypeCreateWithoutCategoriesInput;
}

export interface CourseTypeUpsertWithoutItemsInput {
  update: CourseTypeUpdateWithoutItemsDataInput;
  create: CourseTypeCreateWithoutItemsInput;
}

export interface CourseTypeWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  company?: CompanyWhereInput ;
  items_every?: ItemWhereInput ;
  items_some?: ItemWhereInput ;
  items_none?: ItemWhereInput ;
  categories_every?: CategoryWhereInput ;
  categories_some?: CategoryWhereInput ;
  categories_none?: CategoryWhereInput ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  color?: string ;
  color_not?: string ;
  color_in?: string[] ;
  color_not_in?: string[] ;
  color_lt?: string ;
  color_lte?: string ;
  color_gt?: string ;
  color_gte?: string ;
  color_contains?: string ;
  color_not_contains?: string ;
  color_starts_with?: string ;
  color_not_starts_with?: string ;
  color_ends_with?: string ;
  color_not_ends_with?: string ;
  label?: string ;
  label_not?: string ;
  label_in?: string[] ;
  label_not_in?: string[] ;
  label_lt?: string ;
  label_lte?: string ;
  label_gt?: string ;
  label_gte?: string ;
  label_contains?: string ;
  label_not_contains?: string ;
  label_starts_with?: string ;
  label_not_starts_with?: string ;
  label_ends_with?: string ;
  label_not_ends_with?: string ;
  order?: number ;
  order_not?: number ;
  order_in?: number[] ;
  order_not_in?: number[] ;
  order_lt?: number ;
  order_lte?: number ;
  order_gt?: number ;
  order_gte?: number ;
  AND?: CourseTypeWhereInput[] ;
  OR?: CourseTypeWhereInput[] ;
  NOT?: CourseTypeWhereInput[] ;
}

export interface CourseTypeWhereUniqueInput {
  id?: string ;
}

export interface CreateActiveLicenseInput {
  deviceId?: string ;
  venueId: string;
  product: BAEMINGO_PRODUCT;
  price: number;
}

export interface CreateBillingAccountData {
  email: string;
  name: string;
  legalEntityId: string;
  description?: string ;
  street: string;
  city: string;
  region: string;
  postalCode: string;
  country: string;
}

export interface CreateCashSourceInput {
  venueId: string;
  name: string;
}

export interface CreateChoiceInviteCodesUserInput {
  userId: string;
  userName: string;
}

export interface CreateConfigInput {
  marketplaceId?: string ;
  userCompanyId: string;
  logoUrl?: string ;
  externalId?: string ;
  slug: string;
  name: string;
  theme?: any ;
  landingPageBackgroundUrl?: string ;
  landingPageDesktopBackgroundUrl?: string ;
  force3DSecure?: boolean ;
  sendSmsOnOrderUpdates?: boolean ;
}

export interface CreateDeviceInput {
  name: string;
  venueId: string;
  companyId?: string ;
}

export interface CreateGiftcardUniverseAccessInput {
  ownerId: string;
}

export interface CreateInvoiceAccountInput {
  companyId: string;
  legalEntityId?: string ;
  orgNumber: string;
  name: string;
  country: string;
  region: string;
  city: string;
  postalCode: string;
  street: string;
  email: string;
  additionalEmails?: string[] ;
}

export interface CreateNewAdyenCustomerInput {
  name: string;
  country: string;
  companyId?: string ;
  city?: string ;
  postalCode?: string ;
  street?: string ;
  streetNumber?: string ;
  stateOrProvince?: string ;
  vatNumber?: string ;
  organizationNumber?: string ;
  ownerDateOfBirth?: string ;
  ownerEmail?: string ;
  ownerFirstName?: string ;
  ownerLastName?: string ;
  ownerPhone?: string ;
  ownerPersonalNumber?: string ;
  ownerStreet?: string ;
  ownerStreetNumber?: string ;
  ownerPostalCode?: string ;
  ownerCity?: string ;
  ownerCountry?: string ;
}

export interface CreateOrganizationInput {
  name: string;
}

export interface CreatePromoCodeInput {
  venues: string[];
  code: string;
  active: boolean;
  discountType: DISCOUNT_TYPE;
  discountRate: number;
  title: PromoCodeTitleInput;
  useLimit?: number ;
  requiresUser: boolean;
  activatesAt?: string ;
  expiresAt?: string ;
  activeBetweenHours?: string[] ;
  categoryIds?: string[] ;
  serviceTypes?: string[] ;
}

export interface CreateReleaseInput {
  createdBy: string;
  type: RELEASE_TYPE;
  titleLang: any;
  bodyLang?: any ;
  imageUrls: (string )[];
  notes?: NoteInput[] ;
  productTags: PRODUCT_TAG[];
  repository?: string ;
  triggerModal?: boolean ;
}

export interface CreateSettingsBlueprintInput {
  name: string;
  storage: any;
  companyId?: string ;
  code?: string ;
}

export interface CreditBankCreateOneWithoutCreditsTransactionsInput {
  create?: CreditBankCreateWithoutCreditsTransactionsInput ;
  connect?: CreditBankWhereUniqueInput ;
}

export interface CreditBankCreateOneWithoutUserInput {
  create?: CreditBankCreateWithoutUserInput ;
  connect?: CreditBankWhereUniqueInput ;
}

export interface CreditBankCreateWithoutCreditsTransactionsInput {
  amount: number;
  balanceSnapshot?: number ;
  snapshotTime?: any ;
  history?: CreditBankCreatehistoryInput ;
  id?: string ;
  user: UserCreateOneWithoutCreditBankInput;
}

export interface CreditBankCreateWithoutUserInput {
  amount: number;
  balanceSnapshot?: number ;
  snapshotTime?: any ;
  history?: CreditBankCreatehistoryInput ;
  id?: string ;
  creditsTransactions?: CreditsTransactionCreateManyWithoutCreditBankInput ;
}

export interface CreditBankCreatehistoryInput {
  set?: any[] ;
}

export interface CreditBankUpdateOneRequiredWithoutUserInput {
  create?: CreditBankCreateWithoutUserInput ;
  update?: CreditBankUpdateWithoutUserDataInput ;
  upsert?: CreditBankUpsertWithoutUserInput ;
  connect?: CreditBankWhereUniqueInput ;
}

export interface CreditBankUpdateOneWithoutCreditsTransactionsInput {
  create?: CreditBankCreateWithoutCreditsTransactionsInput ;
  update?: CreditBankUpdateWithoutCreditsTransactionsDataInput ;
  upsert?: CreditBankUpsertWithoutCreditsTransactionsInput ;
  disconnect?: boolean ;
  connect?: CreditBankWhereUniqueInput ;
}

export interface CreditBankUpdateWithoutCreditsTransactionsDataInput {
  amount?: number ;
  balanceSnapshot?: number ;
  snapshotTime?: any ;
  history?: CreditBankUpdatehistoryInput ;
  user?: UserUpdateOneRequiredWithoutCreditBankInput ;
}

export interface CreditBankUpdateWithoutUserDataInput {
  amount?: number ;
  balanceSnapshot?: number ;
  snapshotTime?: any ;
  history?: CreditBankUpdatehistoryInput ;
  creditsTransactions?: CreditsTransactionUpdateManyWithoutCreditBankInput ;
}

export interface CreditBankUpdatehistoryInput {
  set?: any[] ;
}

export interface CreditBankUpsertWithoutCreditsTransactionsInput {
  update: CreditBankUpdateWithoutCreditsTransactionsDataInput;
  create: CreditBankCreateWithoutCreditsTransactionsInput;
}

export interface CreditBankUpsertWithoutUserInput {
  update: CreditBankUpdateWithoutUserDataInput;
  create: CreditBankCreateWithoutUserInput;
}

export interface CreditBankWhereInput {
  amount?: number ;
  amount_not?: number ;
  amount_in?: number[] ;
  amount_not_in?: number[] ;
  amount_lt?: number ;
  amount_lte?: number ;
  amount_gt?: number ;
  amount_gte?: number ;
  balanceSnapshot?: number ;
  balanceSnapshot_not?: number ;
  balanceSnapshot_in?: number[] ;
  balanceSnapshot_not_in?: number[] ;
  balanceSnapshot_lt?: number ;
  balanceSnapshot_lte?: number ;
  balanceSnapshot_gt?: number ;
  balanceSnapshot_gte?: number ;
  snapshotTime?: any ;
  snapshotTime_not?: any ;
  snapshotTime_in?: any[] ;
  snapshotTime_not_in?: any[] ;
  snapshotTime_lt?: any ;
  snapshotTime_lte?: any ;
  snapshotTime_gt?: any ;
  snapshotTime_gte?: any ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  user?: UserWhereInput ;
  creditsTransactions_every?: CreditsTransactionWhereInput ;
  creditsTransactions_some?: CreditsTransactionWhereInput ;
  creditsTransactions_none?: CreditsTransactionWhereInput ;
  AND?: CreditBankWhereInput[] ;
  OR?: CreditBankWhereInput[] ;
  NOT?: CreditBankWhereInput[] ;
}

export interface CreditBankWhereUniqueInput {
  id?: string ;
}

export interface CreditCardCreateManyWithoutUserInput {
  create?: CreditCardCreateWithoutUserInput[] ;
  connect?: CreditCardWhereUniqueInput[] ;
}

export interface CreditCardCreateWithoutUserInput {
  id?: string ;
  provider: string;
  digits: string;
  token: string;
  usesNewPaymentApi?: boolean ;
}

export interface CreditCardScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  provider?: string ;
  provider_not?: string ;
  provider_in?: string[] ;
  provider_not_in?: string[] ;
  provider_lt?: string ;
  provider_lte?: string ;
  provider_gt?: string ;
  provider_gte?: string ;
  provider_contains?: string ;
  provider_not_contains?: string ;
  provider_starts_with?: string ;
  provider_not_starts_with?: string ;
  provider_ends_with?: string ;
  provider_not_ends_with?: string ;
  digits?: string ;
  digits_not?: string ;
  digits_in?: string[] ;
  digits_not_in?: string[] ;
  digits_lt?: string ;
  digits_lte?: string ;
  digits_gt?: string ;
  digits_gte?: string ;
  digits_contains?: string ;
  digits_not_contains?: string ;
  digits_starts_with?: string ;
  digits_not_starts_with?: string ;
  digits_ends_with?: string ;
  digits_not_ends_with?: string ;
  token?: string ;
  token_not?: string ;
  token_in?: string[] ;
  token_not_in?: string[] ;
  token_lt?: string ;
  token_lte?: string ;
  token_gt?: string ;
  token_gte?: string ;
  token_contains?: string ;
  token_not_contains?: string ;
  token_starts_with?: string ;
  token_not_starts_with?: string ;
  token_ends_with?: string ;
  token_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  usesNewPaymentApi?: boolean ;
  usesNewPaymentApi_not?: boolean ;
  AND?: CreditCardScalarWhereInput[] ;
  OR?: CreditCardScalarWhereInput[] ;
  NOT?: CreditCardScalarWhereInput[] ;
}

export interface CreditCardUpdateManyDataInput {
  provider?: string ;
  digits?: string ;
  token?: string ;
  usesNewPaymentApi?: boolean ;
}

export interface CreditCardUpdateManyWithWhereNestedInput {
  where: CreditCardScalarWhereInput;
  data: CreditCardUpdateManyDataInput;
}

export interface CreditCardUpdateManyWithoutUserInput {
  create?: CreditCardCreateWithoutUserInput[] ;
  connect?: CreditCardWhereUniqueInput[] ;
  set?: CreditCardWhereUniqueInput[] ;
  disconnect?: CreditCardWhereUniqueInput[] ;
  update?: CreditCardUpdateWithWhereUniqueWithoutUserInput[] ;
  upsert?: CreditCardUpsertWithWhereUniqueWithoutUserInput[] ;
  deleteMany?: CreditCardScalarWhereInput[] ;
  updateMany?: CreditCardUpdateManyWithWhereNestedInput[] ;
}

export interface CreditCardUpdateWithWhereUniqueWithoutUserInput {
  where: CreditCardWhereUniqueInput;
  data: CreditCardUpdateWithoutUserDataInput;
}

export interface CreditCardUpdateWithoutUserDataInput {
  provider?: string ;
  digits?: string ;
  token?: string ;
  usesNewPaymentApi?: boolean ;
}

export interface CreditCardUpsertWithWhereUniqueWithoutUserInput {
  where: CreditCardWhereUniqueInput;
  update: CreditCardUpdateWithoutUserDataInput;
  create: CreditCardCreateWithoutUserInput;
}

export interface CreditCardWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  provider?: string ;
  provider_not?: string ;
  provider_in?: string[] ;
  provider_not_in?: string[] ;
  provider_lt?: string ;
  provider_lte?: string ;
  provider_gt?: string ;
  provider_gte?: string ;
  provider_contains?: string ;
  provider_not_contains?: string ;
  provider_starts_with?: string ;
  provider_not_starts_with?: string ;
  provider_ends_with?: string ;
  provider_not_ends_with?: string ;
  digits?: string ;
  digits_not?: string ;
  digits_in?: string[] ;
  digits_not_in?: string[] ;
  digits_lt?: string ;
  digits_lte?: string ;
  digits_gt?: string ;
  digits_gte?: string ;
  digits_contains?: string ;
  digits_not_contains?: string ;
  digits_starts_with?: string ;
  digits_not_starts_with?: string ;
  digits_ends_with?: string ;
  digits_not_ends_with?: string ;
  token?: string ;
  token_not?: string ;
  token_in?: string[] ;
  token_not_in?: string[] ;
  token_lt?: string ;
  token_lte?: string ;
  token_gt?: string ;
  token_gte?: string ;
  token_contains?: string ;
  token_not_contains?: string ;
  token_starts_with?: string ;
  token_not_starts_with?: string ;
  token_ends_with?: string ;
  token_not_ends_with?: string ;
  user?: UserWhereInput ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  usesNewPaymentApi?: boolean ;
  usesNewPaymentApi_not?: boolean ;
  AND?: CreditCardWhereInput[] ;
  OR?: CreditCardWhereInput[] ;
  NOT?: CreditCardWhereInput[] ;
}

export interface CreditCardWhereUniqueInput {
  id?: string ;
}

export interface CreditsTransactionCreateManyWithoutCreditBankInput {
  create?: CreditsTransactionCreateWithoutCreditBankInput[] ;
  connect?: CreditsTransactionWhereUniqueInput[] ;
}

export interface CreditsTransactionCreateManyWithoutPaymentInput {
  create?: CreditsTransactionCreateWithoutPaymentInput[] ;
  connect?: CreditsTransactionWhereUniqueInput[] ;
}

export interface CreditsTransactionCreateWithoutCreditBankInput {
  id?: string ;
  amount: number;
  payment?: PaymentCreateOneWithoutCreditsTransactionsInput ;
  source: SOURCE_TYPE;
}

export interface CreditsTransactionCreateWithoutPaymentInput {
  id?: string ;
  amount: number;
  creditBank?: CreditBankCreateOneWithoutCreditsTransactionsInput ;
  source: SOURCE_TYPE;
}

export interface CreditsTransactionScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  amount?: number ;
  amount_not?: number ;
  amount_in?: number[] ;
  amount_not_in?: number[] ;
  amount_lt?: number ;
  amount_lte?: number ;
  amount_gt?: number ;
  amount_gte?: number ;
  source?: SOURCE_TYPE ;
  source_not?: SOURCE_TYPE ;
  source_in?: SOURCE_TYPE[] ;
  source_not_in?: SOURCE_TYPE[] ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  AND?: CreditsTransactionScalarWhereInput[] ;
  OR?: CreditsTransactionScalarWhereInput[] ;
  NOT?: CreditsTransactionScalarWhereInput[] ;
}

export interface CreditsTransactionUpdateManyDataInput {
  amount?: number ;
  source?: SOURCE_TYPE ;
}

export interface CreditsTransactionUpdateManyWithWhereNestedInput {
  where: CreditsTransactionScalarWhereInput;
  data: CreditsTransactionUpdateManyDataInput;
}

export interface CreditsTransactionUpdateManyWithoutCreditBankInput {
  create?: CreditsTransactionCreateWithoutCreditBankInput[] ;
  connect?: CreditsTransactionWhereUniqueInput[] ;
  set?: CreditsTransactionWhereUniqueInput[] ;
  disconnect?: CreditsTransactionWhereUniqueInput[] ;
  update?: CreditsTransactionUpdateWithWhereUniqueWithoutCreditBankInput[] ;
  upsert?: CreditsTransactionUpsertWithWhereUniqueWithoutCreditBankInput[] ;
  deleteMany?: CreditsTransactionScalarWhereInput[] ;
  updateMany?: CreditsTransactionUpdateManyWithWhereNestedInput[] ;
}

export interface CreditsTransactionUpdateManyWithoutPaymentInput {
  create?: CreditsTransactionCreateWithoutPaymentInput[] ;
  connect?: CreditsTransactionWhereUniqueInput[] ;
  set?: CreditsTransactionWhereUniqueInput[] ;
  disconnect?: CreditsTransactionWhereUniqueInput[] ;
  update?: CreditsTransactionUpdateWithWhereUniqueWithoutPaymentInput[] ;
  upsert?: CreditsTransactionUpsertWithWhereUniqueWithoutPaymentInput[] ;
  deleteMany?: CreditsTransactionScalarWhereInput[] ;
  updateMany?: CreditsTransactionUpdateManyWithWhereNestedInput[] ;
}

export interface CreditsTransactionUpdateWithWhereUniqueWithoutCreditBankInput {
  where: CreditsTransactionWhereUniqueInput;
  data: CreditsTransactionUpdateWithoutCreditBankDataInput;
}

export interface CreditsTransactionUpdateWithWhereUniqueWithoutPaymentInput {
  where: CreditsTransactionWhereUniqueInput;
  data: CreditsTransactionUpdateWithoutPaymentDataInput;
}

export interface CreditsTransactionUpdateWithoutCreditBankDataInput {
  amount?: number ;
  payment?: PaymentUpdateOneWithoutCreditsTransactionsInput ;
  source?: SOURCE_TYPE ;
}

export interface CreditsTransactionUpdateWithoutPaymentDataInput {
  amount?: number ;
  creditBank?: CreditBankUpdateOneWithoutCreditsTransactionsInput ;
  source?: SOURCE_TYPE ;
}

export interface CreditsTransactionUpsertWithWhereUniqueWithoutCreditBankInput {
  where: CreditsTransactionWhereUniqueInput;
  update: CreditsTransactionUpdateWithoutCreditBankDataInput;
  create: CreditsTransactionCreateWithoutCreditBankInput;
}

export interface CreditsTransactionUpsertWithWhereUniqueWithoutPaymentInput {
  where: CreditsTransactionWhereUniqueInput;
  update: CreditsTransactionUpdateWithoutPaymentDataInput;
  create: CreditsTransactionCreateWithoutPaymentInput;
}

export interface CreditsTransactionWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  amount?: number ;
  amount_not?: number ;
  amount_in?: number[] ;
  amount_not_in?: number[] ;
  amount_lt?: number ;
  amount_lte?: number ;
  amount_gt?: number ;
  amount_gte?: number ;
  creditBank?: CreditBankWhereInput ;
  payment?: PaymentWhereInput ;
  source?: SOURCE_TYPE ;
  source_not?: SOURCE_TYPE ;
  source_in?: SOURCE_TYPE[] ;
  source_not_in?: SOURCE_TYPE[] ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  AND?: CreditsTransactionWhereInput[] ;
  OR?: CreditsTransactionWhereInput[] ;
  NOT?: CreditsTransactionWhereInput[] ;
}

export interface CreditsTransactionWhereUniqueInput {
  id?: string ;
}

export interface DeleteModificationGroupInput {
  id: string;
}

export interface DeliveryRateCreateInput {
  id?: string ;
  name?: TranslatedStringCreateOneWithoutDeliveryRateNameInput ;
  message?: TranslatedStringCreateOneWithoutDeliveryRateMessageInput ;
  zip?: number ;
  polygon?: any ;
  fee: FeeCreateOneWithoutDeliveryRatesInput;
  venues?: VenueCreateManyWithoutDeliveryRatesInput ;
  company?: CompanyCreateOneWithoutDeliveryRatesInput ;
  menu?: MenuCreateOneWithoutDeliveryRateInput ;
}

export interface DeliveryRateCreateManyWithoutCompanyInput {
  create?: DeliveryRateCreateWithoutCompanyInput[] ;
  connect?: DeliveryRateWhereUniqueInput[] ;
}

export interface DeliveryRateCreateManyWithoutFeeInput {
  create?: DeliveryRateCreateWithoutFeeInput[] ;
  connect?: DeliveryRateWhereUniqueInput[] ;
}

export interface DeliveryRateCreateManyWithoutMenuInput {
  create?: DeliveryRateCreateWithoutMenuInput[] ;
  connect?: DeliveryRateWhereUniqueInput[] ;
}

export interface DeliveryRateCreateManyWithoutVenuesInput {
  create?: DeliveryRateCreateWithoutVenuesInput[] ;
  connect?: DeliveryRateWhereUniqueInput[] ;
}

export interface DeliveryRateCreateOneWithoutMessageInput {
  create?: DeliveryRateCreateWithoutMessageInput ;
  connect?: DeliveryRateWhereUniqueInput ;
}

export interface DeliveryRateCreateOneWithoutNameInput {
  create?: DeliveryRateCreateWithoutNameInput ;
  connect?: DeliveryRateWhereUniqueInput ;
}

export interface DeliveryRateCreateWithoutCompanyInput {
  id?: string ;
  name?: TranslatedStringCreateOneWithoutDeliveryRateNameInput ;
  message?: TranslatedStringCreateOneWithoutDeliveryRateMessageInput ;
  zip?: number ;
  polygon?: any ;
  fee: FeeCreateOneWithoutDeliveryRatesInput;
  venues?: VenueCreateManyWithoutDeliveryRatesInput ;
  menu?: MenuCreateOneWithoutDeliveryRateInput ;
}

export interface DeliveryRateCreateWithoutFeeInput {
  id?: string ;
  name?: TranslatedStringCreateOneWithoutDeliveryRateNameInput ;
  message?: TranslatedStringCreateOneWithoutDeliveryRateMessageInput ;
  zip?: number ;
  polygon?: any ;
  venues?: VenueCreateManyWithoutDeliveryRatesInput ;
  company?: CompanyCreateOneWithoutDeliveryRatesInput ;
  menu?: MenuCreateOneWithoutDeliveryRateInput ;
}

export interface DeliveryRateCreateWithoutMenuInput {
  id?: string ;
  name?: TranslatedStringCreateOneWithoutDeliveryRateNameInput ;
  message?: TranslatedStringCreateOneWithoutDeliveryRateMessageInput ;
  zip?: number ;
  polygon?: any ;
  fee: FeeCreateOneWithoutDeliveryRatesInput;
  venues?: VenueCreateManyWithoutDeliveryRatesInput ;
  company?: CompanyCreateOneWithoutDeliveryRatesInput ;
}

export interface DeliveryRateCreateWithoutMessageInput {
  id?: string ;
  name?: TranslatedStringCreateOneWithoutDeliveryRateNameInput ;
  zip?: number ;
  polygon?: any ;
  fee: FeeCreateOneWithoutDeliveryRatesInput;
  venues?: VenueCreateManyWithoutDeliveryRatesInput ;
  company?: CompanyCreateOneWithoutDeliveryRatesInput ;
  menu?: MenuCreateOneWithoutDeliveryRateInput ;
}

export interface DeliveryRateCreateWithoutNameInput {
  id?: string ;
  message?: TranslatedStringCreateOneWithoutDeliveryRateMessageInput ;
  zip?: number ;
  polygon?: any ;
  fee: FeeCreateOneWithoutDeliveryRatesInput;
  venues?: VenueCreateManyWithoutDeliveryRatesInput ;
  company?: CompanyCreateOneWithoutDeliveryRatesInput ;
  menu?: MenuCreateOneWithoutDeliveryRateInput ;
}

export interface DeliveryRateCreateWithoutVenuesInput {
  id?: string ;
  name?: TranslatedStringCreateOneWithoutDeliveryRateNameInput ;
  message?: TranslatedStringCreateOneWithoutDeliveryRateMessageInput ;
  zip?: number ;
  polygon?: any ;
  fee: FeeCreateOneWithoutDeliveryRatesInput;
  company?: CompanyCreateOneWithoutDeliveryRatesInput ;
  menu?: MenuCreateOneWithoutDeliveryRateInput ;
}

export interface DeliveryRateScalarWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  zip?: number ;
  zip_not?: number ;
  zip_in?: number[] ;
  zip_not_in?: number[] ;
  zip_lt?: number ;
  zip_lte?: number ;
  zip_gt?: number ;
  zip_gte?: number ;
  AND?: DeliveryRateScalarWhereInput[] ;
  OR?: DeliveryRateScalarWhereInput[] ;
  NOT?: DeliveryRateScalarWhereInput[] ;
}

export interface DeliveryRateUpdateInput {
  name?: TranslatedStringUpdateOneWithoutDeliveryRateNameInput ;
  message?: TranslatedStringUpdateOneWithoutDeliveryRateMessageInput ;
  zip?: number ;
  polygon?: any ;
  fee?: FeeUpdateOneRequiredWithoutDeliveryRatesInput ;
  venues?: VenueUpdateManyWithoutDeliveryRatesInput ;
  company?: CompanyUpdateOneWithoutDeliveryRatesInput ;
  menu?: MenuUpdateOneWithoutDeliveryRateInput ;
}

export interface DeliveryRateUpdateManyDataInput {
  zip?: number ;
  polygon?: any ;
}

export interface DeliveryRateUpdateManyWithWhereNestedInput {
  where: DeliveryRateScalarWhereInput;
  data: DeliveryRateUpdateManyDataInput;
}

export interface DeliveryRateUpdateManyWithoutCompanyInput {
  create?: DeliveryRateCreateWithoutCompanyInput[] ;
  connect?: DeliveryRateWhereUniqueInput[] ;
  set?: DeliveryRateWhereUniqueInput[] ;
  disconnect?: DeliveryRateWhereUniqueInput[] ;
  update?: DeliveryRateUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: DeliveryRateUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: DeliveryRateScalarWhereInput[] ;
  updateMany?: DeliveryRateUpdateManyWithWhereNestedInput[] ;
}

export interface DeliveryRateUpdateManyWithoutFeeInput {
  create?: DeliveryRateCreateWithoutFeeInput[] ;
  connect?: DeliveryRateWhereUniqueInput[] ;
  set?: DeliveryRateWhereUniqueInput[] ;
  disconnect?: DeliveryRateWhereUniqueInput[] ;
  update?: DeliveryRateUpdateWithWhereUniqueWithoutFeeInput[] ;
  upsert?: DeliveryRateUpsertWithWhereUniqueWithoutFeeInput[] ;
  deleteMany?: DeliveryRateScalarWhereInput[] ;
  updateMany?: DeliveryRateUpdateManyWithWhereNestedInput[] ;
}

export interface DeliveryRateUpdateManyWithoutMenuInput {
  create?: DeliveryRateCreateWithoutMenuInput[] ;
  connect?: DeliveryRateWhereUniqueInput[] ;
  set?: DeliveryRateWhereUniqueInput[] ;
  disconnect?: DeliveryRateWhereUniqueInput[] ;
  update?: DeliveryRateUpdateWithWhereUniqueWithoutMenuInput[] ;
  upsert?: DeliveryRateUpsertWithWhereUniqueWithoutMenuInput[] ;
  deleteMany?: DeliveryRateScalarWhereInput[] ;
  updateMany?: DeliveryRateUpdateManyWithWhereNestedInput[] ;
}

export interface DeliveryRateUpdateManyWithoutVenuesInput {
  create?: DeliveryRateCreateWithoutVenuesInput[] ;
  connect?: DeliveryRateWhereUniqueInput[] ;
  set?: DeliveryRateWhereUniqueInput[] ;
  disconnect?: DeliveryRateWhereUniqueInput[] ;
  update?: DeliveryRateUpdateWithWhereUniqueWithoutVenuesInput[] ;
  upsert?: DeliveryRateUpsertWithWhereUniqueWithoutVenuesInput[] ;
  deleteMany?: DeliveryRateScalarWhereInput[] ;
  updateMany?: DeliveryRateUpdateManyWithWhereNestedInput[] ;
}

export interface DeliveryRateUpdateOneWithoutMessageInput {
  create?: DeliveryRateCreateWithoutMessageInput ;
  update?: DeliveryRateUpdateWithoutMessageDataInput ;
  upsert?: DeliveryRateUpsertWithoutMessageInput ;
  disconnect?: boolean ;
  connect?: DeliveryRateWhereUniqueInput ;
}

export interface DeliveryRateUpdateOneWithoutNameInput {
  create?: DeliveryRateCreateWithoutNameInput ;
  update?: DeliveryRateUpdateWithoutNameDataInput ;
  upsert?: DeliveryRateUpsertWithoutNameInput ;
  disconnect?: boolean ;
  connect?: DeliveryRateWhereUniqueInput ;
}

export interface DeliveryRateUpdateWithWhereUniqueWithoutCompanyInput {
  where: DeliveryRateWhereUniqueInput;
  data: DeliveryRateUpdateWithoutCompanyDataInput;
}

export interface DeliveryRateUpdateWithWhereUniqueWithoutFeeInput {
  where: DeliveryRateWhereUniqueInput;
  data: DeliveryRateUpdateWithoutFeeDataInput;
}

export interface DeliveryRateUpdateWithWhereUniqueWithoutMenuInput {
  where: DeliveryRateWhereUniqueInput;
  data: DeliveryRateUpdateWithoutMenuDataInput;
}

export interface DeliveryRateUpdateWithWhereUniqueWithoutVenuesInput {
  where: DeliveryRateWhereUniqueInput;
  data: DeliveryRateUpdateWithoutVenuesDataInput;
}

export interface DeliveryRateUpdateWithoutCompanyDataInput {
  name?: TranslatedStringUpdateOneWithoutDeliveryRateNameInput ;
  message?: TranslatedStringUpdateOneWithoutDeliveryRateMessageInput ;
  zip?: number ;
  polygon?: any ;
  fee?: FeeUpdateOneRequiredWithoutDeliveryRatesInput ;
  venues?: VenueUpdateManyWithoutDeliveryRatesInput ;
  menu?: MenuUpdateOneWithoutDeliveryRateInput ;
}

export interface DeliveryRateUpdateWithoutFeeDataInput {
  name?: TranslatedStringUpdateOneWithoutDeliveryRateNameInput ;
  message?: TranslatedStringUpdateOneWithoutDeliveryRateMessageInput ;
  zip?: number ;
  polygon?: any ;
  venues?: VenueUpdateManyWithoutDeliveryRatesInput ;
  company?: CompanyUpdateOneWithoutDeliveryRatesInput ;
  menu?: MenuUpdateOneWithoutDeliveryRateInput ;
}

export interface DeliveryRateUpdateWithoutMenuDataInput {
  name?: TranslatedStringUpdateOneWithoutDeliveryRateNameInput ;
  message?: TranslatedStringUpdateOneWithoutDeliveryRateMessageInput ;
  zip?: number ;
  polygon?: any ;
  fee?: FeeUpdateOneRequiredWithoutDeliveryRatesInput ;
  venues?: VenueUpdateManyWithoutDeliveryRatesInput ;
  company?: CompanyUpdateOneWithoutDeliveryRatesInput ;
}

export interface DeliveryRateUpdateWithoutMessageDataInput {
  name?: TranslatedStringUpdateOneWithoutDeliveryRateNameInput ;
  zip?: number ;
  polygon?: any ;
  fee?: FeeUpdateOneRequiredWithoutDeliveryRatesInput ;
  venues?: VenueUpdateManyWithoutDeliveryRatesInput ;
  company?: CompanyUpdateOneWithoutDeliveryRatesInput ;
  menu?: MenuUpdateOneWithoutDeliveryRateInput ;
}

export interface DeliveryRateUpdateWithoutNameDataInput {
  message?: TranslatedStringUpdateOneWithoutDeliveryRateMessageInput ;
  zip?: number ;
  polygon?: any ;
  fee?: FeeUpdateOneRequiredWithoutDeliveryRatesInput ;
  venues?: VenueUpdateManyWithoutDeliveryRatesInput ;
  company?: CompanyUpdateOneWithoutDeliveryRatesInput ;
  menu?: MenuUpdateOneWithoutDeliveryRateInput ;
}

export interface DeliveryRateUpdateWithoutVenuesDataInput {
  name?: TranslatedStringUpdateOneWithoutDeliveryRateNameInput ;
  message?: TranslatedStringUpdateOneWithoutDeliveryRateMessageInput ;
  zip?: number ;
  polygon?: any ;
  fee?: FeeUpdateOneRequiredWithoutDeliveryRatesInput ;
  company?: CompanyUpdateOneWithoutDeliveryRatesInput ;
  menu?: MenuUpdateOneWithoutDeliveryRateInput ;
}

export interface DeliveryRateUpsertWithWhereUniqueWithoutCompanyInput {
  where: DeliveryRateWhereUniqueInput;
  update: DeliveryRateUpdateWithoutCompanyDataInput;
  create: DeliveryRateCreateWithoutCompanyInput;
}

export interface DeliveryRateUpsertWithWhereUniqueWithoutFeeInput {
  where: DeliveryRateWhereUniqueInput;
  update: DeliveryRateUpdateWithoutFeeDataInput;
  create: DeliveryRateCreateWithoutFeeInput;
}

export interface DeliveryRateUpsertWithWhereUniqueWithoutMenuInput {
  where: DeliveryRateWhereUniqueInput;
  update: DeliveryRateUpdateWithoutMenuDataInput;
  create: DeliveryRateCreateWithoutMenuInput;
}

export interface DeliveryRateUpsertWithWhereUniqueWithoutVenuesInput {
  where: DeliveryRateWhereUniqueInput;
  update: DeliveryRateUpdateWithoutVenuesDataInput;
  create: DeliveryRateCreateWithoutVenuesInput;
}

export interface DeliveryRateUpsertWithoutMessageInput {
  update: DeliveryRateUpdateWithoutMessageDataInput;
  create: DeliveryRateCreateWithoutMessageInput;
}

export interface DeliveryRateUpsertWithoutNameInput {
  update: DeliveryRateUpdateWithoutNameDataInput;
  create: DeliveryRateCreateWithoutNameInput;
}

export interface DeliveryRateWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  name?: TranslatedStringWhereInput ;
  message?: TranslatedStringWhereInput ;
  zip?: number ;
  zip_not?: number ;
  zip_in?: number[] ;
  zip_not_in?: number[] ;
  zip_lt?: number ;
  zip_lte?: number ;
  zip_gt?: number ;
  zip_gte?: number ;
  fee?: FeeWhereInput ;
  venues_every?: VenueWhereInput ;
  venues_some?: VenueWhereInput ;
  venues_none?: VenueWhereInput ;
  company?: CompanyWhereInput ;
  menu?: MenuWhereInput ;
  AND?: DeliveryRateWhereInput[] ;
  OR?: DeliveryRateWhereInput[] ;
  NOT?: DeliveryRateWhereInput[] ;
}

export interface DeliveryRateWhereUniqueInput {
  id?: string ;
}

export interface DeviceCreateManyWithoutUserInput {
  create?: DeviceCreateWithoutUserInput[] ;
  connect?: DeviceWhereUniqueInput[] ;
}

export interface DeviceCreateWithoutUserInput {
  id?: string ;
  operatingSystem: DEVICE_OS;
  notificationsDisabled?: boolean ;
  topic?: string ;
  token: string;
  useNewSenderID?: boolean ;
}

export interface DeviceScalarWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  operatingSystem?: DEVICE_OS ;
  operatingSystem_not?: DEVICE_OS ;
  operatingSystem_in?: DEVICE_OS[] ;
  operatingSystem_not_in?: DEVICE_OS[] ;
  notificationsDisabled?: boolean ;
  notificationsDisabled_not?: boolean ;
  topic?: string ;
  topic_not?: string ;
  topic_in?: string[] ;
  topic_not_in?: string[] ;
  topic_lt?: string ;
  topic_lte?: string ;
  topic_gt?: string ;
  topic_gte?: string ;
  topic_contains?: string ;
  topic_not_contains?: string ;
  topic_starts_with?: string ;
  topic_not_starts_with?: string ;
  topic_ends_with?: string ;
  topic_not_ends_with?: string ;
  token?: string ;
  token_not?: string ;
  token_in?: string[] ;
  token_not_in?: string[] ;
  token_lt?: string ;
  token_lte?: string ;
  token_gt?: string ;
  token_gte?: string ;
  token_contains?: string ;
  token_not_contains?: string ;
  token_starts_with?: string ;
  token_not_starts_with?: string ;
  token_ends_with?: string ;
  token_not_ends_with?: string ;
  useNewSenderID?: boolean ;
  useNewSenderID_not?: boolean ;
  AND?: DeviceScalarWhereInput[] ;
  OR?: DeviceScalarWhereInput[] ;
  NOT?: DeviceScalarWhereInput[] ;
}

export interface DeviceUpdateManyDataInput {
  operatingSystem?: DEVICE_OS ;
  notificationsDisabled?: boolean ;
  topic?: string ;
  token?: string ;
  useNewSenderID?: boolean ;
}

export interface DeviceUpdateManyWithWhereNestedInput {
  where: DeviceScalarWhereInput;
  data: DeviceUpdateManyDataInput;
}

export interface DeviceUpdateManyWithoutUserInput {
  create?: DeviceCreateWithoutUserInput[] ;
  connect?: DeviceWhereUniqueInput[] ;
  set?: DeviceWhereUniqueInput[] ;
  disconnect?: DeviceWhereUniqueInput[] ;
  update?: DeviceUpdateWithWhereUniqueWithoutUserInput[] ;
  upsert?: DeviceUpsertWithWhereUniqueWithoutUserInput[] ;
  deleteMany?: DeviceScalarWhereInput[] ;
  updateMany?: DeviceUpdateManyWithWhereNestedInput[] ;
}

export interface DeviceUpdateWithWhereUniqueWithoutUserInput {
  where: DeviceWhereUniqueInput;
  data: DeviceUpdateWithoutUserDataInput;
}

export interface DeviceUpdateWithoutUserDataInput {
  operatingSystem?: DEVICE_OS ;
  notificationsDisabled?: boolean ;
  topic?: string ;
  token?: string ;
  useNewSenderID?: boolean ;
}

export interface DeviceUpsertWithWhereUniqueWithoutUserInput {
  where: DeviceWhereUniqueInput;
  update: DeviceUpdateWithoutUserDataInput;
  create: DeviceCreateWithoutUserInput;
}

export interface DeviceWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  user?: UserWhereInput ;
  operatingSystem?: DEVICE_OS ;
  operatingSystem_not?: DEVICE_OS ;
  operatingSystem_in?: DEVICE_OS[] ;
  operatingSystem_not_in?: DEVICE_OS[] ;
  notificationsDisabled?: boolean ;
  notificationsDisabled_not?: boolean ;
  topic?: string ;
  topic_not?: string ;
  topic_in?: string[] ;
  topic_not_in?: string[] ;
  topic_lt?: string ;
  topic_lte?: string ;
  topic_gt?: string ;
  topic_gte?: string ;
  topic_contains?: string ;
  topic_not_contains?: string ;
  topic_starts_with?: string ;
  topic_not_starts_with?: string ;
  topic_ends_with?: string ;
  topic_not_ends_with?: string ;
  token?: string ;
  token_not?: string ;
  token_in?: string[] ;
  token_not_in?: string[] ;
  token_lt?: string ;
  token_lte?: string ;
  token_gt?: string ;
  token_gte?: string ;
  token_contains?: string ;
  token_not_contains?: string ;
  token_starts_with?: string ;
  token_not_starts_with?: string ;
  token_ends_with?: string ;
  token_not_ends_with?: string ;
  useNewSenderID?: boolean ;
  useNewSenderID_not?: boolean ;
  AND?: DeviceWhereInput[] ;
  OR?: DeviceWhereInput[] ;
  NOT?: DeviceWhereInput[] ;
}

export interface DeviceWhereUniqueInput {
  id?: string ;
}

export interface DiscountCreateManyWithoutCompanyInput {
  create?: DiscountCreateWithoutCompanyInput[] ;
  connect?: DiscountWhereUniqueInput[] ;
}

export interface DiscountCreateManyWithoutItemsInput {
  create?: DiscountCreateWithoutItemsInput[] ;
  connect?: DiscountWhereUniqueInput[] ;
}

export interface DiscountCreateWithoutCompanyInput {
  campaigns?: CampaignCreateManyWithoutDiscountsInput ;
  id?: string ;
  items?: ItemCreateManyWithoutDiscountsInput ;
  type: DISCOUNT_TYPE;
}

export interface DiscountCreateWithoutItemsInput {
  campaigns?: CampaignCreateManyWithoutDiscountsInput ;
  company?: CompanyCreateOneWithoutDiscountsInput ;
  id?: string ;
  type: DISCOUNT_TYPE;
}

export interface DiscountScalarWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  type?: DISCOUNT_TYPE ;
  type_not?: DISCOUNT_TYPE ;
  type_in?: DISCOUNT_TYPE[] ;
  type_not_in?: DISCOUNT_TYPE[] ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  AND?: DiscountScalarWhereInput[] ;
  OR?: DiscountScalarWhereInput[] ;
  NOT?: DiscountScalarWhereInput[] ;
}

export interface DiscountUpdateManyDataInput {
  type?: DISCOUNT_TYPE ;
}

export interface DiscountUpdateManyWithWhereNestedInput {
  where: DiscountScalarWhereInput;
  data: DiscountUpdateManyDataInput;
}

export interface DiscountUpdateManyWithoutCompanyInput {
  create?: DiscountCreateWithoutCompanyInput[] ;
  connect?: DiscountWhereUniqueInput[] ;
  set?: DiscountWhereUniqueInput[] ;
  disconnect?: DiscountWhereUniqueInput[] ;
  update?: DiscountUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: DiscountUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: DiscountScalarWhereInput[] ;
  updateMany?: DiscountUpdateManyWithWhereNestedInput[] ;
}

export interface DiscountUpdateManyWithoutItemsInput {
  create?: DiscountCreateWithoutItemsInput[] ;
  connect?: DiscountWhereUniqueInput[] ;
  set?: DiscountWhereUniqueInput[] ;
  disconnect?: DiscountWhereUniqueInput[] ;
  update?: DiscountUpdateWithWhereUniqueWithoutItemsInput[] ;
  upsert?: DiscountUpsertWithWhereUniqueWithoutItemsInput[] ;
  deleteMany?: DiscountScalarWhereInput[] ;
  updateMany?: DiscountUpdateManyWithWhereNestedInput[] ;
}

export interface DiscountUpdateWithWhereUniqueWithoutCompanyInput {
  where: DiscountWhereUniqueInput;
  data: DiscountUpdateWithoutCompanyDataInput;
}

export interface DiscountUpdateWithWhereUniqueWithoutItemsInput {
  where: DiscountWhereUniqueInput;
  data: DiscountUpdateWithoutItemsDataInput;
}

export interface DiscountUpdateWithoutCompanyDataInput {
  campaigns?: CampaignUpdateManyWithoutDiscountsInput ;
  items?: ItemUpdateManyWithoutDiscountsInput ;
  type?: DISCOUNT_TYPE ;
}

export interface DiscountUpdateWithoutItemsDataInput {
  campaigns?: CampaignUpdateManyWithoutDiscountsInput ;
  company?: CompanyUpdateOneWithoutDiscountsInput ;
  type?: DISCOUNT_TYPE ;
}

export interface DiscountUpsertWithWhereUniqueWithoutCompanyInput {
  where: DiscountWhereUniqueInput;
  update: DiscountUpdateWithoutCompanyDataInput;
  create: DiscountCreateWithoutCompanyInput;
}

export interface DiscountUpsertWithWhereUniqueWithoutItemsInput {
  where: DiscountWhereUniqueInput;
  update: DiscountUpdateWithoutItemsDataInput;
  create: DiscountCreateWithoutItemsInput;
}

export interface DiscountWhereInput {
  campaigns_every?: CampaignWhereInput ;
  campaigns_some?: CampaignWhereInput ;
  campaigns_none?: CampaignWhereInput ;
  company?: CompanyWhereInput ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  items_every?: ItemWhereInput ;
  items_some?: ItemWhereInput ;
  items_none?: ItemWhereInput ;
  type?: DISCOUNT_TYPE ;
  type_not?: DISCOUNT_TYPE ;
  type_in?: DISCOUNT_TYPE[] ;
  type_not_in?: DISCOUNT_TYPE[] ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  AND?: DiscountWhereInput[] ;
  OR?: DiscountWhereInput[] ;
  NOT?: DiscountWhereInput[] ;
}

export interface DiscountWhereUniqueInput {
  id?: string ;
}

export interface EmailDetails {
  companyName: string;
  formattedAmount: string;
}

export interface EventCreateManyWithoutUserInput {
  create?: EventCreateWithoutUserInput[] ;
  connect?: EventWhereUniqueInput[] ;
}

export interface EventCreateWithoutUserInput {
  id?: string ;
  category: string;
  action: string;
  label?: string ;
  value?: number ;
}

export interface EventScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  category?: string ;
  category_not?: string ;
  category_in?: string[] ;
  category_not_in?: string[] ;
  category_lt?: string ;
  category_lte?: string ;
  category_gt?: string ;
  category_gte?: string ;
  category_contains?: string ;
  category_not_contains?: string ;
  category_starts_with?: string ;
  category_not_starts_with?: string ;
  category_ends_with?: string ;
  category_not_ends_with?: string ;
  action?: string ;
  action_not?: string ;
  action_in?: string[] ;
  action_not_in?: string[] ;
  action_lt?: string ;
  action_lte?: string ;
  action_gt?: string ;
  action_gte?: string ;
  action_contains?: string ;
  action_not_contains?: string ;
  action_starts_with?: string ;
  action_not_starts_with?: string ;
  action_ends_with?: string ;
  action_not_ends_with?: string ;
  label?: string ;
  label_not?: string ;
  label_in?: string[] ;
  label_not_in?: string[] ;
  label_lt?: string ;
  label_lte?: string ;
  label_gt?: string ;
  label_gte?: string ;
  label_contains?: string ;
  label_not_contains?: string ;
  label_starts_with?: string ;
  label_not_starts_with?: string ;
  label_ends_with?: string ;
  label_not_ends_with?: string ;
  value?: number ;
  value_not?: number ;
  value_in?: number[] ;
  value_not_in?: number[] ;
  value_lt?: number ;
  value_lte?: number ;
  value_gt?: number ;
  value_gte?: number ;
  AND?: EventScalarWhereInput[] ;
  OR?: EventScalarWhereInput[] ;
  NOT?: EventScalarWhereInput[] ;
}

export interface EventUpdateManyDataInput {
  category?: string ;
  action?: string ;
  label?: string ;
  value?: number ;
}

export interface EventUpdateManyWithWhereNestedInput {
  where: EventScalarWhereInput;
  data: EventUpdateManyDataInput;
}

export interface EventUpdateManyWithoutUserInput {
  create?: EventCreateWithoutUserInput[] ;
  connect?: EventWhereUniqueInput[] ;
  set?: EventWhereUniqueInput[] ;
  disconnect?: EventWhereUniqueInput[] ;
  update?: EventUpdateWithWhereUniqueWithoutUserInput[] ;
  upsert?: EventUpsertWithWhereUniqueWithoutUserInput[] ;
  deleteMany?: EventScalarWhereInput[] ;
  updateMany?: EventUpdateManyWithWhereNestedInput[] ;
}

export interface EventUpdateWithWhereUniqueWithoutUserInput {
  where: EventWhereUniqueInput;
  data: EventUpdateWithoutUserDataInput;
}

export interface EventUpdateWithoutUserDataInput {
  category?: string ;
  action?: string ;
  label?: string ;
  value?: number ;
}

export interface EventUpsertWithWhereUniqueWithoutUserInput {
  where: EventWhereUniqueInput;
  update: EventUpdateWithoutUserDataInput;
  create: EventCreateWithoutUserInput;
}

export interface EventWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  category?: string ;
  category_not?: string ;
  category_in?: string[] ;
  category_not_in?: string[] ;
  category_lt?: string ;
  category_lte?: string ;
  category_gt?: string ;
  category_gte?: string ;
  category_contains?: string ;
  category_not_contains?: string ;
  category_starts_with?: string ;
  category_not_starts_with?: string ;
  category_ends_with?: string ;
  category_not_ends_with?: string ;
  action?: string ;
  action_not?: string ;
  action_in?: string[] ;
  action_not_in?: string[] ;
  action_lt?: string ;
  action_lte?: string ;
  action_gt?: string ;
  action_gte?: string ;
  action_contains?: string ;
  action_not_contains?: string ;
  action_starts_with?: string ;
  action_not_starts_with?: string ;
  action_ends_with?: string ;
  action_not_ends_with?: string ;
  label?: string ;
  label_not?: string ;
  label_in?: string[] ;
  label_not_in?: string[] ;
  label_lt?: string ;
  label_lte?: string ;
  label_gt?: string ;
  label_gte?: string ;
  label_contains?: string ;
  label_not_contains?: string ;
  label_starts_with?: string ;
  label_not_starts_with?: string ;
  label_ends_with?: string ;
  label_not_ends_with?: string ;
  value?: number ;
  value_not?: number ;
  value_in?: number[] ;
  value_not_in?: number[] ;
  value_lt?: number ;
  value_lte?: number ;
  value_gt?: number ;
  value_gte?: number ;
  user?: UserWhereInput ;
  AND?: EventWhereInput[] ;
  OR?: EventWhereInput[] ;
  NOT?: EventWhereInput[] ;
}

export interface EventWhereUniqueInput {
  id?: string ;
}

export interface ExpenseCreateManyWithoutCompanyInput {
  create?: ExpenseCreateWithoutCompanyInput[] ;
  connect?: ExpenseWhereUniqueInput[] ;
}

export interface ExpenseCreateManyWithoutStaffInput {
  create?: ExpenseCreateWithoutStaffInput[] ;
  connect?: ExpenseWhereUniqueInput[] ;
}

export interface ExpenseCreateManyWithoutVenueInput {
  create?: ExpenseCreateWithoutVenueInput[] ;
  connect?: ExpenseWhereUniqueInput[] ;
}

export interface ExpenseCreateWithoutCompanyInput {
  id?: string ;
  amount: number;
  paymentType: string;
  venue: VenueCreateOneWithoutExpensesInput;
  staff: StaffCreateOneWithoutExpensesInput;
}

export interface ExpenseCreateWithoutStaffInput {
  id?: string ;
  amount: number;
  paymentType: string;
  venue: VenueCreateOneWithoutExpensesInput;
  company: CompanyCreateOneWithoutExpensesInput;
}

export interface ExpenseCreateWithoutVenueInput {
  id?: string ;
  amount: number;
  paymentType: string;
  company: CompanyCreateOneWithoutExpensesInput;
  staff: StaffCreateOneWithoutExpensesInput;
}

export interface ExpenseScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  amount?: number ;
  amount_not?: number ;
  amount_in?: number[] ;
  amount_not_in?: number[] ;
  amount_lt?: number ;
  amount_lte?: number ;
  amount_gt?: number ;
  amount_gte?: number ;
  paymentType?: string ;
  paymentType_not?: string ;
  paymentType_in?: string[] ;
  paymentType_not_in?: string[] ;
  paymentType_lt?: string ;
  paymentType_lte?: string ;
  paymentType_gt?: string ;
  paymentType_gte?: string ;
  paymentType_contains?: string ;
  paymentType_not_contains?: string ;
  paymentType_starts_with?: string ;
  paymentType_not_starts_with?: string ;
  paymentType_ends_with?: string ;
  paymentType_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  AND?: ExpenseScalarWhereInput[] ;
  OR?: ExpenseScalarWhereInput[] ;
  NOT?: ExpenseScalarWhereInput[] ;
}

export interface ExpenseUpdateManyDataInput {
  amount?: number ;
  paymentType?: string ;
}

export interface ExpenseUpdateManyWithWhereNestedInput {
  where: ExpenseScalarWhereInput;
  data: ExpenseUpdateManyDataInput;
}

export interface ExpenseUpdateManyWithoutCompanyInput {
  create?: ExpenseCreateWithoutCompanyInput[] ;
  connect?: ExpenseWhereUniqueInput[] ;
  set?: ExpenseWhereUniqueInput[] ;
  disconnect?: ExpenseWhereUniqueInput[] ;
  update?: ExpenseUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: ExpenseUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: ExpenseScalarWhereInput[] ;
  updateMany?: ExpenseUpdateManyWithWhereNestedInput[] ;
}

export interface ExpenseUpdateManyWithoutStaffInput {
  create?: ExpenseCreateWithoutStaffInput[] ;
  connect?: ExpenseWhereUniqueInput[] ;
  set?: ExpenseWhereUniqueInput[] ;
  disconnect?: ExpenseWhereUniqueInput[] ;
  update?: ExpenseUpdateWithWhereUniqueWithoutStaffInput[] ;
  upsert?: ExpenseUpsertWithWhereUniqueWithoutStaffInput[] ;
  deleteMany?: ExpenseScalarWhereInput[] ;
  updateMany?: ExpenseUpdateManyWithWhereNestedInput[] ;
}

export interface ExpenseUpdateManyWithoutVenueInput {
  create?: ExpenseCreateWithoutVenueInput[] ;
  connect?: ExpenseWhereUniqueInput[] ;
  set?: ExpenseWhereUniqueInput[] ;
  disconnect?: ExpenseWhereUniqueInput[] ;
  update?: ExpenseUpdateWithWhereUniqueWithoutVenueInput[] ;
  upsert?: ExpenseUpsertWithWhereUniqueWithoutVenueInput[] ;
  deleteMany?: ExpenseScalarWhereInput[] ;
  updateMany?: ExpenseUpdateManyWithWhereNestedInput[] ;
}

export interface ExpenseUpdateWithWhereUniqueWithoutCompanyInput {
  where: ExpenseWhereUniqueInput;
  data: ExpenseUpdateWithoutCompanyDataInput;
}

export interface ExpenseUpdateWithWhereUniqueWithoutStaffInput {
  where: ExpenseWhereUniqueInput;
  data: ExpenseUpdateWithoutStaffDataInput;
}

export interface ExpenseUpdateWithWhereUniqueWithoutVenueInput {
  where: ExpenseWhereUniqueInput;
  data: ExpenseUpdateWithoutVenueDataInput;
}

export interface ExpenseUpdateWithoutCompanyDataInput {
  amount?: number ;
  paymentType?: string ;
  venue?: VenueUpdateOneRequiredWithoutExpensesInput ;
  staff?: StaffUpdateOneRequiredWithoutExpensesInput ;
}

export interface ExpenseUpdateWithoutStaffDataInput {
  amount?: number ;
  paymentType?: string ;
  venue?: VenueUpdateOneRequiredWithoutExpensesInput ;
  company?: CompanyUpdateOneRequiredWithoutExpensesInput ;
}

export interface ExpenseUpdateWithoutVenueDataInput {
  amount?: number ;
  paymentType?: string ;
  company?: CompanyUpdateOneRequiredWithoutExpensesInput ;
  staff?: StaffUpdateOneRequiredWithoutExpensesInput ;
}

export interface ExpenseUpsertWithWhereUniqueWithoutCompanyInput {
  where: ExpenseWhereUniqueInput;
  update: ExpenseUpdateWithoutCompanyDataInput;
  create: ExpenseCreateWithoutCompanyInput;
}

export interface ExpenseUpsertWithWhereUniqueWithoutStaffInput {
  where: ExpenseWhereUniqueInput;
  update: ExpenseUpdateWithoutStaffDataInput;
  create: ExpenseCreateWithoutStaffInput;
}

export interface ExpenseUpsertWithWhereUniqueWithoutVenueInput {
  where: ExpenseWhereUniqueInput;
  update: ExpenseUpdateWithoutVenueDataInput;
  create: ExpenseCreateWithoutVenueInput;
}

export interface ExpenseWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  amount?: number ;
  amount_not?: number ;
  amount_in?: number[] ;
  amount_not_in?: number[] ;
  amount_lt?: number ;
  amount_lte?: number ;
  amount_gt?: number ;
  amount_gte?: number ;
  paymentType?: string ;
  paymentType_not?: string ;
  paymentType_in?: string[] ;
  paymentType_not_in?: string[] ;
  paymentType_lt?: string ;
  paymentType_lte?: string ;
  paymentType_gt?: string ;
  paymentType_gte?: string ;
  paymentType_contains?: string ;
  paymentType_not_contains?: string ;
  paymentType_starts_with?: string ;
  paymentType_not_starts_with?: string ;
  paymentType_ends_with?: string ;
  paymentType_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  venue?: VenueWhereInput ;
  company?: CompanyWhereInput ;
  staff?: StaffWhereInput ;
  AND?: ExpenseWhereInput[] ;
  OR?: ExpenseWhereInput[] ;
  NOT?: ExpenseWhereInput[] ;
}

export interface ExpenseWhereUniqueInput {
  id?: string ;
}

export interface ExpressPageCreateInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutExpressPageTitleInput;
  description?: TranslatedStringCreateOneWithoutExpressPageDescriptionInput ;
  company: CompanyCreateOneWithoutExpressPagesInput;
  categories?: CategoryCreateManyWithoutExpressPagesInput ;
  icon: ImageCreateOneWithoutExpressPageIconsInput;
  image?: ImageCreateOneWithoutExpressPageImagesInput ;
  order?: number ;
  deleted?: boolean ;
}

export interface ExpressPageCreateManyWithoutCategoriesInput {
  create?: ExpressPageCreateWithoutCategoriesInput[] ;
  connect?: ExpressPageWhereUniqueInput[] ;
}

export interface ExpressPageCreateManyWithoutCompanyInput {
  create?: ExpressPageCreateWithoutCompanyInput[] ;
  connect?: ExpressPageWhereUniqueInput[] ;
}

export interface ExpressPageCreateManyWithoutIconInput {
  create?: ExpressPageCreateWithoutIconInput[] ;
  connect?: ExpressPageWhereUniqueInput[] ;
}

export interface ExpressPageCreateManyWithoutImageInput {
  create?: ExpressPageCreateWithoutImageInput[] ;
  connect?: ExpressPageWhereUniqueInput[] ;
}

export interface ExpressPageCreateOneWithoutDescriptionInput {
  create?: ExpressPageCreateWithoutDescriptionInput ;
  connect?: ExpressPageWhereUniqueInput ;
}

export interface ExpressPageCreateOneWithoutTitleInput {
  create?: ExpressPageCreateWithoutTitleInput ;
  connect?: ExpressPageWhereUniqueInput ;
}

export interface ExpressPageCreateWithoutCategoriesInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutExpressPageTitleInput;
  description?: TranslatedStringCreateOneWithoutExpressPageDescriptionInput ;
  company: CompanyCreateOneWithoutExpressPagesInput;
  icon: ImageCreateOneWithoutExpressPageIconsInput;
  image?: ImageCreateOneWithoutExpressPageImagesInput ;
  order?: number ;
  deleted?: boolean ;
}

export interface ExpressPageCreateWithoutCompanyInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutExpressPageTitleInput;
  description?: TranslatedStringCreateOneWithoutExpressPageDescriptionInput ;
  categories?: CategoryCreateManyWithoutExpressPagesInput ;
  icon: ImageCreateOneWithoutExpressPageIconsInput;
  image?: ImageCreateOneWithoutExpressPageImagesInput ;
  order?: number ;
  deleted?: boolean ;
}

export interface ExpressPageCreateWithoutDescriptionInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutExpressPageTitleInput;
  company: CompanyCreateOneWithoutExpressPagesInput;
  categories?: CategoryCreateManyWithoutExpressPagesInput ;
  icon: ImageCreateOneWithoutExpressPageIconsInput;
  image?: ImageCreateOneWithoutExpressPageImagesInput ;
  order?: number ;
  deleted?: boolean ;
}

export interface ExpressPageCreateWithoutIconInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutExpressPageTitleInput;
  description?: TranslatedStringCreateOneWithoutExpressPageDescriptionInput ;
  company: CompanyCreateOneWithoutExpressPagesInput;
  categories?: CategoryCreateManyWithoutExpressPagesInput ;
  image?: ImageCreateOneWithoutExpressPageImagesInput ;
  order?: number ;
  deleted?: boolean ;
}

export interface ExpressPageCreateWithoutImageInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutExpressPageTitleInput;
  description?: TranslatedStringCreateOneWithoutExpressPageDescriptionInput ;
  company: CompanyCreateOneWithoutExpressPagesInput;
  categories?: CategoryCreateManyWithoutExpressPagesInput ;
  icon: ImageCreateOneWithoutExpressPageIconsInput;
  order?: number ;
  deleted?: boolean ;
}

export interface ExpressPageCreateWithoutTitleInput {
  id?: string ;
  description?: TranslatedStringCreateOneWithoutExpressPageDescriptionInput ;
  company: CompanyCreateOneWithoutExpressPagesInput;
  categories?: CategoryCreateManyWithoutExpressPagesInput ;
  icon: ImageCreateOneWithoutExpressPageIconsInput;
  image?: ImageCreateOneWithoutExpressPageImagesInput ;
  order?: number ;
  deleted?: boolean ;
}

export interface ExpressPageScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  order?: number ;
  order_not?: number ;
  order_in?: number[] ;
  order_not_in?: number[] ;
  order_lt?: number ;
  order_lte?: number ;
  order_gt?: number ;
  order_gte?: number ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  AND?: ExpressPageScalarWhereInput[] ;
  OR?: ExpressPageScalarWhereInput[] ;
  NOT?: ExpressPageScalarWhereInput[] ;
}

export interface ExpressPageUpdateInput {
  title?: TranslatedStringUpdateOneRequiredWithoutExpressPageTitleInput ;
  description?: TranslatedStringUpdateOneWithoutExpressPageDescriptionInput ;
  company?: CompanyUpdateOneRequiredWithoutExpressPagesInput ;
  categories?: CategoryUpdateManyWithoutExpressPagesInput ;
  icon?: ImageUpdateOneRequiredWithoutExpressPageIconsInput ;
  image?: ImageUpdateOneWithoutExpressPageImagesInput ;
  order?: number ;
  deleted?: boolean ;
}

export interface ExpressPageUpdateManyDataInput {
  order?: number ;
  deleted?: boolean ;
}

export interface ExpressPageUpdateManyWithWhereNestedInput {
  where: ExpressPageScalarWhereInput;
  data: ExpressPageUpdateManyDataInput;
}

export interface ExpressPageUpdateManyWithoutCategoriesInput {
  create?: ExpressPageCreateWithoutCategoriesInput[] ;
  connect?: ExpressPageWhereUniqueInput[] ;
  set?: ExpressPageWhereUniqueInput[] ;
  disconnect?: ExpressPageWhereUniqueInput[] ;
  update?: ExpressPageUpdateWithWhereUniqueWithoutCategoriesInput[] ;
  upsert?: ExpressPageUpsertWithWhereUniqueWithoutCategoriesInput[] ;
  deleteMany?: ExpressPageScalarWhereInput[] ;
  updateMany?: ExpressPageUpdateManyWithWhereNestedInput[] ;
}

export interface ExpressPageUpdateManyWithoutCompanyInput {
  create?: ExpressPageCreateWithoutCompanyInput[] ;
  connect?: ExpressPageWhereUniqueInput[] ;
  set?: ExpressPageWhereUniqueInput[] ;
  disconnect?: ExpressPageWhereUniqueInput[] ;
  update?: ExpressPageUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: ExpressPageUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: ExpressPageScalarWhereInput[] ;
  updateMany?: ExpressPageUpdateManyWithWhereNestedInput[] ;
}

export interface ExpressPageUpdateManyWithoutIconInput {
  create?: ExpressPageCreateWithoutIconInput[] ;
  connect?: ExpressPageWhereUniqueInput[] ;
  set?: ExpressPageWhereUniqueInput[] ;
  disconnect?: ExpressPageWhereUniqueInput[] ;
  update?: ExpressPageUpdateWithWhereUniqueWithoutIconInput[] ;
  upsert?: ExpressPageUpsertWithWhereUniqueWithoutIconInput[] ;
  deleteMany?: ExpressPageScalarWhereInput[] ;
  updateMany?: ExpressPageUpdateManyWithWhereNestedInput[] ;
}

export interface ExpressPageUpdateManyWithoutImageInput {
  create?: ExpressPageCreateWithoutImageInput[] ;
  connect?: ExpressPageWhereUniqueInput[] ;
  set?: ExpressPageWhereUniqueInput[] ;
  disconnect?: ExpressPageWhereUniqueInput[] ;
  update?: ExpressPageUpdateWithWhereUniqueWithoutImageInput[] ;
  upsert?: ExpressPageUpsertWithWhereUniqueWithoutImageInput[] ;
  deleteMany?: ExpressPageScalarWhereInput[] ;
  updateMany?: ExpressPageUpdateManyWithWhereNestedInput[] ;
}

export interface ExpressPageUpdateOneWithoutDescriptionInput {
  create?: ExpressPageCreateWithoutDescriptionInput ;
  update?: ExpressPageUpdateWithoutDescriptionDataInput ;
  upsert?: ExpressPageUpsertWithoutDescriptionInput ;
  disconnect?: boolean ;
  connect?: ExpressPageWhereUniqueInput ;
}

export interface ExpressPageUpdateOneWithoutTitleInput {
  create?: ExpressPageCreateWithoutTitleInput ;
  update?: ExpressPageUpdateWithoutTitleDataInput ;
  upsert?: ExpressPageUpsertWithoutTitleInput ;
  disconnect?: boolean ;
  connect?: ExpressPageWhereUniqueInput ;
}

export interface ExpressPageUpdateWithWhereUniqueWithoutCategoriesInput {
  where: ExpressPageWhereUniqueInput;
  data: ExpressPageUpdateWithoutCategoriesDataInput;
}

export interface ExpressPageUpdateWithWhereUniqueWithoutCompanyInput {
  where: ExpressPageWhereUniqueInput;
  data: ExpressPageUpdateWithoutCompanyDataInput;
}

export interface ExpressPageUpdateWithWhereUniqueWithoutIconInput {
  where: ExpressPageWhereUniqueInput;
  data: ExpressPageUpdateWithoutIconDataInput;
}

export interface ExpressPageUpdateWithWhereUniqueWithoutImageInput {
  where: ExpressPageWhereUniqueInput;
  data: ExpressPageUpdateWithoutImageDataInput;
}

export interface ExpressPageUpdateWithoutCategoriesDataInput {
  title?: TranslatedStringUpdateOneRequiredWithoutExpressPageTitleInput ;
  description?: TranslatedStringUpdateOneWithoutExpressPageDescriptionInput ;
  company?: CompanyUpdateOneRequiredWithoutExpressPagesInput ;
  icon?: ImageUpdateOneRequiredWithoutExpressPageIconsInput ;
  image?: ImageUpdateOneWithoutExpressPageImagesInput ;
  order?: number ;
  deleted?: boolean ;
}

export interface ExpressPageUpdateWithoutCompanyDataInput {
  title?: TranslatedStringUpdateOneRequiredWithoutExpressPageTitleInput ;
  description?: TranslatedStringUpdateOneWithoutExpressPageDescriptionInput ;
  categories?: CategoryUpdateManyWithoutExpressPagesInput ;
  icon?: ImageUpdateOneRequiredWithoutExpressPageIconsInput ;
  image?: ImageUpdateOneWithoutExpressPageImagesInput ;
  order?: number ;
  deleted?: boolean ;
}

export interface ExpressPageUpdateWithoutDescriptionDataInput {
  title?: TranslatedStringUpdateOneRequiredWithoutExpressPageTitleInput ;
  company?: CompanyUpdateOneRequiredWithoutExpressPagesInput ;
  categories?: CategoryUpdateManyWithoutExpressPagesInput ;
  icon?: ImageUpdateOneRequiredWithoutExpressPageIconsInput ;
  image?: ImageUpdateOneWithoutExpressPageImagesInput ;
  order?: number ;
  deleted?: boolean ;
}

export interface ExpressPageUpdateWithoutIconDataInput {
  title?: TranslatedStringUpdateOneRequiredWithoutExpressPageTitleInput ;
  description?: TranslatedStringUpdateOneWithoutExpressPageDescriptionInput ;
  company?: CompanyUpdateOneRequiredWithoutExpressPagesInput ;
  categories?: CategoryUpdateManyWithoutExpressPagesInput ;
  image?: ImageUpdateOneWithoutExpressPageImagesInput ;
  order?: number ;
  deleted?: boolean ;
}

export interface ExpressPageUpdateWithoutImageDataInput {
  title?: TranslatedStringUpdateOneRequiredWithoutExpressPageTitleInput ;
  description?: TranslatedStringUpdateOneWithoutExpressPageDescriptionInput ;
  company?: CompanyUpdateOneRequiredWithoutExpressPagesInput ;
  categories?: CategoryUpdateManyWithoutExpressPagesInput ;
  icon?: ImageUpdateOneRequiredWithoutExpressPageIconsInput ;
  order?: number ;
  deleted?: boolean ;
}

export interface ExpressPageUpdateWithoutTitleDataInput {
  description?: TranslatedStringUpdateOneWithoutExpressPageDescriptionInput ;
  company?: CompanyUpdateOneRequiredWithoutExpressPagesInput ;
  categories?: CategoryUpdateManyWithoutExpressPagesInput ;
  icon?: ImageUpdateOneRequiredWithoutExpressPageIconsInput ;
  image?: ImageUpdateOneWithoutExpressPageImagesInput ;
  order?: number ;
  deleted?: boolean ;
}

export interface ExpressPageUpsertWithWhereUniqueWithoutCategoriesInput {
  where: ExpressPageWhereUniqueInput;
  update: ExpressPageUpdateWithoutCategoriesDataInput;
  create: ExpressPageCreateWithoutCategoriesInput;
}

export interface ExpressPageUpsertWithWhereUniqueWithoutCompanyInput {
  where: ExpressPageWhereUniqueInput;
  update: ExpressPageUpdateWithoutCompanyDataInput;
  create: ExpressPageCreateWithoutCompanyInput;
}

export interface ExpressPageUpsertWithWhereUniqueWithoutIconInput {
  where: ExpressPageWhereUniqueInput;
  update: ExpressPageUpdateWithoutIconDataInput;
  create: ExpressPageCreateWithoutIconInput;
}

export interface ExpressPageUpsertWithWhereUniqueWithoutImageInput {
  where: ExpressPageWhereUniqueInput;
  update: ExpressPageUpdateWithoutImageDataInput;
  create: ExpressPageCreateWithoutImageInput;
}

export interface ExpressPageUpsertWithoutDescriptionInput {
  update: ExpressPageUpdateWithoutDescriptionDataInput;
  create: ExpressPageCreateWithoutDescriptionInput;
}

export interface ExpressPageUpsertWithoutTitleInput {
  update: ExpressPageUpdateWithoutTitleDataInput;
  create: ExpressPageCreateWithoutTitleInput;
}

export interface ExpressPageWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  title?: TranslatedStringWhereInput ;
  description?: TranslatedStringWhereInput ;
  company?: CompanyWhereInput ;
  categories_every?: CategoryWhereInput ;
  categories_some?: CategoryWhereInput ;
  categories_none?: CategoryWhereInput ;
  icon?: ImageWhereInput ;
  image?: ImageWhereInput ;
  order?: number ;
  order_not?: number ;
  order_in?: number[] ;
  order_not_in?: number[] ;
  order_lt?: number ;
  order_lte?: number ;
  order_gt?: number ;
  order_gte?: number ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  AND?: ExpressPageWhereInput[] ;
  OR?: ExpressPageWhereInput[] ;
  NOT?: ExpressPageWhereInput[] ;
}

export interface ExpressPageWhereUniqueInput {
  id?: string ;
}

export interface FeeCreateManyWithoutOrdersInput {
  create?: FeeCreateWithoutOrdersInput[] ;
  connect?: FeeWhereUniqueInput[] ;
}

export interface FeeCreateOneWithoutDeliveryRatesInput {
  create?: FeeCreateWithoutDeliveryRatesInput ;
  connect?: FeeWhereUniqueInput ;
}

export interface FeeCreateOneWithoutLocalDeliveryRatesInput {
  create?: FeeCreateWithoutLocalDeliveryRatesInput ;
  connect?: FeeWhereUniqueInput ;
}

export interface FeeCreateOneWithoutPriceInput {
  create?: FeeCreateWithoutPriceInput ;
  connect?: FeeWhereUniqueInput ;
}

export interface FeeCreateWithoutDeliveryRatesInput {
  id?: string ;
  name: string;
  orders?: OrderCreateManyWithoutFeesInput ;
  price: PriceCreateOneWithoutFeeInput;
  localDeliveryRates?: LocalDeliveryOptionsCreateManyWithoutFeeInput ;
}

export interface FeeCreateWithoutLocalDeliveryRatesInput {
  id?: string ;
  name: string;
  orders?: OrderCreateManyWithoutFeesInput ;
  price: PriceCreateOneWithoutFeeInput;
  deliveryRates?: DeliveryRateCreateManyWithoutFeeInput ;
}

export interface FeeCreateWithoutOrdersInput {
  id?: string ;
  name: string;
  price: PriceCreateOneWithoutFeeInput;
  deliveryRates?: DeliveryRateCreateManyWithoutFeeInput ;
  localDeliveryRates?: LocalDeliveryOptionsCreateManyWithoutFeeInput ;
}

export interface FeeCreateWithoutPriceInput {
  id?: string ;
  name: string;
  orders?: OrderCreateManyWithoutFeesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutFeeInput ;
  localDeliveryRates?: LocalDeliveryOptionsCreateManyWithoutFeeInput ;
}

export interface FeeScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  AND?: FeeScalarWhereInput[] ;
  OR?: FeeScalarWhereInput[] ;
  NOT?: FeeScalarWhereInput[] ;
}

export interface FeeUpdateManyDataInput {
  name?: string ;
}

export interface FeeUpdateManyWithWhereNestedInput {
  where: FeeScalarWhereInput;
  data: FeeUpdateManyDataInput;
}

export interface FeeUpdateManyWithoutOrdersInput {
  create?: FeeCreateWithoutOrdersInput[] ;
  connect?: FeeWhereUniqueInput[] ;
  set?: FeeWhereUniqueInput[] ;
  disconnect?: FeeWhereUniqueInput[] ;
  update?: FeeUpdateWithWhereUniqueWithoutOrdersInput[] ;
  upsert?: FeeUpsertWithWhereUniqueWithoutOrdersInput[] ;
  deleteMany?: FeeScalarWhereInput[] ;
  updateMany?: FeeUpdateManyWithWhereNestedInput[] ;
}

export interface FeeUpdateOneRequiredWithoutDeliveryRatesInput {
  create?: FeeCreateWithoutDeliveryRatesInput ;
  update?: FeeUpdateWithoutDeliveryRatesDataInput ;
  upsert?: FeeUpsertWithoutDeliveryRatesInput ;
  connect?: FeeWhereUniqueInput ;
}

export interface FeeUpdateOneRequiredWithoutLocalDeliveryRatesInput {
  create?: FeeCreateWithoutLocalDeliveryRatesInput ;
  update?: FeeUpdateWithoutLocalDeliveryRatesDataInput ;
  upsert?: FeeUpsertWithoutLocalDeliveryRatesInput ;
  connect?: FeeWhereUniqueInput ;
}

export interface FeeUpdateOneWithoutPriceInput {
  create?: FeeCreateWithoutPriceInput ;
  update?: FeeUpdateWithoutPriceDataInput ;
  upsert?: FeeUpsertWithoutPriceInput ;
  disconnect?: boolean ;
  connect?: FeeWhereUniqueInput ;
}

export interface FeeUpdateWithWhereUniqueWithoutOrdersInput {
  where: FeeWhereUniqueInput;
  data: FeeUpdateWithoutOrdersDataInput;
}

export interface FeeUpdateWithoutDeliveryRatesDataInput {
  name?: string ;
  orders?: OrderUpdateManyWithoutFeesInput ;
  price?: PriceUpdateOneRequiredWithoutFeeInput ;
  localDeliveryRates?: LocalDeliveryOptionsUpdateManyWithoutFeeInput ;
}

export interface FeeUpdateWithoutLocalDeliveryRatesDataInput {
  name?: string ;
  orders?: OrderUpdateManyWithoutFeesInput ;
  price?: PriceUpdateOneRequiredWithoutFeeInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutFeeInput ;
}

export interface FeeUpdateWithoutOrdersDataInput {
  name?: string ;
  price?: PriceUpdateOneRequiredWithoutFeeInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutFeeInput ;
  localDeliveryRates?: LocalDeliveryOptionsUpdateManyWithoutFeeInput ;
}

export interface FeeUpdateWithoutPriceDataInput {
  name?: string ;
  orders?: OrderUpdateManyWithoutFeesInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutFeeInput ;
  localDeliveryRates?: LocalDeliveryOptionsUpdateManyWithoutFeeInput ;
}

export interface FeeUpsertWithWhereUniqueWithoutOrdersInput {
  where: FeeWhereUniqueInput;
  update: FeeUpdateWithoutOrdersDataInput;
  create: FeeCreateWithoutOrdersInput;
}

export interface FeeUpsertWithoutDeliveryRatesInput {
  update: FeeUpdateWithoutDeliveryRatesDataInput;
  create: FeeCreateWithoutDeliveryRatesInput;
}

export interface FeeUpsertWithoutLocalDeliveryRatesInput {
  update: FeeUpdateWithoutLocalDeliveryRatesDataInput;
  create: FeeCreateWithoutLocalDeliveryRatesInput;
}

export interface FeeUpsertWithoutPriceInput {
  update: FeeUpdateWithoutPriceDataInput;
  create: FeeCreateWithoutPriceInput;
}

export interface FeeWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  orders_every?: OrderWhereInput ;
  orders_some?: OrderWhereInput ;
  orders_none?: OrderWhereInput ;
  price?: PriceWhereInput ;
  deliveryRates_every?: DeliveryRateWhereInput ;
  deliveryRates_some?: DeliveryRateWhereInput ;
  deliveryRates_none?: DeliveryRateWhereInput ;
  localDeliveryRates_every?: LocalDeliveryOptionsWhereInput ;
  localDeliveryRates_some?: LocalDeliveryOptionsWhereInput ;
  localDeliveryRates_none?: LocalDeliveryOptionsWhereInput ;
  AND?: FeeWhereInput[] ;
  OR?: FeeWhereInput[] ;
  NOT?: FeeWhereInput[] ;
}

export interface FeeWhereUniqueInput {
  id?: string ;
}

export interface FileCreateOneWithoutImagesInput {
  create?: FileCreateWithoutImagesInput ;
  connect?: FileWhereUniqueInput ;
}

export interface FileCreateWithoutImagesInput {
  contentType: string;
  id?: string ;
  name: string;
  secret: string;
  size: number;
  url: string;
}

export interface FileUpdateOneWithoutImagesInput {
  create?: FileCreateWithoutImagesInput ;
  update?: FileUpdateWithoutImagesDataInput ;
  upsert?: FileUpsertWithoutImagesInput ;
  disconnect?: boolean ;
  connect?: FileWhereUniqueInput ;
}

export interface FileUpdateWithoutImagesDataInput {
  contentType?: string ;
  name?: string ;
  secret?: string ;
  size?: number ;
  url?: string ;
}

export interface FileUpsertWithoutImagesInput {
  update: FileUpdateWithoutImagesDataInput;
  create: FileCreateWithoutImagesInput;
}

export interface FileWhereInput {
  contentType?: string ;
  contentType_not?: string ;
  contentType_in?: string[] ;
  contentType_not_in?: string[] ;
  contentType_lt?: string ;
  contentType_lte?: string ;
  contentType_gt?: string ;
  contentType_gte?: string ;
  contentType_contains?: string ;
  contentType_not_contains?: string ;
  contentType_starts_with?: string ;
  contentType_not_starts_with?: string ;
  contentType_ends_with?: string ;
  contentType_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  images_every?: ImageWhereInput ;
  images_some?: ImageWhereInput ;
  images_none?: ImageWhereInput ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  secret?: string ;
  secret_not?: string ;
  secret_in?: string[] ;
  secret_not_in?: string[] ;
  secret_lt?: string ;
  secret_lte?: string ;
  secret_gt?: string ;
  secret_gte?: string ;
  secret_contains?: string ;
  secret_not_contains?: string ;
  secret_starts_with?: string ;
  secret_not_starts_with?: string ;
  secret_ends_with?: string ;
  secret_not_ends_with?: string ;
  size?: number ;
  size_not?: number ;
  size_in?: number[] ;
  size_not_in?: number[] ;
  size_lt?: number ;
  size_lte?: number ;
  size_gt?: number ;
  size_gte?: number ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  url?: string ;
  url_not?: string ;
  url_in?: string[] ;
  url_not_in?: string[] ;
  url_lt?: string ;
  url_lte?: string ;
  url_gt?: string ;
  url_gte?: string ;
  url_contains?: string ;
  url_not_contains?: string ;
  url_starts_with?: string ;
  url_not_starts_with?: string ;
  url_ends_with?: string ;
  url_not_ends_with?: string ;
  AND?: FileWhereInput[] ;
  OR?: FileWhereInput[] ;
  NOT?: FileWhereInput[] ;
}

export interface FileWhereUniqueInput {
  id?: string ;
  secret?: string ;
  url?: string ;
}

export interface FloorPlanCreateInput {
  id?: string ;
  name: string;
  deleted?: boolean ;
  tables?: TableCreateManyWithoutFloorPlanInput ;
  company: CompanyCreateOneWithoutFloorPlansInput;
  venue: VenueCreateOneWithoutFloorPlansInput;
}

export interface FloorPlanCreateManyWithoutCompanyInput {
  create?: FloorPlanCreateWithoutCompanyInput[] ;
  connect?: FloorPlanWhereUniqueInput[] ;
}

export interface FloorPlanCreateManyWithoutVenueInput {
  create?: FloorPlanCreateWithoutVenueInput[] ;
  connect?: FloorPlanWhereUniqueInput[] ;
}

export interface FloorPlanCreateOneWithoutTablesInput {
  create?: FloorPlanCreateWithoutTablesInput ;
  connect?: FloorPlanWhereUniqueInput ;
}

export interface FloorPlanCreateWithoutCompanyInput {
  id?: string ;
  name: string;
  deleted?: boolean ;
  tables?: TableCreateManyWithoutFloorPlanInput ;
  venue: VenueCreateOneWithoutFloorPlansInput;
}

export interface FloorPlanCreateWithoutTablesInput {
  id?: string ;
  name: string;
  deleted?: boolean ;
  company: CompanyCreateOneWithoutFloorPlansInput;
  venue: VenueCreateOneWithoutFloorPlansInput;
}

export interface FloorPlanCreateWithoutVenueInput {
  id?: string ;
  name: string;
  deleted?: boolean ;
  tables?: TableCreateManyWithoutFloorPlanInput ;
  company: CompanyCreateOneWithoutFloorPlansInput;
}

export interface FloorPlanScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  AND?: FloorPlanScalarWhereInput[] ;
  OR?: FloorPlanScalarWhereInput[] ;
  NOT?: FloorPlanScalarWhereInput[] ;
}

export interface FloorPlanUpdateInput {
  name?: string ;
  deleted?: boolean ;
  tables?: TableUpdateManyWithoutFloorPlanInput ;
  company?: CompanyUpdateOneRequiredWithoutFloorPlansInput ;
  venue?: VenueUpdateOneRequiredWithoutFloorPlansInput ;
}

export interface FloorPlanUpdateManyDataInput {
  name?: string ;
  deleted?: boolean ;
}

export interface FloorPlanUpdateManyWithWhereNestedInput {
  where: FloorPlanScalarWhereInput;
  data: FloorPlanUpdateManyDataInput;
}

export interface FloorPlanUpdateManyWithoutCompanyInput {
  create?: FloorPlanCreateWithoutCompanyInput[] ;
  connect?: FloorPlanWhereUniqueInput[] ;
  set?: FloorPlanWhereUniqueInput[] ;
  disconnect?: FloorPlanWhereUniqueInput[] ;
  update?: FloorPlanUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: FloorPlanUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: FloorPlanScalarWhereInput[] ;
  updateMany?: FloorPlanUpdateManyWithWhereNestedInput[] ;
}

export interface FloorPlanUpdateManyWithoutVenueInput {
  create?: FloorPlanCreateWithoutVenueInput[] ;
  connect?: FloorPlanWhereUniqueInput[] ;
  set?: FloorPlanWhereUniqueInput[] ;
  disconnect?: FloorPlanWhereUniqueInput[] ;
  update?: FloorPlanUpdateWithWhereUniqueWithoutVenueInput[] ;
  upsert?: FloorPlanUpsertWithWhereUniqueWithoutVenueInput[] ;
  deleteMany?: FloorPlanScalarWhereInput[] ;
  updateMany?: FloorPlanUpdateManyWithWhereNestedInput[] ;
}

export interface FloorPlanUpdateOneWithoutTablesInput {
  create?: FloorPlanCreateWithoutTablesInput ;
  update?: FloorPlanUpdateWithoutTablesDataInput ;
  upsert?: FloorPlanUpsertWithoutTablesInput ;
  disconnect?: boolean ;
  connect?: FloorPlanWhereUniqueInput ;
}

export interface FloorPlanUpdateWithWhereUniqueWithoutCompanyInput {
  where: FloorPlanWhereUniqueInput;
  data: FloorPlanUpdateWithoutCompanyDataInput;
}

export interface FloorPlanUpdateWithWhereUniqueWithoutVenueInput {
  where: FloorPlanWhereUniqueInput;
  data: FloorPlanUpdateWithoutVenueDataInput;
}

export interface FloorPlanUpdateWithoutCompanyDataInput {
  name?: string ;
  deleted?: boolean ;
  tables?: TableUpdateManyWithoutFloorPlanInput ;
  venue?: VenueUpdateOneRequiredWithoutFloorPlansInput ;
}

export interface FloorPlanUpdateWithoutTablesDataInput {
  name?: string ;
  deleted?: boolean ;
  company?: CompanyUpdateOneRequiredWithoutFloorPlansInput ;
  venue?: VenueUpdateOneRequiredWithoutFloorPlansInput ;
}

export interface FloorPlanUpdateWithoutVenueDataInput {
  name?: string ;
  deleted?: boolean ;
  tables?: TableUpdateManyWithoutFloorPlanInput ;
  company?: CompanyUpdateOneRequiredWithoutFloorPlansInput ;
}

export interface FloorPlanUpsertWithWhereUniqueWithoutCompanyInput {
  where: FloorPlanWhereUniqueInput;
  update: FloorPlanUpdateWithoutCompanyDataInput;
  create: FloorPlanCreateWithoutCompanyInput;
}

export interface FloorPlanUpsertWithWhereUniqueWithoutVenueInput {
  where: FloorPlanWhereUniqueInput;
  update: FloorPlanUpdateWithoutVenueDataInput;
  create: FloorPlanCreateWithoutVenueInput;
}

export interface FloorPlanUpsertWithoutTablesInput {
  update: FloorPlanUpdateWithoutTablesDataInput;
  create: FloorPlanCreateWithoutTablesInput;
}

export interface FloorPlanWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  tables_every?: TableWhereInput ;
  tables_some?: TableWhereInput ;
  tables_none?: TableWhereInput ;
  company?: CompanyWhereInput ;
  venue?: VenueWhereInput ;
  AND?: FloorPlanWhereInput[] ;
  OR?: FloorPlanWhereInput[] ;
  NOT?: FloorPlanWhereInput[] ;
}

export interface FloorPlanWhereUniqueInput {
  id?: string ;
}

export interface GiftcardAnalyticsInput {
  from: any;
  to: any;
}

/**
 * Super admins only: Baemingo's OHIP credentials for a customer's chain, from
 * Oracle's Developer Portal. Checked by logging in before they are saved.
 */
export interface HotelOperaCredentialsInput {
  environmentId: string;
  companyId: string;
  gatewayUrl: string;
  clientId: string;
  clientSecret: string;
  scope: string;
  appKey?: string ;
}

export interface ImageCreateInput {
  company?: CompanyCreateOneWithoutImagesInput ;
  dEPRECATEDvenues?: VenueCreateManyWithoutImageInput ;
  file?: FileCreateOneWithoutImagesInput ;
  id?: string ;
  items?: ItemCreateManyWithoutImageInput ;
  offers?: OfferCreateManyWithoutImageInput ;
  content?: ContentCreateManyWithoutImageInput ;
  parents?: CategoryCreateManyWithoutImageInput ;
  variations?: VariationCreateManyWithoutImageInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutImageInput ;
  expressPageImages?: ExpressPageCreateManyWithoutImageInput ;
  expressPageIcons?: ExpressPageCreateManyWithoutIconInput ;
  membershipLevelImages?: MembershipLevelCreateManyWithoutImageInput ;
  title: string;
}

export interface ImageCreateManyWithoutCompanyInput {
  create?: ImageCreateWithoutCompanyInput[] ;
  connect?: ImageWhereUniqueInput[] ;
}

export interface ImageCreateOneWithoutContentInput {
  create?: ImageCreateWithoutContentInput ;
  connect?: ImageWhereUniqueInput ;
}

export interface ImageCreateOneWithoutDEPRECATEDvenuesInput {
  create?: ImageCreateWithoutDEPRECATEDvenuesInput ;
  connect?: ImageWhereUniqueInput ;
}

export interface ImageCreateOneWithoutExpressPageIconsInput {
  create?: ImageCreateWithoutExpressPageIconsInput ;
  connect?: ImageWhereUniqueInput ;
}

export interface ImageCreateOneWithoutExpressPageImagesInput {
  create?: ImageCreateWithoutExpressPageImagesInput ;
  connect?: ImageWhereUniqueInput ;
}

export interface ImageCreateOneWithoutItemsInput {
  create?: ImageCreateWithoutItemsInput ;
  connect?: ImageWhereUniqueInput ;
}

export interface ImageCreateOneWithoutMembershipLevelImagesInput {
  create?: ImageCreateWithoutMembershipLevelImagesInput ;
  connect?: ImageWhereUniqueInput ;
}

export interface ImageCreateOneWithoutOffersInput {
  create?: ImageCreateWithoutOffersInput ;
  connect?: ImageWhereUniqueInput ;
}

export interface ImageCreateOneWithoutParentsInput {
  create?: ImageCreateWithoutParentsInput ;
  connect?: ImageWhereUniqueInput ;
}

export interface ImageCreateOneWithoutReceiptTemplateInput {
  create?: ImageCreateWithoutReceiptTemplateInput ;
  connect?: ImageWhereUniqueInput ;
}

export interface ImageCreateOneWithoutVariationsInput {
  create?: ImageCreateWithoutVariationsInput ;
  connect?: ImageWhereUniqueInput ;
}

export interface ImageCreateWithoutCompanyInput {
  dEPRECATEDvenues?: VenueCreateManyWithoutImageInput ;
  file?: FileCreateOneWithoutImagesInput ;
  id?: string ;
  items?: ItemCreateManyWithoutImageInput ;
  offers?: OfferCreateManyWithoutImageInput ;
  content?: ContentCreateManyWithoutImageInput ;
  parents?: CategoryCreateManyWithoutImageInput ;
  variations?: VariationCreateManyWithoutImageInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutImageInput ;
  expressPageImages?: ExpressPageCreateManyWithoutImageInput ;
  expressPageIcons?: ExpressPageCreateManyWithoutIconInput ;
  membershipLevelImages?: MembershipLevelCreateManyWithoutImageInput ;
  title: string;
}

export interface ImageCreateWithoutContentInput {
  company?: CompanyCreateOneWithoutImagesInput ;
  dEPRECATEDvenues?: VenueCreateManyWithoutImageInput ;
  file?: FileCreateOneWithoutImagesInput ;
  id?: string ;
  items?: ItemCreateManyWithoutImageInput ;
  offers?: OfferCreateManyWithoutImageInput ;
  parents?: CategoryCreateManyWithoutImageInput ;
  variations?: VariationCreateManyWithoutImageInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutImageInput ;
  expressPageImages?: ExpressPageCreateManyWithoutImageInput ;
  expressPageIcons?: ExpressPageCreateManyWithoutIconInput ;
  membershipLevelImages?: MembershipLevelCreateManyWithoutImageInput ;
  title: string;
}

export interface ImageCreateWithoutDEPRECATEDvenuesInput {
  company?: CompanyCreateOneWithoutImagesInput ;
  file?: FileCreateOneWithoutImagesInput ;
  id?: string ;
  items?: ItemCreateManyWithoutImageInput ;
  offers?: OfferCreateManyWithoutImageInput ;
  content?: ContentCreateManyWithoutImageInput ;
  parents?: CategoryCreateManyWithoutImageInput ;
  variations?: VariationCreateManyWithoutImageInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutImageInput ;
  expressPageImages?: ExpressPageCreateManyWithoutImageInput ;
  expressPageIcons?: ExpressPageCreateManyWithoutIconInput ;
  membershipLevelImages?: MembershipLevelCreateManyWithoutImageInput ;
  title: string;
}

export interface ImageCreateWithoutExpressPageIconsInput {
  company?: CompanyCreateOneWithoutImagesInput ;
  dEPRECATEDvenues?: VenueCreateManyWithoutImageInput ;
  file?: FileCreateOneWithoutImagesInput ;
  id?: string ;
  items?: ItemCreateManyWithoutImageInput ;
  offers?: OfferCreateManyWithoutImageInput ;
  content?: ContentCreateManyWithoutImageInput ;
  parents?: CategoryCreateManyWithoutImageInput ;
  variations?: VariationCreateManyWithoutImageInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutImageInput ;
  expressPageImages?: ExpressPageCreateManyWithoutImageInput ;
  membershipLevelImages?: MembershipLevelCreateManyWithoutImageInput ;
  title: string;
}

export interface ImageCreateWithoutExpressPageImagesInput {
  company?: CompanyCreateOneWithoutImagesInput ;
  dEPRECATEDvenues?: VenueCreateManyWithoutImageInput ;
  file?: FileCreateOneWithoutImagesInput ;
  id?: string ;
  items?: ItemCreateManyWithoutImageInput ;
  offers?: OfferCreateManyWithoutImageInput ;
  content?: ContentCreateManyWithoutImageInput ;
  parents?: CategoryCreateManyWithoutImageInput ;
  variations?: VariationCreateManyWithoutImageInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutImageInput ;
  expressPageIcons?: ExpressPageCreateManyWithoutIconInput ;
  membershipLevelImages?: MembershipLevelCreateManyWithoutImageInput ;
  title: string;
}

export interface ImageCreateWithoutItemsInput {
  company?: CompanyCreateOneWithoutImagesInput ;
  dEPRECATEDvenues?: VenueCreateManyWithoutImageInput ;
  file?: FileCreateOneWithoutImagesInput ;
  id?: string ;
  offers?: OfferCreateManyWithoutImageInput ;
  content?: ContentCreateManyWithoutImageInput ;
  parents?: CategoryCreateManyWithoutImageInput ;
  variations?: VariationCreateManyWithoutImageInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutImageInput ;
  expressPageImages?: ExpressPageCreateManyWithoutImageInput ;
  expressPageIcons?: ExpressPageCreateManyWithoutIconInput ;
  membershipLevelImages?: MembershipLevelCreateManyWithoutImageInput ;
  title: string;
}

export interface ImageCreateWithoutMembershipLevelImagesInput {
  company?: CompanyCreateOneWithoutImagesInput ;
  dEPRECATEDvenues?: VenueCreateManyWithoutImageInput ;
  file?: FileCreateOneWithoutImagesInput ;
  id?: string ;
  items?: ItemCreateManyWithoutImageInput ;
  offers?: OfferCreateManyWithoutImageInput ;
  content?: ContentCreateManyWithoutImageInput ;
  parents?: CategoryCreateManyWithoutImageInput ;
  variations?: VariationCreateManyWithoutImageInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutImageInput ;
  expressPageImages?: ExpressPageCreateManyWithoutImageInput ;
  expressPageIcons?: ExpressPageCreateManyWithoutIconInput ;
  title: string;
}

export interface ImageCreateWithoutOffersInput {
  company?: CompanyCreateOneWithoutImagesInput ;
  dEPRECATEDvenues?: VenueCreateManyWithoutImageInput ;
  file?: FileCreateOneWithoutImagesInput ;
  id?: string ;
  items?: ItemCreateManyWithoutImageInput ;
  content?: ContentCreateManyWithoutImageInput ;
  parents?: CategoryCreateManyWithoutImageInput ;
  variations?: VariationCreateManyWithoutImageInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutImageInput ;
  expressPageImages?: ExpressPageCreateManyWithoutImageInput ;
  expressPageIcons?: ExpressPageCreateManyWithoutIconInput ;
  membershipLevelImages?: MembershipLevelCreateManyWithoutImageInput ;
  title: string;
}

export interface ImageCreateWithoutParentsInput {
  company?: CompanyCreateOneWithoutImagesInput ;
  dEPRECATEDvenues?: VenueCreateManyWithoutImageInput ;
  file?: FileCreateOneWithoutImagesInput ;
  id?: string ;
  items?: ItemCreateManyWithoutImageInput ;
  offers?: OfferCreateManyWithoutImageInput ;
  content?: ContentCreateManyWithoutImageInput ;
  variations?: VariationCreateManyWithoutImageInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutImageInput ;
  expressPageImages?: ExpressPageCreateManyWithoutImageInput ;
  expressPageIcons?: ExpressPageCreateManyWithoutIconInput ;
  membershipLevelImages?: MembershipLevelCreateManyWithoutImageInput ;
  title: string;
}

export interface ImageCreateWithoutReceiptTemplateInput {
  company?: CompanyCreateOneWithoutImagesInput ;
  dEPRECATEDvenues?: VenueCreateManyWithoutImageInput ;
  file?: FileCreateOneWithoutImagesInput ;
  id?: string ;
  items?: ItemCreateManyWithoutImageInput ;
  offers?: OfferCreateManyWithoutImageInput ;
  content?: ContentCreateManyWithoutImageInput ;
  parents?: CategoryCreateManyWithoutImageInput ;
  variations?: VariationCreateManyWithoutImageInput ;
  expressPageImages?: ExpressPageCreateManyWithoutImageInput ;
  expressPageIcons?: ExpressPageCreateManyWithoutIconInput ;
  membershipLevelImages?: MembershipLevelCreateManyWithoutImageInput ;
  title: string;
}

export interface ImageCreateWithoutVariationsInput {
  company?: CompanyCreateOneWithoutImagesInput ;
  dEPRECATEDvenues?: VenueCreateManyWithoutImageInput ;
  file?: FileCreateOneWithoutImagesInput ;
  id?: string ;
  items?: ItemCreateManyWithoutImageInput ;
  offers?: OfferCreateManyWithoutImageInput ;
  content?: ContentCreateManyWithoutImageInput ;
  parents?: CategoryCreateManyWithoutImageInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutImageInput ;
  expressPageImages?: ExpressPageCreateManyWithoutImageInput ;
  expressPageIcons?: ExpressPageCreateManyWithoutIconInput ;
  membershipLevelImages?: MembershipLevelCreateManyWithoutImageInput ;
  title: string;
}

export interface ImageScalarWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  title?: string ;
  title_not?: string ;
  title_in?: string[] ;
  title_not_in?: string[] ;
  title_lt?: string ;
  title_lte?: string ;
  title_gt?: string ;
  title_gte?: string ;
  title_contains?: string ;
  title_not_contains?: string ;
  title_starts_with?: string ;
  title_not_starts_with?: string ;
  title_ends_with?: string ;
  title_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  AND?: ImageScalarWhereInput[] ;
  OR?: ImageScalarWhereInput[] ;
  NOT?: ImageScalarWhereInput[] ;
}

export interface ImageUpdateManyDataInput {
  title?: string ;
}

export interface ImageUpdateManyWithWhereNestedInput {
  where: ImageScalarWhereInput;
  data: ImageUpdateManyDataInput;
}

export interface ImageUpdateManyWithoutCompanyInput {
  create?: ImageCreateWithoutCompanyInput[] ;
  connect?: ImageWhereUniqueInput[] ;
  set?: ImageWhereUniqueInput[] ;
  disconnect?: ImageWhereUniqueInput[] ;
  update?: ImageUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: ImageUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: ImageScalarWhereInput[] ;
  updateMany?: ImageUpdateManyWithWhereNestedInput[] ;
}

export interface ImageUpdateOneRequiredWithoutExpressPageIconsInput {
  create?: ImageCreateWithoutExpressPageIconsInput ;
  update?: ImageUpdateWithoutExpressPageIconsDataInput ;
  upsert?: ImageUpsertWithoutExpressPageIconsInput ;
  connect?: ImageWhereUniqueInput ;
}

export interface ImageUpdateOneWithoutContentInput {
  create?: ImageCreateWithoutContentInput ;
  update?: ImageUpdateWithoutContentDataInput ;
  upsert?: ImageUpsertWithoutContentInput ;
  disconnect?: boolean ;
  connect?: ImageWhereUniqueInput ;
}

export interface ImageUpdateOneWithoutDEPRECATEDvenuesInput {
  create?: ImageCreateWithoutDEPRECATEDvenuesInput ;
  update?: ImageUpdateWithoutDEPRECATEDvenuesDataInput ;
  upsert?: ImageUpsertWithoutDEPRECATEDvenuesInput ;
  disconnect?: boolean ;
  connect?: ImageWhereUniqueInput ;
}

export interface ImageUpdateOneWithoutExpressPageImagesInput {
  create?: ImageCreateWithoutExpressPageImagesInput ;
  update?: ImageUpdateWithoutExpressPageImagesDataInput ;
  upsert?: ImageUpsertWithoutExpressPageImagesInput ;
  disconnect?: boolean ;
  connect?: ImageWhereUniqueInput ;
}

export interface ImageUpdateOneWithoutItemsInput {
  create?: ImageCreateWithoutItemsInput ;
  update?: ImageUpdateWithoutItemsDataInput ;
  upsert?: ImageUpsertWithoutItemsInput ;
  disconnect?: boolean ;
  connect?: ImageWhereUniqueInput ;
}

export interface ImageUpdateOneWithoutMembershipLevelImagesInput {
  create?: ImageCreateWithoutMembershipLevelImagesInput ;
  update?: ImageUpdateWithoutMembershipLevelImagesDataInput ;
  upsert?: ImageUpsertWithoutMembershipLevelImagesInput ;
  disconnect?: boolean ;
  connect?: ImageWhereUniqueInput ;
}

export interface ImageUpdateOneWithoutOffersInput {
  create?: ImageCreateWithoutOffersInput ;
  update?: ImageUpdateWithoutOffersDataInput ;
  upsert?: ImageUpsertWithoutOffersInput ;
  disconnect?: boolean ;
  connect?: ImageWhereUniqueInput ;
}

export interface ImageUpdateOneWithoutParentsInput {
  create?: ImageCreateWithoutParentsInput ;
  update?: ImageUpdateWithoutParentsDataInput ;
  upsert?: ImageUpsertWithoutParentsInput ;
  disconnect?: boolean ;
  connect?: ImageWhereUniqueInput ;
}

export interface ImageUpdateOneWithoutReceiptTemplateInput {
  create?: ImageCreateWithoutReceiptTemplateInput ;
  update?: ImageUpdateWithoutReceiptTemplateDataInput ;
  upsert?: ImageUpsertWithoutReceiptTemplateInput ;
  disconnect?: boolean ;
  connect?: ImageWhereUniqueInput ;
}

export interface ImageUpdateOneWithoutVariationsInput {
  create?: ImageCreateWithoutVariationsInput ;
  update?: ImageUpdateWithoutVariationsDataInput ;
  upsert?: ImageUpsertWithoutVariationsInput ;
  disconnect?: boolean ;
  connect?: ImageWhereUniqueInput ;
}

export interface ImageUpdateWithWhereUniqueWithoutCompanyInput {
  where: ImageWhereUniqueInput;
  data: ImageUpdateWithoutCompanyDataInput;
}

export interface ImageUpdateWithoutCompanyDataInput {
  dEPRECATEDvenues?: VenueUpdateManyWithoutImageInput ;
  file?: FileUpdateOneWithoutImagesInput ;
  items?: ItemUpdateManyWithoutImageInput ;
  offers?: OfferUpdateManyWithoutImageInput ;
  content?: ContentUpdateManyWithoutImageInput ;
  parents?: CategoryUpdateManyWithoutImageInput ;
  variations?: VariationUpdateManyWithoutImageInput ;
  receiptTemplate?: ReceiptTemplateUpdateOneWithoutImageInput ;
  expressPageImages?: ExpressPageUpdateManyWithoutImageInput ;
  expressPageIcons?: ExpressPageUpdateManyWithoutIconInput ;
  membershipLevelImages?: MembershipLevelUpdateManyWithoutImageInput ;
  title?: string ;
}

export interface ImageUpdateWithoutContentDataInput {
  company?: CompanyUpdateOneWithoutImagesInput ;
  dEPRECATEDvenues?: VenueUpdateManyWithoutImageInput ;
  file?: FileUpdateOneWithoutImagesInput ;
  items?: ItemUpdateManyWithoutImageInput ;
  offers?: OfferUpdateManyWithoutImageInput ;
  parents?: CategoryUpdateManyWithoutImageInput ;
  variations?: VariationUpdateManyWithoutImageInput ;
  receiptTemplate?: ReceiptTemplateUpdateOneWithoutImageInput ;
  expressPageImages?: ExpressPageUpdateManyWithoutImageInput ;
  expressPageIcons?: ExpressPageUpdateManyWithoutIconInput ;
  membershipLevelImages?: MembershipLevelUpdateManyWithoutImageInput ;
  title?: string ;
}

export interface ImageUpdateWithoutDEPRECATEDvenuesDataInput {
  company?: CompanyUpdateOneWithoutImagesInput ;
  file?: FileUpdateOneWithoutImagesInput ;
  items?: ItemUpdateManyWithoutImageInput ;
  offers?: OfferUpdateManyWithoutImageInput ;
  content?: ContentUpdateManyWithoutImageInput ;
  parents?: CategoryUpdateManyWithoutImageInput ;
  variations?: VariationUpdateManyWithoutImageInput ;
  receiptTemplate?: ReceiptTemplateUpdateOneWithoutImageInput ;
  expressPageImages?: ExpressPageUpdateManyWithoutImageInput ;
  expressPageIcons?: ExpressPageUpdateManyWithoutIconInput ;
  membershipLevelImages?: MembershipLevelUpdateManyWithoutImageInput ;
  title?: string ;
}

export interface ImageUpdateWithoutExpressPageIconsDataInput {
  company?: CompanyUpdateOneWithoutImagesInput ;
  dEPRECATEDvenues?: VenueUpdateManyWithoutImageInput ;
  file?: FileUpdateOneWithoutImagesInput ;
  items?: ItemUpdateManyWithoutImageInput ;
  offers?: OfferUpdateManyWithoutImageInput ;
  content?: ContentUpdateManyWithoutImageInput ;
  parents?: CategoryUpdateManyWithoutImageInput ;
  variations?: VariationUpdateManyWithoutImageInput ;
  receiptTemplate?: ReceiptTemplateUpdateOneWithoutImageInput ;
  expressPageImages?: ExpressPageUpdateManyWithoutImageInput ;
  membershipLevelImages?: MembershipLevelUpdateManyWithoutImageInput ;
  title?: string ;
}

export interface ImageUpdateWithoutExpressPageImagesDataInput {
  company?: CompanyUpdateOneWithoutImagesInput ;
  dEPRECATEDvenues?: VenueUpdateManyWithoutImageInput ;
  file?: FileUpdateOneWithoutImagesInput ;
  items?: ItemUpdateManyWithoutImageInput ;
  offers?: OfferUpdateManyWithoutImageInput ;
  content?: ContentUpdateManyWithoutImageInput ;
  parents?: CategoryUpdateManyWithoutImageInput ;
  variations?: VariationUpdateManyWithoutImageInput ;
  receiptTemplate?: ReceiptTemplateUpdateOneWithoutImageInput ;
  expressPageIcons?: ExpressPageUpdateManyWithoutIconInput ;
  membershipLevelImages?: MembershipLevelUpdateManyWithoutImageInput ;
  title?: string ;
}

export interface ImageUpdateWithoutItemsDataInput {
  company?: CompanyUpdateOneWithoutImagesInput ;
  dEPRECATEDvenues?: VenueUpdateManyWithoutImageInput ;
  file?: FileUpdateOneWithoutImagesInput ;
  offers?: OfferUpdateManyWithoutImageInput ;
  content?: ContentUpdateManyWithoutImageInput ;
  parents?: CategoryUpdateManyWithoutImageInput ;
  variations?: VariationUpdateManyWithoutImageInput ;
  receiptTemplate?: ReceiptTemplateUpdateOneWithoutImageInput ;
  expressPageImages?: ExpressPageUpdateManyWithoutImageInput ;
  expressPageIcons?: ExpressPageUpdateManyWithoutIconInput ;
  membershipLevelImages?: MembershipLevelUpdateManyWithoutImageInput ;
  title?: string ;
}

export interface ImageUpdateWithoutMembershipLevelImagesDataInput {
  company?: CompanyUpdateOneWithoutImagesInput ;
  dEPRECATEDvenues?: VenueUpdateManyWithoutImageInput ;
  file?: FileUpdateOneWithoutImagesInput ;
  items?: ItemUpdateManyWithoutImageInput ;
  offers?: OfferUpdateManyWithoutImageInput ;
  content?: ContentUpdateManyWithoutImageInput ;
  parents?: CategoryUpdateManyWithoutImageInput ;
  variations?: VariationUpdateManyWithoutImageInput ;
  receiptTemplate?: ReceiptTemplateUpdateOneWithoutImageInput ;
  expressPageImages?: ExpressPageUpdateManyWithoutImageInput ;
  expressPageIcons?: ExpressPageUpdateManyWithoutIconInput ;
  title?: string ;
}

export interface ImageUpdateWithoutOffersDataInput {
  company?: CompanyUpdateOneWithoutImagesInput ;
  dEPRECATEDvenues?: VenueUpdateManyWithoutImageInput ;
  file?: FileUpdateOneWithoutImagesInput ;
  items?: ItemUpdateManyWithoutImageInput ;
  content?: ContentUpdateManyWithoutImageInput ;
  parents?: CategoryUpdateManyWithoutImageInput ;
  variations?: VariationUpdateManyWithoutImageInput ;
  receiptTemplate?: ReceiptTemplateUpdateOneWithoutImageInput ;
  expressPageImages?: ExpressPageUpdateManyWithoutImageInput ;
  expressPageIcons?: ExpressPageUpdateManyWithoutIconInput ;
  membershipLevelImages?: MembershipLevelUpdateManyWithoutImageInput ;
  title?: string ;
}

export interface ImageUpdateWithoutParentsDataInput {
  company?: CompanyUpdateOneWithoutImagesInput ;
  dEPRECATEDvenues?: VenueUpdateManyWithoutImageInput ;
  file?: FileUpdateOneWithoutImagesInput ;
  items?: ItemUpdateManyWithoutImageInput ;
  offers?: OfferUpdateManyWithoutImageInput ;
  content?: ContentUpdateManyWithoutImageInput ;
  variations?: VariationUpdateManyWithoutImageInput ;
  receiptTemplate?: ReceiptTemplateUpdateOneWithoutImageInput ;
  expressPageImages?: ExpressPageUpdateManyWithoutImageInput ;
  expressPageIcons?: ExpressPageUpdateManyWithoutIconInput ;
  membershipLevelImages?: MembershipLevelUpdateManyWithoutImageInput ;
  title?: string ;
}

export interface ImageUpdateWithoutReceiptTemplateDataInput {
  company?: CompanyUpdateOneWithoutImagesInput ;
  dEPRECATEDvenues?: VenueUpdateManyWithoutImageInput ;
  file?: FileUpdateOneWithoutImagesInput ;
  items?: ItemUpdateManyWithoutImageInput ;
  offers?: OfferUpdateManyWithoutImageInput ;
  content?: ContentUpdateManyWithoutImageInput ;
  parents?: CategoryUpdateManyWithoutImageInput ;
  variations?: VariationUpdateManyWithoutImageInput ;
  expressPageImages?: ExpressPageUpdateManyWithoutImageInput ;
  expressPageIcons?: ExpressPageUpdateManyWithoutIconInput ;
  membershipLevelImages?: MembershipLevelUpdateManyWithoutImageInput ;
  title?: string ;
}

export interface ImageUpdateWithoutVariationsDataInput {
  company?: CompanyUpdateOneWithoutImagesInput ;
  dEPRECATEDvenues?: VenueUpdateManyWithoutImageInput ;
  file?: FileUpdateOneWithoutImagesInput ;
  items?: ItemUpdateManyWithoutImageInput ;
  offers?: OfferUpdateManyWithoutImageInput ;
  content?: ContentUpdateManyWithoutImageInput ;
  parents?: CategoryUpdateManyWithoutImageInput ;
  receiptTemplate?: ReceiptTemplateUpdateOneWithoutImageInput ;
  expressPageImages?: ExpressPageUpdateManyWithoutImageInput ;
  expressPageIcons?: ExpressPageUpdateManyWithoutIconInput ;
  membershipLevelImages?: MembershipLevelUpdateManyWithoutImageInput ;
  title?: string ;
}

export interface ImageUpsertWithWhereUniqueWithoutCompanyInput {
  where: ImageWhereUniqueInput;
  update: ImageUpdateWithoutCompanyDataInput;
  create: ImageCreateWithoutCompanyInput;
}

export interface ImageUpsertWithoutContentInput {
  update: ImageUpdateWithoutContentDataInput;
  create: ImageCreateWithoutContentInput;
}

export interface ImageUpsertWithoutDEPRECATEDvenuesInput {
  update: ImageUpdateWithoutDEPRECATEDvenuesDataInput;
  create: ImageCreateWithoutDEPRECATEDvenuesInput;
}

export interface ImageUpsertWithoutExpressPageIconsInput {
  update: ImageUpdateWithoutExpressPageIconsDataInput;
  create: ImageCreateWithoutExpressPageIconsInput;
}

export interface ImageUpsertWithoutExpressPageImagesInput {
  update: ImageUpdateWithoutExpressPageImagesDataInput;
  create: ImageCreateWithoutExpressPageImagesInput;
}

export interface ImageUpsertWithoutItemsInput {
  update: ImageUpdateWithoutItemsDataInput;
  create: ImageCreateWithoutItemsInput;
}

export interface ImageUpsertWithoutMembershipLevelImagesInput {
  update: ImageUpdateWithoutMembershipLevelImagesDataInput;
  create: ImageCreateWithoutMembershipLevelImagesInput;
}

export interface ImageUpsertWithoutOffersInput {
  update: ImageUpdateWithoutOffersDataInput;
  create: ImageCreateWithoutOffersInput;
}

export interface ImageUpsertWithoutParentsInput {
  update: ImageUpdateWithoutParentsDataInput;
  create: ImageCreateWithoutParentsInput;
}

export interface ImageUpsertWithoutReceiptTemplateInput {
  update: ImageUpdateWithoutReceiptTemplateDataInput;
  create: ImageCreateWithoutReceiptTemplateInput;
}

export interface ImageUpsertWithoutVariationsInput {
  update: ImageUpdateWithoutVariationsDataInput;
  create: ImageCreateWithoutVariationsInput;
}

export interface ImageWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  company?: CompanyWhereInput ;
  dEPRECATEDvenues_every?: VenueWhereInput ;
  dEPRECATEDvenues_some?: VenueWhereInput ;
  dEPRECATEDvenues_none?: VenueWhereInput ;
  file?: FileWhereInput ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  items_every?: ItemWhereInput ;
  items_some?: ItemWhereInput ;
  items_none?: ItemWhereInput ;
  offers_every?: OfferWhereInput ;
  offers_some?: OfferWhereInput ;
  offers_none?: OfferWhereInput ;
  content_every?: ContentWhereInput ;
  content_some?: ContentWhereInput ;
  content_none?: ContentWhereInput ;
  parents_every?: CategoryWhereInput ;
  parents_some?: CategoryWhereInput ;
  parents_none?: CategoryWhereInput ;
  variations_every?: VariationWhereInput ;
  variations_some?: VariationWhereInput ;
  variations_none?: VariationWhereInput ;
  receiptTemplate?: ReceiptTemplateWhereInput ;
  expressPageImages_every?: ExpressPageWhereInput ;
  expressPageImages_some?: ExpressPageWhereInput ;
  expressPageImages_none?: ExpressPageWhereInput ;
  expressPageIcons_every?: ExpressPageWhereInput ;
  expressPageIcons_some?: ExpressPageWhereInput ;
  expressPageIcons_none?: ExpressPageWhereInput ;
  membershipLevelImages_every?: MembershipLevelWhereInput ;
  membershipLevelImages_some?: MembershipLevelWhereInput ;
  membershipLevelImages_none?: MembershipLevelWhereInput ;
  title?: string ;
  title_not?: string ;
  title_in?: string[] ;
  title_not_in?: string[] ;
  title_lt?: string ;
  title_lte?: string ;
  title_gt?: string ;
  title_gte?: string ;
  title_contains?: string ;
  title_not_contains?: string ;
  title_starts_with?: string ;
  title_not_starts_with?: string ;
  title_ends_with?: string ;
  title_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  AND?: ImageWhereInput[] ;
  OR?: ImageWhereInput[] ;
  NOT?: ImageWhereInput[] ;
}

export interface ImageWhereUniqueInput {
  id?: string ;
}

export interface ImportInventorySupplyData {
  day: number;
  hours: number;
  minutes: number;
  itemId: string;
  amount: number;
}

export interface IngredientInput {
  name: string;
  quantity: number;
}

export interface IntegrationCreateManyWithoutCompanyInput {
  create?: IntegrationCreateWithoutCompanyInput[] ;
  connect?: IntegrationWhereUniqueInput[] ;
}

export interface IntegrationCreateWithoutCompanyInput {
  id?: string ;
  type: string;
  provider: string;
  isActive: boolean;
  activatedFeatures?: IntegrationCreateactivatedFeaturesInput ;
  keyStore?: KeyValueCreateManyWithoutIntegrationInput ;
  internalKeyStore?: InternalKeyValueCreateManyWithoutIntegrationInput ;
}

export interface IntegrationCreateactivatedFeaturesInput {
  set?: string[] ;
}

export interface IntegrationScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  type?: string ;
  type_not?: string ;
  type_in?: string[] ;
  type_not_in?: string[] ;
  type_lt?: string ;
  type_lte?: string ;
  type_gt?: string ;
  type_gte?: string ;
  type_contains?: string ;
  type_not_contains?: string ;
  type_starts_with?: string ;
  type_not_starts_with?: string ;
  type_ends_with?: string ;
  type_not_ends_with?: string ;
  provider?: string ;
  provider_not?: string ;
  provider_in?: string[] ;
  provider_not_in?: string[] ;
  provider_lt?: string ;
  provider_lte?: string ;
  provider_gt?: string ;
  provider_gte?: string ;
  provider_contains?: string ;
  provider_not_contains?: string ;
  provider_starts_with?: string ;
  provider_not_starts_with?: string ;
  provider_ends_with?: string ;
  provider_not_ends_with?: string ;
  isActive?: boolean ;
  isActive_not?: boolean ;
  AND?: IntegrationScalarWhereInput[] ;
  OR?: IntegrationScalarWhereInput[] ;
  NOT?: IntegrationScalarWhereInput[] ;
}

export interface IntegrationUpdateManyDataInput {
  type?: string ;
  provider?: string ;
  isActive?: boolean ;
  activatedFeatures?: IntegrationUpdateactivatedFeaturesInput ;
}

export interface IntegrationUpdateManyWithWhereNestedInput {
  where: IntegrationScalarWhereInput;
  data: IntegrationUpdateManyDataInput;
}

export interface IntegrationUpdateManyWithoutCompanyInput {
  create?: IntegrationCreateWithoutCompanyInput[] ;
  connect?: IntegrationWhereUniqueInput[] ;
  set?: IntegrationWhereUniqueInput[] ;
  disconnect?: IntegrationWhereUniqueInput[] ;
  update?: IntegrationUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: IntegrationUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: IntegrationScalarWhereInput[] ;
  updateMany?: IntegrationUpdateManyWithWhereNestedInput[] ;
}

export interface IntegrationUpdateWithWhereUniqueWithoutCompanyInput {
  where: IntegrationWhereUniqueInput;
  data: IntegrationUpdateWithoutCompanyDataInput;
}

export interface IntegrationUpdateWithoutCompanyDataInput {
  type?: string ;
  provider?: string ;
  isActive?: boolean ;
  activatedFeatures?: IntegrationUpdateactivatedFeaturesInput ;
  keyStore?: KeyValueUpdateManyWithoutIntegrationInput ;
  internalKeyStore?: InternalKeyValueUpdateManyWithoutIntegrationInput ;
}

export interface IntegrationUpdateactivatedFeaturesInput {
  set?: string[] ;
}

export interface IntegrationUpsertWithWhereUniqueWithoutCompanyInput {
  where: IntegrationWhereUniqueInput;
  update: IntegrationUpdateWithoutCompanyDataInput;
  create: IntegrationCreateWithoutCompanyInput;
}

export interface IntegrationWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  company?: CompanyWhereInput ;
  type?: string ;
  type_not?: string ;
  type_in?: string[] ;
  type_not_in?: string[] ;
  type_lt?: string ;
  type_lte?: string ;
  type_gt?: string ;
  type_gte?: string ;
  type_contains?: string ;
  type_not_contains?: string ;
  type_starts_with?: string ;
  type_not_starts_with?: string ;
  type_ends_with?: string ;
  type_not_ends_with?: string ;
  provider?: string ;
  provider_not?: string ;
  provider_in?: string[] ;
  provider_not_in?: string[] ;
  provider_lt?: string ;
  provider_lte?: string ;
  provider_gt?: string ;
  provider_gte?: string ;
  provider_contains?: string ;
  provider_not_contains?: string ;
  provider_starts_with?: string ;
  provider_not_starts_with?: string ;
  provider_ends_with?: string ;
  provider_not_ends_with?: string ;
  isActive?: boolean ;
  isActive_not?: boolean ;
  keyStore_every?: KeyValueWhereInput ;
  keyStore_some?: KeyValueWhereInput ;
  keyStore_none?: KeyValueWhereInput ;
  internalKeyStore_every?: InternalKeyValueWhereInput ;
  internalKeyStore_some?: InternalKeyValueWhereInput ;
  internalKeyStore_none?: InternalKeyValueWhereInput ;
  AND?: IntegrationWhereInput[] ;
  OR?: IntegrationWhereInput[] ;
  NOT?: IntegrationWhereInput[] ;
}

export interface IntegrationWhereUniqueInput {
  id?: string ;
}

export interface InternalKeyValueCreateManyWithoutIntegrationInput {
  create?: InternalKeyValueCreateWithoutIntegrationInput[] ;
  connect?: InternalKeyValueWhereUniqueInput[] ;
}

export interface InternalKeyValueCreateWithoutIntegrationInput {
  id?: string ;
  key: string;
  value: string;
}

export interface InternalKeyValueScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  key?: string ;
  key_not?: string ;
  key_in?: string[] ;
  key_not_in?: string[] ;
  key_lt?: string ;
  key_lte?: string ;
  key_gt?: string ;
  key_gte?: string ;
  key_contains?: string ;
  key_not_contains?: string ;
  key_starts_with?: string ;
  key_not_starts_with?: string ;
  key_ends_with?: string ;
  key_not_ends_with?: string ;
  value?: string ;
  value_not?: string ;
  value_in?: string[] ;
  value_not_in?: string[] ;
  value_lt?: string ;
  value_lte?: string ;
  value_gt?: string ;
  value_gte?: string ;
  value_contains?: string ;
  value_not_contains?: string ;
  value_starts_with?: string ;
  value_not_starts_with?: string ;
  value_ends_with?: string ;
  value_not_ends_with?: string ;
  AND?: InternalKeyValueScalarWhereInput[] ;
  OR?: InternalKeyValueScalarWhereInput[] ;
  NOT?: InternalKeyValueScalarWhereInput[] ;
}

export interface InternalKeyValueUpdateManyDataInput {
  key?: string ;
  value?: string ;
}

export interface InternalKeyValueUpdateManyWithWhereNestedInput {
  where: InternalKeyValueScalarWhereInput;
  data: InternalKeyValueUpdateManyDataInput;
}

export interface InternalKeyValueUpdateManyWithoutIntegrationInput {
  create?: InternalKeyValueCreateWithoutIntegrationInput[] ;
  connect?: InternalKeyValueWhereUniqueInput[] ;
  set?: InternalKeyValueWhereUniqueInput[] ;
  disconnect?: InternalKeyValueWhereUniqueInput[] ;
  update?: InternalKeyValueUpdateWithWhereUniqueWithoutIntegrationInput[] ;
  upsert?: InternalKeyValueUpsertWithWhereUniqueWithoutIntegrationInput[] ;
  deleteMany?: InternalKeyValueScalarWhereInput[] ;
  updateMany?: InternalKeyValueUpdateManyWithWhereNestedInput[] ;
}

export interface InternalKeyValueUpdateWithWhereUniqueWithoutIntegrationInput {
  where: InternalKeyValueWhereUniqueInput;
  data: InternalKeyValueUpdateWithoutIntegrationDataInput;
}

export interface InternalKeyValueUpdateWithoutIntegrationDataInput {
  key?: string ;
  value?: string ;
}

export interface InternalKeyValueUpsertWithWhereUniqueWithoutIntegrationInput {
  where: InternalKeyValueWhereUniqueInput;
  update: InternalKeyValueUpdateWithoutIntegrationDataInput;
  create: InternalKeyValueCreateWithoutIntegrationInput;
}

export interface InternalKeyValueWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  integration?: IntegrationWhereInput ;
  key?: string ;
  key_not?: string ;
  key_in?: string[] ;
  key_not_in?: string[] ;
  key_lt?: string ;
  key_lte?: string ;
  key_gt?: string ;
  key_gte?: string ;
  key_contains?: string ;
  key_not_contains?: string ;
  key_starts_with?: string ;
  key_not_starts_with?: string ;
  key_ends_with?: string ;
  key_not_ends_with?: string ;
  value?: string ;
  value_not?: string ;
  value_in?: string[] ;
  value_not_in?: string[] ;
  value_lt?: string ;
  value_lte?: string ;
  value_gt?: string ;
  value_gte?: string ;
  value_contains?: string ;
  value_not_contains?: string ;
  value_starts_with?: string ;
  value_not_starts_with?: string ;
  value_ends_with?: string ;
  value_not_ends_with?: string ;
  AND?: InternalKeyValueWhereInput[] ;
  OR?: InternalKeyValueWhereInput[] ;
  NOT?: InternalKeyValueWhereInput[] ;
}

export interface InternalKeyValueWhereUniqueInput {
  id?: string ;
}

export interface InvoiceTargetCreateManyWithoutCompanyInput {
  create?: InvoiceTargetCreateWithoutCompanyInput[] ;
  connect?: InvoiceTargetWhereUniqueInput[] ;
}

export interface InvoiceTargetCreateManyWithoutVenueInput {
  create?: InvoiceTargetCreateWithoutVenueInput[] ;
  connect?: InvoiceTargetWhereUniqueInput[] ;
}

export interface InvoiceTargetCreateOneWithoutOrdersInput {
  create?: InvoiceTargetCreateWithoutOrdersInput ;
  connect?: InvoiceTargetWhereUniqueInput ;
}

export interface InvoiceTargetCreateWithoutCompanyInput {
  id?: string ;
  lastSeenActive?: any ;
  name: string;
  type: InvoiceTargetType;
  companyName?: string ;
  orgNumber?: string ;
  email?: string ;
  phone?: string ;
  address1?: string ;
  address2?: string ;
  city?: string ;
  zip?: string ;
  country?: string ;
  venue?: VenueCreateOneWithoutInvoiceTargetsInput ;
  orders?: OrderCreateManyWithoutInvoiceTargetInput ;
}

export interface InvoiceTargetCreateWithoutOrdersInput {
  id?: string ;
  lastSeenActive?: any ;
  name: string;
  type: InvoiceTargetType;
  companyName?: string ;
  orgNumber?: string ;
  email?: string ;
  phone?: string ;
  address1?: string ;
  address2?: string ;
  city?: string ;
  zip?: string ;
  country?: string ;
  company: CompanyCreateOneWithoutInvoiceTargetsInput;
  venue?: VenueCreateOneWithoutInvoiceTargetsInput ;
}

export interface InvoiceTargetCreateWithoutVenueInput {
  id?: string ;
  lastSeenActive?: any ;
  name: string;
  type: InvoiceTargetType;
  companyName?: string ;
  orgNumber?: string ;
  email?: string ;
  phone?: string ;
  address1?: string ;
  address2?: string ;
  city?: string ;
  zip?: string ;
  country?: string ;
  company: CompanyCreateOneWithoutInvoiceTargetsInput;
  orders?: OrderCreateManyWithoutInvoiceTargetInput ;
}

export interface InvoiceTargetScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  lastSeenActive?: any ;
  lastSeenActive_not?: any ;
  lastSeenActive_in?: any[] ;
  lastSeenActive_not_in?: any[] ;
  lastSeenActive_lt?: any ;
  lastSeenActive_lte?: any ;
  lastSeenActive_gt?: any ;
  lastSeenActive_gte?: any ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  type?: InvoiceTargetType ;
  type_not?: InvoiceTargetType ;
  type_in?: InvoiceTargetType[] ;
  type_not_in?: InvoiceTargetType[] ;
  companyName?: string ;
  companyName_not?: string ;
  companyName_in?: string[] ;
  companyName_not_in?: string[] ;
  companyName_lt?: string ;
  companyName_lte?: string ;
  companyName_gt?: string ;
  companyName_gte?: string ;
  companyName_contains?: string ;
  companyName_not_contains?: string ;
  companyName_starts_with?: string ;
  companyName_not_starts_with?: string ;
  companyName_ends_with?: string ;
  companyName_not_ends_with?: string ;
  orgNumber?: string ;
  orgNumber_not?: string ;
  orgNumber_in?: string[] ;
  orgNumber_not_in?: string[] ;
  orgNumber_lt?: string ;
  orgNumber_lte?: string ;
  orgNumber_gt?: string ;
  orgNumber_gte?: string ;
  orgNumber_contains?: string ;
  orgNumber_not_contains?: string ;
  orgNumber_starts_with?: string ;
  orgNumber_not_starts_with?: string ;
  orgNumber_ends_with?: string ;
  orgNumber_not_ends_with?: string ;
  email?: string ;
  email_not?: string ;
  email_in?: string[] ;
  email_not_in?: string[] ;
  email_lt?: string ;
  email_lte?: string ;
  email_gt?: string ;
  email_gte?: string ;
  email_contains?: string ;
  email_not_contains?: string ;
  email_starts_with?: string ;
  email_not_starts_with?: string ;
  email_ends_with?: string ;
  email_not_ends_with?: string ;
  phone?: string ;
  phone_not?: string ;
  phone_in?: string[] ;
  phone_not_in?: string[] ;
  phone_lt?: string ;
  phone_lte?: string ;
  phone_gt?: string ;
  phone_gte?: string ;
  phone_contains?: string ;
  phone_not_contains?: string ;
  phone_starts_with?: string ;
  phone_not_starts_with?: string ;
  phone_ends_with?: string ;
  phone_not_ends_with?: string ;
  address1?: string ;
  address1_not?: string ;
  address1_in?: string[] ;
  address1_not_in?: string[] ;
  address1_lt?: string ;
  address1_lte?: string ;
  address1_gt?: string ;
  address1_gte?: string ;
  address1_contains?: string ;
  address1_not_contains?: string ;
  address1_starts_with?: string ;
  address1_not_starts_with?: string ;
  address1_ends_with?: string ;
  address1_not_ends_with?: string ;
  address2?: string ;
  address2_not?: string ;
  address2_in?: string[] ;
  address2_not_in?: string[] ;
  address2_lt?: string ;
  address2_lte?: string ;
  address2_gt?: string ;
  address2_gte?: string ;
  address2_contains?: string ;
  address2_not_contains?: string ;
  address2_starts_with?: string ;
  address2_not_starts_with?: string ;
  address2_ends_with?: string ;
  address2_not_ends_with?: string ;
  city?: string ;
  city_not?: string ;
  city_in?: string[] ;
  city_not_in?: string[] ;
  city_lt?: string ;
  city_lte?: string ;
  city_gt?: string ;
  city_gte?: string ;
  city_contains?: string ;
  city_not_contains?: string ;
  city_starts_with?: string ;
  city_not_starts_with?: string ;
  city_ends_with?: string ;
  city_not_ends_with?: string ;
  zip?: string ;
  zip_not?: string ;
  zip_in?: string[] ;
  zip_not_in?: string[] ;
  zip_lt?: string ;
  zip_lte?: string ;
  zip_gt?: string ;
  zip_gte?: string ;
  zip_contains?: string ;
  zip_not_contains?: string ;
  zip_starts_with?: string ;
  zip_not_starts_with?: string ;
  zip_ends_with?: string ;
  zip_not_ends_with?: string ;
  country?: string ;
  country_not?: string ;
  country_in?: string[] ;
  country_not_in?: string[] ;
  country_lt?: string ;
  country_lte?: string ;
  country_gt?: string ;
  country_gte?: string ;
  country_contains?: string ;
  country_not_contains?: string ;
  country_starts_with?: string ;
  country_not_starts_with?: string ;
  country_ends_with?: string ;
  country_not_ends_with?: string ;
  AND?: InvoiceTargetScalarWhereInput[] ;
  OR?: InvoiceTargetScalarWhereInput[] ;
  NOT?: InvoiceTargetScalarWhereInput[] ;
}

export interface InvoiceTargetUpdateManyDataInput {
  lastSeenActive?: any ;
  name?: string ;
  type?: InvoiceTargetType ;
  companyName?: string ;
  orgNumber?: string ;
  email?: string ;
  phone?: string ;
  address1?: string ;
  address2?: string ;
  city?: string ;
  zip?: string ;
  country?: string ;
}

export interface InvoiceTargetUpdateManyWithWhereNestedInput {
  where: InvoiceTargetScalarWhereInput;
  data: InvoiceTargetUpdateManyDataInput;
}

export interface InvoiceTargetUpdateManyWithoutCompanyInput {
  create?: InvoiceTargetCreateWithoutCompanyInput[] ;
  connect?: InvoiceTargetWhereUniqueInput[] ;
  set?: InvoiceTargetWhereUniqueInput[] ;
  disconnect?: InvoiceTargetWhereUniqueInput[] ;
  update?: InvoiceTargetUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: InvoiceTargetUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: InvoiceTargetScalarWhereInput[] ;
  updateMany?: InvoiceTargetUpdateManyWithWhereNestedInput[] ;
}

export interface InvoiceTargetUpdateManyWithoutVenueInput {
  create?: InvoiceTargetCreateWithoutVenueInput[] ;
  connect?: InvoiceTargetWhereUniqueInput[] ;
  set?: InvoiceTargetWhereUniqueInput[] ;
  disconnect?: InvoiceTargetWhereUniqueInput[] ;
  update?: InvoiceTargetUpdateWithWhereUniqueWithoutVenueInput[] ;
  upsert?: InvoiceTargetUpsertWithWhereUniqueWithoutVenueInput[] ;
  deleteMany?: InvoiceTargetScalarWhereInput[] ;
  updateMany?: InvoiceTargetUpdateManyWithWhereNestedInput[] ;
}

export interface InvoiceTargetUpdateOneWithoutOrdersInput {
  create?: InvoiceTargetCreateWithoutOrdersInput ;
  update?: InvoiceTargetUpdateWithoutOrdersDataInput ;
  upsert?: InvoiceTargetUpsertWithoutOrdersInput ;
  disconnect?: boolean ;
  connect?: InvoiceTargetWhereUniqueInput ;
}

export interface InvoiceTargetUpdateWithWhereUniqueWithoutCompanyInput {
  where: InvoiceTargetWhereUniqueInput;
  data: InvoiceTargetUpdateWithoutCompanyDataInput;
}

export interface InvoiceTargetUpdateWithWhereUniqueWithoutVenueInput {
  where: InvoiceTargetWhereUniqueInput;
  data: InvoiceTargetUpdateWithoutVenueDataInput;
}

export interface InvoiceTargetUpdateWithoutCompanyDataInput {
  lastSeenActive?: any ;
  name?: string ;
  type?: InvoiceTargetType ;
  companyName?: string ;
  orgNumber?: string ;
  email?: string ;
  phone?: string ;
  address1?: string ;
  address2?: string ;
  city?: string ;
  zip?: string ;
  country?: string ;
  venue?: VenueUpdateOneWithoutInvoiceTargetsInput ;
  orders?: OrderUpdateManyWithoutInvoiceTargetInput ;
}

export interface InvoiceTargetUpdateWithoutOrdersDataInput {
  lastSeenActive?: any ;
  name?: string ;
  type?: InvoiceTargetType ;
  companyName?: string ;
  orgNumber?: string ;
  email?: string ;
  phone?: string ;
  address1?: string ;
  address2?: string ;
  city?: string ;
  zip?: string ;
  country?: string ;
  company?: CompanyUpdateOneRequiredWithoutInvoiceTargetsInput ;
  venue?: VenueUpdateOneWithoutInvoiceTargetsInput ;
}

export interface InvoiceTargetUpdateWithoutVenueDataInput {
  lastSeenActive?: any ;
  name?: string ;
  type?: InvoiceTargetType ;
  companyName?: string ;
  orgNumber?: string ;
  email?: string ;
  phone?: string ;
  address1?: string ;
  address2?: string ;
  city?: string ;
  zip?: string ;
  country?: string ;
  company?: CompanyUpdateOneRequiredWithoutInvoiceTargetsInput ;
  orders?: OrderUpdateManyWithoutInvoiceTargetInput ;
}

export interface InvoiceTargetUpsertWithWhereUniqueWithoutCompanyInput {
  where: InvoiceTargetWhereUniqueInput;
  update: InvoiceTargetUpdateWithoutCompanyDataInput;
  create: InvoiceTargetCreateWithoutCompanyInput;
}

export interface InvoiceTargetUpsertWithWhereUniqueWithoutVenueInput {
  where: InvoiceTargetWhereUniqueInput;
  update: InvoiceTargetUpdateWithoutVenueDataInput;
  create: InvoiceTargetCreateWithoutVenueInput;
}

export interface InvoiceTargetUpsertWithoutOrdersInput {
  update: InvoiceTargetUpdateWithoutOrdersDataInput;
  create: InvoiceTargetCreateWithoutOrdersInput;
}

export interface InvoiceTargetWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  lastSeenActive?: any ;
  lastSeenActive_not?: any ;
  lastSeenActive_in?: any[] ;
  lastSeenActive_not_in?: any[] ;
  lastSeenActive_lt?: any ;
  lastSeenActive_lte?: any ;
  lastSeenActive_gt?: any ;
  lastSeenActive_gte?: any ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  type?: InvoiceTargetType ;
  type_not?: InvoiceTargetType ;
  type_in?: InvoiceTargetType[] ;
  type_not_in?: InvoiceTargetType[] ;
  companyName?: string ;
  companyName_not?: string ;
  companyName_in?: string[] ;
  companyName_not_in?: string[] ;
  companyName_lt?: string ;
  companyName_lte?: string ;
  companyName_gt?: string ;
  companyName_gte?: string ;
  companyName_contains?: string ;
  companyName_not_contains?: string ;
  companyName_starts_with?: string ;
  companyName_not_starts_with?: string ;
  companyName_ends_with?: string ;
  companyName_not_ends_with?: string ;
  orgNumber?: string ;
  orgNumber_not?: string ;
  orgNumber_in?: string[] ;
  orgNumber_not_in?: string[] ;
  orgNumber_lt?: string ;
  orgNumber_lte?: string ;
  orgNumber_gt?: string ;
  orgNumber_gte?: string ;
  orgNumber_contains?: string ;
  orgNumber_not_contains?: string ;
  orgNumber_starts_with?: string ;
  orgNumber_not_starts_with?: string ;
  orgNumber_ends_with?: string ;
  orgNumber_not_ends_with?: string ;
  email?: string ;
  email_not?: string ;
  email_in?: string[] ;
  email_not_in?: string[] ;
  email_lt?: string ;
  email_lte?: string ;
  email_gt?: string ;
  email_gte?: string ;
  email_contains?: string ;
  email_not_contains?: string ;
  email_starts_with?: string ;
  email_not_starts_with?: string ;
  email_ends_with?: string ;
  email_not_ends_with?: string ;
  phone?: string ;
  phone_not?: string ;
  phone_in?: string[] ;
  phone_not_in?: string[] ;
  phone_lt?: string ;
  phone_lte?: string ;
  phone_gt?: string ;
  phone_gte?: string ;
  phone_contains?: string ;
  phone_not_contains?: string ;
  phone_starts_with?: string ;
  phone_not_starts_with?: string ;
  phone_ends_with?: string ;
  phone_not_ends_with?: string ;
  address1?: string ;
  address1_not?: string ;
  address1_in?: string[] ;
  address1_not_in?: string[] ;
  address1_lt?: string ;
  address1_lte?: string ;
  address1_gt?: string ;
  address1_gte?: string ;
  address1_contains?: string ;
  address1_not_contains?: string ;
  address1_starts_with?: string ;
  address1_not_starts_with?: string ;
  address1_ends_with?: string ;
  address1_not_ends_with?: string ;
  address2?: string ;
  address2_not?: string ;
  address2_in?: string[] ;
  address2_not_in?: string[] ;
  address2_lt?: string ;
  address2_lte?: string ;
  address2_gt?: string ;
  address2_gte?: string ;
  address2_contains?: string ;
  address2_not_contains?: string ;
  address2_starts_with?: string ;
  address2_not_starts_with?: string ;
  address2_ends_with?: string ;
  address2_not_ends_with?: string ;
  city?: string ;
  city_not?: string ;
  city_in?: string[] ;
  city_not_in?: string[] ;
  city_lt?: string ;
  city_lte?: string ;
  city_gt?: string ;
  city_gte?: string ;
  city_contains?: string ;
  city_not_contains?: string ;
  city_starts_with?: string ;
  city_not_starts_with?: string ;
  city_ends_with?: string ;
  city_not_ends_with?: string ;
  zip?: string ;
  zip_not?: string ;
  zip_in?: string[] ;
  zip_not_in?: string[] ;
  zip_lt?: string ;
  zip_lte?: string ;
  zip_gt?: string ;
  zip_gte?: string ;
  zip_contains?: string ;
  zip_not_contains?: string ;
  zip_starts_with?: string ;
  zip_not_starts_with?: string ;
  zip_ends_with?: string ;
  zip_not_ends_with?: string ;
  country?: string ;
  country_not?: string ;
  country_in?: string[] ;
  country_not_in?: string[] ;
  country_lt?: string ;
  country_lte?: string ;
  country_gt?: string ;
  country_gte?: string ;
  country_contains?: string ;
  country_not_contains?: string ;
  country_starts_with?: string ;
  country_not_starts_with?: string ;
  country_ends_with?: string ;
  country_not_ends_with?: string ;
  company?: CompanyWhereInput ;
  venue?: VenueWhereInput ;
  orders_every?: OrderWhereInput ;
  orders_some?: OrderWhereInput ;
  orders_none?: OrderWhereInput ;
  AND?: InvoiceTargetWhereInput[] ;
  OR?: InvoiceTargetWhereInput[] ;
  NOT?: InvoiceTargetWhereInput[] ;
}

export interface InvoiceTargetWhereUniqueInput {
  id?: string ;
}

export interface ItemCreateInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateManyWithoutCategoriesInput {
  create?: ItemCreateWithoutCategoriesInput[] ;
  connect?: ItemWhereUniqueInput[] ;
}

export interface ItemCreateManyWithoutCompanyInput {
  create?: ItemCreateWithoutCompanyInput[] ;
  connect?: ItemWhereUniqueInput[] ;
}

export interface ItemCreateManyWithoutCourseTypeInput {
  create?: ItemCreateWithoutCourseTypeInput[] ;
  connect?: ItemWhereUniqueInput[] ;
}

export interface ItemCreateManyWithoutDefaultVariationsInput {
  create?: ItemCreateWithoutDefaultVariationsInput[] ;
  connect?: ItemWhereUniqueInput[] ;
}

export interface ItemCreateManyWithoutDiscountsInput {
  create?: ItemCreateWithoutDiscountsInput[] ;
  connect?: ItemWhereUniqueInput[] ;
}

export interface ItemCreateManyWithoutGroupsInput {
  create?: ItemCreateWithoutGroupsInput[] ;
  connect?: ItemWhereUniqueInput[] ;
}

export interface ItemCreateManyWithoutImageInput {
  create?: ItemCreateWithoutImageInput[] ;
  connect?: ItemWhereUniqueInput[] ;
}

export interface ItemCreateManyWithoutOfferStagesInput {
  create?: ItemCreateWithoutOfferStagesInput[] ;
  connect?: ItemWhereUniqueInput[] ;
}

export interface ItemCreateManyWithoutOffersInput {
  create?: ItemCreateWithoutOffersInput[] ;
  connect?: ItemWhereUniqueInput[] ;
}

export interface ItemCreateManyWithoutSizesInput {
  create?: ItemCreateWithoutSizesInput[] ;
  connect?: ItemWhereUniqueInput[] ;
}

export interface ItemCreateManyWithoutStampCardsInput {
  create?: ItemCreateWithoutStampCardsInput[] ;
  connect?: ItemWhereUniqueInput[] ;
}

export interface ItemCreateManyWithoutStationsInput {
  create?: ItemCreateWithoutStationsInput[] ;
  connect?: ItemWhereUniqueInput[] ;
}

export interface ItemCreateManyWithoutUpsalesInput {
  create?: ItemCreateWithoutUpsalesInput[] ;
  connect?: ItemWhereUniqueInput[] ;
}

export interface ItemCreateManyWithoutUpsellInput {
  create?: ItemCreateWithoutUpsellInput[] ;
  connect?: ItemWhereUniqueInput[] ;
}

export interface ItemCreateManyWithoutUsedAsUpsellOnInput {
  create?: ItemCreateWithoutUsedAsUpsellOnInput[] ;
  connect?: ItemWhereUniqueInput[] ;
}

export interface ItemCreateManyWithoutVariationsInput {
  create?: ItemCreateWithoutVariationsInput[] ;
  connect?: ItemWhereUniqueInput[] ;
}

export interface ItemCreateOneInput {
  create?: ItemCreateInput ;
  connect?: ItemWhereUniqueInput ;
}

export interface ItemCreateOneWithoutAllergiesInput {
  create?: ItemCreateWithoutAllergiesInput ;
  connect?: ItemWhereUniqueInput ;
}

export interface ItemCreateOneWithoutAppliedVariationsInput {
  create?: ItemCreateWithoutAppliedVariationsInput ;
  connect?: ItemWhereUniqueInput ;
}

export interface ItemCreateOneWithoutArticleMapsInput {
  create?: ItemCreateWithoutArticleMapsInput ;
  connect?: ItemWhereUniqueInput ;
}

export interface ItemCreateOneWithoutDescriptionLangInput {
  create?: ItemCreateWithoutDescriptionLangInput ;
  connect?: ItemWhereUniqueInput ;
}

export interface ItemCreateOneWithoutMenuEntriesInput {
  create?: ItemCreateWithoutMenuEntriesInput ;
  connect?: ItemWhereUniqueInput ;
}

export interface ItemCreateOneWithoutRecommendationsInput {
  create?: ItemCreateWithoutRecommendationsInput ;
  connect?: ItemWhereUniqueInput ;
}

export interface ItemCreateOneWithoutTitleLangInput {
  create?: ItemCreateWithoutTitleLangInput ;
  connect?: ItemWhereUniqueInput ;
}

export interface ItemCreateWithoutAllergiesInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutAppliedVariationsInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutArticleMapsInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutCategoriesInput {
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutCompanyInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutCourseTypeInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutDefaultVariationsInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutDescriptionLangInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutDiscountsInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutGroupsInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutImageInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutMenuEntriesInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutOfferStagesInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutOffersInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutRecommendationsInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutSizesInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutStampCardsInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutStationsInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutTitleLangInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutUpsalesInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutUpsellInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutUsedAsUpsellOnInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  variations?: VariationCreateManyWithoutItemsInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateWithoutVariationsInput {
  categories?: CategoryCreateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringCreateOneWithoutItemAllergiesInput ;
  allergens?: ItemCreateallergensInput ;
  company?: CompanyCreateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutItemDescriptionInput ;
  discounts?: DiscountCreateManyWithoutItemsInput ;
  id?: string ;
  image?: ImageCreateOneWithoutItemsInput ;
  menuEntries?: MenuEntryCreateManyWithoutItemInput ;
  offers?: OfferCreateManyWithoutItemsInput ;
  offerStages?: OfferStageCreateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringCreateOneWithoutItemTitleInput ;
  stampCards?: StampCardCreateManyWithoutItemsInput ;
  defaultVariations?: VariationCreateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutItemInput ;
  groups?: ItemGroupCreateManyWithoutItemsInput ;
  sizes?: ItemSizeCreateOneWithoutItemsInput ;
  recommendations?: RecommendationCreateManyWithoutItemInput ;
  articleMaps?: ArticleMapCreateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationCreateManyWithoutItemsInput ;
  tags?: ItemCreatetagsInput ;
  upsell?: UpsellCreateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellCreateManyWithoutItemsInput ;
  upsales?: UpsellCreateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeCreateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemCreateallergensInput {
  set?: ALLERGEN[] ;
}

export interface ItemCreatetagsInput {
  set?: string[] ;
}

export interface ItemGroupCreateManyWithoutCategoryInput {
  create?: ItemGroupCreateWithoutCategoryInput[] ;
  connect?: ItemGroupWhereUniqueInput[] ;
}

export interface ItemGroupCreateManyWithoutItemsInput {
  create?: ItemGroupCreateWithoutItemsInput[] ;
  connect?: ItemGroupWhereUniqueInput[] ;
}

export interface ItemGroupCreateWithoutCategoryInput {
  id?: string ;
  items?: ItemCreateManyWithoutGroupsInput ;
  name: string;
}

export interface ItemGroupCreateWithoutItemsInput {
  id?: string ;
  category?: CategoryCreateOneWithoutItemGroupsInput ;
  name: string;
}

export interface ItemGroupScalarWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  AND?: ItemGroupScalarWhereInput[] ;
  OR?: ItemGroupScalarWhereInput[] ;
  NOT?: ItemGroupScalarWhereInput[] ;
}

export interface ItemGroupUpdateManyDataInput {
  name?: string ;
}

export interface ItemGroupUpdateManyWithWhereNestedInput {
  where: ItemGroupScalarWhereInput;
  data: ItemGroupUpdateManyDataInput;
}

export interface ItemGroupUpdateManyWithoutCategoryInput {
  create?: ItemGroupCreateWithoutCategoryInput[] ;
  connect?: ItemGroupWhereUniqueInput[] ;
  set?: ItemGroupWhereUniqueInput[] ;
  disconnect?: ItemGroupWhereUniqueInput[] ;
  update?: ItemGroupUpdateWithWhereUniqueWithoutCategoryInput[] ;
  upsert?: ItemGroupUpsertWithWhereUniqueWithoutCategoryInput[] ;
  deleteMany?: ItemGroupScalarWhereInput[] ;
  updateMany?: ItemGroupUpdateManyWithWhereNestedInput[] ;
}

export interface ItemGroupUpdateManyWithoutItemsInput {
  create?: ItemGroupCreateWithoutItemsInput[] ;
  connect?: ItemGroupWhereUniqueInput[] ;
  set?: ItemGroupWhereUniqueInput[] ;
  disconnect?: ItemGroupWhereUniqueInput[] ;
  update?: ItemGroupUpdateWithWhereUniqueWithoutItemsInput[] ;
  upsert?: ItemGroupUpsertWithWhereUniqueWithoutItemsInput[] ;
  deleteMany?: ItemGroupScalarWhereInput[] ;
  updateMany?: ItemGroupUpdateManyWithWhereNestedInput[] ;
}

export interface ItemGroupUpdateWithWhereUniqueWithoutCategoryInput {
  where: ItemGroupWhereUniqueInput;
  data: ItemGroupUpdateWithoutCategoryDataInput;
}

export interface ItemGroupUpdateWithWhereUniqueWithoutItemsInput {
  where: ItemGroupWhereUniqueInput;
  data: ItemGroupUpdateWithoutItemsDataInput;
}

export interface ItemGroupUpdateWithoutCategoryDataInput {
  items?: ItemUpdateManyWithoutGroupsInput ;
  name?: string ;
}

export interface ItemGroupUpdateWithoutItemsDataInput {
  category?: CategoryUpdateOneWithoutItemGroupsInput ;
  name?: string ;
}

export interface ItemGroupUpsertWithWhereUniqueWithoutCategoryInput {
  where: ItemGroupWhereUniqueInput;
  update: ItemGroupUpdateWithoutCategoryDataInput;
  create: ItemGroupCreateWithoutCategoryInput;
}

export interface ItemGroupUpsertWithWhereUniqueWithoutItemsInput {
  where: ItemGroupWhereUniqueInput;
  update: ItemGroupUpdateWithoutItemsDataInput;
  create: ItemGroupCreateWithoutItemsInput;
}

export interface ItemGroupWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  items_every?: ItemWhereInput ;
  items_some?: ItemWhereInput ;
  items_none?: ItemWhereInput ;
  category?: CategoryWhereInput ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  AND?: ItemGroupWhereInput[] ;
  OR?: ItemGroupWhereInput[] ;
  NOT?: ItemGroupWhereInput[] ;
}

export interface ItemGroupWhereUniqueInput {
  id?: string ;
}

export interface ItemScalarWhereInput {
  ageRestricted?: boolean ;
  ageRestricted_not?: boolean ;
  vatRate?: number ;
  vatRate_not?: number ;
  vatRate_in?: number[] ;
  vatRate_not_in?: number[] ;
  vatRate_lt?: number ;
  vatRate_lte?: number ;
  vatRate_gt?: number ;
  vatRate_gte?: number ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  defaultPrice?: number ;
  defaultPrice_not?: number ;
  defaultPrice_in?: number[] ;
  defaultPrice_not_in?: number[] ;
  defaultPrice_lt?: number ;
  defaultPrice_lte?: number ;
  defaultPrice_gt?: number ;
  defaultPrice_gte?: number ;
  description?: string ;
  description_not?: string ;
  description_in?: string[] ;
  description_not_in?: string[] ;
  description_lt?: string ;
  description_lte?: string ;
  description_gt?: string ;
  description_gte?: string ;
  description_contains?: string ;
  description_not_contains?: string ;
  description_starts_with?: string ;
  description_not_starts_with?: string ;
  description_ends_with?: string ;
  description_not_ends_with?: string ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  order?: number ;
  order_not?: number ;
  order_in?: number[] ;
  order_not_in?: number[] ;
  order_lt?: number ;
  order_lte?: number ;
  order_gt?: number ;
  order_gte?: number ;
  title?: string ;
  title_not?: string ;
  title_in?: string[] ;
  title_not_in?: string[] ;
  title_lt?: string ;
  title_lte?: string ;
  title_gt?: string ;
  title_gte?: string ;
  title_contains?: string ;
  title_not_contains?: string ;
  title_starts_with?: string ;
  title_not_starts_with?: string ;
  title_ends_with?: string ;
  title_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  disableMembershipDiscount?: boolean ;
  disableMembershipDiscount_not?: boolean ;
  manualPrice?: boolean ;
  manualPrice_not?: boolean ;
  inventoryEOD?: boolean ;
  inventoryEOD_not?: boolean ;
  volumeSuffix?: string ;
  volumeSuffix_not?: string ;
  volumeSuffix_in?: string[] ;
  volumeSuffix_not_in?: string[] ;
  volumeSuffix_lt?: string ;
  volumeSuffix_lte?: string ;
  volumeSuffix_gt?: string ;
  volumeSuffix_gte?: string ;
  volumeSuffix_contains?: string ;
  volumeSuffix_not_contains?: string ;
  volumeSuffix_starts_with?: string ;
  volumeSuffix_not_starts_with?: string ;
  volumeSuffix_ends_with?: string ;
  volumeSuffix_not_ends_with?: string ;
  costBasis?: number ;
  costBasis_not?: number ;
  costBasis_in?: number[] ;
  costBasis_not_in?: number[] ;
  costBasis_lt?: number ;
  costBasis_lte?: number ;
  costBasis_gt?: number ;
  costBasis_gte?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
  defaultOrderStatus_not?: ORDER_STATUS ;
  defaultOrderStatus_in?: ORDER_STATUS[] ;
  defaultOrderStatus_not_in?: ORDER_STATUS[] ;
  AND?: ItemScalarWhereInput[] ;
  OR?: ItemScalarWhereInput[] ;
  NOT?: ItemScalarWhereInput[] ;
}

export interface ItemSizeCreateManyWithoutCompanyInput {
  create?: ItemSizeCreateWithoutCompanyInput[] ;
  connect?: ItemSizeWhereUniqueInput[] ;
}

export interface ItemSizeCreateManyWithoutVariationsInput {
  create?: ItemSizeCreateWithoutVariationsInput[] ;
  connect?: ItemSizeWhereUniqueInput[] ;
}

export interface ItemSizeCreateOneWithoutArticleMapInput {
  create?: ItemSizeCreateWithoutArticleMapInput ;
  connect?: ItemSizeWhereUniqueInput ;
}

export interface ItemSizeCreateOneWithoutItemsInput {
  create?: ItemSizeCreateWithoutItemsInput ;
  connect?: ItemSizeWhereUniqueInput ;
}

export interface ItemSizeCreateOneWithoutNameLangInput {
  create?: ItemSizeCreateWithoutNameLangInput ;
  connect?: ItemSizeWhereUniqueInput ;
}

export interface ItemSizeCreateWithoutArticleMapInput {
  id?: string ;
  company?: CompanyCreateOneWithoutItemSizesInput ;
  items?: ItemCreateManyWithoutSizesInput ;
  variations?: VariationCreateManyWithoutSizeUsesInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutItemSizeNameInput ;
  type: ITEM_SIZE_TYPE;
}

export interface ItemSizeCreateWithoutCompanyInput {
  id?: string ;
  items?: ItemCreateManyWithoutSizesInput ;
  variations?: VariationCreateManyWithoutSizeUsesInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutItemSizeNameInput ;
  type: ITEM_SIZE_TYPE;
  articleMap?: ArticleMapCreateOneWithoutSizeInput ;
}

export interface ItemSizeCreateWithoutItemsInput {
  id?: string ;
  company?: CompanyCreateOneWithoutItemSizesInput ;
  variations?: VariationCreateManyWithoutSizeUsesInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutItemSizeNameInput ;
  type: ITEM_SIZE_TYPE;
  articleMap?: ArticleMapCreateOneWithoutSizeInput ;
}

export interface ItemSizeCreateWithoutNameLangInput {
  id?: string ;
  company?: CompanyCreateOneWithoutItemSizesInput ;
  items?: ItemCreateManyWithoutSizesInput ;
  variations?: VariationCreateManyWithoutSizeUsesInput ;
  name: string;
  type: ITEM_SIZE_TYPE;
  articleMap?: ArticleMapCreateOneWithoutSizeInput ;
}

export interface ItemSizeCreateWithoutVariationsInput {
  id?: string ;
  company?: CompanyCreateOneWithoutItemSizesInput ;
  items?: ItemCreateManyWithoutSizesInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutItemSizeNameInput ;
  type: ITEM_SIZE_TYPE;
  articleMap?: ArticleMapCreateOneWithoutSizeInput ;
}

export interface ItemSizeScalarWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  type?: ITEM_SIZE_TYPE ;
  type_not?: ITEM_SIZE_TYPE ;
  type_in?: ITEM_SIZE_TYPE[] ;
  type_not_in?: ITEM_SIZE_TYPE[] ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  AND?: ItemSizeScalarWhereInput[] ;
  OR?: ItemSizeScalarWhereInput[] ;
  NOT?: ItemSizeScalarWhereInput[] ;
}

export interface ItemSizeUpdateManyDataInput {
  name?: string ;
  type?: ITEM_SIZE_TYPE ;
}

export interface ItemSizeUpdateManyWithWhereNestedInput {
  where: ItemSizeScalarWhereInput;
  data: ItemSizeUpdateManyDataInput;
}

export interface ItemSizeUpdateManyWithoutCompanyInput {
  create?: ItemSizeCreateWithoutCompanyInput[] ;
  connect?: ItemSizeWhereUniqueInput[] ;
  set?: ItemSizeWhereUniqueInput[] ;
  disconnect?: ItemSizeWhereUniqueInput[] ;
  update?: ItemSizeUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: ItemSizeUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: ItemSizeScalarWhereInput[] ;
  updateMany?: ItemSizeUpdateManyWithWhereNestedInput[] ;
}

export interface ItemSizeUpdateManyWithoutVariationsInput {
  create?: ItemSizeCreateWithoutVariationsInput[] ;
  connect?: ItemSizeWhereUniqueInput[] ;
  set?: ItemSizeWhereUniqueInput[] ;
  disconnect?: ItemSizeWhereUniqueInput[] ;
  update?: ItemSizeUpdateWithWhereUniqueWithoutVariationsInput[] ;
  upsert?: ItemSizeUpsertWithWhereUniqueWithoutVariationsInput[] ;
  deleteMany?: ItemSizeScalarWhereInput[] ;
  updateMany?: ItemSizeUpdateManyWithWhereNestedInput[] ;
}

export interface ItemSizeUpdateOneWithoutArticleMapInput {
  create?: ItemSizeCreateWithoutArticleMapInput ;
  update?: ItemSizeUpdateWithoutArticleMapDataInput ;
  upsert?: ItemSizeUpsertWithoutArticleMapInput ;
  disconnect?: boolean ;
  connect?: ItemSizeWhereUniqueInput ;
}

export interface ItemSizeUpdateOneWithoutItemsInput {
  create?: ItemSizeCreateWithoutItemsInput ;
  update?: ItemSizeUpdateWithoutItemsDataInput ;
  upsert?: ItemSizeUpsertWithoutItemsInput ;
  disconnect?: boolean ;
  connect?: ItemSizeWhereUniqueInput ;
}

export interface ItemSizeUpdateOneWithoutNameLangInput {
  create?: ItemSizeCreateWithoutNameLangInput ;
  update?: ItemSizeUpdateWithoutNameLangDataInput ;
  upsert?: ItemSizeUpsertWithoutNameLangInput ;
  disconnect?: boolean ;
  connect?: ItemSizeWhereUniqueInput ;
}

export interface ItemSizeUpdateWithWhereUniqueWithoutCompanyInput {
  where: ItemSizeWhereUniqueInput;
  data: ItemSizeUpdateWithoutCompanyDataInput;
}

export interface ItemSizeUpdateWithWhereUniqueWithoutVariationsInput {
  where: ItemSizeWhereUniqueInput;
  data: ItemSizeUpdateWithoutVariationsDataInput;
}

export interface ItemSizeUpdateWithoutArticleMapDataInput {
  company?: CompanyUpdateOneWithoutItemSizesInput ;
  items?: ItemUpdateManyWithoutSizesInput ;
  variations?: VariationUpdateManyWithoutSizeUsesInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutItemSizeNameInput ;
  type?: ITEM_SIZE_TYPE ;
}

export interface ItemSizeUpdateWithoutCompanyDataInput {
  items?: ItemUpdateManyWithoutSizesInput ;
  variations?: VariationUpdateManyWithoutSizeUsesInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutItemSizeNameInput ;
  type?: ITEM_SIZE_TYPE ;
  articleMap?: ArticleMapUpdateOneWithoutSizeInput ;
}

export interface ItemSizeUpdateWithoutItemsDataInput {
  company?: CompanyUpdateOneWithoutItemSizesInput ;
  variations?: VariationUpdateManyWithoutSizeUsesInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutItemSizeNameInput ;
  type?: ITEM_SIZE_TYPE ;
  articleMap?: ArticleMapUpdateOneWithoutSizeInput ;
}

export interface ItemSizeUpdateWithoutNameLangDataInput {
  company?: CompanyUpdateOneWithoutItemSizesInput ;
  items?: ItemUpdateManyWithoutSizesInput ;
  variations?: VariationUpdateManyWithoutSizeUsesInput ;
  name?: string ;
  type?: ITEM_SIZE_TYPE ;
  articleMap?: ArticleMapUpdateOneWithoutSizeInput ;
}

export interface ItemSizeUpdateWithoutVariationsDataInput {
  company?: CompanyUpdateOneWithoutItemSizesInput ;
  items?: ItemUpdateManyWithoutSizesInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutItemSizeNameInput ;
  type?: ITEM_SIZE_TYPE ;
  articleMap?: ArticleMapUpdateOneWithoutSizeInput ;
}

export interface ItemSizeUpsertWithWhereUniqueWithoutCompanyInput {
  where: ItemSizeWhereUniqueInput;
  update: ItemSizeUpdateWithoutCompanyDataInput;
  create: ItemSizeCreateWithoutCompanyInput;
}

export interface ItemSizeUpsertWithWhereUniqueWithoutVariationsInput {
  where: ItemSizeWhereUniqueInput;
  update: ItemSizeUpdateWithoutVariationsDataInput;
  create: ItemSizeCreateWithoutVariationsInput;
}

export interface ItemSizeUpsertWithoutArticleMapInput {
  update: ItemSizeUpdateWithoutArticleMapDataInput;
  create: ItemSizeCreateWithoutArticleMapInput;
}

export interface ItemSizeUpsertWithoutItemsInput {
  update: ItemSizeUpdateWithoutItemsDataInput;
  create: ItemSizeCreateWithoutItemsInput;
}

export interface ItemSizeUpsertWithoutNameLangInput {
  update: ItemSizeUpdateWithoutNameLangDataInput;
  create: ItemSizeCreateWithoutNameLangInput;
}

export interface ItemSizeWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  company?: CompanyWhereInput ;
  items_every?: ItemWhereInput ;
  items_some?: ItemWhereInput ;
  items_none?: ItemWhereInput ;
  variations_every?: VariationWhereInput ;
  variations_some?: VariationWhereInput ;
  variations_none?: VariationWhereInput ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  nameLang?: TranslatedStringWhereInput ;
  type?: ITEM_SIZE_TYPE ;
  type_not?: ITEM_SIZE_TYPE ;
  type_in?: ITEM_SIZE_TYPE[] ;
  type_not_in?: ITEM_SIZE_TYPE[] ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  articleMap?: ArticleMapWhereInput ;
  AND?: ItemSizeWhereInput[] ;
  OR?: ItemSizeWhereInput[] ;
  NOT?: ItemSizeWhereInput[] ;
}

export interface ItemSizeWhereUniqueInput {
  id?: string ;
}

export interface ItemUpdateDataInput {
  categories?: CategoryUpdateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringUpdateOneWithoutItemAllergiesInput ;
  allergens?: ItemUpdateallergensInput ;
  company?: CompanyUpdateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutItemDescriptionInput ;
  discounts?: DiscountUpdateManyWithoutItemsInput ;
  image?: ImageUpdateOneWithoutItemsInput ;
  menuEntries?: MenuEntryUpdateManyWithoutItemInput ;
  offers?: OfferUpdateManyWithoutItemsInput ;
  offerStages?: OfferStageUpdateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringUpdateOneWithoutItemTitleInput ;
  variations?: VariationUpdateManyWithoutItemsInput ;
  stampCards?: StampCardUpdateManyWithoutItemsInput ;
  defaultVariations?: VariationUpdateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutItemInput ;
  groups?: ItemGroupUpdateManyWithoutItemsInput ;
  sizes?: ItemSizeUpdateOneWithoutItemsInput ;
  recommendations?: RecommendationUpdateManyWithoutItemInput ;
  articleMaps?: ArticleMapUpdateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationUpdateManyWithoutItemsInput ;
  tags?: ItemUpdatetagsInput ;
  upsell?: UpsellUpdateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellUpdateManyWithoutItemsInput ;
  upsales?: UpsellUpdateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeUpdateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemUpdateInput {
  categories?: CategoryUpdateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringUpdateOneWithoutItemAllergiesInput ;
  allergens?: ItemUpdateallergensInput ;
  company?: CompanyUpdateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutItemDescriptionInput ;
  discounts?: DiscountUpdateManyWithoutItemsInput ;
  image?: ImageUpdateOneWithoutItemsInput ;
  menuEntries?: MenuEntryUpdateManyWithoutItemInput ;
  offers?: OfferUpdateManyWithoutItemsInput ;
  offerStages?: OfferStageUpdateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringUpdateOneWithoutItemTitleInput ;
  variations?: VariationUpdateManyWithoutItemsInput ;
  stampCards?: StampCardUpdateManyWithoutItemsInput ;
  defaultVariations?: VariationUpdateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutItemInput ;
  groups?: ItemGroupUpdateManyWithoutItemsInput ;
  sizes?: ItemSizeUpdateOneWithoutItemsInput ;
  recommendations?: RecommendationUpdateManyWithoutItemInput ;
  articleMaps?: ArticleMapUpdateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationUpdateManyWithoutItemsInput ;
  tags?: ItemUpdatetagsInput ;
  upsell?: UpsellUpdateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellUpdateManyWithoutItemsInput ;
  upsales?: UpsellUpdateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeUpdateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemUpdateManyDataInput {
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergens?: ItemUpdateallergensInput ;
  defaultPrice?: number ;
  description?: string ;
  order?: number ;
  title?: string ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  tags?: ItemUpdatetagsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemUpdateManyWithWhereNestedInput {
  where: ItemScalarWhereInput;
  data: ItemUpdateManyDataInput;
}

export interface ItemUpdateManyWithoutCategoriesInput {
  create?: ItemCreateWithoutCategoriesInput[] ;
  connect?: ItemWhereUniqueInput[] ;
  set?: ItemWhereUniqueInput[] ;
  disconnect?: ItemWhereUniqueInput[] ;
  update?: ItemUpdateWithWhereUniqueWithoutCategoriesInput[] ;
  upsert?: ItemUpsertWithWhereUniqueWithoutCategoriesInput[] ;
  deleteMany?: ItemScalarWhereInput[] ;
  updateMany?: ItemUpdateManyWithWhereNestedInput[] ;
}

export interface ItemUpdateManyWithoutCompanyInput {
  create?: ItemCreateWithoutCompanyInput[] ;
  connect?: ItemWhereUniqueInput[] ;
  set?: ItemWhereUniqueInput[] ;
  disconnect?: ItemWhereUniqueInput[] ;
  update?: ItemUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: ItemUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: ItemScalarWhereInput[] ;
  updateMany?: ItemUpdateManyWithWhereNestedInput[] ;
}

export interface ItemUpdateManyWithoutCourseTypeInput {
  create?: ItemCreateWithoutCourseTypeInput[] ;
  connect?: ItemWhereUniqueInput[] ;
  set?: ItemWhereUniqueInput[] ;
  disconnect?: ItemWhereUniqueInput[] ;
  update?: ItemUpdateWithWhereUniqueWithoutCourseTypeInput[] ;
  upsert?: ItemUpsertWithWhereUniqueWithoutCourseTypeInput[] ;
  deleteMany?: ItemScalarWhereInput[] ;
  updateMany?: ItemUpdateManyWithWhereNestedInput[] ;
}

export interface ItemUpdateManyWithoutDefaultVariationsInput {
  create?: ItemCreateWithoutDefaultVariationsInput[] ;
  connect?: ItemWhereUniqueInput[] ;
  set?: ItemWhereUniqueInput[] ;
  disconnect?: ItemWhereUniqueInput[] ;
  update?: ItemUpdateWithWhereUniqueWithoutDefaultVariationsInput[] ;
  upsert?: ItemUpsertWithWhereUniqueWithoutDefaultVariationsInput[] ;
  deleteMany?: ItemScalarWhereInput[] ;
  updateMany?: ItemUpdateManyWithWhereNestedInput[] ;
}

export interface ItemUpdateManyWithoutDiscountsInput {
  create?: ItemCreateWithoutDiscountsInput[] ;
  connect?: ItemWhereUniqueInput[] ;
  set?: ItemWhereUniqueInput[] ;
  disconnect?: ItemWhereUniqueInput[] ;
  update?: ItemUpdateWithWhereUniqueWithoutDiscountsInput[] ;
  upsert?: ItemUpsertWithWhereUniqueWithoutDiscountsInput[] ;
  deleteMany?: ItemScalarWhereInput[] ;
  updateMany?: ItemUpdateManyWithWhereNestedInput[] ;
}

export interface ItemUpdateManyWithoutGroupsInput {
  create?: ItemCreateWithoutGroupsInput[] ;
  connect?: ItemWhereUniqueInput[] ;
  set?: ItemWhereUniqueInput[] ;
  disconnect?: ItemWhereUniqueInput[] ;
  update?: ItemUpdateWithWhereUniqueWithoutGroupsInput[] ;
  upsert?: ItemUpsertWithWhereUniqueWithoutGroupsInput[] ;
  deleteMany?: ItemScalarWhereInput[] ;
  updateMany?: ItemUpdateManyWithWhereNestedInput[] ;
}

export interface ItemUpdateManyWithoutImageInput {
  create?: ItemCreateWithoutImageInput[] ;
  connect?: ItemWhereUniqueInput[] ;
  set?: ItemWhereUniqueInput[] ;
  disconnect?: ItemWhereUniqueInput[] ;
  update?: ItemUpdateWithWhereUniqueWithoutImageInput[] ;
  upsert?: ItemUpsertWithWhereUniqueWithoutImageInput[] ;
  deleteMany?: ItemScalarWhereInput[] ;
  updateMany?: ItemUpdateManyWithWhereNestedInput[] ;
}

export interface ItemUpdateManyWithoutOfferStagesInput {
  create?: ItemCreateWithoutOfferStagesInput[] ;
  connect?: ItemWhereUniqueInput[] ;
  set?: ItemWhereUniqueInput[] ;
  disconnect?: ItemWhereUniqueInput[] ;
  update?: ItemUpdateWithWhereUniqueWithoutOfferStagesInput[] ;
  upsert?: ItemUpsertWithWhereUniqueWithoutOfferStagesInput[] ;
  deleteMany?: ItemScalarWhereInput[] ;
  updateMany?: ItemUpdateManyWithWhereNestedInput[] ;
}

export interface ItemUpdateManyWithoutOffersInput {
  create?: ItemCreateWithoutOffersInput[] ;
  connect?: ItemWhereUniqueInput[] ;
  set?: ItemWhereUniqueInput[] ;
  disconnect?: ItemWhereUniqueInput[] ;
  update?: ItemUpdateWithWhereUniqueWithoutOffersInput[] ;
  upsert?: ItemUpsertWithWhereUniqueWithoutOffersInput[] ;
  deleteMany?: ItemScalarWhereInput[] ;
  updateMany?: ItemUpdateManyWithWhereNestedInput[] ;
}

export interface ItemUpdateManyWithoutSizesInput {
  create?: ItemCreateWithoutSizesInput[] ;
  connect?: ItemWhereUniqueInput[] ;
  set?: ItemWhereUniqueInput[] ;
  disconnect?: ItemWhereUniqueInput[] ;
  update?: ItemUpdateWithWhereUniqueWithoutSizesInput[] ;
  upsert?: ItemUpsertWithWhereUniqueWithoutSizesInput[] ;
  deleteMany?: ItemScalarWhereInput[] ;
  updateMany?: ItemUpdateManyWithWhereNestedInput[] ;
}

export interface ItemUpdateManyWithoutStampCardsInput {
  create?: ItemCreateWithoutStampCardsInput[] ;
  connect?: ItemWhereUniqueInput[] ;
  set?: ItemWhereUniqueInput[] ;
  disconnect?: ItemWhereUniqueInput[] ;
  update?: ItemUpdateWithWhereUniqueWithoutStampCardsInput[] ;
  upsert?: ItemUpsertWithWhereUniqueWithoutStampCardsInput[] ;
  deleteMany?: ItemScalarWhereInput[] ;
  updateMany?: ItemUpdateManyWithWhereNestedInput[] ;
}

export interface ItemUpdateManyWithoutStationsInput {
  create?: ItemCreateWithoutStationsInput[] ;
  connect?: ItemWhereUniqueInput[] ;
  set?: ItemWhereUniqueInput[] ;
  disconnect?: ItemWhereUniqueInput[] ;
  update?: ItemUpdateWithWhereUniqueWithoutStationsInput[] ;
  upsert?: ItemUpsertWithWhereUniqueWithoutStationsInput[] ;
  deleteMany?: ItemScalarWhereInput[] ;
  updateMany?: ItemUpdateManyWithWhereNestedInput[] ;
}

export interface ItemUpdateManyWithoutUpsalesInput {
  create?: ItemCreateWithoutUpsalesInput[] ;
  connect?: ItemWhereUniqueInput[] ;
  set?: ItemWhereUniqueInput[] ;
  disconnect?: ItemWhereUniqueInput[] ;
  update?: ItemUpdateWithWhereUniqueWithoutUpsalesInput[] ;
  upsert?: ItemUpsertWithWhereUniqueWithoutUpsalesInput[] ;
  deleteMany?: ItemScalarWhereInput[] ;
  updateMany?: ItemUpdateManyWithWhereNestedInput[] ;
}

export interface ItemUpdateManyWithoutUpsellInput {
  create?: ItemCreateWithoutUpsellInput[] ;
  connect?: ItemWhereUniqueInput[] ;
  set?: ItemWhereUniqueInput[] ;
  disconnect?: ItemWhereUniqueInput[] ;
  update?: ItemUpdateWithWhereUniqueWithoutUpsellInput[] ;
  upsert?: ItemUpsertWithWhereUniqueWithoutUpsellInput[] ;
  deleteMany?: ItemScalarWhereInput[] ;
  updateMany?: ItemUpdateManyWithWhereNestedInput[] ;
}

export interface ItemUpdateManyWithoutUsedAsUpsellOnInput {
  create?: ItemCreateWithoutUsedAsUpsellOnInput[] ;
  connect?: ItemWhereUniqueInput[] ;
  set?: ItemWhereUniqueInput[] ;
  disconnect?: ItemWhereUniqueInput[] ;
  update?: ItemUpdateWithWhereUniqueWithoutUsedAsUpsellOnInput[] ;
  upsert?: ItemUpsertWithWhereUniqueWithoutUsedAsUpsellOnInput[] ;
  deleteMany?: ItemScalarWhereInput[] ;
  updateMany?: ItemUpdateManyWithWhereNestedInput[] ;
}

export interface ItemUpdateManyWithoutVariationsInput {
  create?: ItemCreateWithoutVariationsInput[] ;
  connect?: ItemWhereUniqueInput[] ;
  set?: ItemWhereUniqueInput[] ;
  disconnect?: ItemWhereUniqueInput[] ;
  update?: ItemUpdateWithWhereUniqueWithoutVariationsInput[] ;
  upsert?: ItemUpsertWithWhereUniqueWithoutVariationsInput[] ;
  deleteMany?: ItemScalarWhereInput[] ;
  updateMany?: ItemUpdateManyWithWhereNestedInput[] ;
}

export interface ItemUpdateOneInput {
  create?: ItemCreateInput ;
  update?: ItemUpdateDataInput ;
  upsert?: ItemUpsertNestedInput ;
  disconnect?: boolean ;
  connect?: ItemWhereUniqueInput ;
}

export interface ItemUpdateOneRequiredWithoutArticleMapsInput {
  create?: ItemCreateWithoutArticleMapsInput ;
  update?: ItemUpdateWithoutArticleMapsDataInput ;
  upsert?: ItemUpsertWithoutArticleMapsInput ;
  connect?: ItemWhereUniqueInput ;
}

export interface ItemUpdateOneWithoutAllergiesInput {
  create?: ItemCreateWithoutAllergiesInput ;
  update?: ItemUpdateWithoutAllergiesDataInput ;
  upsert?: ItemUpsertWithoutAllergiesInput ;
  disconnect?: boolean ;
  connect?: ItemWhereUniqueInput ;
}

export interface ItemUpdateOneWithoutAppliedVariationsInput {
  create?: ItemCreateWithoutAppliedVariationsInput ;
  update?: ItemUpdateWithoutAppliedVariationsDataInput ;
  upsert?: ItemUpsertWithoutAppliedVariationsInput ;
  disconnect?: boolean ;
  connect?: ItemWhereUniqueInput ;
}

export interface ItemUpdateOneWithoutDescriptionLangInput {
  create?: ItemCreateWithoutDescriptionLangInput ;
  update?: ItemUpdateWithoutDescriptionLangDataInput ;
  upsert?: ItemUpsertWithoutDescriptionLangInput ;
  disconnect?: boolean ;
  connect?: ItemWhereUniqueInput ;
}

export interface ItemUpdateOneWithoutMenuEntriesInput {
  create?: ItemCreateWithoutMenuEntriesInput ;
  update?: ItemUpdateWithoutMenuEntriesDataInput ;
  upsert?: ItemUpsertWithoutMenuEntriesInput ;
  disconnect?: boolean ;
  connect?: ItemWhereUniqueInput ;
}

export interface ItemUpdateOneWithoutRecommendationsInput {
  create?: ItemCreateWithoutRecommendationsInput ;
  update?: ItemUpdateWithoutRecommendationsDataInput ;
  upsert?: ItemUpsertWithoutRecommendationsInput ;
  disconnect?: boolean ;
  connect?: ItemWhereUniqueInput ;
}

export interface ItemUpdateOneWithoutTitleLangInput {
  create?: ItemCreateWithoutTitleLangInput ;
  update?: ItemUpdateWithoutTitleLangDataInput ;
  upsert?: ItemUpsertWithoutTitleLangInput ;
  disconnect?: boolean ;
  connect?: ItemWhereUniqueInput ;
}

export interface ItemUpdateWithWhereUniqueWithoutCategoriesInput {
  where: ItemWhereUniqueInput;
  data: ItemUpdateWithoutCategoriesDataInput;
}

export interface ItemUpdateWithWhereUniqueWithoutCompanyInput {
  where: ItemWhereUniqueInput;
  data: ItemUpdateWithoutCompanyDataInput;
}

export interface ItemUpdateWithWhereUniqueWithoutCourseTypeInput {
  where: ItemWhereUniqueInput;
  data: ItemUpdateWithoutCourseTypeDataInput;
}

export interface ItemUpdateWithWhereUniqueWithoutDefaultVariationsInput {
  where: ItemWhereUniqueInput;
  data: ItemUpdateWithoutDefaultVariationsDataInput;
}

export interface ItemUpdateWithWhereUniqueWithoutDiscountsInput {
  where: ItemWhereUniqueInput;
  data: ItemUpdateWithoutDiscountsDataInput;
}

export interface ItemUpdateWithWhereUniqueWithoutGroupsInput {
  where: ItemWhereUniqueInput;
  data: ItemUpdateWithoutGroupsDataInput;
}

export interface ItemUpdateWithWhereUniqueWithoutImageInput {
  where: ItemWhereUniqueInput;
  data: ItemUpdateWithoutImageDataInput;
}

export interface ItemUpdateWithWhereUniqueWithoutOfferStagesInput {
  where: ItemWhereUniqueInput;
  data: ItemUpdateWithoutOfferStagesDataInput;
}

export interface ItemUpdateWithWhereUniqueWithoutOffersInput {
  where: ItemWhereUniqueInput;
  data: ItemUpdateWithoutOffersDataInput;
}

export interface ItemUpdateWithWhereUniqueWithoutSizesInput {
  where: ItemWhereUniqueInput;
  data: ItemUpdateWithoutSizesDataInput;
}

export interface ItemUpdateWithWhereUniqueWithoutStampCardsInput {
  where: ItemWhereUniqueInput;
  data: ItemUpdateWithoutStampCardsDataInput;
}

export interface ItemUpdateWithWhereUniqueWithoutStationsInput {
  where: ItemWhereUniqueInput;
  data: ItemUpdateWithoutStationsDataInput;
}

export interface ItemUpdateWithWhereUniqueWithoutUpsalesInput {
  where: ItemWhereUniqueInput;
  data: ItemUpdateWithoutUpsalesDataInput;
}

export interface ItemUpdateWithWhereUniqueWithoutUpsellInput {
  where: ItemWhereUniqueInput;
  data: ItemUpdateWithoutUpsellDataInput;
}

export interface ItemUpdateWithWhereUniqueWithoutUsedAsUpsellOnInput {
  where: ItemWhereUniqueInput;
  data: ItemUpdateWithoutUsedAsUpsellOnDataInput;
}

export interface ItemUpdateWithWhereUniqueWithoutVariationsInput {
  where: ItemWhereUniqueInput;
  data: ItemUpdateWithoutVariationsDataInput;
}

export interface ItemUpdateWithoutAllergiesDataInput {
  categories?: CategoryUpdateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergens?: ItemUpdateallergensInput ;
  company?: CompanyUpdateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutItemDescriptionInput ;
  discounts?: DiscountUpdateManyWithoutItemsInput ;
  image?: ImageUpdateOneWithoutItemsInput ;
  menuEntries?: MenuEntryUpdateManyWithoutItemInput ;
  offers?: OfferUpdateManyWithoutItemsInput ;
  offerStages?: OfferStageUpdateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringUpdateOneWithoutItemTitleInput ;
  variations?: VariationUpdateManyWithoutItemsInput ;
  stampCards?: StampCardUpdateManyWithoutItemsInput ;
  defaultVariations?: VariationUpdateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutItemInput ;
  groups?: ItemGroupUpdateManyWithoutItemsInput ;
  sizes?: ItemSizeUpdateOneWithoutItemsInput ;
  recommendations?: RecommendationUpdateManyWithoutItemInput ;
  articleMaps?: ArticleMapUpdateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationUpdateManyWithoutItemsInput ;
  tags?: ItemUpdatetagsInput ;
  upsell?: UpsellUpdateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellUpdateManyWithoutItemsInput ;
  upsales?: UpsellUpdateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeUpdateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemUpdateWithoutAppliedVariationsDataInput {
  categories?: CategoryUpdateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringUpdateOneWithoutItemAllergiesInput ;
  allergens?: ItemUpdateallergensInput ;
  company?: CompanyUpdateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutItemDescriptionInput ;
  discounts?: DiscountUpdateManyWithoutItemsInput ;
  image?: ImageUpdateOneWithoutItemsInput ;
  menuEntries?: MenuEntryUpdateManyWithoutItemInput ;
  offers?: OfferUpdateManyWithoutItemsInput ;
  offerStages?: OfferStageUpdateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringUpdateOneWithoutItemTitleInput ;
  variations?: VariationUpdateManyWithoutItemsInput ;
  stampCards?: StampCardUpdateManyWithoutItemsInput ;
  defaultVariations?: VariationUpdateManyWithoutDefaultOnItemsInput ;
  groups?: ItemGroupUpdateManyWithoutItemsInput ;
  sizes?: ItemSizeUpdateOneWithoutItemsInput ;
  recommendations?: RecommendationUpdateManyWithoutItemInput ;
  articleMaps?: ArticleMapUpdateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationUpdateManyWithoutItemsInput ;
  tags?: ItemUpdatetagsInput ;
  upsell?: UpsellUpdateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellUpdateManyWithoutItemsInput ;
  upsales?: UpsellUpdateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeUpdateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemUpdateWithoutArticleMapsDataInput {
  categories?: CategoryUpdateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringUpdateOneWithoutItemAllergiesInput ;
  allergens?: ItemUpdateallergensInput ;
  company?: CompanyUpdateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutItemDescriptionInput ;
  discounts?: DiscountUpdateManyWithoutItemsInput ;
  image?: ImageUpdateOneWithoutItemsInput ;
  menuEntries?: MenuEntryUpdateManyWithoutItemInput ;
  offers?: OfferUpdateManyWithoutItemsInput ;
  offerStages?: OfferStageUpdateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringUpdateOneWithoutItemTitleInput ;
  variations?: VariationUpdateManyWithoutItemsInput ;
  stampCards?: StampCardUpdateManyWithoutItemsInput ;
  defaultVariations?: VariationUpdateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutItemInput ;
  groups?: ItemGroupUpdateManyWithoutItemsInput ;
  sizes?: ItemSizeUpdateOneWithoutItemsInput ;
  recommendations?: RecommendationUpdateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationUpdateManyWithoutItemsInput ;
  tags?: ItemUpdatetagsInput ;
  upsell?: UpsellUpdateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellUpdateManyWithoutItemsInput ;
  upsales?: UpsellUpdateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeUpdateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemUpdateWithoutCategoriesDataInput {
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringUpdateOneWithoutItemAllergiesInput ;
  allergens?: ItemUpdateallergensInput ;
  company?: CompanyUpdateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutItemDescriptionInput ;
  discounts?: DiscountUpdateManyWithoutItemsInput ;
  image?: ImageUpdateOneWithoutItemsInput ;
  menuEntries?: MenuEntryUpdateManyWithoutItemInput ;
  offers?: OfferUpdateManyWithoutItemsInput ;
  offerStages?: OfferStageUpdateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringUpdateOneWithoutItemTitleInput ;
  variations?: VariationUpdateManyWithoutItemsInput ;
  stampCards?: StampCardUpdateManyWithoutItemsInput ;
  defaultVariations?: VariationUpdateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutItemInput ;
  groups?: ItemGroupUpdateManyWithoutItemsInput ;
  sizes?: ItemSizeUpdateOneWithoutItemsInput ;
  recommendations?: RecommendationUpdateManyWithoutItemInput ;
  articleMaps?: ArticleMapUpdateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationUpdateManyWithoutItemsInput ;
  tags?: ItemUpdatetagsInput ;
  upsell?: UpsellUpdateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellUpdateManyWithoutItemsInput ;
  upsales?: UpsellUpdateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeUpdateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemUpdateWithoutCompanyDataInput {
  categories?: CategoryUpdateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringUpdateOneWithoutItemAllergiesInput ;
  allergens?: ItemUpdateallergensInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutItemDescriptionInput ;
  discounts?: DiscountUpdateManyWithoutItemsInput ;
  image?: ImageUpdateOneWithoutItemsInput ;
  menuEntries?: MenuEntryUpdateManyWithoutItemInput ;
  offers?: OfferUpdateManyWithoutItemsInput ;
  offerStages?: OfferStageUpdateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringUpdateOneWithoutItemTitleInput ;
  variations?: VariationUpdateManyWithoutItemsInput ;
  stampCards?: StampCardUpdateManyWithoutItemsInput ;
  defaultVariations?: VariationUpdateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutItemInput ;
  groups?: ItemGroupUpdateManyWithoutItemsInput ;
  sizes?: ItemSizeUpdateOneWithoutItemsInput ;
  recommendations?: RecommendationUpdateManyWithoutItemInput ;
  articleMaps?: ArticleMapUpdateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationUpdateManyWithoutItemsInput ;
  tags?: ItemUpdatetagsInput ;
  upsell?: UpsellUpdateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellUpdateManyWithoutItemsInput ;
  upsales?: UpsellUpdateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeUpdateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemUpdateWithoutCourseTypeDataInput {
  categories?: CategoryUpdateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringUpdateOneWithoutItemAllergiesInput ;
  allergens?: ItemUpdateallergensInput ;
  company?: CompanyUpdateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutItemDescriptionInput ;
  discounts?: DiscountUpdateManyWithoutItemsInput ;
  image?: ImageUpdateOneWithoutItemsInput ;
  menuEntries?: MenuEntryUpdateManyWithoutItemInput ;
  offers?: OfferUpdateManyWithoutItemsInput ;
  offerStages?: OfferStageUpdateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringUpdateOneWithoutItemTitleInput ;
  variations?: VariationUpdateManyWithoutItemsInput ;
  stampCards?: StampCardUpdateManyWithoutItemsInput ;
  defaultVariations?: VariationUpdateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutItemInput ;
  groups?: ItemGroupUpdateManyWithoutItemsInput ;
  sizes?: ItemSizeUpdateOneWithoutItemsInput ;
  recommendations?: RecommendationUpdateManyWithoutItemInput ;
  articleMaps?: ArticleMapUpdateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationUpdateManyWithoutItemsInput ;
  tags?: ItemUpdatetagsInput ;
  upsell?: UpsellUpdateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellUpdateManyWithoutItemsInput ;
  upsales?: UpsellUpdateManyWithoutItemsUsedOnInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemUpdateWithoutDefaultVariationsDataInput {
  categories?: CategoryUpdateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringUpdateOneWithoutItemAllergiesInput ;
  allergens?: ItemUpdateallergensInput ;
  company?: CompanyUpdateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutItemDescriptionInput ;
  discounts?: DiscountUpdateManyWithoutItemsInput ;
  image?: ImageUpdateOneWithoutItemsInput ;
  menuEntries?: MenuEntryUpdateManyWithoutItemInput ;
  offers?: OfferUpdateManyWithoutItemsInput ;
  offerStages?: OfferStageUpdateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringUpdateOneWithoutItemTitleInput ;
  variations?: VariationUpdateManyWithoutItemsInput ;
  stampCards?: StampCardUpdateManyWithoutItemsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutItemInput ;
  groups?: ItemGroupUpdateManyWithoutItemsInput ;
  sizes?: ItemSizeUpdateOneWithoutItemsInput ;
  recommendations?: RecommendationUpdateManyWithoutItemInput ;
  articleMaps?: ArticleMapUpdateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationUpdateManyWithoutItemsInput ;
  tags?: ItemUpdatetagsInput ;
  upsell?: UpsellUpdateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellUpdateManyWithoutItemsInput ;
  upsales?: UpsellUpdateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeUpdateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemUpdateWithoutDescriptionLangDataInput {
  categories?: CategoryUpdateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringUpdateOneWithoutItemAllergiesInput ;
  allergens?: ItemUpdateallergensInput ;
  company?: CompanyUpdateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  discounts?: DiscountUpdateManyWithoutItemsInput ;
  image?: ImageUpdateOneWithoutItemsInput ;
  menuEntries?: MenuEntryUpdateManyWithoutItemInput ;
  offers?: OfferUpdateManyWithoutItemsInput ;
  offerStages?: OfferStageUpdateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringUpdateOneWithoutItemTitleInput ;
  variations?: VariationUpdateManyWithoutItemsInput ;
  stampCards?: StampCardUpdateManyWithoutItemsInput ;
  defaultVariations?: VariationUpdateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutItemInput ;
  groups?: ItemGroupUpdateManyWithoutItemsInput ;
  sizes?: ItemSizeUpdateOneWithoutItemsInput ;
  recommendations?: RecommendationUpdateManyWithoutItemInput ;
  articleMaps?: ArticleMapUpdateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationUpdateManyWithoutItemsInput ;
  tags?: ItemUpdatetagsInput ;
  upsell?: UpsellUpdateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellUpdateManyWithoutItemsInput ;
  upsales?: UpsellUpdateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeUpdateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemUpdateWithoutDiscountsDataInput {
  categories?: CategoryUpdateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringUpdateOneWithoutItemAllergiesInput ;
  allergens?: ItemUpdateallergensInput ;
  company?: CompanyUpdateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutItemDescriptionInput ;
  image?: ImageUpdateOneWithoutItemsInput ;
  menuEntries?: MenuEntryUpdateManyWithoutItemInput ;
  offers?: OfferUpdateManyWithoutItemsInput ;
  offerStages?: OfferStageUpdateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringUpdateOneWithoutItemTitleInput ;
  variations?: VariationUpdateManyWithoutItemsInput ;
  stampCards?: StampCardUpdateManyWithoutItemsInput ;
  defaultVariations?: VariationUpdateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutItemInput ;
  groups?: ItemGroupUpdateManyWithoutItemsInput ;
  sizes?: ItemSizeUpdateOneWithoutItemsInput ;
  recommendations?: RecommendationUpdateManyWithoutItemInput ;
  articleMaps?: ArticleMapUpdateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationUpdateManyWithoutItemsInput ;
  tags?: ItemUpdatetagsInput ;
  upsell?: UpsellUpdateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellUpdateManyWithoutItemsInput ;
  upsales?: UpsellUpdateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeUpdateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemUpdateWithoutGroupsDataInput {
  categories?: CategoryUpdateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringUpdateOneWithoutItemAllergiesInput ;
  allergens?: ItemUpdateallergensInput ;
  company?: CompanyUpdateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutItemDescriptionInput ;
  discounts?: DiscountUpdateManyWithoutItemsInput ;
  image?: ImageUpdateOneWithoutItemsInput ;
  menuEntries?: MenuEntryUpdateManyWithoutItemInput ;
  offers?: OfferUpdateManyWithoutItemsInput ;
  offerStages?: OfferStageUpdateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringUpdateOneWithoutItemTitleInput ;
  variations?: VariationUpdateManyWithoutItemsInput ;
  stampCards?: StampCardUpdateManyWithoutItemsInput ;
  defaultVariations?: VariationUpdateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutItemInput ;
  sizes?: ItemSizeUpdateOneWithoutItemsInput ;
  recommendations?: RecommendationUpdateManyWithoutItemInput ;
  articleMaps?: ArticleMapUpdateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationUpdateManyWithoutItemsInput ;
  tags?: ItemUpdatetagsInput ;
  upsell?: UpsellUpdateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellUpdateManyWithoutItemsInput ;
  upsales?: UpsellUpdateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeUpdateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemUpdateWithoutImageDataInput {
  categories?: CategoryUpdateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringUpdateOneWithoutItemAllergiesInput ;
  allergens?: ItemUpdateallergensInput ;
  company?: CompanyUpdateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutItemDescriptionInput ;
  discounts?: DiscountUpdateManyWithoutItemsInput ;
  menuEntries?: MenuEntryUpdateManyWithoutItemInput ;
  offers?: OfferUpdateManyWithoutItemsInput ;
  offerStages?: OfferStageUpdateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringUpdateOneWithoutItemTitleInput ;
  variations?: VariationUpdateManyWithoutItemsInput ;
  stampCards?: StampCardUpdateManyWithoutItemsInput ;
  defaultVariations?: VariationUpdateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutItemInput ;
  groups?: ItemGroupUpdateManyWithoutItemsInput ;
  sizes?: ItemSizeUpdateOneWithoutItemsInput ;
  recommendations?: RecommendationUpdateManyWithoutItemInput ;
  articleMaps?: ArticleMapUpdateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationUpdateManyWithoutItemsInput ;
  tags?: ItemUpdatetagsInput ;
  upsell?: UpsellUpdateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellUpdateManyWithoutItemsInput ;
  upsales?: UpsellUpdateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeUpdateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemUpdateWithoutMenuEntriesDataInput {
  categories?: CategoryUpdateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringUpdateOneWithoutItemAllergiesInput ;
  allergens?: ItemUpdateallergensInput ;
  company?: CompanyUpdateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutItemDescriptionInput ;
  discounts?: DiscountUpdateManyWithoutItemsInput ;
  image?: ImageUpdateOneWithoutItemsInput ;
  offers?: OfferUpdateManyWithoutItemsInput ;
  offerStages?: OfferStageUpdateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringUpdateOneWithoutItemTitleInput ;
  variations?: VariationUpdateManyWithoutItemsInput ;
  stampCards?: StampCardUpdateManyWithoutItemsInput ;
  defaultVariations?: VariationUpdateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutItemInput ;
  groups?: ItemGroupUpdateManyWithoutItemsInput ;
  sizes?: ItemSizeUpdateOneWithoutItemsInput ;
  recommendations?: RecommendationUpdateManyWithoutItemInput ;
  articleMaps?: ArticleMapUpdateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationUpdateManyWithoutItemsInput ;
  tags?: ItemUpdatetagsInput ;
  upsell?: UpsellUpdateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellUpdateManyWithoutItemsInput ;
  upsales?: UpsellUpdateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeUpdateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemUpdateWithoutOfferStagesDataInput {
  categories?: CategoryUpdateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringUpdateOneWithoutItemAllergiesInput ;
  allergens?: ItemUpdateallergensInput ;
  company?: CompanyUpdateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutItemDescriptionInput ;
  discounts?: DiscountUpdateManyWithoutItemsInput ;
  image?: ImageUpdateOneWithoutItemsInput ;
  menuEntries?: MenuEntryUpdateManyWithoutItemInput ;
  offers?: OfferUpdateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringUpdateOneWithoutItemTitleInput ;
  variations?: VariationUpdateManyWithoutItemsInput ;
  stampCards?: StampCardUpdateManyWithoutItemsInput ;
  defaultVariations?: VariationUpdateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutItemInput ;
  groups?: ItemGroupUpdateManyWithoutItemsInput ;
  sizes?: ItemSizeUpdateOneWithoutItemsInput ;
  recommendations?: RecommendationUpdateManyWithoutItemInput ;
  articleMaps?: ArticleMapUpdateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationUpdateManyWithoutItemsInput ;
  tags?: ItemUpdatetagsInput ;
  upsell?: UpsellUpdateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellUpdateManyWithoutItemsInput ;
  upsales?: UpsellUpdateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeUpdateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemUpdateWithoutOffersDataInput {
  categories?: CategoryUpdateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringUpdateOneWithoutItemAllergiesInput ;
  allergens?: ItemUpdateallergensInput ;
  company?: CompanyUpdateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutItemDescriptionInput ;
  discounts?: DiscountUpdateManyWithoutItemsInput ;
  image?: ImageUpdateOneWithoutItemsInput ;
  menuEntries?: MenuEntryUpdateManyWithoutItemInput ;
  offerStages?: OfferStageUpdateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringUpdateOneWithoutItemTitleInput ;
  variations?: VariationUpdateManyWithoutItemsInput ;
  stampCards?: StampCardUpdateManyWithoutItemsInput ;
  defaultVariations?: VariationUpdateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutItemInput ;
  groups?: ItemGroupUpdateManyWithoutItemsInput ;
  sizes?: ItemSizeUpdateOneWithoutItemsInput ;
  recommendations?: RecommendationUpdateManyWithoutItemInput ;
  articleMaps?: ArticleMapUpdateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationUpdateManyWithoutItemsInput ;
  tags?: ItemUpdatetagsInput ;
  upsell?: UpsellUpdateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellUpdateManyWithoutItemsInput ;
  upsales?: UpsellUpdateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeUpdateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemUpdateWithoutRecommendationsDataInput {
  categories?: CategoryUpdateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringUpdateOneWithoutItemAllergiesInput ;
  allergens?: ItemUpdateallergensInput ;
  company?: CompanyUpdateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutItemDescriptionInput ;
  discounts?: DiscountUpdateManyWithoutItemsInput ;
  image?: ImageUpdateOneWithoutItemsInput ;
  menuEntries?: MenuEntryUpdateManyWithoutItemInput ;
  offers?: OfferUpdateManyWithoutItemsInput ;
  offerStages?: OfferStageUpdateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringUpdateOneWithoutItemTitleInput ;
  variations?: VariationUpdateManyWithoutItemsInput ;
  stampCards?: StampCardUpdateManyWithoutItemsInput ;
  defaultVariations?: VariationUpdateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutItemInput ;
  groups?: ItemGroupUpdateManyWithoutItemsInput ;
  sizes?: ItemSizeUpdateOneWithoutItemsInput ;
  articleMaps?: ArticleMapUpdateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationUpdateManyWithoutItemsInput ;
  tags?: ItemUpdatetagsInput ;
  upsell?: UpsellUpdateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellUpdateManyWithoutItemsInput ;
  upsales?: UpsellUpdateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeUpdateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemUpdateWithoutSizesDataInput {
  categories?: CategoryUpdateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringUpdateOneWithoutItemAllergiesInput ;
  allergens?: ItemUpdateallergensInput ;
  company?: CompanyUpdateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutItemDescriptionInput ;
  discounts?: DiscountUpdateManyWithoutItemsInput ;
  image?: ImageUpdateOneWithoutItemsInput ;
  menuEntries?: MenuEntryUpdateManyWithoutItemInput ;
  offers?: OfferUpdateManyWithoutItemsInput ;
  offerStages?: OfferStageUpdateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringUpdateOneWithoutItemTitleInput ;
  variations?: VariationUpdateManyWithoutItemsInput ;
  stampCards?: StampCardUpdateManyWithoutItemsInput ;
  defaultVariations?: VariationUpdateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutItemInput ;
  groups?: ItemGroupUpdateManyWithoutItemsInput ;
  recommendations?: RecommendationUpdateManyWithoutItemInput ;
  articleMaps?: ArticleMapUpdateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationUpdateManyWithoutItemsInput ;
  tags?: ItemUpdatetagsInput ;
  upsell?: UpsellUpdateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellUpdateManyWithoutItemsInput ;
  upsales?: UpsellUpdateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeUpdateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemUpdateWithoutStampCardsDataInput {
  categories?: CategoryUpdateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringUpdateOneWithoutItemAllergiesInput ;
  allergens?: ItemUpdateallergensInput ;
  company?: CompanyUpdateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutItemDescriptionInput ;
  discounts?: DiscountUpdateManyWithoutItemsInput ;
  image?: ImageUpdateOneWithoutItemsInput ;
  menuEntries?: MenuEntryUpdateManyWithoutItemInput ;
  offers?: OfferUpdateManyWithoutItemsInput ;
  offerStages?: OfferStageUpdateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringUpdateOneWithoutItemTitleInput ;
  variations?: VariationUpdateManyWithoutItemsInput ;
  defaultVariations?: VariationUpdateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutItemInput ;
  groups?: ItemGroupUpdateManyWithoutItemsInput ;
  sizes?: ItemSizeUpdateOneWithoutItemsInput ;
  recommendations?: RecommendationUpdateManyWithoutItemInput ;
  articleMaps?: ArticleMapUpdateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationUpdateManyWithoutItemsInput ;
  tags?: ItemUpdatetagsInput ;
  upsell?: UpsellUpdateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellUpdateManyWithoutItemsInput ;
  upsales?: UpsellUpdateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeUpdateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemUpdateWithoutStationsDataInput {
  categories?: CategoryUpdateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringUpdateOneWithoutItemAllergiesInput ;
  allergens?: ItemUpdateallergensInput ;
  company?: CompanyUpdateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutItemDescriptionInput ;
  discounts?: DiscountUpdateManyWithoutItemsInput ;
  image?: ImageUpdateOneWithoutItemsInput ;
  menuEntries?: MenuEntryUpdateManyWithoutItemInput ;
  offers?: OfferUpdateManyWithoutItemsInput ;
  offerStages?: OfferStageUpdateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringUpdateOneWithoutItemTitleInput ;
  variations?: VariationUpdateManyWithoutItemsInput ;
  stampCards?: StampCardUpdateManyWithoutItemsInput ;
  defaultVariations?: VariationUpdateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutItemInput ;
  groups?: ItemGroupUpdateManyWithoutItemsInput ;
  sizes?: ItemSizeUpdateOneWithoutItemsInput ;
  recommendations?: RecommendationUpdateManyWithoutItemInput ;
  articleMaps?: ArticleMapUpdateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  tags?: ItemUpdatetagsInput ;
  upsell?: UpsellUpdateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellUpdateManyWithoutItemsInput ;
  upsales?: UpsellUpdateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeUpdateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemUpdateWithoutTitleLangDataInput {
  categories?: CategoryUpdateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringUpdateOneWithoutItemAllergiesInput ;
  allergens?: ItemUpdateallergensInput ;
  company?: CompanyUpdateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutItemDescriptionInput ;
  discounts?: DiscountUpdateManyWithoutItemsInput ;
  image?: ImageUpdateOneWithoutItemsInput ;
  menuEntries?: MenuEntryUpdateManyWithoutItemInput ;
  offers?: OfferUpdateManyWithoutItemsInput ;
  offerStages?: OfferStageUpdateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  variations?: VariationUpdateManyWithoutItemsInput ;
  stampCards?: StampCardUpdateManyWithoutItemsInput ;
  defaultVariations?: VariationUpdateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutItemInput ;
  groups?: ItemGroupUpdateManyWithoutItemsInput ;
  sizes?: ItemSizeUpdateOneWithoutItemsInput ;
  recommendations?: RecommendationUpdateManyWithoutItemInput ;
  articleMaps?: ArticleMapUpdateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationUpdateManyWithoutItemsInput ;
  tags?: ItemUpdatetagsInput ;
  upsell?: UpsellUpdateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellUpdateManyWithoutItemsInput ;
  upsales?: UpsellUpdateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeUpdateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemUpdateWithoutUpsalesDataInput {
  categories?: CategoryUpdateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringUpdateOneWithoutItemAllergiesInput ;
  allergens?: ItemUpdateallergensInput ;
  company?: CompanyUpdateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutItemDescriptionInput ;
  discounts?: DiscountUpdateManyWithoutItemsInput ;
  image?: ImageUpdateOneWithoutItemsInput ;
  menuEntries?: MenuEntryUpdateManyWithoutItemInput ;
  offers?: OfferUpdateManyWithoutItemsInput ;
  offerStages?: OfferStageUpdateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringUpdateOneWithoutItemTitleInput ;
  variations?: VariationUpdateManyWithoutItemsInput ;
  stampCards?: StampCardUpdateManyWithoutItemsInput ;
  defaultVariations?: VariationUpdateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutItemInput ;
  groups?: ItemGroupUpdateManyWithoutItemsInput ;
  sizes?: ItemSizeUpdateOneWithoutItemsInput ;
  recommendations?: RecommendationUpdateManyWithoutItemInput ;
  articleMaps?: ArticleMapUpdateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationUpdateManyWithoutItemsInput ;
  tags?: ItemUpdatetagsInput ;
  upsell?: UpsellUpdateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellUpdateManyWithoutItemsInput ;
  courseType?: CourseTypeUpdateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemUpdateWithoutUpsellDataInput {
  categories?: CategoryUpdateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringUpdateOneWithoutItemAllergiesInput ;
  allergens?: ItemUpdateallergensInput ;
  company?: CompanyUpdateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutItemDescriptionInput ;
  discounts?: DiscountUpdateManyWithoutItemsInput ;
  image?: ImageUpdateOneWithoutItemsInput ;
  menuEntries?: MenuEntryUpdateManyWithoutItemInput ;
  offers?: OfferUpdateManyWithoutItemsInput ;
  offerStages?: OfferStageUpdateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringUpdateOneWithoutItemTitleInput ;
  variations?: VariationUpdateManyWithoutItemsInput ;
  stampCards?: StampCardUpdateManyWithoutItemsInput ;
  defaultVariations?: VariationUpdateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutItemInput ;
  groups?: ItemGroupUpdateManyWithoutItemsInput ;
  sizes?: ItemSizeUpdateOneWithoutItemsInput ;
  recommendations?: RecommendationUpdateManyWithoutItemInput ;
  articleMaps?: ArticleMapUpdateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationUpdateManyWithoutItemsInput ;
  tags?: ItemUpdatetagsInput ;
  usedAsUpsellOn?: UpsellUpdateManyWithoutItemsInput ;
  upsales?: UpsellUpdateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeUpdateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemUpdateWithoutUsedAsUpsellOnDataInput {
  categories?: CategoryUpdateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringUpdateOneWithoutItemAllergiesInput ;
  allergens?: ItemUpdateallergensInput ;
  company?: CompanyUpdateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutItemDescriptionInput ;
  discounts?: DiscountUpdateManyWithoutItemsInput ;
  image?: ImageUpdateOneWithoutItemsInput ;
  menuEntries?: MenuEntryUpdateManyWithoutItemInput ;
  offers?: OfferUpdateManyWithoutItemsInput ;
  offerStages?: OfferStageUpdateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringUpdateOneWithoutItemTitleInput ;
  variations?: VariationUpdateManyWithoutItemsInput ;
  stampCards?: StampCardUpdateManyWithoutItemsInput ;
  defaultVariations?: VariationUpdateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutItemInput ;
  groups?: ItemGroupUpdateManyWithoutItemsInput ;
  sizes?: ItemSizeUpdateOneWithoutItemsInput ;
  recommendations?: RecommendationUpdateManyWithoutItemInput ;
  articleMaps?: ArticleMapUpdateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationUpdateManyWithoutItemsInput ;
  tags?: ItemUpdatetagsInput ;
  upsell?: UpsellUpdateOneWithoutUsedOnInput ;
  upsales?: UpsellUpdateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeUpdateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemUpdateWithoutVariationsDataInput {
  categories?: CategoryUpdateManyWithoutItemsInput ;
  ageRestricted?: boolean ;
  vatRate?: number ;
  allergies?: TranslatedStringUpdateOneWithoutItemAllergiesInput ;
  allergens?: ItemUpdateallergensInput ;
  company?: CompanyUpdateOneWithoutItemsInput ;
  defaultPrice?: number ;
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutItemDescriptionInput ;
  discounts?: DiscountUpdateManyWithoutItemsInput ;
  image?: ImageUpdateOneWithoutItemsInput ;
  menuEntries?: MenuEntryUpdateManyWithoutItemInput ;
  offers?: OfferUpdateManyWithoutItemsInput ;
  offerStages?: OfferStageUpdateManyWithoutItemsInput ;
  order?: number ;
  title?: string ;
  titleLang?: TranslatedStringUpdateOneWithoutItemTitleInput ;
  stampCards?: StampCardUpdateManyWithoutItemsInput ;
  defaultVariations?: VariationUpdateManyWithoutDefaultOnItemsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutItemInput ;
  groups?: ItemGroupUpdateManyWithoutItemsInput ;
  sizes?: ItemSizeUpdateOneWithoutItemsInput ;
  recommendations?: RecommendationUpdateManyWithoutItemInput ;
  articleMaps?: ArticleMapUpdateManyWithoutItemInput ;
  deleted?: boolean ;
  disableMembershipDiscount?: boolean ;
  stations?: StationUpdateManyWithoutItemsInput ;
  tags?: ItemUpdatetagsInput ;
  upsell?: UpsellUpdateOneWithoutUsedOnInput ;
  usedAsUpsellOn?: UpsellUpdateManyWithoutItemsInput ;
  upsales?: UpsellUpdateManyWithoutItemsUsedOnInput ;
  courseType?: CourseTypeUpdateOneWithoutItemsInput ;
  manualPrice?: boolean ;
  inventoryEOD?: boolean ;
  volumeSuffix?: string ;
  costBasis?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
}

export interface ItemUpdateallergensInput {
  set?: ALLERGEN[] ;
}

export interface ItemUpdatetagsInput {
  set?: string[] ;
}

export interface ItemUpsertNestedInput {
  update: ItemUpdateDataInput;
  create: ItemCreateInput;
}

export interface ItemUpsertWithWhereUniqueWithoutCategoriesInput {
  where: ItemWhereUniqueInput;
  update: ItemUpdateWithoutCategoriesDataInput;
  create: ItemCreateWithoutCategoriesInput;
}

export interface ItemUpsertWithWhereUniqueWithoutCompanyInput {
  where: ItemWhereUniqueInput;
  update: ItemUpdateWithoutCompanyDataInput;
  create: ItemCreateWithoutCompanyInput;
}

export interface ItemUpsertWithWhereUniqueWithoutCourseTypeInput {
  where: ItemWhereUniqueInput;
  update: ItemUpdateWithoutCourseTypeDataInput;
  create: ItemCreateWithoutCourseTypeInput;
}

export interface ItemUpsertWithWhereUniqueWithoutDefaultVariationsInput {
  where: ItemWhereUniqueInput;
  update: ItemUpdateWithoutDefaultVariationsDataInput;
  create: ItemCreateWithoutDefaultVariationsInput;
}

export interface ItemUpsertWithWhereUniqueWithoutDiscountsInput {
  where: ItemWhereUniqueInput;
  update: ItemUpdateWithoutDiscountsDataInput;
  create: ItemCreateWithoutDiscountsInput;
}

export interface ItemUpsertWithWhereUniqueWithoutGroupsInput {
  where: ItemWhereUniqueInput;
  update: ItemUpdateWithoutGroupsDataInput;
  create: ItemCreateWithoutGroupsInput;
}

export interface ItemUpsertWithWhereUniqueWithoutImageInput {
  where: ItemWhereUniqueInput;
  update: ItemUpdateWithoutImageDataInput;
  create: ItemCreateWithoutImageInput;
}

export interface ItemUpsertWithWhereUniqueWithoutOfferStagesInput {
  where: ItemWhereUniqueInput;
  update: ItemUpdateWithoutOfferStagesDataInput;
  create: ItemCreateWithoutOfferStagesInput;
}

export interface ItemUpsertWithWhereUniqueWithoutOffersInput {
  where: ItemWhereUniqueInput;
  update: ItemUpdateWithoutOffersDataInput;
  create: ItemCreateWithoutOffersInput;
}

export interface ItemUpsertWithWhereUniqueWithoutSizesInput {
  where: ItemWhereUniqueInput;
  update: ItemUpdateWithoutSizesDataInput;
  create: ItemCreateWithoutSizesInput;
}

export interface ItemUpsertWithWhereUniqueWithoutStampCardsInput {
  where: ItemWhereUniqueInput;
  update: ItemUpdateWithoutStampCardsDataInput;
  create: ItemCreateWithoutStampCardsInput;
}

export interface ItemUpsertWithWhereUniqueWithoutStationsInput {
  where: ItemWhereUniqueInput;
  update: ItemUpdateWithoutStationsDataInput;
  create: ItemCreateWithoutStationsInput;
}

export interface ItemUpsertWithWhereUniqueWithoutUpsalesInput {
  where: ItemWhereUniqueInput;
  update: ItemUpdateWithoutUpsalesDataInput;
  create: ItemCreateWithoutUpsalesInput;
}

export interface ItemUpsertWithWhereUniqueWithoutUpsellInput {
  where: ItemWhereUniqueInput;
  update: ItemUpdateWithoutUpsellDataInput;
  create: ItemCreateWithoutUpsellInput;
}

export interface ItemUpsertWithWhereUniqueWithoutUsedAsUpsellOnInput {
  where: ItemWhereUniqueInput;
  update: ItemUpdateWithoutUsedAsUpsellOnDataInput;
  create: ItemCreateWithoutUsedAsUpsellOnInput;
}

export interface ItemUpsertWithWhereUniqueWithoutVariationsInput {
  where: ItemWhereUniqueInput;
  update: ItemUpdateWithoutVariationsDataInput;
  create: ItemCreateWithoutVariationsInput;
}

export interface ItemUpsertWithoutAllergiesInput {
  update: ItemUpdateWithoutAllergiesDataInput;
  create: ItemCreateWithoutAllergiesInput;
}

export interface ItemUpsertWithoutAppliedVariationsInput {
  update: ItemUpdateWithoutAppliedVariationsDataInput;
  create: ItemCreateWithoutAppliedVariationsInput;
}

export interface ItemUpsertWithoutArticleMapsInput {
  update: ItemUpdateWithoutArticleMapsDataInput;
  create: ItemCreateWithoutArticleMapsInput;
}

export interface ItemUpsertWithoutDescriptionLangInput {
  update: ItemUpdateWithoutDescriptionLangDataInput;
  create: ItemCreateWithoutDescriptionLangInput;
}

export interface ItemUpsertWithoutMenuEntriesInput {
  update: ItemUpdateWithoutMenuEntriesDataInput;
  create: ItemCreateWithoutMenuEntriesInput;
}

export interface ItemUpsertWithoutRecommendationsInput {
  update: ItemUpdateWithoutRecommendationsDataInput;
  create: ItemCreateWithoutRecommendationsInput;
}

export interface ItemUpsertWithoutTitleLangInput {
  update: ItemUpdateWithoutTitleLangDataInput;
  create: ItemCreateWithoutTitleLangInput;
}

export interface ItemWhereInput {
  categories_every?: CategoryWhereInput ;
  categories_some?: CategoryWhereInput ;
  categories_none?: CategoryWhereInput ;
  ageRestricted?: boolean ;
  ageRestricted_not?: boolean ;
  vatRate?: number ;
  vatRate_not?: number ;
  vatRate_in?: number[] ;
  vatRate_not_in?: number[] ;
  vatRate_lt?: number ;
  vatRate_lte?: number ;
  vatRate_gt?: number ;
  vatRate_gte?: number ;
  allergies?: TranslatedStringWhereInput ;
  company?: CompanyWhereInput ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  defaultPrice?: number ;
  defaultPrice_not?: number ;
  defaultPrice_in?: number[] ;
  defaultPrice_not_in?: number[] ;
  defaultPrice_lt?: number ;
  defaultPrice_lte?: number ;
  defaultPrice_gt?: number ;
  defaultPrice_gte?: number ;
  description?: string ;
  description_not?: string ;
  description_in?: string[] ;
  description_not_in?: string[] ;
  description_lt?: string ;
  description_lte?: string ;
  description_gt?: string ;
  description_gte?: string ;
  description_contains?: string ;
  description_not_contains?: string ;
  description_starts_with?: string ;
  description_not_starts_with?: string ;
  description_ends_with?: string ;
  description_not_ends_with?: string ;
  descriptionLang?: TranslatedStringWhereInput ;
  discounts_every?: DiscountWhereInput ;
  discounts_some?: DiscountWhereInput ;
  discounts_none?: DiscountWhereInput ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  image?: ImageWhereInput ;
  menuEntries_every?: MenuEntryWhereInput ;
  menuEntries_some?: MenuEntryWhereInput ;
  menuEntries_none?: MenuEntryWhereInput ;
  offers_every?: OfferWhereInput ;
  offers_some?: OfferWhereInput ;
  offers_none?: OfferWhereInput ;
  offerStages_every?: OfferStageWhereInput ;
  offerStages_some?: OfferStageWhereInput ;
  offerStages_none?: OfferStageWhereInput ;
  order?: number ;
  order_not?: number ;
  order_in?: number[] ;
  order_not_in?: number[] ;
  order_lt?: number ;
  order_lte?: number ;
  order_gt?: number ;
  order_gte?: number ;
  title?: string ;
  title_not?: string ;
  title_in?: string[] ;
  title_not_in?: string[] ;
  title_lt?: string ;
  title_lte?: string ;
  title_gt?: string ;
  title_gte?: string ;
  title_contains?: string ;
  title_not_contains?: string ;
  title_starts_with?: string ;
  title_not_starts_with?: string ;
  title_ends_with?: string ;
  title_not_ends_with?: string ;
  titleLang?: TranslatedStringWhereInput ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  variations_every?: VariationWhereInput ;
  variations_some?: VariationWhereInput ;
  variations_none?: VariationWhereInput ;
  stampCards_every?: StampCardWhereInput ;
  stampCards_some?: StampCardWhereInput ;
  stampCards_none?: StampCardWhereInput ;
  defaultVariations_every?: VariationWhereInput ;
  defaultVariations_some?: VariationWhereInput ;
  defaultVariations_none?: VariationWhereInput ;
  appliedVariations_every?: AppliedVariationWhereInput ;
  appliedVariations_some?: AppliedVariationWhereInput ;
  appliedVariations_none?: AppliedVariationWhereInput ;
  groups_every?: ItemGroupWhereInput ;
  groups_some?: ItemGroupWhereInput ;
  groups_none?: ItemGroupWhereInput ;
  sizes?: ItemSizeWhereInput ;
  recommendations_every?: RecommendationWhereInput ;
  recommendations_some?: RecommendationWhereInput ;
  recommendations_none?: RecommendationWhereInput ;
  articleMaps_every?: ArticleMapWhereInput ;
  articleMaps_some?: ArticleMapWhereInput ;
  articleMaps_none?: ArticleMapWhereInput ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  disableMembershipDiscount?: boolean ;
  disableMembershipDiscount_not?: boolean ;
  stations_every?: StationWhereInput ;
  stations_some?: StationWhereInput ;
  stations_none?: StationWhereInput ;
  upsell?: UpsellWhereInput ;
  usedAsUpsellOn_every?: UpsellWhereInput ;
  usedAsUpsellOn_some?: UpsellWhereInput ;
  usedAsUpsellOn_none?: UpsellWhereInput ;
  upsales_every?: UpsellWhereInput ;
  upsales_some?: UpsellWhereInput ;
  upsales_none?: UpsellWhereInput ;
  courseType?: CourseTypeWhereInput ;
  manualPrice?: boolean ;
  manualPrice_not?: boolean ;
  inventoryEOD?: boolean ;
  inventoryEOD_not?: boolean ;
  volumeSuffix?: string ;
  volumeSuffix_not?: string ;
  volumeSuffix_in?: string[] ;
  volumeSuffix_not_in?: string[] ;
  volumeSuffix_lt?: string ;
  volumeSuffix_lte?: string ;
  volumeSuffix_gt?: string ;
  volumeSuffix_gte?: string ;
  volumeSuffix_contains?: string ;
  volumeSuffix_not_contains?: string ;
  volumeSuffix_starts_with?: string ;
  volumeSuffix_not_starts_with?: string ;
  volumeSuffix_ends_with?: string ;
  volumeSuffix_not_ends_with?: string ;
  costBasis?: number ;
  costBasis_not?: number ;
  costBasis_in?: number[] ;
  costBasis_not_in?: number[] ;
  costBasis_lt?: number ;
  costBasis_lte?: number ;
  costBasis_gt?: number ;
  costBasis_gte?: number ;
  defaultOrderStatus?: ORDER_STATUS ;
  defaultOrderStatus_not?: ORDER_STATUS ;
  defaultOrderStatus_in?: ORDER_STATUS[] ;
  defaultOrderStatus_not_in?: ORDER_STATUS[] ;
  AND?: ItemWhereInput[] ;
  OR?: ItemWhereInput[] ;
  NOT?: ItemWhereInput[] ;
}

export interface ItemWhereUniqueInput {
  id?: string ;
}

export interface ItemappliedVariationsAppliedVariation {
  default?: boolean ;
  expandedByDefault?: boolean ;
  required?: boolean ;
  groupId?: string ;
  variationId?: string ;
}

export interface ItemdescriptionLangTranslatedString {
  en?: string ;
  no?: string ;
  se?: string ;
  es?: string ;
  pt?: string ;
}

export interface ItemtitleLangTranslatedString {
  en?: string ;
  no?: string ;
  se?: string ;
  es?: string ;
  pt?: string ;
}

export interface KeyValueCreateManyWithoutIntegrationInput {
  create?: KeyValueCreateWithoutIntegrationInput[] ;
  connect?: KeyValueWhereUniqueInput[] ;
}

export interface KeyValueCreateWithoutIntegrationInput {
  id?: string ;
  key: string;
  value: string;
}

export interface KeyValueScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  key?: string ;
  key_not?: string ;
  key_in?: string[] ;
  key_not_in?: string[] ;
  key_lt?: string ;
  key_lte?: string ;
  key_gt?: string ;
  key_gte?: string ;
  key_contains?: string ;
  key_not_contains?: string ;
  key_starts_with?: string ;
  key_not_starts_with?: string ;
  key_ends_with?: string ;
  key_not_ends_with?: string ;
  value?: string ;
  value_not?: string ;
  value_in?: string[] ;
  value_not_in?: string[] ;
  value_lt?: string ;
  value_lte?: string ;
  value_gt?: string ;
  value_gte?: string ;
  value_contains?: string ;
  value_not_contains?: string ;
  value_starts_with?: string ;
  value_not_starts_with?: string ;
  value_ends_with?: string ;
  value_not_ends_with?: string ;
  AND?: KeyValueScalarWhereInput[] ;
  OR?: KeyValueScalarWhereInput[] ;
  NOT?: KeyValueScalarWhereInput[] ;
}

export interface KeyValueUpdateManyDataInput {
  key?: string ;
  value?: string ;
}

export interface KeyValueUpdateManyWithWhereNestedInput {
  where: KeyValueScalarWhereInput;
  data: KeyValueUpdateManyDataInput;
}

export interface KeyValueUpdateManyWithoutIntegrationInput {
  create?: KeyValueCreateWithoutIntegrationInput[] ;
  connect?: KeyValueWhereUniqueInput[] ;
  set?: KeyValueWhereUniqueInput[] ;
  disconnect?: KeyValueWhereUniqueInput[] ;
  update?: KeyValueUpdateWithWhereUniqueWithoutIntegrationInput[] ;
  upsert?: KeyValueUpsertWithWhereUniqueWithoutIntegrationInput[] ;
  deleteMany?: KeyValueScalarWhereInput[] ;
  updateMany?: KeyValueUpdateManyWithWhereNestedInput[] ;
}

export interface KeyValueUpdateWithWhereUniqueWithoutIntegrationInput {
  where: KeyValueWhereUniqueInput;
  data: KeyValueUpdateWithoutIntegrationDataInput;
}

export interface KeyValueUpdateWithoutIntegrationDataInput {
  key?: string ;
  value?: string ;
}

export interface KeyValueUpsertWithWhereUniqueWithoutIntegrationInput {
  where: KeyValueWhereUniqueInput;
  update: KeyValueUpdateWithoutIntegrationDataInput;
  create: KeyValueCreateWithoutIntegrationInput;
}

export interface KeyValueWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  integration?: IntegrationWhereInput ;
  key?: string ;
  key_not?: string ;
  key_in?: string[] ;
  key_not_in?: string[] ;
  key_lt?: string ;
  key_lte?: string ;
  key_gt?: string ;
  key_gte?: string ;
  key_contains?: string ;
  key_not_contains?: string ;
  key_starts_with?: string ;
  key_not_starts_with?: string ;
  key_ends_with?: string ;
  key_not_ends_with?: string ;
  value?: string ;
  value_not?: string ;
  value_in?: string[] ;
  value_not_in?: string[] ;
  value_lt?: string ;
  value_lte?: string ;
  value_gt?: string ;
  value_gte?: string ;
  value_contains?: string ;
  value_not_contains?: string ;
  value_starts_with?: string ;
  value_not_starts_with?: string ;
  value_ends_with?: string ;
  value_not_ends_with?: string ;
  AND?: KeyValueWhereInput[] ;
  OR?: KeyValueWhereInput[] ;
  NOT?: KeyValueWhereInput[] ;
}

export interface KeyValueWhereUniqueInput {
  id?: string ;
}

export interface LayoutCreateInput {
  id?: string ;
  deleted?: boolean ;
  name: TranslatedStringCreateOneWithoutLayoutInput;
  company: CompanyCreateOneWithoutLayoutsInput;
  categories?: PosCategoryCreateManyWithoutLayoutInput ;
}

export interface LayoutCreateManyWithoutCompanyInput {
  create?: LayoutCreateWithoutCompanyInput[] ;
  connect?: LayoutWhereUniqueInput[] ;
}

export interface LayoutCreateOneWithoutCategoriesInput {
  create?: LayoutCreateWithoutCategoriesInput ;
  connect?: LayoutWhereUniqueInput ;
}

export interface LayoutCreateOneWithoutNameInput {
  create?: LayoutCreateWithoutNameInput ;
  connect?: LayoutWhereUniqueInput ;
}

export interface LayoutCreateWithoutCategoriesInput {
  id?: string ;
  deleted?: boolean ;
  name: TranslatedStringCreateOneWithoutLayoutInput;
  company: CompanyCreateOneWithoutLayoutsInput;
}

export interface LayoutCreateWithoutCompanyInput {
  id?: string ;
  deleted?: boolean ;
  name: TranslatedStringCreateOneWithoutLayoutInput;
  categories?: PosCategoryCreateManyWithoutLayoutInput ;
}

export interface LayoutCreateWithoutNameInput {
  id?: string ;
  deleted?: boolean ;
  company: CompanyCreateOneWithoutLayoutsInput;
  categories?: PosCategoryCreateManyWithoutLayoutInput ;
}

export interface LayoutScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  AND?: LayoutScalarWhereInput[] ;
  OR?: LayoutScalarWhereInput[] ;
  NOT?: LayoutScalarWhereInput[] ;
}

export interface LayoutUpdateInput {
  deleted?: boolean ;
  name?: TranslatedStringUpdateOneRequiredWithoutLayoutInput ;
  company?: CompanyUpdateOneRequiredWithoutLayoutsInput ;
  categories?: PosCategoryUpdateManyWithoutLayoutInput ;
}

export interface LayoutUpdateManyDataInput {
  deleted?: boolean ;
}

export interface LayoutUpdateManyWithWhereNestedInput {
  where: LayoutScalarWhereInput;
  data: LayoutUpdateManyDataInput;
}

export interface LayoutUpdateManyWithoutCompanyInput {
  create?: LayoutCreateWithoutCompanyInput[] ;
  connect?: LayoutWhereUniqueInput[] ;
  set?: LayoutWhereUniqueInput[] ;
  disconnect?: LayoutWhereUniqueInput[] ;
  update?: LayoutUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: LayoutUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: LayoutScalarWhereInput[] ;
  updateMany?: LayoutUpdateManyWithWhereNestedInput[] ;
}

export interface LayoutUpdateOneRequiredWithoutCategoriesInput {
  create?: LayoutCreateWithoutCategoriesInput ;
  update?: LayoutUpdateWithoutCategoriesDataInput ;
  upsert?: LayoutUpsertWithoutCategoriesInput ;
  connect?: LayoutWhereUniqueInput ;
}

export interface LayoutUpdateOneWithoutNameInput {
  create?: LayoutCreateWithoutNameInput ;
  update?: LayoutUpdateWithoutNameDataInput ;
  upsert?: LayoutUpsertWithoutNameInput ;
  disconnect?: boolean ;
  connect?: LayoutWhereUniqueInput ;
}

export interface LayoutUpdateWithWhereUniqueWithoutCompanyInput {
  where: LayoutWhereUniqueInput;
  data: LayoutUpdateWithoutCompanyDataInput;
}

export interface LayoutUpdateWithoutCategoriesDataInput {
  deleted?: boolean ;
  name?: TranslatedStringUpdateOneRequiredWithoutLayoutInput ;
  company?: CompanyUpdateOneRequiredWithoutLayoutsInput ;
}

export interface LayoutUpdateWithoutCompanyDataInput {
  deleted?: boolean ;
  name?: TranslatedStringUpdateOneRequiredWithoutLayoutInput ;
  categories?: PosCategoryUpdateManyWithoutLayoutInput ;
}

export interface LayoutUpdateWithoutNameDataInput {
  deleted?: boolean ;
  company?: CompanyUpdateOneRequiredWithoutLayoutsInput ;
  categories?: PosCategoryUpdateManyWithoutLayoutInput ;
}

export interface LayoutUpsertWithWhereUniqueWithoutCompanyInput {
  where: LayoutWhereUniqueInput;
  update: LayoutUpdateWithoutCompanyDataInput;
  create: LayoutCreateWithoutCompanyInput;
}

export interface LayoutUpsertWithoutCategoriesInput {
  update: LayoutUpdateWithoutCategoriesDataInput;
  create: LayoutCreateWithoutCategoriesInput;
}

export interface LayoutUpsertWithoutNameInput {
  update: LayoutUpdateWithoutNameDataInput;
  create: LayoutCreateWithoutNameInput;
}

export interface LayoutWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  name?: TranslatedStringWhereInput ;
  company?: CompanyWhereInput ;
  categories_every?: PosCategoryWhereInput ;
  categories_some?: PosCategoryWhereInput ;
  categories_none?: PosCategoryWhereInput ;
  AND?: LayoutWhereInput[] ;
  OR?: LayoutWhereInput[] ;
  NOT?: LayoutWhereInput[] ;
}

export interface LayoutWhereUniqueInput {
  id?: string ;
}

export interface LocalDeliveryOptionsCreateManyWithoutFeeInput {
  create?: LocalDeliveryOptionsCreateWithoutFeeInput[] ;
  connect?: LocalDeliveryOptionsWhereUniqueInput[] ;
}

export interface LocalDeliveryOptionsCreateOneWithoutVenuesInput {
  create?: LocalDeliveryOptionsCreateWithoutVenuesInput ;
  connect?: LocalDeliveryOptionsWhereUniqueInput ;
}

export interface LocalDeliveryOptionsCreateWithoutFeeInput {
  id?: string ;
  options?: LocalDeliveryOptionsCreateoptionsInput ;
  venues?: VenueCreateManyWithoutLocalDeliveriesInput ;
}

export interface LocalDeliveryOptionsCreateWithoutVenuesInput {
  id?: string ;
  options?: LocalDeliveryOptionsCreateoptionsInput ;
  fee: FeeCreateOneWithoutLocalDeliveryRatesInput;
}

export interface LocalDeliveryOptionsCreateoptionsInput {
  set?: string[] ;
}

export interface LocalDeliveryOptionsScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  AND?: LocalDeliveryOptionsScalarWhereInput[] ;
  OR?: LocalDeliveryOptionsScalarWhereInput[] ;
  NOT?: LocalDeliveryOptionsScalarWhereInput[] ;
}

export interface LocalDeliveryOptionsUpdateManyDataInput {
  options?: LocalDeliveryOptionsUpdateoptionsInput ;
}

export interface LocalDeliveryOptionsUpdateManyWithWhereNestedInput {
  where: LocalDeliveryOptionsScalarWhereInput;
  data: LocalDeliveryOptionsUpdateManyDataInput;
}

export interface LocalDeliveryOptionsUpdateManyWithoutFeeInput {
  create?: LocalDeliveryOptionsCreateWithoutFeeInput[] ;
  connect?: LocalDeliveryOptionsWhereUniqueInput[] ;
  set?: LocalDeliveryOptionsWhereUniqueInput[] ;
  disconnect?: LocalDeliveryOptionsWhereUniqueInput[] ;
  update?: LocalDeliveryOptionsUpdateWithWhereUniqueWithoutFeeInput[] ;
  upsert?: LocalDeliveryOptionsUpsertWithWhereUniqueWithoutFeeInput[] ;
  deleteMany?: LocalDeliveryOptionsScalarWhereInput[] ;
  updateMany?: LocalDeliveryOptionsUpdateManyWithWhereNestedInput[] ;
}

export interface LocalDeliveryOptionsUpdateOneWithoutVenuesInput {
  create?: LocalDeliveryOptionsCreateWithoutVenuesInput ;
  update?: LocalDeliveryOptionsUpdateWithoutVenuesDataInput ;
  upsert?: LocalDeliveryOptionsUpsertWithoutVenuesInput ;
  disconnect?: boolean ;
  connect?: LocalDeliveryOptionsWhereUniqueInput ;
}

export interface LocalDeliveryOptionsUpdateWithWhereUniqueWithoutFeeInput {
  where: LocalDeliveryOptionsWhereUniqueInput;
  data: LocalDeliveryOptionsUpdateWithoutFeeDataInput;
}

export interface LocalDeliveryOptionsUpdateWithoutFeeDataInput {
  options?: LocalDeliveryOptionsUpdateoptionsInput ;
  venues?: VenueUpdateManyWithoutLocalDeliveriesInput ;
}

export interface LocalDeliveryOptionsUpdateWithoutVenuesDataInput {
  options?: LocalDeliveryOptionsUpdateoptionsInput ;
  fee?: FeeUpdateOneRequiredWithoutLocalDeliveryRatesInput ;
}

export interface LocalDeliveryOptionsUpdateoptionsInput {
  set?: string[] ;
}

export interface LocalDeliveryOptionsUpsertWithWhereUniqueWithoutFeeInput {
  where: LocalDeliveryOptionsWhereUniqueInput;
  update: LocalDeliveryOptionsUpdateWithoutFeeDataInput;
  create: LocalDeliveryOptionsCreateWithoutFeeInput;
}

export interface LocalDeliveryOptionsUpsertWithoutVenuesInput {
  update: LocalDeliveryOptionsUpdateWithoutVenuesDataInput;
  create: LocalDeliveryOptionsCreateWithoutVenuesInput;
}

export interface LocalDeliveryOptionsWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  fee?: FeeWhereInput ;
  venues_every?: VenueWhereInput ;
  venues_some?: VenueWhereInput ;
  venues_none?: VenueWhereInput ;
  AND?: LocalDeliveryOptionsWhereInput[] ;
  OR?: LocalDeliveryOptionsWhereInput[] ;
  NOT?: LocalDeliveryOptionsWhereInput[] ;
}

export interface LocalDeliveryOptionsWhereUniqueInput {
  id?: string ;
}

export interface LocationCreateManyWithoutUserInput {
  create?: LocationCreateWithoutUserInput[] ;
  connect?: LocationWhereUniqueInput[] ;
}

export interface LocationCreateOneWithoutOrdersInput {
  create?: LocationCreateWithoutOrdersInput ;
  connect?: LocationWhereUniqueInput ;
}

export interface LocationCreateOneWithoutVenueInput {
  create?: LocationCreateWithoutVenueInput ;
  connect?: LocationWhereUniqueInput ;
}

export interface LocationCreateWithoutOrdersInput {
  id?: string ;
  lat: string;
  long: string;
  name: string;
  venue?: VenueCreateOneWithoutLocationInput ;
  city?: string ;
  street?: string ;
  user?: UserCreateOneWithoutLocationsInput ;
  zip?: number ;
}

export interface LocationCreateWithoutUserInput {
  id?: string ;
  lat: string;
  long: string;
  name: string;
  venue?: VenueCreateOneWithoutLocationInput ;
  city?: string ;
  orders?: OrderCreateManyWithoutDeliveryLocationInput ;
  street?: string ;
  zip?: number ;
}

export interface LocationCreateWithoutVenueInput {
  id?: string ;
  lat: string;
  long: string;
  name: string;
  city?: string ;
  orders?: OrderCreateManyWithoutDeliveryLocationInput ;
  street?: string ;
  user?: UserCreateOneWithoutLocationsInput ;
  zip?: number ;
}

export interface LocationScalarWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  lat?: string ;
  lat_not?: string ;
  lat_in?: string[] ;
  lat_not_in?: string[] ;
  lat_lt?: string ;
  lat_lte?: string ;
  lat_gt?: string ;
  lat_gte?: string ;
  lat_contains?: string ;
  lat_not_contains?: string ;
  lat_starts_with?: string ;
  lat_not_starts_with?: string ;
  lat_ends_with?: string ;
  lat_not_ends_with?: string ;
  long?: string ;
  long_not?: string ;
  long_in?: string[] ;
  long_not_in?: string[] ;
  long_lt?: string ;
  long_lte?: string ;
  long_gt?: string ;
  long_gte?: string ;
  long_contains?: string ;
  long_not_contains?: string ;
  long_starts_with?: string ;
  long_not_starts_with?: string ;
  long_ends_with?: string ;
  long_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  city?: string ;
  city_not?: string ;
  city_in?: string[] ;
  city_not_in?: string[] ;
  city_lt?: string ;
  city_lte?: string ;
  city_gt?: string ;
  city_gte?: string ;
  city_contains?: string ;
  city_not_contains?: string ;
  city_starts_with?: string ;
  city_not_starts_with?: string ;
  city_ends_with?: string ;
  city_not_ends_with?: string ;
  street?: string ;
  street_not?: string ;
  street_in?: string[] ;
  street_not_in?: string[] ;
  street_lt?: string ;
  street_lte?: string ;
  street_gt?: string ;
  street_gte?: string ;
  street_contains?: string ;
  street_not_contains?: string ;
  street_starts_with?: string ;
  street_not_starts_with?: string ;
  street_ends_with?: string ;
  street_not_ends_with?: string ;
  zip?: number ;
  zip_not?: number ;
  zip_in?: number[] ;
  zip_not_in?: number[] ;
  zip_lt?: number ;
  zip_lte?: number ;
  zip_gt?: number ;
  zip_gte?: number ;
  AND?: LocationScalarWhereInput[] ;
  OR?: LocationScalarWhereInput[] ;
  NOT?: LocationScalarWhereInput[] ;
}

export interface LocationUpdateManyDataInput {
  lat?: string ;
  long?: string ;
  name?: string ;
  city?: string ;
  street?: string ;
  zip?: number ;
}

export interface LocationUpdateManyWithWhereNestedInput {
  where: LocationScalarWhereInput;
  data: LocationUpdateManyDataInput;
}

export interface LocationUpdateManyWithoutUserInput {
  create?: LocationCreateWithoutUserInput[] ;
  connect?: LocationWhereUniqueInput[] ;
  set?: LocationWhereUniqueInput[] ;
  disconnect?: LocationWhereUniqueInput[] ;
  update?: LocationUpdateWithWhereUniqueWithoutUserInput[] ;
  upsert?: LocationUpsertWithWhereUniqueWithoutUserInput[] ;
  deleteMany?: LocationScalarWhereInput[] ;
  updateMany?: LocationUpdateManyWithWhereNestedInput[] ;
}

export interface LocationUpdateOneWithoutOrdersInput {
  create?: LocationCreateWithoutOrdersInput ;
  update?: LocationUpdateWithoutOrdersDataInput ;
  upsert?: LocationUpsertWithoutOrdersInput ;
  disconnect?: boolean ;
  connect?: LocationWhereUniqueInput ;
}

export interface LocationUpdateOneWithoutVenueInput {
  create?: LocationCreateWithoutVenueInput ;
  update?: LocationUpdateWithoutVenueDataInput ;
  upsert?: LocationUpsertWithoutVenueInput ;
  disconnect?: boolean ;
  connect?: LocationWhereUniqueInput ;
}

export interface LocationUpdateWithWhereUniqueWithoutUserInput {
  where: LocationWhereUniqueInput;
  data: LocationUpdateWithoutUserDataInput;
}

export interface LocationUpdateWithoutOrdersDataInput {
  lat?: string ;
  long?: string ;
  name?: string ;
  venue?: VenueUpdateOneWithoutLocationInput ;
  city?: string ;
  street?: string ;
  user?: UserUpdateOneWithoutLocationsInput ;
  zip?: number ;
}

export interface LocationUpdateWithoutUserDataInput {
  lat?: string ;
  long?: string ;
  name?: string ;
  venue?: VenueUpdateOneWithoutLocationInput ;
  city?: string ;
  orders?: OrderUpdateManyWithoutDeliveryLocationInput ;
  street?: string ;
  zip?: number ;
}

export interface LocationUpdateWithoutVenueDataInput {
  lat?: string ;
  long?: string ;
  name?: string ;
  city?: string ;
  orders?: OrderUpdateManyWithoutDeliveryLocationInput ;
  street?: string ;
  user?: UserUpdateOneWithoutLocationsInput ;
  zip?: number ;
}

export interface LocationUpsertWithWhereUniqueWithoutUserInput {
  where: LocationWhereUniqueInput;
  update: LocationUpdateWithoutUserDataInput;
  create: LocationCreateWithoutUserInput;
}

export interface LocationUpsertWithoutOrdersInput {
  update: LocationUpdateWithoutOrdersDataInput;
  create: LocationCreateWithoutOrdersInput;
}

export interface LocationUpsertWithoutVenueInput {
  update: LocationUpdateWithoutVenueDataInput;
  create: LocationCreateWithoutVenueInput;
}

export interface LocationWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  lat?: string ;
  lat_not?: string ;
  lat_in?: string[] ;
  lat_not_in?: string[] ;
  lat_lt?: string ;
  lat_lte?: string ;
  lat_gt?: string ;
  lat_gte?: string ;
  lat_contains?: string ;
  lat_not_contains?: string ;
  lat_starts_with?: string ;
  lat_not_starts_with?: string ;
  lat_ends_with?: string ;
  lat_not_ends_with?: string ;
  long?: string ;
  long_not?: string ;
  long_in?: string[] ;
  long_not_in?: string[] ;
  long_lt?: string ;
  long_lte?: string ;
  long_gt?: string ;
  long_gte?: string ;
  long_contains?: string ;
  long_not_contains?: string ;
  long_starts_with?: string ;
  long_not_starts_with?: string ;
  long_ends_with?: string ;
  long_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  venue?: VenueWhereInput ;
  city?: string ;
  city_not?: string ;
  city_in?: string[] ;
  city_not_in?: string[] ;
  city_lt?: string ;
  city_lte?: string ;
  city_gt?: string ;
  city_gte?: string ;
  city_contains?: string ;
  city_not_contains?: string ;
  city_starts_with?: string ;
  city_not_starts_with?: string ;
  city_ends_with?: string ;
  city_not_ends_with?: string ;
  orders_every?: OrderWhereInput ;
  orders_some?: OrderWhereInput ;
  orders_none?: OrderWhereInput ;
  street?: string ;
  street_not?: string ;
  street_in?: string[] ;
  street_not_in?: string[] ;
  street_lt?: string ;
  street_lte?: string ;
  street_gt?: string ;
  street_gte?: string ;
  street_contains?: string ;
  street_not_contains?: string ;
  street_starts_with?: string ;
  street_not_starts_with?: string ;
  street_ends_with?: string ;
  street_not_ends_with?: string ;
  user?: UserWhereInput ;
  zip?: number ;
  zip_not?: number ;
  zip_in?: number[] ;
  zip_not_in?: number[] ;
  zip_lt?: number ;
  zip_lte?: number ;
  zip_gt?: number ;
  zip_gte?: number ;
  AND?: LocationWhereInput[] ;
  OR?: LocationWhereInput[] ;
  NOT?: LocationWhereInput[] ;
}

export interface LocationWhereUniqueInput {
  id?: string ;
}

export interface LogCreateManyWithoutUserInput {
  create?: LogCreateWithoutUserInput[] ;
  connect?: LogWhereUniqueInput[] ;
}

export interface LogCreateWithoutUserInput {
  id?: string ;
  content?: any ;
  message?: string ;
  logLevel?: LOG_LEVEL ;
  context?: string ;
  actionLog?: ActionLogCreateOneWithoutLogInput ;
  requestId?: string ;
  stack?: string ;
  index?: number ;
}

export interface LogScalarWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  message?: string ;
  message_not?: string ;
  message_in?: string[] ;
  message_not_in?: string[] ;
  message_lt?: string ;
  message_lte?: string ;
  message_gt?: string ;
  message_gte?: string ;
  message_contains?: string ;
  message_not_contains?: string ;
  message_starts_with?: string ;
  message_not_starts_with?: string ;
  message_ends_with?: string ;
  message_not_ends_with?: string ;
  logLevel?: LOG_LEVEL ;
  logLevel_not?: LOG_LEVEL ;
  logLevel_in?: LOG_LEVEL[] ;
  logLevel_not_in?: LOG_LEVEL[] ;
  context?: string ;
  context_not?: string ;
  context_in?: string[] ;
  context_not_in?: string[] ;
  context_lt?: string ;
  context_lte?: string ;
  context_gt?: string ;
  context_gte?: string ;
  context_contains?: string ;
  context_not_contains?: string ;
  context_starts_with?: string ;
  context_not_starts_with?: string ;
  context_ends_with?: string ;
  context_not_ends_with?: string ;
  requestId?: string ;
  requestId_not?: string ;
  requestId_in?: string[] ;
  requestId_not_in?: string[] ;
  requestId_lt?: string ;
  requestId_lte?: string ;
  requestId_gt?: string ;
  requestId_gte?: string ;
  requestId_contains?: string ;
  requestId_not_contains?: string ;
  requestId_starts_with?: string ;
  requestId_not_starts_with?: string ;
  requestId_ends_with?: string ;
  requestId_not_ends_with?: string ;
  stack?: string ;
  stack_not?: string ;
  stack_in?: string[] ;
  stack_not_in?: string[] ;
  stack_lt?: string ;
  stack_lte?: string ;
  stack_gt?: string ;
  stack_gte?: string ;
  stack_contains?: string ;
  stack_not_contains?: string ;
  stack_starts_with?: string ;
  stack_not_starts_with?: string ;
  stack_ends_with?: string ;
  stack_not_ends_with?: string ;
  index?: number ;
  index_not?: number ;
  index_in?: number[] ;
  index_not_in?: number[] ;
  index_lt?: number ;
  index_lte?: number ;
  index_gt?: number ;
  index_gte?: number ;
  AND?: LogScalarWhereInput[] ;
  OR?: LogScalarWhereInput[] ;
  NOT?: LogScalarWhereInput[] ;
}

export interface LogUpdateManyDataInput {
  content?: any ;
  message?: string ;
  logLevel?: LOG_LEVEL ;
  context?: string ;
  requestId?: string ;
  stack?: string ;
  index?: number ;
}

export interface LogUpdateManyWithWhereNestedInput {
  where: LogScalarWhereInput;
  data: LogUpdateManyDataInput;
}

export interface LogUpdateManyWithoutUserInput {
  create?: LogCreateWithoutUserInput[] ;
  connect?: LogWhereUniqueInput[] ;
  set?: LogWhereUniqueInput[] ;
  disconnect?: LogWhereUniqueInput[] ;
  update?: LogUpdateWithWhereUniqueWithoutUserInput[] ;
  upsert?: LogUpsertWithWhereUniqueWithoutUserInput[] ;
  deleteMany?: LogScalarWhereInput[] ;
  updateMany?: LogUpdateManyWithWhereNestedInput[] ;
}

export interface LogUpdateWithWhereUniqueWithoutUserInput {
  where: LogWhereUniqueInput;
  data: LogUpdateWithoutUserDataInput;
}

export interface LogUpdateWithoutUserDataInput {
  content?: any ;
  message?: string ;
  logLevel?: LOG_LEVEL ;
  context?: string ;
  actionLog?: ActionLogUpdateOneWithoutLogInput ;
  requestId?: string ;
  stack?: string ;
  index?: number ;
}

export interface LogUpsertWithWhereUniqueWithoutUserInput {
  where: LogWhereUniqueInput;
  update: LogUpdateWithoutUserDataInput;
  create: LogCreateWithoutUserInput;
}

export interface LogWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  message?: string ;
  message_not?: string ;
  message_in?: string[] ;
  message_not_in?: string[] ;
  message_lt?: string ;
  message_lte?: string ;
  message_gt?: string ;
  message_gte?: string ;
  message_contains?: string ;
  message_not_contains?: string ;
  message_starts_with?: string ;
  message_not_starts_with?: string ;
  message_ends_with?: string ;
  message_not_ends_with?: string ;
  logLevel?: LOG_LEVEL ;
  logLevel_not?: LOG_LEVEL ;
  logLevel_in?: LOG_LEVEL[] ;
  logLevel_not_in?: LOG_LEVEL[] ;
  context?: string ;
  context_not?: string ;
  context_in?: string[] ;
  context_not_in?: string[] ;
  context_lt?: string ;
  context_lte?: string ;
  context_gt?: string ;
  context_gte?: string ;
  context_contains?: string ;
  context_not_contains?: string ;
  context_starts_with?: string ;
  context_not_starts_with?: string ;
  context_ends_with?: string ;
  context_not_ends_with?: string ;
  user?: UserWhereInput ;
  actionLog?: ActionLogWhereInput ;
  requestId?: string ;
  requestId_not?: string ;
  requestId_in?: string[] ;
  requestId_not_in?: string[] ;
  requestId_lt?: string ;
  requestId_lte?: string ;
  requestId_gt?: string ;
  requestId_gte?: string ;
  requestId_contains?: string ;
  requestId_not_contains?: string ;
  requestId_starts_with?: string ;
  requestId_not_starts_with?: string ;
  requestId_ends_with?: string ;
  requestId_not_ends_with?: string ;
  stack?: string ;
  stack_not?: string ;
  stack_in?: string[] ;
  stack_not_in?: string[] ;
  stack_lt?: string ;
  stack_lte?: string ;
  stack_gt?: string ;
  stack_gte?: string ;
  stack_contains?: string ;
  stack_not_contains?: string ;
  stack_starts_with?: string ;
  stack_not_starts_with?: string ;
  stack_ends_with?: string ;
  stack_not_ends_with?: string ;
  index?: number ;
  index_not?: number ;
  index_in?: number[] ;
  index_not_in?: number[] ;
  index_lt?: number ;
  index_lte?: number ;
  index_gt?: number ;
  index_gte?: number ;
  AND?: LogWhereInput[] ;
  OR?: LogWhereInput[] ;
  NOT?: LogWhereInput[] ;
}

export interface LogWhereUniqueInput {
  id?: string ;
}

export interface MembershipAssignmentCreateManyWithoutMembershipLevelInput {
  create?: MembershipAssignmentCreateWithoutMembershipLevelInput[] ;
  connect?: MembershipAssignmentWhereUniqueInput[] ;
}

export interface MembershipAssignmentCreateManyWithoutUserInput {
  create?: MembershipAssignmentCreateWithoutUserInput[] ;
  connect?: MembershipAssignmentWhereUniqueInput[] ;
}

export interface MembershipAssignmentCreateWithoutMembershipLevelInput {
  id?: string ;
  source: MEMBERSHIP_SOURCE_TYPE;
  user: UserCreateOneWithoutMembershipAssignmentsInput;
}

export interface MembershipAssignmentCreateWithoutUserInput {
  id?: string ;
  membershipLevel: MembershipLevelCreateOneWithoutMembershipAssignmentsInput;
  source: MEMBERSHIP_SOURCE_TYPE;
}

export interface MembershipAssignmentScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  source?: MEMBERSHIP_SOURCE_TYPE ;
  source_not?: MEMBERSHIP_SOURCE_TYPE ;
  source_in?: MEMBERSHIP_SOURCE_TYPE[] ;
  source_not_in?: MEMBERSHIP_SOURCE_TYPE[] ;
  AND?: MembershipAssignmentScalarWhereInput[] ;
  OR?: MembershipAssignmentScalarWhereInput[] ;
  NOT?: MembershipAssignmentScalarWhereInput[] ;
}

export interface MembershipAssignmentUpdateManyDataInput {
  source?: MEMBERSHIP_SOURCE_TYPE ;
}

export interface MembershipAssignmentUpdateManyWithWhereNestedInput {
  where: MembershipAssignmentScalarWhereInput;
  data: MembershipAssignmentUpdateManyDataInput;
}

export interface MembershipAssignmentUpdateManyWithoutMembershipLevelInput {
  create?: MembershipAssignmentCreateWithoutMembershipLevelInput[] ;
  connect?: MembershipAssignmentWhereUniqueInput[] ;
  set?: MembershipAssignmentWhereUniqueInput[] ;
  disconnect?: MembershipAssignmentWhereUniqueInput[] ;
  update?: MembershipAssignmentUpdateWithWhereUniqueWithoutMembershipLevelInput[] ;
  upsert?: MembershipAssignmentUpsertWithWhereUniqueWithoutMembershipLevelInput[] ;
  deleteMany?: MembershipAssignmentScalarWhereInput[] ;
  updateMany?: MembershipAssignmentUpdateManyWithWhereNestedInput[] ;
}

export interface MembershipAssignmentUpdateManyWithoutUserInput {
  create?: MembershipAssignmentCreateWithoutUserInput[] ;
  connect?: MembershipAssignmentWhereUniqueInput[] ;
  set?: MembershipAssignmentWhereUniqueInput[] ;
  disconnect?: MembershipAssignmentWhereUniqueInput[] ;
  update?: MembershipAssignmentUpdateWithWhereUniqueWithoutUserInput[] ;
  upsert?: MembershipAssignmentUpsertWithWhereUniqueWithoutUserInput[] ;
  deleteMany?: MembershipAssignmentScalarWhereInput[] ;
  updateMany?: MembershipAssignmentUpdateManyWithWhereNestedInput[] ;
}

export interface MembershipAssignmentUpdateWithWhereUniqueWithoutMembershipLevelInput {
  where: MembershipAssignmentWhereUniqueInput;
  data: MembershipAssignmentUpdateWithoutMembershipLevelDataInput;
}

export interface MembershipAssignmentUpdateWithWhereUniqueWithoutUserInput {
  where: MembershipAssignmentWhereUniqueInput;
  data: MembershipAssignmentUpdateWithoutUserDataInput;
}

export interface MembershipAssignmentUpdateWithoutMembershipLevelDataInput {
  source?: MEMBERSHIP_SOURCE_TYPE ;
  user?: UserUpdateOneRequiredWithoutMembershipAssignmentsInput ;
}

export interface MembershipAssignmentUpdateWithoutUserDataInput {
  membershipLevel?: MembershipLevelUpdateOneRequiredWithoutMembershipAssignmentsInput ;
  source?: MEMBERSHIP_SOURCE_TYPE ;
}

export interface MembershipAssignmentUpsertWithWhereUniqueWithoutMembershipLevelInput {
  where: MembershipAssignmentWhereUniqueInput;
  update: MembershipAssignmentUpdateWithoutMembershipLevelDataInput;
  create: MembershipAssignmentCreateWithoutMembershipLevelInput;
}

export interface MembershipAssignmentUpsertWithWhereUniqueWithoutUserInput {
  where: MembershipAssignmentWhereUniqueInput;
  update: MembershipAssignmentUpdateWithoutUserDataInput;
  create: MembershipAssignmentCreateWithoutUserInput;
}

export interface MembershipAssignmentWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  membershipLevel?: MembershipLevelWhereInput ;
  source?: MEMBERSHIP_SOURCE_TYPE ;
  source_not?: MEMBERSHIP_SOURCE_TYPE ;
  source_in?: MEMBERSHIP_SOURCE_TYPE[] ;
  source_not_in?: MEMBERSHIP_SOURCE_TYPE[] ;
  user?: UserWhereInput ;
  AND?: MembershipAssignmentWhereInput[] ;
  OR?: MembershipAssignmentWhereInput[] ;
  NOT?: MembershipAssignmentWhereInput[] ;
}

export interface MembershipAssignmentWhereUniqueInput {
  id?: string ;
}

export interface MembershipCardCreateManyWithoutLowestMembershipLevelInput {
  create?: MembershipCardCreateWithoutLowestMembershipLevelInput[] ;
  connect?: MembershipCardWhereUniqueInput[] ;
}

export interface MembershipCardCreateManyWithoutMembershipLevelInput {
  create?: MembershipCardCreateWithoutMembershipLevelInput[] ;
  connect?: MembershipCardWhereUniqueInput[] ;
}

export interface MembershipCardCreateOneWithoutPointsTransactionsInput {
  create?: MembershipCardCreateWithoutPointsTransactionsInput ;
  connect?: MembershipCardWhereUniqueInput ;
}

export interface MembershipCardCreateOneWithoutUserInput {
  create?: MembershipCardCreateWithoutUserInput ;
  connect?: MembershipCardWhereUniqueInput ;
}

export interface MembershipCardCreateWithoutLowestMembershipLevelInput {
  id?: string ;
  membershipLevel: MembershipLevelCreateOneWithoutMembershipCardsInput;
  user: UserCreateOneWithoutMembershipCardInput;
  points?: number ;
  pointsTransactions?: PointsTransactionCreateManyWithoutMembershipCardInput ;
  balanceSnapshot?: number ;
  snapshotTime?: any ;
  source: MEMBERSHIP_SOURCE_TYPE;
}

export interface MembershipCardCreateWithoutMembershipLevelInput {
  id?: string ;
  lowestMembershipLevel?: MembershipLevelCreateOneWithoutAsLowestInInput ;
  user: UserCreateOneWithoutMembershipCardInput;
  points?: number ;
  pointsTransactions?: PointsTransactionCreateManyWithoutMembershipCardInput ;
  balanceSnapshot?: number ;
  snapshotTime?: any ;
  source: MEMBERSHIP_SOURCE_TYPE;
}

export interface MembershipCardCreateWithoutPointsTransactionsInput {
  id?: string ;
  membershipLevel: MembershipLevelCreateOneWithoutMembershipCardsInput;
  lowestMembershipLevel?: MembershipLevelCreateOneWithoutAsLowestInInput ;
  user: UserCreateOneWithoutMembershipCardInput;
  points?: number ;
  balanceSnapshot?: number ;
  snapshotTime?: any ;
  source: MEMBERSHIP_SOURCE_TYPE;
}

export interface MembershipCardCreateWithoutUserInput {
  id?: string ;
  membershipLevel: MembershipLevelCreateOneWithoutMembershipCardsInput;
  lowestMembershipLevel?: MembershipLevelCreateOneWithoutAsLowestInInput ;
  points?: number ;
  pointsTransactions?: PointsTransactionCreateManyWithoutMembershipCardInput ;
  balanceSnapshot?: number ;
  snapshotTime?: any ;
  source: MEMBERSHIP_SOURCE_TYPE;
}

export interface MembershipCardScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  points?: number ;
  points_not?: number ;
  points_in?: number[] ;
  points_not_in?: number[] ;
  points_lt?: number ;
  points_lte?: number ;
  points_gt?: number ;
  points_gte?: number ;
  balanceSnapshot?: number ;
  balanceSnapshot_not?: number ;
  balanceSnapshot_in?: number[] ;
  balanceSnapshot_not_in?: number[] ;
  balanceSnapshot_lt?: number ;
  balanceSnapshot_lte?: number ;
  balanceSnapshot_gt?: number ;
  balanceSnapshot_gte?: number ;
  snapshotTime?: any ;
  snapshotTime_not?: any ;
  snapshotTime_in?: any[] ;
  snapshotTime_not_in?: any[] ;
  snapshotTime_lt?: any ;
  snapshotTime_lte?: any ;
  snapshotTime_gt?: any ;
  snapshotTime_gte?: any ;
  source?: MEMBERSHIP_SOURCE_TYPE ;
  source_not?: MEMBERSHIP_SOURCE_TYPE ;
  source_in?: MEMBERSHIP_SOURCE_TYPE[] ;
  source_not_in?: MEMBERSHIP_SOURCE_TYPE[] ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  AND?: MembershipCardScalarWhereInput[] ;
  OR?: MembershipCardScalarWhereInput[] ;
  NOT?: MembershipCardScalarWhereInput[] ;
}

export interface MembershipCardUpdateManyDataInput {
  points?: number ;
  balanceSnapshot?: number ;
  snapshotTime?: any ;
  source?: MEMBERSHIP_SOURCE_TYPE ;
}

export interface MembershipCardUpdateManyWithWhereNestedInput {
  where: MembershipCardScalarWhereInput;
  data: MembershipCardUpdateManyDataInput;
}

export interface MembershipCardUpdateManyWithoutLowestMembershipLevelInput {
  create?: MembershipCardCreateWithoutLowestMembershipLevelInput[] ;
  connect?: MembershipCardWhereUniqueInput[] ;
  set?: MembershipCardWhereUniqueInput[] ;
  disconnect?: MembershipCardWhereUniqueInput[] ;
  update?: MembershipCardUpdateWithWhereUniqueWithoutLowestMembershipLevelInput[] ;
  upsert?: MembershipCardUpsertWithWhereUniqueWithoutLowestMembershipLevelInput[] ;
  deleteMany?: MembershipCardScalarWhereInput[] ;
  updateMany?: MembershipCardUpdateManyWithWhereNestedInput[] ;
}

export interface MembershipCardUpdateManyWithoutMembershipLevelInput {
  create?: MembershipCardCreateWithoutMembershipLevelInput[] ;
  connect?: MembershipCardWhereUniqueInput[] ;
  set?: MembershipCardWhereUniqueInput[] ;
  disconnect?: MembershipCardWhereUniqueInput[] ;
  update?: MembershipCardUpdateWithWhereUniqueWithoutMembershipLevelInput[] ;
  upsert?: MembershipCardUpsertWithWhereUniqueWithoutMembershipLevelInput[] ;
  deleteMany?: MembershipCardScalarWhereInput[] ;
  updateMany?: MembershipCardUpdateManyWithWhereNestedInput[] ;
}

export interface MembershipCardUpdateOneRequiredWithoutPointsTransactionsInput {
  create?: MembershipCardCreateWithoutPointsTransactionsInput ;
  update?: MembershipCardUpdateWithoutPointsTransactionsDataInput ;
  upsert?: MembershipCardUpsertWithoutPointsTransactionsInput ;
  connect?: MembershipCardWhereUniqueInput ;
}

export interface MembershipCardUpdateOneWithoutUserInput {
  create?: MembershipCardCreateWithoutUserInput ;
  update?: MembershipCardUpdateWithoutUserDataInput ;
  upsert?: MembershipCardUpsertWithoutUserInput ;
  disconnect?: boolean ;
  connect?: MembershipCardWhereUniqueInput ;
}

export interface MembershipCardUpdateWithWhereUniqueWithoutLowestMembershipLevelInput {
  where: MembershipCardWhereUniqueInput;
  data: MembershipCardUpdateWithoutLowestMembershipLevelDataInput;
}

export interface MembershipCardUpdateWithWhereUniqueWithoutMembershipLevelInput {
  where: MembershipCardWhereUniqueInput;
  data: MembershipCardUpdateWithoutMembershipLevelDataInput;
}

export interface MembershipCardUpdateWithoutLowestMembershipLevelDataInput {
  membershipLevel?: MembershipLevelUpdateOneRequiredWithoutMembershipCardsInput ;
  user?: UserUpdateOneRequiredWithoutMembershipCardInput ;
  points?: number ;
  pointsTransactions?: PointsTransactionUpdateManyWithoutMembershipCardInput ;
  balanceSnapshot?: number ;
  snapshotTime?: any ;
  source?: MEMBERSHIP_SOURCE_TYPE ;
}

export interface MembershipCardUpdateWithoutMembershipLevelDataInput {
  lowestMembershipLevel?: MembershipLevelUpdateOneWithoutAsLowestInInput ;
  user?: UserUpdateOneRequiredWithoutMembershipCardInput ;
  points?: number ;
  pointsTransactions?: PointsTransactionUpdateManyWithoutMembershipCardInput ;
  balanceSnapshot?: number ;
  snapshotTime?: any ;
  source?: MEMBERSHIP_SOURCE_TYPE ;
}

export interface MembershipCardUpdateWithoutPointsTransactionsDataInput {
  membershipLevel?: MembershipLevelUpdateOneRequiredWithoutMembershipCardsInput ;
  lowestMembershipLevel?: MembershipLevelUpdateOneWithoutAsLowestInInput ;
  user?: UserUpdateOneRequiredWithoutMembershipCardInput ;
  points?: number ;
  balanceSnapshot?: number ;
  snapshotTime?: any ;
  source?: MEMBERSHIP_SOURCE_TYPE ;
}

export interface MembershipCardUpdateWithoutUserDataInput {
  membershipLevel?: MembershipLevelUpdateOneRequiredWithoutMembershipCardsInput ;
  lowestMembershipLevel?: MembershipLevelUpdateOneWithoutAsLowestInInput ;
  points?: number ;
  pointsTransactions?: PointsTransactionUpdateManyWithoutMembershipCardInput ;
  balanceSnapshot?: number ;
  snapshotTime?: any ;
  source?: MEMBERSHIP_SOURCE_TYPE ;
}

export interface MembershipCardUpsertWithWhereUniqueWithoutLowestMembershipLevelInput {
  where: MembershipCardWhereUniqueInput;
  update: MembershipCardUpdateWithoutLowestMembershipLevelDataInput;
  create: MembershipCardCreateWithoutLowestMembershipLevelInput;
}

export interface MembershipCardUpsertWithWhereUniqueWithoutMembershipLevelInput {
  where: MembershipCardWhereUniqueInput;
  update: MembershipCardUpdateWithoutMembershipLevelDataInput;
  create: MembershipCardCreateWithoutMembershipLevelInput;
}

export interface MembershipCardUpsertWithoutPointsTransactionsInput {
  update: MembershipCardUpdateWithoutPointsTransactionsDataInput;
  create: MembershipCardCreateWithoutPointsTransactionsInput;
}

export interface MembershipCardUpsertWithoutUserInput {
  update: MembershipCardUpdateWithoutUserDataInput;
  create: MembershipCardCreateWithoutUserInput;
}

export interface MembershipCardWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  membershipLevel?: MembershipLevelWhereInput ;
  lowestMembershipLevel?: MembershipLevelWhereInput ;
  user?: UserWhereInput ;
  points?: number ;
  points_not?: number ;
  points_in?: number[] ;
  points_not_in?: number[] ;
  points_lt?: number ;
  points_lte?: number ;
  points_gt?: number ;
  points_gte?: number ;
  pointsTransactions_every?: PointsTransactionWhereInput ;
  pointsTransactions_some?: PointsTransactionWhereInput ;
  pointsTransactions_none?: PointsTransactionWhereInput ;
  balanceSnapshot?: number ;
  balanceSnapshot_not?: number ;
  balanceSnapshot_in?: number[] ;
  balanceSnapshot_not_in?: number[] ;
  balanceSnapshot_lt?: number ;
  balanceSnapshot_lte?: number ;
  balanceSnapshot_gt?: number ;
  balanceSnapshot_gte?: number ;
  snapshotTime?: any ;
  snapshotTime_not?: any ;
  snapshotTime_in?: any[] ;
  snapshotTime_not_in?: any[] ;
  snapshotTime_lt?: any ;
  snapshotTime_lte?: any ;
  snapshotTime_gt?: any ;
  snapshotTime_gte?: any ;
  source?: MEMBERSHIP_SOURCE_TYPE ;
  source_not?: MEMBERSHIP_SOURCE_TYPE ;
  source_in?: MEMBERSHIP_SOURCE_TYPE[] ;
  source_not_in?: MEMBERSHIP_SOURCE_TYPE[] ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  AND?: MembershipCardWhereInput[] ;
  OR?: MembershipCardWhereInput[] ;
  NOT?: MembershipCardWhereInput[] ;
}

export interface MembershipCardWhereUniqueInput {
  id?: string ;
}

export interface MembershipLevelCreateManyWithoutCompanyInput {
  create?: MembershipLevelCreateWithoutCompanyInput[] ;
  connect?: MembershipLevelWhereUniqueInput[] ;
}

export interface MembershipLevelCreateManyWithoutDesignInput {
  create?: MembershipLevelCreateWithoutDesignInput[] ;
  connect?: MembershipLevelWhereUniqueInput[] ;
}

export interface MembershipLevelCreateManyWithoutImageInput {
  create?: MembershipLevelCreateWithoutImageInput[] ;
  connect?: MembershipLevelWhereUniqueInput[] ;
}

export interface MembershipLevelCreateManyWithoutMenusInput {
  create?: MembershipLevelCreateWithoutMenusInput[] ;
  connect?: MembershipLevelWhereUniqueInput[] ;
}

export interface MembershipLevelCreateOneWithoutAsLowestInInput {
  create?: MembershipLevelCreateWithoutAsLowestInInput ;
  connect?: MembershipLevelWhereUniqueInput ;
}

export interface MembershipLevelCreateOneWithoutDescriptionInput {
  create?: MembershipLevelCreateWithoutDescriptionInput ;
  connect?: MembershipLevelWhereUniqueInput ;
}

export interface MembershipLevelCreateOneWithoutMembershipAssignmentsInput {
  create?: MembershipLevelCreateWithoutMembershipAssignmentsInput ;
  connect?: MembershipLevelWhereUniqueInput ;
}

export interface MembershipLevelCreateOneWithoutMembershipCardsInput {
  create?: MembershipLevelCreateWithoutMembershipCardsInput ;
  connect?: MembershipLevelWhereUniqueInput ;
}

export interface MembershipLevelCreateOneWithoutMembershipTradeinsInput {
  create?: MembershipLevelCreateWithoutMembershipTradeinsInput ;
  connect?: MembershipLevelWhereUniqueInput ;
}

export interface MembershipLevelCreateOneWithoutPromoCodesInput {
  create?: MembershipLevelCreateWithoutPromoCodesInput ;
  connect?: MembershipLevelWhereUniqueInput ;
}

export interface MembershipLevelCreateOneWithoutTitleInput {
  create?: MembershipLevelCreateWithoutTitleInput ;
  connect?: MembershipLevelWhereUniqueInput ;
}

export interface MembershipLevelCreateOneWithoutUsersInput {
  create?: MembershipLevelCreateWithoutUsersInput ;
  connect?: MembershipLevelWhereUniqueInput ;
}

export interface MembershipLevelCreateWithoutAsLowestInInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutMembershipLevelTitleInput;
  description: TranslatedStringCreateOneWithoutMembershipLevelDescriptionInput;
  users?: UserCreateManyWithoutMembershipLevelInput ;
  company: CompanyCreateOneWithoutMembershipsInput;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage: number;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  membershipCards?: MembershipCardCreateManyWithoutMembershipLevelInput ;
  promoCodes?: PromoCodeCreateManyWithoutMembershipLevelInput ;
  menus?: AppliedMenuCreateManyWithoutMembershipLevelsInput ;
  design?: CardDesignCreateOneWithoutMembershipsInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutMembershipLevelInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutMembershipLevelInput ;
  image?: ImageCreateOneWithoutMembershipLevelImagesInput ;
}

export interface MembershipLevelCreateWithoutCompanyInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutMembershipLevelTitleInput;
  description: TranslatedStringCreateOneWithoutMembershipLevelDescriptionInput;
  users?: UserCreateManyWithoutMembershipLevelInput ;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage: number;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  membershipCards?: MembershipCardCreateManyWithoutMembershipLevelInput ;
  asLowestIn?: MembershipCardCreateManyWithoutLowestMembershipLevelInput ;
  promoCodes?: PromoCodeCreateManyWithoutMembershipLevelInput ;
  menus?: AppliedMenuCreateManyWithoutMembershipLevelsInput ;
  design?: CardDesignCreateOneWithoutMembershipsInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutMembershipLevelInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutMembershipLevelInput ;
  image?: ImageCreateOneWithoutMembershipLevelImagesInput ;
}

export interface MembershipLevelCreateWithoutDescriptionInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutMembershipLevelTitleInput;
  users?: UserCreateManyWithoutMembershipLevelInput ;
  company: CompanyCreateOneWithoutMembershipsInput;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage: number;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  membershipCards?: MembershipCardCreateManyWithoutMembershipLevelInput ;
  asLowestIn?: MembershipCardCreateManyWithoutLowestMembershipLevelInput ;
  promoCodes?: PromoCodeCreateManyWithoutMembershipLevelInput ;
  menus?: AppliedMenuCreateManyWithoutMembershipLevelsInput ;
  design?: CardDesignCreateOneWithoutMembershipsInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutMembershipLevelInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutMembershipLevelInput ;
  image?: ImageCreateOneWithoutMembershipLevelImagesInput ;
}

export interface MembershipLevelCreateWithoutDesignInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutMembershipLevelTitleInput;
  description: TranslatedStringCreateOneWithoutMembershipLevelDescriptionInput;
  users?: UserCreateManyWithoutMembershipLevelInput ;
  company: CompanyCreateOneWithoutMembershipsInput;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage: number;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  membershipCards?: MembershipCardCreateManyWithoutMembershipLevelInput ;
  asLowestIn?: MembershipCardCreateManyWithoutLowestMembershipLevelInput ;
  promoCodes?: PromoCodeCreateManyWithoutMembershipLevelInput ;
  menus?: AppliedMenuCreateManyWithoutMembershipLevelsInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutMembershipLevelInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutMembershipLevelInput ;
  image?: ImageCreateOneWithoutMembershipLevelImagesInput ;
}

export interface MembershipLevelCreateWithoutImageInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutMembershipLevelTitleInput;
  description: TranslatedStringCreateOneWithoutMembershipLevelDescriptionInput;
  users?: UserCreateManyWithoutMembershipLevelInput ;
  company: CompanyCreateOneWithoutMembershipsInput;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage: number;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  membershipCards?: MembershipCardCreateManyWithoutMembershipLevelInput ;
  asLowestIn?: MembershipCardCreateManyWithoutLowestMembershipLevelInput ;
  promoCodes?: PromoCodeCreateManyWithoutMembershipLevelInput ;
  menus?: AppliedMenuCreateManyWithoutMembershipLevelsInput ;
  design?: CardDesignCreateOneWithoutMembershipsInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutMembershipLevelInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutMembershipLevelInput ;
}

export interface MembershipLevelCreateWithoutMembershipAssignmentsInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutMembershipLevelTitleInput;
  description: TranslatedStringCreateOneWithoutMembershipLevelDescriptionInput;
  users?: UserCreateManyWithoutMembershipLevelInput ;
  company: CompanyCreateOneWithoutMembershipsInput;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage: number;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  membershipCards?: MembershipCardCreateManyWithoutMembershipLevelInput ;
  asLowestIn?: MembershipCardCreateManyWithoutLowestMembershipLevelInput ;
  promoCodes?: PromoCodeCreateManyWithoutMembershipLevelInput ;
  menus?: AppliedMenuCreateManyWithoutMembershipLevelsInput ;
  design?: CardDesignCreateOneWithoutMembershipsInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutMembershipLevelInput ;
  image?: ImageCreateOneWithoutMembershipLevelImagesInput ;
}

export interface MembershipLevelCreateWithoutMembershipCardsInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutMembershipLevelTitleInput;
  description: TranslatedStringCreateOneWithoutMembershipLevelDescriptionInput;
  users?: UserCreateManyWithoutMembershipLevelInput ;
  company: CompanyCreateOneWithoutMembershipsInput;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage: number;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  asLowestIn?: MembershipCardCreateManyWithoutLowestMembershipLevelInput ;
  promoCodes?: PromoCodeCreateManyWithoutMembershipLevelInput ;
  menus?: AppliedMenuCreateManyWithoutMembershipLevelsInput ;
  design?: CardDesignCreateOneWithoutMembershipsInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutMembershipLevelInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutMembershipLevelInput ;
  image?: ImageCreateOneWithoutMembershipLevelImagesInput ;
}

export interface MembershipLevelCreateWithoutMembershipTradeinsInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutMembershipLevelTitleInput;
  description: TranslatedStringCreateOneWithoutMembershipLevelDescriptionInput;
  users?: UserCreateManyWithoutMembershipLevelInput ;
  company: CompanyCreateOneWithoutMembershipsInput;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage: number;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  membershipCards?: MembershipCardCreateManyWithoutMembershipLevelInput ;
  asLowestIn?: MembershipCardCreateManyWithoutLowestMembershipLevelInput ;
  promoCodes?: PromoCodeCreateManyWithoutMembershipLevelInput ;
  menus?: AppliedMenuCreateManyWithoutMembershipLevelsInput ;
  design?: CardDesignCreateOneWithoutMembershipsInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutMembershipLevelInput ;
  image?: ImageCreateOneWithoutMembershipLevelImagesInput ;
}

export interface MembershipLevelCreateWithoutMenusInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutMembershipLevelTitleInput;
  description: TranslatedStringCreateOneWithoutMembershipLevelDescriptionInput;
  users?: UserCreateManyWithoutMembershipLevelInput ;
  company: CompanyCreateOneWithoutMembershipsInput;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage: number;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  membershipCards?: MembershipCardCreateManyWithoutMembershipLevelInput ;
  asLowestIn?: MembershipCardCreateManyWithoutLowestMembershipLevelInput ;
  promoCodes?: PromoCodeCreateManyWithoutMembershipLevelInput ;
  design?: CardDesignCreateOneWithoutMembershipsInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutMembershipLevelInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutMembershipLevelInput ;
  image?: ImageCreateOneWithoutMembershipLevelImagesInput ;
}

export interface MembershipLevelCreateWithoutPromoCodesInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutMembershipLevelTitleInput;
  description: TranslatedStringCreateOneWithoutMembershipLevelDescriptionInput;
  users?: UserCreateManyWithoutMembershipLevelInput ;
  company: CompanyCreateOneWithoutMembershipsInput;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage: number;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  membershipCards?: MembershipCardCreateManyWithoutMembershipLevelInput ;
  asLowestIn?: MembershipCardCreateManyWithoutLowestMembershipLevelInput ;
  menus?: AppliedMenuCreateManyWithoutMembershipLevelsInput ;
  design?: CardDesignCreateOneWithoutMembershipsInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutMembershipLevelInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutMembershipLevelInput ;
  image?: ImageCreateOneWithoutMembershipLevelImagesInput ;
}

export interface MembershipLevelCreateWithoutTitleInput {
  id?: string ;
  description: TranslatedStringCreateOneWithoutMembershipLevelDescriptionInput;
  users?: UserCreateManyWithoutMembershipLevelInput ;
  company: CompanyCreateOneWithoutMembershipsInput;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage: number;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  membershipCards?: MembershipCardCreateManyWithoutMembershipLevelInput ;
  asLowestIn?: MembershipCardCreateManyWithoutLowestMembershipLevelInput ;
  promoCodes?: PromoCodeCreateManyWithoutMembershipLevelInput ;
  menus?: AppliedMenuCreateManyWithoutMembershipLevelsInput ;
  design?: CardDesignCreateOneWithoutMembershipsInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutMembershipLevelInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutMembershipLevelInput ;
  image?: ImageCreateOneWithoutMembershipLevelImagesInput ;
}

export interface MembershipLevelCreateWithoutUsersInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutMembershipLevelTitleInput;
  description: TranslatedStringCreateOneWithoutMembershipLevelDescriptionInput;
  company: CompanyCreateOneWithoutMembershipsInput;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage: number;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  membershipCards?: MembershipCardCreateManyWithoutMembershipLevelInput ;
  asLowestIn?: MembershipCardCreateManyWithoutLowestMembershipLevelInput ;
  promoCodes?: PromoCodeCreateManyWithoutMembershipLevelInput ;
  menus?: AppliedMenuCreateManyWithoutMembershipLevelsInput ;
  design?: CardDesignCreateOneWithoutMembershipsInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutMembershipLevelInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutMembershipLevelInput ;
  image?: ImageCreateOneWithoutMembershipLevelImagesInput ;
}

export interface MembershipLevelScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  default?: boolean ;
  default_not?: boolean ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  primaryColor?: string ;
  primaryColor_not?: string ;
  primaryColor_in?: string[] ;
  primaryColor_not_in?: string[] ;
  primaryColor_lt?: string ;
  primaryColor_lte?: string ;
  primaryColor_gt?: string ;
  primaryColor_gte?: string ;
  primaryColor_contains?: string ;
  primaryColor_not_contains?: string ;
  primaryColor_starts_with?: string ;
  primaryColor_not_starts_with?: string ;
  primaryColor_ends_with?: string ;
  primaryColor_not_ends_with?: string ;
  secondaryColor?: string ;
  secondaryColor_not?: string ;
  secondaryColor_in?: string[] ;
  secondaryColor_not_in?: string[] ;
  secondaryColor_lt?: string ;
  secondaryColor_lte?: string ;
  secondaryColor_gt?: string ;
  secondaryColor_gte?: string ;
  secondaryColor_contains?: string ;
  secondaryColor_not_contains?: string ;
  secondaryColor_starts_with?: string ;
  secondaryColor_not_starts_with?: string ;
  secondaryColor_ends_with?: string ;
  secondaryColor_not_ends_with?: string ;
  discountPercentage?: number ;
  discountPercentage_not?: number ;
  discountPercentage_in?: number[] ;
  discountPercentage_not_in?: number[] ;
  discountPercentage_lt?: number ;
  discountPercentage_lte?: number ;
  discountPercentage_gt?: number ;
  discountPercentage_gte?: number ;
  creditsYieldPercentage?: number ;
  creditsYieldPercentage_not?: number ;
  creditsYieldPercentage_in?: number[] ;
  creditsYieldPercentage_not_in?: number[] ;
  creditsYieldPercentage_lt?: number ;
  creditsYieldPercentage_lte?: number ;
  creditsYieldPercentage_gt?: number ;
  creditsYieldPercentage_gte?: number ;
  pointsRequired?: number ;
  pointsRequired_not?: number ;
  pointsRequired_in?: number[] ;
  pointsRequired_not_in?: number[] ;
  pointsRequired_lt?: number ;
  pointsRequired_lte?: number ;
  pointsRequired_gt?: number ;
  pointsRequired_gte?: number ;
  AND?: MembershipLevelScalarWhereInput[] ;
  OR?: MembershipLevelScalarWhereInput[] ;
  NOT?: MembershipLevelScalarWhereInput[] ;
}

export interface MembershipLevelUpdateManyDataInput {
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage?: number ;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
}

export interface MembershipLevelUpdateManyWithWhereNestedInput {
  where: MembershipLevelScalarWhereInput;
  data: MembershipLevelUpdateManyDataInput;
}

export interface MembershipLevelUpdateManyWithoutCompanyInput {
  create?: MembershipLevelCreateWithoutCompanyInput[] ;
  connect?: MembershipLevelWhereUniqueInput[] ;
  set?: MembershipLevelWhereUniqueInput[] ;
  disconnect?: MembershipLevelWhereUniqueInput[] ;
  update?: MembershipLevelUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: MembershipLevelUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: MembershipLevelScalarWhereInput[] ;
  updateMany?: MembershipLevelUpdateManyWithWhereNestedInput[] ;
}

export interface MembershipLevelUpdateManyWithoutDesignInput {
  create?: MembershipLevelCreateWithoutDesignInput[] ;
  connect?: MembershipLevelWhereUniqueInput[] ;
  set?: MembershipLevelWhereUniqueInput[] ;
  disconnect?: MembershipLevelWhereUniqueInput[] ;
  update?: MembershipLevelUpdateWithWhereUniqueWithoutDesignInput[] ;
  upsert?: MembershipLevelUpsertWithWhereUniqueWithoutDesignInput[] ;
  deleteMany?: MembershipLevelScalarWhereInput[] ;
  updateMany?: MembershipLevelUpdateManyWithWhereNestedInput[] ;
}

export interface MembershipLevelUpdateManyWithoutImageInput {
  create?: MembershipLevelCreateWithoutImageInput[] ;
  connect?: MembershipLevelWhereUniqueInput[] ;
  set?: MembershipLevelWhereUniqueInput[] ;
  disconnect?: MembershipLevelWhereUniqueInput[] ;
  update?: MembershipLevelUpdateWithWhereUniqueWithoutImageInput[] ;
  upsert?: MembershipLevelUpsertWithWhereUniqueWithoutImageInput[] ;
  deleteMany?: MembershipLevelScalarWhereInput[] ;
  updateMany?: MembershipLevelUpdateManyWithWhereNestedInput[] ;
}

export interface MembershipLevelUpdateManyWithoutMenusInput {
  create?: MembershipLevelCreateWithoutMenusInput[] ;
  connect?: MembershipLevelWhereUniqueInput[] ;
  set?: MembershipLevelWhereUniqueInput[] ;
  disconnect?: MembershipLevelWhereUniqueInput[] ;
  update?: MembershipLevelUpdateWithWhereUniqueWithoutMenusInput[] ;
  upsert?: MembershipLevelUpsertWithWhereUniqueWithoutMenusInput[] ;
  deleteMany?: MembershipLevelScalarWhereInput[] ;
  updateMany?: MembershipLevelUpdateManyWithWhereNestedInput[] ;
}

export interface MembershipLevelUpdateOneRequiredWithoutMembershipAssignmentsInput {
  create?: MembershipLevelCreateWithoutMembershipAssignmentsInput ;
  update?: MembershipLevelUpdateWithoutMembershipAssignmentsDataInput ;
  upsert?: MembershipLevelUpsertWithoutMembershipAssignmentsInput ;
  connect?: MembershipLevelWhereUniqueInput ;
}

export interface MembershipLevelUpdateOneRequiredWithoutMembershipCardsInput {
  create?: MembershipLevelCreateWithoutMembershipCardsInput ;
  update?: MembershipLevelUpdateWithoutMembershipCardsDataInput ;
  upsert?: MembershipLevelUpsertWithoutMembershipCardsInput ;
  connect?: MembershipLevelWhereUniqueInput ;
}

export interface MembershipLevelUpdateOneRequiredWithoutMembershipTradeinsInput {
  create?: MembershipLevelCreateWithoutMembershipTradeinsInput ;
  update?: MembershipLevelUpdateWithoutMembershipTradeinsDataInput ;
  upsert?: MembershipLevelUpsertWithoutMembershipTradeinsInput ;
  connect?: MembershipLevelWhereUniqueInput ;
}

export interface MembershipLevelUpdateOneWithoutAsLowestInInput {
  create?: MembershipLevelCreateWithoutAsLowestInInput ;
  update?: MembershipLevelUpdateWithoutAsLowestInDataInput ;
  upsert?: MembershipLevelUpsertWithoutAsLowestInInput ;
  disconnect?: boolean ;
  connect?: MembershipLevelWhereUniqueInput ;
}

export interface MembershipLevelUpdateOneWithoutDescriptionInput {
  create?: MembershipLevelCreateWithoutDescriptionInput ;
  update?: MembershipLevelUpdateWithoutDescriptionDataInput ;
  upsert?: MembershipLevelUpsertWithoutDescriptionInput ;
  disconnect?: boolean ;
  connect?: MembershipLevelWhereUniqueInput ;
}

export interface MembershipLevelUpdateOneWithoutPromoCodesInput {
  create?: MembershipLevelCreateWithoutPromoCodesInput ;
  update?: MembershipLevelUpdateWithoutPromoCodesDataInput ;
  upsert?: MembershipLevelUpsertWithoutPromoCodesInput ;
  disconnect?: boolean ;
  connect?: MembershipLevelWhereUniqueInput ;
}

export interface MembershipLevelUpdateOneWithoutTitleInput {
  create?: MembershipLevelCreateWithoutTitleInput ;
  update?: MembershipLevelUpdateWithoutTitleDataInput ;
  upsert?: MembershipLevelUpsertWithoutTitleInput ;
  disconnect?: boolean ;
  connect?: MembershipLevelWhereUniqueInput ;
}

export interface MembershipLevelUpdateOneWithoutUsersInput {
  create?: MembershipLevelCreateWithoutUsersInput ;
  update?: MembershipLevelUpdateWithoutUsersDataInput ;
  upsert?: MembershipLevelUpsertWithoutUsersInput ;
  disconnect?: boolean ;
  connect?: MembershipLevelWhereUniqueInput ;
}

export interface MembershipLevelUpdateWithWhereUniqueWithoutCompanyInput {
  where: MembershipLevelWhereUniqueInput;
  data: MembershipLevelUpdateWithoutCompanyDataInput;
}

export interface MembershipLevelUpdateWithWhereUniqueWithoutDesignInput {
  where: MembershipLevelWhereUniqueInput;
  data: MembershipLevelUpdateWithoutDesignDataInput;
}

export interface MembershipLevelUpdateWithWhereUniqueWithoutImageInput {
  where: MembershipLevelWhereUniqueInput;
  data: MembershipLevelUpdateWithoutImageDataInput;
}

export interface MembershipLevelUpdateWithWhereUniqueWithoutMenusInput {
  where: MembershipLevelWhereUniqueInput;
  data: MembershipLevelUpdateWithoutMenusDataInput;
}

export interface MembershipLevelUpdateWithoutAsLowestInDataInput {
  title?: TranslatedStringUpdateOneRequiredWithoutMembershipLevelTitleInput ;
  description?: TranslatedStringUpdateOneRequiredWithoutMembershipLevelDescriptionInput ;
  users?: UserUpdateManyWithoutMembershipLevelInput ;
  company?: CompanyUpdateOneRequiredWithoutMembershipsInput ;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage?: number ;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  membershipCards?: MembershipCardUpdateManyWithoutMembershipLevelInput ;
  promoCodes?: PromoCodeUpdateManyWithoutMembershipLevelInput ;
  menus?: AppliedMenuUpdateManyWithoutMembershipLevelsInput ;
  design?: CardDesignUpdateOneWithoutMembershipsInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutMembershipLevelInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutMembershipLevelInput ;
  image?: ImageUpdateOneWithoutMembershipLevelImagesInput ;
}

export interface MembershipLevelUpdateWithoutCompanyDataInput {
  title?: TranslatedStringUpdateOneRequiredWithoutMembershipLevelTitleInput ;
  description?: TranslatedStringUpdateOneRequiredWithoutMembershipLevelDescriptionInput ;
  users?: UserUpdateManyWithoutMembershipLevelInput ;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage?: number ;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  membershipCards?: MembershipCardUpdateManyWithoutMembershipLevelInput ;
  asLowestIn?: MembershipCardUpdateManyWithoutLowestMembershipLevelInput ;
  promoCodes?: PromoCodeUpdateManyWithoutMembershipLevelInput ;
  menus?: AppliedMenuUpdateManyWithoutMembershipLevelsInput ;
  design?: CardDesignUpdateOneWithoutMembershipsInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutMembershipLevelInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutMembershipLevelInput ;
  image?: ImageUpdateOneWithoutMembershipLevelImagesInput ;
}

export interface MembershipLevelUpdateWithoutDescriptionDataInput {
  title?: TranslatedStringUpdateOneRequiredWithoutMembershipLevelTitleInput ;
  users?: UserUpdateManyWithoutMembershipLevelInput ;
  company?: CompanyUpdateOneRequiredWithoutMembershipsInput ;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage?: number ;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  membershipCards?: MembershipCardUpdateManyWithoutMembershipLevelInput ;
  asLowestIn?: MembershipCardUpdateManyWithoutLowestMembershipLevelInput ;
  promoCodes?: PromoCodeUpdateManyWithoutMembershipLevelInput ;
  menus?: AppliedMenuUpdateManyWithoutMembershipLevelsInput ;
  design?: CardDesignUpdateOneWithoutMembershipsInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutMembershipLevelInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutMembershipLevelInput ;
  image?: ImageUpdateOneWithoutMembershipLevelImagesInput ;
}

export interface MembershipLevelUpdateWithoutDesignDataInput {
  title?: TranslatedStringUpdateOneRequiredWithoutMembershipLevelTitleInput ;
  description?: TranslatedStringUpdateOneRequiredWithoutMembershipLevelDescriptionInput ;
  users?: UserUpdateManyWithoutMembershipLevelInput ;
  company?: CompanyUpdateOneRequiredWithoutMembershipsInput ;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage?: number ;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  membershipCards?: MembershipCardUpdateManyWithoutMembershipLevelInput ;
  asLowestIn?: MembershipCardUpdateManyWithoutLowestMembershipLevelInput ;
  promoCodes?: PromoCodeUpdateManyWithoutMembershipLevelInput ;
  menus?: AppliedMenuUpdateManyWithoutMembershipLevelsInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutMembershipLevelInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutMembershipLevelInput ;
  image?: ImageUpdateOneWithoutMembershipLevelImagesInput ;
}

export interface MembershipLevelUpdateWithoutImageDataInput {
  title?: TranslatedStringUpdateOneRequiredWithoutMembershipLevelTitleInput ;
  description?: TranslatedStringUpdateOneRequiredWithoutMembershipLevelDescriptionInput ;
  users?: UserUpdateManyWithoutMembershipLevelInput ;
  company?: CompanyUpdateOneRequiredWithoutMembershipsInput ;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage?: number ;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  membershipCards?: MembershipCardUpdateManyWithoutMembershipLevelInput ;
  asLowestIn?: MembershipCardUpdateManyWithoutLowestMembershipLevelInput ;
  promoCodes?: PromoCodeUpdateManyWithoutMembershipLevelInput ;
  menus?: AppliedMenuUpdateManyWithoutMembershipLevelsInput ;
  design?: CardDesignUpdateOneWithoutMembershipsInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutMembershipLevelInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutMembershipLevelInput ;
}

export interface MembershipLevelUpdateWithoutMembershipAssignmentsDataInput {
  title?: TranslatedStringUpdateOneRequiredWithoutMembershipLevelTitleInput ;
  description?: TranslatedStringUpdateOneRequiredWithoutMembershipLevelDescriptionInput ;
  users?: UserUpdateManyWithoutMembershipLevelInput ;
  company?: CompanyUpdateOneRequiredWithoutMembershipsInput ;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage?: number ;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  membershipCards?: MembershipCardUpdateManyWithoutMembershipLevelInput ;
  asLowestIn?: MembershipCardUpdateManyWithoutLowestMembershipLevelInput ;
  promoCodes?: PromoCodeUpdateManyWithoutMembershipLevelInput ;
  menus?: AppliedMenuUpdateManyWithoutMembershipLevelsInput ;
  design?: CardDesignUpdateOneWithoutMembershipsInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutMembershipLevelInput ;
  image?: ImageUpdateOneWithoutMembershipLevelImagesInput ;
}

export interface MembershipLevelUpdateWithoutMembershipCardsDataInput {
  title?: TranslatedStringUpdateOneRequiredWithoutMembershipLevelTitleInput ;
  description?: TranslatedStringUpdateOneRequiredWithoutMembershipLevelDescriptionInput ;
  users?: UserUpdateManyWithoutMembershipLevelInput ;
  company?: CompanyUpdateOneRequiredWithoutMembershipsInput ;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage?: number ;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  asLowestIn?: MembershipCardUpdateManyWithoutLowestMembershipLevelInput ;
  promoCodes?: PromoCodeUpdateManyWithoutMembershipLevelInput ;
  menus?: AppliedMenuUpdateManyWithoutMembershipLevelsInput ;
  design?: CardDesignUpdateOneWithoutMembershipsInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutMembershipLevelInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutMembershipLevelInput ;
  image?: ImageUpdateOneWithoutMembershipLevelImagesInput ;
}

export interface MembershipLevelUpdateWithoutMembershipTradeinsDataInput {
  title?: TranslatedStringUpdateOneRequiredWithoutMembershipLevelTitleInput ;
  description?: TranslatedStringUpdateOneRequiredWithoutMembershipLevelDescriptionInput ;
  users?: UserUpdateManyWithoutMembershipLevelInput ;
  company?: CompanyUpdateOneRequiredWithoutMembershipsInput ;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage?: number ;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  membershipCards?: MembershipCardUpdateManyWithoutMembershipLevelInput ;
  asLowestIn?: MembershipCardUpdateManyWithoutLowestMembershipLevelInput ;
  promoCodes?: PromoCodeUpdateManyWithoutMembershipLevelInput ;
  menus?: AppliedMenuUpdateManyWithoutMembershipLevelsInput ;
  design?: CardDesignUpdateOneWithoutMembershipsInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutMembershipLevelInput ;
  image?: ImageUpdateOneWithoutMembershipLevelImagesInput ;
}

export interface MembershipLevelUpdateWithoutMenusDataInput {
  title?: TranslatedStringUpdateOneRequiredWithoutMembershipLevelTitleInput ;
  description?: TranslatedStringUpdateOneRequiredWithoutMembershipLevelDescriptionInput ;
  users?: UserUpdateManyWithoutMembershipLevelInput ;
  company?: CompanyUpdateOneRequiredWithoutMembershipsInput ;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage?: number ;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  membershipCards?: MembershipCardUpdateManyWithoutMembershipLevelInput ;
  asLowestIn?: MembershipCardUpdateManyWithoutLowestMembershipLevelInput ;
  promoCodes?: PromoCodeUpdateManyWithoutMembershipLevelInput ;
  design?: CardDesignUpdateOneWithoutMembershipsInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutMembershipLevelInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutMembershipLevelInput ;
  image?: ImageUpdateOneWithoutMembershipLevelImagesInput ;
}

export interface MembershipLevelUpdateWithoutPromoCodesDataInput {
  title?: TranslatedStringUpdateOneRequiredWithoutMembershipLevelTitleInput ;
  description?: TranslatedStringUpdateOneRequiredWithoutMembershipLevelDescriptionInput ;
  users?: UserUpdateManyWithoutMembershipLevelInput ;
  company?: CompanyUpdateOneRequiredWithoutMembershipsInput ;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage?: number ;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  membershipCards?: MembershipCardUpdateManyWithoutMembershipLevelInput ;
  asLowestIn?: MembershipCardUpdateManyWithoutLowestMembershipLevelInput ;
  menus?: AppliedMenuUpdateManyWithoutMembershipLevelsInput ;
  design?: CardDesignUpdateOneWithoutMembershipsInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutMembershipLevelInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutMembershipLevelInput ;
  image?: ImageUpdateOneWithoutMembershipLevelImagesInput ;
}

export interface MembershipLevelUpdateWithoutTitleDataInput {
  description?: TranslatedStringUpdateOneRequiredWithoutMembershipLevelDescriptionInput ;
  users?: UserUpdateManyWithoutMembershipLevelInput ;
  company?: CompanyUpdateOneRequiredWithoutMembershipsInput ;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage?: number ;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  membershipCards?: MembershipCardUpdateManyWithoutMembershipLevelInput ;
  asLowestIn?: MembershipCardUpdateManyWithoutLowestMembershipLevelInput ;
  promoCodes?: PromoCodeUpdateManyWithoutMembershipLevelInput ;
  menus?: AppliedMenuUpdateManyWithoutMembershipLevelsInput ;
  design?: CardDesignUpdateOneWithoutMembershipsInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutMembershipLevelInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutMembershipLevelInput ;
  image?: ImageUpdateOneWithoutMembershipLevelImagesInput ;
}

export interface MembershipLevelUpdateWithoutUsersDataInput {
  title?: TranslatedStringUpdateOneRequiredWithoutMembershipLevelTitleInput ;
  description?: TranslatedStringUpdateOneRequiredWithoutMembershipLevelDescriptionInput ;
  company?: CompanyUpdateOneRequiredWithoutMembershipsInput ;
  default?: boolean ;
  deleted?: boolean ;
  primaryColor?: string ;
  secondaryColor?: string ;
  discountPercentage?: number ;
  creditsYieldPercentage?: number ;
  pointsRequired?: number ;
  membershipCards?: MembershipCardUpdateManyWithoutMembershipLevelInput ;
  asLowestIn?: MembershipCardUpdateManyWithoutLowestMembershipLevelInput ;
  promoCodes?: PromoCodeUpdateManyWithoutMembershipLevelInput ;
  menus?: AppliedMenuUpdateManyWithoutMembershipLevelsInput ;
  design?: CardDesignUpdateOneWithoutMembershipsInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutMembershipLevelInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutMembershipLevelInput ;
  image?: ImageUpdateOneWithoutMembershipLevelImagesInput ;
}

export interface MembershipLevelUpsertWithWhereUniqueWithoutCompanyInput {
  where: MembershipLevelWhereUniqueInput;
  update: MembershipLevelUpdateWithoutCompanyDataInput;
  create: MembershipLevelCreateWithoutCompanyInput;
}

export interface MembershipLevelUpsertWithWhereUniqueWithoutDesignInput {
  where: MembershipLevelWhereUniqueInput;
  update: MembershipLevelUpdateWithoutDesignDataInput;
  create: MembershipLevelCreateWithoutDesignInput;
}

export interface MembershipLevelUpsertWithWhereUniqueWithoutImageInput {
  where: MembershipLevelWhereUniqueInput;
  update: MembershipLevelUpdateWithoutImageDataInput;
  create: MembershipLevelCreateWithoutImageInput;
}

export interface MembershipLevelUpsertWithWhereUniqueWithoutMenusInput {
  where: MembershipLevelWhereUniqueInput;
  update: MembershipLevelUpdateWithoutMenusDataInput;
  create: MembershipLevelCreateWithoutMenusInput;
}

export interface MembershipLevelUpsertWithoutAsLowestInInput {
  update: MembershipLevelUpdateWithoutAsLowestInDataInput;
  create: MembershipLevelCreateWithoutAsLowestInInput;
}

export interface MembershipLevelUpsertWithoutDescriptionInput {
  update: MembershipLevelUpdateWithoutDescriptionDataInput;
  create: MembershipLevelCreateWithoutDescriptionInput;
}

export interface MembershipLevelUpsertWithoutMembershipAssignmentsInput {
  update: MembershipLevelUpdateWithoutMembershipAssignmentsDataInput;
  create: MembershipLevelCreateWithoutMembershipAssignmentsInput;
}

export interface MembershipLevelUpsertWithoutMembershipCardsInput {
  update: MembershipLevelUpdateWithoutMembershipCardsDataInput;
  create: MembershipLevelCreateWithoutMembershipCardsInput;
}

export interface MembershipLevelUpsertWithoutMembershipTradeinsInput {
  update: MembershipLevelUpdateWithoutMembershipTradeinsDataInput;
  create: MembershipLevelCreateWithoutMembershipTradeinsInput;
}

export interface MembershipLevelUpsertWithoutPromoCodesInput {
  update: MembershipLevelUpdateWithoutPromoCodesDataInput;
  create: MembershipLevelCreateWithoutPromoCodesInput;
}

export interface MembershipLevelUpsertWithoutTitleInput {
  update: MembershipLevelUpdateWithoutTitleDataInput;
  create: MembershipLevelCreateWithoutTitleInput;
}

export interface MembershipLevelUpsertWithoutUsersInput {
  update: MembershipLevelUpdateWithoutUsersDataInput;
  create: MembershipLevelCreateWithoutUsersInput;
}

export interface MembershipLevelWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  title?: TranslatedStringWhereInput ;
  description?: TranslatedStringWhereInput ;
  users_every?: UserWhereInput ;
  users_some?: UserWhereInput ;
  users_none?: UserWhereInput ;
  company?: CompanyWhereInput ;
  default?: boolean ;
  default_not?: boolean ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  primaryColor?: string ;
  primaryColor_not?: string ;
  primaryColor_in?: string[] ;
  primaryColor_not_in?: string[] ;
  primaryColor_lt?: string ;
  primaryColor_lte?: string ;
  primaryColor_gt?: string ;
  primaryColor_gte?: string ;
  primaryColor_contains?: string ;
  primaryColor_not_contains?: string ;
  primaryColor_starts_with?: string ;
  primaryColor_not_starts_with?: string ;
  primaryColor_ends_with?: string ;
  primaryColor_not_ends_with?: string ;
  secondaryColor?: string ;
  secondaryColor_not?: string ;
  secondaryColor_in?: string[] ;
  secondaryColor_not_in?: string[] ;
  secondaryColor_lt?: string ;
  secondaryColor_lte?: string ;
  secondaryColor_gt?: string ;
  secondaryColor_gte?: string ;
  secondaryColor_contains?: string ;
  secondaryColor_not_contains?: string ;
  secondaryColor_starts_with?: string ;
  secondaryColor_not_starts_with?: string ;
  secondaryColor_ends_with?: string ;
  secondaryColor_not_ends_with?: string ;
  discountPercentage?: number ;
  discountPercentage_not?: number ;
  discountPercentage_in?: number[] ;
  discountPercentage_not_in?: number[] ;
  discountPercentage_lt?: number ;
  discountPercentage_lte?: number ;
  discountPercentage_gt?: number ;
  discountPercentage_gte?: number ;
  creditsYieldPercentage?: number ;
  creditsYieldPercentage_not?: number ;
  creditsYieldPercentage_in?: number[] ;
  creditsYieldPercentage_not_in?: number[] ;
  creditsYieldPercentage_lt?: number ;
  creditsYieldPercentage_lte?: number ;
  creditsYieldPercentage_gt?: number ;
  creditsYieldPercentage_gte?: number ;
  pointsRequired?: number ;
  pointsRequired_not?: number ;
  pointsRequired_in?: number[] ;
  pointsRequired_not_in?: number[] ;
  pointsRequired_lt?: number ;
  pointsRequired_lte?: number ;
  pointsRequired_gt?: number ;
  pointsRequired_gte?: number ;
  membershipCards_every?: MembershipCardWhereInput ;
  membershipCards_some?: MembershipCardWhereInput ;
  membershipCards_none?: MembershipCardWhereInput ;
  asLowestIn_every?: MembershipCardWhereInput ;
  asLowestIn_some?: MembershipCardWhereInput ;
  asLowestIn_none?: MembershipCardWhereInput ;
  promoCodes_every?: PromoCodeWhereInput ;
  promoCodes_some?: PromoCodeWhereInput ;
  promoCodes_none?: PromoCodeWhereInput ;
  menus_every?: AppliedMenuWhereInput ;
  menus_some?: AppliedMenuWhereInput ;
  menus_none?: AppliedMenuWhereInput ;
  design?: CardDesignWhereInput ;
  membershipAssignments_every?: MembershipAssignmentWhereInput ;
  membershipAssignments_some?: MembershipAssignmentWhereInput ;
  membershipAssignments_none?: MembershipAssignmentWhereInput ;
  membershipTradeins_every?: MembershipTradeinWhereInput ;
  membershipTradeins_some?: MembershipTradeinWhereInput ;
  membershipTradeins_none?: MembershipTradeinWhereInput ;
  image?: ImageWhereInput ;
  AND?: MembershipLevelWhereInput[] ;
  OR?: MembershipLevelWhereInput[] ;
  NOT?: MembershipLevelWhereInput[] ;
}

export interface MembershipLevelWhereUniqueInput {
  id?: string ;
}

export interface MembershipTradeinCreateManyWithoutCompanyInput {
  create?: MembershipTradeinCreateWithoutCompanyInput[] ;
  connect?: MembershipTradeinWhereUniqueInput[] ;
}

export interface MembershipTradeinCreateManyWithoutMembershipLevelInput {
  create?: MembershipTradeinCreateWithoutMembershipLevelInput[] ;
  connect?: MembershipTradeinWhereUniqueInput[] ;
}

export interface MembershipTradeinCreateManyWithoutUserInput {
  create?: MembershipTradeinCreateWithoutUserInput[] ;
  connect?: MembershipTradeinWhereUniqueInput[] ;
}

export interface MembershipTradeinCreateWithoutCompanyInput {
  id?: string ;
  membershipLevel: MembershipLevelCreateOneWithoutMembershipTradeinsInput;
  traded?: boolean ;
  code: string;
  user?: UserCreateOneWithoutMembershipTradeinsInput ;
}

export interface MembershipTradeinCreateWithoutMembershipLevelInput {
  id?: string ;
  traded?: boolean ;
  code: string;
  user?: UserCreateOneWithoutMembershipTradeinsInput ;
  company: CompanyCreateOneWithoutMembershipTradeinsInput;
}

export interface MembershipTradeinCreateWithoutUserInput {
  id?: string ;
  membershipLevel: MembershipLevelCreateOneWithoutMembershipTradeinsInput;
  traded?: boolean ;
  code: string;
  company: CompanyCreateOneWithoutMembershipTradeinsInput;
}

export interface MembershipTradeinScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  traded?: boolean ;
  traded_not?: boolean ;
  code?: string ;
  code_not?: string ;
  code_in?: string[] ;
  code_not_in?: string[] ;
  code_lt?: string ;
  code_lte?: string ;
  code_gt?: string ;
  code_gte?: string ;
  code_contains?: string ;
  code_not_contains?: string ;
  code_starts_with?: string ;
  code_not_starts_with?: string ;
  code_ends_with?: string ;
  code_not_ends_with?: string ;
  AND?: MembershipTradeinScalarWhereInput[] ;
  OR?: MembershipTradeinScalarWhereInput[] ;
  NOT?: MembershipTradeinScalarWhereInput[] ;
}

export interface MembershipTradeinUpdateManyDataInput {
  traded?: boolean ;
  code?: string ;
}

export interface MembershipTradeinUpdateManyWithWhereNestedInput {
  where: MembershipTradeinScalarWhereInput;
  data: MembershipTradeinUpdateManyDataInput;
}

export interface MembershipTradeinUpdateManyWithoutCompanyInput {
  create?: MembershipTradeinCreateWithoutCompanyInput[] ;
  connect?: MembershipTradeinWhereUniqueInput[] ;
  set?: MembershipTradeinWhereUniqueInput[] ;
  disconnect?: MembershipTradeinWhereUniqueInput[] ;
  update?: MembershipTradeinUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: MembershipTradeinUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: MembershipTradeinScalarWhereInput[] ;
  updateMany?: MembershipTradeinUpdateManyWithWhereNestedInput[] ;
}

export interface MembershipTradeinUpdateManyWithoutMembershipLevelInput {
  create?: MembershipTradeinCreateWithoutMembershipLevelInput[] ;
  connect?: MembershipTradeinWhereUniqueInput[] ;
  set?: MembershipTradeinWhereUniqueInput[] ;
  disconnect?: MembershipTradeinWhereUniqueInput[] ;
  update?: MembershipTradeinUpdateWithWhereUniqueWithoutMembershipLevelInput[] ;
  upsert?: MembershipTradeinUpsertWithWhereUniqueWithoutMembershipLevelInput[] ;
  deleteMany?: MembershipTradeinScalarWhereInput[] ;
  updateMany?: MembershipTradeinUpdateManyWithWhereNestedInput[] ;
}

export interface MembershipTradeinUpdateManyWithoutUserInput {
  create?: MembershipTradeinCreateWithoutUserInput[] ;
  connect?: MembershipTradeinWhereUniqueInput[] ;
  set?: MembershipTradeinWhereUniqueInput[] ;
  disconnect?: MembershipTradeinWhereUniqueInput[] ;
  update?: MembershipTradeinUpdateWithWhereUniqueWithoutUserInput[] ;
  upsert?: MembershipTradeinUpsertWithWhereUniqueWithoutUserInput[] ;
  deleteMany?: MembershipTradeinScalarWhereInput[] ;
  updateMany?: MembershipTradeinUpdateManyWithWhereNestedInput[] ;
}

export interface MembershipTradeinUpdateWithWhereUniqueWithoutCompanyInput {
  where: MembershipTradeinWhereUniqueInput;
  data: MembershipTradeinUpdateWithoutCompanyDataInput;
}

export interface MembershipTradeinUpdateWithWhereUniqueWithoutMembershipLevelInput {
  where: MembershipTradeinWhereUniqueInput;
  data: MembershipTradeinUpdateWithoutMembershipLevelDataInput;
}

export interface MembershipTradeinUpdateWithWhereUniqueWithoutUserInput {
  where: MembershipTradeinWhereUniqueInput;
  data: MembershipTradeinUpdateWithoutUserDataInput;
}

export interface MembershipTradeinUpdateWithoutCompanyDataInput {
  membershipLevel?: MembershipLevelUpdateOneRequiredWithoutMembershipTradeinsInput ;
  traded?: boolean ;
  code?: string ;
  user?: UserUpdateOneWithoutMembershipTradeinsInput ;
}

export interface MembershipTradeinUpdateWithoutMembershipLevelDataInput {
  traded?: boolean ;
  code?: string ;
  user?: UserUpdateOneWithoutMembershipTradeinsInput ;
  company?: CompanyUpdateOneRequiredWithoutMembershipTradeinsInput ;
}

export interface MembershipTradeinUpdateWithoutUserDataInput {
  membershipLevel?: MembershipLevelUpdateOneRequiredWithoutMembershipTradeinsInput ;
  traded?: boolean ;
  code?: string ;
  company?: CompanyUpdateOneRequiredWithoutMembershipTradeinsInput ;
}

export interface MembershipTradeinUpsertWithWhereUniqueWithoutCompanyInput {
  where: MembershipTradeinWhereUniqueInput;
  update: MembershipTradeinUpdateWithoutCompanyDataInput;
  create: MembershipTradeinCreateWithoutCompanyInput;
}

export interface MembershipTradeinUpsertWithWhereUniqueWithoutMembershipLevelInput {
  where: MembershipTradeinWhereUniqueInput;
  update: MembershipTradeinUpdateWithoutMembershipLevelDataInput;
  create: MembershipTradeinCreateWithoutMembershipLevelInput;
}

export interface MembershipTradeinUpsertWithWhereUniqueWithoutUserInput {
  where: MembershipTradeinWhereUniqueInput;
  update: MembershipTradeinUpdateWithoutUserDataInput;
  create: MembershipTradeinCreateWithoutUserInput;
}

export interface MembershipTradeinWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  membershipLevel?: MembershipLevelWhereInput ;
  traded?: boolean ;
  traded_not?: boolean ;
  code?: string ;
  code_not?: string ;
  code_in?: string[] ;
  code_not_in?: string[] ;
  code_lt?: string ;
  code_lte?: string ;
  code_gt?: string ;
  code_gte?: string ;
  code_contains?: string ;
  code_not_contains?: string ;
  code_starts_with?: string ;
  code_not_starts_with?: string ;
  code_ends_with?: string ;
  code_not_ends_with?: string ;
  user?: UserWhereInput ;
  company?: CompanyWhereInput ;
  AND?: MembershipTradeinWhereInput[] ;
  OR?: MembershipTradeinWhereInput[] ;
  NOT?: MembershipTradeinWhereInput[] ;
}

export interface MembershipTradeinWhereUniqueInput {
  id?: string ;
}

export interface MenuCreateInput {
  company?: CompanyCreateOneWithoutMenusInput ;
  id?: string ;
  menuEntries?: MenuEntryCreateManyWithoutMenuInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutMenuNameInput ;
  applications?: AppliedMenuCreateManyWithoutMenuInput ;
  deleted?: boolean ;
  currency?: CURRENCY ;
  deliveryRate?: DeliveryRateCreateManyWithoutMenuInput ;
}

export interface MenuCreateManyWithoutCompanyInput {
  create?: MenuCreateWithoutCompanyInput[] ;
  connect?: MenuWhereUniqueInput[] ;
}

export interface MenuCreateOneWithoutApplicationsInput {
  create?: MenuCreateWithoutApplicationsInput ;
  connect?: MenuWhereUniqueInput ;
}

export interface MenuCreateOneWithoutDeliveryRateInput {
  create?: MenuCreateWithoutDeliveryRateInput ;
  connect?: MenuWhereUniqueInput ;
}

export interface MenuCreateOneWithoutMenuEntriesInput {
  create?: MenuCreateWithoutMenuEntriesInput ;
  connect?: MenuWhereUniqueInput ;
}

export interface MenuCreateOneWithoutNameLangInput {
  create?: MenuCreateWithoutNameLangInput ;
  connect?: MenuWhereUniqueInput ;
}

export interface MenuCreateWithoutApplicationsInput {
  company?: CompanyCreateOneWithoutMenusInput ;
  id?: string ;
  menuEntries?: MenuEntryCreateManyWithoutMenuInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutMenuNameInput ;
  deleted?: boolean ;
  currency?: CURRENCY ;
  deliveryRate?: DeliveryRateCreateManyWithoutMenuInput ;
}

export interface MenuCreateWithoutCompanyInput {
  id?: string ;
  menuEntries?: MenuEntryCreateManyWithoutMenuInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutMenuNameInput ;
  applications?: AppliedMenuCreateManyWithoutMenuInput ;
  deleted?: boolean ;
  currency?: CURRENCY ;
  deliveryRate?: DeliveryRateCreateManyWithoutMenuInput ;
}

export interface MenuCreateWithoutDeliveryRateInput {
  company?: CompanyCreateOneWithoutMenusInput ;
  id?: string ;
  menuEntries?: MenuEntryCreateManyWithoutMenuInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutMenuNameInput ;
  applications?: AppliedMenuCreateManyWithoutMenuInput ;
  deleted?: boolean ;
  currency?: CURRENCY ;
}

export interface MenuCreateWithoutMenuEntriesInput {
  company?: CompanyCreateOneWithoutMenusInput ;
  id?: string ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutMenuNameInput ;
  applications?: AppliedMenuCreateManyWithoutMenuInput ;
  deleted?: boolean ;
  currency?: CURRENCY ;
  deliveryRate?: DeliveryRateCreateManyWithoutMenuInput ;
}

export interface MenuCreateWithoutNameLangInput {
  company?: CompanyCreateOneWithoutMenusInput ;
  id?: string ;
  menuEntries?: MenuEntryCreateManyWithoutMenuInput ;
  name: string;
  applications?: AppliedMenuCreateManyWithoutMenuInput ;
  deleted?: boolean ;
  currency?: CURRENCY ;
  deliveryRate?: DeliveryRateCreateManyWithoutMenuInput ;
}

export interface MenuEntryCreateManyWithoutCategoryInput {
  create?: MenuEntryCreateWithoutCategoryInput[] ;
  connect?: MenuEntryWhereUniqueInput[] ;
}

export interface MenuEntryCreateManyWithoutItemInput {
  create?: MenuEntryCreateWithoutItemInput[] ;
  connect?: MenuEntryWhereUniqueInput[] ;
}

export interface MenuEntryCreateManyWithoutMenuInput {
  create?: MenuEntryCreateWithoutMenuInput[] ;
  connect?: MenuEntryWhereUniqueInput[] ;
}

export interface MenuEntryCreateOneWithoutOrderItemsInput {
  create?: MenuEntryCreateWithoutOrderItemsInput ;
  connect?: MenuEntryWhereUniqueInput ;
}

export interface MenuEntryCreateOneWithoutSelectedVariationsInput {
  create?: MenuEntryCreateWithoutSelectedVariationsInput ;
  connect?: MenuEntryWhereUniqueInput ;
}

export interface MenuEntryCreateWithoutCategoryInput {
  endTime?: any ;
  id?: string ;
  item?: ItemCreateOneWithoutMenuEntriesInput ;
  menu?: MenuCreateOneWithoutMenuEntriesInput ;
  orderItems?: OrderItemCreateManyWithoutEntryInput ;
  price?: number ;
  selectedVariations?: VariationCreateManyWithoutMenuEntryInput ;
  startTime?: any ;
  instant?: boolean ;
  selfService?: boolean ;
}

export interface MenuEntryCreateWithoutItemInput {
  category?: CategoryCreateOneWithoutEntriesInput ;
  endTime?: any ;
  id?: string ;
  menu?: MenuCreateOneWithoutMenuEntriesInput ;
  orderItems?: OrderItemCreateManyWithoutEntryInput ;
  price?: number ;
  selectedVariations?: VariationCreateManyWithoutMenuEntryInput ;
  startTime?: any ;
  instant?: boolean ;
  selfService?: boolean ;
}

export interface MenuEntryCreateWithoutMenuInput {
  category?: CategoryCreateOneWithoutEntriesInput ;
  endTime?: any ;
  id?: string ;
  item?: ItemCreateOneWithoutMenuEntriesInput ;
  orderItems?: OrderItemCreateManyWithoutEntryInput ;
  price?: number ;
  selectedVariations?: VariationCreateManyWithoutMenuEntryInput ;
  startTime?: any ;
  instant?: boolean ;
  selfService?: boolean ;
}

export interface MenuEntryCreateWithoutOrderItemsInput {
  category?: CategoryCreateOneWithoutEntriesInput ;
  endTime?: any ;
  id?: string ;
  item?: ItemCreateOneWithoutMenuEntriesInput ;
  menu?: MenuCreateOneWithoutMenuEntriesInput ;
  price?: number ;
  selectedVariations?: VariationCreateManyWithoutMenuEntryInput ;
  startTime?: any ;
  instant?: boolean ;
  selfService?: boolean ;
}

export interface MenuEntryCreateWithoutSelectedVariationsInput {
  category?: CategoryCreateOneWithoutEntriesInput ;
  endTime?: any ;
  id?: string ;
  item?: ItemCreateOneWithoutMenuEntriesInput ;
  menu?: MenuCreateOneWithoutMenuEntriesInput ;
  orderItems?: OrderItemCreateManyWithoutEntryInput ;
  price?: number ;
  startTime?: any ;
  instant?: boolean ;
  selfService?: boolean ;
}

export interface MenuEntryScalarWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  endTime?: any ;
  endTime_not?: any ;
  endTime_in?: any[] ;
  endTime_not_in?: any[] ;
  endTime_lt?: any ;
  endTime_lte?: any ;
  endTime_gt?: any ;
  endTime_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  price?: number ;
  price_not?: number ;
  price_in?: number[] ;
  price_not_in?: number[] ;
  price_lt?: number ;
  price_lte?: number ;
  price_gt?: number ;
  price_gte?: number ;
  startTime?: any ;
  startTime_not?: any ;
  startTime_in?: any[] ;
  startTime_not_in?: any[] ;
  startTime_lt?: any ;
  startTime_lte?: any ;
  startTime_gt?: any ;
  startTime_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  instant?: boolean ;
  instant_not?: boolean ;
  selfService?: boolean ;
  selfService_not?: boolean ;
  AND?: MenuEntryScalarWhereInput[] ;
  OR?: MenuEntryScalarWhereInput[] ;
  NOT?: MenuEntryScalarWhereInput[] ;
}

export interface MenuEntryUpdateManyDataInput {
  endTime?: any ;
  price?: number ;
  startTime?: any ;
  instant?: boolean ;
  selfService?: boolean ;
}

export interface MenuEntryUpdateManyWithWhereNestedInput {
  where: MenuEntryScalarWhereInput;
  data: MenuEntryUpdateManyDataInput;
}

export interface MenuEntryUpdateManyWithoutCategoryInput {
  create?: MenuEntryCreateWithoutCategoryInput[] ;
  connect?: MenuEntryWhereUniqueInput[] ;
  set?: MenuEntryWhereUniqueInput[] ;
  disconnect?: MenuEntryWhereUniqueInput[] ;
  update?: MenuEntryUpdateWithWhereUniqueWithoutCategoryInput[] ;
  upsert?: MenuEntryUpsertWithWhereUniqueWithoutCategoryInput[] ;
  deleteMany?: MenuEntryScalarWhereInput[] ;
  updateMany?: MenuEntryUpdateManyWithWhereNestedInput[] ;
}

export interface MenuEntryUpdateManyWithoutItemInput {
  create?: MenuEntryCreateWithoutItemInput[] ;
  connect?: MenuEntryWhereUniqueInput[] ;
  set?: MenuEntryWhereUniqueInput[] ;
  disconnect?: MenuEntryWhereUniqueInput[] ;
  update?: MenuEntryUpdateWithWhereUniqueWithoutItemInput[] ;
  upsert?: MenuEntryUpsertWithWhereUniqueWithoutItemInput[] ;
  deleteMany?: MenuEntryScalarWhereInput[] ;
  updateMany?: MenuEntryUpdateManyWithWhereNestedInput[] ;
}

export interface MenuEntryUpdateManyWithoutMenuInput {
  create?: MenuEntryCreateWithoutMenuInput[] ;
  connect?: MenuEntryWhereUniqueInput[] ;
  set?: MenuEntryWhereUniqueInput[] ;
  disconnect?: MenuEntryWhereUniqueInput[] ;
  update?: MenuEntryUpdateWithWhereUniqueWithoutMenuInput[] ;
  upsert?: MenuEntryUpsertWithWhereUniqueWithoutMenuInput[] ;
  deleteMany?: MenuEntryScalarWhereInput[] ;
  updateMany?: MenuEntryUpdateManyWithWhereNestedInput[] ;
}

export interface MenuEntryUpdateOneWithoutOrderItemsInput {
  create?: MenuEntryCreateWithoutOrderItemsInput ;
  update?: MenuEntryUpdateWithoutOrderItemsDataInput ;
  upsert?: MenuEntryUpsertWithoutOrderItemsInput ;
  disconnect?: boolean ;
  connect?: MenuEntryWhereUniqueInput ;
}

export interface MenuEntryUpdateOneWithoutSelectedVariationsInput {
  create?: MenuEntryCreateWithoutSelectedVariationsInput ;
  update?: MenuEntryUpdateWithoutSelectedVariationsDataInput ;
  upsert?: MenuEntryUpsertWithoutSelectedVariationsInput ;
  disconnect?: boolean ;
  connect?: MenuEntryWhereUniqueInput ;
}

export interface MenuEntryUpdateWithWhereUniqueWithoutCategoryInput {
  where: MenuEntryWhereUniqueInput;
  data: MenuEntryUpdateWithoutCategoryDataInput;
}

export interface MenuEntryUpdateWithWhereUniqueWithoutItemInput {
  where: MenuEntryWhereUniqueInput;
  data: MenuEntryUpdateWithoutItemDataInput;
}

export interface MenuEntryUpdateWithWhereUniqueWithoutMenuInput {
  where: MenuEntryWhereUniqueInput;
  data: MenuEntryUpdateWithoutMenuDataInput;
}

export interface MenuEntryUpdateWithoutCategoryDataInput {
  endTime?: any ;
  item?: ItemUpdateOneWithoutMenuEntriesInput ;
  menu?: MenuUpdateOneWithoutMenuEntriesInput ;
  orderItems?: OrderItemUpdateManyWithoutEntryInput ;
  price?: number ;
  selectedVariations?: VariationUpdateManyWithoutMenuEntryInput ;
  startTime?: any ;
  instant?: boolean ;
  selfService?: boolean ;
}

export interface MenuEntryUpdateWithoutItemDataInput {
  category?: CategoryUpdateOneWithoutEntriesInput ;
  endTime?: any ;
  menu?: MenuUpdateOneWithoutMenuEntriesInput ;
  orderItems?: OrderItemUpdateManyWithoutEntryInput ;
  price?: number ;
  selectedVariations?: VariationUpdateManyWithoutMenuEntryInput ;
  startTime?: any ;
  instant?: boolean ;
  selfService?: boolean ;
}

export interface MenuEntryUpdateWithoutMenuDataInput {
  category?: CategoryUpdateOneWithoutEntriesInput ;
  endTime?: any ;
  item?: ItemUpdateOneWithoutMenuEntriesInput ;
  orderItems?: OrderItemUpdateManyWithoutEntryInput ;
  price?: number ;
  selectedVariations?: VariationUpdateManyWithoutMenuEntryInput ;
  startTime?: any ;
  instant?: boolean ;
  selfService?: boolean ;
}

export interface MenuEntryUpdateWithoutOrderItemsDataInput {
  category?: CategoryUpdateOneWithoutEntriesInput ;
  endTime?: any ;
  item?: ItemUpdateOneWithoutMenuEntriesInput ;
  menu?: MenuUpdateOneWithoutMenuEntriesInput ;
  price?: number ;
  selectedVariations?: VariationUpdateManyWithoutMenuEntryInput ;
  startTime?: any ;
  instant?: boolean ;
  selfService?: boolean ;
}

export interface MenuEntryUpdateWithoutSelectedVariationsDataInput {
  category?: CategoryUpdateOneWithoutEntriesInput ;
  endTime?: any ;
  item?: ItemUpdateOneWithoutMenuEntriesInput ;
  menu?: MenuUpdateOneWithoutMenuEntriesInput ;
  orderItems?: OrderItemUpdateManyWithoutEntryInput ;
  price?: number ;
  startTime?: any ;
  instant?: boolean ;
  selfService?: boolean ;
}

export interface MenuEntryUpsertWithWhereUniqueWithoutCategoryInput {
  where: MenuEntryWhereUniqueInput;
  update: MenuEntryUpdateWithoutCategoryDataInput;
  create: MenuEntryCreateWithoutCategoryInput;
}

export interface MenuEntryUpsertWithWhereUniqueWithoutItemInput {
  where: MenuEntryWhereUniqueInput;
  update: MenuEntryUpdateWithoutItemDataInput;
  create: MenuEntryCreateWithoutItemInput;
}

export interface MenuEntryUpsertWithWhereUniqueWithoutMenuInput {
  where: MenuEntryWhereUniqueInput;
  update: MenuEntryUpdateWithoutMenuDataInput;
  create: MenuEntryCreateWithoutMenuInput;
}

export interface MenuEntryUpsertWithoutOrderItemsInput {
  update: MenuEntryUpdateWithoutOrderItemsDataInput;
  create: MenuEntryCreateWithoutOrderItemsInput;
}

export interface MenuEntryUpsertWithoutSelectedVariationsInput {
  update: MenuEntryUpdateWithoutSelectedVariationsDataInput;
  create: MenuEntryCreateWithoutSelectedVariationsInput;
}

export interface MenuEntryWhereInput {
  category?: CategoryWhereInput ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  endTime?: any ;
  endTime_not?: any ;
  endTime_in?: any[] ;
  endTime_not_in?: any[] ;
  endTime_lt?: any ;
  endTime_lte?: any ;
  endTime_gt?: any ;
  endTime_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  item?: ItemWhereInput ;
  menu?: MenuWhereInput ;
  orderItems_every?: OrderItemWhereInput ;
  orderItems_some?: OrderItemWhereInput ;
  orderItems_none?: OrderItemWhereInput ;
  price?: number ;
  price_not?: number ;
  price_in?: number[] ;
  price_not_in?: number[] ;
  price_lt?: number ;
  price_lte?: number ;
  price_gt?: number ;
  price_gte?: number ;
  selectedVariations_every?: VariationWhereInput ;
  selectedVariations_some?: VariationWhereInput ;
  selectedVariations_none?: VariationWhereInput ;
  startTime?: any ;
  startTime_not?: any ;
  startTime_in?: any[] ;
  startTime_not_in?: any[] ;
  startTime_lt?: any ;
  startTime_lte?: any ;
  startTime_gt?: any ;
  startTime_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  instant?: boolean ;
  instant_not?: boolean ;
  selfService?: boolean ;
  selfService_not?: boolean ;
  AND?: MenuEntryWhereInput[] ;
  OR?: MenuEntryWhereInput[] ;
  NOT?: MenuEntryWhereInput[] ;
}

export interface MenuEntryWhereUniqueInput {
  id?: string ;
}

export interface MenuScalarWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  currency?: CURRENCY ;
  currency_not?: CURRENCY ;
  currency_in?: CURRENCY[] ;
  currency_not_in?: CURRENCY[] ;
  AND?: MenuScalarWhereInput[] ;
  OR?: MenuScalarWhereInput[] ;
  NOT?: MenuScalarWhereInput[] ;
}

export interface MenuUpdateInput {
  company?: CompanyUpdateOneWithoutMenusInput ;
  menuEntries?: MenuEntryUpdateManyWithoutMenuInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutMenuNameInput ;
  applications?: AppliedMenuUpdateManyWithoutMenuInput ;
  deleted?: boolean ;
  currency?: CURRENCY ;
  deliveryRate?: DeliveryRateUpdateManyWithoutMenuInput ;
}

export interface MenuUpdateManyDataInput {
  name?: string ;
  deleted?: boolean ;
  currency?: CURRENCY ;
}

export interface MenuUpdateManyWithWhereNestedInput {
  where: MenuScalarWhereInput;
  data: MenuUpdateManyDataInput;
}

export interface MenuUpdateManyWithoutCompanyInput {
  create?: MenuCreateWithoutCompanyInput[] ;
  connect?: MenuWhereUniqueInput[] ;
  set?: MenuWhereUniqueInput[] ;
  disconnect?: MenuWhereUniqueInput[] ;
  update?: MenuUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: MenuUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: MenuScalarWhereInput[] ;
  updateMany?: MenuUpdateManyWithWhereNestedInput[] ;
}

export interface MenuUpdateOneWithoutApplicationsInput {
  create?: MenuCreateWithoutApplicationsInput ;
  update?: MenuUpdateWithoutApplicationsDataInput ;
  upsert?: MenuUpsertWithoutApplicationsInput ;
  disconnect?: boolean ;
  connect?: MenuWhereUniqueInput ;
}

export interface MenuUpdateOneWithoutDeliveryRateInput {
  create?: MenuCreateWithoutDeliveryRateInput ;
  update?: MenuUpdateWithoutDeliveryRateDataInput ;
  upsert?: MenuUpsertWithoutDeliveryRateInput ;
  disconnect?: boolean ;
  connect?: MenuWhereUniqueInput ;
}

export interface MenuUpdateOneWithoutMenuEntriesInput {
  create?: MenuCreateWithoutMenuEntriesInput ;
  update?: MenuUpdateWithoutMenuEntriesDataInput ;
  upsert?: MenuUpsertWithoutMenuEntriesInput ;
  disconnect?: boolean ;
  connect?: MenuWhereUniqueInput ;
}

export interface MenuUpdateOneWithoutNameLangInput {
  create?: MenuCreateWithoutNameLangInput ;
  update?: MenuUpdateWithoutNameLangDataInput ;
  upsert?: MenuUpsertWithoutNameLangInput ;
  disconnect?: boolean ;
  connect?: MenuWhereUniqueInput ;
}

export interface MenuUpdateWithWhereUniqueWithoutCompanyInput {
  where: MenuWhereUniqueInput;
  data: MenuUpdateWithoutCompanyDataInput;
}

export interface MenuUpdateWithoutApplicationsDataInput {
  company?: CompanyUpdateOneWithoutMenusInput ;
  menuEntries?: MenuEntryUpdateManyWithoutMenuInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutMenuNameInput ;
  deleted?: boolean ;
  currency?: CURRENCY ;
  deliveryRate?: DeliveryRateUpdateManyWithoutMenuInput ;
}

export interface MenuUpdateWithoutCompanyDataInput {
  menuEntries?: MenuEntryUpdateManyWithoutMenuInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutMenuNameInput ;
  applications?: AppliedMenuUpdateManyWithoutMenuInput ;
  deleted?: boolean ;
  currency?: CURRENCY ;
  deliveryRate?: DeliveryRateUpdateManyWithoutMenuInput ;
}

export interface MenuUpdateWithoutDeliveryRateDataInput {
  company?: CompanyUpdateOneWithoutMenusInput ;
  menuEntries?: MenuEntryUpdateManyWithoutMenuInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutMenuNameInput ;
  applications?: AppliedMenuUpdateManyWithoutMenuInput ;
  deleted?: boolean ;
  currency?: CURRENCY ;
}

export interface MenuUpdateWithoutMenuEntriesDataInput {
  company?: CompanyUpdateOneWithoutMenusInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutMenuNameInput ;
  applications?: AppliedMenuUpdateManyWithoutMenuInput ;
  deleted?: boolean ;
  currency?: CURRENCY ;
  deliveryRate?: DeliveryRateUpdateManyWithoutMenuInput ;
}

export interface MenuUpdateWithoutNameLangDataInput {
  company?: CompanyUpdateOneWithoutMenusInput ;
  menuEntries?: MenuEntryUpdateManyWithoutMenuInput ;
  name?: string ;
  applications?: AppliedMenuUpdateManyWithoutMenuInput ;
  deleted?: boolean ;
  currency?: CURRENCY ;
  deliveryRate?: DeliveryRateUpdateManyWithoutMenuInput ;
}

export interface MenuUpsertWithWhereUniqueWithoutCompanyInput {
  where: MenuWhereUniqueInput;
  update: MenuUpdateWithoutCompanyDataInput;
  create: MenuCreateWithoutCompanyInput;
}

export interface MenuUpsertWithoutApplicationsInput {
  update: MenuUpdateWithoutApplicationsDataInput;
  create: MenuCreateWithoutApplicationsInput;
}

export interface MenuUpsertWithoutDeliveryRateInput {
  update: MenuUpdateWithoutDeliveryRateDataInput;
  create: MenuCreateWithoutDeliveryRateInput;
}

export interface MenuUpsertWithoutMenuEntriesInput {
  update: MenuUpdateWithoutMenuEntriesDataInput;
  create: MenuCreateWithoutMenuEntriesInput;
}

export interface MenuUpsertWithoutNameLangInput {
  update: MenuUpdateWithoutNameLangDataInput;
  create: MenuCreateWithoutNameLangInput;
}

export interface MenuWhereInput {
  company?: CompanyWhereInput ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  menuEntries_every?: MenuEntryWhereInput ;
  menuEntries_some?: MenuEntryWhereInput ;
  menuEntries_none?: MenuEntryWhereInput ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  nameLang?: TranslatedStringWhereInput ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  applications_every?: AppliedMenuWhereInput ;
  applications_some?: AppliedMenuWhereInput ;
  applications_none?: AppliedMenuWhereInput ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  currency?: CURRENCY ;
  currency_not?: CURRENCY ;
  currency_in?: CURRENCY[] ;
  currency_not_in?: CURRENCY[] ;
  deliveryRate_every?: DeliveryRateWhereInput ;
  deliveryRate_some?: DeliveryRateWhereInput ;
  deliveryRate_none?: DeliveryRateWhereInput ;
  AND?: MenuWhereInput[] ;
  OR?: MenuWhereInput[] ;
  NOT?: MenuWhereInput[] ;
}

export interface MenuWhereUniqueInput {
  id?: string ;
}

export interface ModificationGroupInput {
  type: MODIFICATION_GROUP_TYPE;
  preselectedVariations?: string[] ;
  expandedByDefault?: boolean ;
  required?: boolean ;
  variations?: string[] ;
  internalName: string;
  externalName: any;
  isGridViewEnabled?: boolean ;
  icon?: string ;
}

export interface NoteInput {
  titleLang: any;
  showToCustomers: boolean;
  imageUrls?: (string )[] ;
  companyIds?: string[] ;
}

export interface NotificationCreateManyWithoutUsersInput {
  create?: NotificationCreateWithoutUsersInput[] ;
  connect?: NotificationWhereUniqueInput[] ;
}

export interface NotificationCreateOneWithoutBodyInput {
  create?: NotificationCreateWithoutBodyInput ;
  connect?: NotificationWhereUniqueInput ;
}

export interface NotificationCreateOneWithoutSentNotificationsInput {
  create?: NotificationCreateWithoutSentNotificationsInput ;
  connect?: NotificationWhereUniqueInput ;
}

export interface NotificationCreateOneWithoutTitleInput {
  create?: NotificationCreateWithoutTitleInput ;
  connect?: NotificationWhereUniqueInput ;
}

export interface NotificationCreateWithoutBodyInput {
  id?: string ;
  users?: UserCreateManyWithoutNotificationsInput ;
  sentNotifications?: SentNotificationCreateManyWithoutNotificationInput ;
  ticker: string;
  bigText: string;
  message: string;
  sent?: NotificationCreatesentInput ;
  failed?: NotificationCreatefailedInput ;
  target?: NOTIFICATION_TARGET ;
  title?: TranslatedStringCreateOneWithoutNotifTitleInput ;
  payload?: any ;
}

export interface NotificationCreateWithoutSentNotificationsInput {
  id?: string ;
  users?: UserCreateManyWithoutNotificationsInput ;
  ticker: string;
  bigText: string;
  message: string;
  sent?: NotificationCreatesentInput ;
  failed?: NotificationCreatefailedInput ;
  target?: NOTIFICATION_TARGET ;
  title?: TranslatedStringCreateOneWithoutNotifTitleInput ;
  body?: TranslatedStringCreateOneWithoutNotifBodyInput ;
  payload?: any ;
}

export interface NotificationCreateWithoutTitleInput {
  id?: string ;
  users?: UserCreateManyWithoutNotificationsInput ;
  sentNotifications?: SentNotificationCreateManyWithoutNotificationInput ;
  ticker: string;
  bigText: string;
  message: string;
  sent?: NotificationCreatesentInput ;
  failed?: NotificationCreatefailedInput ;
  target?: NOTIFICATION_TARGET ;
  body?: TranslatedStringCreateOneWithoutNotifBodyInput ;
  payload?: any ;
}

export interface NotificationCreateWithoutUsersInput {
  id?: string ;
  sentNotifications?: SentNotificationCreateManyWithoutNotificationInput ;
  ticker: string;
  bigText: string;
  message: string;
  sent?: NotificationCreatesentInput ;
  failed?: NotificationCreatefailedInput ;
  target?: NOTIFICATION_TARGET ;
  title?: TranslatedStringCreateOneWithoutNotifTitleInput ;
  body?: TranslatedStringCreateOneWithoutNotifBodyInput ;
  payload?: any ;
}

export interface NotificationCreatefailedInput {
  set?: string[] ;
}

export interface NotificationCreatesentInput {
  set?: string[] ;
}

export interface NotificationScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  ticker?: string ;
  ticker_not?: string ;
  ticker_in?: string[] ;
  ticker_not_in?: string[] ;
  ticker_lt?: string ;
  ticker_lte?: string ;
  ticker_gt?: string ;
  ticker_gte?: string ;
  ticker_contains?: string ;
  ticker_not_contains?: string ;
  ticker_starts_with?: string ;
  ticker_not_starts_with?: string ;
  ticker_ends_with?: string ;
  ticker_not_ends_with?: string ;
  bigText?: string ;
  bigText_not?: string ;
  bigText_in?: string[] ;
  bigText_not_in?: string[] ;
  bigText_lt?: string ;
  bigText_lte?: string ;
  bigText_gt?: string ;
  bigText_gte?: string ;
  bigText_contains?: string ;
  bigText_not_contains?: string ;
  bigText_starts_with?: string ;
  bigText_not_starts_with?: string ;
  bigText_ends_with?: string ;
  bigText_not_ends_with?: string ;
  message?: string ;
  message_not?: string ;
  message_in?: string[] ;
  message_not_in?: string[] ;
  message_lt?: string ;
  message_lte?: string ;
  message_gt?: string ;
  message_gte?: string ;
  message_contains?: string ;
  message_not_contains?: string ;
  message_starts_with?: string ;
  message_not_starts_with?: string ;
  message_ends_with?: string ;
  message_not_ends_with?: string ;
  target?: NOTIFICATION_TARGET ;
  target_not?: NOTIFICATION_TARGET ;
  target_in?: NOTIFICATION_TARGET[] ;
  target_not_in?: NOTIFICATION_TARGET[] ;
  AND?: NotificationScalarWhereInput[] ;
  OR?: NotificationScalarWhereInput[] ;
  NOT?: NotificationScalarWhereInput[] ;
}

export interface NotificationUpdateManyDataInput {
  ticker?: string ;
  bigText?: string ;
  message?: string ;
  sent?: NotificationUpdatesentInput ;
  failed?: NotificationUpdatefailedInput ;
  target?: NOTIFICATION_TARGET ;
  payload?: any ;
}

export interface NotificationUpdateManyWithWhereNestedInput {
  where: NotificationScalarWhereInput;
  data: NotificationUpdateManyDataInput;
}

export interface NotificationUpdateManyWithoutUsersInput {
  create?: NotificationCreateWithoutUsersInput[] ;
  connect?: NotificationWhereUniqueInput[] ;
  set?: NotificationWhereUniqueInput[] ;
  disconnect?: NotificationWhereUniqueInput[] ;
  update?: NotificationUpdateWithWhereUniqueWithoutUsersInput[] ;
  upsert?: NotificationUpsertWithWhereUniqueWithoutUsersInput[] ;
  deleteMany?: NotificationScalarWhereInput[] ;
  updateMany?: NotificationUpdateManyWithWhereNestedInput[] ;
}

export interface NotificationUpdateOneRequiredWithoutSentNotificationsInput {
  create?: NotificationCreateWithoutSentNotificationsInput ;
  update?: NotificationUpdateWithoutSentNotificationsDataInput ;
  upsert?: NotificationUpsertWithoutSentNotificationsInput ;
  connect?: NotificationWhereUniqueInput ;
}

export interface NotificationUpdateOneWithoutBodyInput {
  create?: NotificationCreateWithoutBodyInput ;
  update?: NotificationUpdateWithoutBodyDataInput ;
  upsert?: NotificationUpsertWithoutBodyInput ;
  disconnect?: boolean ;
  connect?: NotificationWhereUniqueInput ;
}

export interface NotificationUpdateOneWithoutTitleInput {
  create?: NotificationCreateWithoutTitleInput ;
  update?: NotificationUpdateWithoutTitleDataInput ;
  upsert?: NotificationUpsertWithoutTitleInput ;
  disconnect?: boolean ;
  connect?: NotificationWhereUniqueInput ;
}

export interface NotificationUpdateWithWhereUniqueWithoutUsersInput {
  where: NotificationWhereUniqueInput;
  data: NotificationUpdateWithoutUsersDataInput;
}

export interface NotificationUpdateWithoutBodyDataInput {
  users?: UserUpdateManyWithoutNotificationsInput ;
  sentNotifications?: SentNotificationUpdateManyWithoutNotificationInput ;
  ticker?: string ;
  bigText?: string ;
  message?: string ;
  sent?: NotificationUpdatesentInput ;
  failed?: NotificationUpdatefailedInput ;
  target?: NOTIFICATION_TARGET ;
  title?: TranslatedStringUpdateOneWithoutNotifTitleInput ;
  payload?: any ;
}

export interface NotificationUpdateWithoutSentNotificationsDataInput {
  users?: UserUpdateManyWithoutNotificationsInput ;
  ticker?: string ;
  bigText?: string ;
  message?: string ;
  sent?: NotificationUpdatesentInput ;
  failed?: NotificationUpdatefailedInput ;
  target?: NOTIFICATION_TARGET ;
  title?: TranslatedStringUpdateOneWithoutNotifTitleInput ;
  body?: TranslatedStringUpdateOneWithoutNotifBodyInput ;
  payload?: any ;
}

export interface NotificationUpdateWithoutTitleDataInput {
  users?: UserUpdateManyWithoutNotificationsInput ;
  sentNotifications?: SentNotificationUpdateManyWithoutNotificationInput ;
  ticker?: string ;
  bigText?: string ;
  message?: string ;
  sent?: NotificationUpdatesentInput ;
  failed?: NotificationUpdatefailedInput ;
  target?: NOTIFICATION_TARGET ;
  body?: TranslatedStringUpdateOneWithoutNotifBodyInput ;
  payload?: any ;
}

export interface NotificationUpdateWithoutUsersDataInput {
  sentNotifications?: SentNotificationUpdateManyWithoutNotificationInput ;
  ticker?: string ;
  bigText?: string ;
  message?: string ;
  sent?: NotificationUpdatesentInput ;
  failed?: NotificationUpdatefailedInput ;
  target?: NOTIFICATION_TARGET ;
  title?: TranslatedStringUpdateOneWithoutNotifTitleInput ;
  body?: TranslatedStringUpdateOneWithoutNotifBodyInput ;
  payload?: any ;
}

export interface NotificationUpdatefailedInput {
  set?: string[] ;
}

export interface NotificationUpdatesentInput {
  set?: string[] ;
}

export interface NotificationUpsertWithWhereUniqueWithoutUsersInput {
  where: NotificationWhereUniqueInput;
  update: NotificationUpdateWithoutUsersDataInput;
  create: NotificationCreateWithoutUsersInput;
}

export interface NotificationUpsertWithoutBodyInput {
  update: NotificationUpdateWithoutBodyDataInput;
  create: NotificationCreateWithoutBodyInput;
}

export interface NotificationUpsertWithoutSentNotificationsInput {
  update: NotificationUpdateWithoutSentNotificationsDataInput;
  create: NotificationCreateWithoutSentNotificationsInput;
}

export interface NotificationUpsertWithoutTitleInput {
  update: NotificationUpdateWithoutTitleDataInput;
  create: NotificationCreateWithoutTitleInput;
}

export interface NotificationWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  users_every?: UserWhereInput ;
  users_some?: UserWhereInput ;
  users_none?: UserWhereInput ;
  sentNotifications_every?: SentNotificationWhereInput ;
  sentNotifications_some?: SentNotificationWhereInput ;
  sentNotifications_none?: SentNotificationWhereInput ;
  ticker?: string ;
  ticker_not?: string ;
  ticker_in?: string[] ;
  ticker_not_in?: string[] ;
  ticker_lt?: string ;
  ticker_lte?: string ;
  ticker_gt?: string ;
  ticker_gte?: string ;
  ticker_contains?: string ;
  ticker_not_contains?: string ;
  ticker_starts_with?: string ;
  ticker_not_starts_with?: string ;
  ticker_ends_with?: string ;
  ticker_not_ends_with?: string ;
  bigText?: string ;
  bigText_not?: string ;
  bigText_in?: string[] ;
  bigText_not_in?: string[] ;
  bigText_lt?: string ;
  bigText_lte?: string ;
  bigText_gt?: string ;
  bigText_gte?: string ;
  bigText_contains?: string ;
  bigText_not_contains?: string ;
  bigText_starts_with?: string ;
  bigText_not_starts_with?: string ;
  bigText_ends_with?: string ;
  bigText_not_ends_with?: string ;
  message?: string ;
  message_not?: string ;
  message_in?: string[] ;
  message_not_in?: string[] ;
  message_lt?: string ;
  message_lte?: string ;
  message_gt?: string ;
  message_gte?: string ;
  message_contains?: string ;
  message_not_contains?: string ;
  message_starts_with?: string ;
  message_not_starts_with?: string ;
  message_ends_with?: string ;
  message_not_ends_with?: string ;
  target?: NOTIFICATION_TARGET ;
  target_not?: NOTIFICATION_TARGET ;
  target_in?: NOTIFICATION_TARGET[] ;
  target_not_in?: NOTIFICATION_TARGET[] ;
  title?: TranslatedStringWhereInput ;
  body?: TranslatedStringWhereInput ;
  AND?: NotificationWhereInput[] ;
  OR?: NotificationWhereInput[] ;
  NOT?: NotificationWhereInput[] ;
}

export interface NotificationWhereUniqueInput {
  id?: string ;
}

export interface OfferCreateInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  orders?: OrderCreateManyWithoutOffersInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  company?: CompanyCreateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferCreateManyWithoutCategoriesInput {
  create?: OfferCreateWithoutCategoriesInput[] ;
  connect?: OfferWhereUniqueInput[] ;
}

export interface OfferCreateManyWithoutCompanyInput {
  create?: OfferCreateWithoutCompanyInput[] ;
  connect?: OfferWhereUniqueInput[] ;
}

export interface OfferCreateManyWithoutImageInput {
  create?: OfferCreateWithoutImageInput[] ;
  connect?: OfferWhereUniqueInput[] ;
}

export interface OfferCreateManyWithoutItemsInput {
  create?: OfferCreateWithoutItemsInput[] ;
  connect?: OfferWhereUniqueInput[] ;
}

export interface OfferCreateManyWithoutOrdersInput {
  create?: OfferCreateWithoutOrdersInput[] ;
  connect?: OfferWhereUniqueInput[] ;
}

export interface OfferCreateManyWithoutUsersInput {
  create?: OfferCreateWithoutUsersInput[] ;
  connect?: OfferWhereUniqueInput[] ;
}

export interface OfferCreateManyWithoutVenuesInput {
  create?: OfferCreateWithoutVenuesInput[] ;
  connect?: OfferWhereUniqueInput[] ;
}

export interface OfferCreateOneWithoutDescriptionLangInput {
  create?: OfferCreateWithoutDescriptionLangInput ;
  connect?: OfferWhereUniqueInput ;
}

export interface OfferCreateOneWithoutNameLangInput {
  create?: OfferCreateWithoutNameLangInput ;
  connect?: OfferWhereUniqueInput ;
}

export interface OfferCreateOneWithoutOrdersSinglesInput {
  create?: OfferCreateWithoutOrdersSinglesInput ;
  connect?: OfferWhereUniqueInput ;
}

export interface OfferCreateOneWithoutPromoCodesInput {
  create?: OfferCreateWithoutPromoCodesInput ;
  connect?: OfferWhereUniqueInput ;
}

export interface OfferCreateOneWithoutReferralOfferForCompanyInput {
  create?: OfferCreateWithoutReferralOfferForCompanyInput ;
  connect?: OfferWhereUniqueInput ;
}

export interface OfferCreateOneWithoutReferrerOfferForCompanyInput {
  create?: OfferCreateWithoutReferrerOfferForCompanyInput ;
  connect?: OfferWhereUniqueInput ;
}

export interface OfferCreateOneWithoutStagesInput {
  create?: OfferCreateWithoutStagesInput ;
  connect?: OfferWhereUniqueInput ;
}

export interface OfferCreateOneWithoutStampCardsInput {
  create?: OfferCreateWithoutStampCardsInput ;
  connect?: OfferWhereUniqueInput ;
}

export interface OfferCreateOneWithoutTokensInput {
  create?: OfferCreateWithoutTokensInput ;
  connect?: OfferWhereUniqueInput ;
}

export interface OfferCreateOneWithoutUsesInput {
  create?: OfferCreateWithoutUsesInput ;
  connect?: OfferWhereUniqueInput ;
}

export interface OfferCreateOneWithoutYieldEventsInput {
  create?: OfferCreateWithoutYieldEventsInput ;
  connect?: OfferWhereUniqueInput ;
}

export interface OfferCreateWithoutCategoriesInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  orders?: OrderCreateManyWithoutOffersInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  company?: CompanyCreateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
}

export interface OfferCreateWithoutCompanyInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  orders?: OrderCreateManyWithoutOffersInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferCreateWithoutDescriptionLangInput {
  id?: string ;
  description?: string ;
  orders?: OrderCreateManyWithoutOffersInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  company?: CompanyCreateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferCreateWithoutImageInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  orders?: OrderCreateManyWithoutOffersInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  company?: CompanyCreateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferCreateWithoutItemsInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  orders?: OrderCreateManyWithoutOffersInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  company?: CompanyCreateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferCreateWithoutNameLangInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  orders?: OrderCreateManyWithoutOffersInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  company?: CompanyCreateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferCreateWithoutOrdersInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  company?: CompanyCreateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferCreateWithoutOrdersSinglesInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  orders?: OrderCreateManyWithoutOffersInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  company?: CompanyCreateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferCreateWithoutPromoCodesInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  orders?: OrderCreateManyWithoutOffersInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  company?: CompanyCreateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferCreateWithoutReferralOfferForCompanyInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  orders?: OrderCreateManyWithoutOffersInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  company?: CompanyCreateOneWithoutOffersInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferCreateWithoutReferrerOfferForCompanyInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  orders?: OrderCreateManyWithoutOffersInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  company?: CompanyCreateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferCreateWithoutStagesInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  orders?: OrderCreateManyWithoutOffersInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  company?: CompanyCreateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferCreateWithoutStampCardsInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  orders?: OrderCreateManyWithoutOffersInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  company?: CompanyCreateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferCreateWithoutTokensInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  orders?: OrderCreateManyWithoutOffersInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  company?: CompanyCreateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferCreateWithoutUsersInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  orders?: OrderCreateManyWithoutOffersInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  company?: CompanyCreateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferCreateWithoutUsesInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  orders?: OrderCreateManyWithoutOffersInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  company?: CompanyCreateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferCreateWithoutVenuesInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  orders?: OrderCreateManyWithoutOffersInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  company?: CompanyCreateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventCreateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferCreateWithoutYieldEventsInput {
  id?: string ;
  description?: string ;
  descriptionLang?: TranslatedStringCreateOneWithoutOfferDescriptionInput ;
  orders?: OrderCreateManyWithoutOffersInput ;
  ordersSingles?: OrderCreateManyWithoutOfferInput ;
  image?: ImageCreateOneWithoutOffersInput ;
  items?: ItemCreateManyWithoutOffersInput ;
  uses?: OrderItemCreateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringCreateOneWithoutOfferNameInput ;
  price: number;
  users?: UserCreateManyWithoutOffersInput ;
  company?: CompanyCreateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyCreateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyCreateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardCreateManyWithoutOfferInput ;
  tokens?: OfferTokenCreateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeCreateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  singleUseDefault?: boolean ;
  stages?: OfferStageCreateManyWithoutOfferInput ;
  venues?: VenueCreateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryCreateManyWithoutOffersInput ;
}

export interface OfferScalarWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  description?: string ;
  description_not?: string ;
  description_in?: string[] ;
  description_not_in?: string[] ;
  description_lt?: string ;
  description_lte?: string ;
  description_gt?: string ;
  description_gte?: string ;
  description_contains?: string ;
  description_not_contains?: string ;
  description_starts_with?: string ;
  description_not_starts_with?: string ;
  description_ends_with?: string ;
  description_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  price?: number ;
  price_not?: number ;
  price_in?: number[] ;
  price_not_in?: number[] ;
  price_lt?: number ;
  price_lte?: number ;
  price_gt?: number ;
  price_gte?: number ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  default?: boolean ;
  default_not?: boolean ;
  discountRate?: number ;
  discountRate_not?: number ;
  discountRate_in?: number[] ;
  discountRate_not_in?: number[] ;
  discountRate_lt?: number ;
  discountRate_lte?: number ;
  discountRate_gt?: number ;
  discountRate_gte?: number ;
  discountType?: DISCOUNT_TYPE ;
  discountType_not?: DISCOUNT_TYPE ;
  discountType_in?: DISCOUNT_TYPE[] ;
  discountType_not_in?: DISCOUNT_TYPE[] ;
  type?: OFFER_TYPE ;
  type_not?: OFFER_TYPE ;
  type_in?: OFFER_TYPE[] ;
  type_not_in?: OFFER_TYPE[] ;
  enabled?: boolean ;
  enabled_not?: boolean ;
  context?: OFFER_CONTEXT ;
  context_not?: OFFER_CONTEXT ;
  context_in?: OFFER_CONTEXT[] ;
  context_not_in?: OFFER_CONTEXT[] ;
  quality?: number ;
  quality_not?: number ;
  quality_in?: number[] ;
  quality_not_in?: number[] ;
  quality_lt?: number ;
  quality_lte?: number ;
  quality_gt?: number ;
  quality_gte?: number ;
  singleUseDefault?: boolean ;
  singleUseDefault_not?: boolean ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  AND?: OfferScalarWhereInput[] ;
  OR?: OfferScalarWhereInput[] ;
  NOT?: OfferScalarWhereInput[] ;
}

export interface OfferStageCreateManyWithoutItemsInput {
  create?: OfferStageCreateWithoutItemsInput[] ;
  connect?: OfferStageWhereUniqueInput[] ;
}

export interface OfferStageCreateManyWithoutOfferInput {
  create?: OfferStageCreateWithoutOfferInput[] ;
  connect?: OfferStageWhereUniqueInput[] ;
}

export interface OfferStageCreateOneWithoutDescriptionInput {
  create?: OfferStageCreateWithoutDescriptionInput ;
  connect?: OfferStageWhereUniqueInput ;
}

export interface OfferStageCreateOneWithoutTitleInput {
  create?: OfferStageCreateWithoutTitleInput ;
  connect?: OfferStageWhereUniqueInput ;
}

export interface OfferStageCreateWithoutDescriptionInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutOfferStageTitleInput;
  discountRate?: number ;
  discountType?: DISCOUNT_TYPE ;
  items?: ItemCreateManyWithoutOfferStagesInput ;
  offer?: OfferCreateOneWithoutStagesInput ;
}

export interface OfferStageCreateWithoutItemsInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutOfferStageTitleInput;
  description: TranslatedStringCreateOneWithoutOfferStageDescriptionInput;
  discountRate?: number ;
  discountType?: DISCOUNT_TYPE ;
  offer?: OfferCreateOneWithoutStagesInput ;
}

export interface OfferStageCreateWithoutOfferInput {
  id?: string ;
  title: TranslatedStringCreateOneWithoutOfferStageTitleInput;
  description: TranslatedStringCreateOneWithoutOfferStageDescriptionInput;
  discountRate?: number ;
  discountType?: DISCOUNT_TYPE ;
  items?: ItemCreateManyWithoutOfferStagesInput ;
}

export interface OfferStageCreateWithoutTitleInput {
  id?: string ;
  description: TranslatedStringCreateOneWithoutOfferStageDescriptionInput;
  discountRate?: number ;
  discountType?: DISCOUNT_TYPE ;
  items?: ItemCreateManyWithoutOfferStagesInput ;
  offer?: OfferCreateOneWithoutStagesInput ;
}

export interface OfferStageScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  discountRate?: number ;
  discountRate_not?: number ;
  discountRate_in?: number[] ;
  discountRate_not_in?: number[] ;
  discountRate_lt?: number ;
  discountRate_lte?: number ;
  discountRate_gt?: number ;
  discountRate_gte?: number ;
  discountType?: DISCOUNT_TYPE ;
  discountType_not?: DISCOUNT_TYPE ;
  discountType_in?: DISCOUNT_TYPE[] ;
  discountType_not_in?: DISCOUNT_TYPE[] ;
  AND?: OfferStageScalarWhereInput[] ;
  OR?: OfferStageScalarWhereInput[] ;
  NOT?: OfferStageScalarWhereInput[] ;
}

export interface OfferStageUpdateManyDataInput {
  discountRate?: number ;
  discountType?: DISCOUNT_TYPE ;
}

export interface OfferStageUpdateManyWithWhereNestedInput {
  where: OfferStageScalarWhereInput;
  data: OfferStageUpdateManyDataInput;
}

export interface OfferStageUpdateManyWithoutItemsInput {
  create?: OfferStageCreateWithoutItemsInput[] ;
  connect?: OfferStageWhereUniqueInput[] ;
  set?: OfferStageWhereUniqueInput[] ;
  disconnect?: OfferStageWhereUniqueInput[] ;
  update?: OfferStageUpdateWithWhereUniqueWithoutItemsInput[] ;
  upsert?: OfferStageUpsertWithWhereUniqueWithoutItemsInput[] ;
  deleteMany?: OfferStageScalarWhereInput[] ;
  updateMany?: OfferStageUpdateManyWithWhereNestedInput[] ;
}

export interface OfferStageUpdateManyWithoutOfferInput {
  create?: OfferStageCreateWithoutOfferInput[] ;
  connect?: OfferStageWhereUniqueInput[] ;
  set?: OfferStageWhereUniqueInput[] ;
  disconnect?: OfferStageWhereUniqueInput[] ;
  update?: OfferStageUpdateWithWhereUniqueWithoutOfferInput[] ;
  upsert?: OfferStageUpsertWithWhereUniqueWithoutOfferInput[] ;
  deleteMany?: OfferStageScalarWhereInput[] ;
  updateMany?: OfferStageUpdateManyWithWhereNestedInput[] ;
}

export interface OfferStageUpdateOneWithoutDescriptionInput {
  create?: OfferStageCreateWithoutDescriptionInput ;
  update?: OfferStageUpdateWithoutDescriptionDataInput ;
  upsert?: OfferStageUpsertWithoutDescriptionInput ;
  disconnect?: boolean ;
  connect?: OfferStageWhereUniqueInput ;
}

export interface OfferStageUpdateOneWithoutTitleInput {
  create?: OfferStageCreateWithoutTitleInput ;
  update?: OfferStageUpdateWithoutTitleDataInput ;
  upsert?: OfferStageUpsertWithoutTitleInput ;
  disconnect?: boolean ;
  connect?: OfferStageWhereUniqueInput ;
}

export interface OfferStageUpdateWithWhereUniqueWithoutItemsInput {
  where: OfferStageWhereUniqueInput;
  data: OfferStageUpdateWithoutItemsDataInput;
}

export interface OfferStageUpdateWithWhereUniqueWithoutOfferInput {
  where: OfferStageWhereUniqueInput;
  data: OfferStageUpdateWithoutOfferDataInput;
}

export interface OfferStageUpdateWithoutDescriptionDataInput {
  title?: TranslatedStringUpdateOneRequiredWithoutOfferStageTitleInput ;
  discountRate?: number ;
  discountType?: DISCOUNT_TYPE ;
  items?: ItemUpdateManyWithoutOfferStagesInput ;
  offer?: OfferUpdateOneWithoutStagesInput ;
}

export interface OfferStageUpdateWithoutItemsDataInput {
  title?: TranslatedStringUpdateOneRequiredWithoutOfferStageTitleInput ;
  description?: TranslatedStringUpdateOneRequiredWithoutOfferStageDescriptionInput ;
  discountRate?: number ;
  discountType?: DISCOUNT_TYPE ;
  offer?: OfferUpdateOneWithoutStagesInput ;
}

export interface OfferStageUpdateWithoutOfferDataInput {
  title?: TranslatedStringUpdateOneRequiredWithoutOfferStageTitleInput ;
  description?: TranslatedStringUpdateOneRequiredWithoutOfferStageDescriptionInput ;
  discountRate?: number ;
  discountType?: DISCOUNT_TYPE ;
  items?: ItemUpdateManyWithoutOfferStagesInput ;
}

export interface OfferStageUpdateWithoutTitleDataInput {
  description?: TranslatedStringUpdateOneRequiredWithoutOfferStageDescriptionInput ;
  discountRate?: number ;
  discountType?: DISCOUNT_TYPE ;
  items?: ItemUpdateManyWithoutOfferStagesInput ;
  offer?: OfferUpdateOneWithoutStagesInput ;
}

export interface OfferStageUpsertWithWhereUniqueWithoutItemsInput {
  where: OfferStageWhereUniqueInput;
  update: OfferStageUpdateWithoutItemsDataInput;
  create: OfferStageCreateWithoutItemsInput;
}

export interface OfferStageUpsertWithWhereUniqueWithoutOfferInput {
  where: OfferStageWhereUniqueInput;
  update: OfferStageUpdateWithoutOfferDataInput;
  create: OfferStageCreateWithoutOfferInput;
}

export interface OfferStageUpsertWithoutDescriptionInput {
  update: OfferStageUpdateWithoutDescriptionDataInput;
  create: OfferStageCreateWithoutDescriptionInput;
}

export interface OfferStageUpsertWithoutTitleInput {
  update: OfferStageUpdateWithoutTitleDataInput;
  create: OfferStageCreateWithoutTitleInput;
}

export interface OfferStageWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  title?: TranslatedStringWhereInput ;
  description?: TranslatedStringWhereInput ;
  discountRate?: number ;
  discountRate_not?: number ;
  discountRate_in?: number[] ;
  discountRate_not_in?: number[] ;
  discountRate_lt?: number ;
  discountRate_lte?: number ;
  discountRate_gt?: number ;
  discountRate_gte?: number ;
  discountType?: DISCOUNT_TYPE ;
  discountType_not?: DISCOUNT_TYPE ;
  discountType_in?: DISCOUNT_TYPE[] ;
  discountType_not_in?: DISCOUNT_TYPE[] ;
  items_every?: ItemWhereInput ;
  items_some?: ItemWhereInput ;
  items_none?: ItemWhereInput ;
  offer?: OfferWhereInput ;
  AND?: OfferStageWhereInput[] ;
  OR?: OfferStageWhereInput[] ;
  NOT?: OfferStageWhereInput[] ;
}

export interface OfferStageWhereUniqueInput {
  id?: string ;
}

export interface OfferTokenCreateManyWithoutOfferInput {
  create?: OfferTokenCreateWithoutOfferInput[] ;
  connect?: OfferTokenWhereUniqueInput[] ;
}

export interface OfferTokenCreateManyWithoutUserInput {
  create?: OfferTokenCreateWithoutUserInput[] ;
  connect?: OfferTokenWhereUniqueInput[] ;
}

export interface OfferTokenCreateOneWithoutAvailabilitiesInput {
  create?: OfferTokenCreateWithoutAvailabilitiesInput ;
  connect?: OfferTokenWhereUniqueInput ;
}

export interface OfferTokenCreateWithoutAvailabilitiesInput {
  id?: string ;
  offer?: OfferCreateOneWithoutTokensInput ;
  used?: boolean ;
  user?: UserCreateOneWithoutTokensInput ;
  expiresAt?: any ;
  singleUse?: boolean ;
  expired?: boolean ;
  activated?: boolean ;
  lifetime?: number ;
  deleteAt?: any ;
  deleted?: boolean ;
}

export interface OfferTokenCreateWithoutOfferInput {
  id?: string ;
  used?: boolean ;
  user?: UserCreateOneWithoutTokensInput ;
  expiresAt?: any ;
  singleUse?: boolean ;
  availabilities?: AvailabilityCreateManyWithoutOfferTokenInput ;
  expired?: boolean ;
  activated?: boolean ;
  lifetime?: number ;
  deleteAt?: any ;
  deleted?: boolean ;
}

export interface OfferTokenCreateWithoutUserInput {
  id?: string ;
  offer?: OfferCreateOneWithoutTokensInput ;
  used?: boolean ;
  expiresAt?: any ;
  singleUse?: boolean ;
  availabilities?: AvailabilityCreateManyWithoutOfferTokenInput ;
  expired?: boolean ;
  activated?: boolean ;
  lifetime?: number ;
  deleteAt?: any ;
  deleted?: boolean ;
}

export interface OfferTokenScalarWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  used?: boolean ;
  used_not?: boolean ;
  expiresAt?: any ;
  expiresAt_not?: any ;
  expiresAt_in?: any[] ;
  expiresAt_not_in?: any[] ;
  expiresAt_lt?: any ;
  expiresAt_lte?: any ;
  expiresAt_gt?: any ;
  expiresAt_gte?: any ;
  singleUse?: boolean ;
  singleUse_not?: boolean ;
  expired?: boolean ;
  expired_not?: boolean ;
  activated?: boolean ;
  activated_not?: boolean ;
  lifetime?: number ;
  lifetime_not?: number ;
  lifetime_in?: number[] ;
  lifetime_not_in?: number[] ;
  lifetime_lt?: number ;
  lifetime_lte?: number ;
  lifetime_gt?: number ;
  lifetime_gte?: number ;
  deleteAt?: any ;
  deleteAt_not?: any ;
  deleteAt_in?: any[] ;
  deleteAt_not_in?: any[] ;
  deleteAt_lt?: any ;
  deleteAt_lte?: any ;
  deleteAt_gt?: any ;
  deleteAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  AND?: OfferTokenScalarWhereInput[] ;
  OR?: OfferTokenScalarWhereInput[] ;
  NOT?: OfferTokenScalarWhereInput[] ;
}

export interface OfferTokenUpdateManyDataInput {
  used?: boolean ;
  expiresAt?: any ;
  singleUse?: boolean ;
  expired?: boolean ;
  activated?: boolean ;
  lifetime?: number ;
  deleteAt?: any ;
  deleted?: boolean ;
}

export interface OfferTokenUpdateManyWithWhereNestedInput {
  where: OfferTokenScalarWhereInput;
  data: OfferTokenUpdateManyDataInput;
}

export interface OfferTokenUpdateManyWithoutOfferInput {
  create?: OfferTokenCreateWithoutOfferInput[] ;
  connect?: OfferTokenWhereUniqueInput[] ;
  set?: OfferTokenWhereUniqueInput[] ;
  disconnect?: OfferTokenWhereUniqueInput[] ;
  update?: OfferTokenUpdateWithWhereUniqueWithoutOfferInput[] ;
  upsert?: OfferTokenUpsertWithWhereUniqueWithoutOfferInput[] ;
  deleteMany?: OfferTokenScalarWhereInput[] ;
  updateMany?: OfferTokenUpdateManyWithWhereNestedInput[] ;
}

export interface OfferTokenUpdateManyWithoutUserInput {
  create?: OfferTokenCreateWithoutUserInput[] ;
  connect?: OfferTokenWhereUniqueInput[] ;
  set?: OfferTokenWhereUniqueInput[] ;
  disconnect?: OfferTokenWhereUniqueInput[] ;
  update?: OfferTokenUpdateWithWhereUniqueWithoutUserInput[] ;
  upsert?: OfferTokenUpsertWithWhereUniqueWithoutUserInput[] ;
  deleteMany?: OfferTokenScalarWhereInput[] ;
  updateMany?: OfferTokenUpdateManyWithWhereNestedInput[] ;
}

export interface OfferTokenUpdateOneWithoutAvailabilitiesInput {
  create?: OfferTokenCreateWithoutAvailabilitiesInput ;
  update?: OfferTokenUpdateWithoutAvailabilitiesDataInput ;
  upsert?: OfferTokenUpsertWithoutAvailabilitiesInput ;
  disconnect?: boolean ;
  connect?: OfferTokenWhereUniqueInput ;
}

export interface OfferTokenUpdateWithWhereUniqueWithoutOfferInput {
  where: OfferTokenWhereUniqueInput;
  data: OfferTokenUpdateWithoutOfferDataInput;
}

export interface OfferTokenUpdateWithWhereUniqueWithoutUserInput {
  where: OfferTokenWhereUniqueInput;
  data: OfferTokenUpdateWithoutUserDataInput;
}

export interface OfferTokenUpdateWithoutAvailabilitiesDataInput {
  offer?: OfferUpdateOneWithoutTokensInput ;
  used?: boolean ;
  user?: UserUpdateOneWithoutTokensInput ;
  expiresAt?: any ;
  singleUse?: boolean ;
  expired?: boolean ;
  activated?: boolean ;
  lifetime?: number ;
  deleteAt?: any ;
  deleted?: boolean ;
}

export interface OfferTokenUpdateWithoutOfferDataInput {
  used?: boolean ;
  user?: UserUpdateOneWithoutTokensInput ;
  expiresAt?: any ;
  singleUse?: boolean ;
  availabilities?: AvailabilityUpdateManyWithoutOfferTokenInput ;
  expired?: boolean ;
  activated?: boolean ;
  lifetime?: number ;
  deleteAt?: any ;
  deleted?: boolean ;
}

export interface OfferTokenUpdateWithoutUserDataInput {
  offer?: OfferUpdateOneWithoutTokensInput ;
  used?: boolean ;
  expiresAt?: any ;
  singleUse?: boolean ;
  availabilities?: AvailabilityUpdateManyWithoutOfferTokenInput ;
  expired?: boolean ;
  activated?: boolean ;
  lifetime?: number ;
  deleteAt?: any ;
  deleted?: boolean ;
}

export interface OfferTokenUpsertWithWhereUniqueWithoutOfferInput {
  where: OfferTokenWhereUniqueInput;
  update: OfferTokenUpdateWithoutOfferDataInput;
  create: OfferTokenCreateWithoutOfferInput;
}

export interface OfferTokenUpsertWithWhereUniqueWithoutUserInput {
  where: OfferTokenWhereUniqueInput;
  update: OfferTokenUpdateWithoutUserDataInput;
  create: OfferTokenCreateWithoutUserInput;
}

export interface OfferTokenUpsertWithoutAvailabilitiesInput {
  update: OfferTokenUpdateWithoutAvailabilitiesDataInput;
  create: OfferTokenCreateWithoutAvailabilitiesInput;
}

export interface OfferTokenWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  offer?: OfferWhereInput ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  used?: boolean ;
  used_not?: boolean ;
  user?: UserWhereInput ;
  expiresAt?: any ;
  expiresAt_not?: any ;
  expiresAt_in?: any[] ;
  expiresAt_not_in?: any[] ;
  expiresAt_lt?: any ;
  expiresAt_lte?: any ;
  expiresAt_gt?: any ;
  expiresAt_gte?: any ;
  singleUse?: boolean ;
  singleUse_not?: boolean ;
  availabilities_every?: AvailabilityWhereInput ;
  availabilities_some?: AvailabilityWhereInput ;
  availabilities_none?: AvailabilityWhereInput ;
  expired?: boolean ;
  expired_not?: boolean ;
  activated?: boolean ;
  activated_not?: boolean ;
  lifetime?: number ;
  lifetime_not?: number ;
  lifetime_in?: number[] ;
  lifetime_not_in?: number[] ;
  lifetime_lt?: number ;
  lifetime_lte?: number ;
  lifetime_gt?: number ;
  lifetime_gte?: number ;
  deleteAt?: any ;
  deleteAt_not?: any ;
  deleteAt_in?: any[] ;
  deleteAt_not_in?: any[] ;
  deleteAt_lt?: any ;
  deleteAt_lte?: any ;
  deleteAt_gt?: any ;
  deleteAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  AND?: OfferTokenWhereInput[] ;
  OR?: OfferTokenWhereInput[] ;
  NOT?: OfferTokenWhereInput[] ;
}

export interface OfferTokenWhereUniqueInput {
  id?: string ;
}

export interface OfferUpdateInput {
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutOfferDescriptionInput ;
  orders?: OrderUpdateManyWithoutOffersInput ;
  ordersSingles?: OrderUpdateManyWithoutOfferInput ;
  image?: ImageUpdateOneWithoutOffersInput ;
  items?: ItemUpdateManyWithoutOffersInput ;
  uses?: OrderItemUpdateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutOfferNameInput ;
  price?: number ;
  users?: UserUpdateManyWithoutOffersInput ;
  company?: CompanyUpdateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyUpdateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyUpdateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardUpdateManyWithoutOfferInput ;
  tokens?: OfferTokenUpdateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeUpdateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventUpdateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageUpdateManyWithoutOfferInput ;
  venues?: VenueUpdateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryUpdateManyWithoutOffersInput ;
}

export interface OfferUpdateManyDataInput {
  description?: string ;
  name?: string ;
  price?: number ;
  default?: boolean ;
  discountRate?: number ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  singleUseDefault?: boolean ;
  deleted?: boolean ;
}

export interface OfferUpdateManyWithWhereNestedInput {
  where: OfferScalarWhereInput;
  data: OfferUpdateManyDataInput;
}

export interface OfferUpdateManyWithoutCategoriesInput {
  create?: OfferCreateWithoutCategoriesInput[] ;
  connect?: OfferWhereUniqueInput[] ;
  set?: OfferWhereUniqueInput[] ;
  disconnect?: OfferWhereUniqueInput[] ;
  update?: OfferUpdateWithWhereUniqueWithoutCategoriesInput[] ;
  upsert?: OfferUpsertWithWhereUniqueWithoutCategoriesInput[] ;
  deleteMany?: OfferScalarWhereInput[] ;
  updateMany?: OfferUpdateManyWithWhereNestedInput[] ;
}

export interface OfferUpdateManyWithoutCompanyInput {
  create?: OfferCreateWithoutCompanyInput[] ;
  connect?: OfferWhereUniqueInput[] ;
  set?: OfferWhereUniqueInput[] ;
  disconnect?: OfferWhereUniqueInput[] ;
  update?: OfferUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: OfferUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: OfferScalarWhereInput[] ;
  updateMany?: OfferUpdateManyWithWhereNestedInput[] ;
}

export interface OfferUpdateManyWithoutImageInput {
  create?: OfferCreateWithoutImageInput[] ;
  connect?: OfferWhereUniqueInput[] ;
  set?: OfferWhereUniqueInput[] ;
  disconnect?: OfferWhereUniqueInput[] ;
  update?: OfferUpdateWithWhereUniqueWithoutImageInput[] ;
  upsert?: OfferUpsertWithWhereUniqueWithoutImageInput[] ;
  deleteMany?: OfferScalarWhereInput[] ;
  updateMany?: OfferUpdateManyWithWhereNestedInput[] ;
}

export interface OfferUpdateManyWithoutItemsInput {
  create?: OfferCreateWithoutItemsInput[] ;
  connect?: OfferWhereUniqueInput[] ;
  set?: OfferWhereUniqueInput[] ;
  disconnect?: OfferWhereUniqueInput[] ;
  update?: OfferUpdateWithWhereUniqueWithoutItemsInput[] ;
  upsert?: OfferUpsertWithWhereUniqueWithoutItemsInput[] ;
  deleteMany?: OfferScalarWhereInput[] ;
  updateMany?: OfferUpdateManyWithWhereNestedInput[] ;
}

export interface OfferUpdateManyWithoutOrdersInput {
  create?: OfferCreateWithoutOrdersInput[] ;
  connect?: OfferWhereUniqueInput[] ;
  set?: OfferWhereUniqueInput[] ;
  disconnect?: OfferWhereUniqueInput[] ;
  update?: OfferUpdateWithWhereUniqueWithoutOrdersInput[] ;
  upsert?: OfferUpsertWithWhereUniqueWithoutOrdersInput[] ;
  deleteMany?: OfferScalarWhereInput[] ;
  updateMany?: OfferUpdateManyWithWhereNestedInput[] ;
}

export interface OfferUpdateManyWithoutUsersInput {
  create?: OfferCreateWithoutUsersInput[] ;
  connect?: OfferWhereUniqueInput[] ;
  set?: OfferWhereUniqueInput[] ;
  disconnect?: OfferWhereUniqueInput[] ;
  update?: OfferUpdateWithWhereUniqueWithoutUsersInput[] ;
  upsert?: OfferUpsertWithWhereUniqueWithoutUsersInput[] ;
  deleteMany?: OfferScalarWhereInput[] ;
  updateMany?: OfferUpdateManyWithWhereNestedInput[] ;
}

export interface OfferUpdateManyWithoutVenuesInput {
  create?: OfferCreateWithoutVenuesInput[] ;
  connect?: OfferWhereUniqueInput[] ;
  set?: OfferWhereUniqueInput[] ;
  disconnect?: OfferWhereUniqueInput[] ;
  update?: OfferUpdateWithWhereUniqueWithoutVenuesInput[] ;
  upsert?: OfferUpsertWithWhereUniqueWithoutVenuesInput[] ;
  deleteMany?: OfferScalarWhereInput[] ;
  updateMany?: OfferUpdateManyWithWhereNestedInput[] ;
}

export interface OfferUpdateOneRequiredWithoutYieldEventsInput {
  create?: OfferCreateWithoutYieldEventsInput ;
  update?: OfferUpdateWithoutYieldEventsDataInput ;
  upsert?: OfferUpsertWithoutYieldEventsInput ;
  connect?: OfferWhereUniqueInput ;
}

export interface OfferUpdateOneWithoutDescriptionLangInput {
  create?: OfferCreateWithoutDescriptionLangInput ;
  update?: OfferUpdateWithoutDescriptionLangDataInput ;
  upsert?: OfferUpsertWithoutDescriptionLangInput ;
  disconnect?: boolean ;
  connect?: OfferWhereUniqueInput ;
}

export interface OfferUpdateOneWithoutNameLangInput {
  create?: OfferCreateWithoutNameLangInput ;
  update?: OfferUpdateWithoutNameLangDataInput ;
  upsert?: OfferUpsertWithoutNameLangInput ;
  disconnect?: boolean ;
  connect?: OfferWhereUniqueInput ;
}

export interface OfferUpdateOneWithoutOrdersSinglesInput {
  create?: OfferCreateWithoutOrdersSinglesInput ;
  update?: OfferUpdateWithoutOrdersSinglesDataInput ;
  upsert?: OfferUpsertWithoutOrdersSinglesInput ;
  disconnect?: boolean ;
  connect?: OfferWhereUniqueInput ;
}

export interface OfferUpdateOneWithoutPromoCodesInput {
  create?: OfferCreateWithoutPromoCodesInput ;
  update?: OfferUpdateWithoutPromoCodesDataInput ;
  upsert?: OfferUpsertWithoutPromoCodesInput ;
  disconnect?: boolean ;
  connect?: OfferWhereUniqueInput ;
}

export interface OfferUpdateOneWithoutReferralOfferForCompanyInput {
  create?: OfferCreateWithoutReferralOfferForCompanyInput ;
  update?: OfferUpdateWithoutReferralOfferForCompanyDataInput ;
  upsert?: OfferUpsertWithoutReferralOfferForCompanyInput ;
  disconnect?: boolean ;
  connect?: OfferWhereUniqueInput ;
}

export interface OfferUpdateOneWithoutReferrerOfferForCompanyInput {
  create?: OfferCreateWithoutReferrerOfferForCompanyInput ;
  update?: OfferUpdateWithoutReferrerOfferForCompanyDataInput ;
  upsert?: OfferUpsertWithoutReferrerOfferForCompanyInput ;
  disconnect?: boolean ;
  connect?: OfferWhereUniqueInput ;
}

export interface OfferUpdateOneWithoutStagesInput {
  create?: OfferCreateWithoutStagesInput ;
  update?: OfferUpdateWithoutStagesDataInput ;
  upsert?: OfferUpsertWithoutStagesInput ;
  disconnect?: boolean ;
  connect?: OfferWhereUniqueInput ;
}

export interface OfferUpdateOneWithoutStampCardsInput {
  create?: OfferCreateWithoutStampCardsInput ;
  update?: OfferUpdateWithoutStampCardsDataInput ;
  upsert?: OfferUpsertWithoutStampCardsInput ;
  disconnect?: boolean ;
  connect?: OfferWhereUniqueInput ;
}

export interface OfferUpdateOneWithoutTokensInput {
  create?: OfferCreateWithoutTokensInput ;
  update?: OfferUpdateWithoutTokensDataInput ;
  upsert?: OfferUpsertWithoutTokensInput ;
  disconnect?: boolean ;
  connect?: OfferWhereUniqueInput ;
}

export interface OfferUpdateOneWithoutUsesInput {
  create?: OfferCreateWithoutUsesInput ;
  update?: OfferUpdateWithoutUsesDataInput ;
  upsert?: OfferUpsertWithoutUsesInput ;
  disconnect?: boolean ;
  connect?: OfferWhereUniqueInput ;
}

export interface OfferUpdateWithWhereUniqueWithoutCategoriesInput {
  where: OfferWhereUniqueInput;
  data: OfferUpdateWithoutCategoriesDataInput;
}

export interface OfferUpdateWithWhereUniqueWithoutCompanyInput {
  where: OfferWhereUniqueInput;
  data: OfferUpdateWithoutCompanyDataInput;
}

export interface OfferUpdateWithWhereUniqueWithoutImageInput {
  where: OfferWhereUniqueInput;
  data: OfferUpdateWithoutImageDataInput;
}

export interface OfferUpdateWithWhereUniqueWithoutItemsInput {
  where: OfferWhereUniqueInput;
  data: OfferUpdateWithoutItemsDataInput;
}

export interface OfferUpdateWithWhereUniqueWithoutOrdersInput {
  where: OfferWhereUniqueInput;
  data: OfferUpdateWithoutOrdersDataInput;
}

export interface OfferUpdateWithWhereUniqueWithoutUsersInput {
  where: OfferWhereUniqueInput;
  data: OfferUpdateWithoutUsersDataInput;
}

export interface OfferUpdateWithWhereUniqueWithoutVenuesInput {
  where: OfferWhereUniqueInput;
  data: OfferUpdateWithoutVenuesDataInput;
}

export interface OfferUpdateWithoutCategoriesDataInput {
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutOfferDescriptionInput ;
  orders?: OrderUpdateManyWithoutOffersInput ;
  ordersSingles?: OrderUpdateManyWithoutOfferInput ;
  image?: ImageUpdateOneWithoutOffersInput ;
  items?: ItemUpdateManyWithoutOffersInput ;
  uses?: OrderItemUpdateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutOfferNameInput ;
  price?: number ;
  users?: UserUpdateManyWithoutOffersInput ;
  company?: CompanyUpdateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyUpdateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyUpdateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardUpdateManyWithoutOfferInput ;
  tokens?: OfferTokenUpdateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeUpdateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventUpdateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageUpdateManyWithoutOfferInput ;
  venues?: VenueUpdateManyWithoutOffersInput ;
  deleted?: boolean ;
}

export interface OfferUpdateWithoutCompanyDataInput {
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutOfferDescriptionInput ;
  orders?: OrderUpdateManyWithoutOffersInput ;
  ordersSingles?: OrderUpdateManyWithoutOfferInput ;
  image?: ImageUpdateOneWithoutOffersInput ;
  items?: ItemUpdateManyWithoutOffersInput ;
  uses?: OrderItemUpdateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutOfferNameInput ;
  price?: number ;
  users?: UserUpdateManyWithoutOffersInput ;
  referralOfferForCompany?: CompanyUpdateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyUpdateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardUpdateManyWithoutOfferInput ;
  tokens?: OfferTokenUpdateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeUpdateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventUpdateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageUpdateManyWithoutOfferInput ;
  venues?: VenueUpdateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryUpdateManyWithoutOffersInput ;
}

export interface OfferUpdateWithoutDescriptionLangDataInput {
  description?: string ;
  orders?: OrderUpdateManyWithoutOffersInput ;
  ordersSingles?: OrderUpdateManyWithoutOfferInput ;
  image?: ImageUpdateOneWithoutOffersInput ;
  items?: ItemUpdateManyWithoutOffersInput ;
  uses?: OrderItemUpdateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutOfferNameInput ;
  price?: number ;
  users?: UserUpdateManyWithoutOffersInput ;
  company?: CompanyUpdateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyUpdateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyUpdateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardUpdateManyWithoutOfferInput ;
  tokens?: OfferTokenUpdateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeUpdateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventUpdateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageUpdateManyWithoutOfferInput ;
  venues?: VenueUpdateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryUpdateManyWithoutOffersInput ;
}

export interface OfferUpdateWithoutImageDataInput {
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutOfferDescriptionInput ;
  orders?: OrderUpdateManyWithoutOffersInput ;
  ordersSingles?: OrderUpdateManyWithoutOfferInput ;
  items?: ItemUpdateManyWithoutOffersInput ;
  uses?: OrderItemUpdateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutOfferNameInput ;
  price?: number ;
  users?: UserUpdateManyWithoutOffersInput ;
  company?: CompanyUpdateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyUpdateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyUpdateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardUpdateManyWithoutOfferInput ;
  tokens?: OfferTokenUpdateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeUpdateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventUpdateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageUpdateManyWithoutOfferInput ;
  venues?: VenueUpdateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryUpdateManyWithoutOffersInput ;
}

export interface OfferUpdateWithoutItemsDataInput {
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutOfferDescriptionInput ;
  orders?: OrderUpdateManyWithoutOffersInput ;
  ordersSingles?: OrderUpdateManyWithoutOfferInput ;
  image?: ImageUpdateOneWithoutOffersInput ;
  uses?: OrderItemUpdateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutOfferNameInput ;
  price?: number ;
  users?: UserUpdateManyWithoutOffersInput ;
  company?: CompanyUpdateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyUpdateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyUpdateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardUpdateManyWithoutOfferInput ;
  tokens?: OfferTokenUpdateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeUpdateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventUpdateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageUpdateManyWithoutOfferInput ;
  venues?: VenueUpdateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryUpdateManyWithoutOffersInput ;
}

export interface OfferUpdateWithoutNameLangDataInput {
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutOfferDescriptionInput ;
  orders?: OrderUpdateManyWithoutOffersInput ;
  ordersSingles?: OrderUpdateManyWithoutOfferInput ;
  image?: ImageUpdateOneWithoutOffersInput ;
  items?: ItemUpdateManyWithoutOffersInput ;
  uses?: OrderItemUpdateManyWithoutOfferInput ;
  name?: string ;
  price?: number ;
  users?: UserUpdateManyWithoutOffersInput ;
  company?: CompanyUpdateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyUpdateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyUpdateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardUpdateManyWithoutOfferInput ;
  tokens?: OfferTokenUpdateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeUpdateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventUpdateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageUpdateManyWithoutOfferInput ;
  venues?: VenueUpdateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryUpdateManyWithoutOffersInput ;
}

export interface OfferUpdateWithoutOrdersDataInput {
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutOfferDescriptionInput ;
  ordersSingles?: OrderUpdateManyWithoutOfferInput ;
  image?: ImageUpdateOneWithoutOffersInput ;
  items?: ItemUpdateManyWithoutOffersInput ;
  uses?: OrderItemUpdateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutOfferNameInput ;
  price?: number ;
  users?: UserUpdateManyWithoutOffersInput ;
  company?: CompanyUpdateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyUpdateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyUpdateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardUpdateManyWithoutOfferInput ;
  tokens?: OfferTokenUpdateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeUpdateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventUpdateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageUpdateManyWithoutOfferInput ;
  venues?: VenueUpdateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryUpdateManyWithoutOffersInput ;
}

export interface OfferUpdateWithoutOrdersSinglesDataInput {
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutOfferDescriptionInput ;
  orders?: OrderUpdateManyWithoutOffersInput ;
  image?: ImageUpdateOneWithoutOffersInput ;
  items?: ItemUpdateManyWithoutOffersInput ;
  uses?: OrderItemUpdateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutOfferNameInput ;
  price?: number ;
  users?: UserUpdateManyWithoutOffersInput ;
  company?: CompanyUpdateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyUpdateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyUpdateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardUpdateManyWithoutOfferInput ;
  tokens?: OfferTokenUpdateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeUpdateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventUpdateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageUpdateManyWithoutOfferInput ;
  venues?: VenueUpdateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryUpdateManyWithoutOffersInput ;
}

export interface OfferUpdateWithoutPromoCodesDataInput {
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutOfferDescriptionInput ;
  orders?: OrderUpdateManyWithoutOffersInput ;
  ordersSingles?: OrderUpdateManyWithoutOfferInput ;
  image?: ImageUpdateOneWithoutOffersInput ;
  items?: ItemUpdateManyWithoutOffersInput ;
  uses?: OrderItemUpdateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutOfferNameInput ;
  price?: number ;
  users?: UserUpdateManyWithoutOffersInput ;
  company?: CompanyUpdateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyUpdateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyUpdateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardUpdateManyWithoutOfferInput ;
  tokens?: OfferTokenUpdateManyWithoutOfferInput ;
  discountRate?: number ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventUpdateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageUpdateManyWithoutOfferInput ;
  venues?: VenueUpdateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryUpdateManyWithoutOffersInput ;
}

export interface OfferUpdateWithoutReferralOfferForCompanyDataInput {
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutOfferDescriptionInput ;
  orders?: OrderUpdateManyWithoutOffersInput ;
  ordersSingles?: OrderUpdateManyWithoutOfferInput ;
  image?: ImageUpdateOneWithoutOffersInput ;
  items?: ItemUpdateManyWithoutOffersInput ;
  uses?: OrderItemUpdateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutOfferNameInput ;
  price?: number ;
  users?: UserUpdateManyWithoutOffersInput ;
  company?: CompanyUpdateOneWithoutOffersInput ;
  referrerOfferForCompany?: CompanyUpdateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardUpdateManyWithoutOfferInput ;
  tokens?: OfferTokenUpdateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeUpdateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventUpdateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageUpdateManyWithoutOfferInput ;
  venues?: VenueUpdateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryUpdateManyWithoutOffersInput ;
}

export interface OfferUpdateWithoutReferrerOfferForCompanyDataInput {
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutOfferDescriptionInput ;
  orders?: OrderUpdateManyWithoutOffersInput ;
  ordersSingles?: OrderUpdateManyWithoutOfferInput ;
  image?: ImageUpdateOneWithoutOffersInput ;
  items?: ItemUpdateManyWithoutOffersInput ;
  uses?: OrderItemUpdateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutOfferNameInput ;
  price?: number ;
  users?: UserUpdateManyWithoutOffersInput ;
  company?: CompanyUpdateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyUpdateManyWithoutReferralOfferInput ;
  default?: boolean ;
  stampCards?: StampCardUpdateManyWithoutOfferInput ;
  tokens?: OfferTokenUpdateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeUpdateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventUpdateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageUpdateManyWithoutOfferInput ;
  venues?: VenueUpdateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryUpdateManyWithoutOffersInput ;
}

export interface OfferUpdateWithoutStagesDataInput {
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutOfferDescriptionInput ;
  orders?: OrderUpdateManyWithoutOffersInput ;
  ordersSingles?: OrderUpdateManyWithoutOfferInput ;
  image?: ImageUpdateOneWithoutOffersInput ;
  items?: ItemUpdateManyWithoutOffersInput ;
  uses?: OrderItemUpdateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutOfferNameInput ;
  price?: number ;
  users?: UserUpdateManyWithoutOffersInput ;
  company?: CompanyUpdateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyUpdateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyUpdateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardUpdateManyWithoutOfferInput ;
  tokens?: OfferTokenUpdateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeUpdateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventUpdateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  venues?: VenueUpdateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryUpdateManyWithoutOffersInput ;
}

export interface OfferUpdateWithoutStampCardsDataInput {
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutOfferDescriptionInput ;
  orders?: OrderUpdateManyWithoutOffersInput ;
  ordersSingles?: OrderUpdateManyWithoutOfferInput ;
  image?: ImageUpdateOneWithoutOffersInput ;
  items?: ItemUpdateManyWithoutOffersInput ;
  uses?: OrderItemUpdateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutOfferNameInput ;
  price?: number ;
  users?: UserUpdateManyWithoutOffersInput ;
  company?: CompanyUpdateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyUpdateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyUpdateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  tokens?: OfferTokenUpdateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeUpdateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventUpdateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageUpdateManyWithoutOfferInput ;
  venues?: VenueUpdateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryUpdateManyWithoutOffersInput ;
}

export interface OfferUpdateWithoutTokensDataInput {
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutOfferDescriptionInput ;
  orders?: OrderUpdateManyWithoutOffersInput ;
  ordersSingles?: OrderUpdateManyWithoutOfferInput ;
  image?: ImageUpdateOneWithoutOffersInput ;
  items?: ItemUpdateManyWithoutOffersInput ;
  uses?: OrderItemUpdateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutOfferNameInput ;
  price?: number ;
  users?: UserUpdateManyWithoutOffersInput ;
  company?: CompanyUpdateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyUpdateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyUpdateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardUpdateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeUpdateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventUpdateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageUpdateManyWithoutOfferInput ;
  venues?: VenueUpdateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryUpdateManyWithoutOffersInput ;
}

export interface OfferUpdateWithoutUsersDataInput {
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutOfferDescriptionInput ;
  orders?: OrderUpdateManyWithoutOffersInput ;
  ordersSingles?: OrderUpdateManyWithoutOfferInput ;
  image?: ImageUpdateOneWithoutOffersInput ;
  items?: ItemUpdateManyWithoutOffersInput ;
  uses?: OrderItemUpdateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutOfferNameInput ;
  price?: number ;
  company?: CompanyUpdateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyUpdateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyUpdateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardUpdateManyWithoutOfferInput ;
  tokens?: OfferTokenUpdateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeUpdateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventUpdateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageUpdateManyWithoutOfferInput ;
  venues?: VenueUpdateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryUpdateManyWithoutOffersInput ;
}

export interface OfferUpdateWithoutUsesDataInput {
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutOfferDescriptionInput ;
  orders?: OrderUpdateManyWithoutOffersInput ;
  ordersSingles?: OrderUpdateManyWithoutOfferInput ;
  image?: ImageUpdateOneWithoutOffersInput ;
  items?: ItemUpdateManyWithoutOffersInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutOfferNameInput ;
  price?: number ;
  users?: UserUpdateManyWithoutOffersInput ;
  company?: CompanyUpdateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyUpdateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyUpdateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardUpdateManyWithoutOfferInput ;
  tokens?: OfferTokenUpdateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeUpdateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventUpdateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageUpdateManyWithoutOfferInput ;
  venues?: VenueUpdateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryUpdateManyWithoutOffersInput ;
}

export interface OfferUpdateWithoutVenuesDataInput {
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutOfferDescriptionInput ;
  orders?: OrderUpdateManyWithoutOffersInput ;
  ordersSingles?: OrderUpdateManyWithoutOfferInput ;
  image?: ImageUpdateOneWithoutOffersInput ;
  items?: ItemUpdateManyWithoutOffersInput ;
  uses?: OrderItemUpdateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutOfferNameInput ;
  price?: number ;
  users?: UserUpdateManyWithoutOffersInput ;
  company?: CompanyUpdateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyUpdateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyUpdateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardUpdateManyWithoutOfferInput ;
  tokens?: OfferTokenUpdateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeUpdateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  yieldEvents?: OfferYieldEventUpdateManyWithoutOfferInput ;
  singleUseDefault?: boolean ;
  stages?: OfferStageUpdateManyWithoutOfferInput ;
  deleted?: boolean ;
  categories?: CategoryUpdateManyWithoutOffersInput ;
}

export interface OfferUpdateWithoutYieldEventsDataInput {
  description?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutOfferDescriptionInput ;
  orders?: OrderUpdateManyWithoutOffersInput ;
  ordersSingles?: OrderUpdateManyWithoutOfferInput ;
  image?: ImageUpdateOneWithoutOffersInput ;
  items?: ItemUpdateManyWithoutOffersInput ;
  uses?: OrderItemUpdateManyWithoutOfferInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutOfferNameInput ;
  price?: number ;
  users?: UserUpdateManyWithoutOffersInput ;
  company?: CompanyUpdateOneWithoutOffersInput ;
  referralOfferForCompany?: CompanyUpdateManyWithoutReferralOfferInput ;
  referrerOfferForCompany?: CompanyUpdateManyWithoutReferrerOfferInput ;
  default?: boolean ;
  stampCards?: StampCardUpdateManyWithoutOfferInput ;
  tokens?: OfferTokenUpdateManyWithoutOfferInput ;
  discountRate?: number ;
  promoCodes?: PromoCodeUpdateManyWithoutOfferInput ;
  discountType?: DISCOUNT_TYPE ;
  type?: OFFER_TYPE ;
  enabled?: boolean ;
  context?: OFFER_CONTEXT ;
  quality?: number ;
  singleUseDefault?: boolean ;
  stages?: OfferStageUpdateManyWithoutOfferInput ;
  venues?: VenueUpdateManyWithoutOffersInput ;
  deleted?: boolean ;
  categories?: CategoryUpdateManyWithoutOffersInput ;
}

export interface OfferUpsertWithWhereUniqueWithoutCategoriesInput {
  where: OfferWhereUniqueInput;
  update: OfferUpdateWithoutCategoriesDataInput;
  create: OfferCreateWithoutCategoriesInput;
}

export interface OfferUpsertWithWhereUniqueWithoutCompanyInput {
  where: OfferWhereUniqueInput;
  update: OfferUpdateWithoutCompanyDataInput;
  create: OfferCreateWithoutCompanyInput;
}

export interface OfferUpsertWithWhereUniqueWithoutImageInput {
  where: OfferWhereUniqueInput;
  update: OfferUpdateWithoutImageDataInput;
  create: OfferCreateWithoutImageInput;
}

export interface OfferUpsertWithWhereUniqueWithoutItemsInput {
  where: OfferWhereUniqueInput;
  update: OfferUpdateWithoutItemsDataInput;
  create: OfferCreateWithoutItemsInput;
}

export interface OfferUpsertWithWhereUniqueWithoutOrdersInput {
  where: OfferWhereUniqueInput;
  update: OfferUpdateWithoutOrdersDataInput;
  create: OfferCreateWithoutOrdersInput;
}

export interface OfferUpsertWithWhereUniqueWithoutUsersInput {
  where: OfferWhereUniqueInput;
  update: OfferUpdateWithoutUsersDataInput;
  create: OfferCreateWithoutUsersInput;
}

export interface OfferUpsertWithWhereUniqueWithoutVenuesInput {
  where: OfferWhereUniqueInput;
  update: OfferUpdateWithoutVenuesDataInput;
  create: OfferCreateWithoutVenuesInput;
}

export interface OfferUpsertWithoutDescriptionLangInput {
  update: OfferUpdateWithoutDescriptionLangDataInput;
  create: OfferCreateWithoutDescriptionLangInput;
}

export interface OfferUpsertWithoutNameLangInput {
  update: OfferUpdateWithoutNameLangDataInput;
  create: OfferCreateWithoutNameLangInput;
}

export interface OfferUpsertWithoutOrdersSinglesInput {
  update: OfferUpdateWithoutOrdersSinglesDataInput;
  create: OfferCreateWithoutOrdersSinglesInput;
}

export interface OfferUpsertWithoutPromoCodesInput {
  update: OfferUpdateWithoutPromoCodesDataInput;
  create: OfferCreateWithoutPromoCodesInput;
}

export interface OfferUpsertWithoutReferralOfferForCompanyInput {
  update: OfferUpdateWithoutReferralOfferForCompanyDataInput;
  create: OfferCreateWithoutReferralOfferForCompanyInput;
}

export interface OfferUpsertWithoutReferrerOfferForCompanyInput {
  update: OfferUpdateWithoutReferrerOfferForCompanyDataInput;
  create: OfferCreateWithoutReferrerOfferForCompanyInput;
}

export interface OfferUpsertWithoutStagesInput {
  update: OfferUpdateWithoutStagesDataInput;
  create: OfferCreateWithoutStagesInput;
}

export interface OfferUpsertWithoutStampCardsInput {
  update: OfferUpdateWithoutStampCardsDataInput;
  create: OfferCreateWithoutStampCardsInput;
}

export interface OfferUpsertWithoutTokensInput {
  update: OfferUpdateWithoutTokensDataInput;
  create: OfferCreateWithoutTokensInput;
}

export interface OfferUpsertWithoutUsesInput {
  update: OfferUpdateWithoutUsesDataInput;
  create: OfferCreateWithoutUsesInput;
}

export interface OfferUpsertWithoutYieldEventsInput {
  update: OfferUpdateWithoutYieldEventsDataInput;
  create: OfferCreateWithoutYieldEventsInput;
}

export interface OfferWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  description?: string ;
  description_not?: string ;
  description_in?: string[] ;
  description_not_in?: string[] ;
  description_lt?: string ;
  description_lte?: string ;
  description_gt?: string ;
  description_gte?: string ;
  description_contains?: string ;
  description_not_contains?: string ;
  description_starts_with?: string ;
  description_not_starts_with?: string ;
  description_ends_with?: string ;
  description_not_ends_with?: string ;
  descriptionLang?: TranslatedStringWhereInput ;
  orders_every?: OrderWhereInput ;
  orders_some?: OrderWhereInput ;
  orders_none?: OrderWhereInput ;
  ordersSingles_every?: OrderWhereInput ;
  ordersSingles_some?: OrderWhereInput ;
  ordersSingles_none?: OrderWhereInput ;
  image?: ImageWhereInput ;
  items_every?: ItemWhereInput ;
  items_some?: ItemWhereInput ;
  items_none?: ItemWhereInput ;
  uses_every?: OrderItemWhereInput ;
  uses_some?: OrderItemWhereInput ;
  uses_none?: OrderItemWhereInput ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  nameLang?: TranslatedStringWhereInput ;
  price?: number ;
  price_not?: number ;
  price_in?: number[] ;
  price_not_in?: number[] ;
  price_lt?: number ;
  price_lte?: number ;
  price_gt?: number ;
  price_gte?: number ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  users_every?: UserWhereInput ;
  users_some?: UserWhereInput ;
  users_none?: UserWhereInput ;
  company?: CompanyWhereInput ;
  referralOfferForCompany_every?: CompanyWhereInput ;
  referralOfferForCompany_some?: CompanyWhereInput ;
  referralOfferForCompany_none?: CompanyWhereInput ;
  referrerOfferForCompany_every?: CompanyWhereInput ;
  referrerOfferForCompany_some?: CompanyWhereInput ;
  referrerOfferForCompany_none?: CompanyWhereInput ;
  default?: boolean ;
  default_not?: boolean ;
  stampCards_every?: StampCardWhereInput ;
  stampCards_some?: StampCardWhereInput ;
  stampCards_none?: StampCardWhereInput ;
  tokens_every?: OfferTokenWhereInput ;
  tokens_some?: OfferTokenWhereInput ;
  tokens_none?: OfferTokenWhereInput ;
  discountRate?: number ;
  discountRate_not?: number ;
  discountRate_in?: number[] ;
  discountRate_not_in?: number[] ;
  discountRate_lt?: number ;
  discountRate_lte?: number ;
  discountRate_gt?: number ;
  discountRate_gte?: number ;
  promoCodes_every?: PromoCodeWhereInput ;
  promoCodes_some?: PromoCodeWhereInput ;
  promoCodes_none?: PromoCodeWhereInput ;
  discountType?: DISCOUNT_TYPE ;
  discountType_not?: DISCOUNT_TYPE ;
  discountType_in?: DISCOUNT_TYPE[] ;
  discountType_not_in?: DISCOUNT_TYPE[] ;
  type?: OFFER_TYPE ;
  type_not?: OFFER_TYPE ;
  type_in?: OFFER_TYPE[] ;
  type_not_in?: OFFER_TYPE[] ;
  enabled?: boolean ;
  enabled_not?: boolean ;
  context?: OFFER_CONTEXT ;
  context_not?: OFFER_CONTEXT ;
  context_in?: OFFER_CONTEXT[] ;
  context_not_in?: OFFER_CONTEXT[] ;
  quality?: number ;
  quality_not?: number ;
  quality_in?: number[] ;
  quality_not_in?: number[] ;
  quality_lt?: number ;
  quality_lte?: number ;
  quality_gt?: number ;
  quality_gte?: number ;
  yieldEvents_every?: OfferYieldEventWhereInput ;
  yieldEvents_some?: OfferYieldEventWhereInput ;
  yieldEvents_none?: OfferYieldEventWhereInput ;
  singleUseDefault?: boolean ;
  singleUseDefault_not?: boolean ;
  stages_every?: OfferStageWhereInput ;
  stages_some?: OfferStageWhereInput ;
  stages_none?: OfferStageWhereInput ;
  venues_every?: VenueWhereInput ;
  venues_some?: VenueWhereInput ;
  venues_none?: VenueWhereInput ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  categories_every?: CategoryWhereInput ;
  categories_some?: CategoryWhereInput ;
  categories_none?: CategoryWhereInput ;
  AND?: OfferWhereInput[] ;
  OR?: OfferWhereInput[] ;
  NOT?: OfferWhereInput[] ;
}

export interface OfferWhereUniqueInput {
  id?: string ;
}

export interface OfferYieldEventCreateManyWithoutCompanyInput {
  create?: OfferYieldEventCreateWithoutCompanyInput[] ;
  connect?: OfferYieldEventWhereUniqueInput[] ;
}

export interface OfferYieldEventCreateManyWithoutOfferInput {
  create?: OfferYieldEventCreateWithoutOfferInput[] ;
  connect?: OfferYieldEventWhereUniqueInput[] ;
}

export interface OfferYieldEventCreateManyWithoutSegmentsInput {
  create?: OfferYieldEventCreateWithoutSegmentsInput[] ;
  connect?: OfferYieldEventWhereUniqueInput[] ;
}

export interface OfferYieldEventCreateManyWithoutUsersInput {
  create?: OfferYieldEventCreateWithoutUsersInput[] ;
  connect?: OfferYieldEventWhereUniqueInput[] ;
}

export interface OfferYieldEventCreateOneWithoutNameInput {
  create?: OfferYieldEventCreateWithoutNameInput ;
  connect?: OfferYieldEventWhereUniqueInput ;
}

export interface OfferYieldEventCreateWithoutCompanyInput {
  id?: string ;
  deleted?: boolean ;
  name?: TranslatedStringCreateOneWithoutOfferYieldNameInput ;
  cron?: string ;
  yieldAt: any;
  shouldExpireAfter?: number ;
  hasYielded?: boolean ;
  yieldIfDuplicate?: boolean ;
  isRepeatable?: boolean ;
  notificationTitle?: string ;
  notificationBody?: string ;
  users?: UserCreateManyWithoutOfferYieldEventsInput ;
  segments?: UserSegmentCreateManyWithoutYieldEventsInput ;
  offer: OfferCreateOneWithoutYieldEventsInput;
}

export interface OfferYieldEventCreateWithoutNameInput {
  id?: string ;
  deleted?: boolean ;
  company: CompanyCreateOneWithoutOfferYieldEventsInput;
  cron?: string ;
  yieldAt: any;
  shouldExpireAfter?: number ;
  hasYielded?: boolean ;
  yieldIfDuplicate?: boolean ;
  isRepeatable?: boolean ;
  notificationTitle?: string ;
  notificationBody?: string ;
  users?: UserCreateManyWithoutOfferYieldEventsInput ;
  segments?: UserSegmentCreateManyWithoutYieldEventsInput ;
  offer: OfferCreateOneWithoutYieldEventsInput;
}

export interface OfferYieldEventCreateWithoutOfferInput {
  id?: string ;
  deleted?: boolean ;
  name?: TranslatedStringCreateOneWithoutOfferYieldNameInput ;
  company: CompanyCreateOneWithoutOfferYieldEventsInput;
  cron?: string ;
  yieldAt: any;
  shouldExpireAfter?: number ;
  hasYielded?: boolean ;
  yieldIfDuplicate?: boolean ;
  isRepeatable?: boolean ;
  notificationTitle?: string ;
  notificationBody?: string ;
  users?: UserCreateManyWithoutOfferYieldEventsInput ;
  segments?: UserSegmentCreateManyWithoutYieldEventsInput ;
}

export interface OfferYieldEventCreateWithoutSegmentsInput {
  id?: string ;
  deleted?: boolean ;
  name?: TranslatedStringCreateOneWithoutOfferYieldNameInput ;
  company: CompanyCreateOneWithoutOfferYieldEventsInput;
  cron?: string ;
  yieldAt: any;
  shouldExpireAfter?: number ;
  hasYielded?: boolean ;
  yieldIfDuplicate?: boolean ;
  isRepeatable?: boolean ;
  notificationTitle?: string ;
  notificationBody?: string ;
  users?: UserCreateManyWithoutOfferYieldEventsInput ;
  offer: OfferCreateOneWithoutYieldEventsInput;
}

export interface OfferYieldEventCreateWithoutUsersInput {
  id?: string ;
  deleted?: boolean ;
  name?: TranslatedStringCreateOneWithoutOfferYieldNameInput ;
  company: CompanyCreateOneWithoutOfferYieldEventsInput;
  cron?: string ;
  yieldAt: any;
  shouldExpireAfter?: number ;
  hasYielded?: boolean ;
  yieldIfDuplicate?: boolean ;
  isRepeatable?: boolean ;
  notificationTitle?: string ;
  notificationBody?: string ;
  segments?: UserSegmentCreateManyWithoutYieldEventsInput ;
  offer: OfferCreateOneWithoutYieldEventsInput;
}

export interface OfferYieldEventScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  cron?: string ;
  cron_not?: string ;
  cron_in?: string[] ;
  cron_not_in?: string[] ;
  cron_lt?: string ;
  cron_lte?: string ;
  cron_gt?: string ;
  cron_gte?: string ;
  cron_contains?: string ;
  cron_not_contains?: string ;
  cron_starts_with?: string ;
  cron_not_starts_with?: string ;
  cron_ends_with?: string ;
  cron_not_ends_with?: string ;
  yieldAt?: any ;
  yieldAt_not?: any ;
  yieldAt_in?: any[] ;
  yieldAt_not_in?: any[] ;
  yieldAt_lt?: any ;
  yieldAt_lte?: any ;
  yieldAt_gt?: any ;
  yieldAt_gte?: any ;
  shouldExpireAfter?: number ;
  shouldExpireAfter_not?: number ;
  shouldExpireAfter_in?: number[] ;
  shouldExpireAfter_not_in?: number[] ;
  shouldExpireAfter_lt?: number ;
  shouldExpireAfter_lte?: number ;
  shouldExpireAfter_gt?: number ;
  shouldExpireAfter_gte?: number ;
  hasYielded?: boolean ;
  hasYielded_not?: boolean ;
  yieldIfDuplicate?: boolean ;
  yieldIfDuplicate_not?: boolean ;
  isRepeatable?: boolean ;
  isRepeatable_not?: boolean ;
  notificationTitle?: string ;
  notificationTitle_not?: string ;
  notificationTitle_in?: string[] ;
  notificationTitle_not_in?: string[] ;
  notificationTitle_lt?: string ;
  notificationTitle_lte?: string ;
  notificationTitle_gt?: string ;
  notificationTitle_gte?: string ;
  notificationTitle_contains?: string ;
  notificationTitle_not_contains?: string ;
  notificationTitle_starts_with?: string ;
  notificationTitle_not_starts_with?: string ;
  notificationTitle_ends_with?: string ;
  notificationTitle_not_ends_with?: string ;
  notificationBody?: string ;
  notificationBody_not?: string ;
  notificationBody_in?: string[] ;
  notificationBody_not_in?: string[] ;
  notificationBody_lt?: string ;
  notificationBody_lte?: string ;
  notificationBody_gt?: string ;
  notificationBody_gte?: string ;
  notificationBody_contains?: string ;
  notificationBody_not_contains?: string ;
  notificationBody_starts_with?: string ;
  notificationBody_not_starts_with?: string ;
  notificationBody_ends_with?: string ;
  notificationBody_not_ends_with?: string ;
  AND?: OfferYieldEventScalarWhereInput[] ;
  OR?: OfferYieldEventScalarWhereInput[] ;
  NOT?: OfferYieldEventScalarWhereInput[] ;
}

export interface OfferYieldEventUpdateManyDataInput {
  deleted?: boolean ;
  cron?: string ;
  yieldAt?: any ;
  shouldExpireAfter?: number ;
  hasYielded?: boolean ;
  yieldIfDuplicate?: boolean ;
  isRepeatable?: boolean ;
  notificationTitle?: string ;
  notificationBody?: string ;
}

export interface OfferYieldEventUpdateManyWithWhereNestedInput {
  where: OfferYieldEventScalarWhereInput;
  data: OfferYieldEventUpdateManyDataInput;
}

export interface OfferYieldEventUpdateManyWithoutCompanyInput {
  create?: OfferYieldEventCreateWithoutCompanyInput[] ;
  connect?: OfferYieldEventWhereUniqueInput[] ;
  set?: OfferYieldEventWhereUniqueInput[] ;
  disconnect?: OfferYieldEventWhereUniqueInput[] ;
  update?: OfferYieldEventUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: OfferYieldEventUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: OfferYieldEventScalarWhereInput[] ;
  updateMany?: OfferYieldEventUpdateManyWithWhereNestedInput[] ;
}

export interface OfferYieldEventUpdateManyWithoutOfferInput {
  create?: OfferYieldEventCreateWithoutOfferInput[] ;
  connect?: OfferYieldEventWhereUniqueInput[] ;
  set?: OfferYieldEventWhereUniqueInput[] ;
  disconnect?: OfferYieldEventWhereUniqueInput[] ;
  update?: OfferYieldEventUpdateWithWhereUniqueWithoutOfferInput[] ;
  upsert?: OfferYieldEventUpsertWithWhereUniqueWithoutOfferInput[] ;
  deleteMany?: OfferYieldEventScalarWhereInput[] ;
  updateMany?: OfferYieldEventUpdateManyWithWhereNestedInput[] ;
}

export interface OfferYieldEventUpdateManyWithoutSegmentsInput {
  create?: OfferYieldEventCreateWithoutSegmentsInput[] ;
  connect?: OfferYieldEventWhereUniqueInput[] ;
  set?: OfferYieldEventWhereUniqueInput[] ;
  disconnect?: OfferYieldEventWhereUniqueInput[] ;
  update?: OfferYieldEventUpdateWithWhereUniqueWithoutSegmentsInput[] ;
  upsert?: OfferYieldEventUpsertWithWhereUniqueWithoutSegmentsInput[] ;
  deleteMany?: OfferYieldEventScalarWhereInput[] ;
  updateMany?: OfferYieldEventUpdateManyWithWhereNestedInput[] ;
}

export interface OfferYieldEventUpdateManyWithoutUsersInput {
  create?: OfferYieldEventCreateWithoutUsersInput[] ;
  connect?: OfferYieldEventWhereUniqueInput[] ;
  set?: OfferYieldEventWhereUniqueInput[] ;
  disconnect?: OfferYieldEventWhereUniqueInput[] ;
  update?: OfferYieldEventUpdateWithWhereUniqueWithoutUsersInput[] ;
  upsert?: OfferYieldEventUpsertWithWhereUniqueWithoutUsersInput[] ;
  deleteMany?: OfferYieldEventScalarWhereInput[] ;
  updateMany?: OfferYieldEventUpdateManyWithWhereNestedInput[] ;
}

export interface OfferYieldEventUpdateOneWithoutNameInput {
  create?: OfferYieldEventCreateWithoutNameInput ;
  update?: OfferYieldEventUpdateWithoutNameDataInput ;
  upsert?: OfferYieldEventUpsertWithoutNameInput ;
  disconnect?: boolean ;
  connect?: OfferYieldEventWhereUniqueInput ;
}

export interface OfferYieldEventUpdateWithWhereUniqueWithoutCompanyInput {
  where: OfferYieldEventWhereUniqueInput;
  data: OfferYieldEventUpdateWithoutCompanyDataInput;
}

export interface OfferYieldEventUpdateWithWhereUniqueWithoutOfferInput {
  where: OfferYieldEventWhereUniqueInput;
  data: OfferYieldEventUpdateWithoutOfferDataInput;
}

export interface OfferYieldEventUpdateWithWhereUniqueWithoutSegmentsInput {
  where: OfferYieldEventWhereUniqueInput;
  data: OfferYieldEventUpdateWithoutSegmentsDataInput;
}

export interface OfferYieldEventUpdateWithWhereUniqueWithoutUsersInput {
  where: OfferYieldEventWhereUniqueInput;
  data: OfferYieldEventUpdateWithoutUsersDataInput;
}

export interface OfferYieldEventUpdateWithoutCompanyDataInput {
  deleted?: boolean ;
  name?: TranslatedStringUpdateOneWithoutOfferYieldNameInput ;
  cron?: string ;
  yieldAt?: any ;
  shouldExpireAfter?: number ;
  hasYielded?: boolean ;
  yieldIfDuplicate?: boolean ;
  isRepeatable?: boolean ;
  notificationTitle?: string ;
  notificationBody?: string ;
  users?: UserUpdateManyWithoutOfferYieldEventsInput ;
  segments?: UserSegmentUpdateManyWithoutYieldEventsInput ;
  offer?: OfferUpdateOneRequiredWithoutYieldEventsInput ;
}

export interface OfferYieldEventUpdateWithoutNameDataInput {
  deleted?: boolean ;
  company?: CompanyUpdateOneRequiredWithoutOfferYieldEventsInput ;
  cron?: string ;
  yieldAt?: any ;
  shouldExpireAfter?: number ;
  hasYielded?: boolean ;
  yieldIfDuplicate?: boolean ;
  isRepeatable?: boolean ;
  notificationTitle?: string ;
  notificationBody?: string ;
  users?: UserUpdateManyWithoutOfferYieldEventsInput ;
  segments?: UserSegmentUpdateManyWithoutYieldEventsInput ;
  offer?: OfferUpdateOneRequiredWithoutYieldEventsInput ;
}

export interface OfferYieldEventUpdateWithoutOfferDataInput {
  deleted?: boolean ;
  name?: TranslatedStringUpdateOneWithoutOfferYieldNameInput ;
  company?: CompanyUpdateOneRequiredWithoutOfferYieldEventsInput ;
  cron?: string ;
  yieldAt?: any ;
  shouldExpireAfter?: number ;
  hasYielded?: boolean ;
  yieldIfDuplicate?: boolean ;
  isRepeatable?: boolean ;
  notificationTitle?: string ;
  notificationBody?: string ;
  users?: UserUpdateManyWithoutOfferYieldEventsInput ;
  segments?: UserSegmentUpdateManyWithoutYieldEventsInput ;
}

export interface OfferYieldEventUpdateWithoutSegmentsDataInput {
  deleted?: boolean ;
  name?: TranslatedStringUpdateOneWithoutOfferYieldNameInput ;
  company?: CompanyUpdateOneRequiredWithoutOfferYieldEventsInput ;
  cron?: string ;
  yieldAt?: any ;
  shouldExpireAfter?: number ;
  hasYielded?: boolean ;
  yieldIfDuplicate?: boolean ;
  isRepeatable?: boolean ;
  notificationTitle?: string ;
  notificationBody?: string ;
  users?: UserUpdateManyWithoutOfferYieldEventsInput ;
  offer?: OfferUpdateOneRequiredWithoutYieldEventsInput ;
}

export interface OfferYieldEventUpdateWithoutUsersDataInput {
  deleted?: boolean ;
  name?: TranslatedStringUpdateOneWithoutOfferYieldNameInput ;
  company?: CompanyUpdateOneRequiredWithoutOfferYieldEventsInput ;
  cron?: string ;
  yieldAt?: any ;
  shouldExpireAfter?: number ;
  hasYielded?: boolean ;
  yieldIfDuplicate?: boolean ;
  isRepeatable?: boolean ;
  notificationTitle?: string ;
  notificationBody?: string ;
  segments?: UserSegmentUpdateManyWithoutYieldEventsInput ;
  offer?: OfferUpdateOneRequiredWithoutYieldEventsInput ;
}

export interface OfferYieldEventUpsertWithWhereUniqueWithoutCompanyInput {
  where: OfferYieldEventWhereUniqueInput;
  update: OfferYieldEventUpdateWithoutCompanyDataInput;
  create: OfferYieldEventCreateWithoutCompanyInput;
}

export interface OfferYieldEventUpsertWithWhereUniqueWithoutOfferInput {
  where: OfferYieldEventWhereUniqueInput;
  update: OfferYieldEventUpdateWithoutOfferDataInput;
  create: OfferYieldEventCreateWithoutOfferInput;
}

export interface OfferYieldEventUpsertWithWhereUniqueWithoutSegmentsInput {
  where: OfferYieldEventWhereUniqueInput;
  update: OfferYieldEventUpdateWithoutSegmentsDataInput;
  create: OfferYieldEventCreateWithoutSegmentsInput;
}

export interface OfferYieldEventUpsertWithWhereUniqueWithoutUsersInput {
  where: OfferYieldEventWhereUniqueInput;
  update: OfferYieldEventUpdateWithoutUsersDataInput;
  create: OfferYieldEventCreateWithoutUsersInput;
}

export interface OfferYieldEventUpsertWithoutNameInput {
  update: OfferYieldEventUpdateWithoutNameDataInput;
  create: OfferYieldEventCreateWithoutNameInput;
}

export interface OfferYieldEventWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  name?: TranslatedStringWhereInput ;
  company?: CompanyWhereInput ;
  cron?: string ;
  cron_not?: string ;
  cron_in?: string[] ;
  cron_not_in?: string[] ;
  cron_lt?: string ;
  cron_lte?: string ;
  cron_gt?: string ;
  cron_gte?: string ;
  cron_contains?: string ;
  cron_not_contains?: string ;
  cron_starts_with?: string ;
  cron_not_starts_with?: string ;
  cron_ends_with?: string ;
  cron_not_ends_with?: string ;
  yieldAt?: any ;
  yieldAt_not?: any ;
  yieldAt_in?: any[] ;
  yieldAt_not_in?: any[] ;
  yieldAt_lt?: any ;
  yieldAt_lte?: any ;
  yieldAt_gt?: any ;
  yieldAt_gte?: any ;
  shouldExpireAfter?: number ;
  shouldExpireAfter_not?: number ;
  shouldExpireAfter_in?: number[] ;
  shouldExpireAfter_not_in?: number[] ;
  shouldExpireAfter_lt?: number ;
  shouldExpireAfter_lte?: number ;
  shouldExpireAfter_gt?: number ;
  shouldExpireAfter_gte?: number ;
  hasYielded?: boolean ;
  hasYielded_not?: boolean ;
  yieldIfDuplicate?: boolean ;
  yieldIfDuplicate_not?: boolean ;
  isRepeatable?: boolean ;
  isRepeatable_not?: boolean ;
  notificationTitle?: string ;
  notificationTitle_not?: string ;
  notificationTitle_in?: string[] ;
  notificationTitle_not_in?: string[] ;
  notificationTitle_lt?: string ;
  notificationTitle_lte?: string ;
  notificationTitle_gt?: string ;
  notificationTitle_gte?: string ;
  notificationTitle_contains?: string ;
  notificationTitle_not_contains?: string ;
  notificationTitle_starts_with?: string ;
  notificationTitle_not_starts_with?: string ;
  notificationTitle_ends_with?: string ;
  notificationTitle_not_ends_with?: string ;
  notificationBody?: string ;
  notificationBody_not?: string ;
  notificationBody_in?: string[] ;
  notificationBody_not_in?: string[] ;
  notificationBody_lt?: string ;
  notificationBody_lte?: string ;
  notificationBody_gt?: string ;
  notificationBody_gte?: string ;
  notificationBody_contains?: string ;
  notificationBody_not_contains?: string ;
  notificationBody_starts_with?: string ;
  notificationBody_not_starts_with?: string ;
  notificationBody_ends_with?: string ;
  notificationBody_not_ends_with?: string ;
  users_every?: UserWhereInput ;
  users_some?: UserWhereInput ;
  users_none?: UserWhereInput ;
  segments_every?: UserSegmentWhereInput ;
  segments_some?: UserSegmentWhereInput ;
  segments_none?: UserSegmentWhereInput ;
  offer?: OfferWhereInput ;
  AND?: OfferYieldEventWhereInput[] ;
  OR?: OfferYieldEventWhereInput[] ;
  NOT?: OfferYieldEventWhereInput[] ;
}

export interface OfferYieldEventWhereUniqueInput {
  id?: string ;
}

export interface OrderCreateInput {
  claimed?: boolean ;
  creationDate?: any ;
  offers?: OfferCreateManyWithoutOrdersInput ;
  offer?: OfferCreateOneWithoutOrdersSinglesInput ;
  estimatedFinishTime?: string ;
  id?: string ;
  easyId?: string ;
  items?: OrderItemCreateManyWithoutOrderInput ;
  payment?: PaymentCreateOneWithoutOrderInput ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  user: UserCreateOneWithoutOrdersInput;
  venue?: VenueCreateOneWithoutOrdersInput ;
  confirmed?: boolean ;
  comment?: string ;
  deliveryLocation?: LocationCreateOneWithoutOrdersInput ;
  type: SERVICE_TYPE;
  fees?: FeeCreateManyWithoutOrdersInput ;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken: string;
  isTableOrder?: boolean ;
  table?: TableSessionCreateOneWithoutOrdersInput ;
  invoiceTarget?: InvoiceTargetCreateOneWithoutOrdersInput ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posDevice?: POSDeviceCreateOneInput ;
  posOrderUnique?: string ;
  zone?: ZoneCreateOneInput ;
  complianceId?: string ;
}

export interface OrderCreateManyWithoutDeliveryLocationInput {
  create?: OrderCreateWithoutDeliveryLocationInput[] ;
  connect?: OrderWhereUniqueInput[] ;
}

export interface OrderCreateManyWithoutFeesInput {
  create?: OrderCreateWithoutFeesInput[] ;
  connect?: OrderWhereUniqueInput[] ;
}

export interface OrderCreateManyWithoutInvoiceTargetInput {
  create?: OrderCreateWithoutInvoiceTargetInput[] ;
  connect?: OrderWhereUniqueInput[] ;
}

export interface OrderCreateManyWithoutOfferInput {
  create?: OrderCreateWithoutOfferInput[] ;
  connect?: OrderWhereUniqueInput[] ;
}

export interface OrderCreateManyWithoutOffersInput {
  create?: OrderCreateWithoutOffersInput[] ;
  connect?: OrderWhereUniqueInput[] ;
}

export interface OrderCreateManyWithoutTableInput {
  create?: OrderCreateWithoutTableInput[] ;
  connect?: OrderWhereUniqueInput[] ;
}

export interface OrderCreateManyWithoutUserInput {
  create?: OrderCreateWithoutUserInput[] ;
  connect?: OrderWhereUniqueInput[] ;
}

export interface OrderCreateManyWithoutVenueInput {
  create?: OrderCreateWithoutVenueInput[] ;
  connect?: OrderWhereUniqueInput[] ;
}

export interface OrderCreateOneInput {
  create?: OrderCreateInput ;
  connect?: OrderWhereUniqueInput ;
}

export interface OrderCreateOneWithoutItemsInput {
  create?: OrderCreateWithoutItemsInput ;
  connect?: OrderWhereUniqueInput ;
}

export interface OrderCreateOneWithoutPaymentInput {
  create?: OrderCreateWithoutPaymentInput ;
  connect?: OrderWhereUniqueInput ;
}

export interface OrderCreateWithoutDeliveryLocationInput {
  claimed?: boolean ;
  creationDate?: any ;
  offers?: OfferCreateManyWithoutOrdersInput ;
  offer?: OfferCreateOneWithoutOrdersSinglesInput ;
  estimatedFinishTime?: string ;
  id?: string ;
  easyId?: string ;
  items?: OrderItemCreateManyWithoutOrderInput ;
  payment?: PaymentCreateOneWithoutOrderInput ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  user: UserCreateOneWithoutOrdersInput;
  venue?: VenueCreateOneWithoutOrdersInput ;
  confirmed?: boolean ;
  comment?: string ;
  type: SERVICE_TYPE;
  fees?: FeeCreateManyWithoutOrdersInput ;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken: string;
  isTableOrder?: boolean ;
  table?: TableSessionCreateOneWithoutOrdersInput ;
  invoiceTarget?: InvoiceTargetCreateOneWithoutOrdersInput ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posDevice?: POSDeviceCreateOneInput ;
  posOrderUnique?: string ;
  zone?: ZoneCreateOneInput ;
  complianceId?: string ;
}

export interface OrderCreateWithoutFeesInput {
  claimed?: boolean ;
  creationDate?: any ;
  offers?: OfferCreateManyWithoutOrdersInput ;
  offer?: OfferCreateOneWithoutOrdersSinglesInput ;
  estimatedFinishTime?: string ;
  id?: string ;
  easyId?: string ;
  items?: OrderItemCreateManyWithoutOrderInput ;
  payment?: PaymentCreateOneWithoutOrderInput ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  user: UserCreateOneWithoutOrdersInput;
  venue?: VenueCreateOneWithoutOrdersInput ;
  confirmed?: boolean ;
  comment?: string ;
  deliveryLocation?: LocationCreateOneWithoutOrdersInput ;
  type: SERVICE_TYPE;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken: string;
  isTableOrder?: boolean ;
  table?: TableSessionCreateOneWithoutOrdersInput ;
  invoiceTarget?: InvoiceTargetCreateOneWithoutOrdersInput ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posDevice?: POSDeviceCreateOneInput ;
  posOrderUnique?: string ;
  zone?: ZoneCreateOneInput ;
  complianceId?: string ;
}

export interface OrderCreateWithoutInvoiceTargetInput {
  claimed?: boolean ;
  creationDate?: any ;
  offers?: OfferCreateManyWithoutOrdersInput ;
  offer?: OfferCreateOneWithoutOrdersSinglesInput ;
  estimatedFinishTime?: string ;
  id?: string ;
  easyId?: string ;
  items?: OrderItemCreateManyWithoutOrderInput ;
  payment?: PaymentCreateOneWithoutOrderInput ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  user: UserCreateOneWithoutOrdersInput;
  venue?: VenueCreateOneWithoutOrdersInput ;
  confirmed?: boolean ;
  comment?: string ;
  deliveryLocation?: LocationCreateOneWithoutOrdersInput ;
  type: SERVICE_TYPE;
  fees?: FeeCreateManyWithoutOrdersInput ;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken: string;
  isTableOrder?: boolean ;
  table?: TableSessionCreateOneWithoutOrdersInput ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posDevice?: POSDeviceCreateOneInput ;
  posOrderUnique?: string ;
  zone?: ZoneCreateOneInput ;
  complianceId?: string ;
}

export interface OrderCreateWithoutItemsInput {
  claimed?: boolean ;
  creationDate?: any ;
  offers?: OfferCreateManyWithoutOrdersInput ;
  offer?: OfferCreateOneWithoutOrdersSinglesInput ;
  estimatedFinishTime?: string ;
  id?: string ;
  easyId?: string ;
  payment?: PaymentCreateOneWithoutOrderInput ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  user: UserCreateOneWithoutOrdersInput;
  venue?: VenueCreateOneWithoutOrdersInput ;
  confirmed?: boolean ;
  comment?: string ;
  deliveryLocation?: LocationCreateOneWithoutOrdersInput ;
  type: SERVICE_TYPE;
  fees?: FeeCreateManyWithoutOrdersInput ;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken: string;
  isTableOrder?: boolean ;
  table?: TableSessionCreateOneWithoutOrdersInput ;
  invoiceTarget?: InvoiceTargetCreateOneWithoutOrdersInput ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posDevice?: POSDeviceCreateOneInput ;
  posOrderUnique?: string ;
  zone?: ZoneCreateOneInput ;
  complianceId?: string ;
}

export interface OrderCreateWithoutOfferInput {
  claimed?: boolean ;
  creationDate?: any ;
  offers?: OfferCreateManyWithoutOrdersInput ;
  estimatedFinishTime?: string ;
  id?: string ;
  easyId?: string ;
  items?: OrderItemCreateManyWithoutOrderInput ;
  payment?: PaymentCreateOneWithoutOrderInput ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  user: UserCreateOneWithoutOrdersInput;
  venue?: VenueCreateOneWithoutOrdersInput ;
  confirmed?: boolean ;
  comment?: string ;
  deliveryLocation?: LocationCreateOneWithoutOrdersInput ;
  type: SERVICE_TYPE;
  fees?: FeeCreateManyWithoutOrdersInput ;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken: string;
  isTableOrder?: boolean ;
  table?: TableSessionCreateOneWithoutOrdersInput ;
  invoiceTarget?: InvoiceTargetCreateOneWithoutOrdersInput ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posDevice?: POSDeviceCreateOneInput ;
  posOrderUnique?: string ;
  zone?: ZoneCreateOneInput ;
  complianceId?: string ;
}

export interface OrderCreateWithoutOffersInput {
  claimed?: boolean ;
  creationDate?: any ;
  offer?: OfferCreateOneWithoutOrdersSinglesInput ;
  estimatedFinishTime?: string ;
  id?: string ;
  easyId?: string ;
  items?: OrderItemCreateManyWithoutOrderInput ;
  payment?: PaymentCreateOneWithoutOrderInput ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  user: UserCreateOneWithoutOrdersInput;
  venue?: VenueCreateOneWithoutOrdersInput ;
  confirmed?: boolean ;
  comment?: string ;
  deliveryLocation?: LocationCreateOneWithoutOrdersInput ;
  type: SERVICE_TYPE;
  fees?: FeeCreateManyWithoutOrdersInput ;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken: string;
  isTableOrder?: boolean ;
  table?: TableSessionCreateOneWithoutOrdersInput ;
  invoiceTarget?: InvoiceTargetCreateOneWithoutOrdersInput ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posDevice?: POSDeviceCreateOneInput ;
  posOrderUnique?: string ;
  zone?: ZoneCreateOneInput ;
  complianceId?: string ;
}

export interface OrderCreateWithoutPaymentInput {
  claimed?: boolean ;
  creationDate?: any ;
  offers?: OfferCreateManyWithoutOrdersInput ;
  offer?: OfferCreateOneWithoutOrdersSinglesInput ;
  estimatedFinishTime?: string ;
  id?: string ;
  easyId?: string ;
  items?: OrderItemCreateManyWithoutOrderInput ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  user: UserCreateOneWithoutOrdersInput;
  venue?: VenueCreateOneWithoutOrdersInput ;
  confirmed?: boolean ;
  comment?: string ;
  deliveryLocation?: LocationCreateOneWithoutOrdersInput ;
  type: SERVICE_TYPE;
  fees?: FeeCreateManyWithoutOrdersInput ;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken: string;
  isTableOrder?: boolean ;
  table?: TableSessionCreateOneWithoutOrdersInput ;
  invoiceTarget?: InvoiceTargetCreateOneWithoutOrdersInput ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posDevice?: POSDeviceCreateOneInput ;
  posOrderUnique?: string ;
  zone?: ZoneCreateOneInput ;
  complianceId?: string ;
}

export interface OrderCreateWithoutTableInput {
  claimed?: boolean ;
  creationDate?: any ;
  offers?: OfferCreateManyWithoutOrdersInput ;
  offer?: OfferCreateOneWithoutOrdersSinglesInput ;
  estimatedFinishTime?: string ;
  id?: string ;
  easyId?: string ;
  items?: OrderItemCreateManyWithoutOrderInput ;
  payment?: PaymentCreateOneWithoutOrderInput ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  user: UserCreateOneWithoutOrdersInput;
  venue?: VenueCreateOneWithoutOrdersInput ;
  confirmed?: boolean ;
  comment?: string ;
  deliveryLocation?: LocationCreateOneWithoutOrdersInput ;
  type: SERVICE_TYPE;
  fees?: FeeCreateManyWithoutOrdersInput ;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken: string;
  isTableOrder?: boolean ;
  invoiceTarget?: InvoiceTargetCreateOneWithoutOrdersInput ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posDevice?: POSDeviceCreateOneInput ;
  posOrderUnique?: string ;
  zone?: ZoneCreateOneInput ;
  complianceId?: string ;
}

export interface OrderCreateWithoutUserInput {
  claimed?: boolean ;
  creationDate?: any ;
  offers?: OfferCreateManyWithoutOrdersInput ;
  offer?: OfferCreateOneWithoutOrdersSinglesInput ;
  estimatedFinishTime?: string ;
  id?: string ;
  easyId?: string ;
  items?: OrderItemCreateManyWithoutOrderInput ;
  payment?: PaymentCreateOneWithoutOrderInput ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  venue?: VenueCreateOneWithoutOrdersInput ;
  confirmed?: boolean ;
  comment?: string ;
  deliveryLocation?: LocationCreateOneWithoutOrdersInput ;
  type: SERVICE_TYPE;
  fees?: FeeCreateManyWithoutOrdersInput ;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken: string;
  isTableOrder?: boolean ;
  table?: TableSessionCreateOneWithoutOrdersInput ;
  invoiceTarget?: InvoiceTargetCreateOneWithoutOrdersInput ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posDevice?: POSDeviceCreateOneInput ;
  posOrderUnique?: string ;
  zone?: ZoneCreateOneInput ;
  complianceId?: string ;
}

export interface OrderCreateWithoutVenueInput {
  claimed?: boolean ;
  creationDate?: any ;
  offers?: OfferCreateManyWithoutOrdersInput ;
  offer?: OfferCreateOneWithoutOrdersSinglesInput ;
  estimatedFinishTime?: string ;
  id?: string ;
  easyId?: string ;
  items?: OrderItemCreateManyWithoutOrderInput ;
  payment?: PaymentCreateOneWithoutOrderInput ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  user: UserCreateOneWithoutOrdersInput;
  confirmed?: boolean ;
  comment?: string ;
  deliveryLocation?: LocationCreateOneWithoutOrdersInput ;
  type: SERVICE_TYPE;
  fees?: FeeCreateManyWithoutOrdersInput ;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken: string;
  isTableOrder?: boolean ;
  table?: TableSessionCreateOneWithoutOrdersInput ;
  invoiceTarget?: InvoiceTargetCreateOneWithoutOrdersInput ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posDevice?: POSDeviceCreateOneInput ;
  posOrderUnique?: string ;
  zone?: ZoneCreateOneInput ;
  complianceId?: string ;
}

export interface OrderItemCreateInput {
  id?: string ;
  fraction?: number ;
  isRefunded?: boolean ;
  bundleId?: string ;
  message?: string ;
  offer?: OfferCreateOneWithoutUsesInput ;
  entry?: MenuEntryCreateOneWithoutOrderItemsInput ;
  size?: VariationCreateOneWithoutOrderItemSizesInput ;
  order?: OrderCreateOneWithoutItemsInput ;
  variations?: VariationCreateManyWithoutOrderItemsInput ;
  removedVariations?: VariationCreateManyWithoutRemovedFromInput ;
  price?: PriceCreateOneWithoutOrderItemInput ;
  tableSession?: TableSessionCreateOneWithoutItemsInput ;
  selectedForPaymentByUser?: TablePaymentSettingCreateOneWithoutSelectedItemsInput ;
}

export interface OrderItemCreateManyWithoutEntryInput {
  create?: OrderItemCreateWithoutEntryInput[] ;
  connect?: OrderItemWhereUniqueInput[] ;
}

export interface OrderItemCreateManyWithoutOfferInput {
  create?: OrderItemCreateWithoutOfferInput[] ;
  connect?: OrderItemWhereUniqueInput[] ;
}

export interface OrderItemCreateManyWithoutOrderInput {
  create?: OrderItemCreateWithoutOrderInput[] ;
  connect?: OrderItemWhereUniqueInput[] ;
}

export interface OrderItemCreateManyWithoutRemovedVariationsInput {
  create?: OrderItemCreateWithoutRemovedVariationsInput[] ;
  connect?: OrderItemWhereUniqueInput[] ;
}

export interface OrderItemCreateManyWithoutSelectedForPaymentByUserInput {
  create?: OrderItemCreateWithoutSelectedForPaymentByUserInput[] ;
  connect?: OrderItemWhereUniqueInput[] ;
}

export interface OrderItemCreateManyWithoutSizeInput {
  create?: OrderItemCreateWithoutSizeInput[] ;
  connect?: OrderItemWhereUniqueInput[] ;
}

export interface OrderItemCreateManyWithoutTableSessionInput {
  create?: OrderItemCreateWithoutTableSessionInput[] ;
  connect?: OrderItemWhereUniqueInput[] ;
}

export interface OrderItemCreateManyWithoutVariationsInput {
  create?: OrderItemCreateWithoutVariationsInput[] ;
  connect?: OrderItemWhereUniqueInput[] ;
}

export interface OrderItemCreateOneInput {
  create?: OrderItemCreateInput ;
  connect?: OrderItemWhereUniqueInput ;
}

export interface OrderItemCreateOneWithoutPriceInput {
  create?: OrderItemCreateWithoutPriceInput ;
  connect?: OrderItemWhereUniqueInput ;
}

export interface OrderItemCreateWithoutEntryInput {
  id?: string ;
  fraction?: number ;
  isRefunded?: boolean ;
  bundleId?: string ;
  message?: string ;
  offer?: OfferCreateOneWithoutUsesInput ;
  size?: VariationCreateOneWithoutOrderItemSizesInput ;
  order?: OrderCreateOneWithoutItemsInput ;
  variations?: VariationCreateManyWithoutOrderItemsInput ;
  removedVariations?: VariationCreateManyWithoutRemovedFromInput ;
  price?: PriceCreateOneWithoutOrderItemInput ;
  tableSession?: TableSessionCreateOneWithoutItemsInput ;
  selectedForPaymentByUser?: TablePaymentSettingCreateOneWithoutSelectedItemsInput ;
}

export interface OrderItemCreateWithoutOfferInput {
  id?: string ;
  fraction?: number ;
  isRefunded?: boolean ;
  bundleId?: string ;
  message?: string ;
  entry?: MenuEntryCreateOneWithoutOrderItemsInput ;
  size?: VariationCreateOneWithoutOrderItemSizesInput ;
  order?: OrderCreateOneWithoutItemsInput ;
  variations?: VariationCreateManyWithoutOrderItemsInput ;
  removedVariations?: VariationCreateManyWithoutRemovedFromInput ;
  price?: PriceCreateOneWithoutOrderItemInput ;
  tableSession?: TableSessionCreateOneWithoutItemsInput ;
  selectedForPaymentByUser?: TablePaymentSettingCreateOneWithoutSelectedItemsInput ;
}

export interface OrderItemCreateWithoutOrderInput {
  id?: string ;
  fraction?: number ;
  isRefunded?: boolean ;
  bundleId?: string ;
  message?: string ;
  offer?: OfferCreateOneWithoutUsesInput ;
  entry?: MenuEntryCreateOneWithoutOrderItemsInput ;
  size?: VariationCreateOneWithoutOrderItemSizesInput ;
  variations?: VariationCreateManyWithoutOrderItemsInput ;
  removedVariations?: VariationCreateManyWithoutRemovedFromInput ;
  price?: PriceCreateOneWithoutOrderItemInput ;
  tableSession?: TableSessionCreateOneWithoutItemsInput ;
  selectedForPaymentByUser?: TablePaymentSettingCreateOneWithoutSelectedItemsInput ;
}

export interface OrderItemCreateWithoutPriceInput {
  id?: string ;
  fraction?: number ;
  isRefunded?: boolean ;
  bundleId?: string ;
  message?: string ;
  offer?: OfferCreateOneWithoutUsesInput ;
  entry?: MenuEntryCreateOneWithoutOrderItemsInput ;
  size?: VariationCreateOneWithoutOrderItemSizesInput ;
  order?: OrderCreateOneWithoutItemsInput ;
  variations?: VariationCreateManyWithoutOrderItemsInput ;
  removedVariations?: VariationCreateManyWithoutRemovedFromInput ;
  tableSession?: TableSessionCreateOneWithoutItemsInput ;
  selectedForPaymentByUser?: TablePaymentSettingCreateOneWithoutSelectedItemsInput ;
}

export interface OrderItemCreateWithoutRemovedVariationsInput {
  id?: string ;
  fraction?: number ;
  isRefunded?: boolean ;
  bundleId?: string ;
  message?: string ;
  offer?: OfferCreateOneWithoutUsesInput ;
  entry?: MenuEntryCreateOneWithoutOrderItemsInput ;
  size?: VariationCreateOneWithoutOrderItemSizesInput ;
  order?: OrderCreateOneWithoutItemsInput ;
  variations?: VariationCreateManyWithoutOrderItemsInput ;
  price?: PriceCreateOneWithoutOrderItemInput ;
  tableSession?: TableSessionCreateOneWithoutItemsInput ;
  selectedForPaymentByUser?: TablePaymentSettingCreateOneWithoutSelectedItemsInput ;
}

export interface OrderItemCreateWithoutSelectedForPaymentByUserInput {
  id?: string ;
  fraction?: number ;
  isRefunded?: boolean ;
  bundleId?: string ;
  message?: string ;
  offer?: OfferCreateOneWithoutUsesInput ;
  entry?: MenuEntryCreateOneWithoutOrderItemsInput ;
  size?: VariationCreateOneWithoutOrderItemSizesInput ;
  order?: OrderCreateOneWithoutItemsInput ;
  variations?: VariationCreateManyWithoutOrderItemsInput ;
  removedVariations?: VariationCreateManyWithoutRemovedFromInput ;
  price?: PriceCreateOneWithoutOrderItemInput ;
  tableSession?: TableSessionCreateOneWithoutItemsInput ;
}

export interface OrderItemCreateWithoutSizeInput {
  id?: string ;
  fraction?: number ;
  isRefunded?: boolean ;
  bundleId?: string ;
  message?: string ;
  offer?: OfferCreateOneWithoutUsesInput ;
  entry?: MenuEntryCreateOneWithoutOrderItemsInput ;
  order?: OrderCreateOneWithoutItemsInput ;
  variations?: VariationCreateManyWithoutOrderItemsInput ;
  removedVariations?: VariationCreateManyWithoutRemovedFromInput ;
  price?: PriceCreateOneWithoutOrderItemInput ;
  tableSession?: TableSessionCreateOneWithoutItemsInput ;
  selectedForPaymentByUser?: TablePaymentSettingCreateOneWithoutSelectedItemsInput ;
}

export interface OrderItemCreateWithoutTableSessionInput {
  id?: string ;
  fraction?: number ;
  isRefunded?: boolean ;
  bundleId?: string ;
  message?: string ;
  offer?: OfferCreateOneWithoutUsesInput ;
  entry?: MenuEntryCreateOneWithoutOrderItemsInput ;
  size?: VariationCreateOneWithoutOrderItemSizesInput ;
  order?: OrderCreateOneWithoutItemsInput ;
  variations?: VariationCreateManyWithoutOrderItemsInput ;
  removedVariations?: VariationCreateManyWithoutRemovedFromInput ;
  price?: PriceCreateOneWithoutOrderItemInput ;
  selectedForPaymentByUser?: TablePaymentSettingCreateOneWithoutSelectedItemsInput ;
}

export interface OrderItemCreateWithoutVariationsInput {
  id?: string ;
  fraction?: number ;
  isRefunded?: boolean ;
  bundleId?: string ;
  message?: string ;
  offer?: OfferCreateOneWithoutUsesInput ;
  entry?: MenuEntryCreateOneWithoutOrderItemsInput ;
  size?: VariationCreateOneWithoutOrderItemSizesInput ;
  order?: OrderCreateOneWithoutItemsInput ;
  removedVariations?: VariationCreateManyWithoutRemovedFromInput ;
  price?: PriceCreateOneWithoutOrderItemInput ;
  tableSession?: TableSessionCreateOneWithoutItemsInput ;
  selectedForPaymentByUser?: TablePaymentSettingCreateOneWithoutSelectedItemsInput ;
}

export interface OrderItemScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  fraction?: number ;
  fraction_not?: number ;
  fraction_in?: number[] ;
  fraction_not_in?: number[] ;
  fraction_lt?: number ;
  fraction_lte?: number ;
  fraction_gt?: number ;
  fraction_gte?: number ;
  isRefunded?: boolean ;
  isRefunded_not?: boolean ;
  bundleId?: string ;
  bundleId_not?: string ;
  bundleId_in?: string[] ;
  bundleId_not_in?: string[] ;
  bundleId_lt?: string ;
  bundleId_lte?: string ;
  bundleId_gt?: string ;
  bundleId_gte?: string ;
  bundleId_contains?: string ;
  bundleId_not_contains?: string ;
  bundleId_starts_with?: string ;
  bundleId_not_starts_with?: string ;
  bundleId_ends_with?: string ;
  bundleId_not_ends_with?: string ;
  message?: string ;
  message_not?: string ;
  message_in?: string[] ;
  message_not_in?: string[] ;
  message_lt?: string ;
  message_lte?: string ;
  message_gt?: string ;
  message_gte?: string ;
  message_contains?: string ;
  message_not_contains?: string ;
  message_starts_with?: string ;
  message_not_starts_with?: string ;
  message_ends_with?: string ;
  message_not_ends_with?: string ;
  AND?: OrderItemScalarWhereInput[] ;
  OR?: OrderItemScalarWhereInput[] ;
  NOT?: OrderItemScalarWhereInput[] ;
}

export interface OrderItemUpdateDataInput {
  fraction?: number ;
  isRefunded?: boolean ;
  bundleId?: string ;
  message?: string ;
  offer?: OfferUpdateOneWithoutUsesInput ;
  entry?: MenuEntryUpdateOneWithoutOrderItemsInput ;
  size?: VariationUpdateOneWithoutOrderItemSizesInput ;
  order?: OrderUpdateOneWithoutItemsInput ;
  variations?: VariationUpdateManyWithoutOrderItemsInput ;
  removedVariations?: VariationUpdateManyWithoutRemovedFromInput ;
  price?: PriceUpdateOneWithoutOrderItemInput ;
  tableSession?: TableSessionUpdateOneWithoutItemsInput ;
  selectedForPaymentByUser?: TablePaymentSettingUpdateOneWithoutSelectedItemsInput ;
}

export interface OrderItemUpdateManyDataInput {
  fraction?: number ;
  isRefunded?: boolean ;
  bundleId?: string ;
  message?: string ;
}

export interface OrderItemUpdateManyWithWhereNestedInput {
  where: OrderItemScalarWhereInput;
  data: OrderItemUpdateManyDataInput;
}

export interface OrderItemUpdateManyWithoutEntryInput {
  create?: OrderItemCreateWithoutEntryInput[] ;
  connect?: OrderItemWhereUniqueInput[] ;
  set?: OrderItemWhereUniqueInput[] ;
  disconnect?: OrderItemWhereUniqueInput[] ;
  update?: OrderItemUpdateWithWhereUniqueWithoutEntryInput[] ;
  upsert?: OrderItemUpsertWithWhereUniqueWithoutEntryInput[] ;
  deleteMany?: OrderItemScalarWhereInput[] ;
  updateMany?: OrderItemUpdateManyWithWhereNestedInput[] ;
}

export interface OrderItemUpdateManyWithoutOfferInput {
  create?: OrderItemCreateWithoutOfferInput[] ;
  connect?: OrderItemWhereUniqueInput[] ;
  set?: OrderItemWhereUniqueInput[] ;
  disconnect?: OrderItemWhereUniqueInput[] ;
  update?: OrderItemUpdateWithWhereUniqueWithoutOfferInput[] ;
  upsert?: OrderItemUpsertWithWhereUniqueWithoutOfferInput[] ;
  deleteMany?: OrderItemScalarWhereInput[] ;
  updateMany?: OrderItemUpdateManyWithWhereNestedInput[] ;
}

export interface OrderItemUpdateManyWithoutOrderInput {
  create?: OrderItemCreateWithoutOrderInput[] ;
  connect?: OrderItemWhereUniqueInput[] ;
  set?: OrderItemWhereUniqueInput[] ;
  disconnect?: OrderItemWhereUniqueInput[] ;
  update?: OrderItemUpdateWithWhereUniqueWithoutOrderInput[] ;
  upsert?: OrderItemUpsertWithWhereUniqueWithoutOrderInput[] ;
  deleteMany?: OrderItemScalarWhereInput[] ;
  updateMany?: OrderItemUpdateManyWithWhereNestedInput[] ;
}

export interface OrderItemUpdateManyWithoutRemovedVariationsInput {
  create?: OrderItemCreateWithoutRemovedVariationsInput[] ;
  connect?: OrderItemWhereUniqueInput[] ;
  set?: OrderItemWhereUniqueInput[] ;
  disconnect?: OrderItemWhereUniqueInput[] ;
  update?: OrderItemUpdateWithWhereUniqueWithoutRemovedVariationsInput[] ;
  upsert?: OrderItemUpsertWithWhereUniqueWithoutRemovedVariationsInput[] ;
  deleteMany?: OrderItemScalarWhereInput[] ;
  updateMany?: OrderItemUpdateManyWithWhereNestedInput[] ;
}

export interface OrderItemUpdateManyWithoutSelectedForPaymentByUserInput {
  create?: OrderItemCreateWithoutSelectedForPaymentByUserInput[] ;
  connect?: OrderItemWhereUniqueInput[] ;
  set?: OrderItemWhereUniqueInput[] ;
  disconnect?: OrderItemWhereUniqueInput[] ;
  update?: OrderItemUpdateWithWhereUniqueWithoutSelectedForPaymentByUserInput[] ;
  upsert?: OrderItemUpsertWithWhereUniqueWithoutSelectedForPaymentByUserInput[] ;
  deleteMany?: OrderItemScalarWhereInput[] ;
  updateMany?: OrderItemUpdateManyWithWhereNestedInput[] ;
}

export interface OrderItemUpdateManyWithoutSizeInput {
  create?: OrderItemCreateWithoutSizeInput[] ;
  connect?: OrderItemWhereUniqueInput[] ;
  set?: OrderItemWhereUniqueInput[] ;
  disconnect?: OrderItemWhereUniqueInput[] ;
  update?: OrderItemUpdateWithWhereUniqueWithoutSizeInput[] ;
  upsert?: OrderItemUpsertWithWhereUniqueWithoutSizeInput[] ;
  deleteMany?: OrderItemScalarWhereInput[] ;
  updateMany?: OrderItemUpdateManyWithWhereNestedInput[] ;
}

export interface OrderItemUpdateManyWithoutTableSessionInput {
  create?: OrderItemCreateWithoutTableSessionInput[] ;
  connect?: OrderItemWhereUniqueInput[] ;
  set?: OrderItemWhereUniqueInput[] ;
  disconnect?: OrderItemWhereUniqueInput[] ;
  update?: OrderItemUpdateWithWhereUniqueWithoutTableSessionInput[] ;
  upsert?: OrderItemUpsertWithWhereUniqueWithoutTableSessionInput[] ;
  deleteMany?: OrderItemScalarWhereInput[] ;
  updateMany?: OrderItemUpdateManyWithWhereNestedInput[] ;
}

export interface OrderItemUpdateManyWithoutVariationsInput {
  create?: OrderItemCreateWithoutVariationsInput[] ;
  connect?: OrderItemWhereUniqueInput[] ;
  set?: OrderItemWhereUniqueInput[] ;
  disconnect?: OrderItemWhereUniqueInput[] ;
  update?: OrderItemUpdateWithWhereUniqueWithoutVariationsInput[] ;
  upsert?: OrderItemUpsertWithWhereUniqueWithoutVariationsInput[] ;
  deleteMany?: OrderItemScalarWhereInput[] ;
  updateMany?: OrderItemUpdateManyWithWhereNestedInput[] ;
}

export interface OrderItemUpdateOneInput {
  create?: OrderItemCreateInput ;
  update?: OrderItemUpdateDataInput ;
  upsert?: OrderItemUpsertNestedInput ;
  disconnect?: boolean ;
  connect?: OrderItemWhereUniqueInput ;
}

export interface OrderItemUpdateOneWithoutPriceInput {
  create?: OrderItemCreateWithoutPriceInput ;
  update?: OrderItemUpdateWithoutPriceDataInput ;
  upsert?: OrderItemUpsertWithoutPriceInput ;
  disconnect?: boolean ;
  connect?: OrderItemWhereUniqueInput ;
}

export interface OrderItemUpdateWithWhereUniqueWithoutEntryInput {
  where: OrderItemWhereUniqueInput;
  data: OrderItemUpdateWithoutEntryDataInput;
}

export interface OrderItemUpdateWithWhereUniqueWithoutOfferInput {
  where: OrderItemWhereUniqueInput;
  data: OrderItemUpdateWithoutOfferDataInput;
}

export interface OrderItemUpdateWithWhereUniqueWithoutOrderInput {
  where: OrderItemWhereUniqueInput;
  data: OrderItemUpdateWithoutOrderDataInput;
}

export interface OrderItemUpdateWithWhereUniqueWithoutRemovedVariationsInput {
  where: OrderItemWhereUniqueInput;
  data: OrderItemUpdateWithoutRemovedVariationsDataInput;
}

export interface OrderItemUpdateWithWhereUniqueWithoutSelectedForPaymentByUserInput {
  where: OrderItemWhereUniqueInput;
  data: OrderItemUpdateWithoutSelectedForPaymentByUserDataInput;
}

export interface OrderItemUpdateWithWhereUniqueWithoutSizeInput {
  where: OrderItemWhereUniqueInput;
  data: OrderItemUpdateWithoutSizeDataInput;
}

export interface OrderItemUpdateWithWhereUniqueWithoutTableSessionInput {
  where: OrderItemWhereUniqueInput;
  data: OrderItemUpdateWithoutTableSessionDataInput;
}

export interface OrderItemUpdateWithWhereUniqueWithoutVariationsInput {
  where: OrderItemWhereUniqueInput;
  data: OrderItemUpdateWithoutVariationsDataInput;
}

export interface OrderItemUpdateWithoutEntryDataInput {
  fraction?: number ;
  isRefunded?: boolean ;
  bundleId?: string ;
  message?: string ;
  offer?: OfferUpdateOneWithoutUsesInput ;
  size?: VariationUpdateOneWithoutOrderItemSizesInput ;
  order?: OrderUpdateOneWithoutItemsInput ;
  variations?: VariationUpdateManyWithoutOrderItemsInput ;
  removedVariations?: VariationUpdateManyWithoutRemovedFromInput ;
  price?: PriceUpdateOneWithoutOrderItemInput ;
  tableSession?: TableSessionUpdateOneWithoutItemsInput ;
  selectedForPaymentByUser?: TablePaymentSettingUpdateOneWithoutSelectedItemsInput ;
}

export interface OrderItemUpdateWithoutOfferDataInput {
  fraction?: number ;
  isRefunded?: boolean ;
  bundleId?: string ;
  message?: string ;
  entry?: MenuEntryUpdateOneWithoutOrderItemsInput ;
  size?: VariationUpdateOneWithoutOrderItemSizesInput ;
  order?: OrderUpdateOneWithoutItemsInput ;
  variations?: VariationUpdateManyWithoutOrderItemsInput ;
  removedVariations?: VariationUpdateManyWithoutRemovedFromInput ;
  price?: PriceUpdateOneWithoutOrderItemInput ;
  tableSession?: TableSessionUpdateOneWithoutItemsInput ;
  selectedForPaymentByUser?: TablePaymentSettingUpdateOneWithoutSelectedItemsInput ;
}

export interface OrderItemUpdateWithoutOrderDataInput {
  fraction?: number ;
  isRefunded?: boolean ;
  bundleId?: string ;
  message?: string ;
  offer?: OfferUpdateOneWithoutUsesInput ;
  entry?: MenuEntryUpdateOneWithoutOrderItemsInput ;
  size?: VariationUpdateOneWithoutOrderItemSizesInput ;
  variations?: VariationUpdateManyWithoutOrderItemsInput ;
  removedVariations?: VariationUpdateManyWithoutRemovedFromInput ;
  price?: PriceUpdateOneWithoutOrderItemInput ;
  tableSession?: TableSessionUpdateOneWithoutItemsInput ;
  selectedForPaymentByUser?: TablePaymentSettingUpdateOneWithoutSelectedItemsInput ;
}

export interface OrderItemUpdateWithoutPriceDataInput {
  fraction?: number ;
  isRefunded?: boolean ;
  bundleId?: string ;
  message?: string ;
  offer?: OfferUpdateOneWithoutUsesInput ;
  entry?: MenuEntryUpdateOneWithoutOrderItemsInput ;
  size?: VariationUpdateOneWithoutOrderItemSizesInput ;
  order?: OrderUpdateOneWithoutItemsInput ;
  variations?: VariationUpdateManyWithoutOrderItemsInput ;
  removedVariations?: VariationUpdateManyWithoutRemovedFromInput ;
  tableSession?: TableSessionUpdateOneWithoutItemsInput ;
  selectedForPaymentByUser?: TablePaymentSettingUpdateOneWithoutSelectedItemsInput ;
}

export interface OrderItemUpdateWithoutRemovedVariationsDataInput {
  fraction?: number ;
  isRefunded?: boolean ;
  bundleId?: string ;
  message?: string ;
  offer?: OfferUpdateOneWithoutUsesInput ;
  entry?: MenuEntryUpdateOneWithoutOrderItemsInput ;
  size?: VariationUpdateOneWithoutOrderItemSizesInput ;
  order?: OrderUpdateOneWithoutItemsInput ;
  variations?: VariationUpdateManyWithoutOrderItemsInput ;
  price?: PriceUpdateOneWithoutOrderItemInput ;
  tableSession?: TableSessionUpdateOneWithoutItemsInput ;
  selectedForPaymentByUser?: TablePaymentSettingUpdateOneWithoutSelectedItemsInput ;
}

export interface OrderItemUpdateWithoutSelectedForPaymentByUserDataInput {
  fraction?: number ;
  isRefunded?: boolean ;
  bundleId?: string ;
  message?: string ;
  offer?: OfferUpdateOneWithoutUsesInput ;
  entry?: MenuEntryUpdateOneWithoutOrderItemsInput ;
  size?: VariationUpdateOneWithoutOrderItemSizesInput ;
  order?: OrderUpdateOneWithoutItemsInput ;
  variations?: VariationUpdateManyWithoutOrderItemsInput ;
  removedVariations?: VariationUpdateManyWithoutRemovedFromInput ;
  price?: PriceUpdateOneWithoutOrderItemInput ;
  tableSession?: TableSessionUpdateOneWithoutItemsInput ;
}

export interface OrderItemUpdateWithoutSizeDataInput {
  fraction?: number ;
  isRefunded?: boolean ;
  bundleId?: string ;
  message?: string ;
  offer?: OfferUpdateOneWithoutUsesInput ;
  entry?: MenuEntryUpdateOneWithoutOrderItemsInput ;
  order?: OrderUpdateOneWithoutItemsInput ;
  variations?: VariationUpdateManyWithoutOrderItemsInput ;
  removedVariations?: VariationUpdateManyWithoutRemovedFromInput ;
  price?: PriceUpdateOneWithoutOrderItemInput ;
  tableSession?: TableSessionUpdateOneWithoutItemsInput ;
  selectedForPaymentByUser?: TablePaymentSettingUpdateOneWithoutSelectedItemsInput ;
}

export interface OrderItemUpdateWithoutTableSessionDataInput {
  fraction?: number ;
  isRefunded?: boolean ;
  bundleId?: string ;
  message?: string ;
  offer?: OfferUpdateOneWithoutUsesInput ;
  entry?: MenuEntryUpdateOneWithoutOrderItemsInput ;
  size?: VariationUpdateOneWithoutOrderItemSizesInput ;
  order?: OrderUpdateOneWithoutItemsInput ;
  variations?: VariationUpdateManyWithoutOrderItemsInput ;
  removedVariations?: VariationUpdateManyWithoutRemovedFromInput ;
  price?: PriceUpdateOneWithoutOrderItemInput ;
  selectedForPaymentByUser?: TablePaymentSettingUpdateOneWithoutSelectedItemsInput ;
}

export interface OrderItemUpdateWithoutVariationsDataInput {
  fraction?: number ;
  isRefunded?: boolean ;
  bundleId?: string ;
  message?: string ;
  offer?: OfferUpdateOneWithoutUsesInput ;
  entry?: MenuEntryUpdateOneWithoutOrderItemsInput ;
  size?: VariationUpdateOneWithoutOrderItemSizesInput ;
  order?: OrderUpdateOneWithoutItemsInput ;
  removedVariations?: VariationUpdateManyWithoutRemovedFromInput ;
  price?: PriceUpdateOneWithoutOrderItemInput ;
  tableSession?: TableSessionUpdateOneWithoutItemsInput ;
  selectedForPaymentByUser?: TablePaymentSettingUpdateOneWithoutSelectedItemsInput ;
}

export interface OrderItemUpsertNestedInput {
  update: OrderItemUpdateDataInput;
  create: OrderItemCreateInput;
}

export interface OrderItemUpsertWithWhereUniqueWithoutEntryInput {
  where: OrderItemWhereUniqueInput;
  update: OrderItemUpdateWithoutEntryDataInput;
  create: OrderItemCreateWithoutEntryInput;
}

export interface OrderItemUpsertWithWhereUniqueWithoutOfferInput {
  where: OrderItemWhereUniqueInput;
  update: OrderItemUpdateWithoutOfferDataInput;
  create: OrderItemCreateWithoutOfferInput;
}

export interface OrderItemUpsertWithWhereUniqueWithoutOrderInput {
  where: OrderItemWhereUniqueInput;
  update: OrderItemUpdateWithoutOrderDataInput;
  create: OrderItemCreateWithoutOrderInput;
}

export interface OrderItemUpsertWithWhereUniqueWithoutRemovedVariationsInput {
  where: OrderItemWhereUniqueInput;
  update: OrderItemUpdateWithoutRemovedVariationsDataInput;
  create: OrderItemCreateWithoutRemovedVariationsInput;
}

export interface OrderItemUpsertWithWhereUniqueWithoutSelectedForPaymentByUserInput {
  where: OrderItemWhereUniqueInput;
  update: OrderItemUpdateWithoutSelectedForPaymentByUserDataInput;
  create: OrderItemCreateWithoutSelectedForPaymentByUserInput;
}

export interface OrderItemUpsertWithWhereUniqueWithoutSizeInput {
  where: OrderItemWhereUniqueInput;
  update: OrderItemUpdateWithoutSizeDataInput;
  create: OrderItemCreateWithoutSizeInput;
}

export interface OrderItemUpsertWithWhereUniqueWithoutTableSessionInput {
  where: OrderItemWhereUniqueInput;
  update: OrderItemUpdateWithoutTableSessionDataInput;
  create: OrderItemCreateWithoutTableSessionInput;
}

export interface OrderItemUpsertWithWhereUniqueWithoutVariationsInput {
  where: OrderItemWhereUniqueInput;
  update: OrderItemUpdateWithoutVariationsDataInput;
  create: OrderItemCreateWithoutVariationsInput;
}

export interface OrderItemUpsertWithoutPriceInput {
  update: OrderItemUpdateWithoutPriceDataInput;
  create: OrderItemCreateWithoutPriceInput;
}

export interface OrderItemWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  fraction?: number ;
  fraction_not?: number ;
  fraction_in?: number[] ;
  fraction_not_in?: number[] ;
  fraction_lt?: number ;
  fraction_lte?: number ;
  fraction_gt?: number ;
  fraction_gte?: number ;
  isRefunded?: boolean ;
  isRefunded_not?: boolean ;
  bundleId?: string ;
  bundleId_not?: string ;
  bundleId_in?: string[] ;
  bundleId_not_in?: string[] ;
  bundleId_lt?: string ;
  bundleId_lte?: string ;
  bundleId_gt?: string ;
  bundleId_gte?: string ;
  bundleId_contains?: string ;
  bundleId_not_contains?: string ;
  bundleId_starts_with?: string ;
  bundleId_not_starts_with?: string ;
  bundleId_ends_with?: string ;
  bundleId_not_ends_with?: string ;
  message?: string ;
  message_not?: string ;
  message_in?: string[] ;
  message_not_in?: string[] ;
  message_lt?: string ;
  message_lte?: string ;
  message_gt?: string ;
  message_gte?: string ;
  message_contains?: string ;
  message_not_contains?: string ;
  message_starts_with?: string ;
  message_not_starts_with?: string ;
  message_ends_with?: string ;
  message_not_ends_with?: string ;
  offer?: OfferWhereInput ;
  entry?: MenuEntryWhereInput ;
  size?: VariationWhereInput ;
  order?: OrderWhereInput ;
  variations_every?: VariationWhereInput ;
  variations_some?: VariationWhereInput ;
  variations_none?: VariationWhereInput ;
  removedVariations_every?: VariationWhereInput ;
  removedVariations_some?: VariationWhereInput ;
  removedVariations_none?: VariationWhereInput ;
  price?: PriceWhereInput ;
  tableSession?: TableSessionWhereInput ;
  selectedForPaymentByUser?: TablePaymentSettingWhereInput ;
  AND?: OrderItemWhereInput[] ;
  OR?: OrderItemWhereInput[] ;
  NOT?: OrderItemWhereInput[] ;
}

export interface OrderItemWhereUniqueInput {
  id?: string ;
}

export interface OrderScalarWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  claimed?: boolean ;
  claimed_not?: boolean ;
  creationDate?: any ;
  creationDate_not?: any ;
  creationDate_in?: any[] ;
  creationDate_not_in?: any[] ;
  creationDate_lt?: any ;
  creationDate_lte?: any ;
  creationDate_gt?: any ;
  creationDate_gte?: any ;
  estimatedFinishTime?: string ;
  estimatedFinishTime_not?: string ;
  estimatedFinishTime_in?: string[] ;
  estimatedFinishTime_not_in?: string[] ;
  estimatedFinishTime_lt?: string ;
  estimatedFinishTime_lte?: string ;
  estimatedFinishTime_gt?: string ;
  estimatedFinishTime_gte?: string ;
  estimatedFinishTime_contains?: string ;
  estimatedFinishTime_not_contains?: string ;
  estimatedFinishTime_starts_with?: string ;
  estimatedFinishTime_not_starts_with?: string ;
  estimatedFinishTime_ends_with?: string ;
  estimatedFinishTime_not_ends_with?: string ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  easyId?: string ;
  easyId_not?: string ;
  easyId_in?: string[] ;
  easyId_not_in?: string[] ;
  easyId_lt?: string ;
  easyId_lte?: string ;
  easyId_gt?: string ;
  easyId_gte?: string ;
  easyId_contains?: string ;
  easyId_not_contains?: string ;
  easyId_starts_with?: string ;
  easyId_not_starts_with?: string ;
  easyId_ends_with?: string ;
  easyId_not_ends_with?: string ;
  rejectReason?: REJECT_REASON ;
  rejectReason_not?: REJECT_REASON ;
  rejectReason_in?: REJECT_REASON[] ;
  rejectReason_not_in?: REJECT_REASON[] ;
  status?: ORDER_STATUS ;
  status_not?: ORDER_STATUS ;
  status_in?: ORDER_STATUS[] ;
  status_not_in?: ORDER_STATUS[] ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  confirmed?: boolean ;
  confirmed_not?: boolean ;
  comment?: string ;
  comment_not?: string ;
  comment_in?: string[] ;
  comment_not_in?: string[] ;
  comment_lt?: string ;
  comment_lte?: string ;
  comment_gt?: string ;
  comment_gte?: string ;
  comment_contains?: string ;
  comment_not_contains?: string ;
  comment_starts_with?: string ;
  comment_not_starts_with?: string ;
  comment_ends_with?: string ;
  comment_not_ends_with?: string ;
  type?: SERVICE_TYPE ;
  type_not?: SERVICE_TYPE ;
  type_in?: SERVICE_TYPE[] ;
  type_not_in?: SERVICE_TYPE[] ;
  updateToken?: string ;
  updateToken_not?: string ;
  updateToken_in?: string[] ;
  updateToken_not_in?: string[] ;
  updateToken_lt?: string ;
  updateToken_lte?: string ;
  updateToken_gt?: string ;
  updateToken_gte?: string ;
  updateToken_contains?: string ;
  updateToken_not_contains?: string ;
  updateToken_starts_with?: string ;
  updateToken_not_starts_with?: string ;
  updateToken_ends_with?: string ;
  updateToken_not_ends_with?: string ;
  desiredTime?: any ;
  desiredTime_not?: any ;
  desiredTime_in?: any[] ;
  desiredTime_not_in?: any[] ;
  desiredTime_lt?: any ;
  desiredTime_lte?: any ;
  desiredTime_gt?: any ;
  desiredTime_gte?: any ;
  remindTimer?: number ;
  remindTimer_not?: number ;
  remindTimer_in?: number[] ;
  remindTimer_not_in?: number[] ;
  remindTimer_lt?: number ;
  remindTimer_lte?: number ;
  remindTimer_gt?: number ;
  remindTimer_gte?: number ;
  reminded?: boolean ;
  reminded_not?: boolean ;
  basketToken?: string ;
  basketToken_not?: string ;
  basketToken_in?: string[] ;
  basketToken_not_in?: string[] ;
  basketToken_lt?: string ;
  basketToken_lte?: string ;
  basketToken_gt?: string ;
  basketToken_gte?: string ;
  basketToken_contains?: string ;
  basketToken_not_contains?: string ;
  basketToken_starts_with?: string ;
  basketToken_not_starts_with?: string ;
  basketToken_ends_with?: string ;
  basketToken_not_ends_with?: string ;
  isTableOrder?: boolean ;
  isTableOrder_not?: boolean ;
  immediateInvoice?: boolean ;
  immediateInvoice_not?: boolean ;
  invoiceName?: string ;
  invoiceName_not?: string ;
  invoiceName_in?: string[] ;
  invoiceName_not_in?: string[] ;
  invoiceName_lt?: string ;
  invoiceName_lte?: string ;
  invoiceName_gt?: string ;
  invoiceName_gte?: string ;
  invoiceName_contains?: string ;
  invoiceName_not_contains?: string ;
  invoiceName_starts_with?: string ;
  invoiceName_not_starts_with?: string ;
  invoiceName_ends_with?: string ;
  invoiceName_not_ends_with?: string ;
  hasPrintedReceiptCopy?: boolean ;
  hasPrintedReceiptCopy_not?: boolean ;
  origin?: ORDER_ORIGIN ;
  origin_not?: ORDER_ORIGIN ;
  origin_in?: ORDER_ORIGIN[] ;
  origin_not_in?: ORDER_ORIGIN[] ;
  posOrderUnique?: string ;
  posOrderUnique_not?: string ;
  posOrderUnique_in?: string[] ;
  posOrderUnique_not_in?: string[] ;
  posOrderUnique_lt?: string ;
  posOrderUnique_lte?: string ;
  posOrderUnique_gt?: string ;
  posOrderUnique_gte?: string ;
  posOrderUnique_contains?: string ;
  posOrderUnique_not_contains?: string ;
  posOrderUnique_starts_with?: string ;
  posOrderUnique_not_starts_with?: string ;
  posOrderUnique_ends_with?: string ;
  posOrderUnique_not_ends_with?: string ;
  complianceId?: string ;
  complianceId_not?: string ;
  complianceId_in?: string[] ;
  complianceId_not_in?: string[] ;
  complianceId_lt?: string ;
  complianceId_lte?: string ;
  complianceId_gt?: string ;
  complianceId_gte?: string ;
  complianceId_contains?: string ;
  complianceId_not_contains?: string ;
  complianceId_starts_with?: string ;
  complianceId_not_starts_with?: string ;
  complianceId_ends_with?: string ;
  complianceId_not_ends_with?: string ;
  AND?: OrderScalarWhereInput[] ;
  OR?: OrderScalarWhereInput[] ;
  NOT?: OrderScalarWhereInput[] ;
}

export interface OrderUpdateDataInput {
  claimed?: boolean ;
  creationDate?: any ;
  offers?: OfferUpdateManyWithoutOrdersInput ;
  offer?: OfferUpdateOneWithoutOrdersSinglesInput ;
  estimatedFinishTime?: string ;
  easyId?: string ;
  items?: OrderItemUpdateManyWithoutOrderInput ;
  payment?: PaymentUpdateOneWithoutOrderInput ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  user?: UserUpdateOneRequiredWithoutOrdersInput ;
  venue?: VenueUpdateOneWithoutOrdersInput ;
  confirmed?: boolean ;
  comment?: string ;
  deliveryLocation?: LocationUpdateOneWithoutOrdersInput ;
  type?: SERVICE_TYPE ;
  fees?: FeeUpdateManyWithoutOrdersInput ;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken?: string ;
  isTableOrder?: boolean ;
  table?: TableSessionUpdateOneWithoutOrdersInput ;
  invoiceTarget?: InvoiceTargetUpdateOneWithoutOrdersInput ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posDevice?: POSDeviceUpdateOneInput ;
  posOrderUnique?: string ;
  zone?: ZoneUpdateOneInput ;
  complianceId?: string ;
}

export interface OrderUpdateManyDataInput {
  claimed?: boolean ;
  creationDate?: any ;
  estimatedFinishTime?: string ;
  easyId?: string ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  confirmed?: boolean ;
  comment?: string ;
  type?: SERVICE_TYPE ;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken?: string ;
  isTableOrder?: boolean ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posOrderUnique?: string ;
  complianceId?: string ;
}

export interface OrderUpdateManyWithWhereNestedInput {
  where: OrderScalarWhereInput;
  data: OrderUpdateManyDataInput;
}

export interface OrderUpdateManyWithoutDeliveryLocationInput {
  create?: OrderCreateWithoutDeliveryLocationInput[] ;
  connect?: OrderWhereUniqueInput[] ;
  set?: OrderWhereUniqueInput[] ;
  disconnect?: OrderWhereUniqueInput[] ;
  update?: OrderUpdateWithWhereUniqueWithoutDeliveryLocationInput[] ;
  upsert?: OrderUpsertWithWhereUniqueWithoutDeliveryLocationInput[] ;
  deleteMany?: OrderScalarWhereInput[] ;
  updateMany?: OrderUpdateManyWithWhereNestedInput[] ;
}

export interface OrderUpdateManyWithoutFeesInput {
  create?: OrderCreateWithoutFeesInput[] ;
  connect?: OrderWhereUniqueInput[] ;
  set?: OrderWhereUniqueInput[] ;
  disconnect?: OrderWhereUniqueInput[] ;
  update?: OrderUpdateWithWhereUniqueWithoutFeesInput[] ;
  upsert?: OrderUpsertWithWhereUniqueWithoutFeesInput[] ;
  deleteMany?: OrderScalarWhereInput[] ;
  updateMany?: OrderUpdateManyWithWhereNestedInput[] ;
}

export interface OrderUpdateManyWithoutInvoiceTargetInput {
  create?: OrderCreateWithoutInvoiceTargetInput[] ;
  connect?: OrderWhereUniqueInput[] ;
  set?: OrderWhereUniqueInput[] ;
  disconnect?: OrderWhereUniqueInput[] ;
  update?: OrderUpdateWithWhereUniqueWithoutInvoiceTargetInput[] ;
  upsert?: OrderUpsertWithWhereUniqueWithoutInvoiceTargetInput[] ;
  deleteMany?: OrderScalarWhereInput[] ;
  updateMany?: OrderUpdateManyWithWhereNestedInput[] ;
}

export interface OrderUpdateManyWithoutOfferInput {
  create?: OrderCreateWithoutOfferInput[] ;
  connect?: OrderWhereUniqueInput[] ;
  set?: OrderWhereUniqueInput[] ;
  disconnect?: OrderWhereUniqueInput[] ;
  update?: OrderUpdateWithWhereUniqueWithoutOfferInput[] ;
  upsert?: OrderUpsertWithWhereUniqueWithoutOfferInput[] ;
  deleteMany?: OrderScalarWhereInput[] ;
  updateMany?: OrderUpdateManyWithWhereNestedInput[] ;
}

export interface OrderUpdateManyWithoutOffersInput {
  create?: OrderCreateWithoutOffersInput[] ;
  connect?: OrderWhereUniqueInput[] ;
  set?: OrderWhereUniqueInput[] ;
  disconnect?: OrderWhereUniqueInput[] ;
  update?: OrderUpdateWithWhereUniqueWithoutOffersInput[] ;
  upsert?: OrderUpsertWithWhereUniqueWithoutOffersInput[] ;
  deleteMany?: OrderScalarWhereInput[] ;
  updateMany?: OrderUpdateManyWithWhereNestedInput[] ;
}

export interface OrderUpdateManyWithoutTableInput {
  create?: OrderCreateWithoutTableInput[] ;
  connect?: OrderWhereUniqueInput[] ;
  set?: OrderWhereUniqueInput[] ;
  disconnect?: OrderWhereUniqueInput[] ;
  update?: OrderUpdateWithWhereUniqueWithoutTableInput[] ;
  upsert?: OrderUpsertWithWhereUniqueWithoutTableInput[] ;
  deleteMany?: OrderScalarWhereInput[] ;
  updateMany?: OrderUpdateManyWithWhereNestedInput[] ;
}

export interface OrderUpdateManyWithoutUserInput {
  create?: OrderCreateWithoutUserInput[] ;
  connect?: OrderWhereUniqueInput[] ;
  set?: OrderWhereUniqueInput[] ;
  disconnect?: OrderWhereUniqueInput[] ;
  update?: OrderUpdateWithWhereUniqueWithoutUserInput[] ;
  upsert?: OrderUpsertWithWhereUniqueWithoutUserInput[] ;
  deleteMany?: OrderScalarWhereInput[] ;
  updateMany?: OrderUpdateManyWithWhereNestedInput[] ;
}

export interface OrderUpdateManyWithoutVenueInput {
  create?: OrderCreateWithoutVenueInput[] ;
  connect?: OrderWhereUniqueInput[] ;
  set?: OrderWhereUniqueInput[] ;
  disconnect?: OrderWhereUniqueInput[] ;
  update?: OrderUpdateWithWhereUniqueWithoutVenueInput[] ;
  upsert?: OrderUpsertWithWhereUniqueWithoutVenueInput[] ;
  deleteMany?: OrderScalarWhereInput[] ;
  updateMany?: OrderUpdateManyWithWhereNestedInput[] ;
}

export interface OrderUpdateOneRequiredInput {
  create?: OrderCreateInput ;
  update?: OrderUpdateDataInput ;
  upsert?: OrderUpsertNestedInput ;
  connect?: OrderWhereUniqueInput ;
}

export interface OrderUpdateOneWithoutItemsInput {
  create?: OrderCreateWithoutItemsInput ;
  update?: OrderUpdateWithoutItemsDataInput ;
  upsert?: OrderUpsertWithoutItemsInput ;
  disconnect?: boolean ;
  connect?: OrderWhereUniqueInput ;
}

export interface OrderUpdateOneWithoutPaymentInput {
  create?: OrderCreateWithoutPaymentInput ;
  update?: OrderUpdateWithoutPaymentDataInput ;
  upsert?: OrderUpsertWithoutPaymentInput ;
  disconnect?: boolean ;
  connect?: OrderWhereUniqueInput ;
}

export interface OrderUpdateWithWhereUniqueWithoutDeliveryLocationInput {
  where: OrderWhereUniqueInput;
  data: OrderUpdateWithoutDeliveryLocationDataInput;
}

export interface OrderUpdateWithWhereUniqueWithoutFeesInput {
  where: OrderWhereUniqueInput;
  data: OrderUpdateWithoutFeesDataInput;
}

export interface OrderUpdateWithWhereUniqueWithoutInvoiceTargetInput {
  where: OrderWhereUniqueInput;
  data: OrderUpdateWithoutInvoiceTargetDataInput;
}

export interface OrderUpdateWithWhereUniqueWithoutOfferInput {
  where: OrderWhereUniqueInput;
  data: OrderUpdateWithoutOfferDataInput;
}

export interface OrderUpdateWithWhereUniqueWithoutOffersInput {
  where: OrderWhereUniqueInput;
  data: OrderUpdateWithoutOffersDataInput;
}

export interface OrderUpdateWithWhereUniqueWithoutTableInput {
  where: OrderWhereUniqueInput;
  data: OrderUpdateWithoutTableDataInput;
}

export interface OrderUpdateWithWhereUniqueWithoutUserInput {
  where: OrderWhereUniqueInput;
  data: OrderUpdateWithoutUserDataInput;
}

export interface OrderUpdateWithWhereUniqueWithoutVenueInput {
  where: OrderWhereUniqueInput;
  data: OrderUpdateWithoutVenueDataInput;
}

export interface OrderUpdateWithoutDeliveryLocationDataInput {
  claimed?: boolean ;
  creationDate?: any ;
  offers?: OfferUpdateManyWithoutOrdersInput ;
  offer?: OfferUpdateOneWithoutOrdersSinglesInput ;
  estimatedFinishTime?: string ;
  easyId?: string ;
  items?: OrderItemUpdateManyWithoutOrderInput ;
  payment?: PaymentUpdateOneWithoutOrderInput ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  user?: UserUpdateOneRequiredWithoutOrdersInput ;
  venue?: VenueUpdateOneWithoutOrdersInput ;
  confirmed?: boolean ;
  comment?: string ;
  type?: SERVICE_TYPE ;
  fees?: FeeUpdateManyWithoutOrdersInput ;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken?: string ;
  isTableOrder?: boolean ;
  table?: TableSessionUpdateOneWithoutOrdersInput ;
  invoiceTarget?: InvoiceTargetUpdateOneWithoutOrdersInput ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posDevice?: POSDeviceUpdateOneInput ;
  posOrderUnique?: string ;
  zone?: ZoneUpdateOneInput ;
  complianceId?: string ;
}

export interface OrderUpdateWithoutFeesDataInput {
  claimed?: boolean ;
  creationDate?: any ;
  offers?: OfferUpdateManyWithoutOrdersInput ;
  offer?: OfferUpdateOneWithoutOrdersSinglesInput ;
  estimatedFinishTime?: string ;
  easyId?: string ;
  items?: OrderItemUpdateManyWithoutOrderInput ;
  payment?: PaymentUpdateOneWithoutOrderInput ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  user?: UserUpdateOneRequiredWithoutOrdersInput ;
  venue?: VenueUpdateOneWithoutOrdersInput ;
  confirmed?: boolean ;
  comment?: string ;
  deliveryLocation?: LocationUpdateOneWithoutOrdersInput ;
  type?: SERVICE_TYPE ;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken?: string ;
  isTableOrder?: boolean ;
  table?: TableSessionUpdateOneWithoutOrdersInput ;
  invoiceTarget?: InvoiceTargetUpdateOneWithoutOrdersInput ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posDevice?: POSDeviceUpdateOneInput ;
  posOrderUnique?: string ;
  zone?: ZoneUpdateOneInput ;
  complianceId?: string ;
}

export interface OrderUpdateWithoutInvoiceTargetDataInput {
  claimed?: boolean ;
  creationDate?: any ;
  offers?: OfferUpdateManyWithoutOrdersInput ;
  offer?: OfferUpdateOneWithoutOrdersSinglesInput ;
  estimatedFinishTime?: string ;
  easyId?: string ;
  items?: OrderItemUpdateManyWithoutOrderInput ;
  payment?: PaymentUpdateOneWithoutOrderInput ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  user?: UserUpdateOneRequiredWithoutOrdersInput ;
  venue?: VenueUpdateOneWithoutOrdersInput ;
  confirmed?: boolean ;
  comment?: string ;
  deliveryLocation?: LocationUpdateOneWithoutOrdersInput ;
  type?: SERVICE_TYPE ;
  fees?: FeeUpdateManyWithoutOrdersInput ;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken?: string ;
  isTableOrder?: boolean ;
  table?: TableSessionUpdateOneWithoutOrdersInput ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posDevice?: POSDeviceUpdateOneInput ;
  posOrderUnique?: string ;
  zone?: ZoneUpdateOneInput ;
  complianceId?: string ;
}

export interface OrderUpdateWithoutItemsDataInput {
  claimed?: boolean ;
  creationDate?: any ;
  offers?: OfferUpdateManyWithoutOrdersInput ;
  offer?: OfferUpdateOneWithoutOrdersSinglesInput ;
  estimatedFinishTime?: string ;
  easyId?: string ;
  payment?: PaymentUpdateOneWithoutOrderInput ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  user?: UserUpdateOneRequiredWithoutOrdersInput ;
  venue?: VenueUpdateOneWithoutOrdersInput ;
  confirmed?: boolean ;
  comment?: string ;
  deliveryLocation?: LocationUpdateOneWithoutOrdersInput ;
  type?: SERVICE_TYPE ;
  fees?: FeeUpdateManyWithoutOrdersInput ;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken?: string ;
  isTableOrder?: boolean ;
  table?: TableSessionUpdateOneWithoutOrdersInput ;
  invoiceTarget?: InvoiceTargetUpdateOneWithoutOrdersInput ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posDevice?: POSDeviceUpdateOneInput ;
  posOrderUnique?: string ;
  zone?: ZoneUpdateOneInput ;
  complianceId?: string ;
}

export interface OrderUpdateWithoutOfferDataInput {
  claimed?: boolean ;
  creationDate?: any ;
  offers?: OfferUpdateManyWithoutOrdersInput ;
  estimatedFinishTime?: string ;
  easyId?: string ;
  items?: OrderItemUpdateManyWithoutOrderInput ;
  payment?: PaymentUpdateOneWithoutOrderInput ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  user?: UserUpdateOneRequiredWithoutOrdersInput ;
  venue?: VenueUpdateOneWithoutOrdersInput ;
  confirmed?: boolean ;
  comment?: string ;
  deliveryLocation?: LocationUpdateOneWithoutOrdersInput ;
  type?: SERVICE_TYPE ;
  fees?: FeeUpdateManyWithoutOrdersInput ;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken?: string ;
  isTableOrder?: boolean ;
  table?: TableSessionUpdateOneWithoutOrdersInput ;
  invoiceTarget?: InvoiceTargetUpdateOneWithoutOrdersInput ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posDevice?: POSDeviceUpdateOneInput ;
  posOrderUnique?: string ;
  zone?: ZoneUpdateOneInput ;
  complianceId?: string ;
}

export interface OrderUpdateWithoutOffersDataInput {
  claimed?: boolean ;
  creationDate?: any ;
  offer?: OfferUpdateOneWithoutOrdersSinglesInput ;
  estimatedFinishTime?: string ;
  easyId?: string ;
  items?: OrderItemUpdateManyWithoutOrderInput ;
  payment?: PaymentUpdateOneWithoutOrderInput ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  user?: UserUpdateOneRequiredWithoutOrdersInput ;
  venue?: VenueUpdateOneWithoutOrdersInput ;
  confirmed?: boolean ;
  comment?: string ;
  deliveryLocation?: LocationUpdateOneWithoutOrdersInput ;
  type?: SERVICE_TYPE ;
  fees?: FeeUpdateManyWithoutOrdersInput ;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken?: string ;
  isTableOrder?: boolean ;
  table?: TableSessionUpdateOneWithoutOrdersInput ;
  invoiceTarget?: InvoiceTargetUpdateOneWithoutOrdersInput ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posDevice?: POSDeviceUpdateOneInput ;
  posOrderUnique?: string ;
  zone?: ZoneUpdateOneInput ;
  complianceId?: string ;
}

export interface OrderUpdateWithoutPaymentDataInput {
  claimed?: boolean ;
  creationDate?: any ;
  offers?: OfferUpdateManyWithoutOrdersInput ;
  offer?: OfferUpdateOneWithoutOrdersSinglesInput ;
  estimatedFinishTime?: string ;
  easyId?: string ;
  items?: OrderItemUpdateManyWithoutOrderInput ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  user?: UserUpdateOneRequiredWithoutOrdersInput ;
  venue?: VenueUpdateOneWithoutOrdersInput ;
  confirmed?: boolean ;
  comment?: string ;
  deliveryLocation?: LocationUpdateOneWithoutOrdersInput ;
  type?: SERVICE_TYPE ;
  fees?: FeeUpdateManyWithoutOrdersInput ;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken?: string ;
  isTableOrder?: boolean ;
  table?: TableSessionUpdateOneWithoutOrdersInput ;
  invoiceTarget?: InvoiceTargetUpdateOneWithoutOrdersInput ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posDevice?: POSDeviceUpdateOneInput ;
  posOrderUnique?: string ;
  zone?: ZoneUpdateOneInput ;
  complianceId?: string ;
}

export interface OrderUpdateWithoutTableDataInput {
  claimed?: boolean ;
  creationDate?: any ;
  offers?: OfferUpdateManyWithoutOrdersInput ;
  offer?: OfferUpdateOneWithoutOrdersSinglesInput ;
  estimatedFinishTime?: string ;
  easyId?: string ;
  items?: OrderItemUpdateManyWithoutOrderInput ;
  payment?: PaymentUpdateOneWithoutOrderInput ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  user?: UserUpdateOneRequiredWithoutOrdersInput ;
  venue?: VenueUpdateOneWithoutOrdersInput ;
  confirmed?: boolean ;
  comment?: string ;
  deliveryLocation?: LocationUpdateOneWithoutOrdersInput ;
  type?: SERVICE_TYPE ;
  fees?: FeeUpdateManyWithoutOrdersInput ;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken?: string ;
  isTableOrder?: boolean ;
  invoiceTarget?: InvoiceTargetUpdateOneWithoutOrdersInput ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posDevice?: POSDeviceUpdateOneInput ;
  posOrderUnique?: string ;
  zone?: ZoneUpdateOneInput ;
  complianceId?: string ;
}

export interface OrderUpdateWithoutUserDataInput {
  claimed?: boolean ;
  creationDate?: any ;
  offers?: OfferUpdateManyWithoutOrdersInput ;
  offer?: OfferUpdateOneWithoutOrdersSinglesInput ;
  estimatedFinishTime?: string ;
  easyId?: string ;
  items?: OrderItemUpdateManyWithoutOrderInput ;
  payment?: PaymentUpdateOneWithoutOrderInput ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  venue?: VenueUpdateOneWithoutOrdersInput ;
  confirmed?: boolean ;
  comment?: string ;
  deliveryLocation?: LocationUpdateOneWithoutOrdersInput ;
  type?: SERVICE_TYPE ;
  fees?: FeeUpdateManyWithoutOrdersInput ;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken?: string ;
  isTableOrder?: boolean ;
  table?: TableSessionUpdateOneWithoutOrdersInput ;
  invoiceTarget?: InvoiceTargetUpdateOneWithoutOrdersInput ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posDevice?: POSDeviceUpdateOneInput ;
  posOrderUnique?: string ;
  zone?: ZoneUpdateOneInput ;
  complianceId?: string ;
}

export interface OrderUpdateWithoutVenueDataInput {
  claimed?: boolean ;
  creationDate?: any ;
  offers?: OfferUpdateManyWithoutOrdersInput ;
  offer?: OfferUpdateOneWithoutOrdersSinglesInput ;
  estimatedFinishTime?: string ;
  easyId?: string ;
  items?: OrderItemUpdateManyWithoutOrderInput ;
  payment?: PaymentUpdateOneWithoutOrderInput ;
  rejectReason?: REJECT_REASON ;
  statusHistory?: any ;
  status?: ORDER_STATUS ;
  user?: UserUpdateOneRequiredWithoutOrdersInput ;
  confirmed?: boolean ;
  comment?: string ;
  deliveryLocation?: LocationUpdateOneWithoutOrdersInput ;
  type?: SERVICE_TYPE ;
  fees?: FeeUpdateManyWithoutOrdersInput ;
  updateToken?: string ;
  desiredTime?: any ;
  remindTimer?: number ;
  reminded?: boolean ;
  basketToken?: string ;
  isTableOrder?: boolean ;
  table?: TableSessionUpdateOneWithoutOrdersInput ;
  invoiceTarget?: InvoiceTargetUpdateOneWithoutOrdersInput ;
  immediateInvoice?: boolean ;
  invoiceName?: string ;
  hasPrintedReceiptCopy?: boolean ;
  origin?: ORDER_ORIGIN ;
  posDevice?: POSDeviceUpdateOneInput ;
  posOrderUnique?: string ;
  zone?: ZoneUpdateOneInput ;
  complianceId?: string ;
}

export interface OrderUpsertNestedInput {
  update: OrderUpdateDataInput;
  create: OrderCreateInput;
}

export interface OrderUpsertWithWhereUniqueWithoutDeliveryLocationInput {
  where: OrderWhereUniqueInput;
  update: OrderUpdateWithoutDeliveryLocationDataInput;
  create: OrderCreateWithoutDeliveryLocationInput;
}

export interface OrderUpsertWithWhereUniqueWithoutFeesInput {
  where: OrderWhereUniqueInput;
  update: OrderUpdateWithoutFeesDataInput;
  create: OrderCreateWithoutFeesInput;
}

export interface OrderUpsertWithWhereUniqueWithoutInvoiceTargetInput {
  where: OrderWhereUniqueInput;
  update: OrderUpdateWithoutInvoiceTargetDataInput;
  create: OrderCreateWithoutInvoiceTargetInput;
}

export interface OrderUpsertWithWhereUniqueWithoutOfferInput {
  where: OrderWhereUniqueInput;
  update: OrderUpdateWithoutOfferDataInput;
  create: OrderCreateWithoutOfferInput;
}

export interface OrderUpsertWithWhereUniqueWithoutOffersInput {
  where: OrderWhereUniqueInput;
  update: OrderUpdateWithoutOffersDataInput;
  create: OrderCreateWithoutOffersInput;
}

export interface OrderUpsertWithWhereUniqueWithoutTableInput {
  where: OrderWhereUniqueInput;
  update: OrderUpdateWithoutTableDataInput;
  create: OrderCreateWithoutTableInput;
}

export interface OrderUpsertWithWhereUniqueWithoutUserInput {
  where: OrderWhereUniqueInput;
  update: OrderUpdateWithoutUserDataInput;
  create: OrderCreateWithoutUserInput;
}

export interface OrderUpsertWithWhereUniqueWithoutVenueInput {
  where: OrderWhereUniqueInput;
  update: OrderUpdateWithoutVenueDataInput;
  create: OrderCreateWithoutVenueInput;
}

export interface OrderUpsertWithoutItemsInput {
  update: OrderUpdateWithoutItemsDataInput;
  create: OrderCreateWithoutItemsInput;
}

export interface OrderUpsertWithoutPaymentInput {
  update: OrderUpdateWithoutPaymentDataInput;
  create: OrderCreateWithoutPaymentInput;
}

export interface OrderWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  claimed?: boolean ;
  claimed_not?: boolean ;
  creationDate?: any ;
  creationDate_not?: any ;
  creationDate_in?: any[] ;
  creationDate_not_in?: any[] ;
  creationDate_lt?: any ;
  creationDate_lte?: any ;
  creationDate_gt?: any ;
  creationDate_gte?: any ;
  offers_every?: OfferWhereInput ;
  offers_some?: OfferWhereInput ;
  offers_none?: OfferWhereInput ;
  offer?: OfferWhereInput ;
  estimatedFinishTime?: string ;
  estimatedFinishTime_not?: string ;
  estimatedFinishTime_in?: string[] ;
  estimatedFinishTime_not_in?: string[] ;
  estimatedFinishTime_lt?: string ;
  estimatedFinishTime_lte?: string ;
  estimatedFinishTime_gt?: string ;
  estimatedFinishTime_gte?: string ;
  estimatedFinishTime_contains?: string ;
  estimatedFinishTime_not_contains?: string ;
  estimatedFinishTime_starts_with?: string ;
  estimatedFinishTime_not_starts_with?: string ;
  estimatedFinishTime_ends_with?: string ;
  estimatedFinishTime_not_ends_with?: string ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  easyId?: string ;
  easyId_not?: string ;
  easyId_in?: string[] ;
  easyId_not_in?: string[] ;
  easyId_lt?: string ;
  easyId_lte?: string ;
  easyId_gt?: string ;
  easyId_gte?: string ;
  easyId_contains?: string ;
  easyId_not_contains?: string ;
  easyId_starts_with?: string ;
  easyId_not_starts_with?: string ;
  easyId_ends_with?: string ;
  easyId_not_ends_with?: string ;
  items_every?: OrderItemWhereInput ;
  items_some?: OrderItemWhereInput ;
  items_none?: OrderItemWhereInput ;
  payment?: PaymentWhereInput ;
  rejectReason?: REJECT_REASON ;
  rejectReason_not?: REJECT_REASON ;
  rejectReason_in?: REJECT_REASON[] ;
  rejectReason_not_in?: REJECT_REASON[] ;
  status?: ORDER_STATUS ;
  status_not?: ORDER_STATUS ;
  status_in?: ORDER_STATUS[] ;
  status_not_in?: ORDER_STATUS[] ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  user?: UserWhereInput ;
  venue?: VenueWhereInput ;
  confirmed?: boolean ;
  confirmed_not?: boolean ;
  comment?: string ;
  comment_not?: string ;
  comment_in?: string[] ;
  comment_not_in?: string[] ;
  comment_lt?: string ;
  comment_lte?: string ;
  comment_gt?: string ;
  comment_gte?: string ;
  comment_contains?: string ;
  comment_not_contains?: string ;
  comment_starts_with?: string ;
  comment_not_starts_with?: string ;
  comment_ends_with?: string ;
  comment_not_ends_with?: string ;
  deliveryLocation?: LocationWhereInput ;
  type?: SERVICE_TYPE ;
  type_not?: SERVICE_TYPE ;
  type_in?: SERVICE_TYPE[] ;
  type_not_in?: SERVICE_TYPE[] ;
  fees_every?: FeeWhereInput ;
  fees_some?: FeeWhereInput ;
  fees_none?: FeeWhereInput ;
  updateToken?: string ;
  updateToken_not?: string ;
  updateToken_in?: string[] ;
  updateToken_not_in?: string[] ;
  updateToken_lt?: string ;
  updateToken_lte?: string ;
  updateToken_gt?: string ;
  updateToken_gte?: string ;
  updateToken_contains?: string ;
  updateToken_not_contains?: string ;
  updateToken_starts_with?: string ;
  updateToken_not_starts_with?: string ;
  updateToken_ends_with?: string ;
  updateToken_not_ends_with?: string ;
  desiredTime?: any ;
  desiredTime_not?: any ;
  desiredTime_in?: any[] ;
  desiredTime_not_in?: any[] ;
  desiredTime_lt?: any ;
  desiredTime_lte?: any ;
  desiredTime_gt?: any ;
  desiredTime_gte?: any ;
  remindTimer?: number ;
  remindTimer_not?: number ;
  remindTimer_in?: number[] ;
  remindTimer_not_in?: number[] ;
  remindTimer_lt?: number ;
  remindTimer_lte?: number ;
  remindTimer_gt?: number ;
  remindTimer_gte?: number ;
  reminded?: boolean ;
  reminded_not?: boolean ;
  basketToken?: string ;
  basketToken_not?: string ;
  basketToken_in?: string[] ;
  basketToken_not_in?: string[] ;
  basketToken_lt?: string ;
  basketToken_lte?: string ;
  basketToken_gt?: string ;
  basketToken_gte?: string ;
  basketToken_contains?: string ;
  basketToken_not_contains?: string ;
  basketToken_starts_with?: string ;
  basketToken_not_starts_with?: string ;
  basketToken_ends_with?: string ;
  basketToken_not_ends_with?: string ;
  isTableOrder?: boolean ;
  isTableOrder_not?: boolean ;
  table?: TableSessionWhereInput ;
  invoiceTarget?: InvoiceTargetWhereInput ;
  immediateInvoice?: boolean ;
  immediateInvoice_not?: boolean ;
  invoiceName?: string ;
  invoiceName_not?: string ;
  invoiceName_in?: string[] ;
  invoiceName_not_in?: string[] ;
  invoiceName_lt?: string ;
  invoiceName_lte?: string ;
  invoiceName_gt?: string ;
  invoiceName_gte?: string ;
  invoiceName_contains?: string ;
  invoiceName_not_contains?: string ;
  invoiceName_starts_with?: string ;
  invoiceName_not_starts_with?: string ;
  invoiceName_ends_with?: string ;
  invoiceName_not_ends_with?: string ;
  hasPrintedReceiptCopy?: boolean ;
  hasPrintedReceiptCopy_not?: boolean ;
  origin?: ORDER_ORIGIN ;
  origin_not?: ORDER_ORIGIN ;
  origin_in?: ORDER_ORIGIN[] ;
  origin_not_in?: ORDER_ORIGIN[] ;
  posDevice?: POSDeviceWhereInput ;
  posOrderUnique?: string ;
  posOrderUnique_not?: string ;
  posOrderUnique_in?: string[] ;
  posOrderUnique_not_in?: string[] ;
  posOrderUnique_lt?: string ;
  posOrderUnique_lte?: string ;
  posOrderUnique_gt?: string ;
  posOrderUnique_gte?: string ;
  posOrderUnique_contains?: string ;
  posOrderUnique_not_contains?: string ;
  posOrderUnique_starts_with?: string ;
  posOrderUnique_not_starts_with?: string ;
  posOrderUnique_ends_with?: string ;
  posOrderUnique_not_ends_with?: string ;
  zone?: ZoneWhereInput ;
  complianceId?: string ;
  complianceId_not?: string ;
  complianceId_in?: string[] ;
  complianceId_not_in?: string[] ;
  complianceId_lt?: string ;
  complianceId_lte?: string ;
  complianceId_gt?: string ;
  complianceId_gte?: string ;
  complianceId_contains?: string ;
  complianceId_not_contains?: string ;
  complianceId_starts_with?: string ;
  complianceId_not_starts_with?: string ;
  complianceId_ends_with?: string ;
  complianceId_not_ends_with?: string ;
  AND?: OrderWhereInput[] ;
  OR?: OrderWhereInput[] ;
  NOT?: OrderWhereInput[] ;
}

export interface OrderWhereUniqueInput {
  id?: string ;
  posOrderUnique?: string ;
}

export interface POSDeviceCreateInput {
  id?: string ;
  lastSeen?: any ;
  name: string;
  deviceOS?: string ;
  claimed?: boolean ;
  company?: CompanyCreateOneWithoutPosDevicesInput ;
  venue: VenueCreateOneWithoutPosDevicesInput;
}

export interface POSDeviceCreateManyWithoutCompanyInput {
  create?: POSDeviceCreateWithoutCompanyInput[] ;
  connect?: POSDeviceWhereUniqueInput[] ;
}

export interface POSDeviceCreateManyWithoutVenueInput {
  create?: POSDeviceCreateWithoutVenueInput[] ;
  connect?: POSDeviceWhereUniqueInput[] ;
}

export interface POSDeviceCreateOneInput {
  create?: POSDeviceCreateInput ;
  connect?: POSDeviceWhereUniqueInput ;
}

export interface POSDeviceCreateWithoutCompanyInput {
  id?: string ;
  lastSeen?: any ;
  name: string;
  deviceOS?: string ;
  claimed?: boolean ;
  venue: VenueCreateOneWithoutPosDevicesInput;
}

export interface POSDeviceCreateWithoutVenueInput {
  id?: string ;
  lastSeen?: any ;
  name: string;
  deviceOS?: string ;
  claimed?: boolean ;
  company?: CompanyCreateOneWithoutPosDevicesInput ;
}

export interface POSDeviceScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  lastSeen?: any ;
  lastSeen_not?: any ;
  lastSeen_in?: any[] ;
  lastSeen_not_in?: any[] ;
  lastSeen_lt?: any ;
  lastSeen_lte?: any ;
  lastSeen_gt?: any ;
  lastSeen_gte?: any ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  deviceOS?: string ;
  deviceOS_not?: string ;
  deviceOS_in?: string[] ;
  deviceOS_not_in?: string[] ;
  deviceOS_lt?: string ;
  deviceOS_lte?: string ;
  deviceOS_gt?: string ;
  deviceOS_gte?: string ;
  deviceOS_contains?: string ;
  deviceOS_not_contains?: string ;
  deviceOS_starts_with?: string ;
  deviceOS_not_starts_with?: string ;
  deviceOS_ends_with?: string ;
  deviceOS_not_ends_with?: string ;
  claimed?: boolean ;
  claimed_not?: boolean ;
  AND?: POSDeviceScalarWhereInput[] ;
  OR?: POSDeviceScalarWhereInput[] ;
  NOT?: POSDeviceScalarWhereInput[] ;
}

export interface POSDeviceUpdateDataInput {
  lastSeen?: any ;
  name?: string ;
  deviceOS?: string ;
  claimed?: boolean ;
  company?: CompanyUpdateOneWithoutPosDevicesInput ;
  venue?: VenueUpdateOneRequiredWithoutPosDevicesInput ;
}

export interface POSDeviceUpdateInput {
  lastSeen?: any ;
  name?: string ;
  deviceOS?: string ;
  claimed?: boolean ;
  company?: CompanyUpdateOneWithoutPosDevicesInput ;
  venue?: VenueUpdateOneRequiredWithoutPosDevicesInput ;
}

export interface POSDeviceUpdateManyDataInput {
  lastSeen?: any ;
  name?: string ;
  deviceOS?: string ;
  claimed?: boolean ;
}

export interface POSDeviceUpdateManyWithWhereNestedInput {
  where: POSDeviceScalarWhereInput;
  data: POSDeviceUpdateManyDataInput;
}

export interface POSDeviceUpdateManyWithoutCompanyInput {
  create?: POSDeviceCreateWithoutCompanyInput[] ;
  connect?: POSDeviceWhereUniqueInput[] ;
  set?: POSDeviceWhereUniqueInput[] ;
  disconnect?: POSDeviceWhereUniqueInput[] ;
  update?: POSDeviceUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: POSDeviceUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: POSDeviceScalarWhereInput[] ;
  updateMany?: POSDeviceUpdateManyWithWhereNestedInput[] ;
}

export interface POSDeviceUpdateManyWithoutVenueInput {
  create?: POSDeviceCreateWithoutVenueInput[] ;
  connect?: POSDeviceWhereUniqueInput[] ;
  set?: POSDeviceWhereUniqueInput[] ;
  disconnect?: POSDeviceWhereUniqueInput[] ;
  update?: POSDeviceUpdateWithWhereUniqueWithoutVenueInput[] ;
  upsert?: POSDeviceUpsertWithWhereUniqueWithoutVenueInput[] ;
  deleteMany?: POSDeviceScalarWhereInput[] ;
  updateMany?: POSDeviceUpdateManyWithWhereNestedInput[] ;
}

export interface POSDeviceUpdateOneInput {
  create?: POSDeviceCreateInput ;
  update?: POSDeviceUpdateDataInput ;
  upsert?: POSDeviceUpsertNestedInput ;
  disconnect?: boolean ;
  connect?: POSDeviceWhereUniqueInput ;
}

export interface POSDeviceUpdateWithWhereUniqueWithoutCompanyInput {
  where: POSDeviceWhereUniqueInput;
  data: POSDeviceUpdateWithoutCompanyDataInput;
}

export interface POSDeviceUpdateWithWhereUniqueWithoutVenueInput {
  where: POSDeviceWhereUniqueInput;
  data: POSDeviceUpdateWithoutVenueDataInput;
}

export interface POSDeviceUpdateWithoutCompanyDataInput {
  lastSeen?: any ;
  name?: string ;
  deviceOS?: string ;
  claimed?: boolean ;
  venue?: VenueUpdateOneRequiredWithoutPosDevicesInput ;
}

export interface POSDeviceUpdateWithoutVenueDataInput {
  lastSeen?: any ;
  name?: string ;
  deviceOS?: string ;
  claimed?: boolean ;
  company?: CompanyUpdateOneWithoutPosDevicesInput ;
}

export interface POSDeviceUpsertNestedInput {
  update: POSDeviceUpdateDataInput;
  create: POSDeviceCreateInput;
}

export interface POSDeviceUpsertWithWhereUniqueWithoutCompanyInput {
  where: POSDeviceWhereUniqueInput;
  update: POSDeviceUpdateWithoutCompanyDataInput;
  create: POSDeviceCreateWithoutCompanyInput;
}

export interface POSDeviceUpsertWithWhereUniqueWithoutVenueInput {
  where: POSDeviceWhereUniqueInput;
  update: POSDeviceUpdateWithoutVenueDataInput;
  create: POSDeviceCreateWithoutVenueInput;
}

export interface POSDeviceWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  lastSeen?: any ;
  lastSeen_not?: any ;
  lastSeen_in?: any[] ;
  lastSeen_not_in?: any[] ;
  lastSeen_lt?: any ;
  lastSeen_lte?: any ;
  lastSeen_gt?: any ;
  lastSeen_gte?: any ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  deviceOS?: string ;
  deviceOS_not?: string ;
  deviceOS_in?: string[] ;
  deviceOS_not_in?: string[] ;
  deviceOS_lt?: string ;
  deviceOS_lte?: string ;
  deviceOS_gt?: string ;
  deviceOS_gte?: string ;
  deviceOS_contains?: string ;
  deviceOS_not_contains?: string ;
  deviceOS_starts_with?: string ;
  deviceOS_not_starts_with?: string ;
  deviceOS_ends_with?: string ;
  deviceOS_not_ends_with?: string ;
  claimed?: boolean ;
  claimed_not?: boolean ;
  company?: CompanyWhereInput ;
  venue?: VenueWhereInput ;
  AND?: POSDeviceWhereInput[] ;
  OR?: POSDeviceWhereInput[] ;
  NOT?: POSDeviceWhereInput[] ;
}

export interface POSDeviceWhereUniqueInput {
  id?: string ;
}

export interface PageCreateInput {
  id?: string ;
  name: TranslatedStringCreateOneWithoutPageInput;
  rows: number;
  columns: number;
  deleted?: boolean ;
  category?: PosCategoryCreateOneWithoutPageInput ;
  buttons?: PageCreatebuttonsInput ;
  company: CompanyCreateOneWithoutPagesInput;
}

export interface PageCreateManyWithoutCompanyInput {
  create?: PageCreateWithoutCompanyInput[] ;
  connect?: PageWhereUniqueInput[] ;
}

export interface PageCreateOneWithoutCategoryInput {
  create?: PageCreateWithoutCategoryInput ;
  connect?: PageWhereUniqueInput ;
}

export interface PageCreateOneWithoutNameInput {
  create?: PageCreateWithoutNameInput ;
  connect?: PageWhereUniqueInput ;
}

export interface PageCreateWithoutCategoryInput {
  id?: string ;
  name: TranslatedStringCreateOneWithoutPageInput;
  rows: number;
  columns: number;
  deleted?: boolean ;
  buttons?: PageCreatebuttonsInput ;
  company: CompanyCreateOneWithoutPagesInput;
}

export interface PageCreateWithoutCompanyInput {
  id?: string ;
  name: TranslatedStringCreateOneWithoutPageInput;
  rows: number;
  columns: number;
  deleted?: boolean ;
  category?: PosCategoryCreateOneWithoutPageInput ;
  buttons?: PageCreatebuttonsInput ;
}

export interface PageCreateWithoutNameInput {
  id?: string ;
  rows: number;
  columns: number;
  deleted?: boolean ;
  category?: PosCategoryCreateOneWithoutPageInput ;
  buttons?: PageCreatebuttonsInput ;
  company: CompanyCreateOneWithoutPagesInput;
}

export interface PageCreatebuttonsInput {
  set?: any[] ;
}

export interface PageScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  rows?: number ;
  rows_not?: number ;
  rows_in?: number[] ;
  rows_not_in?: number[] ;
  rows_lt?: number ;
  rows_lte?: number ;
  rows_gt?: number ;
  rows_gte?: number ;
  columns?: number ;
  columns_not?: number ;
  columns_in?: number[] ;
  columns_not_in?: number[] ;
  columns_lt?: number ;
  columns_lte?: number ;
  columns_gt?: number ;
  columns_gte?: number ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  AND?: PageScalarWhereInput[] ;
  OR?: PageScalarWhereInput[] ;
  NOT?: PageScalarWhereInput[] ;
}

export interface PageUpdateInput {
  name?: TranslatedStringUpdateOneRequiredWithoutPageInput ;
  rows?: number ;
  columns?: number ;
  deleted?: boolean ;
  category?: PosCategoryUpdateOneWithoutPageInput ;
  buttons?: PageUpdatebuttonsInput ;
  company?: CompanyUpdateOneRequiredWithoutPagesInput ;
}

export interface PageUpdateManyDataInput {
  rows?: number ;
  columns?: number ;
  deleted?: boolean ;
  buttons?: PageUpdatebuttonsInput ;
}

export interface PageUpdateManyWithWhereNestedInput {
  where: PageScalarWhereInput;
  data: PageUpdateManyDataInput;
}

export interface PageUpdateManyWithoutCompanyInput {
  create?: PageCreateWithoutCompanyInput[] ;
  connect?: PageWhereUniqueInput[] ;
  set?: PageWhereUniqueInput[] ;
  disconnect?: PageWhereUniqueInput[] ;
  update?: PageUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: PageUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: PageScalarWhereInput[] ;
  updateMany?: PageUpdateManyWithWhereNestedInput[] ;
}

export interface PageUpdateOneRequiredWithoutCategoryInput {
  create?: PageCreateWithoutCategoryInput ;
  update?: PageUpdateWithoutCategoryDataInput ;
  upsert?: PageUpsertWithoutCategoryInput ;
  connect?: PageWhereUniqueInput ;
}

export interface PageUpdateOneWithoutNameInput {
  create?: PageCreateWithoutNameInput ;
  update?: PageUpdateWithoutNameDataInput ;
  upsert?: PageUpsertWithoutNameInput ;
  disconnect?: boolean ;
  connect?: PageWhereUniqueInput ;
}

export interface PageUpdateWithWhereUniqueWithoutCompanyInput {
  where: PageWhereUniqueInput;
  data: PageUpdateWithoutCompanyDataInput;
}

export interface PageUpdateWithoutCategoryDataInput {
  name?: TranslatedStringUpdateOneRequiredWithoutPageInput ;
  rows?: number ;
  columns?: number ;
  deleted?: boolean ;
  buttons?: PageUpdatebuttonsInput ;
  company?: CompanyUpdateOneRequiredWithoutPagesInput ;
}

export interface PageUpdateWithoutCompanyDataInput {
  name?: TranslatedStringUpdateOneRequiredWithoutPageInput ;
  rows?: number ;
  columns?: number ;
  deleted?: boolean ;
  category?: PosCategoryUpdateOneWithoutPageInput ;
  buttons?: PageUpdatebuttonsInput ;
}

export interface PageUpdateWithoutNameDataInput {
  rows?: number ;
  columns?: number ;
  deleted?: boolean ;
  category?: PosCategoryUpdateOneWithoutPageInput ;
  buttons?: PageUpdatebuttonsInput ;
  company?: CompanyUpdateOneRequiredWithoutPagesInput ;
}

export interface PageUpdatebuttonsInput {
  set?: any[] ;
}

export interface PageUpsertWithWhereUniqueWithoutCompanyInput {
  where: PageWhereUniqueInput;
  update: PageUpdateWithoutCompanyDataInput;
  create: PageCreateWithoutCompanyInput;
}

export interface PageUpsertWithoutCategoryInput {
  update: PageUpdateWithoutCategoryDataInput;
  create: PageCreateWithoutCategoryInput;
}

export interface PageUpsertWithoutNameInput {
  update: PageUpdateWithoutNameDataInput;
  create: PageCreateWithoutNameInput;
}

export interface PageWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  name?: TranslatedStringWhereInput ;
  rows?: number ;
  rows_not?: number ;
  rows_in?: number[] ;
  rows_not_in?: number[] ;
  rows_lt?: number ;
  rows_lte?: number ;
  rows_gt?: number ;
  rows_gte?: number ;
  columns?: number ;
  columns_not?: number ;
  columns_in?: number[] ;
  columns_not_in?: number[] ;
  columns_lt?: number ;
  columns_lte?: number ;
  columns_gt?: number ;
  columns_gte?: number ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  category?: PosCategoryWhereInput ;
  company?: CompanyWhereInput ;
  AND?: PageWhereInput[] ;
  OR?: PageWhereInput[] ;
  NOT?: PageWhereInput[] ;
}

export interface PageWhereUniqueInput {
  id?: string ;
}

export interface PaymentCreateManyWithoutUserInput {
  create?: PaymentCreateWithoutUserInput[] ;
  connect?: PaymentWhereUniqueInput[] ;
}

export interface PaymentCreateOneWithoutCreditsTransactionsInput {
  create?: PaymentCreateWithoutCreditsTransactionsInput ;
  connect?: PaymentWhereUniqueInput ;
}

export interface PaymentCreateOneWithoutOrderInput {
  create?: PaymentCreateWithoutOrderInput ;
  connect?: PaymentWhereUniqueInput ;
}

export interface PaymentCreateOneWithoutPointsTransactionsInput {
  create?: PaymentCreateWithoutPointsTransactionsInput ;
  connect?: PaymentWhereUniqueInput ;
}

export interface PaymentCreateOneWithoutPosMetadataInput {
  create?: PaymentCreateWithoutPosMetadataInput ;
  connect?: PaymentWhereUniqueInput ;
}

export interface PaymentCreateOneWithoutTablePaymentInput {
  create?: PaymentCreateWithoutTablePaymentInput ;
  connect?: PaymentWhereUniqueInput ;
}

export interface PaymentCreateWithoutCreditsTransactionsInput {
  amount: number;
  pointsTransactions?: PointsTransactionCreateManyWithoutPaymentInput ;
  credits?: number ;
  yieldedCredits?: number ;
  tip?: number ;
  correctedTip?: number ;
  refunded?: number ;
  id?: string ;
  order?: OrderCreateOneWithoutPaymentInput ;
  status?: PAYMENT_STATUS ;
  user?: UserCreateOneWithoutPaymentsInput ;
  type?: string ;
  tablePayment?: TablePaymentSettingCreateOneWithoutPaymentInput ;
  posMetadata?: PosMetadataCreateOneWithoutPaymentInput ;
  transactionId?: string ;
  subPayments?: SubPaymentCreateManyWithoutPaymentInput ;
  transactions?: TransactionCreateManyWithoutPaymentInput ;
}

export interface PaymentCreateWithoutOrderInput {
  amount: number;
  pointsTransactions?: PointsTransactionCreateManyWithoutPaymentInput ;
  credits?: number ;
  creditsTransactions?: CreditsTransactionCreateManyWithoutPaymentInput ;
  yieldedCredits?: number ;
  tip?: number ;
  correctedTip?: number ;
  refunded?: number ;
  id?: string ;
  status?: PAYMENT_STATUS ;
  user?: UserCreateOneWithoutPaymentsInput ;
  type?: string ;
  tablePayment?: TablePaymentSettingCreateOneWithoutPaymentInput ;
  posMetadata?: PosMetadataCreateOneWithoutPaymentInput ;
  transactionId?: string ;
  subPayments?: SubPaymentCreateManyWithoutPaymentInput ;
  transactions?: TransactionCreateManyWithoutPaymentInput ;
}

export interface PaymentCreateWithoutPointsTransactionsInput {
  amount: number;
  credits?: number ;
  creditsTransactions?: CreditsTransactionCreateManyWithoutPaymentInput ;
  yieldedCredits?: number ;
  tip?: number ;
  correctedTip?: number ;
  refunded?: number ;
  id?: string ;
  order?: OrderCreateOneWithoutPaymentInput ;
  status?: PAYMENT_STATUS ;
  user?: UserCreateOneWithoutPaymentsInput ;
  type?: string ;
  tablePayment?: TablePaymentSettingCreateOneWithoutPaymentInput ;
  posMetadata?: PosMetadataCreateOneWithoutPaymentInput ;
  transactionId?: string ;
  subPayments?: SubPaymentCreateManyWithoutPaymentInput ;
  transactions?: TransactionCreateManyWithoutPaymentInput ;
}

export interface PaymentCreateWithoutPosMetadataInput {
  amount: number;
  pointsTransactions?: PointsTransactionCreateManyWithoutPaymentInput ;
  credits?: number ;
  creditsTransactions?: CreditsTransactionCreateManyWithoutPaymentInput ;
  yieldedCredits?: number ;
  tip?: number ;
  correctedTip?: number ;
  refunded?: number ;
  id?: string ;
  order?: OrderCreateOneWithoutPaymentInput ;
  status?: PAYMENT_STATUS ;
  user?: UserCreateOneWithoutPaymentsInput ;
  type?: string ;
  tablePayment?: TablePaymentSettingCreateOneWithoutPaymentInput ;
  transactionId?: string ;
  subPayments?: SubPaymentCreateManyWithoutPaymentInput ;
  transactions?: TransactionCreateManyWithoutPaymentInput ;
}

export interface PaymentCreateWithoutTablePaymentInput {
  amount: number;
  pointsTransactions?: PointsTransactionCreateManyWithoutPaymentInput ;
  credits?: number ;
  creditsTransactions?: CreditsTransactionCreateManyWithoutPaymentInput ;
  yieldedCredits?: number ;
  tip?: number ;
  correctedTip?: number ;
  refunded?: number ;
  id?: string ;
  order?: OrderCreateOneWithoutPaymentInput ;
  status?: PAYMENT_STATUS ;
  user?: UserCreateOneWithoutPaymentsInput ;
  type?: string ;
  posMetadata?: PosMetadataCreateOneWithoutPaymentInput ;
  transactionId?: string ;
  subPayments?: SubPaymentCreateManyWithoutPaymentInput ;
  transactions?: TransactionCreateManyWithoutPaymentInput ;
}

export interface PaymentCreateWithoutUserInput {
  amount: number;
  pointsTransactions?: PointsTransactionCreateManyWithoutPaymentInput ;
  credits?: number ;
  creditsTransactions?: CreditsTransactionCreateManyWithoutPaymentInput ;
  yieldedCredits?: number ;
  tip?: number ;
  correctedTip?: number ;
  refunded?: number ;
  id?: string ;
  order?: OrderCreateOneWithoutPaymentInput ;
  status?: PAYMENT_STATUS ;
  type?: string ;
  tablePayment?: TablePaymentSettingCreateOneWithoutPaymentInput ;
  posMetadata?: PosMetadataCreateOneWithoutPaymentInput ;
  transactionId?: string ;
  subPayments?: SubPaymentCreateManyWithoutPaymentInput ;
  transactions?: TransactionCreateManyWithoutPaymentInput ;
}

export interface PaymentMethodCreateInput {
  id?: string ;
  internalId: string;
  name: string;
  default?: boolean ;
  deleted?: boolean ;
  company: CompanyCreateOneWithoutPaymentMethodsInput;
  venue?: VenueCreateOneWithoutPaymentMethodsInput ;
}

export interface PaymentMethodCreateManyWithoutCompanyInput {
  create?: PaymentMethodCreateWithoutCompanyInput[] ;
  connect?: PaymentMethodWhereUniqueInput[] ;
}

export interface PaymentMethodCreateManyWithoutVenueInput {
  create?: PaymentMethodCreateWithoutVenueInput[] ;
  connect?: PaymentMethodWhereUniqueInput[] ;
}

export interface PaymentMethodCreateWithoutCompanyInput {
  id?: string ;
  internalId: string;
  name: string;
  default?: boolean ;
  deleted?: boolean ;
  venue?: VenueCreateOneWithoutPaymentMethodsInput ;
}

export interface PaymentMethodCreateWithoutVenueInput {
  id?: string ;
  internalId: string;
  name: string;
  default?: boolean ;
  deleted?: boolean ;
  company: CompanyCreateOneWithoutPaymentMethodsInput;
}

export interface PaymentMethodScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  internalId?: string ;
  internalId_not?: string ;
  internalId_in?: string[] ;
  internalId_not_in?: string[] ;
  internalId_lt?: string ;
  internalId_lte?: string ;
  internalId_gt?: string ;
  internalId_gte?: string ;
  internalId_contains?: string ;
  internalId_not_contains?: string ;
  internalId_starts_with?: string ;
  internalId_not_starts_with?: string ;
  internalId_ends_with?: string ;
  internalId_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  default?: boolean ;
  default_not?: boolean ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  AND?: PaymentMethodScalarWhereInput[] ;
  OR?: PaymentMethodScalarWhereInput[] ;
  NOT?: PaymentMethodScalarWhereInput[] ;
}

export interface PaymentMethodUpdateInput {
  internalId?: string ;
  name?: string ;
  default?: boolean ;
  deleted?: boolean ;
  company?: CompanyUpdateOneRequiredWithoutPaymentMethodsInput ;
  venue?: VenueUpdateOneWithoutPaymentMethodsInput ;
}

export interface PaymentMethodUpdateManyDataInput {
  internalId?: string ;
  name?: string ;
  default?: boolean ;
  deleted?: boolean ;
}

export interface PaymentMethodUpdateManyWithWhereNestedInput {
  where: PaymentMethodScalarWhereInput;
  data: PaymentMethodUpdateManyDataInput;
}

export interface PaymentMethodUpdateManyWithoutCompanyInput {
  create?: PaymentMethodCreateWithoutCompanyInput[] ;
  connect?: PaymentMethodWhereUniqueInput[] ;
  set?: PaymentMethodWhereUniqueInput[] ;
  disconnect?: PaymentMethodWhereUniqueInput[] ;
  update?: PaymentMethodUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: PaymentMethodUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: PaymentMethodScalarWhereInput[] ;
  updateMany?: PaymentMethodUpdateManyWithWhereNestedInput[] ;
}

export interface PaymentMethodUpdateManyWithoutVenueInput {
  create?: PaymentMethodCreateWithoutVenueInput[] ;
  connect?: PaymentMethodWhereUniqueInput[] ;
  set?: PaymentMethodWhereUniqueInput[] ;
  disconnect?: PaymentMethodWhereUniqueInput[] ;
  update?: PaymentMethodUpdateWithWhereUniqueWithoutVenueInput[] ;
  upsert?: PaymentMethodUpsertWithWhereUniqueWithoutVenueInput[] ;
  deleteMany?: PaymentMethodScalarWhereInput[] ;
  updateMany?: PaymentMethodUpdateManyWithWhereNestedInput[] ;
}

export interface PaymentMethodUpdateWithWhereUniqueWithoutCompanyInput {
  where: PaymentMethodWhereUniqueInput;
  data: PaymentMethodUpdateWithoutCompanyDataInput;
}

export interface PaymentMethodUpdateWithWhereUniqueWithoutVenueInput {
  where: PaymentMethodWhereUniqueInput;
  data: PaymentMethodUpdateWithoutVenueDataInput;
}

export interface PaymentMethodUpdateWithoutCompanyDataInput {
  internalId?: string ;
  name?: string ;
  default?: boolean ;
  deleted?: boolean ;
  venue?: VenueUpdateOneWithoutPaymentMethodsInput ;
}

export interface PaymentMethodUpdateWithoutVenueDataInput {
  internalId?: string ;
  name?: string ;
  default?: boolean ;
  deleted?: boolean ;
  company?: CompanyUpdateOneRequiredWithoutPaymentMethodsInput ;
}

export interface PaymentMethodUpsertWithWhereUniqueWithoutCompanyInput {
  where: PaymentMethodWhereUniqueInput;
  update: PaymentMethodUpdateWithoutCompanyDataInput;
  create: PaymentMethodCreateWithoutCompanyInput;
}

export interface PaymentMethodUpsertWithWhereUniqueWithoutVenueInput {
  where: PaymentMethodWhereUniqueInput;
  update: PaymentMethodUpdateWithoutVenueDataInput;
  create: PaymentMethodCreateWithoutVenueInput;
}

export interface PaymentMethodWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  internalId?: string ;
  internalId_not?: string ;
  internalId_in?: string[] ;
  internalId_not_in?: string[] ;
  internalId_lt?: string ;
  internalId_lte?: string ;
  internalId_gt?: string ;
  internalId_gte?: string ;
  internalId_contains?: string ;
  internalId_not_contains?: string ;
  internalId_starts_with?: string ;
  internalId_not_starts_with?: string ;
  internalId_ends_with?: string ;
  internalId_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  default?: boolean ;
  default_not?: boolean ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  company?: CompanyWhereInput ;
  venue?: VenueWhereInput ;
  AND?: PaymentMethodWhereInput[] ;
  OR?: PaymentMethodWhereInput[] ;
  NOT?: PaymentMethodWhereInput[] ;
}

export interface PaymentMethodWhereUniqueInput {
  id?: string ;
}

export interface PaymentScalarWhereInput {
  amount?: number ;
  amount_not?: number ;
  amount_in?: number[] ;
  amount_not_in?: number[] ;
  amount_lt?: number ;
  amount_lte?: number ;
  amount_gt?: number ;
  amount_gte?: number ;
  credits?: number ;
  credits_not?: number ;
  credits_in?: number[] ;
  credits_not_in?: number[] ;
  credits_lt?: number ;
  credits_lte?: number ;
  credits_gt?: number ;
  credits_gte?: number ;
  yieldedCredits?: number ;
  yieldedCredits_not?: number ;
  yieldedCredits_in?: number[] ;
  yieldedCredits_not_in?: number[] ;
  yieldedCredits_lt?: number ;
  yieldedCredits_lte?: number ;
  yieldedCredits_gt?: number ;
  yieldedCredits_gte?: number ;
  tip?: number ;
  tip_not?: number ;
  tip_in?: number[] ;
  tip_not_in?: number[] ;
  tip_lt?: number ;
  tip_lte?: number ;
  tip_gt?: number ;
  tip_gte?: number ;
  correctedTip?: number ;
  correctedTip_not?: number ;
  correctedTip_in?: number[] ;
  correctedTip_not_in?: number[] ;
  correctedTip_lt?: number ;
  correctedTip_lte?: number ;
  correctedTip_gt?: number ;
  correctedTip_gte?: number ;
  refunded?: number ;
  refunded_not?: number ;
  refunded_in?: number[] ;
  refunded_not_in?: number[] ;
  refunded_lt?: number ;
  refunded_lte?: number ;
  refunded_gt?: number ;
  refunded_gte?: number ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  status?: PAYMENT_STATUS ;
  status_not?: PAYMENT_STATUS ;
  status_in?: PAYMENT_STATUS[] ;
  status_not_in?: PAYMENT_STATUS[] ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  type?: string ;
  type_not?: string ;
  type_in?: string[] ;
  type_not_in?: string[] ;
  type_lt?: string ;
  type_lte?: string ;
  type_gt?: string ;
  type_gte?: string ;
  type_contains?: string ;
  type_not_contains?: string ;
  type_starts_with?: string ;
  type_not_starts_with?: string ;
  type_ends_with?: string ;
  type_not_ends_with?: string ;
  transactionId?: string ;
  transactionId_not?: string ;
  transactionId_in?: string[] ;
  transactionId_not_in?: string[] ;
  transactionId_lt?: string ;
  transactionId_lte?: string ;
  transactionId_gt?: string ;
  transactionId_gte?: string ;
  transactionId_contains?: string ;
  transactionId_not_contains?: string ;
  transactionId_starts_with?: string ;
  transactionId_not_starts_with?: string ;
  transactionId_ends_with?: string ;
  transactionId_not_ends_with?: string ;
  AND?: PaymentScalarWhereInput[] ;
  OR?: PaymentScalarWhereInput[] ;
  NOT?: PaymentScalarWhereInput[] ;
}

export interface PaymentUpdateManyDataInput {
  amount?: number ;
  credits?: number ;
  yieldedCredits?: number ;
  tip?: number ;
  correctedTip?: number ;
  refunded?: number ;
  status?: PAYMENT_STATUS ;
  type?: string ;
  transactionId?: string ;
}

export interface PaymentUpdateManyWithWhereNestedInput {
  where: PaymentScalarWhereInput;
  data: PaymentUpdateManyDataInput;
}

export interface PaymentUpdateManyWithoutUserInput {
  create?: PaymentCreateWithoutUserInput[] ;
  connect?: PaymentWhereUniqueInput[] ;
  set?: PaymentWhereUniqueInput[] ;
  disconnect?: PaymentWhereUniqueInput[] ;
  update?: PaymentUpdateWithWhereUniqueWithoutUserInput[] ;
  upsert?: PaymentUpsertWithWhereUniqueWithoutUserInput[] ;
  deleteMany?: PaymentScalarWhereInput[] ;
  updateMany?: PaymentUpdateManyWithWhereNestedInput[] ;
}

export interface PaymentUpdateOneRequiredWithoutPosMetadataInput {
  create?: PaymentCreateWithoutPosMetadataInput ;
  update?: PaymentUpdateWithoutPosMetadataDataInput ;
  upsert?: PaymentUpsertWithoutPosMetadataInput ;
  connect?: PaymentWhereUniqueInput ;
}

export interface PaymentUpdateOneWithoutCreditsTransactionsInput {
  create?: PaymentCreateWithoutCreditsTransactionsInput ;
  update?: PaymentUpdateWithoutCreditsTransactionsDataInput ;
  upsert?: PaymentUpsertWithoutCreditsTransactionsInput ;
  disconnect?: boolean ;
  connect?: PaymentWhereUniqueInput ;
}

export interface PaymentUpdateOneWithoutOrderInput {
  create?: PaymentCreateWithoutOrderInput ;
  update?: PaymentUpdateWithoutOrderDataInput ;
  upsert?: PaymentUpsertWithoutOrderInput ;
  disconnect?: boolean ;
  connect?: PaymentWhereUniqueInput ;
}

export interface PaymentUpdateOneWithoutPointsTransactionsInput {
  create?: PaymentCreateWithoutPointsTransactionsInput ;
  update?: PaymentUpdateWithoutPointsTransactionsDataInput ;
  upsert?: PaymentUpsertWithoutPointsTransactionsInput ;
  disconnect?: boolean ;
  connect?: PaymentWhereUniqueInput ;
}

export interface PaymentUpdateOneWithoutTablePaymentInput {
  create?: PaymentCreateWithoutTablePaymentInput ;
  update?: PaymentUpdateWithoutTablePaymentDataInput ;
  upsert?: PaymentUpsertWithoutTablePaymentInput ;
  disconnect?: boolean ;
  connect?: PaymentWhereUniqueInput ;
}

export interface PaymentUpdateWithWhereUniqueWithoutUserInput {
  where: PaymentWhereUniqueInput;
  data: PaymentUpdateWithoutUserDataInput;
}

export interface PaymentUpdateWithoutCreditsTransactionsDataInput {
  amount?: number ;
  pointsTransactions?: PointsTransactionUpdateManyWithoutPaymentInput ;
  credits?: number ;
  yieldedCredits?: number ;
  tip?: number ;
  correctedTip?: number ;
  refunded?: number ;
  order?: OrderUpdateOneWithoutPaymentInput ;
  status?: PAYMENT_STATUS ;
  user?: UserUpdateOneWithoutPaymentsInput ;
  type?: string ;
  tablePayment?: TablePaymentSettingUpdateOneWithoutPaymentInput ;
  posMetadata?: PosMetadataUpdateOneWithoutPaymentInput ;
  transactionId?: string ;
  subPayments?: SubPaymentUpdateManyWithoutPaymentInput ;
  transactions?: TransactionUpdateManyWithoutPaymentInput ;
}

export interface PaymentUpdateWithoutOrderDataInput {
  amount?: number ;
  pointsTransactions?: PointsTransactionUpdateManyWithoutPaymentInput ;
  credits?: number ;
  creditsTransactions?: CreditsTransactionUpdateManyWithoutPaymentInput ;
  yieldedCredits?: number ;
  tip?: number ;
  correctedTip?: number ;
  refunded?: number ;
  status?: PAYMENT_STATUS ;
  user?: UserUpdateOneWithoutPaymentsInput ;
  type?: string ;
  tablePayment?: TablePaymentSettingUpdateOneWithoutPaymentInput ;
  posMetadata?: PosMetadataUpdateOneWithoutPaymentInput ;
  transactionId?: string ;
  subPayments?: SubPaymentUpdateManyWithoutPaymentInput ;
  transactions?: TransactionUpdateManyWithoutPaymentInput ;
}

export interface PaymentUpdateWithoutPointsTransactionsDataInput {
  amount?: number ;
  credits?: number ;
  creditsTransactions?: CreditsTransactionUpdateManyWithoutPaymentInput ;
  yieldedCredits?: number ;
  tip?: number ;
  correctedTip?: number ;
  refunded?: number ;
  order?: OrderUpdateOneWithoutPaymentInput ;
  status?: PAYMENT_STATUS ;
  user?: UserUpdateOneWithoutPaymentsInput ;
  type?: string ;
  tablePayment?: TablePaymentSettingUpdateOneWithoutPaymentInput ;
  posMetadata?: PosMetadataUpdateOneWithoutPaymentInput ;
  transactionId?: string ;
  subPayments?: SubPaymentUpdateManyWithoutPaymentInput ;
  transactions?: TransactionUpdateManyWithoutPaymentInput ;
}

export interface PaymentUpdateWithoutPosMetadataDataInput {
  amount?: number ;
  pointsTransactions?: PointsTransactionUpdateManyWithoutPaymentInput ;
  credits?: number ;
  creditsTransactions?: CreditsTransactionUpdateManyWithoutPaymentInput ;
  yieldedCredits?: number ;
  tip?: number ;
  correctedTip?: number ;
  refunded?: number ;
  order?: OrderUpdateOneWithoutPaymentInput ;
  status?: PAYMENT_STATUS ;
  user?: UserUpdateOneWithoutPaymentsInput ;
  type?: string ;
  tablePayment?: TablePaymentSettingUpdateOneWithoutPaymentInput ;
  transactionId?: string ;
  subPayments?: SubPaymentUpdateManyWithoutPaymentInput ;
  transactions?: TransactionUpdateManyWithoutPaymentInput ;
}

export interface PaymentUpdateWithoutTablePaymentDataInput {
  amount?: number ;
  pointsTransactions?: PointsTransactionUpdateManyWithoutPaymentInput ;
  credits?: number ;
  creditsTransactions?: CreditsTransactionUpdateManyWithoutPaymentInput ;
  yieldedCredits?: number ;
  tip?: number ;
  correctedTip?: number ;
  refunded?: number ;
  order?: OrderUpdateOneWithoutPaymentInput ;
  status?: PAYMENT_STATUS ;
  user?: UserUpdateOneWithoutPaymentsInput ;
  type?: string ;
  posMetadata?: PosMetadataUpdateOneWithoutPaymentInput ;
  transactionId?: string ;
  subPayments?: SubPaymentUpdateManyWithoutPaymentInput ;
  transactions?: TransactionUpdateManyWithoutPaymentInput ;
}

export interface PaymentUpdateWithoutUserDataInput {
  amount?: number ;
  pointsTransactions?: PointsTransactionUpdateManyWithoutPaymentInput ;
  credits?: number ;
  creditsTransactions?: CreditsTransactionUpdateManyWithoutPaymentInput ;
  yieldedCredits?: number ;
  tip?: number ;
  correctedTip?: number ;
  refunded?: number ;
  order?: OrderUpdateOneWithoutPaymentInput ;
  status?: PAYMENT_STATUS ;
  type?: string ;
  tablePayment?: TablePaymentSettingUpdateOneWithoutPaymentInput ;
  posMetadata?: PosMetadataUpdateOneWithoutPaymentInput ;
  transactionId?: string ;
  subPayments?: SubPaymentUpdateManyWithoutPaymentInput ;
  transactions?: TransactionUpdateManyWithoutPaymentInput ;
}

export interface PaymentUpsertWithWhereUniqueWithoutUserInput {
  where: PaymentWhereUniqueInput;
  update: PaymentUpdateWithoutUserDataInput;
  create: PaymentCreateWithoutUserInput;
}

export interface PaymentUpsertWithoutCreditsTransactionsInput {
  update: PaymentUpdateWithoutCreditsTransactionsDataInput;
  create: PaymentCreateWithoutCreditsTransactionsInput;
}

export interface PaymentUpsertWithoutOrderInput {
  update: PaymentUpdateWithoutOrderDataInput;
  create: PaymentCreateWithoutOrderInput;
}

export interface PaymentUpsertWithoutPointsTransactionsInput {
  update: PaymentUpdateWithoutPointsTransactionsDataInput;
  create: PaymentCreateWithoutPointsTransactionsInput;
}

export interface PaymentUpsertWithoutPosMetadataInput {
  update: PaymentUpdateWithoutPosMetadataDataInput;
  create: PaymentCreateWithoutPosMetadataInput;
}

export interface PaymentUpsertWithoutTablePaymentInput {
  update: PaymentUpdateWithoutTablePaymentDataInput;
  create: PaymentCreateWithoutTablePaymentInput;
}

export interface PaymentWhereInput {
  amount?: number ;
  amount_not?: number ;
  amount_in?: number[] ;
  amount_not_in?: number[] ;
  amount_lt?: number ;
  amount_lte?: number ;
  amount_gt?: number ;
  amount_gte?: number ;
  pointsTransactions_every?: PointsTransactionWhereInput ;
  pointsTransactions_some?: PointsTransactionWhereInput ;
  pointsTransactions_none?: PointsTransactionWhereInput ;
  credits?: number ;
  credits_not?: number ;
  credits_in?: number[] ;
  credits_not_in?: number[] ;
  credits_lt?: number ;
  credits_lte?: number ;
  credits_gt?: number ;
  credits_gte?: number ;
  creditsTransactions_every?: CreditsTransactionWhereInput ;
  creditsTransactions_some?: CreditsTransactionWhereInput ;
  creditsTransactions_none?: CreditsTransactionWhereInput ;
  yieldedCredits?: number ;
  yieldedCredits_not?: number ;
  yieldedCredits_in?: number[] ;
  yieldedCredits_not_in?: number[] ;
  yieldedCredits_lt?: number ;
  yieldedCredits_lte?: number ;
  yieldedCredits_gt?: number ;
  yieldedCredits_gte?: number ;
  tip?: number ;
  tip_not?: number ;
  tip_in?: number[] ;
  tip_not_in?: number[] ;
  tip_lt?: number ;
  tip_lte?: number ;
  tip_gt?: number ;
  tip_gte?: number ;
  correctedTip?: number ;
  correctedTip_not?: number ;
  correctedTip_in?: number[] ;
  correctedTip_not_in?: number[] ;
  correctedTip_lt?: number ;
  correctedTip_lte?: number ;
  correctedTip_gt?: number ;
  correctedTip_gte?: number ;
  refunded?: number ;
  refunded_not?: number ;
  refunded_in?: number[] ;
  refunded_not_in?: number[] ;
  refunded_lt?: number ;
  refunded_lte?: number ;
  refunded_gt?: number ;
  refunded_gte?: number ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  order?: OrderWhereInput ;
  status?: PAYMENT_STATUS ;
  status_not?: PAYMENT_STATUS ;
  status_in?: PAYMENT_STATUS[] ;
  status_not_in?: PAYMENT_STATUS[] ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  user?: UserWhereInput ;
  type?: string ;
  type_not?: string ;
  type_in?: string[] ;
  type_not_in?: string[] ;
  type_lt?: string ;
  type_lte?: string ;
  type_gt?: string ;
  type_gte?: string ;
  type_contains?: string ;
  type_not_contains?: string ;
  type_starts_with?: string ;
  type_not_starts_with?: string ;
  type_ends_with?: string ;
  type_not_ends_with?: string ;
  tablePayment?: TablePaymentSettingWhereInput ;
  posMetadata?: PosMetadataWhereInput ;
  transactionId?: string ;
  transactionId_not?: string ;
  transactionId_in?: string[] ;
  transactionId_not_in?: string[] ;
  transactionId_lt?: string ;
  transactionId_lte?: string ;
  transactionId_gt?: string ;
  transactionId_gte?: string ;
  transactionId_contains?: string ;
  transactionId_not_contains?: string ;
  transactionId_starts_with?: string ;
  transactionId_not_starts_with?: string ;
  transactionId_ends_with?: string ;
  transactionId_not_ends_with?: string ;
  subPayments_every?: SubPaymentWhereInput ;
  subPayments_some?: SubPaymentWhereInput ;
  subPayments_none?: SubPaymentWhereInput ;
  transactions_every?: TransactionWhereInput ;
  transactions_some?: TransactionWhereInput ;
  transactions_none?: TransactionWhereInput ;
  AND?: PaymentWhereInput[] ;
  OR?: PaymentWhereInput[] ;
  NOT?: PaymentWhereInput[] ;
}

export interface PaymentWhereUniqueInput {
  id?: string ;
}

export interface PointsTransactionCreateManyWithoutMembershipCardInput {
  create?: PointsTransactionCreateWithoutMembershipCardInput[] ;
  connect?: PointsTransactionWhereUniqueInput[] ;
}

export interface PointsTransactionCreateManyWithoutPaymentInput {
  create?: PointsTransactionCreateWithoutPaymentInput[] ;
  connect?: PointsTransactionWhereUniqueInput[] ;
}

export interface PointsTransactionCreateOneWithoutScanInput {
  create?: PointsTransactionCreateWithoutScanInput ;
  connect?: PointsTransactionWhereUniqueInput ;
}

export interface PointsTransactionCreateWithoutMembershipCardInput {
  id?: string ;
  amount: number;
  payment?: PaymentCreateOneWithoutPointsTransactionsInput ;
  scan?: ReceiptPointsScanCreateOneWithoutPointsTransactionInput ;
  source: POINTS_SOURCE_TYPE;
}

export interface PointsTransactionCreateWithoutPaymentInput {
  id?: string ;
  amount: number;
  membershipCard: MembershipCardCreateOneWithoutPointsTransactionsInput;
  scan?: ReceiptPointsScanCreateOneWithoutPointsTransactionInput ;
  source: POINTS_SOURCE_TYPE;
}

export interface PointsTransactionCreateWithoutScanInput {
  id?: string ;
  amount: number;
  membershipCard: MembershipCardCreateOneWithoutPointsTransactionsInput;
  payment?: PaymentCreateOneWithoutPointsTransactionsInput ;
  source: POINTS_SOURCE_TYPE;
}

export interface PointsTransactionScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  amount?: number ;
  amount_not?: number ;
  amount_in?: number[] ;
  amount_not_in?: number[] ;
  amount_lt?: number ;
  amount_lte?: number ;
  amount_gt?: number ;
  amount_gte?: number ;
  source?: POINTS_SOURCE_TYPE ;
  source_not?: POINTS_SOURCE_TYPE ;
  source_in?: POINTS_SOURCE_TYPE[] ;
  source_not_in?: POINTS_SOURCE_TYPE[] ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  AND?: PointsTransactionScalarWhereInput[] ;
  OR?: PointsTransactionScalarWhereInput[] ;
  NOT?: PointsTransactionScalarWhereInput[] ;
}

export interface PointsTransactionUpdateManyDataInput {
  amount?: number ;
  source?: POINTS_SOURCE_TYPE ;
}

export interface PointsTransactionUpdateManyWithWhereNestedInput {
  where: PointsTransactionScalarWhereInput;
  data: PointsTransactionUpdateManyDataInput;
}

export interface PointsTransactionUpdateManyWithoutMembershipCardInput {
  create?: PointsTransactionCreateWithoutMembershipCardInput[] ;
  connect?: PointsTransactionWhereUniqueInput[] ;
  set?: PointsTransactionWhereUniqueInput[] ;
  disconnect?: PointsTransactionWhereUniqueInput[] ;
  update?: PointsTransactionUpdateWithWhereUniqueWithoutMembershipCardInput[] ;
  upsert?: PointsTransactionUpsertWithWhereUniqueWithoutMembershipCardInput[] ;
  deleteMany?: PointsTransactionScalarWhereInput[] ;
  updateMany?: PointsTransactionUpdateManyWithWhereNestedInput[] ;
}

export interface PointsTransactionUpdateManyWithoutPaymentInput {
  create?: PointsTransactionCreateWithoutPaymentInput[] ;
  connect?: PointsTransactionWhereUniqueInput[] ;
  set?: PointsTransactionWhereUniqueInput[] ;
  disconnect?: PointsTransactionWhereUniqueInput[] ;
  update?: PointsTransactionUpdateWithWhereUniqueWithoutPaymentInput[] ;
  upsert?: PointsTransactionUpsertWithWhereUniqueWithoutPaymentInput[] ;
  deleteMany?: PointsTransactionScalarWhereInput[] ;
  updateMany?: PointsTransactionUpdateManyWithWhereNestedInput[] ;
}

export interface PointsTransactionUpdateOneWithoutScanInput {
  create?: PointsTransactionCreateWithoutScanInput ;
  update?: PointsTransactionUpdateWithoutScanDataInput ;
  upsert?: PointsTransactionUpsertWithoutScanInput ;
  disconnect?: boolean ;
  connect?: PointsTransactionWhereUniqueInput ;
}

export interface PointsTransactionUpdateWithWhereUniqueWithoutMembershipCardInput {
  where: PointsTransactionWhereUniqueInput;
  data: PointsTransactionUpdateWithoutMembershipCardDataInput;
}

export interface PointsTransactionUpdateWithWhereUniqueWithoutPaymentInput {
  where: PointsTransactionWhereUniqueInput;
  data: PointsTransactionUpdateWithoutPaymentDataInput;
}

export interface PointsTransactionUpdateWithoutMembershipCardDataInput {
  amount?: number ;
  payment?: PaymentUpdateOneWithoutPointsTransactionsInput ;
  scan?: ReceiptPointsScanUpdateOneWithoutPointsTransactionInput ;
  source?: POINTS_SOURCE_TYPE ;
}

export interface PointsTransactionUpdateWithoutPaymentDataInput {
  amount?: number ;
  membershipCard?: MembershipCardUpdateOneRequiredWithoutPointsTransactionsInput ;
  scan?: ReceiptPointsScanUpdateOneWithoutPointsTransactionInput ;
  source?: POINTS_SOURCE_TYPE ;
}

export interface PointsTransactionUpdateWithoutScanDataInput {
  amount?: number ;
  membershipCard?: MembershipCardUpdateOneRequiredWithoutPointsTransactionsInput ;
  payment?: PaymentUpdateOneWithoutPointsTransactionsInput ;
  source?: POINTS_SOURCE_TYPE ;
}

export interface PointsTransactionUpsertWithWhereUniqueWithoutMembershipCardInput {
  where: PointsTransactionWhereUniqueInput;
  update: PointsTransactionUpdateWithoutMembershipCardDataInput;
  create: PointsTransactionCreateWithoutMembershipCardInput;
}

export interface PointsTransactionUpsertWithWhereUniqueWithoutPaymentInput {
  where: PointsTransactionWhereUniqueInput;
  update: PointsTransactionUpdateWithoutPaymentDataInput;
  create: PointsTransactionCreateWithoutPaymentInput;
}

export interface PointsTransactionUpsertWithoutScanInput {
  update: PointsTransactionUpdateWithoutScanDataInput;
  create: PointsTransactionCreateWithoutScanInput;
}

export interface PointsTransactionWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  amount?: number ;
  amount_not?: number ;
  amount_in?: number[] ;
  amount_not_in?: number[] ;
  amount_lt?: number ;
  amount_lte?: number ;
  amount_gt?: number ;
  amount_gte?: number ;
  membershipCard?: MembershipCardWhereInput ;
  payment?: PaymentWhereInput ;
  scan?: ReceiptPointsScanWhereInput ;
  source?: POINTS_SOURCE_TYPE ;
  source_not?: POINTS_SOURCE_TYPE ;
  source_in?: POINTS_SOURCE_TYPE[] ;
  source_not_in?: POINTS_SOURCE_TYPE[] ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  AND?: PointsTransactionWhereInput[] ;
  OR?: PointsTransactionWhereInput[] ;
  NOT?: PointsTransactionWhereInput[] ;
}

export interface PointsTransactionWhereUniqueInput {
  id?: string ;
}

export interface PosCategoryCreateInput {
  id?: string ;
  name: TranslatedStringCreateOneWithoutPosCategoryInput;
  layout: LayoutCreateOneWithoutCategoriesInput;
  color?: string ;
  order?: number ;
  deleted?: boolean ;
  page: PageCreateOneWithoutCategoryInput;
  company: CompanyCreateOneWithoutPosCategoriesInput;
}

export interface PosCategoryCreateManyWithoutCompanyInput {
  create?: PosCategoryCreateWithoutCompanyInput[] ;
  connect?: PosCategoryWhereUniqueInput[] ;
}

export interface PosCategoryCreateManyWithoutLayoutInput {
  create?: PosCategoryCreateWithoutLayoutInput[] ;
  connect?: PosCategoryWhereUniqueInput[] ;
}

export interface PosCategoryCreateOneWithoutNameInput {
  create?: PosCategoryCreateWithoutNameInput ;
  connect?: PosCategoryWhereUniqueInput ;
}

export interface PosCategoryCreateOneWithoutPageInput {
  create?: PosCategoryCreateWithoutPageInput ;
  connect?: PosCategoryWhereUniqueInput ;
}

export interface PosCategoryCreateWithoutCompanyInput {
  id?: string ;
  name: TranslatedStringCreateOneWithoutPosCategoryInput;
  layout: LayoutCreateOneWithoutCategoriesInput;
  color?: string ;
  order?: number ;
  deleted?: boolean ;
  page: PageCreateOneWithoutCategoryInput;
}

export interface PosCategoryCreateWithoutLayoutInput {
  id?: string ;
  name: TranslatedStringCreateOneWithoutPosCategoryInput;
  color?: string ;
  order?: number ;
  deleted?: boolean ;
  page: PageCreateOneWithoutCategoryInput;
  company: CompanyCreateOneWithoutPosCategoriesInput;
}

export interface PosCategoryCreateWithoutNameInput {
  id?: string ;
  layout: LayoutCreateOneWithoutCategoriesInput;
  color?: string ;
  order?: number ;
  deleted?: boolean ;
  page: PageCreateOneWithoutCategoryInput;
  company: CompanyCreateOneWithoutPosCategoriesInput;
}

export interface PosCategoryCreateWithoutPageInput {
  id?: string ;
  name: TranslatedStringCreateOneWithoutPosCategoryInput;
  layout: LayoutCreateOneWithoutCategoriesInput;
  color?: string ;
  order?: number ;
  deleted?: boolean ;
  company: CompanyCreateOneWithoutPosCategoriesInput;
}

export interface PosCategoryScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  color?: string ;
  color_not?: string ;
  color_in?: string[] ;
  color_not_in?: string[] ;
  color_lt?: string ;
  color_lte?: string ;
  color_gt?: string ;
  color_gte?: string ;
  color_contains?: string ;
  color_not_contains?: string ;
  color_starts_with?: string ;
  color_not_starts_with?: string ;
  color_ends_with?: string ;
  color_not_ends_with?: string ;
  order?: number ;
  order_not?: number ;
  order_in?: number[] ;
  order_not_in?: number[] ;
  order_lt?: number ;
  order_lte?: number ;
  order_gt?: number ;
  order_gte?: number ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  AND?: PosCategoryScalarWhereInput[] ;
  OR?: PosCategoryScalarWhereInput[] ;
  NOT?: PosCategoryScalarWhereInput[] ;
}

export interface PosCategoryUpdateInput {
  name?: TranslatedStringUpdateOneRequiredWithoutPosCategoryInput ;
  layout?: LayoutUpdateOneRequiredWithoutCategoriesInput ;
  color?: string ;
  order?: number ;
  deleted?: boolean ;
  page?: PageUpdateOneRequiredWithoutCategoryInput ;
  company?: CompanyUpdateOneRequiredWithoutPosCategoriesInput ;
}

export interface PosCategoryUpdateManyDataInput {
  color?: string ;
  order?: number ;
  deleted?: boolean ;
}

export interface PosCategoryUpdateManyWithWhereNestedInput {
  where: PosCategoryScalarWhereInput;
  data: PosCategoryUpdateManyDataInput;
}

export interface PosCategoryUpdateManyWithoutCompanyInput {
  create?: PosCategoryCreateWithoutCompanyInput[] ;
  connect?: PosCategoryWhereUniqueInput[] ;
  set?: PosCategoryWhereUniqueInput[] ;
  disconnect?: PosCategoryWhereUniqueInput[] ;
  update?: PosCategoryUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: PosCategoryUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: PosCategoryScalarWhereInput[] ;
  updateMany?: PosCategoryUpdateManyWithWhereNestedInput[] ;
}

export interface PosCategoryUpdateManyWithoutLayoutInput {
  create?: PosCategoryCreateWithoutLayoutInput[] ;
  connect?: PosCategoryWhereUniqueInput[] ;
  set?: PosCategoryWhereUniqueInput[] ;
  disconnect?: PosCategoryWhereUniqueInput[] ;
  update?: PosCategoryUpdateWithWhereUniqueWithoutLayoutInput[] ;
  upsert?: PosCategoryUpsertWithWhereUniqueWithoutLayoutInput[] ;
  deleteMany?: PosCategoryScalarWhereInput[] ;
  updateMany?: PosCategoryUpdateManyWithWhereNestedInput[] ;
}

export interface PosCategoryUpdateOneWithoutNameInput {
  create?: PosCategoryCreateWithoutNameInput ;
  update?: PosCategoryUpdateWithoutNameDataInput ;
  upsert?: PosCategoryUpsertWithoutNameInput ;
  disconnect?: boolean ;
  connect?: PosCategoryWhereUniqueInput ;
}

export interface PosCategoryUpdateOneWithoutPageInput {
  create?: PosCategoryCreateWithoutPageInput ;
  update?: PosCategoryUpdateWithoutPageDataInput ;
  upsert?: PosCategoryUpsertWithoutPageInput ;
  disconnect?: boolean ;
  connect?: PosCategoryWhereUniqueInput ;
}

export interface PosCategoryUpdateWithWhereUniqueWithoutCompanyInput {
  where: PosCategoryWhereUniqueInput;
  data: PosCategoryUpdateWithoutCompanyDataInput;
}

export interface PosCategoryUpdateWithWhereUniqueWithoutLayoutInput {
  where: PosCategoryWhereUniqueInput;
  data: PosCategoryUpdateWithoutLayoutDataInput;
}

export interface PosCategoryUpdateWithoutCompanyDataInput {
  name?: TranslatedStringUpdateOneRequiredWithoutPosCategoryInput ;
  layout?: LayoutUpdateOneRequiredWithoutCategoriesInput ;
  color?: string ;
  order?: number ;
  deleted?: boolean ;
  page?: PageUpdateOneRequiredWithoutCategoryInput ;
}

export interface PosCategoryUpdateWithoutLayoutDataInput {
  name?: TranslatedStringUpdateOneRequiredWithoutPosCategoryInput ;
  color?: string ;
  order?: number ;
  deleted?: boolean ;
  page?: PageUpdateOneRequiredWithoutCategoryInput ;
  company?: CompanyUpdateOneRequiredWithoutPosCategoriesInput ;
}

export interface PosCategoryUpdateWithoutNameDataInput {
  layout?: LayoutUpdateOneRequiredWithoutCategoriesInput ;
  color?: string ;
  order?: number ;
  deleted?: boolean ;
  page?: PageUpdateOneRequiredWithoutCategoryInput ;
  company?: CompanyUpdateOneRequiredWithoutPosCategoriesInput ;
}

export interface PosCategoryUpdateWithoutPageDataInput {
  name?: TranslatedStringUpdateOneRequiredWithoutPosCategoryInput ;
  layout?: LayoutUpdateOneRequiredWithoutCategoriesInput ;
  color?: string ;
  order?: number ;
  deleted?: boolean ;
  company?: CompanyUpdateOneRequiredWithoutPosCategoriesInput ;
}

export interface PosCategoryUpsertWithWhereUniqueWithoutCompanyInput {
  where: PosCategoryWhereUniqueInput;
  update: PosCategoryUpdateWithoutCompanyDataInput;
  create: PosCategoryCreateWithoutCompanyInput;
}

export interface PosCategoryUpsertWithWhereUniqueWithoutLayoutInput {
  where: PosCategoryWhereUniqueInput;
  update: PosCategoryUpdateWithoutLayoutDataInput;
  create: PosCategoryCreateWithoutLayoutInput;
}

export interface PosCategoryUpsertWithoutNameInput {
  update: PosCategoryUpdateWithoutNameDataInput;
  create: PosCategoryCreateWithoutNameInput;
}

export interface PosCategoryUpsertWithoutPageInput {
  update: PosCategoryUpdateWithoutPageDataInput;
  create: PosCategoryCreateWithoutPageInput;
}

export interface PosCategoryWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  name?: TranslatedStringWhereInput ;
  layout?: LayoutWhereInput ;
  color?: string ;
  color_not?: string ;
  color_in?: string[] ;
  color_not_in?: string[] ;
  color_lt?: string ;
  color_lte?: string ;
  color_gt?: string ;
  color_gte?: string ;
  color_contains?: string ;
  color_not_contains?: string ;
  color_starts_with?: string ;
  color_not_starts_with?: string ;
  color_ends_with?: string ;
  color_not_ends_with?: string ;
  order?: number ;
  order_not?: number ;
  order_in?: number[] ;
  order_not_in?: number[] ;
  order_lt?: number ;
  order_lte?: number ;
  order_gt?: number ;
  order_gte?: number ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  page?: PageWhereInput ;
  company?: CompanyWhereInput ;
  AND?: PosCategoryWhereInput[] ;
  OR?: PosCategoryWhereInput[] ;
  NOT?: PosCategoryWhereInput[] ;
}

export interface PosCategoryWhereUniqueInput {
  id?: string ;
}

export interface PosMetadataCreateOneWithoutPaymentInput {
  create?: PosMetadataCreateWithoutPaymentInput ;
  connect?: PosMetadataWhereUniqueInput ;
}

export interface PosMetadataCreateOneWithoutTableSessionInput {
  create?: PosMetadataCreateWithoutTableSessionInput ;
  connect?: PosMetadataWhereUniqueInput ;
}

export interface PosMetadataCreateOneWithoutVenueInput {
  create?: PosMetadataCreateWithoutVenueInput ;
  connect?: PosMetadataWhereUniqueInput ;
}

export interface PosMetadataCreateWithoutPaymentInput {
  id?: string ;
  waiterId?: string ;
  staffId?: string ;
  originalAmount: number;
  discounts?: PosMetadataDiscountCreateManyWithoutPosMetadataInput ;
  currency?: CURRENCY ;
  venue?: VenueCreateOneWithoutPosMetadataInput ;
  paidAmount?: number ;
  tip?: number ;
  surcharge?: number ;
  tableSession?: TableSessionCreateOneWithoutPosMetadataInput ;
  terminalTransactions?: TerminalTransactionCreateManyWithoutPosMetadataInput ;
}

export interface PosMetadataCreateWithoutTableSessionInput {
  id?: string ;
  waiterId?: string ;
  staffId?: string ;
  originalAmount: number;
  discounts?: PosMetadataDiscountCreateManyWithoutPosMetadataInput ;
  currency?: CURRENCY ;
  venue?: VenueCreateOneWithoutPosMetadataInput ;
  payment: PaymentCreateOneWithoutPosMetadataInput;
  paidAmount?: number ;
  tip?: number ;
  surcharge?: number ;
  terminalTransactions?: TerminalTransactionCreateManyWithoutPosMetadataInput ;
}

export interface PosMetadataCreateWithoutVenueInput {
  id?: string ;
  waiterId?: string ;
  staffId?: string ;
  originalAmount: number;
  discounts?: PosMetadataDiscountCreateManyWithoutPosMetadataInput ;
  currency?: CURRENCY ;
  payment: PaymentCreateOneWithoutPosMetadataInput;
  paidAmount?: number ;
  tip?: number ;
  surcharge?: number ;
  tableSession?: TableSessionCreateOneWithoutPosMetadataInput ;
  terminalTransactions?: TerminalTransactionCreateManyWithoutPosMetadataInput ;
}

export interface PosMetadataDiscountCreateManyWithoutPosMetadataInput {
  create?: PosMetadataDiscountCreateWithoutPosMetadataInput[] ;
  connect?: PosMetadataDiscountWhereUniqueInput[] ;
}

export interface PosMetadataDiscountCreateWithoutPosMetadataInput {
  id?: string ;
  source: POS_DISCOUNT_SOURCE;
  discountRate: number;
  discountType?: DISCOUNT_TYPE ;
}

export interface PosMetadataDiscountScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  source?: POS_DISCOUNT_SOURCE ;
  source_not?: POS_DISCOUNT_SOURCE ;
  source_in?: POS_DISCOUNT_SOURCE[] ;
  source_not_in?: POS_DISCOUNT_SOURCE[] ;
  discountRate?: number ;
  discountRate_not?: number ;
  discountRate_in?: number[] ;
  discountRate_not_in?: number[] ;
  discountRate_lt?: number ;
  discountRate_lte?: number ;
  discountRate_gt?: number ;
  discountRate_gte?: number ;
  discountType?: DISCOUNT_TYPE ;
  discountType_not?: DISCOUNT_TYPE ;
  discountType_in?: DISCOUNT_TYPE[] ;
  discountType_not_in?: DISCOUNT_TYPE[] ;
  AND?: PosMetadataDiscountScalarWhereInput[] ;
  OR?: PosMetadataDiscountScalarWhereInput[] ;
  NOT?: PosMetadataDiscountScalarWhereInput[] ;
}

export interface PosMetadataDiscountUpdateManyDataInput {
  source?: POS_DISCOUNT_SOURCE ;
  discountRate?: number ;
  discountType?: DISCOUNT_TYPE ;
}

export interface PosMetadataDiscountUpdateManyWithWhereNestedInput {
  where: PosMetadataDiscountScalarWhereInput;
  data: PosMetadataDiscountUpdateManyDataInput;
}

export interface PosMetadataDiscountUpdateManyWithoutPosMetadataInput {
  create?: PosMetadataDiscountCreateWithoutPosMetadataInput[] ;
  connect?: PosMetadataDiscountWhereUniqueInput[] ;
  set?: PosMetadataDiscountWhereUniqueInput[] ;
  disconnect?: PosMetadataDiscountWhereUniqueInput[] ;
  update?: PosMetadataDiscountUpdateWithWhereUniqueWithoutPosMetadataInput[] ;
  upsert?: PosMetadataDiscountUpsertWithWhereUniqueWithoutPosMetadataInput[] ;
  deleteMany?: PosMetadataDiscountScalarWhereInput[] ;
  updateMany?: PosMetadataDiscountUpdateManyWithWhereNestedInput[] ;
}

export interface PosMetadataDiscountUpdateWithWhereUniqueWithoutPosMetadataInput {
  where: PosMetadataDiscountWhereUniqueInput;
  data: PosMetadataDiscountUpdateWithoutPosMetadataDataInput;
}

export interface PosMetadataDiscountUpdateWithoutPosMetadataDataInput {
  source?: POS_DISCOUNT_SOURCE ;
  discountRate?: number ;
  discountType?: DISCOUNT_TYPE ;
}

export interface PosMetadataDiscountUpsertWithWhereUniqueWithoutPosMetadataInput {
  where: PosMetadataDiscountWhereUniqueInput;
  update: PosMetadataDiscountUpdateWithoutPosMetadataDataInput;
  create: PosMetadataDiscountCreateWithoutPosMetadataInput;
}

export interface PosMetadataDiscountWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  source?: POS_DISCOUNT_SOURCE ;
  source_not?: POS_DISCOUNT_SOURCE ;
  source_in?: POS_DISCOUNT_SOURCE[] ;
  source_not_in?: POS_DISCOUNT_SOURCE[] ;
  discountRate?: number ;
  discountRate_not?: number ;
  discountRate_in?: number[] ;
  discountRate_not_in?: number[] ;
  discountRate_lt?: number ;
  discountRate_lte?: number ;
  discountRate_gt?: number ;
  discountRate_gte?: number ;
  discountType?: DISCOUNT_TYPE ;
  discountType_not?: DISCOUNT_TYPE ;
  discountType_in?: DISCOUNT_TYPE[] ;
  discountType_not_in?: DISCOUNT_TYPE[] ;
  posMetadata?: PosMetadataWhereInput ;
  AND?: PosMetadataDiscountWhereInput[] ;
  OR?: PosMetadataDiscountWhereInput[] ;
  NOT?: PosMetadataDiscountWhereInput[] ;
}

export interface PosMetadataDiscountWhereUniqueInput {
  id?: string ;
}

export interface PosMetadataUpdateOneWithoutPaymentInput {
  create?: PosMetadataCreateWithoutPaymentInput ;
  update?: PosMetadataUpdateWithoutPaymentDataInput ;
  upsert?: PosMetadataUpsertWithoutPaymentInput ;
  disconnect?: boolean ;
  connect?: PosMetadataWhereUniqueInput ;
}

export interface PosMetadataUpdateOneWithoutTableSessionInput {
  create?: PosMetadataCreateWithoutTableSessionInput ;
  update?: PosMetadataUpdateWithoutTableSessionDataInput ;
  upsert?: PosMetadataUpsertWithoutTableSessionInput ;
  disconnect?: boolean ;
  connect?: PosMetadataWhereUniqueInput ;
}

export interface PosMetadataUpdateOneWithoutVenueInput {
  create?: PosMetadataCreateWithoutVenueInput ;
  update?: PosMetadataUpdateWithoutVenueDataInput ;
  upsert?: PosMetadataUpsertWithoutVenueInput ;
  disconnect?: boolean ;
  connect?: PosMetadataWhereUniqueInput ;
}

export interface PosMetadataUpdateWithoutPaymentDataInput {
  waiterId?: string ;
  staffId?: string ;
  originalAmount?: number ;
  discounts?: PosMetadataDiscountUpdateManyWithoutPosMetadataInput ;
  currency?: CURRENCY ;
  venue?: VenueUpdateOneWithoutPosMetadataInput ;
  paidAmount?: number ;
  tip?: number ;
  surcharge?: number ;
  tableSession?: TableSessionUpdateOneWithoutPosMetadataInput ;
  terminalTransactions?: TerminalTransactionUpdateManyWithoutPosMetadataInput ;
}

export interface PosMetadataUpdateWithoutTableSessionDataInput {
  waiterId?: string ;
  staffId?: string ;
  originalAmount?: number ;
  discounts?: PosMetadataDiscountUpdateManyWithoutPosMetadataInput ;
  currency?: CURRENCY ;
  venue?: VenueUpdateOneWithoutPosMetadataInput ;
  payment?: PaymentUpdateOneRequiredWithoutPosMetadataInput ;
  paidAmount?: number ;
  tip?: number ;
  surcharge?: number ;
  terminalTransactions?: TerminalTransactionUpdateManyWithoutPosMetadataInput ;
}

export interface PosMetadataUpdateWithoutVenueDataInput {
  waiterId?: string ;
  staffId?: string ;
  originalAmount?: number ;
  discounts?: PosMetadataDiscountUpdateManyWithoutPosMetadataInput ;
  currency?: CURRENCY ;
  payment?: PaymentUpdateOneRequiredWithoutPosMetadataInput ;
  paidAmount?: number ;
  tip?: number ;
  surcharge?: number ;
  tableSession?: TableSessionUpdateOneWithoutPosMetadataInput ;
  terminalTransactions?: TerminalTransactionUpdateManyWithoutPosMetadataInput ;
}

export interface PosMetadataUpsertWithoutPaymentInput {
  update: PosMetadataUpdateWithoutPaymentDataInput;
  create: PosMetadataCreateWithoutPaymentInput;
}

export interface PosMetadataUpsertWithoutTableSessionInput {
  update: PosMetadataUpdateWithoutTableSessionDataInput;
  create: PosMetadataCreateWithoutTableSessionInput;
}

export interface PosMetadataUpsertWithoutVenueInput {
  update: PosMetadataUpdateWithoutVenueDataInput;
  create: PosMetadataCreateWithoutVenueInput;
}

export interface PosMetadataWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  waiterId?: string ;
  waiterId_not?: string ;
  waiterId_in?: string[] ;
  waiterId_not_in?: string[] ;
  waiterId_lt?: string ;
  waiterId_lte?: string ;
  waiterId_gt?: string ;
  waiterId_gte?: string ;
  waiterId_contains?: string ;
  waiterId_not_contains?: string ;
  waiterId_starts_with?: string ;
  waiterId_not_starts_with?: string ;
  waiterId_ends_with?: string ;
  waiterId_not_ends_with?: string ;
  staffId?: string ;
  staffId_not?: string ;
  staffId_in?: string[] ;
  staffId_not_in?: string[] ;
  staffId_lt?: string ;
  staffId_lte?: string ;
  staffId_gt?: string ;
  staffId_gte?: string ;
  staffId_contains?: string ;
  staffId_not_contains?: string ;
  staffId_starts_with?: string ;
  staffId_not_starts_with?: string ;
  staffId_ends_with?: string ;
  staffId_not_ends_with?: string ;
  originalAmount?: number ;
  originalAmount_not?: number ;
  originalAmount_in?: number[] ;
  originalAmount_not_in?: number[] ;
  originalAmount_lt?: number ;
  originalAmount_lte?: number ;
  originalAmount_gt?: number ;
  originalAmount_gte?: number ;
  discounts_every?: PosMetadataDiscountWhereInput ;
  discounts_some?: PosMetadataDiscountWhereInput ;
  discounts_none?: PosMetadataDiscountWhereInput ;
  currency?: CURRENCY ;
  currency_not?: CURRENCY ;
  currency_in?: CURRENCY[] ;
  currency_not_in?: CURRENCY[] ;
  venue?: VenueWhereInput ;
  payment?: PaymentWhereInput ;
  paidAmount?: number ;
  paidAmount_not?: number ;
  paidAmount_in?: number[] ;
  paidAmount_not_in?: number[] ;
  paidAmount_lt?: number ;
  paidAmount_lte?: number ;
  paidAmount_gt?: number ;
  paidAmount_gte?: number ;
  tip?: number ;
  tip_not?: number ;
  tip_in?: number[] ;
  tip_not_in?: number[] ;
  tip_lt?: number ;
  tip_lte?: number ;
  tip_gt?: number ;
  tip_gte?: number ;
  surcharge?: number ;
  surcharge_not?: number ;
  surcharge_in?: number[] ;
  surcharge_not_in?: number[] ;
  surcharge_lt?: number ;
  surcharge_lte?: number ;
  surcharge_gt?: number ;
  surcharge_gte?: number ;
  tableSession?: TableSessionWhereInput ;
  terminalTransactions_every?: TerminalTransactionWhereInput ;
  terminalTransactions_some?: TerminalTransactionWhereInput ;
  terminalTransactions_none?: TerminalTransactionWhereInput ;
  AND?: PosMetadataWhereInput[] ;
  OR?: PosMetadataWhereInput[] ;
  NOT?: PosMetadataWhereInput[] ;
}

export interface PosMetadataWhereUniqueInput {
  id?: string ;
}

export interface PosTerminalCreateManyWithoutCompanyInput {
  create?: PosTerminalCreateWithoutCompanyInput[] ;
  connect?: PosTerminalWhereUniqueInput[] ;
}

export interface PosTerminalCreateWithoutCompanyInput {
  id?: string ;
  terminal: string;
}

export interface PosTerminalScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  terminal?: string ;
  terminal_not?: string ;
  terminal_in?: string[] ;
  terminal_not_in?: string[] ;
  terminal_lt?: string ;
  terminal_lte?: string ;
  terminal_gt?: string ;
  terminal_gte?: string ;
  terminal_contains?: string ;
  terminal_not_contains?: string ;
  terminal_starts_with?: string ;
  terminal_not_starts_with?: string ;
  terminal_ends_with?: string ;
  terminal_not_ends_with?: string ;
  AND?: PosTerminalScalarWhereInput[] ;
  OR?: PosTerminalScalarWhereInput[] ;
  NOT?: PosTerminalScalarWhereInput[] ;
}

export interface PosTerminalUpdateManyDataInput {
  terminal?: string ;
}

export interface PosTerminalUpdateManyWithWhereNestedInput {
  where: PosTerminalScalarWhereInput;
  data: PosTerminalUpdateManyDataInput;
}

export interface PosTerminalUpdateManyWithoutCompanyInput {
  create?: PosTerminalCreateWithoutCompanyInput[] ;
  connect?: PosTerminalWhereUniqueInput[] ;
  set?: PosTerminalWhereUniqueInput[] ;
  disconnect?: PosTerminalWhereUniqueInput[] ;
  update?: PosTerminalUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: PosTerminalUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: PosTerminalScalarWhereInput[] ;
  updateMany?: PosTerminalUpdateManyWithWhereNestedInput[] ;
}

export interface PosTerminalUpdateWithWhereUniqueWithoutCompanyInput {
  where: PosTerminalWhereUniqueInput;
  data: PosTerminalUpdateWithoutCompanyDataInput;
}

export interface PosTerminalUpdateWithoutCompanyDataInput {
  terminal?: string ;
}

export interface PosTerminalUpsertWithWhereUniqueWithoutCompanyInput {
  where: PosTerminalWhereUniqueInput;
  update: PosTerminalUpdateWithoutCompanyDataInput;
  create: PosTerminalCreateWithoutCompanyInput;
}

export interface PosTerminalWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  terminal?: string ;
  terminal_not?: string ;
  terminal_in?: string[] ;
  terminal_not_in?: string[] ;
  terminal_lt?: string ;
  terminal_lte?: string ;
  terminal_gt?: string ;
  terminal_gte?: string ;
  terminal_contains?: string ;
  terminal_not_contains?: string ;
  terminal_starts_with?: string ;
  terminal_not_starts_with?: string ;
  terminal_ends_with?: string ;
  terminal_not_ends_with?: string ;
  company?: CompanyWhereInput ;
  AND?: PosTerminalWhereInput[] ;
  OR?: PosTerminalWhereInput[] ;
  NOT?: PosTerminalWhereInput[] ;
}

export interface PosTerminalWhereUniqueInput {
  id?: string ;
  terminal?: string ;
}

export interface PredefinedMessageCreateInput {
  id?: string ;
  message: string;
  type: string;
  deleted?: boolean ;
  company: CompanyCreateOneWithoutPredefinedMessagesInput;
  venue: VenueCreateOneWithoutPredefinedMessagesInput;
}

export interface PredefinedMessageCreateManyWithoutCompanyInput {
  create?: PredefinedMessageCreateWithoutCompanyInput[] ;
  connect?: PredefinedMessageWhereUniqueInput[] ;
}

export interface PredefinedMessageCreateManyWithoutVenueInput {
  create?: PredefinedMessageCreateWithoutVenueInput[] ;
  connect?: PredefinedMessageWhereUniqueInput[] ;
}

export interface PredefinedMessageCreateWithoutCompanyInput {
  id?: string ;
  message: string;
  type: string;
  deleted?: boolean ;
  venue: VenueCreateOneWithoutPredefinedMessagesInput;
}

export interface PredefinedMessageCreateWithoutVenueInput {
  id?: string ;
  message: string;
  type: string;
  deleted?: boolean ;
  company: CompanyCreateOneWithoutPredefinedMessagesInput;
}

export interface PredefinedMessageScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  message?: string ;
  message_not?: string ;
  message_in?: string[] ;
  message_not_in?: string[] ;
  message_lt?: string ;
  message_lte?: string ;
  message_gt?: string ;
  message_gte?: string ;
  message_contains?: string ;
  message_not_contains?: string ;
  message_starts_with?: string ;
  message_not_starts_with?: string ;
  message_ends_with?: string ;
  message_not_ends_with?: string ;
  type?: string ;
  type_not?: string ;
  type_in?: string[] ;
  type_not_in?: string[] ;
  type_lt?: string ;
  type_lte?: string ;
  type_gt?: string ;
  type_gte?: string ;
  type_contains?: string ;
  type_not_contains?: string ;
  type_starts_with?: string ;
  type_not_starts_with?: string ;
  type_ends_with?: string ;
  type_not_ends_with?: string ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  AND?: PredefinedMessageScalarWhereInput[] ;
  OR?: PredefinedMessageScalarWhereInput[] ;
  NOT?: PredefinedMessageScalarWhereInput[] ;
}

export interface PredefinedMessageUpdateInput {
  message?: string ;
  type?: string ;
  deleted?: boolean ;
  company?: CompanyUpdateOneRequiredWithoutPredefinedMessagesInput ;
  venue?: VenueUpdateOneRequiredWithoutPredefinedMessagesInput ;
}

export interface PredefinedMessageUpdateManyDataInput {
  message?: string ;
  type?: string ;
  deleted?: boolean ;
}

export interface PredefinedMessageUpdateManyWithWhereNestedInput {
  where: PredefinedMessageScalarWhereInput;
  data: PredefinedMessageUpdateManyDataInput;
}

export interface PredefinedMessageUpdateManyWithoutCompanyInput {
  create?: PredefinedMessageCreateWithoutCompanyInput[] ;
  connect?: PredefinedMessageWhereUniqueInput[] ;
  set?: PredefinedMessageWhereUniqueInput[] ;
  disconnect?: PredefinedMessageWhereUniqueInput[] ;
  update?: PredefinedMessageUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: PredefinedMessageUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: PredefinedMessageScalarWhereInput[] ;
  updateMany?: PredefinedMessageUpdateManyWithWhereNestedInput[] ;
}

export interface PredefinedMessageUpdateManyWithoutVenueInput {
  create?: PredefinedMessageCreateWithoutVenueInput[] ;
  connect?: PredefinedMessageWhereUniqueInput[] ;
  set?: PredefinedMessageWhereUniqueInput[] ;
  disconnect?: PredefinedMessageWhereUniqueInput[] ;
  update?: PredefinedMessageUpdateWithWhereUniqueWithoutVenueInput[] ;
  upsert?: PredefinedMessageUpsertWithWhereUniqueWithoutVenueInput[] ;
  deleteMany?: PredefinedMessageScalarWhereInput[] ;
  updateMany?: PredefinedMessageUpdateManyWithWhereNestedInput[] ;
}

export interface PredefinedMessageUpdateWithWhereUniqueWithoutCompanyInput {
  where: PredefinedMessageWhereUniqueInput;
  data: PredefinedMessageUpdateWithoutCompanyDataInput;
}

export interface PredefinedMessageUpdateWithWhereUniqueWithoutVenueInput {
  where: PredefinedMessageWhereUniqueInput;
  data: PredefinedMessageUpdateWithoutVenueDataInput;
}

export interface PredefinedMessageUpdateWithoutCompanyDataInput {
  message?: string ;
  type?: string ;
  deleted?: boolean ;
  venue?: VenueUpdateOneRequiredWithoutPredefinedMessagesInput ;
}

export interface PredefinedMessageUpdateWithoutVenueDataInput {
  message?: string ;
  type?: string ;
  deleted?: boolean ;
  company?: CompanyUpdateOneRequiredWithoutPredefinedMessagesInput ;
}

export interface PredefinedMessageUpsertWithWhereUniqueWithoutCompanyInput {
  where: PredefinedMessageWhereUniqueInput;
  update: PredefinedMessageUpdateWithoutCompanyDataInput;
  create: PredefinedMessageCreateWithoutCompanyInput;
}

export interface PredefinedMessageUpsertWithWhereUniqueWithoutVenueInput {
  where: PredefinedMessageWhereUniqueInput;
  update: PredefinedMessageUpdateWithoutVenueDataInput;
  create: PredefinedMessageCreateWithoutVenueInput;
}

export interface PredefinedMessageWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  message?: string ;
  message_not?: string ;
  message_in?: string[] ;
  message_not_in?: string[] ;
  message_lt?: string ;
  message_lte?: string ;
  message_gt?: string ;
  message_gte?: string ;
  message_contains?: string ;
  message_not_contains?: string ;
  message_starts_with?: string ;
  message_not_starts_with?: string ;
  message_ends_with?: string ;
  message_not_ends_with?: string ;
  type?: string ;
  type_not?: string ;
  type_in?: string[] ;
  type_not_in?: string[] ;
  type_lt?: string ;
  type_lte?: string ;
  type_gt?: string ;
  type_gte?: string ;
  type_contains?: string ;
  type_not_contains?: string ;
  type_starts_with?: string ;
  type_not_starts_with?: string ;
  type_ends_with?: string ;
  type_not_ends_with?: string ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  company?: CompanyWhereInput ;
  venue?: VenueWhereInput ;
  AND?: PredefinedMessageWhereInput[] ;
  OR?: PredefinedMessageWhereInput[] ;
  NOT?: PredefinedMessageWhereInput[] ;
}

export interface PredefinedMessageWhereUniqueInput {
  id?: string ;
}

export interface PriceCreateOneWithoutFeeInput {
  create?: PriceCreateWithoutFeeInput ;
  connect?: PriceWhereUniqueInput ;
}

export interface PriceCreateOneWithoutOrderItemInput {
  create?: PriceCreateWithoutOrderItemInput ;
  connect?: PriceWhereUniqueInput ;
}

export interface PriceCreateWithoutFeeInput {
  amount: number;
  currency: string;
  discount: number;
  id?: string ;
  orderItem?: OrderItemCreateOneWithoutPriceInput ;
  percentageVAT: number;
  subtotal: number;
}

export interface PriceCreateWithoutOrderItemInput {
  amount: number;
  currency: string;
  discount: number;
  id?: string ;
  percentageVAT: number;
  subtotal: number;
  fee?: FeeCreateOneWithoutPriceInput ;
}

export interface PriceUpdateOneRequiredWithoutFeeInput {
  create?: PriceCreateWithoutFeeInput ;
  update?: PriceUpdateWithoutFeeDataInput ;
  upsert?: PriceUpsertWithoutFeeInput ;
  connect?: PriceWhereUniqueInput ;
}

export interface PriceUpdateOneWithoutOrderItemInput {
  create?: PriceCreateWithoutOrderItemInput ;
  update?: PriceUpdateWithoutOrderItemDataInput ;
  upsert?: PriceUpsertWithoutOrderItemInput ;
  disconnect?: boolean ;
  connect?: PriceWhereUniqueInput ;
}

export interface PriceUpdateWithoutFeeDataInput {
  amount?: number ;
  currency?: string ;
  discount?: number ;
  orderItem?: OrderItemUpdateOneWithoutPriceInput ;
  percentageVAT?: number ;
  subtotal?: number ;
}

export interface PriceUpdateWithoutOrderItemDataInput {
  amount?: number ;
  currency?: string ;
  discount?: number ;
  percentageVAT?: number ;
  subtotal?: number ;
  fee?: FeeUpdateOneWithoutPriceInput ;
}

export interface PriceUpsertWithoutFeeInput {
  update: PriceUpdateWithoutFeeDataInput;
  create: PriceCreateWithoutFeeInput;
}

export interface PriceUpsertWithoutOrderItemInput {
  update: PriceUpdateWithoutOrderItemDataInput;
  create: PriceCreateWithoutOrderItemInput;
}

export interface PriceWhereInput {
  amount?: number ;
  amount_not?: number ;
  amount_in?: number[] ;
  amount_not_in?: number[] ;
  amount_lt?: number ;
  amount_lte?: number ;
  amount_gt?: number ;
  amount_gte?: number ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  currency?: string ;
  currency_not?: string ;
  currency_in?: string[] ;
  currency_not_in?: string[] ;
  currency_lt?: string ;
  currency_lte?: string ;
  currency_gt?: string ;
  currency_gte?: string ;
  currency_contains?: string ;
  currency_not_contains?: string ;
  currency_starts_with?: string ;
  currency_not_starts_with?: string ;
  currency_ends_with?: string ;
  currency_not_ends_with?: string ;
  discount?: number ;
  discount_not?: number ;
  discount_in?: number[] ;
  discount_not_in?: number[] ;
  discount_lt?: number ;
  discount_lte?: number ;
  discount_gt?: number ;
  discount_gte?: number ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  orderItem?: OrderItemWhereInput ;
  percentageVAT?: number ;
  percentageVAT_not?: number ;
  percentageVAT_in?: number[] ;
  percentageVAT_not_in?: number[] ;
  percentageVAT_lt?: number ;
  percentageVAT_lte?: number ;
  percentageVAT_gt?: number ;
  percentageVAT_gte?: number ;
  subtotal?: number ;
  subtotal_not?: number ;
  subtotal_in?: number[] ;
  subtotal_not_in?: number[] ;
  subtotal_lt?: number ;
  subtotal_lte?: number ;
  subtotal_gt?: number ;
  subtotal_gte?: number ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  fee?: FeeWhereInput ;
  AND?: PriceWhereInput[] ;
  OR?: PriceWhereInput[] ;
  NOT?: PriceWhereInput[] ;
}

export interface PriceWhereUniqueInput {
  id?: string ;
}

export interface PromoCodeCreateManyWithoutCompanyInput {
  create?: PromoCodeCreateWithoutCompanyInput[] ;
  connect?: PromoCodeWhereUniqueInput[] ;
}

export interface PromoCodeCreateManyWithoutMembershipLevelInput {
  create?: PromoCodeCreateWithoutMembershipLevelInput[] ;
  connect?: PromoCodeWhereUniqueInput[] ;
}

export interface PromoCodeCreateManyWithoutOfferInput {
  create?: PromoCodeCreateWithoutOfferInput[] ;
  connect?: PromoCodeWhereUniqueInput[] ;
}

export interface PromoCodeCreateManyWithoutUsersInput {
  create?: PromoCodeCreateWithoutUsersInput[] ;
  connect?: PromoCodeWhereUniqueInput[] ;
}

export interface PromoCodeCreateWithoutCompanyInput {
  id?: string ;
  offer?: OfferCreateOneWithoutPromoCodesInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutPromoCodesInput ;
  promoCode: string;
  users?: UserCreateManyWithoutPromoCodesInput ;
}

export interface PromoCodeCreateWithoutMembershipLevelInput {
  id?: string ;
  company?: CompanyCreateOneWithoutPromocodesInput ;
  offer?: OfferCreateOneWithoutPromoCodesInput ;
  promoCode: string;
  users?: UserCreateManyWithoutPromoCodesInput ;
}

export interface PromoCodeCreateWithoutOfferInput {
  id?: string ;
  company?: CompanyCreateOneWithoutPromocodesInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutPromoCodesInput ;
  promoCode: string;
  users?: UserCreateManyWithoutPromoCodesInput ;
}

export interface PromoCodeCreateWithoutUsersInput {
  id?: string ;
  company?: CompanyCreateOneWithoutPromocodesInput ;
  offer?: OfferCreateOneWithoutPromoCodesInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutPromoCodesInput ;
  promoCode: string;
}

export interface PromoCodeScalarWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  promoCode?: string ;
  promoCode_not?: string ;
  promoCode_in?: string[] ;
  promoCode_not_in?: string[] ;
  promoCode_lt?: string ;
  promoCode_lte?: string ;
  promoCode_gt?: string ;
  promoCode_gte?: string ;
  promoCode_contains?: string ;
  promoCode_not_contains?: string ;
  promoCode_starts_with?: string ;
  promoCode_not_starts_with?: string ;
  promoCode_ends_with?: string ;
  promoCode_not_ends_with?: string ;
  AND?: PromoCodeScalarWhereInput[] ;
  OR?: PromoCodeScalarWhereInput[] ;
  NOT?: PromoCodeScalarWhereInput[] ;
}

export interface PromoCodeTitleInput {
  en?: string ;
  se?: string ;
  es?: string ;
}

export interface PromoCodeUpdateManyDataInput {
  promoCode?: string ;
}

export interface PromoCodeUpdateManyWithWhereNestedInput {
  where: PromoCodeScalarWhereInput;
  data: PromoCodeUpdateManyDataInput;
}

export interface PromoCodeUpdateManyWithoutCompanyInput {
  create?: PromoCodeCreateWithoutCompanyInput[] ;
  connect?: PromoCodeWhereUniqueInput[] ;
  set?: PromoCodeWhereUniqueInput[] ;
  disconnect?: PromoCodeWhereUniqueInput[] ;
  update?: PromoCodeUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: PromoCodeUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: PromoCodeScalarWhereInput[] ;
  updateMany?: PromoCodeUpdateManyWithWhereNestedInput[] ;
}

export interface PromoCodeUpdateManyWithoutMembershipLevelInput {
  create?: PromoCodeCreateWithoutMembershipLevelInput[] ;
  connect?: PromoCodeWhereUniqueInput[] ;
  set?: PromoCodeWhereUniqueInput[] ;
  disconnect?: PromoCodeWhereUniqueInput[] ;
  update?: PromoCodeUpdateWithWhereUniqueWithoutMembershipLevelInput[] ;
  upsert?: PromoCodeUpsertWithWhereUniqueWithoutMembershipLevelInput[] ;
  deleteMany?: PromoCodeScalarWhereInput[] ;
  updateMany?: PromoCodeUpdateManyWithWhereNestedInput[] ;
}

export interface PromoCodeUpdateManyWithoutOfferInput {
  create?: PromoCodeCreateWithoutOfferInput[] ;
  connect?: PromoCodeWhereUniqueInput[] ;
  set?: PromoCodeWhereUniqueInput[] ;
  disconnect?: PromoCodeWhereUniqueInput[] ;
  update?: PromoCodeUpdateWithWhereUniqueWithoutOfferInput[] ;
  upsert?: PromoCodeUpsertWithWhereUniqueWithoutOfferInput[] ;
  deleteMany?: PromoCodeScalarWhereInput[] ;
  updateMany?: PromoCodeUpdateManyWithWhereNestedInput[] ;
}

export interface PromoCodeUpdateManyWithoutUsersInput {
  create?: PromoCodeCreateWithoutUsersInput[] ;
  connect?: PromoCodeWhereUniqueInput[] ;
  set?: PromoCodeWhereUniqueInput[] ;
  disconnect?: PromoCodeWhereUniqueInput[] ;
  update?: PromoCodeUpdateWithWhereUniqueWithoutUsersInput[] ;
  upsert?: PromoCodeUpsertWithWhereUniqueWithoutUsersInput[] ;
  deleteMany?: PromoCodeScalarWhereInput[] ;
  updateMany?: PromoCodeUpdateManyWithWhereNestedInput[] ;
}

export interface PromoCodeUpdateWithWhereUniqueWithoutCompanyInput {
  where: PromoCodeWhereUniqueInput;
  data: PromoCodeUpdateWithoutCompanyDataInput;
}

export interface PromoCodeUpdateWithWhereUniqueWithoutMembershipLevelInput {
  where: PromoCodeWhereUniqueInput;
  data: PromoCodeUpdateWithoutMembershipLevelDataInput;
}

export interface PromoCodeUpdateWithWhereUniqueWithoutOfferInput {
  where: PromoCodeWhereUniqueInput;
  data: PromoCodeUpdateWithoutOfferDataInput;
}

export interface PromoCodeUpdateWithWhereUniqueWithoutUsersInput {
  where: PromoCodeWhereUniqueInput;
  data: PromoCodeUpdateWithoutUsersDataInput;
}

export interface PromoCodeUpdateWithoutCompanyDataInput {
  offer?: OfferUpdateOneWithoutPromoCodesInput ;
  membershipLevel?: MembershipLevelUpdateOneWithoutPromoCodesInput ;
  promoCode?: string ;
  users?: UserUpdateManyWithoutPromoCodesInput ;
}

export interface PromoCodeUpdateWithoutMembershipLevelDataInput {
  company?: CompanyUpdateOneWithoutPromocodesInput ;
  offer?: OfferUpdateOneWithoutPromoCodesInput ;
  promoCode?: string ;
  users?: UserUpdateManyWithoutPromoCodesInput ;
}

export interface PromoCodeUpdateWithoutOfferDataInput {
  company?: CompanyUpdateOneWithoutPromocodesInput ;
  membershipLevel?: MembershipLevelUpdateOneWithoutPromoCodesInput ;
  promoCode?: string ;
  users?: UserUpdateManyWithoutPromoCodesInput ;
}

export interface PromoCodeUpdateWithoutUsersDataInput {
  company?: CompanyUpdateOneWithoutPromocodesInput ;
  offer?: OfferUpdateOneWithoutPromoCodesInput ;
  membershipLevel?: MembershipLevelUpdateOneWithoutPromoCodesInput ;
  promoCode?: string ;
}

export interface PromoCodeUpsertWithWhereUniqueWithoutCompanyInput {
  where: PromoCodeWhereUniqueInput;
  update: PromoCodeUpdateWithoutCompanyDataInput;
  create: PromoCodeCreateWithoutCompanyInput;
}

export interface PromoCodeUpsertWithWhereUniqueWithoutMembershipLevelInput {
  where: PromoCodeWhereUniqueInput;
  update: PromoCodeUpdateWithoutMembershipLevelDataInput;
  create: PromoCodeCreateWithoutMembershipLevelInput;
}

export interface PromoCodeUpsertWithWhereUniqueWithoutOfferInput {
  where: PromoCodeWhereUniqueInput;
  update: PromoCodeUpdateWithoutOfferDataInput;
  create: PromoCodeCreateWithoutOfferInput;
}

export interface PromoCodeUpsertWithWhereUniqueWithoutUsersInput {
  where: PromoCodeWhereUniqueInput;
  update: PromoCodeUpdateWithoutUsersDataInput;
  create: PromoCodeCreateWithoutUsersInput;
}

export interface PromoCodeWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  company?: CompanyWhereInput ;
  offer?: OfferWhereInput ;
  membershipLevel?: MembershipLevelWhereInput ;
  promoCode?: string ;
  promoCode_not?: string ;
  promoCode_in?: string[] ;
  promoCode_not_in?: string[] ;
  promoCode_lt?: string ;
  promoCode_lte?: string ;
  promoCode_gt?: string ;
  promoCode_gte?: string ;
  promoCode_contains?: string ;
  promoCode_not_contains?: string ;
  promoCode_starts_with?: string ;
  promoCode_not_starts_with?: string ;
  promoCode_ends_with?: string ;
  promoCode_not_ends_with?: string ;
  users_every?: UserWhereInput ;
  users_some?: UserWhereInput ;
  users_none?: UserWhereInput ;
  AND?: PromoCodeWhereInput[] ;
  OR?: PromoCodeWhereInput[] ;
  NOT?: PromoCodeWhereInput[] ;
}

export interface PromoCodeWhereUniqueInput {
  id?: string ;
}

export interface PutCredentialsInput {
  companyId: string;
  clientId: string;
  clientSecret: string;
  userCenters: UserCenterInput[];
}

export interface QuicksightNamespaceInput {
  namespace: string;
}

export interface ReceiptPointsScanCreateManyWithoutUserInput {
  create?: ReceiptPointsScanCreateWithoutUserInput[] ;
  connect?: ReceiptPointsScanWhereUniqueInput[] ;
}

export interface ReceiptPointsScanCreateOneWithoutPointsTransactionInput {
  create?: ReceiptPointsScanCreateWithoutPointsTransactionInput ;
  connect?: ReceiptPointsScanWhereUniqueInput ;
}

export interface ReceiptPointsScanCreateWithoutPointsTransactionInput {
  id?: string ;
  receiptId: string;
  amount: number;
  verified?: boolean ;
  manual?: boolean ;
  rejected?: boolean ;
  user: UserCreateOneWithoutReceiptPointsScansInput;
}

export interface ReceiptPointsScanCreateWithoutUserInput {
  id?: string ;
  receiptId: string;
  amount: number;
  verified?: boolean ;
  manual?: boolean ;
  rejected?: boolean ;
  pointsTransaction?: PointsTransactionCreateOneWithoutScanInput ;
}

export interface ReceiptPointsScanScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  receiptId?: string ;
  receiptId_not?: string ;
  receiptId_in?: string[] ;
  receiptId_not_in?: string[] ;
  receiptId_lt?: string ;
  receiptId_lte?: string ;
  receiptId_gt?: string ;
  receiptId_gte?: string ;
  receiptId_contains?: string ;
  receiptId_not_contains?: string ;
  receiptId_starts_with?: string ;
  receiptId_not_starts_with?: string ;
  receiptId_ends_with?: string ;
  receiptId_not_ends_with?: string ;
  amount?: number ;
  amount_not?: number ;
  amount_in?: number[] ;
  amount_not_in?: number[] ;
  amount_lt?: number ;
  amount_lte?: number ;
  amount_gt?: number ;
  amount_gte?: number ;
  verified?: boolean ;
  verified_not?: boolean ;
  manual?: boolean ;
  manual_not?: boolean ;
  rejected?: boolean ;
  rejected_not?: boolean ;
  AND?: ReceiptPointsScanScalarWhereInput[] ;
  OR?: ReceiptPointsScanScalarWhereInput[] ;
  NOT?: ReceiptPointsScanScalarWhereInput[] ;
}

export interface ReceiptPointsScanUpdateManyDataInput {
  receiptId?: string ;
  amount?: number ;
  verified?: boolean ;
  manual?: boolean ;
  rejected?: boolean ;
}

export interface ReceiptPointsScanUpdateManyWithWhereNestedInput {
  where: ReceiptPointsScanScalarWhereInput;
  data: ReceiptPointsScanUpdateManyDataInput;
}

export interface ReceiptPointsScanUpdateManyWithoutUserInput {
  create?: ReceiptPointsScanCreateWithoutUserInput[] ;
  connect?: ReceiptPointsScanWhereUniqueInput[] ;
  set?: ReceiptPointsScanWhereUniqueInput[] ;
  disconnect?: ReceiptPointsScanWhereUniqueInput[] ;
  update?: ReceiptPointsScanUpdateWithWhereUniqueWithoutUserInput[] ;
  upsert?: ReceiptPointsScanUpsertWithWhereUniqueWithoutUserInput[] ;
  deleteMany?: ReceiptPointsScanScalarWhereInput[] ;
  updateMany?: ReceiptPointsScanUpdateManyWithWhereNestedInput[] ;
}

export interface ReceiptPointsScanUpdateOneWithoutPointsTransactionInput {
  create?: ReceiptPointsScanCreateWithoutPointsTransactionInput ;
  update?: ReceiptPointsScanUpdateWithoutPointsTransactionDataInput ;
  upsert?: ReceiptPointsScanUpsertWithoutPointsTransactionInput ;
  disconnect?: boolean ;
  connect?: ReceiptPointsScanWhereUniqueInput ;
}

export interface ReceiptPointsScanUpdateWithWhereUniqueWithoutUserInput {
  where: ReceiptPointsScanWhereUniqueInput;
  data: ReceiptPointsScanUpdateWithoutUserDataInput;
}

export interface ReceiptPointsScanUpdateWithoutPointsTransactionDataInput {
  receiptId?: string ;
  amount?: number ;
  verified?: boolean ;
  manual?: boolean ;
  rejected?: boolean ;
  user?: UserUpdateOneRequiredWithoutReceiptPointsScansInput ;
}

export interface ReceiptPointsScanUpdateWithoutUserDataInput {
  receiptId?: string ;
  amount?: number ;
  verified?: boolean ;
  manual?: boolean ;
  rejected?: boolean ;
  pointsTransaction?: PointsTransactionUpdateOneWithoutScanInput ;
}

export interface ReceiptPointsScanUpsertWithWhereUniqueWithoutUserInput {
  where: ReceiptPointsScanWhereUniqueInput;
  update: ReceiptPointsScanUpdateWithoutUserDataInput;
  create: ReceiptPointsScanCreateWithoutUserInput;
}

export interface ReceiptPointsScanUpsertWithoutPointsTransactionInput {
  update: ReceiptPointsScanUpdateWithoutPointsTransactionDataInput;
  create: ReceiptPointsScanCreateWithoutPointsTransactionInput;
}

export interface ReceiptPointsScanWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  receiptId?: string ;
  receiptId_not?: string ;
  receiptId_in?: string[] ;
  receiptId_not_in?: string[] ;
  receiptId_lt?: string ;
  receiptId_lte?: string ;
  receiptId_gt?: string ;
  receiptId_gte?: string ;
  receiptId_contains?: string ;
  receiptId_not_contains?: string ;
  receiptId_starts_with?: string ;
  receiptId_not_starts_with?: string ;
  receiptId_ends_with?: string ;
  receiptId_not_ends_with?: string ;
  amount?: number ;
  amount_not?: number ;
  amount_in?: number[] ;
  amount_not_in?: number[] ;
  amount_lt?: number ;
  amount_lte?: number ;
  amount_gt?: number ;
  amount_gte?: number ;
  verified?: boolean ;
  verified_not?: boolean ;
  manual?: boolean ;
  manual_not?: boolean ;
  rejected?: boolean ;
  rejected_not?: boolean ;
  pointsTransaction?: PointsTransactionWhereInput ;
  user?: UserWhereInput ;
  AND?: ReceiptPointsScanWhereInput[] ;
  OR?: ReceiptPointsScanWhereInput[] ;
  NOT?: ReceiptPointsScanWhereInput[] ;
}

export interface ReceiptPointsScanWhereUniqueInput {
  id?: string ;
}

export interface ReceiptTemplateCreateInput {
  id?: string ;
  name: string;
  image?: ImageCreateOneWithoutReceiptTemplateInput ;
  introLines?: ReceiptTemplateCreateintroLinesInput ;
  bottomLines?: ReceiptTemplateCreatebottomLinesInput ;
  company: CompanyCreateOneWithoutReceiptTemplateInput;
  venue?: VenueCreateOneWithoutReceiptTemplateInput ;
}

export interface ReceiptTemplateCreateManyWithoutCompanyInput {
  create?: ReceiptTemplateCreateWithoutCompanyInput[] ;
  connect?: ReceiptTemplateWhereUniqueInput[] ;
}

export interface ReceiptTemplateCreateOneWithoutImageInput {
  create?: ReceiptTemplateCreateWithoutImageInput ;
  connect?: ReceiptTemplateWhereUniqueInput ;
}

export interface ReceiptTemplateCreateOneWithoutVenueInput {
  create?: ReceiptTemplateCreateWithoutVenueInput ;
  connect?: ReceiptTemplateWhereUniqueInput ;
}

export interface ReceiptTemplateCreateWithoutCompanyInput {
  id?: string ;
  name: string;
  image?: ImageCreateOneWithoutReceiptTemplateInput ;
  introLines?: ReceiptTemplateCreateintroLinesInput ;
  bottomLines?: ReceiptTemplateCreatebottomLinesInput ;
  venue?: VenueCreateOneWithoutReceiptTemplateInput ;
}

export interface ReceiptTemplateCreateWithoutImageInput {
  id?: string ;
  name: string;
  introLines?: ReceiptTemplateCreateintroLinesInput ;
  bottomLines?: ReceiptTemplateCreatebottomLinesInput ;
  company: CompanyCreateOneWithoutReceiptTemplateInput;
  venue?: VenueCreateOneWithoutReceiptTemplateInput ;
}

export interface ReceiptTemplateCreateWithoutVenueInput {
  id?: string ;
  name: string;
  image?: ImageCreateOneWithoutReceiptTemplateInput ;
  introLines?: ReceiptTemplateCreateintroLinesInput ;
  bottomLines?: ReceiptTemplateCreatebottomLinesInput ;
  company: CompanyCreateOneWithoutReceiptTemplateInput;
}

export interface ReceiptTemplateCreatebottomLinesInput {
  set?: string[] ;
}

export interface ReceiptTemplateCreateintroLinesInput {
  set?: string[] ;
}

export interface ReceiptTemplateScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  AND?: ReceiptTemplateScalarWhereInput[] ;
  OR?: ReceiptTemplateScalarWhereInput[] ;
  NOT?: ReceiptTemplateScalarWhereInput[] ;
}

export interface ReceiptTemplateUpdateInput {
  name?: string ;
  image?: ImageUpdateOneWithoutReceiptTemplateInput ;
  introLines?: ReceiptTemplateUpdateintroLinesInput ;
  bottomLines?: ReceiptTemplateUpdatebottomLinesInput ;
  company?: CompanyUpdateOneRequiredWithoutReceiptTemplateInput ;
  venue?: VenueUpdateOneWithoutReceiptTemplateInput ;
}

export interface ReceiptTemplateUpdateManyDataInput {
  name?: string ;
  introLines?: ReceiptTemplateUpdateintroLinesInput ;
  bottomLines?: ReceiptTemplateUpdatebottomLinesInput ;
}

export interface ReceiptTemplateUpdateManyWithWhereNestedInput {
  where: ReceiptTemplateScalarWhereInput;
  data: ReceiptTemplateUpdateManyDataInput;
}

export interface ReceiptTemplateUpdateManyWithoutCompanyInput {
  create?: ReceiptTemplateCreateWithoutCompanyInput[] ;
  connect?: ReceiptTemplateWhereUniqueInput[] ;
  set?: ReceiptTemplateWhereUniqueInput[] ;
  disconnect?: ReceiptTemplateWhereUniqueInput[] ;
  update?: ReceiptTemplateUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: ReceiptTemplateUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: ReceiptTemplateScalarWhereInput[] ;
  updateMany?: ReceiptTemplateUpdateManyWithWhereNestedInput[] ;
}

export interface ReceiptTemplateUpdateOneWithoutImageInput {
  create?: ReceiptTemplateCreateWithoutImageInput ;
  update?: ReceiptTemplateUpdateWithoutImageDataInput ;
  upsert?: ReceiptTemplateUpsertWithoutImageInput ;
  disconnect?: boolean ;
  connect?: ReceiptTemplateWhereUniqueInput ;
}

export interface ReceiptTemplateUpdateOneWithoutVenueInput {
  create?: ReceiptTemplateCreateWithoutVenueInput ;
  update?: ReceiptTemplateUpdateWithoutVenueDataInput ;
  upsert?: ReceiptTemplateUpsertWithoutVenueInput ;
  disconnect?: boolean ;
  connect?: ReceiptTemplateWhereUniqueInput ;
}

export interface ReceiptTemplateUpdateWithWhereUniqueWithoutCompanyInput {
  where: ReceiptTemplateWhereUniqueInput;
  data: ReceiptTemplateUpdateWithoutCompanyDataInput;
}

export interface ReceiptTemplateUpdateWithoutCompanyDataInput {
  name?: string ;
  image?: ImageUpdateOneWithoutReceiptTemplateInput ;
  introLines?: ReceiptTemplateUpdateintroLinesInput ;
  bottomLines?: ReceiptTemplateUpdatebottomLinesInput ;
  venue?: VenueUpdateOneWithoutReceiptTemplateInput ;
}

export interface ReceiptTemplateUpdateWithoutImageDataInput {
  name?: string ;
  introLines?: ReceiptTemplateUpdateintroLinesInput ;
  bottomLines?: ReceiptTemplateUpdatebottomLinesInput ;
  company?: CompanyUpdateOneRequiredWithoutReceiptTemplateInput ;
  venue?: VenueUpdateOneWithoutReceiptTemplateInput ;
}

export interface ReceiptTemplateUpdateWithoutVenueDataInput {
  name?: string ;
  image?: ImageUpdateOneWithoutReceiptTemplateInput ;
  introLines?: ReceiptTemplateUpdateintroLinesInput ;
  bottomLines?: ReceiptTemplateUpdatebottomLinesInput ;
  company?: CompanyUpdateOneRequiredWithoutReceiptTemplateInput ;
}

export interface ReceiptTemplateUpdatebottomLinesInput {
  set?: string[] ;
}

export interface ReceiptTemplateUpdateintroLinesInput {
  set?: string[] ;
}

export interface ReceiptTemplateUpsertWithWhereUniqueWithoutCompanyInput {
  where: ReceiptTemplateWhereUniqueInput;
  update: ReceiptTemplateUpdateWithoutCompanyDataInput;
  create: ReceiptTemplateCreateWithoutCompanyInput;
}

export interface ReceiptTemplateUpsertWithoutImageInput {
  update: ReceiptTemplateUpdateWithoutImageDataInput;
  create: ReceiptTemplateCreateWithoutImageInput;
}

export interface ReceiptTemplateUpsertWithoutVenueInput {
  update: ReceiptTemplateUpdateWithoutVenueDataInput;
  create: ReceiptTemplateCreateWithoutVenueInput;
}

export interface ReceiptTemplateWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  image?: ImageWhereInput ;
  company?: CompanyWhereInput ;
  venue?: VenueWhereInput ;
  AND?: ReceiptTemplateWhereInput[] ;
  OR?: ReceiptTemplateWhereInput[] ;
  NOT?: ReceiptTemplateWhereInput[] ;
}

export interface ReceiptTemplateWhereUniqueInput {
  id?: string ;
}

export interface RecommendationCreateManyWithoutItemInput {
  create?: RecommendationCreateWithoutItemInput[] ;
  connect?: RecommendationWhereUniqueInput[] ;
}

export interface RecommendationCreateManyWithoutUserInput {
  create?: RecommendationCreateWithoutUserInput[] ;
  connect?: RecommendationWhereUniqueInput[] ;
}

export interface RecommendationCreateManyWithoutVariationsInput {
  create?: RecommendationCreateWithoutVariationsInput[] ;
  connect?: RecommendationWhereUniqueInput[] ;
}

export interface RecommendationCreateWithoutItemInput {
  id?: string ;
  user?: UserCreateOneWithoutRecommendationsInput ;
  variations?: VariationCreateManyWithoutRecommendationsInput ;
}

export interface RecommendationCreateWithoutUserInput {
  id?: string ;
  item?: ItemCreateOneWithoutRecommendationsInput ;
  variations?: VariationCreateManyWithoutRecommendationsInput ;
}

export interface RecommendationCreateWithoutVariationsInput {
  id?: string ;
  item?: ItemCreateOneWithoutRecommendationsInput ;
  user?: UserCreateOneWithoutRecommendationsInput ;
}

export interface RecommendationScalarWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  AND?: RecommendationScalarWhereInput[] ;
  OR?: RecommendationScalarWhereInput[] ;
  NOT?: RecommendationScalarWhereInput[] ;
}

export interface RecommendationUpdateManyWithoutItemInput {
  create?: RecommendationCreateWithoutItemInput[] ;
  connect?: RecommendationWhereUniqueInput[] ;
  set?: RecommendationWhereUniqueInput[] ;
  disconnect?: RecommendationWhereUniqueInput[] ;
  update?: RecommendationUpdateWithWhereUniqueWithoutItemInput[] ;
  upsert?: RecommendationUpsertWithWhereUniqueWithoutItemInput[] ;
  deleteMany?: RecommendationScalarWhereInput[] ;
}

export interface RecommendationUpdateManyWithoutUserInput {
  create?: RecommendationCreateWithoutUserInput[] ;
  connect?: RecommendationWhereUniqueInput[] ;
  set?: RecommendationWhereUniqueInput[] ;
  disconnect?: RecommendationWhereUniqueInput[] ;
  update?: RecommendationUpdateWithWhereUniqueWithoutUserInput[] ;
  upsert?: RecommendationUpsertWithWhereUniqueWithoutUserInput[] ;
  deleteMany?: RecommendationScalarWhereInput[] ;
}

export interface RecommendationUpdateManyWithoutVariationsInput {
  create?: RecommendationCreateWithoutVariationsInput[] ;
  connect?: RecommendationWhereUniqueInput[] ;
  set?: RecommendationWhereUniqueInput[] ;
  disconnect?: RecommendationWhereUniqueInput[] ;
  update?: RecommendationUpdateWithWhereUniqueWithoutVariationsInput[] ;
  upsert?: RecommendationUpsertWithWhereUniqueWithoutVariationsInput[] ;
  deleteMany?: RecommendationScalarWhereInput[] ;
}

export interface RecommendationUpdateWithWhereUniqueWithoutItemInput {
  where: RecommendationWhereUniqueInput;
  data: RecommendationUpdateWithoutItemDataInput;
}

export interface RecommendationUpdateWithWhereUniqueWithoutUserInput {
  where: RecommendationWhereUniqueInput;
  data: RecommendationUpdateWithoutUserDataInput;
}

export interface RecommendationUpdateWithWhereUniqueWithoutVariationsInput {
  where: RecommendationWhereUniqueInput;
  data: RecommendationUpdateWithoutVariationsDataInput;
}

export interface RecommendationUpdateWithoutItemDataInput {
  user?: UserUpdateOneWithoutRecommendationsInput ;
  variations?: VariationUpdateManyWithoutRecommendationsInput ;
}

export interface RecommendationUpdateWithoutUserDataInput {
  item?: ItemUpdateOneWithoutRecommendationsInput ;
  variations?: VariationUpdateManyWithoutRecommendationsInput ;
}

export interface RecommendationUpdateWithoutVariationsDataInput {
  item?: ItemUpdateOneWithoutRecommendationsInput ;
  user?: UserUpdateOneWithoutRecommendationsInput ;
}

export interface RecommendationUpsertWithWhereUniqueWithoutItemInput {
  where: RecommendationWhereUniqueInput;
  update: RecommendationUpdateWithoutItemDataInput;
  create: RecommendationCreateWithoutItemInput;
}

export interface RecommendationUpsertWithWhereUniqueWithoutUserInput {
  where: RecommendationWhereUniqueInput;
  update: RecommendationUpdateWithoutUserDataInput;
  create: RecommendationCreateWithoutUserInput;
}

export interface RecommendationUpsertWithWhereUniqueWithoutVariationsInput {
  where: RecommendationWhereUniqueInput;
  update: RecommendationUpdateWithoutVariationsDataInput;
  create: RecommendationCreateWithoutVariationsInput;
}

export interface RecommendationWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  item?: ItemWhereInput ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  user?: UserWhereInput ;
  variations_every?: VariationWhereInput ;
  variations_some?: VariationWhereInput ;
  variations_none?: VariationWhereInput ;
  AND?: RecommendationWhereInput[] ;
  OR?: RecommendationWhereInput[] ;
  NOT?: RecommendationWhereInput[] ;
}

export interface RecommendationWhereUniqueInput {
  id?: string ;
}

export interface RefundCreateOneWithoutTransactionsInput {
  create?: RefundCreateWithoutTransactionsInput ;
  connect?: RefundWhereUniqueInput ;
}

export interface RefundCreateWithoutTransactionsInput {
  id?: string ;
  fullRefund?: boolean ;
  tipRefund?: boolean ;
  refundDate?: any ;
  refundSum: number;
  order: OrderCreateOneInput;
  item?: OrderItemCreateOneInput ;
}

export interface RefundUpdateOneWithoutTransactionsInput {
  create?: RefundCreateWithoutTransactionsInput ;
  update?: RefundUpdateWithoutTransactionsDataInput ;
  upsert?: RefundUpsertWithoutTransactionsInput ;
  disconnect?: boolean ;
  connect?: RefundWhereUniqueInput ;
}

export interface RefundUpdateWithoutTransactionsDataInput {
  fullRefund?: boolean ;
  tipRefund?: boolean ;
  refundDate?: any ;
  refundSum?: number ;
  order?: OrderUpdateOneRequiredInput ;
  item?: OrderItemUpdateOneInput ;
}

export interface RefundUpsertWithoutTransactionsInput {
  update: RefundUpdateWithoutTransactionsDataInput;
  create: RefundCreateWithoutTransactionsInput;
}

export interface RefundWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  fullRefund?: boolean ;
  fullRefund_not?: boolean ;
  tipRefund?: boolean ;
  tipRefund_not?: boolean ;
  refundDate?: any ;
  refundDate_not?: any ;
  refundDate_in?: any[] ;
  refundDate_not_in?: any[] ;
  refundDate_lt?: any ;
  refundDate_lte?: any ;
  refundDate_gt?: any ;
  refundDate_gte?: any ;
  refundSum?: number ;
  refundSum_not?: number ;
  refundSum_in?: number[] ;
  refundSum_not_in?: number[] ;
  refundSum_lt?: number ;
  refundSum_lte?: number ;
  refundSum_gt?: number ;
  refundSum_gte?: number ;
  order?: OrderWhereInput ;
  item?: OrderItemWhereInput ;
  transactions_every?: TransactionWhereInput ;
  transactions_some?: TransactionWhereInput ;
  transactions_none?: TransactionWhereInput ;
  AND?: RefundWhereInput[] ;
  OR?: RefundWhereInput[] ;
  NOT?: RefundWhereInput[] ;
}

export interface RefundWhereUniqueInput {
  id?: string ;
}

export interface RelevantUserDataInput {
  userId: string;
  name: string;
  username: string;
  venues: string[];
}

export interface ReportCreateManyWithoutVenueInput {
  create?: ReportCreateWithoutVenueInput[] ;
  connect?: ReportWhereUniqueInput[] ;
}

export interface ReportCreateWithoutVenueInput {
  id?: string ;
  type?: REPORT_TYPE ;
}

export interface ReportScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  type?: REPORT_TYPE ;
  type_not?: REPORT_TYPE ;
  type_in?: REPORT_TYPE[] ;
  type_not_in?: REPORT_TYPE[] ;
  AND?: ReportScalarWhereInput[] ;
  OR?: ReportScalarWhereInput[] ;
  NOT?: ReportScalarWhereInput[] ;
}

export interface ReportUpdateManyDataInput {
  type?: REPORT_TYPE ;
}

export interface ReportUpdateManyWithWhereNestedInput {
  where: ReportScalarWhereInput;
  data: ReportUpdateManyDataInput;
}

export interface ReportUpdateManyWithoutVenueInput {
  create?: ReportCreateWithoutVenueInput[] ;
  connect?: ReportWhereUniqueInput[] ;
  set?: ReportWhereUniqueInput[] ;
  disconnect?: ReportWhereUniqueInput[] ;
  update?: ReportUpdateWithWhereUniqueWithoutVenueInput[] ;
  upsert?: ReportUpsertWithWhereUniqueWithoutVenueInput[] ;
  deleteMany?: ReportScalarWhereInput[] ;
  updateMany?: ReportUpdateManyWithWhereNestedInput[] ;
}

export interface ReportUpdateWithWhereUniqueWithoutVenueInput {
  where: ReportWhereUniqueInput;
  data: ReportUpdateWithoutVenueDataInput;
}

export interface ReportUpdateWithoutVenueDataInput {
  type?: REPORT_TYPE ;
}

export interface ReportUpsertWithWhereUniqueWithoutVenueInput {
  where: ReportWhereUniqueInput;
  update: ReportUpdateWithoutVenueDataInput;
  create: ReportCreateWithoutVenueInput;
}

export interface ReportWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  venue?: VenueWhereInput ;
  type?: REPORT_TYPE ;
  type_not?: REPORT_TYPE ;
  type_in?: REPORT_TYPE[] ;
  type_not_in?: REPORT_TYPE[] ;
  AND?: ReportWhereInput[] ;
  OR?: ReportWhereInput[] ;
  NOT?: ReportWhereInput[] ;
}

export interface ReportWhereUniqueInput {
  id?: string ;
}

export interface ReportsServiceCategoryInput {
  id: string;
  name: string;
}

export interface ReservationCreateManyWithoutTableInput {
  create?: ReservationCreateWithoutTableInput[] ;
  connect?: ReservationWhereUniqueInput[] ;
}

export interface ReservationCreateManyWithoutUserInput {
  create?: ReservationCreateWithoutUserInput[] ;
  connect?: ReservationWhereUniqueInput[] ;
}

export interface ReservationCreateWithoutTableInput {
  id?: string ;
  from: any;
  to: any;
  user: UserCreateOneWithoutReservationsInput;
  data?: any ;
  comment?: string ;
  deleted?: boolean ;
}

export interface ReservationCreateWithoutUserInput {
  id?: string ;
  table?: TableCreateOneWithoutReservationsInput ;
  from: any;
  to: any;
  data?: any ;
  comment?: string ;
  deleted?: boolean ;
}

export interface ReservationScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  from?: any ;
  from_not?: any ;
  from_in?: any[] ;
  from_not_in?: any[] ;
  from_lt?: any ;
  from_lte?: any ;
  from_gt?: any ;
  from_gte?: any ;
  to?: any ;
  to_not?: any ;
  to_in?: any[] ;
  to_not_in?: any[] ;
  to_lt?: any ;
  to_lte?: any ;
  to_gt?: any ;
  to_gte?: any ;
  comment?: string ;
  comment_not?: string ;
  comment_in?: string[] ;
  comment_not_in?: string[] ;
  comment_lt?: string ;
  comment_lte?: string ;
  comment_gt?: string ;
  comment_gte?: string ;
  comment_contains?: string ;
  comment_not_contains?: string ;
  comment_starts_with?: string ;
  comment_not_starts_with?: string ;
  comment_ends_with?: string ;
  comment_not_ends_with?: string ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  AND?: ReservationScalarWhereInput[] ;
  OR?: ReservationScalarWhereInput[] ;
  NOT?: ReservationScalarWhereInput[] ;
}

export interface ReservationUpdateManyDataInput {
  from?: any ;
  to?: any ;
  data?: any ;
  comment?: string ;
  deleted?: boolean ;
}

export interface ReservationUpdateManyWithWhereNestedInput {
  where: ReservationScalarWhereInput;
  data: ReservationUpdateManyDataInput;
}

export interface ReservationUpdateManyWithoutTableInput {
  create?: ReservationCreateWithoutTableInput[] ;
  connect?: ReservationWhereUniqueInput[] ;
  set?: ReservationWhereUniqueInput[] ;
  disconnect?: ReservationWhereUniqueInput[] ;
  update?: ReservationUpdateWithWhereUniqueWithoutTableInput[] ;
  upsert?: ReservationUpsertWithWhereUniqueWithoutTableInput[] ;
  deleteMany?: ReservationScalarWhereInput[] ;
  updateMany?: ReservationUpdateManyWithWhereNestedInput[] ;
}

export interface ReservationUpdateManyWithoutUserInput {
  create?: ReservationCreateWithoutUserInput[] ;
  connect?: ReservationWhereUniqueInput[] ;
  set?: ReservationWhereUniqueInput[] ;
  disconnect?: ReservationWhereUniqueInput[] ;
  update?: ReservationUpdateWithWhereUniqueWithoutUserInput[] ;
  upsert?: ReservationUpsertWithWhereUniqueWithoutUserInput[] ;
  deleteMany?: ReservationScalarWhereInput[] ;
  updateMany?: ReservationUpdateManyWithWhereNestedInput[] ;
}

export interface ReservationUpdateWithWhereUniqueWithoutTableInput {
  where: ReservationWhereUniqueInput;
  data: ReservationUpdateWithoutTableDataInput;
}

export interface ReservationUpdateWithWhereUniqueWithoutUserInput {
  where: ReservationWhereUniqueInput;
  data: ReservationUpdateWithoutUserDataInput;
}

export interface ReservationUpdateWithoutTableDataInput {
  from?: any ;
  to?: any ;
  user?: UserUpdateOneRequiredWithoutReservationsInput ;
  data?: any ;
  comment?: string ;
  deleted?: boolean ;
}

export interface ReservationUpdateWithoutUserDataInput {
  table?: TableUpdateOneWithoutReservationsInput ;
  from?: any ;
  to?: any ;
  data?: any ;
  comment?: string ;
  deleted?: boolean ;
}

export interface ReservationUpsertWithWhereUniqueWithoutTableInput {
  where: ReservationWhereUniqueInput;
  update: ReservationUpdateWithoutTableDataInput;
  create: ReservationCreateWithoutTableInput;
}

export interface ReservationUpsertWithWhereUniqueWithoutUserInput {
  where: ReservationWhereUniqueInput;
  update: ReservationUpdateWithoutUserDataInput;
  create: ReservationCreateWithoutUserInput;
}

export interface ReservationWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  table?: TableWhereInput ;
  from?: any ;
  from_not?: any ;
  from_in?: any[] ;
  from_not_in?: any[] ;
  from_lt?: any ;
  from_lte?: any ;
  from_gt?: any ;
  from_gte?: any ;
  to?: any ;
  to_not?: any ;
  to_in?: any[] ;
  to_not_in?: any[] ;
  to_lt?: any ;
  to_lte?: any ;
  to_gt?: any ;
  to_gte?: any ;
  user?: UserWhereInput ;
  comment?: string ;
  comment_not?: string ;
  comment_in?: string[] ;
  comment_not_in?: string[] ;
  comment_lt?: string ;
  comment_lte?: string ;
  comment_gt?: string ;
  comment_gte?: string ;
  comment_contains?: string ;
  comment_not_contains?: string ;
  comment_starts_with?: string ;
  comment_not_starts_with?: string ;
  comment_ends_with?: string ;
  comment_not_ends_with?: string ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  AND?: ReservationWhereInput[] ;
  OR?: ReservationWhereInput[] ;
  NOT?: ReservationWhereInput[] ;
}

export interface ReservationWhereUniqueInput {
  id?: string ;
}

export interface SalesServiceExporterInput {
  name: SalesServiceExporterType;
  originGroups?: SalesServiceOrigin[][] ;
  types?: SalesServiceReportType[] ;
}

export interface SentNotificationCreateManyWithoutNotificationInput {
  create?: SentNotificationCreateWithoutNotificationInput[] ;
  connect?: SentNotificationWhereUniqueInput[] ;
}

export interface SentNotificationCreateManyWithoutUserInput {
  create?: SentNotificationCreateWithoutUserInput[] ;
  connect?: SentNotificationWhereUniqueInput[] ;
}

export interface SentNotificationCreateWithoutNotificationInput {
  id?: string ;
  user: UserCreateOneWithoutSentNotificationsInput;
  successful: boolean;
  sent: any;
  failed: any;
}

export interface SentNotificationCreateWithoutUserInput {
  id?: string ;
  notification: NotificationCreateOneWithoutSentNotificationsInput;
  successful: boolean;
  sent: any;
  failed: any;
}

export interface SentNotificationScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  successful?: boolean ;
  successful_not?: boolean ;
  AND?: SentNotificationScalarWhereInput[] ;
  OR?: SentNotificationScalarWhereInput[] ;
  NOT?: SentNotificationScalarWhereInput[] ;
}

export interface SentNotificationUpdateManyDataInput {
  successful?: boolean ;
  sent?: any ;
  failed?: any ;
}

export interface SentNotificationUpdateManyWithWhereNestedInput {
  where: SentNotificationScalarWhereInput;
  data: SentNotificationUpdateManyDataInput;
}

export interface SentNotificationUpdateManyWithoutNotificationInput {
  create?: SentNotificationCreateWithoutNotificationInput[] ;
  connect?: SentNotificationWhereUniqueInput[] ;
  set?: SentNotificationWhereUniqueInput[] ;
  disconnect?: SentNotificationWhereUniqueInput[] ;
  update?: SentNotificationUpdateWithWhereUniqueWithoutNotificationInput[] ;
  upsert?: SentNotificationUpsertWithWhereUniqueWithoutNotificationInput[] ;
  deleteMany?: SentNotificationScalarWhereInput[] ;
  updateMany?: SentNotificationUpdateManyWithWhereNestedInput[] ;
}

export interface SentNotificationUpdateManyWithoutUserInput {
  create?: SentNotificationCreateWithoutUserInput[] ;
  connect?: SentNotificationWhereUniqueInput[] ;
  set?: SentNotificationWhereUniqueInput[] ;
  disconnect?: SentNotificationWhereUniqueInput[] ;
  update?: SentNotificationUpdateWithWhereUniqueWithoutUserInput[] ;
  upsert?: SentNotificationUpsertWithWhereUniqueWithoutUserInput[] ;
  deleteMany?: SentNotificationScalarWhereInput[] ;
  updateMany?: SentNotificationUpdateManyWithWhereNestedInput[] ;
}

export interface SentNotificationUpdateWithWhereUniqueWithoutNotificationInput {
  where: SentNotificationWhereUniqueInput;
  data: SentNotificationUpdateWithoutNotificationDataInput;
}

export interface SentNotificationUpdateWithWhereUniqueWithoutUserInput {
  where: SentNotificationWhereUniqueInput;
  data: SentNotificationUpdateWithoutUserDataInput;
}

export interface SentNotificationUpdateWithoutNotificationDataInput {
  user?: UserUpdateOneRequiredWithoutSentNotificationsInput ;
  successful?: boolean ;
  sent?: any ;
  failed?: any ;
}

export interface SentNotificationUpdateWithoutUserDataInput {
  notification?: NotificationUpdateOneRequiredWithoutSentNotificationsInput ;
  successful?: boolean ;
  sent?: any ;
  failed?: any ;
}

export interface SentNotificationUpsertWithWhereUniqueWithoutNotificationInput {
  where: SentNotificationWhereUniqueInput;
  update: SentNotificationUpdateWithoutNotificationDataInput;
  create: SentNotificationCreateWithoutNotificationInput;
}

export interface SentNotificationUpsertWithWhereUniqueWithoutUserInput {
  where: SentNotificationWhereUniqueInput;
  update: SentNotificationUpdateWithoutUserDataInput;
  create: SentNotificationCreateWithoutUserInput;
}

export interface SentNotificationWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  user?: UserWhereInput ;
  notification?: NotificationWhereInput ;
  successful?: boolean ;
  successful_not?: boolean ;
  AND?: SentNotificationWhereInput[] ;
  OR?: SentNotificationWhereInput[] ;
  NOT?: SentNotificationWhereInput[] ;
}

export interface SentNotificationWhereUniqueInput {
  id?: string ;
}

export interface SetTipsInput {
  legalEntityId: string;
  terminalId?: string ;
  storeReference?: string ;
  allowCustomAmount: boolean;
  preDefinedTipEntries: string[];
}

export interface SocialMediaFeedCreateManyWithoutCompanyInput {
  create?: SocialMediaFeedCreateWithoutCompanyInput[] ;
  connect?: SocialMediaFeedWhereUniqueInput[] ;
}

export interface SocialMediaFeedCreateManyWithoutSocialMediaCompanyInput {
  create?: SocialMediaFeedCreateWithoutSocialMediaCompanyInput[] ;
  connect?: SocialMediaFeedWhereUniqueInput[] ;
}

export interface SocialMediaFeedCreateWithoutCompanyInput {
  id?: string ;
  externalId: string;
  link: string;
  description?: string ;
  mediaType: string;
  mediaUrl?: string ;
  socialMediaCompany?: CompanyCreateOneWithoutSocialMediaFeedInput ;
  type?: SOCIAL_MEDIA ;
}

export interface SocialMediaFeedCreateWithoutSocialMediaCompanyInput {
  id?: string ;
  externalId: string;
  link: string;
  description?: string ;
  mediaType: string;
  mediaUrl?: string ;
  company?: CompanyCreateOneWithoutFeedInput ;
  type?: SOCIAL_MEDIA ;
}

export interface SocialMediaFeedScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  externalId?: string ;
  externalId_not?: string ;
  externalId_in?: string[] ;
  externalId_not_in?: string[] ;
  externalId_lt?: string ;
  externalId_lte?: string ;
  externalId_gt?: string ;
  externalId_gte?: string ;
  externalId_contains?: string ;
  externalId_not_contains?: string ;
  externalId_starts_with?: string ;
  externalId_not_starts_with?: string ;
  externalId_ends_with?: string ;
  externalId_not_ends_with?: string ;
  link?: string ;
  link_not?: string ;
  link_in?: string[] ;
  link_not_in?: string[] ;
  link_lt?: string ;
  link_lte?: string ;
  link_gt?: string ;
  link_gte?: string ;
  link_contains?: string ;
  link_not_contains?: string ;
  link_starts_with?: string ;
  link_not_starts_with?: string ;
  link_ends_with?: string ;
  link_not_ends_with?: string ;
  description?: string ;
  description_not?: string ;
  description_in?: string[] ;
  description_not_in?: string[] ;
  description_lt?: string ;
  description_lte?: string ;
  description_gt?: string ;
  description_gte?: string ;
  description_contains?: string ;
  description_not_contains?: string ;
  description_starts_with?: string ;
  description_not_starts_with?: string ;
  description_ends_with?: string ;
  description_not_ends_with?: string ;
  mediaType?: string ;
  mediaType_not?: string ;
  mediaType_in?: string[] ;
  mediaType_not_in?: string[] ;
  mediaType_lt?: string ;
  mediaType_lte?: string ;
  mediaType_gt?: string ;
  mediaType_gte?: string ;
  mediaType_contains?: string ;
  mediaType_not_contains?: string ;
  mediaType_starts_with?: string ;
  mediaType_not_starts_with?: string ;
  mediaType_ends_with?: string ;
  mediaType_not_ends_with?: string ;
  mediaUrl?: string ;
  mediaUrl_not?: string ;
  mediaUrl_in?: string[] ;
  mediaUrl_not_in?: string[] ;
  mediaUrl_lt?: string ;
  mediaUrl_lte?: string ;
  mediaUrl_gt?: string ;
  mediaUrl_gte?: string ;
  mediaUrl_contains?: string ;
  mediaUrl_not_contains?: string ;
  mediaUrl_starts_with?: string ;
  mediaUrl_not_starts_with?: string ;
  mediaUrl_ends_with?: string ;
  mediaUrl_not_ends_with?: string ;
  type?: SOCIAL_MEDIA ;
  type_not?: SOCIAL_MEDIA ;
  type_in?: SOCIAL_MEDIA[] ;
  type_not_in?: SOCIAL_MEDIA[] ;
  AND?: SocialMediaFeedScalarWhereInput[] ;
  OR?: SocialMediaFeedScalarWhereInput[] ;
  NOT?: SocialMediaFeedScalarWhereInput[] ;
}

export interface SocialMediaFeedUpdateManyDataInput {
  externalId?: string ;
  link?: string ;
  description?: string ;
  mediaType?: string ;
  mediaUrl?: string ;
  type?: SOCIAL_MEDIA ;
}

export interface SocialMediaFeedUpdateManyWithWhereNestedInput {
  where: SocialMediaFeedScalarWhereInput;
  data: SocialMediaFeedUpdateManyDataInput;
}

export interface SocialMediaFeedUpdateManyWithoutCompanyInput {
  create?: SocialMediaFeedCreateWithoutCompanyInput[] ;
  connect?: SocialMediaFeedWhereUniqueInput[] ;
  set?: SocialMediaFeedWhereUniqueInput[] ;
  disconnect?: SocialMediaFeedWhereUniqueInput[] ;
  update?: SocialMediaFeedUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: SocialMediaFeedUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: SocialMediaFeedScalarWhereInput[] ;
  updateMany?: SocialMediaFeedUpdateManyWithWhereNestedInput[] ;
}

export interface SocialMediaFeedUpdateManyWithoutSocialMediaCompanyInput {
  create?: SocialMediaFeedCreateWithoutSocialMediaCompanyInput[] ;
  connect?: SocialMediaFeedWhereUniqueInput[] ;
  set?: SocialMediaFeedWhereUniqueInput[] ;
  disconnect?: SocialMediaFeedWhereUniqueInput[] ;
  update?: SocialMediaFeedUpdateWithWhereUniqueWithoutSocialMediaCompanyInput[] ;
  upsert?: SocialMediaFeedUpsertWithWhereUniqueWithoutSocialMediaCompanyInput[] ;
  deleteMany?: SocialMediaFeedScalarWhereInput[] ;
  updateMany?: SocialMediaFeedUpdateManyWithWhereNestedInput[] ;
}

export interface SocialMediaFeedUpdateWithWhereUniqueWithoutCompanyInput {
  where: SocialMediaFeedWhereUniqueInput;
  data: SocialMediaFeedUpdateWithoutCompanyDataInput;
}

export interface SocialMediaFeedUpdateWithWhereUniqueWithoutSocialMediaCompanyInput {
  where: SocialMediaFeedWhereUniqueInput;
  data: SocialMediaFeedUpdateWithoutSocialMediaCompanyDataInput;
}

export interface SocialMediaFeedUpdateWithoutCompanyDataInput {
  externalId?: string ;
  link?: string ;
  description?: string ;
  mediaType?: string ;
  mediaUrl?: string ;
  socialMediaCompany?: CompanyUpdateOneWithoutSocialMediaFeedInput ;
  type?: SOCIAL_MEDIA ;
}

export interface SocialMediaFeedUpdateWithoutSocialMediaCompanyDataInput {
  externalId?: string ;
  link?: string ;
  description?: string ;
  mediaType?: string ;
  mediaUrl?: string ;
  company?: CompanyUpdateOneWithoutFeedInput ;
  type?: SOCIAL_MEDIA ;
}

export interface SocialMediaFeedUpsertWithWhereUniqueWithoutCompanyInput {
  where: SocialMediaFeedWhereUniqueInput;
  update: SocialMediaFeedUpdateWithoutCompanyDataInput;
  create: SocialMediaFeedCreateWithoutCompanyInput;
}

export interface SocialMediaFeedUpsertWithWhereUniqueWithoutSocialMediaCompanyInput {
  where: SocialMediaFeedWhereUniqueInput;
  update: SocialMediaFeedUpdateWithoutSocialMediaCompanyDataInput;
  create: SocialMediaFeedCreateWithoutSocialMediaCompanyInput;
}

export interface SocialMediaFeedWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  externalId?: string ;
  externalId_not?: string ;
  externalId_in?: string[] ;
  externalId_not_in?: string[] ;
  externalId_lt?: string ;
  externalId_lte?: string ;
  externalId_gt?: string ;
  externalId_gte?: string ;
  externalId_contains?: string ;
  externalId_not_contains?: string ;
  externalId_starts_with?: string ;
  externalId_not_starts_with?: string ;
  externalId_ends_with?: string ;
  externalId_not_ends_with?: string ;
  link?: string ;
  link_not?: string ;
  link_in?: string[] ;
  link_not_in?: string[] ;
  link_lt?: string ;
  link_lte?: string ;
  link_gt?: string ;
  link_gte?: string ;
  link_contains?: string ;
  link_not_contains?: string ;
  link_starts_with?: string ;
  link_not_starts_with?: string ;
  link_ends_with?: string ;
  link_not_ends_with?: string ;
  description?: string ;
  description_not?: string ;
  description_in?: string[] ;
  description_not_in?: string[] ;
  description_lt?: string ;
  description_lte?: string ;
  description_gt?: string ;
  description_gte?: string ;
  description_contains?: string ;
  description_not_contains?: string ;
  description_starts_with?: string ;
  description_not_starts_with?: string ;
  description_ends_with?: string ;
  description_not_ends_with?: string ;
  mediaType?: string ;
  mediaType_not?: string ;
  mediaType_in?: string[] ;
  mediaType_not_in?: string[] ;
  mediaType_lt?: string ;
  mediaType_lte?: string ;
  mediaType_gt?: string ;
  mediaType_gte?: string ;
  mediaType_contains?: string ;
  mediaType_not_contains?: string ;
  mediaType_starts_with?: string ;
  mediaType_not_starts_with?: string ;
  mediaType_ends_with?: string ;
  mediaType_not_ends_with?: string ;
  mediaUrl?: string ;
  mediaUrl_not?: string ;
  mediaUrl_in?: string[] ;
  mediaUrl_not_in?: string[] ;
  mediaUrl_lt?: string ;
  mediaUrl_lte?: string ;
  mediaUrl_gt?: string ;
  mediaUrl_gte?: string ;
  mediaUrl_contains?: string ;
  mediaUrl_not_contains?: string ;
  mediaUrl_starts_with?: string ;
  mediaUrl_not_starts_with?: string ;
  mediaUrl_ends_with?: string ;
  mediaUrl_not_ends_with?: string ;
  socialMediaCompany?: CompanyWhereInput ;
  company?: CompanyWhereInput ;
  type?: SOCIAL_MEDIA ;
  type_not?: SOCIAL_MEDIA ;
  type_in?: SOCIAL_MEDIA[] ;
  type_not_in?: SOCIAL_MEDIA[] ;
  AND?: SocialMediaFeedWhereInput[] ;
  OR?: SocialMediaFeedWhereInput[] ;
  NOT?: SocialMediaFeedWhereInput[] ;
}

export interface SocialMediaFeedWhereUniqueInput {
  id?: string ;
}

export interface StaffCreateInput {
  id?: string ;
  name: string;
  code: string;
  deleted?: boolean ;
  company: CompanyCreateOneWithoutStaffsInput;
  accessLevel: AccessLevelCreateOneInput;
  expenses?: ExpenseCreateManyWithoutStaffInput ;
}

export interface StaffCreateManyWithoutCompanyInput {
  create?: StaffCreateWithoutCompanyInput[] ;
  connect?: StaffWhereUniqueInput[] ;
}

export interface StaffCreateOneInput {
  create?: StaffCreateInput ;
  connect?: StaffWhereUniqueInput ;
}

export interface StaffCreateOneWithoutExpensesInput {
  create?: StaffCreateWithoutExpensesInput ;
  connect?: StaffWhereUniqueInput ;
}

export interface StaffCreateWithoutCompanyInput {
  id?: string ;
  name: string;
  code: string;
  deleted?: boolean ;
  accessLevel: AccessLevelCreateOneInput;
  expenses?: ExpenseCreateManyWithoutStaffInput ;
}

export interface StaffCreateWithoutExpensesInput {
  id?: string ;
  name: string;
  code: string;
  deleted?: boolean ;
  company: CompanyCreateOneWithoutStaffsInput;
  accessLevel: AccessLevelCreateOneInput;
}

export interface StaffScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  code?: string ;
  code_not?: string ;
  code_in?: string[] ;
  code_not_in?: string[] ;
  code_lt?: string ;
  code_lte?: string ;
  code_gt?: string ;
  code_gte?: string ;
  code_contains?: string ;
  code_not_contains?: string ;
  code_starts_with?: string ;
  code_not_starts_with?: string ;
  code_ends_with?: string ;
  code_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  AND?: StaffScalarWhereInput[] ;
  OR?: StaffScalarWhereInput[] ;
  NOT?: StaffScalarWhereInput[] ;
}

export interface StaffUpdateDataInput {
  name?: string ;
  code?: string ;
  deleted?: boolean ;
  company?: CompanyUpdateOneRequiredWithoutStaffsInput ;
  accessLevel?: AccessLevelUpdateOneRequiredInput ;
  expenses?: ExpenseUpdateManyWithoutStaffInput ;
}

export interface StaffUpdateInput {
  name?: string ;
  code?: string ;
  deleted?: boolean ;
  company?: CompanyUpdateOneRequiredWithoutStaffsInput ;
  accessLevel?: AccessLevelUpdateOneRequiredInput ;
  expenses?: ExpenseUpdateManyWithoutStaffInput ;
}

export interface StaffUpdateManyDataInput {
  name?: string ;
  code?: string ;
  deleted?: boolean ;
}

export interface StaffUpdateManyWithWhereNestedInput {
  where: StaffScalarWhereInput;
  data: StaffUpdateManyDataInput;
}

export interface StaffUpdateManyWithoutCompanyInput {
  create?: StaffCreateWithoutCompanyInput[] ;
  connect?: StaffWhereUniqueInput[] ;
  set?: StaffWhereUniqueInput[] ;
  disconnect?: StaffWhereUniqueInput[] ;
  update?: StaffUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: StaffUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: StaffScalarWhereInput[] ;
  updateMany?: StaffUpdateManyWithWhereNestedInput[] ;
}

export interface StaffUpdateOneInput {
  create?: StaffCreateInput ;
  update?: StaffUpdateDataInput ;
  upsert?: StaffUpsertNestedInput ;
  disconnect?: boolean ;
  connect?: StaffWhereUniqueInput ;
}

export interface StaffUpdateOneRequiredWithoutExpensesInput {
  create?: StaffCreateWithoutExpensesInput ;
  update?: StaffUpdateWithoutExpensesDataInput ;
  upsert?: StaffUpsertWithoutExpensesInput ;
  connect?: StaffWhereUniqueInput ;
}

export interface StaffUpdateWithWhereUniqueWithoutCompanyInput {
  where: StaffWhereUniqueInput;
  data: StaffUpdateWithoutCompanyDataInput;
}

export interface StaffUpdateWithoutCompanyDataInput {
  name?: string ;
  code?: string ;
  deleted?: boolean ;
  accessLevel?: AccessLevelUpdateOneRequiredInput ;
  expenses?: ExpenseUpdateManyWithoutStaffInput ;
}

export interface StaffUpdateWithoutExpensesDataInput {
  name?: string ;
  code?: string ;
  deleted?: boolean ;
  company?: CompanyUpdateOneRequiredWithoutStaffsInput ;
  accessLevel?: AccessLevelUpdateOneRequiredInput ;
}

export interface StaffUpsertNestedInput {
  update: StaffUpdateDataInput;
  create: StaffCreateInput;
}

export interface StaffUpsertWithWhereUniqueWithoutCompanyInput {
  where: StaffWhereUniqueInput;
  update: StaffUpdateWithoutCompanyDataInput;
  create: StaffCreateWithoutCompanyInput;
}

export interface StaffUpsertWithoutExpensesInput {
  update: StaffUpdateWithoutExpensesDataInput;
  create: StaffCreateWithoutExpensesInput;
}

export interface StaffWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  code?: string ;
  code_not?: string ;
  code_in?: string[] ;
  code_not_in?: string[] ;
  code_lt?: string ;
  code_lte?: string ;
  code_gt?: string ;
  code_gte?: string ;
  code_contains?: string ;
  code_not_contains?: string ;
  code_starts_with?: string ;
  code_not_starts_with?: string ;
  code_ends_with?: string ;
  code_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  company?: CompanyWhereInput ;
  accessLevel?: AccessLevelWhereInput ;
  expenses_every?: ExpenseWhereInput ;
  expenses_some?: ExpenseWhereInput ;
  expenses_none?: ExpenseWhereInput ;
  AND?: StaffWhereInput[] ;
  OR?: StaffWhereInput[] ;
  NOT?: StaffWhereInput[] ;
}

export interface StaffWhereUniqueInput {
  id?: string ;
}

export interface StampCardCreateManyWithoutCompanyInput {
  create?: StampCardCreateWithoutCompanyInput[] ;
  connect?: StampCardWhereUniqueInput[] ;
}

export interface StampCardCreateManyWithoutItemsInput {
  create?: StampCardCreateWithoutItemsInput[] ;
  connect?: StampCardWhereUniqueInput[] ;
}

export interface StampCardCreateManyWithoutOfferInput {
  create?: StampCardCreateWithoutOfferInput[] ;
  connect?: StampCardWhereUniqueInput[] ;
}

export interface StampCardCreateManyWithoutUsersInput {
  create?: StampCardCreateWithoutUsersInput[] ;
  connect?: StampCardWhereUniqueInput[] ;
}

export interface StampCardCreateManyWithoutVenuesInput {
  create?: StampCardCreateWithoutVenuesInput[] ;
  connect?: StampCardWhereUniqueInput[] ;
}

export interface StampCardCreateOneWithoutDescriptionLangInput {
  create?: StampCardCreateWithoutDescriptionLangInput ;
  connect?: StampCardWhereUniqueInput ;
}

export interface StampCardCreateOneWithoutDetailsInput {
  create?: StampCardCreateWithoutDetailsInput ;
  connect?: StampCardWhereUniqueInput ;
}

export interface StampCardCreateOneWithoutNameLangInput {
  create?: StampCardCreateWithoutNameLangInput ;
  connect?: StampCardWhereUniqueInput ;
}

export interface StampCardCreateOneWithoutStampsInput {
  create?: StampCardCreateWithoutStampsInput ;
  connect?: StampCardWhereUniqueInput ;
}

export interface StampCardCreateWithoutCompanyInput {
  count: number;
  id?: string ;
  items?: ItemCreateManyWithoutStampCardsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutStampCardNameInput ;
  descriptionLang?: TranslatedStringCreateOneWithoutStampcardDescriptionInput ;
  details?: TranslatedStringCreateOneWithoutStampCardDetailsInput ;
  stamps?: StampCreateManyWithoutStampCardInput ;
  users?: UserCreateManyWithoutStampCardsInput ;
  deleted?: boolean ;
  venues?: VenueCreateManyWithoutStampCardsInput ;
  default?: boolean ;
  offer?: OfferCreateOneWithoutStampCardsInput ;
  icon?: string ;
}

export interface StampCardCreateWithoutDescriptionLangInput {
  company?: CompanyCreateOneWithoutStampCardsInput ;
  count: number;
  id?: string ;
  items?: ItemCreateManyWithoutStampCardsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutStampCardNameInput ;
  details?: TranslatedStringCreateOneWithoutStampCardDetailsInput ;
  stamps?: StampCreateManyWithoutStampCardInput ;
  users?: UserCreateManyWithoutStampCardsInput ;
  deleted?: boolean ;
  venues?: VenueCreateManyWithoutStampCardsInput ;
  default?: boolean ;
  offer?: OfferCreateOneWithoutStampCardsInput ;
  icon?: string ;
}

export interface StampCardCreateWithoutDetailsInput {
  company?: CompanyCreateOneWithoutStampCardsInput ;
  count: number;
  id?: string ;
  items?: ItemCreateManyWithoutStampCardsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutStampCardNameInput ;
  descriptionLang?: TranslatedStringCreateOneWithoutStampcardDescriptionInput ;
  stamps?: StampCreateManyWithoutStampCardInput ;
  users?: UserCreateManyWithoutStampCardsInput ;
  deleted?: boolean ;
  venues?: VenueCreateManyWithoutStampCardsInput ;
  default?: boolean ;
  offer?: OfferCreateOneWithoutStampCardsInput ;
  icon?: string ;
}

export interface StampCardCreateWithoutItemsInput {
  company?: CompanyCreateOneWithoutStampCardsInput ;
  count: number;
  id?: string ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutStampCardNameInput ;
  descriptionLang?: TranslatedStringCreateOneWithoutStampcardDescriptionInput ;
  details?: TranslatedStringCreateOneWithoutStampCardDetailsInput ;
  stamps?: StampCreateManyWithoutStampCardInput ;
  users?: UserCreateManyWithoutStampCardsInput ;
  deleted?: boolean ;
  venues?: VenueCreateManyWithoutStampCardsInput ;
  default?: boolean ;
  offer?: OfferCreateOneWithoutStampCardsInput ;
  icon?: string ;
}

export interface StampCardCreateWithoutNameLangInput {
  company?: CompanyCreateOneWithoutStampCardsInput ;
  count: number;
  id?: string ;
  items?: ItemCreateManyWithoutStampCardsInput ;
  name: string;
  descriptionLang?: TranslatedStringCreateOneWithoutStampcardDescriptionInput ;
  details?: TranslatedStringCreateOneWithoutStampCardDetailsInput ;
  stamps?: StampCreateManyWithoutStampCardInput ;
  users?: UserCreateManyWithoutStampCardsInput ;
  deleted?: boolean ;
  venues?: VenueCreateManyWithoutStampCardsInput ;
  default?: boolean ;
  offer?: OfferCreateOneWithoutStampCardsInput ;
  icon?: string ;
}

export interface StampCardCreateWithoutOfferInput {
  company?: CompanyCreateOneWithoutStampCardsInput ;
  count: number;
  id?: string ;
  items?: ItemCreateManyWithoutStampCardsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutStampCardNameInput ;
  descriptionLang?: TranslatedStringCreateOneWithoutStampcardDescriptionInput ;
  details?: TranslatedStringCreateOneWithoutStampCardDetailsInput ;
  stamps?: StampCreateManyWithoutStampCardInput ;
  users?: UserCreateManyWithoutStampCardsInput ;
  deleted?: boolean ;
  venues?: VenueCreateManyWithoutStampCardsInput ;
  default?: boolean ;
  icon?: string ;
}

export interface StampCardCreateWithoutStampsInput {
  company?: CompanyCreateOneWithoutStampCardsInput ;
  count: number;
  id?: string ;
  items?: ItemCreateManyWithoutStampCardsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutStampCardNameInput ;
  descriptionLang?: TranslatedStringCreateOneWithoutStampcardDescriptionInput ;
  details?: TranslatedStringCreateOneWithoutStampCardDetailsInput ;
  users?: UserCreateManyWithoutStampCardsInput ;
  deleted?: boolean ;
  venues?: VenueCreateManyWithoutStampCardsInput ;
  default?: boolean ;
  offer?: OfferCreateOneWithoutStampCardsInput ;
  icon?: string ;
}

export interface StampCardCreateWithoutUsersInput {
  company?: CompanyCreateOneWithoutStampCardsInput ;
  count: number;
  id?: string ;
  items?: ItemCreateManyWithoutStampCardsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutStampCardNameInput ;
  descriptionLang?: TranslatedStringCreateOneWithoutStampcardDescriptionInput ;
  details?: TranslatedStringCreateOneWithoutStampCardDetailsInput ;
  stamps?: StampCreateManyWithoutStampCardInput ;
  deleted?: boolean ;
  venues?: VenueCreateManyWithoutStampCardsInput ;
  default?: boolean ;
  offer?: OfferCreateOneWithoutStampCardsInput ;
  icon?: string ;
}

export interface StampCardCreateWithoutVenuesInput {
  company?: CompanyCreateOneWithoutStampCardsInput ;
  count: number;
  id?: string ;
  items?: ItemCreateManyWithoutStampCardsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutStampCardNameInput ;
  descriptionLang?: TranslatedStringCreateOneWithoutStampcardDescriptionInput ;
  details?: TranslatedStringCreateOneWithoutStampCardDetailsInput ;
  stamps?: StampCreateManyWithoutStampCardInput ;
  users?: UserCreateManyWithoutStampCardsInput ;
  deleted?: boolean ;
  default?: boolean ;
  offer?: OfferCreateOneWithoutStampCardsInput ;
  icon?: string ;
}

export interface StampCardScalarWhereInput {
  count?: number ;
  count_not?: number ;
  count_in?: number[] ;
  count_not_in?: number[] ;
  count_lt?: number ;
  count_lte?: number ;
  count_gt?: number ;
  count_gte?: number ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  default?: boolean ;
  default_not?: boolean ;
  icon?: string ;
  icon_not?: string ;
  icon_in?: string[] ;
  icon_not_in?: string[] ;
  icon_lt?: string ;
  icon_lte?: string ;
  icon_gt?: string ;
  icon_gte?: string ;
  icon_contains?: string ;
  icon_not_contains?: string ;
  icon_starts_with?: string ;
  icon_not_starts_with?: string ;
  icon_ends_with?: string ;
  icon_not_ends_with?: string ;
  AND?: StampCardScalarWhereInput[] ;
  OR?: StampCardScalarWhereInput[] ;
  NOT?: StampCardScalarWhereInput[] ;
}

export interface StampCardUpdateManyDataInput {
  count?: number ;
  name?: string ;
  deleted?: boolean ;
  default?: boolean ;
  icon?: string ;
}

export interface StampCardUpdateManyWithWhereNestedInput {
  where: StampCardScalarWhereInput;
  data: StampCardUpdateManyDataInput;
}

export interface StampCardUpdateManyWithoutCompanyInput {
  create?: StampCardCreateWithoutCompanyInput[] ;
  connect?: StampCardWhereUniqueInput[] ;
  set?: StampCardWhereUniqueInput[] ;
  disconnect?: StampCardWhereUniqueInput[] ;
  update?: StampCardUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: StampCardUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: StampCardScalarWhereInput[] ;
  updateMany?: StampCardUpdateManyWithWhereNestedInput[] ;
}

export interface StampCardUpdateManyWithoutItemsInput {
  create?: StampCardCreateWithoutItemsInput[] ;
  connect?: StampCardWhereUniqueInput[] ;
  set?: StampCardWhereUniqueInput[] ;
  disconnect?: StampCardWhereUniqueInput[] ;
  update?: StampCardUpdateWithWhereUniqueWithoutItemsInput[] ;
  upsert?: StampCardUpsertWithWhereUniqueWithoutItemsInput[] ;
  deleteMany?: StampCardScalarWhereInput[] ;
  updateMany?: StampCardUpdateManyWithWhereNestedInput[] ;
}

export interface StampCardUpdateManyWithoutOfferInput {
  create?: StampCardCreateWithoutOfferInput[] ;
  connect?: StampCardWhereUniqueInput[] ;
  set?: StampCardWhereUniqueInput[] ;
  disconnect?: StampCardWhereUniqueInput[] ;
  update?: StampCardUpdateWithWhereUniqueWithoutOfferInput[] ;
  upsert?: StampCardUpsertWithWhereUniqueWithoutOfferInput[] ;
  deleteMany?: StampCardScalarWhereInput[] ;
  updateMany?: StampCardUpdateManyWithWhereNestedInput[] ;
}

export interface StampCardUpdateManyWithoutUsersInput {
  create?: StampCardCreateWithoutUsersInput[] ;
  connect?: StampCardWhereUniqueInput[] ;
  set?: StampCardWhereUniqueInput[] ;
  disconnect?: StampCardWhereUniqueInput[] ;
  update?: StampCardUpdateWithWhereUniqueWithoutUsersInput[] ;
  upsert?: StampCardUpsertWithWhereUniqueWithoutUsersInput[] ;
  deleteMany?: StampCardScalarWhereInput[] ;
  updateMany?: StampCardUpdateManyWithWhereNestedInput[] ;
}

export interface StampCardUpdateManyWithoutVenuesInput {
  create?: StampCardCreateWithoutVenuesInput[] ;
  connect?: StampCardWhereUniqueInput[] ;
  set?: StampCardWhereUniqueInput[] ;
  disconnect?: StampCardWhereUniqueInput[] ;
  update?: StampCardUpdateWithWhereUniqueWithoutVenuesInput[] ;
  upsert?: StampCardUpsertWithWhereUniqueWithoutVenuesInput[] ;
  deleteMany?: StampCardScalarWhereInput[] ;
  updateMany?: StampCardUpdateManyWithWhereNestedInput[] ;
}

export interface StampCardUpdateOneWithoutDescriptionLangInput {
  create?: StampCardCreateWithoutDescriptionLangInput ;
  update?: StampCardUpdateWithoutDescriptionLangDataInput ;
  upsert?: StampCardUpsertWithoutDescriptionLangInput ;
  disconnect?: boolean ;
  connect?: StampCardWhereUniqueInput ;
}

export interface StampCardUpdateOneWithoutDetailsInput {
  create?: StampCardCreateWithoutDetailsInput ;
  update?: StampCardUpdateWithoutDetailsDataInput ;
  upsert?: StampCardUpsertWithoutDetailsInput ;
  disconnect?: boolean ;
  connect?: StampCardWhereUniqueInput ;
}

export interface StampCardUpdateOneWithoutNameLangInput {
  create?: StampCardCreateWithoutNameLangInput ;
  update?: StampCardUpdateWithoutNameLangDataInput ;
  upsert?: StampCardUpsertWithoutNameLangInput ;
  disconnect?: boolean ;
  connect?: StampCardWhereUniqueInput ;
}

export interface StampCardUpdateOneWithoutStampsInput {
  create?: StampCardCreateWithoutStampsInput ;
  update?: StampCardUpdateWithoutStampsDataInput ;
  upsert?: StampCardUpsertWithoutStampsInput ;
  disconnect?: boolean ;
  connect?: StampCardWhereUniqueInput ;
}

export interface StampCardUpdateWithWhereUniqueWithoutCompanyInput {
  where: StampCardWhereUniqueInput;
  data: StampCardUpdateWithoutCompanyDataInput;
}

export interface StampCardUpdateWithWhereUniqueWithoutItemsInput {
  where: StampCardWhereUniqueInput;
  data: StampCardUpdateWithoutItemsDataInput;
}

export interface StampCardUpdateWithWhereUniqueWithoutOfferInput {
  where: StampCardWhereUniqueInput;
  data: StampCardUpdateWithoutOfferDataInput;
}

export interface StampCardUpdateWithWhereUniqueWithoutUsersInput {
  where: StampCardWhereUniqueInput;
  data: StampCardUpdateWithoutUsersDataInput;
}

export interface StampCardUpdateWithWhereUniqueWithoutVenuesInput {
  where: StampCardWhereUniqueInput;
  data: StampCardUpdateWithoutVenuesDataInput;
}

export interface StampCardUpdateWithoutCompanyDataInput {
  count?: number ;
  items?: ItemUpdateManyWithoutStampCardsInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutStampCardNameInput ;
  descriptionLang?: TranslatedStringUpdateOneWithoutStampcardDescriptionInput ;
  details?: TranslatedStringUpdateOneWithoutStampCardDetailsInput ;
  stamps?: StampUpdateManyWithoutStampCardInput ;
  users?: UserUpdateManyWithoutStampCardsInput ;
  deleted?: boolean ;
  venues?: VenueUpdateManyWithoutStampCardsInput ;
  default?: boolean ;
  offer?: OfferUpdateOneWithoutStampCardsInput ;
  icon?: string ;
}

export interface StampCardUpdateWithoutDescriptionLangDataInput {
  company?: CompanyUpdateOneWithoutStampCardsInput ;
  count?: number ;
  items?: ItemUpdateManyWithoutStampCardsInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutStampCardNameInput ;
  details?: TranslatedStringUpdateOneWithoutStampCardDetailsInput ;
  stamps?: StampUpdateManyWithoutStampCardInput ;
  users?: UserUpdateManyWithoutStampCardsInput ;
  deleted?: boolean ;
  venues?: VenueUpdateManyWithoutStampCardsInput ;
  default?: boolean ;
  offer?: OfferUpdateOneWithoutStampCardsInput ;
  icon?: string ;
}

export interface StampCardUpdateWithoutDetailsDataInput {
  company?: CompanyUpdateOneWithoutStampCardsInput ;
  count?: number ;
  items?: ItemUpdateManyWithoutStampCardsInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutStampCardNameInput ;
  descriptionLang?: TranslatedStringUpdateOneWithoutStampcardDescriptionInput ;
  stamps?: StampUpdateManyWithoutStampCardInput ;
  users?: UserUpdateManyWithoutStampCardsInput ;
  deleted?: boolean ;
  venues?: VenueUpdateManyWithoutStampCardsInput ;
  default?: boolean ;
  offer?: OfferUpdateOneWithoutStampCardsInput ;
  icon?: string ;
}

export interface StampCardUpdateWithoutItemsDataInput {
  company?: CompanyUpdateOneWithoutStampCardsInput ;
  count?: number ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutStampCardNameInput ;
  descriptionLang?: TranslatedStringUpdateOneWithoutStampcardDescriptionInput ;
  details?: TranslatedStringUpdateOneWithoutStampCardDetailsInput ;
  stamps?: StampUpdateManyWithoutStampCardInput ;
  users?: UserUpdateManyWithoutStampCardsInput ;
  deleted?: boolean ;
  venues?: VenueUpdateManyWithoutStampCardsInput ;
  default?: boolean ;
  offer?: OfferUpdateOneWithoutStampCardsInput ;
  icon?: string ;
}

export interface StampCardUpdateWithoutNameLangDataInput {
  company?: CompanyUpdateOneWithoutStampCardsInput ;
  count?: number ;
  items?: ItemUpdateManyWithoutStampCardsInput ;
  name?: string ;
  descriptionLang?: TranslatedStringUpdateOneWithoutStampcardDescriptionInput ;
  details?: TranslatedStringUpdateOneWithoutStampCardDetailsInput ;
  stamps?: StampUpdateManyWithoutStampCardInput ;
  users?: UserUpdateManyWithoutStampCardsInput ;
  deleted?: boolean ;
  venues?: VenueUpdateManyWithoutStampCardsInput ;
  default?: boolean ;
  offer?: OfferUpdateOneWithoutStampCardsInput ;
  icon?: string ;
}

export interface StampCardUpdateWithoutOfferDataInput {
  company?: CompanyUpdateOneWithoutStampCardsInput ;
  count?: number ;
  items?: ItemUpdateManyWithoutStampCardsInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutStampCardNameInput ;
  descriptionLang?: TranslatedStringUpdateOneWithoutStampcardDescriptionInput ;
  details?: TranslatedStringUpdateOneWithoutStampCardDetailsInput ;
  stamps?: StampUpdateManyWithoutStampCardInput ;
  users?: UserUpdateManyWithoutStampCardsInput ;
  deleted?: boolean ;
  venues?: VenueUpdateManyWithoutStampCardsInput ;
  default?: boolean ;
  icon?: string ;
}

export interface StampCardUpdateWithoutStampsDataInput {
  company?: CompanyUpdateOneWithoutStampCardsInput ;
  count?: number ;
  items?: ItemUpdateManyWithoutStampCardsInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutStampCardNameInput ;
  descriptionLang?: TranslatedStringUpdateOneWithoutStampcardDescriptionInput ;
  details?: TranslatedStringUpdateOneWithoutStampCardDetailsInput ;
  users?: UserUpdateManyWithoutStampCardsInput ;
  deleted?: boolean ;
  venues?: VenueUpdateManyWithoutStampCardsInput ;
  default?: boolean ;
  offer?: OfferUpdateOneWithoutStampCardsInput ;
  icon?: string ;
}

export interface StampCardUpdateWithoutUsersDataInput {
  company?: CompanyUpdateOneWithoutStampCardsInput ;
  count?: number ;
  items?: ItemUpdateManyWithoutStampCardsInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutStampCardNameInput ;
  descriptionLang?: TranslatedStringUpdateOneWithoutStampcardDescriptionInput ;
  details?: TranslatedStringUpdateOneWithoutStampCardDetailsInput ;
  stamps?: StampUpdateManyWithoutStampCardInput ;
  deleted?: boolean ;
  venues?: VenueUpdateManyWithoutStampCardsInput ;
  default?: boolean ;
  offer?: OfferUpdateOneWithoutStampCardsInput ;
  icon?: string ;
}

export interface StampCardUpdateWithoutVenuesDataInput {
  company?: CompanyUpdateOneWithoutStampCardsInput ;
  count?: number ;
  items?: ItemUpdateManyWithoutStampCardsInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutStampCardNameInput ;
  descriptionLang?: TranslatedStringUpdateOneWithoutStampcardDescriptionInput ;
  details?: TranslatedStringUpdateOneWithoutStampCardDetailsInput ;
  stamps?: StampUpdateManyWithoutStampCardInput ;
  users?: UserUpdateManyWithoutStampCardsInput ;
  deleted?: boolean ;
  default?: boolean ;
  offer?: OfferUpdateOneWithoutStampCardsInput ;
  icon?: string ;
}

export interface StampCardUpsertWithWhereUniqueWithoutCompanyInput {
  where: StampCardWhereUniqueInput;
  update: StampCardUpdateWithoutCompanyDataInput;
  create: StampCardCreateWithoutCompanyInput;
}

export interface StampCardUpsertWithWhereUniqueWithoutItemsInput {
  where: StampCardWhereUniqueInput;
  update: StampCardUpdateWithoutItemsDataInput;
  create: StampCardCreateWithoutItemsInput;
}

export interface StampCardUpsertWithWhereUniqueWithoutOfferInput {
  where: StampCardWhereUniqueInput;
  update: StampCardUpdateWithoutOfferDataInput;
  create: StampCardCreateWithoutOfferInput;
}

export interface StampCardUpsertWithWhereUniqueWithoutUsersInput {
  where: StampCardWhereUniqueInput;
  update: StampCardUpdateWithoutUsersDataInput;
  create: StampCardCreateWithoutUsersInput;
}

export interface StampCardUpsertWithWhereUniqueWithoutVenuesInput {
  where: StampCardWhereUniqueInput;
  update: StampCardUpdateWithoutVenuesDataInput;
  create: StampCardCreateWithoutVenuesInput;
}

export interface StampCardUpsertWithoutDescriptionLangInput {
  update: StampCardUpdateWithoutDescriptionLangDataInput;
  create: StampCardCreateWithoutDescriptionLangInput;
}

export interface StampCardUpsertWithoutDetailsInput {
  update: StampCardUpdateWithoutDetailsDataInput;
  create: StampCardCreateWithoutDetailsInput;
}

export interface StampCardUpsertWithoutNameLangInput {
  update: StampCardUpdateWithoutNameLangDataInput;
  create: StampCardCreateWithoutNameLangInput;
}

export interface StampCardUpsertWithoutStampsInput {
  update: StampCardUpdateWithoutStampsDataInput;
  create: StampCardCreateWithoutStampsInput;
}

export interface StampCardWhereInput {
  company?: CompanyWhereInput ;
  count?: number ;
  count_not?: number ;
  count_in?: number[] ;
  count_not_in?: number[] ;
  count_lt?: number ;
  count_lte?: number ;
  count_gt?: number ;
  count_gte?: number ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  items_every?: ItemWhereInput ;
  items_some?: ItemWhereInput ;
  items_none?: ItemWhereInput ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  nameLang?: TranslatedStringWhereInput ;
  descriptionLang?: TranslatedStringWhereInput ;
  details?: TranslatedStringWhereInput ;
  stamps_every?: StampWhereInput ;
  stamps_some?: StampWhereInput ;
  stamps_none?: StampWhereInput ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  users_every?: UserWhereInput ;
  users_some?: UserWhereInput ;
  users_none?: UserWhereInput ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  venues_every?: VenueWhereInput ;
  venues_some?: VenueWhereInput ;
  venues_none?: VenueWhereInput ;
  default?: boolean ;
  default_not?: boolean ;
  offer?: OfferWhereInput ;
  icon?: string ;
  icon_not?: string ;
  icon_in?: string[] ;
  icon_not_in?: string[] ;
  icon_lt?: string ;
  icon_lte?: string ;
  icon_gt?: string ;
  icon_gte?: string ;
  icon_contains?: string ;
  icon_not_contains?: string ;
  icon_starts_with?: string ;
  icon_not_starts_with?: string ;
  icon_ends_with?: string ;
  icon_not_ends_with?: string ;
  AND?: StampCardWhereInput[] ;
  OR?: StampCardWhereInput[] ;
  NOT?: StampCardWhereInput[] ;
}

export interface StampCardWhereUniqueInput {
  id?: string ;
}

export interface StampCreateManyWithoutStampCardInput {
  create?: StampCreateWithoutStampCardInput[] ;
  connect?: StampWhereUniqueInput[] ;
}

export interface StampCreateManyWithoutUserInput {
  create?: StampCreateWithoutUserInput[] ;
  connect?: StampWhereUniqueInput[] ;
}

export interface StampCreateWithoutStampCardInput {
  id?: string ;
  seen?: boolean ;
  user?: UserCreateOneWithoutStampsInput ;
}

export interface StampCreateWithoutUserInput {
  id?: string ;
  seen?: boolean ;
  stampCard?: StampCardCreateOneWithoutStampsInput ;
}

export interface StampScalarWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  seen?: boolean ;
  seen_not?: boolean ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  AND?: StampScalarWhereInput[] ;
  OR?: StampScalarWhereInput[] ;
  NOT?: StampScalarWhereInput[] ;
}

export interface StampUpdateManyDataInput {
  seen?: boolean ;
}

export interface StampUpdateManyWithWhereNestedInput {
  where: StampScalarWhereInput;
  data: StampUpdateManyDataInput;
}

export interface StampUpdateManyWithoutStampCardInput {
  create?: StampCreateWithoutStampCardInput[] ;
  connect?: StampWhereUniqueInput[] ;
  set?: StampWhereUniqueInput[] ;
  disconnect?: StampWhereUniqueInput[] ;
  update?: StampUpdateWithWhereUniqueWithoutStampCardInput[] ;
  upsert?: StampUpsertWithWhereUniqueWithoutStampCardInput[] ;
  deleteMany?: StampScalarWhereInput[] ;
  updateMany?: StampUpdateManyWithWhereNestedInput[] ;
}

export interface StampUpdateManyWithoutUserInput {
  create?: StampCreateWithoutUserInput[] ;
  connect?: StampWhereUniqueInput[] ;
  set?: StampWhereUniqueInput[] ;
  disconnect?: StampWhereUniqueInput[] ;
  update?: StampUpdateWithWhereUniqueWithoutUserInput[] ;
  upsert?: StampUpsertWithWhereUniqueWithoutUserInput[] ;
  deleteMany?: StampScalarWhereInput[] ;
  updateMany?: StampUpdateManyWithWhereNestedInput[] ;
}

export interface StampUpdateWithWhereUniqueWithoutStampCardInput {
  where: StampWhereUniqueInput;
  data: StampUpdateWithoutStampCardDataInput;
}

export interface StampUpdateWithWhereUniqueWithoutUserInput {
  where: StampWhereUniqueInput;
  data: StampUpdateWithoutUserDataInput;
}

export interface StampUpdateWithoutStampCardDataInput {
  seen?: boolean ;
  user?: UserUpdateOneWithoutStampsInput ;
}

export interface StampUpdateWithoutUserDataInput {
  seen?: boolean ;
  stampCard?: StampCardUpdateOneWithoutStampsInput ;
}

export interface StampUpsertWithWhereUniqueWithoutStampCardInput {
  where: StampWhereUniqueInput;
  update: StampUpdateWithoutStampCardDataInput;
  create: StampCreateWithoutStampCardInput;
}

export interface StampUpsertWithWhereUniqueWithoutUserInput {
  where: StampWhereUniqueInput;
  update: StampUpdateWithoutUserDataInput;
  create: StampCreateWithoutUserInput;
}

export interface StampWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  seen?: boolean ;
  seen_not?: boolean ;
  stampCard?: StampCardWhereInput ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  user?: UserWhereInput ;
  AND?: StampWhereInput[] ;
  OR?: StampWhereInput[] ;
  NOT?: StampWhereInput[] ;
}

export interface StampWhereUniqueInput {
  id?: string ;
}

export interface StationCreateInput {
  id?: string ;
  name: string;
  company: CompanyCreateOneWithoutStationsInput;
  items?: ItemCreateManyWithoutStationsInput ;
  categories?: CategoryCreateManyWithoutStationsInput ;
  orderStatuses?: StationCreateorderStatusesInput ;
  deleted?: boolean ;
  showAllItems?: boolean ;
  type?: STATION_TYPE ;
  origin?: StationCreateoriginInput ;
  serviceType?: StationCreateserviceTypeInput ;
}

export interface StationCreateManyWithoutCategoriesInput {
  create?: StationCreateWithoutCategoriesInput[] ;
  connect?: StationWhereUniqueInput[] ;
}

export interface StationCreateManyWithoutCompanyInput {
  create?: StationCreateWithoutCompanyInput[] ;
  connect?: StationWhereUniqueInput[] ;
}

export interface StationCreateManyWithoutItemsInput {
  create?: StationCreateWithoutItemsInput[] ;
  connect?: StationWhereUniqueInput[] ;
}

export interface StationCreateWithoutCategoriesInput {
  id?: string ;
  name: string;
  company: CompanyCreateOneWithoutStationsInput;
  items?: ItemCreateManyWithoutStationsInput ;
  orderStatuses?: StationCreateorderStatusesInput ;
  deleted?: boolean ;
  showAllItems?: boolean ;
  type?: STATION_TYPE ;
  origin?: StationCreateoriginInput ;
  serviceType?: StationCreateserviceTypeInput ;
}

export interface StationCreateWithoutCompanyInput {
  id?: string ;
  name: string;
  items?: ItemCreateManyWithoutStationsInput ;
  categories?: CategoryCreateManyWithoutStationsInput ;
  orderStatuses?: StationCreateorderStatusesInput ;
  deleted?: boolean ;
  showAllItems?: boolean ;
  type?: STATION_TYPE ;
  origin?: StationCreateoriginInput ;
  serviceType?: StationCreateserviceTypeInput ;
}

export interface StationCreateWithoutItemsInput {
  id?: string ;
  name: string;
  company: CompanyCreateOneWithoutStationsInput;
  categories?: CategoryCreateManyWithoutStationsInput ;
  orderStatuses?: StationCreateorderStatusesInput ;
  deleted?: boolean ;
  showAllItems?: boolean ;
  type?: STATION_TYPE ;
  origin?: StationCreateoriginInput ;
  serviceType?: StationCreateserviceTypeInput ;
}

export interface StationCreateorderStatusesInput {
  set?: ORDER_STATUS[] ;
}

export interface StationCreateoriginInput {
  set?: ORDER_ORIGIN[] ;
}

export interface StationCreateserviceTypeInput {
  set?: SERVICE_TYPE[] ;
}

export interface StationScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  showAllItems?: boolean ;
  showAllItems_not?: boolean ;
  type?: STATION_TYPE ;
  type_not?: STATION_TYPE ;
  type_in?: STATION_TYPE[] ;
  type_not_in?: STATION_TYPE[] ;
  AND?: StationScalarWhereInput[] ;
  OR?: StationScalarWhereInput[] ;
  NOT?: StationScalarWhereInput[] ;
}

export interface StationUpdateInput {
  name?: string ;
  company?: CompanyUpdateOneRequiredWithoutStationsInput ;
  items?: ItemUpdateManyWithoutStationsInput ;
  categories?: CategoryUpdateManyWithoutStationsInput ;
  orderStatuses?: StationUpdateorderStatusesInput ;
  deleted?: boolean ;
  showAllItems?: boolean ;
  type?: STATION_TYPE ;
  origin?: StationUpdateoriginInput ;
  serviceType?: StationUpdateserviceTypeInput ;
}

export interface StationUpdateManyDataInput {
  name?: string ;
  orderStatuses?: StationUpdateorderStatusesInput ;
  deleted?: boolean ;
  showAllItems?: boolean ;
  type?: STATION_TYPE ;
  origin?: StationUpdateoriginInput ;
  serviceType?: StationUpdateserviceTypeInput ;
}

export interface StationUpdateManyWithWhereNestedInput {
  where: StationScalarWhereInput;
  data: StationUpdateManyDataInput;
}

export interface StationUpdateManyWithoutCategoriesInput {
  create?: StationCreateWithoutCategoriesInput[] ;
  connect?: StationWhereUniqueInput[] ;
  set?: StationWhereUniqueInput[] ;
  disconnect?: StationWhereUniqueInput[] ;
  update?: StationUpdateWithWhereUniqueWithoutCategoriesInput[] ;
  upsert?: StationUpsertWithWhereUniqueWithoutCategoriesInput[] ;
  deleteMany?: StationScalarWhereInput[] ;
  updateMany?: StationUpdateManyWithWhereNestedInput[] ;
}

export interface StationUpdateManyWithoutCompanyInput {
  create?: StationCreateWithoutCompanyInput[] ;
  connect?: StationWhereUniqueInput[] ;
  set?: StationWhereUniqueInput[] ;
  disconnect?: StationWhereUniqueInput[] ;
  update?: StationUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: StationUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: StationScalarWhereInput[] ;
  updateMany?: StationUpdateManyWithWhereNestedInput[] ;
}

export interface StationUpdateManyWithoutItemsInput {
  create?: StationCreateWithoutItemsInput[] ;
  connect?: StationWhereUniqueInput[] ;
  set?: StationWhereUniqueInput[] ;
  disconnect?: StationWhereUniqueInput[] ;
  update?: StationUpdateWithWhereUniqueWithoutItemsInput[] ;
  upsert?: StationUpsertWithWhereUniqueWithoutItemsInput[] ;
  deleteMany?: StationScalarWhereInput[] ;
  updateMany?: StationUpdateManyWithWhereNestedInput[] ;
}

export interface StationUpdateWithWhereUniqueWithoutCategoriesInput {
  where: StationWhereUniqueInput;
  data: StationUpdateWithoutCategoriesDataInput;
}

export interface StationUpdateWithWhereUniqueWithoutCompanyInput {
  where: StationWhereUniqueInput;
  data: StationUpdateWithoutCompanyDataInput;
}

export interface StationUpdateWithWhereUniqueWithoutItemsInput {
  where: StationWhereUniqueInput;
  data: StationUpdateWithoutItemsDataInput;
}

export interface StationUpdateWithoutCategoriesDataInput {
  name?: string ;
  company?: CompanyUpdateOneRequiredWithoutStationsInput ;
  items?: ItemUpdateManyWithoutStationsInput ;
  orderStatuses?: StationUpdateorderStatusesInput ;
  deleted?: boolean ;
  showAllItems?: boolean ;
  type?: STATION_TYPE ;
  origin?: StationUpdateoriginInput ;
  serviceType?: StationUpdateserviceTypeInput ;
}

export interface StationUpdateWithoutCompanyDataInput {
  name?: string ;
  items?: ItemUpdateManyWithoutStationsInput ;
  categories?: CategoryUpdateManyWithoutStationsInput ;
  orderStatuses?: StationUpdateorderStatusesInput ;
  deleted?: boolean ;
  showAllItems?: boolean ;
  type?: STATION_TYPE ;
  origin?: StationUpdateoriginInput ;
  serviceType?: StationUpdateserviceTypeInput ;
}

export interface StationUpdateWithoutItemsDataInput {
  name?: string ;
  company?: CompanyUpdateOneRequiredWithoutStationsInput ;
  categories?: CategoryUpdateManyWithoutStationsInput ;
  orderStatuses?: StationUpdateorderStatusesInput ;
  deleted?: boolean ;
  showAllItems?: boolean ;
  type?: STATION_TYPE ;
  origin?: StationUpdateoriginInput ;
  serviceType?: StationUpdateserviceTypeInput ;
}

export interface StationUpdateorderStatusesInput {
  set?: ORDER_STATUS[] ;
}

export interface StationUpdateoriginInput {
  set?: ORDER_ORIGIN[] ;
}

export interface StationUpdateserviceTypeInput {
  set?: SERVICE_TYPE[] ;
}

export interface StationUpsertWithWhereUniqueWithoutCategoriesInput {
  where: StationWhereUniqueInput;
  update: StationUpdateWithoutCategoriesDataInput;
  create: StationCreateWithoutCategoriesInput;
}

export interface StationUpsertWithWhereUniqueWithoutCompanyInput {
  where: StationWhereUniqueInput;
  update: StationUpdateWithoutCompanyDataInput;
  create: StationCreateWithoutCompanyInput;
}

export interface StationUpsertWithWhereUniqueWithoutItemsInput {
  where: StationWhereUniqueInput;
  update: StationUpdateWithoutItemsDataInput;
  create: StationCreateWithoutItemsInput;
}

export interface StationWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  company?: CompanyWhereInput ;
  items_every?: ItemWhereInput ;
  items_some?: ItemWhereInput ;
  items_none?: ItemWhereInput ;
  categories_every?: CategoryWhereInput ;
  categories_some?: CategoryWhereInput ;
  categories_none?: CategoryWhereInput ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  showAllItems?: boolean ;
  showAllItems_not?: boolean ;
  type?: STATION_TYPE ;
  type_not?: STATION_TYPE ;
  type_in?: STATION_TYPE[] ;
  type_not_in?: STATION_TYPE[] ;
  AND?: StationWhereInput[] ;
  OR?: StationWhereInput[] ;
  NOT?: StationWhereInput[] ;
}

export interface StationWhereUniqueInput {
  id?: string ;
}

export interface SubPaymentCreateManyWithoutPaymentInput {
  create?: SubPaymentCreateWithoutPaymentInput[] ;
  connect?: SubPaymentWhereUniqueInput[] ;
}

export interface SubPaymentCreateWithoutPaymentInput {
  id?: string ;
  refunded?: number ;
  amount: number;
  status?: PAYMENT_STATUS ;
  tip?: number ;
  correctedTip?: number ;
  type: string;
  transactionId?: string ;
}

export interface SubPaymentScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  refunded?: number ;
  refunded_not?: number ;
  refunded_in?: number[] ;
  refunded_not_in?: number[] ;
  refunded_lt?: number ;
  refunded_lte?: number ;
  refunded_gt?: number ;
  refunded_gte?: number ;
  amount?: number ;
  amount_not?: number ;
  amount_in?: number[] ;
  amount_not_in?: number[] ;
  amount_lt?: number ;
  amount_lte?: number ;
  amount_gt?: number ;
  amount_gte?: number ;
  status?: PAYMENT_STATUS ;
  status_not?: PAYMENT_STATUS ;
  status_in?: PAYMENT_STATUS[] ;
  status_not_in?: PAYMENT_STATUS[] ;
  tip?: number ;
  tip_not?: number ;
  tip_in?: number[] ;
  tip_not_in?: number[] ;
  tip_lt?: number ;
  tip_lte?: number ;
  tip_gt?: number ;
  tip_gte?: number ;
  correctedTip?: number ;
  correctedTip_not?: number ;
  correctedTip_in?: number[] ;
  correctedTip_not_in?: number[] ;
  correctedTip_lt?: number ;
  correctedTip_lte?: number ;
  correctedTip_gt?: number ;
  correctedTip_gte?: number ;
  type?: string ;
  type_not?: string ;
  type_in?: string[] ;
  type_not_in?: string[] ;
  type_lt?: string ;
  type_lte?: string ;
  type_gt?: string ;
  type_gte?: string ;
  type_contains?: string ;
  type_not_contains?: string ;
  type_starts_with?: string ;
  type_not_starts_with?: string ;
  type_ends_with?: string ;
  type_not_ends_with?: string ;
  transactionId?: string ;
  transactionId_not?: string ;
  transactionId_in?: string[] ;
  transactionId_not_in?: string[] ;
  transactionId_lt?: string ;
  transactionId_lte?: string ;
  transactionId_gt?: string ;
  transactionId_gte?: string ;
  transactionId_contains?: string ;
  transactionId_not_contains?: string ;
  transactionId_starts_with?: string ;
  transactionId_not_starts_with?: string ;
  transactionId_ends_with?: string ;
  transactionId_not_ends_with?: string ;
  AND?: SubPaymentScalarWhereInput[] ;
  OR?: SubPaymentScalarWhereInput[] ;
  NOT?: SubPaymentScalarWhereInput[] ;
}

export interface SubPaymentUpdateManyDataInput {
  refunded?: number ;
  amount?: number ;
  status?: PAYMENT_STATUS ;
  tip?: number ;
  correctedTip?: number ;
  type?: string ;
  transactionId?: string ;
}

export interface SubPaymentUpdateManyWithWhereNestedInput {
  where: SubPaymentScalarWhereInput;
  data: SubPaymentUpdateManyDataInput;
}

export interface SubPaymentUpdateManyWithoutPaymentInput {
  create?: SubPaymentCreateWithoutPaymentInput[] ;
  connect?: SubPaymentWhereUniqueInput[] ;
  set?: SubPaymentWhereUniqueInput[] ;
  disconnect?: SubPaymentWhereUniqueInput[] ;
  update?: SubPaymentUpdateWithWhereUniqueWithoutPaymentInput[] ;
  upsert?: SubPaymentUpsertWithWhereUniqueWithoutPaymentInput[] ;
  deleteMany?: SubPaymentScalarWhereInput[] ;
  updateMany?: SubPaymentUpdateManyWithWhereNestedInput[] ;
}

export interface SubPaymentUpdateWithWhereUniqueWithoutPaymentInput {
  where: SubPaymentWhereUniqueInput;
  data: SubPaymentUpdateWithoutPaymentDataInput;
}

export interface SubPaymentUpdateWithoutPaymentDataInput {
  refunded?: number ;
  amount?: number ;
  status?: PAYMENT_STATUS ;
  tip?: number ;
  correctedTip?: number ;
  type?: string ;
  transactionId?: string ;
}

export interface SubPaymentUpsertWithWhereUniqueWithoutPaymentInput {
  where: SubPaymentWhereUniqueInput;
  update: SubPaymentUpdateWithoutPaymentDataInput;
  create: SubPaymentCreateWithoutPaymentInput;
}

export interface SubPaymentWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  refunded?: number ;
  refunded_not?: number ;
  refunded_in?: number[] ;
  refunded_not_in?: number[] ;
  refunded_lt?: number ;
  refunded_lte?: number ;
  refunded_gt?: number ;
  refunded_gte?: number ;
  amount?: number ;
  amount_not?: number ;
  amount_in?: number[] ;
  amount_not_in?: number[] ;
  amount_lt?: number ;
  amount_lte?: number ;
  amount_gt?: number ;
  amount_gte?: number ;
  payment?: PaymentWhereInput ;
  status?: PAYMENT_STATUS ;
  status_not?: PAYMENT_STATUS ;
  status_in?: PAYMENT_STATUS[] ;
  status_not_in?: PAYMENT_STATUS[] ;
  tip?: number ;
  tip_not?: number ;
  tip_in?: number[] ;
  tip_not_in?: number[] ;
  tip_lt?: number ;
  tip_lte?: number ;
  tip_gt?: number ;
  tip_gte?: number ;
  correctedTip?: number ;
  correctedTip_not?: number ;
  correctedTip_in?: number[] ;
  correctedTip_not_in?: number[] ;
  correctedTip_lt?: number ;
  correctedTip_lte?: number ;
  correctedTip_gt?: number ;
  correctedTip_gte?: number ;
  type?: string ;
  type_not?: string ;
  type_in?: string[] ;
  type_not_in?: string[] ;
  type_lt?: string ;
  type_lte?: string ;
  type_gt?: string ;
  type_gte?: string ;
  type_contains?: string ;
  type_not_contains?: string ;
  type_starts_with?: string ;
  type_not_starts_with?: string ;
  type_ends_with?: string ;
  type_not_ends_with?: string ;
  transactionId?: string ;
  transactionId_not?: string ;
  transactionId_in?: string[] ;
  transactionId_not_in?: string[] ;
  transactionId_lt?: string ;
  transactionId_lte?: string ;
  transactionId_gt?: string ;
  transactionId_gte?: string ;
  transactionId_contains?: string ;
  transactionId_not_contains?: string ;
  transactionId_starts_with?: string ;
  transactionId_not_starts_with?: string ;
  transactionId_ends_with?: string ;
  transactionId_not_ends_with?: string ;
  AND?: SubPaymentWhereInput[] ;
  OR?: SubPaymentWhereInput[] ;
  NOT?: SubPaymentWhereInput[] ;
}

export interface SubPaymentWhereUniqueInput {
  id?: string ;
}

export interface SubmitIntegrationFormFieldData {
  provider: string;
  formId: string;
  value: string;
  companyId?: string ;
  venueId?: string ;
  relatedId?: string ;
}

export interface TableCreateInput {
  id?: string ;
  deleted?: boolean ;
  venue: VenueCreateOneWithoutTablesInput;
  floorPlan?: FloorPlanCreateOneWithoutTablesInput ;
  reservations?: ReservationCreateManyWithoutTableInput ;
  sessions?: TableSessionCreateManyWithoutTableInput ;
  session?: TableSessionCreateOneWithoutTableActiveInput ;
  users?: UserCreateManyWithoutTableInput ;
  code: string;
  capacity?: number ;
  posX?: number ;
  posY?: number ;
  width?: number ;
  height?: number ;
  rotation?: number ;
}

export interface TableCreateManyInput {
  create?: TableCreateInput[] ;
  connect?: TableWhereUniqueInput[] ;
}

export interface TableCreateManyWithoutFloorPlanInput {
  create?: TableCreateWithoutFloorPlanInput[] ;
  connect?: TableWhereUniqueInput[] ;
}

export interface TableCreateManyWithoutVenueInput {
  create?: TableCreateWithoutVenueInput[] ;
  connect?: TableWhereUniqueInput[] ;
}

export interface TableCreateOneWithoutReservationsInput {
  create?: TableCreateWithoutReservationsInput ;
  connect?: TableWhereUniqueInput ;
}

export interface TableCreateOneWithoutSessionInput {
  create?: TableCreateWithoutSessionInput ;
  connect?: TableWhereUniqueInput ;
}

export interface TableCreateOneWithoutSessionsInput {
  create?: TableCreateWithoutSessionsInput ;
  connect?: TableWhereUniqueInput ;
}

export interface TableCreateOneWithoutUsersInput {
  create?: TableCreateWithoutUsersInput ;
  connect?: TableWhereUniqueInput ;
}

export interface TableCreateWithoutFloorPlanInput {
  id?: string ;
  deleted?: boolean ;
  venue: VenueCreateOneWithoutTablesInput;
  reservations?: ReservationCreateManyWithoutTableInput ;
  sessions?: TableSessionCreateManyWithoutTableInput ;
  session?: TableSessionCreateOneWithoutTableActiveInput ;
  users?: UserCreateManyWithoutTableInput ;
  code: string;
  capacity?: number ;
  posX?: number ;
  posY?: number ;
  width?: number ;
  height?: number ;
  rotation?: number ;
}

export interface TableCreateWithoutReservationsInput {
  id?: string ;
  deleted?: boolean ;
  venue: VenueCreateOneWithoutTablesInput;
  floorPlan?: FloorPlanCreateOneWithoutTablesInput ;
  sessions?: TableSessionCreateManyWithoutTableInput ;
  session?: TableSessionCreateOneWithoutTableActiveInput ;
  users?: UserCreateManyWithoutTableInput ;
  code: string;
  capacity?: number ;
  posX?: number ;
  posY?: number ;
  width?: number ;
  height?: number ;
  rotation?: number ;
}

export interface TableCreateWithoutSessionInput {
  id?: string ;
  deleted?: boolean ;
  venue: VenueCreateOneWithoutTablesInput;
  floorPlan?: FloorPlanCreateOneWithoutTablesInput ;
  reservations?: ReservationCreateManyWithoutTableInput ;
  sessions?: TableSessionCreateManyWithoutTableInput ;
  users?: UserCreateManyWithoutTableInput ;
  code: string;
  capacity?: number ;
  posX?: number ;
  posY?: number ;
  width?: number ;
  height?: number ;
  rotation?: number ;
}

export interface TableCreateWithoutSessionsInput {
  id?: string ;
  deleted?: boolean ;
  venue: VenueCreateOneWithoutTablesInput;
  floorPlan?: FloorPlanCreateOneWithoutTablesInput ;
  reservations?: ReservationCreateManyWithoutTableInput ;
  session?: TableSessionCreateOneWithoutTableActiveInput ;
  users?: UserCreateManyWithoutTableInput ;
  code: string;
  capacity?: number ;
  posX?: number ;
  posY?: number ;
  width?: number ;
  height?: number ;
  rotation?: number ;
}

export interface TableCreateWithoutUsersInput {
  id?: string ;
  deleted?: boolean ;
  venue: VenueCreateOneWithoutTablesInput;
  floorPlan?: FloorPlanCreateOneWithoutTablesInput ;
  reservations?: ReservationCreateManyWithoutTableInput ;
  sessions?: TableSessionCreateManyWithoutTableInput ;
  session?: TableSessionCreateOneWithoutTableActiveInput ;
  code: string;
  capacity?: number ;
  posX?: number ;
  posY?: number ;
  width?: number ;
  height?: number ;
  rotation?: number ;
}

export interface TableCreateWithoutVenueInput {
  id?: string ;
  deleted?: boolean ;
  floorPlan?: FloorPlanCreateOneWithoutTablesInput ;
  reservations?: ReservationCreateManyWithoutTableInput ;
  sessions?: TableSessionCreateManyWithoutTableInput ;
  session?: TableSessionCreateOneWithoutTableActiveInput ;
  users?: UserCreateManyWithoutTableInput ;
  code: string;
  capacity?: number ;
  posX?: number ;
  posY?: number ;
  width?: number ;
  height?: number ;
  rotation?: number ;
}

export interface TablePaymentSettingCreateManyWithoutTableSessionInput {
  create?: TablePaymentSettingCreateWithoutTableSessionInput[] ;
  connect?: TablePaymentSettingWhereUniqueInput[] ;
}

export interface TablePaymentSettingCreateManyWithoutUserInput {
  create?: TablePaymentSettingCreateWithoutUserInput[] ;
  connect?: TablePaymentSettingWhereUniqueInput[] ;
}

export interface TablePaymentSettingCreateOneWithoutPaymentInput {
  create?: TablePaymentSettingCreateWithoutPaymentInput ;
  connect?: TablePaymentSettingWhereUniqueInput ;
}

export interface TablePaymentSettingCreateOneWithoutSelectedItemsInput {
  create?: TablePaymentSettingCreateWithoutSelectedItemsInput ;
  connect?: TablePaymentSettingWhereUniqueInput ;
}

export interface TablePaymentSettingCreateOneWithoutUserActiveInput {
  create?: TablePaymentSettingCreateWithoutUserActiveInput ;
  connect?: TablePaymentSettingWhereUniqueInput ;
}

export interface TablePaymentSettingCreateWithoutPaymentInput {
  id?: string ;
  userActive?: UserCreateOneWithoutTablePaymentSettingsInput ;
  user: UserCreateOneWithoutTablePaymentSettingsHistoryInput;
  tableSession: TableSessionCreateOneWithoutUserPaymentSettingsInput;
  paymentMethod: string;
  tip?: number ;
  billPaymentType?: BILL_PAYMENT_TYPE ;
  selectedItems?: OrderItemCreateManyWithoutSelectedForPaymentByUserInput ;
}

export interface TablePaymentSettingCreateWithoutSelectedItemsInput {
  id?: string ;
  userActive?: UserCreateOneWithoutTablePaymentSettingsInput ;
  user: UserCreateOneWithoutTablePaymentSettingsHistoryInput;
  tableSession: TableSessionCreateOneWithoutUserPaymentSettingsInput;
  paymentMethod: string;
  payment?: PaymentCreateOneWithoutTablePaymentInput ;
  tip?: number ;
  billPaymentType?: BILL_PAYMENT_TYPE ;
}

export interface TablePaymentSettingCreateWithoutTableSessionInput {
  id?: string ;
  userActive?: UserCreateOneWithoutTablePaymentSettingsInput ;
  user: UserCreateOneWithoutTablePaymentSettingsHistoryInput;
  paymentMethod: string;
  payment?: PaymentCreateOneWithoutTablePaymentInput ;
  tip?: number ;
  billPaymentType?: BILL_PAYMENT_TYPE ;
  selectedItems?: OrderItemCreateManyWithoutSelectedForPaymentByUserInput ;
}

export interface TablePaymentSettingCreateWithoutUserActiveInput {
  id?: string ;
  user: UserCreateOneWithoutTablePaymentSettingsHistoryInput;
  tableSession: TableSessionCreateOneWithoutUserPaymentSettingsInput;
  paymentMethod: string;
  payment?: PaymentCreateOneWithoutTablePaymentInput ;
  tip?: number ;
  billPaymentType?: BILL_PAYMENT_TYPE ;
  selectedItems?: OrderItemCreateManyWithoutSelectedForPaymentByUserInput ;
}

export interface TablePaymentSettingCreateWithoutUserInput {
  id?: string ;
  userActive?: UserCreateOneWithoutTablePaymentSettingsInput ;
  tableSession: TableSessionCreateOneWithoutUserPaymentSettingsInput;
  paymentMethod: string;
  payment?: PaymentCreateOneWithoutTablePaymentInput ;
  tip?: number ;
  billPaymentType?: BILL_PAYMENT_TYPE ;
  selectedItems?: OrderItemCreateManyWithoutSelectedForPaymentByUserInput ;
}

export interface TablePaymentSettingScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  paymentMethod?: string ;
  paymentMethod_not?: string ;
  paymentMethod_in?: string[] ;
  paymentMethod_not_in?: string[] ;
  paymentMethod_lt?: string ;
  paymentMethod_lte?: string ;
  paymentMethod_gt?: string ;
  paymentMethod_gte?: string ;
  paymentMethod_contains?: string ;
  paymentMethod_not_contains?: string ;
  paymentMethod_starts_with?: string ;
  paymentMethod_not_starts_with?: string ;
  paymentMethod_ends_with?: string ;
  paymentMethod_not_ends_with?: string ;
  tip?: number ;
  tip_not?: number ;
  tip_in?: number[] ;
  tip_not_in?: number[] ;
  tip_lt?: number ;
  tip_lte?: number ;
  tip_gt?: number ;
  tip_gte?: number ;
  billPaymentType?: BILL_PAYMENT_TYPE ;
  billPaymentType_not?: BILL_PAYMENT_TYPE ;
  billPaymentType_in?: BILL_PAYMENT_TYPE[] ;
  billPaymentType_not_in?: BILL_PAYMENT_TYPE[] ;
  AND?: TablePaymentSettingScalarWhereInput[] ;
  OR?: TablePaymentSettingScalarWhereInput[] ;
  NOT?: TablePaymentSettingScalarWhereInput[] ;
}

export interface TablePaymentSettingUpdateManyDataInput {
  paymentMethod?: string ;
  tip?: number ;
  billPaymentType?: BILL_PAYMENT_TYPE ;
}

export interface TablePaymentSettingUpdateManyWithWhereNestedInput {
  where: TablePaymentSettingScalarWhereInput;
  data: TablePaymentSettingUpdateManyDataInput;
}

export interface TablePaymentSettingUpdateManyWithoutTableSessionInput {
  create?: TablePaymentSettingCreateWithoutTableSessionInput[] ;
  connect?: TablePaymentSettingWhereUniqueInput[] ;
  set?: TablePaymentSettingWhereUniqueInput[] ;
  disconnect?: TablePaymentSettingWhereUniqueInput[] ;
  update?: TablePaymentSettingUpdateWithWhereUniqueWithoutTableSessionInput[] ;
  upsert?: TablePaymentSettingUpsertWithWhereUniqueWithoutTableSessionInput[] ;
  deleteMany?: TablePaymentSettingScalarWhereInput[] ;
  updateMany?: TablePaymentSettingUpdateManyWithWhereNestedInput[] ;
}

export interface TablePaymentSettingUpdateManyWithoutUserInput {
  create?: TablePaymentSettingCreateWithoutUserInput[] ;
  connect?: TablePaymentSettingWhereUniqueInput[] ;
  set?: TablePaymentSettingWhereUniqueInput[] ;
  disconnect?: TablePaymentSettingWhereUniqueInput[] ;
  update?: TablePaymentSettingUpdateWithWhereUniqueWithoutUserInput[] ;
  upsert?: TablePaymentSettingUpsertWithWhereUniqueWithoutUserInput[] ;
  deleteMany?: TablePaymentSettingScalarWhereInput[] ;
  updateMany?: TablePaymentSettingUpdateManyWithWhereNestedInput[] ;
}

export interface TablePaymentSettingUpdateOneWithoutPaymentInput {
  create?: TablePaymentSettingCreateWithoutPaymentInput ;
  update?: TablePaymentSettingUpdateWithoutPaymentDataInput ;
  upsert?: TablePaymentSettingUpsertWithoutPaymentInput ;
  disconnect?: boolean ;
  connect?: TablePaymentSettingWhereUniqueInput ;
}

export interface TablePaymentSettingUpdateOneWithoutSelectedItemsInput {
  create?: TablePaymentSettingCreateWithoutSelectedItemsInput ;
  update?: TablePaymentSettingUpdateWithoutSelectedItemsDataInput ;
  upsert?: TablePaymentSettingUpsertWithoutSelectedItemsInput ;
  disconnect?: boolean ;
  connect?: TablePaymentSettingWhereUniqueInput ;
}

export interface TablePaymentSettingUpdateOneWithoutUserActiveInput {
  create?: TablePaymentSettingCreateWithoutUserActiveInput ;
  update?: TablePaymentSettingUpdateWithoutUserActiveDataInput ;
  upsert?: TablePaymentSettingUpsertWithoutUserActiveInput ;
  disconnect?: boolean ;
  connect?: TablePaymentSettingWhereUniqueInput ;
}

export interface TablePaymentSettingUpdateWithWhereUniqueWithoutTableSessionInput {
  where: TablePaymentSettingWhereUniqueInput;
  data: TablePaymentSettingUpdateWithoutTableSessionDataInput;
}

export interface TablePaymentSettingUpdateWithWhereUniqueWithoutUserInput {
  where: TablePaymentSettingWhereUniqueInput;
  data: TablePaymentSettingUpdateWithoutUserDataInput;
}

export interface TablePaymentSettingUpdateWithoutPaymentDataInput {
  userActive?: UserUpdateOneWithoutTablePaymentSettingsInput ;
  user?: UserUpdateOneRequiredWithoutTablePaymentSettingsHistoryInput ;
  tableSession?: TableSessionUpdateOneRequiredWithoutUserPaymentSettingsInput ;
  paymentMethod?: string ;
  tip?: number ;
  billPaymentType?: BILL_PAYMENT_TYPE ;
  selectedItems?: OrderItemUpdateManyWithoutSelectedForPaymentByUserInput ;
}

export interface TablePaymentSettingUpdateWithoutSelectedItemsDataInput {
  userActive?: UserUpdateOneWithoutTablePaymentSettingsInput ;
  user?: UserUpdateOneRequiredWithoutTablePaymentSettingsHistoryInput ;
  tableSession?: TableSessionUpdateOneRequiredWithoutUserPaymentSettingsInput ;
  paymentMethod?: string ;
  payment?: PaymentUpdateOneWithoutTablePaymentInput ;
  tip?: number ;
  billPaymentType?: BILL_PAYMENT_TYPE ;
}

export interface TablePaymentSettingUpdateWithoutTableSessionDataInput {
  userActive?: UserUpdateOneWithoutTablePaymentSettingsInput ;
  user?: UserUpdateOneRequiredWithoutTablePaymentSettingsHistoryInput ;
  paymentMethod?: string ;
  payment?: PaymentUpdateOneWithoutTablePaymentInput ;
  tip?: number ;
  billPaymentType?: BILL_PAYMENT_TYPE ;
  selectedItems?: OrderItemUpdateManyWithoutSelectedForPaymentByUserInput ;
}

export interface TablePaymentSettingUpdateWithoutUserActiveDataInput {
  user?: UserUpdateOneRequiredWithoutTablePaymentSettingsHistoryInput ;
  tableSession?: TableSessionUpdateOneRequiredWithoutUserPaymentSettingsInput ;
  paymentMethod?: string ;
  payment?: PaymentUpdateOneWithoutTablePaymentInput ;
  tip?: number ;
  billPaymentType?: BILL_PAYMENT_TYPE ;
  selectedItems?: OrderItemUpdateManyWithoutSelectedForPaymentByUserInput ;
}

export interface TablePaymentSettingUpdateWithoutUserDataInput {
  userActive?: UserUpdateOneWithoutTablePaymentSettingsInput ;
  tableSession?: TableSessionUpdateOneRequiredWithoutUserPaymentSettingsInput ;
  paymentMethod?: string ;
  payment?: PaymentUpdateOneWithoutTablePaymentInput ;
  tip?: number ;
  billPaymentType?: BILL_PAYMENT_TYPE ;
  selectedItems?: OrderItemUpdateManyWithoutSelectedForPaymentByUserInput ;
}

export interface TablePaymentSettingUpsertWithWhereUniqueWithoutTableSessionInput {
  where: TablePaymentSettingWhereUniqueInput;
  update: TablePaymentSettingUpdateWithoutTableSessionDataInput;
  create: TablePaymentSettingCreateWithoutTableSessionInput;
}

export interface TablePaymentSettingUpsertWithWhereUniqueWithoutUserInput {
  where: TablePaymentSettingWhereUniqueInput;
  update: TablePaymentSettingUpdateWithoutUserDataInput;
  create: TablePaymentSettingCreateWithoutUserInput;
}

export interface TablePaymentSettingUpsertWithoutPaymentInput {
  update: TablePaymentSettingUpdateWithoutPaymentDataInput;
  create: TablePaymentSettingCreateWithoutPaymentInput;
}

export interface TablePaymentSettingUpsertWithoutSelectedItemsInput {
  update: TablePaymentSettingUpdateWithoutSelectedItemsDataInput;
  create: TablePaymentSettingCreateWithoutSelectedItemsInput;
}

export interface TablePaymentSettingUpsertWithoutUserActiveInput {
  update: TablePaymentSettingUpdateWithoutUserActiveDataInput;
  create: TablePaymentSettingCreateWithoutUserActiveInput;
}

export interface TablePaymentSettingWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  userActive?: UserWhereInput ;
  user?: UserWhereInput ;
  tableSession?: TableSessionWhereInput ;
  paymentMethod?: string ;
  paymentMethod_not?: string ;
  paymentMethod_in?: string[] ;
  paymentMethod_not_in?: string[] ;
  paymentMethod_lt?: string ;
  paymentMethod_lte?: string ;
  paymentMethod_gt?: string ;
  paymentMethod_gte?: string ;
  paymentMethod_contains?: string ;
  paymentMethod_not_contains?: string ;
  paymentMethod_starts_with?: string ;
  paymentMethod_not_starts_with?: string ;
  paymentMethod_ends_with?: string ;
  paymentMethod_not_ends_with?: string ;
  payment?: PaymentWhereInput ;
  tip?: number ;
  tip_not?: number ;
  tip_in?: number[] ;
  tip_not_in?: number[] ;
  tip_lt?: number ;
  tip_lte?: number ;
  tip_gt?: number ;
  tip_gte?: number ;
  billPaymentType?: BILL_PAYMENT_TYPE ;
  billPaymentType_not?: BILL_PAYMENT_TYPE ;
  billPaymentType_in?: BILL_PAYMENT_TYPE[] ;
  billPaymentType_not_in?: BILL_PAYMENT_TYPE[] ;
  selectedItems_every?: OrderItemWhereInput ;
  selectedItems_some?: OrderItemWhereInput ;
  selectedItems_none?: OrderItemWhereInput ;
  AND?: TablePaymentSettingWhereInput[] ;
  OR?: TablePaymentSettingWhereInput[] ;
  NOT?: TablePaymentSettingWhereInput[] ;
}

export interface TablePaymentSettingWhereUniqueInput {
  id?: string ;
}

export interface TableScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  code?: string ;
  code_not?: string ;
  code_in?: string[] ;
  code_not_in?: string[] ;
  code_lt?: string ;
  code_lte?: string ;
  code_gt?: string ;
  code_gte?: string ;
  code_contains?: string ;
  code_not_contains?: string ;
  code_starts_with?: string ;
  code_not_starts_with?: string ;
  code_ends_with?: string ;
  code_not_ends_with?: string ;
  capacity?: number ;
  capacity_not?: number ;
  capacity_in?: number[] ;
  capacity_not_in?: number[] ;
  capacity_lt?: number ;
  capacity_lte?: number ;
  capacity_gt?: number ;
  capacity_gte?: number ;
  posX?: number ;
  posX_not?: number ;
  posX_in?: number[] ;
  posX_not_in?: number[] ;
  posX_lt?: number ;
  posX_lte?: number ;
  posX_gt?: number ;
  posX_gte?: number ;
  posY?: number ;
  posY_not?: number ;
  posY_in?: number[] ;
  posY_not_in?: number[] ;
  posY_lt?: number ;
  posY_lte?: number ;
  posY_gt?: number ;
  posY_gte?: number ;
  width?: number ;
  width_not?: number ;
  width_in?: number[] ;
  width_not_in?: number[] ;
  width_lt?: number ;
  width_lte?: number ;
  width_gt?: number ;
  width_gte?: number ;
  height?: number ;
  height_not?: number ;
  height_in?: number[] ;
  height_not_in?: number[] ;
  height_lt?: number ;
  height_lte?: number ;
  height_gt?: number ;
  height_gte?: number ;
  rotation?: number ;
  rotation_not?: number ;
  rotation_in?: number[] ;
  rotation_not_in?: number[] ;
  rotation_lt?: number ;
  rotation_lte?: number ;
  rotation_gt?: number ;
  rotation_gte?: number ;
  AND?: TableScalarWhereInput[] ;
  OR?: TableScalarWhereInput[] ;
  NOT?: TableScalarWhereInput[] ;
}

export interface TableSessionCreateManyWithoutTableInput {
  create?: TableSessionCreateWithoutTableInput[] ;
  connect?: TableSessionWhereUniqueInput[] ;
}

export interface TableSessionCreateManyWithoutUsersInput {
  create?: TableSessionCreateWithoutUsersInput[] ;
  connect?: TableSessionWhereUniqueInput[] ;
}

export interface TableSessionCreateOneWithoutItemsInput {
  create?: TableSessionCreateWithoutItemsInput ;
  connect?: TableSessionWhereUniqueInput ;
}

export interface TableSessionCreateOneWithoutOrdersInput {
  create?: TableSessionCreateWithoutOrdersInput ;
  connect?: TableSessionWhereUniqueInput ;
}

export interface TableSessionCreateOneWithoutPosMetadataInput {
  create?: TableSessionCreateWithoutPosMetadataInput ;
  connect?: TableSessionWhereUniqueInput ;
}

export interface TableSessionCreateOneWithoutTableActiveInput {
  create?: TableSessionCreateWithoutTableActiveInput ;
  connect?: TableSessionWhereUniqueInput ;
}

export interface TableSessionCreateOneWithoutUserPaymentSettingsInput {
  create?: TableSessionCreateWithoutUserPaymentSettingsInput ;
  connect?: TableSessionWhereUniqueInput ;
}

export interface TableSessionCreateWithoutItemsInput {
  id?: string ;
  active?: boolean ;
  posMetadata?: PosMetadataCreateOneWithoutTableSessionInput ;
  waiterId?: string ;
  staff?: StaffCreateOneInput ;
  locked?: boolean ;
  checkId?: string ;
  assistance?: boolean ;
  table: TableCreateOneWithoutSessionsInput;
  tableActive?: TableCreateOneWithoutSessionInput ;
  orders?: OrderCreateManyWithoutTableInput ;
  users?: UserCreateManyWithoutTableSessionsInput ;
  covers?: number ;
  userPaymentSettings?: TablePaymentSettingCreateManyWithoutTableSessionInput ;
}

export interface TableSessionCreateWithoutOrdersInput {
  id?: string ;
  active?: boolean ;
  posMetadata?: PosMetadataCreateOneWithoutTableSessionInput ;
  waiterId?: string ;
  staff?: StaffCreateOneInput ;
  locked?: boolean ;
  checkId?: string ;
  assistance?: boolean ;
  table: TableCreateOneWithoutSessionsInput;
  tableActive?: TableCreateOneWithoutSessionInput ;
  users?: UserCreateManyWithoutTableSessionsInput ;
  covers?: number ;
  items?: OrderItemCreateManyWithoutTableSessionInput ;
  userPaymentSettings?: TablePaymentSettingCreateManyWithoutTableSessionInput ;
}

export interface TableSessionCreateWithoutPosMetadataInput {
  id?: string ;
  active?: boolean ;
  waiterId?: string ;
  staff?: StaffCreateOneInput ;
  locked?: boolean ;
  checkId?: string ;
  assistance?: boolean ;
  table: TableCreateOneWithoutSessionsInput;
  tableActive?: TableCreateOneWithoutSessionInput ;
  orders?: OrderCreateManyWithoutTableInput ;
  users?: UserCreateManyWithoutTableSessionsInput ;
  covers?: number ;
  items?: OrderItemCreateManyWithoutTableSessionInput ;
  userPaymentSettings?: TablePaymentSettingCreateManyWithoutTableSessionInput ;
}

export interface TableSessionCreateWithoutTableActiveInput {
  id?: string ;
  active?: boolean ;
  posMetadata?: PosMetadataCreateOneWithoutTableSessionInput ;
  waiterId?: string ;
  staff?: StaffCreateOneInput ;
  locked?: boolean ;
  checkId?: string ;
  assistance?: boolean ;
  table: TableCreateOneWithoutSessionsInput;
  orders?: OrderCreateManyWithoutTableInput ;
  users?: UserCreateManyWithoutTableSessionsInput ;
  covers?: number ;
  items?: OrderItemCreateManyWithoutTableSessionInput ;
  userPaymentSettings?: TablePaymentSettingCreateManyWithoutTableSessionInput ;
}

export interface TableSessionCreateWithoutTableInput {
  id?: string ;
  active?: boolean ;
  posMetadata?: PosMetadataCreateOneWithoutTableSessionInput ;
  waiterId?: string ;
  staff?: StaffCreateOneInput ;
  locked?: boolean ;
  checkId?: string ;
  assistance?: boolean ;
  tableActive?: TableCreateOneWithoutSessionInput ;
  orders?: OrderCreateManyWithoutTableInput ;
  users?: UserCreateManyWithoutTableSessionsInput ;
  covers?: number ;
  items?: OrderItemCreateManyWithoutTableSessionInput ;
  userPaymentSettings?: TablePaymentSettingCreateManyWithoutTableSessionInput ;
}

export interface TableSessionCreateWithoutUserPaymentSettingsInput {
  id?: string ;
  active?: boolean ;
  posMetadata?: PosMetadataCreateOneWithoutTableSessionInput ;
  waiterId?: string ;
  staff?: StaffCreateOneInput ;
  locked?: boolean ;
  checkId?: string ;
  assistance?: boolean ;
  table: TableCreateOneWithoutSessionsInput;
  tableActive?: TableCreateOneWithoutSessionInput ;
  orders?: OrderCreateManyWithoutTableInput ;
  users?: UserCreateManyWithoutTableSessionsInput ;
  covers?: number ;
  items?: OrderItemCreateManyWithoutTableSessionInput ;
}

export interface TableSessionCreateWithoutUsersInput {
  id?: string ;
  active?: boolean ;
  posMetadata?: PosMetadataCreateOneWithoutTableSessionInput ;
  waiterId?: string ;
  staff?: StaffCreateOneInput ;
  locked?: boolean ;
  checkId?: string ;
  assistance?: boolean ;
  table: TableCreateOneWithoutSessionsInput;
  tableActive?: TableCreateOneWithoutSessionInput ;
  orders?: OrderCreateManyWithoutTableInput ;
  covers?: number ;
  items?: OrderItemCreateManyWithoutTableSessionInput ;
  userPaymentSettings?: TablePaymentSettingCreateManyWithoutTableSessionInput ;
}

export interface TableSessionScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  active?: boolean ;
  active_not?: boolean ;
  waiterId?: string ;
  waiterId_not?: string ;
  waiterId_in?: string[] ;
  waiterId_not_in?: string[] ;
  waiterId_lt?: string ;
  waiterId_lte?: string ;
  waiterId_gt?: string ;
  waiterId_gte?: string ;
  waiterId_contains?: string ;
  waiterId_not_contains?: string ;
  waiterId_starts_with?: string ;
  waiterId_not_starts_with?: string ;
  waiterId_ends_with?: string ;
  waiterId_not_ends_with?: string ;
  locked?: boolean ;
  locked_not?: boolean ;
  checkId?: string ;
  checkId_not?: string ;
  checkId_in?: string[] ;
  checkId_not_in?: string[] ;
  checkId_lt?: string ;
  checkId_lte?: string ;
  checkId_gt?: string ;
  checkId_gte?: string ;
  checkId_contains?: string ;
  checkId_not_contains?: string ;
  checkId_starts_with?: string ;
  checkId_not_starts_with?: string ;
  checkId_ends_with?: string ;
  checkId_not_ends_with?: string ;
  assistance?: boolean ;
  assistance_not?: boolean ;
  covers?: number ;
  covers_not?: number ;
  covers_in?: number[] ;
  covers_not_in?: number[] ;
  covers_lt?: number ;
  covers_lte?: number ;
  covers_gt?: number ;
  covers_gte?: number ;
  AND?: TableSessionScalarWhereInput[] ;
  OR?: TableSessionScalarWhereInput[] ;
  NOT?: TableSessionScalarWhereInput[] ;
}

export interface TableSessionUpdateManyDataInput {
  active?: boolean ;
  waiterId?: string ;
  locked?: boolean ;
  checkId?: string ;
  assistance?: boolean ;
  covers?: number ;
}

export interface TableSessionUpdateManyWithWhereNestedInput {
  where: TableSessionScalarWhereInput;
  data: TableSessionUpdateManyDataInput;
}

export interface TableSessionUpdateManyWithoutTableInput {
  create?: TableSessionCreateWithoutTableInput[] ;
  connect?: TableSessionWhereUniqueInput[] ;
  set?: TableSessionWhereUniqueInput[] ;
  disconnect?: TableSessionWhereUniqueInput[] ;
  update?: TableSessionUpdateWithWhereUniqueWithoutTableInput[] ;
  upsert?: TableSessionUpsertWithWhereUniqueWithoutTableInput[] ;
  deleteMany?: TableSessionScalarWhereInput[] ;
  updateMany?: TableSessionUpdateManyWithWhereNestedInput[] ;
}

export interface TableSessionUpdateManyWithoutUsersInput {
  create?: TableSessionCreateWithoutUsersInput[] ;
  connect?: TableSessionWhereUniqueInput[] ;
  set?: TableSessionWhereUniqueInput[] ;
  disconnect?: TableSessionWhereUniqueInput[] ;
  update?: TableSessionUpdateWithWhereUniqueWithoutUsersInput[] ;
  upsert?: TableSessionUpsertWithWhereUniqueWithoutUsersInput[] ;
  deleteMany?: TableSessionScalarWhereInput[] ;
  updateMany?: TableSessionUpdateManyWithWhereNestedInput[] ;
}

export interface TableSessionUpdateOneRequiredWithoutUserPaymentSettingsInput {
  create?: TableSessionCreateWithoutUserPaymentSettingsInput ;
  update?: TableSessionUpdateWithoutUserPaymentSettingsDataInput ;
  upsert?: TableSessionUpsertWithoutUserPaymentSettingsInput ;
  connect?: TableSessionWhereUniqueInput ;
}

export interface TableSessionUpdateOneWithoutItemsInput {
  create?: TableSessionCreateWithoutItemsInput ;
  update?: TableSessionUpdateWithoutItemsDataInput ;
  upsert?: TableSessionUpsertWithoutItemsInput ;
  disconnect?: boolean ;
  connect?: TableSessionWhereUniqueInput ;
}

export interface TableSessionUpdateOneWithoutOrdersInput {
  create?: TableSessionCreateWithoutOrdersInput ;
  update?: TableSessionUpdateWithoutOrdersDataInput ;
  upsert?: TableSessionUpsertWithoutOrdersInput ;
  disconnect?: boolean ;
  connect?: TableSessionWhereUniqueInput ;
}

export interface TableSessionUpdateOneWithoutPosMetadataInput {
  create?: TableSessionCreateWithoutPosMetadataInput ;
  update?: TableSessionUpdateWithoutPosMetadataDataInput ;
  upsert?: TableSessionUpsertWithoutPosMetadataInput ;
  disconnect?: boolean ;
  connect?: TableSessionWhereUniqueInput ;
}

export interface TableSessionUpdateOneWithoutTableActiveInput {
  create?: TableSessionCreateWithoutTableActiveInput ;
  update?: TableSessionUpdateWithoutTableActiveDataInput ;
  upsert?: TableSessionUpsertWithoutTableActiveInput ;
  disconnect?: boolean ;
  connect?: TableSessionWhereUniqueInput ;
}

export interface TableSessionUpdateWithWhereUniqueWithoutTableInput {
  where: TableSessionWhereUniqueInput;
  data: TableSessionUpdateWithoutTableDataInput;
}

export interface TableSessionUpdateWithWhereUniqueWithoutUsersInput {
  where: TableSessionWhereUniqueInput;
  data: TableSessionUpdateWithoutUsersDataInput;
}

export interface TableSessionUpdateWithoutItemsDataInput {
  active?: boolean ;
  posMetadata?: PosMetadataUpdateOneWithoutTableSessionInput ;
  waiterId?: string ;
  staff?: StaffUpdateOneInput ;
  locked?: boolean ;
  checkId?: string ;
  assistance?: boolean ;
  table?: TableUpdateOneRequiredWithoutSessionsInput ;
  tableActive?: TableUpdateOneWithoutSessionInput ;
  orders?: OrderUpdateManyWithoutTableInput ;
  users?: UserUpdateManyWithoutTableSessionsInput ;
  covers?: number ;
  userPaymentSettings?: TablePaymentSettingUpdateManyWithoutTableSessionInput ;
}

export interface TableSessionUpdateWithoutOrdersDataInput {
  active?: boolean ;
  posMetadata?: PosMetadataUpdateOneWithoutTableSessionInput ;
  waiterId?: string ;
  staff?: StaffUpdateOneInput ;
  locked?: boolean ;
  checkId?: string ;
  assistance?: boolean ;
  table?: TableUpdateOneRequiredWithoutSessionsInput ;
  tableActive?: TableUpdateOneWithoutSessionInput ;
  users?: UserUpdateManyWithoutTableSessionsInput ;
  covers?: number ;
  items?: OrderItemUpdateManyWithoutTableSessionInput ;
  userPaymentSettings?: TablePaymentSettingUpdateManyWithoutTableSessionInput ;
}

export interface TableSessionUpdateWithoutPosMetadataDataInput {
  active?: boolean ;
  waiterId?: string ;
  staff?: StaffUpdateOneInput ;
  locked?: boolean ;
  checkId?: string ;
  assistance?: boolean ;
  table?: TableUpdateOneRequiredWithoutSessionsInput ;
  tableActive?: TableUpdateOneWithoutSessionInput ;
  orders?: OrderUpdateManyWithoutTableInput ;
  users?: UserUpdateManyWithoutTableSessionsInput ;
  covers?: number ;
  items?: OrderItemUpdateManyWithoutTableSessionInput ;
  userPaymentSettings?: TablePaymentSettingUpdateManyWithoutTableSessionInput ;
}

export interface TableSessionUpdateWithoutTableActiveDataInput {
  active?: boolean ;
  posMetadata?: PosMetadataUpdateOneWithoutTableSessionInput ;
  waiterId?: string ;
  staff?: StaffUpdateOneInput ;
  locked?: boolean ;
  checkId?: string ;
  assistance?: boolean ;
  table?: TableUpdateOneRequiredWithoutSessionsInput ;
  orders?: OrderUpdateManyWithoutTableInput ;
  users?: UserUpdateManyWithoutTableSessionsInput ;
  covers?: number ;
  items?: OrderItemUpdateManyWithoutTableSessionInput ;
  userPaymentSettings?: TablePaymentSettingUpdateManyWithoutTableSessionInput ;
}

export interface TableSessionUpdateWithoutTableDataInput {
  active?: boolean ;
  posMetadata?: PosMetadataUpdateOneWithoutTableSessionInput ;
  waiterId?: string ;
  staff?: StaffUpdateOneInput ;
  locked?: boolean ;
  checkId?: string ;
  assistance?: boolean ;
  tableActive?: TableUpdateOneWithoutSessionInput ;
  orders?: OrderUpdateManyWithoutTableInput ;
  users?: UserUpdateManyWithoutTableSessionsInput ;
  covers?: number ;
  items?: OrderItemUpdateManyWithoutTableSessionInput ;
  userPaymentSettings?: TablePaymentSettingUpdateManyWithoutTableSessionInput ;
}

export interface TableSessionUpdateWithoutUserPaymentSettingsDataInput {
  active?: boolean ;
  posMetadata?: PosMetadataUpdateOneWithoutTableSessionInput ;
  waiterId?: string ;
  staff?: StaffUpdateOneInput ;
  locked?: boolean ;
  checkId?: string ;
  assistance?: boolean ;
  table?: TableUpdateOneRequiredWithoutSessionsInput ;
  tableActive?: TableUpdateOneWithoutSessionInput ;
  orders?: OrderUpdateManyWithoutTableInput ;
  users?: UserUpdateManyWithoutTableSessionsInput ;
  covers?: number ;
  items?: OrderItemUpdateManyWithoutTableSessionInput ;
}

export interface TableSessionUpdateWithoutUsersDataInput {
  active?: boolean ;
  posMetadata?: PosMetadataUpdateOneWithoutTableSessionInput ;
  waiterId?: string ;
  staff?: StaffUpdateOneInput ;
  locked?: boolean ;
  checkId?: string ;
  assistance?: boolean ;
  table?: TableUpdateOneRequiredWithoutSessionsInput ;
  tableActive?: TableUpdateOneWithoutSessionInput ;
  orders?: OrderUpdateManyWithoutTableInput ;
  covers?: number ;
  items?: OrderItemUpdateManyWithoutTableSessionInput ;
  userPaymentSettings?: TablePaymentSettingUpdateManyWithoutTableSessionInput ;
}

export interface TableSessionUpsertWithWhereUniqueWithoutTableInput {
  where: TableSessionWhereUniqueInput;
  update: TableSessionUpdateWithoutTableDataInput;
  create: TableSessionCreateWithoutTableInput;
}

export interface TableSessionUpsertWithWhereUniqueWithoutUsersInput {
  where: TableSessionWhereUniqueInput;
  update: TableSessionUpdateWithoutUsersDataInput;
  create: TableSessionCreateWithoutUsersInput;
}

export interface TableSessionUpsertWithoutItemsInput {
  update: TableSessionUpdateWithoutItemsDataInput;
  create: TableSessionCreateWithoutItemsInput;
}

export interface TableSessionUpsertWithoutOrdersInput {
  update: TableSessionUpdateWithoutOrdersDataInput;
  create: TableSessionCreateWithoutOrdersInput;
}

export interface TableSessionUpsertWithoutPosMetadataInput {
  update: TableSessionUpdateWithoutPosMetadataDataInput;
  create: TableSessionCreateWithoutPosMetadataInput;
}

export interface TableSessionUpsertWithoutTableActiveInput {
  update: TableSessionUpdateWithoutTableActiveDataInput;
  create: TableSessionCreateWithoutTableActiveInput;
}

export interface TableSessionUpsertWithoutUserPaymentSettingsInput {
  update: TableSessionUpdateWithoutUserPaymentSettingsDataInput;
  create: TableSessionCreateWithoutUserPaymentSettingsInput;
}

export interface TableSessionWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  active?: boolean ;
  active_not?: boolean ;
  posMetadata?: PosMetadataWhereInput ;
  waiterId?: string ;
  waiterId_not?: string ;
  waiterId_in?: string[] ;
  waiterId_not_in?: string[] ;
  waiterId_lt?: string ;
  waiterId_lte?: string ;
  waiterId_gt?: string ;
  waiterId_gte?: string ;
  waiterId_contains?: string ;
  waiterId_not_contains?: string ;
  waiterId_starts_with?: string ;
  waiterId_not_starts_with?: string ;
  waiterId_ends_with?: string ;
  waiterId_not_ends_with?: string ;
  staff?: StaffWhereInput ;
  locked?: boolean ;
  locked_not?: boolean ;
  checkId?: string ;
  checkId_not?: string ;
  checkId_in?: string[] ;
  checkId_not_in?: string[] ;
  checkId_lt?: string ;
  checkId_lte?: string ;
  checkId_gt?: string ;
  checkId_gte?: string ;
  checkId_contains?: string ;
  checkId_not_contains?: string ;
  checkId_starts_with?: string ;
  checkId_not_starts_with?: string ;
  checkId_ends_with?: string ;
  checkId_not_ends_with?: string ;
  assistance?: boolean ;
  assistance_not?: boolean ;
  table?: TableWhereInput ;
  tableActive?: TableWhereInput ;
  orders_every?: OrderWhereInput ;
  orders_some?: OrderWhereInput ;
  orders_none?: OrderWhereInput ;
  users_every?: UserWhereInput ;
  users_some?: UserWhereInput ;
  users_none?: UserWhereInput ;
  covers?: number ;
  covers_not?: number ;
  covers_in?: number[] ;
  covers_not_in?: number[] ;
  covers_lt?: number ;
  covers_lte?: number ;
  covers_gt?: number ;
  covers_gte?: number ;
  items_every?: OrderItemWhereInput ;
  items_some?: OrderItemWhereInput ;
  items_none?: OrderItemWhereInput ;
  userPaymentSettings_every?: TablePaymentSettingWhereInput ;
  userPaymentSettings_some?: TablePaymentSettingWhereInput ;
  userPaymentSettings_none?: TablePaymentSettingWhereInput ;
  AND?: TableSessionWhereInput[] ;
  OR?: TableSessionWhereInput[] ;
  NOT?: TableSessionWhereInput[] ;
}

export interface TableSessionWhereUniqueInput {
  id?: string ;
}

export interface TableUpdateDataInput {
  deleted?: boolean ;
  venue?: VenueUpdateOneRequiredWithoutTablesInput ;
  floorPlan?: FloorPlanUpdateOneWithoutTablesInput ;
  reservations?: ReservationUpdateManyWithoutTableInput ;
  sessions?: TableSessionUpdateManyWithoutTableInput ;
  session?: TableSessionUpdateOneWithoutTableActiveInput ;
  users?: UserUpdateManyWithoutTableInput ;
  code?: string ;
  capacity?: number ;
  posX?: number ;
  posY?: number ;
  width?: number ;
  height?: number ;
  rotation?: number ;
}

export interface TableUpdateInput {
  deleted?: boolean ;
  venue?: VenueUpdateOneRequiredWithoutTablesInput ;
  floorPlan?: FloorPlanUpdateOneWithoutTablesInput ;
  reservations?: ReservationUpdateManyWithoutTableInput ;
  sessions?: TableSessionUpdateManyWithoutTableInput ;
  session?: TableSessionUpdateOneWithoutTableActiveInput ;
  users?: UserUpdateManyWithoutTableInput ;
  code?: string ;
  capacity?: number ;
  posX?: number ;
  posY?: number ;
  width?: number ;
  height?: number ;
  rotation?: number ;
}

export interface TableUpdateManyDataInput {
  deleted?: boolean ;
  code?: string ;
  capacity?: number ;
  posX?: number ;
  posY?: number ;
  width?: number ;
  height?: number ;
  rotation?: number ;
}

export interface TableUpdateManyInput {
  create?: TableCreateInput[] ;
  update?: TableUpdateWithWhereUniqueNestedInput[] ;
  upsert?: TableUpsertWithWhereUniqueNestedInput[] ;
  connect?: TableWhereUniqueInput[] ;
  set?: TableWhereUniqueInput[] ;
  disconnect?: TableWhereUniqueInput[] ;
  deleteMany?: TableScalarWhereInput[] ;
  updateMany?: TableUpdateManyWithWhereNestedInput[] ;
}

export interface TableUpdateManyWithWhereNestedInput {
  where: TableScalarWhereInput;
  data: TableUpdateManyDataInput;
}

export interface TableUpdateManyWithoutFloorPlanInput {
  create?: TableCreateWithoutFloorPlanInput[] ;
  connect?: TableWhereUniqueInput[] ;
  set?: TableWhereUniqueInput[] ;
  disconnect?: TableWhereUniqueInput[] ;
  update?: TableUpdateWithWhereUniqueWithoutFloorPlanInput[] ;
  upsert?: TableUpsertWithWhereUniqueWithoutFloorPlanInput[] ;
  deleteMany?: TableScalarWhereInput[] ;
  updateMany?: TableUpdateManyWithWhereNestedInput[] ;
}

export interface TableUpdateManyWithoutVenueInput {
  create?: TableCreateWithoutVenueInput[] ;
  connect?: TableWhereUniqueInput[] ;
  set?: TableWhereUniqueInput[] ;
  disconnect?: TableWhereUniqueInput[] ;
  update?: TableUpdateWithWhereUniqueWithoutVenueInput[] ;
  upsert?: TableUpsertWithWhereUniqueWithoutVenueInput[] ;
  deleteMany?: TableScalarWhereInput[] ;
  updateMany?: TableUpdateManyWithWhereNestedInput[] ;
}

export interface TableUpdateOneRequiredWithoutSessionsInput {
  create?: TableCreateWithoutSessionsInput ;
  update?: TableUpdateWithoutSessionsDataInput ;
  upsert?: TableUpsertWithoutSessionsInput ;
  connect?: TableWhereUniqueInput ;
}

export interface TableUpdateOneWithoutReservationsInput {
  create?: TableCreateWithoutReservationsInput ;
  update?: TableUpdateWithoutReservationsDataInput ;
  upsert?: TableUpsertWithoutReservationsInput ;
  disconnect?: boolean ;
  connect?: TableWhereUniqueInput ;
}

export interface TableUpdateOneWithoutSessionInput {
  create?: TableCreateWithoutSessionInput ;
  update?: TableUpdateWithoutSessionDataInput ;
  upsert?: TableUpsertWithoutSessionInput ;
  disconnect?: boolean ;
  connect?: TableWhereUniqueInput ;
}

export interface TableUpdateOneWithoutUsersInput {
  create?: TableCreateWithoutUsersInput ;
  update?: TableUpdateWithoutUsersDataInput ;
  upsert?: TableUpsertWithoutUsersInput ;
  disconnect?: boolean ;
  connect?: TableWhereUniqueInput ;
}

export interface TableUpdateWithWhereUniqueNestedInput {
  where: TableWhereUniqueInput;
  data: TableUpdateDataInput;
}

export interface TableUpdateWithWhereUniqueWithoutFloorPlanInput {
  where: TableWhereUniqueInput;
  data: TableUpdateWithoutFloorPlanDataInput;
}

export interface TableUpdateWithWhereUniqueWithoutVenueInput {
  where: TableWhereUniqueInput;
  data: TableUpdateWithoutVenueDataInput;
}

export interface TableUpdateWithoutFloorPlanDataInput {
  deleted?: boolean ;
  venue?: VenueUpdateOneRequiredWithoutTablesInput ;
  reservations?: ReservationUpdateManyWithoutTableInput ;
  sessions?: TableSessionUpdateManyWithoutTableInput ;
  session?: TableSessionUpdateOneWithoutTableActiveInput ;
  users?: UserUpdateManyWithoutTableInput ;
  code?: string ;
  capacity?: number ;
  posX?: number ;
  posY?: number ;
  width?: number ;
  height?: number ;
  rotation?: number ;
}

export interface TableUpdateWithoutReservationsDataInput {
  deleted?: boolean ;
  venue?: VenueUpdateOneRequiredWithoutTablesInput ;
  floorPlan?: FloorPlanUpdateOneWithoutTablesInput ;
  sessions?: TableSessionUpdateManyWithoutTableInput ;
  session?: TableSessionUpdateOneWithoutTableActiveInput ;
  users?: UserUpdateManyWithoutTableInput ;
  code?: string ;
  capacity?: number ;
  posX?: number ;
  posY?: number ;
  width?: number ;
  height?: number ;
  rotation?: number ;
}

export interface TableUpdateWithoutSessionDataInput {
  deleted?: boolean ;
  venue?: VenueUpdateOneRequiredWithoutTablesInput ;
  floorPlan?: FloorPlanUpdateOneWithoutTablesInput ;
  reservations?: ReservationUpdateManyWithoutTableInput ;
  sessions?: TableSessionUpdateManyWithoutTableInput ;
  users?: UserUpdateManyWithoutTableInput ;
  code?: string ;
  capacity?: number ;
  posX?: number ;
  posY?: number ;
  width?: number ;
  height?: number ;
  rotation?: number ;
}

export interface TableUpdateWithoutSessionsDataInput {
  deleted?: boolean ;
  venue?: VenueUpdateOneRequiredWithoutTablesInput ;
  floorPlan?: FloorPlanUpdateOneWithoutTablesInput ;
  reservations?: ReservationUpdateManyWithoutTableInput ;
  session?: TableSessionUpdateOneWithoutTableActiveInput ;
  users?: UserUpdateManyWithoutTableInput ;
  code?: string ;
  capacity?: number ;
  posX?: number ;
  posY?: number ;
  width?: number ;
  height?: number ;
  rotation?: number ;
}

export interface TableUpdateWithoutUsersDataInput {
  deleted?: boolean ;
  venue?: VenueUpdateOneRequiredWithoutTablesInput ;
  floorPlan?: FloorPlanUpdateOneWithoutTablesInput ;
  reservations?: ReservationUpdateManyWithoutTableInput ;
  sessions?: TableSessionUpdateManyWithoutTableInput ;
  session?: TableSessionUpdateOneWithoutTableActiveInput ;
  code?: string ;
  capacity?: number ;
  posX?: number ;
  posY?: number ;
  width?: number ;
  height?: number ;
  rotation?: number ;
}

export interface TableUpdateWithoutVenueDataInput {
  deleted?: boolean ;
  floorPlan?: FloorPlanUpdateOneWithoutTablesInput ;
  reservations?: ReservationUpdateManyWithoutTableInput ;
  sessions?: TableSessionUpdateManyWithoutTableInput ;
  session?: TableSessionUpdateOneWithoutTableActiveInput ;
  users?: UserUpdateManyWithoutTableInput ;
  code?: string ;
  capacity?: number ;
  posX?: number ;
  posY?: number ;
  width?: number ;
  height?: number ;
  rotation?: number ;
}

export interface TableUpsertWithWhereUniqueNestedInput {
  where: TableWhereUniqueInput;
  update: TableUpdateDataInput;
  create: TableCreateInput;
}

export interface TableUpsertWithWhereUniqueWithoutFloorPlanInput {
  where: TableWhereUniqueInput;
  update: TableUpdateWithoutFloorPlanDataInput;
  create: TableCreateWithoutFloorPlanInput;
}

export interface TableUpsertWithWhereUniqueWithoutVenueInput {
  where: TableWhereUniqueInput;
  update: TableUpdateWithoutVenueDataInput;
  create: TableCreateWithoutVenueInput;
}

export interface TableUpsertWithoutReservationsInput {
  update: TableUpdateWithoutReservationsDataInput;
  create: TableCreateWithoutReservationsInput;
}

export interface TableUpsertWithoutSessionInput {
  update: TableUpdateWithoutSessionDataInput;
  create: TableCreateWithoutSessionInput;
}

export interface TableUpsertWithoutSessionsInput {
  update: TableUpdateWithoutSessionsDataInput;
  create: TableCreateWithoutSessionsInput;
}

export interface TableUpsertWithoutUsersInput {
  update: TableUpdateWithoutUsersDataInput;
  create: TableCreateWithoutUsersInput;
}

export interface TableWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  venue?: VenueWhereInput ;
  floorPlan?: FloorPlanWhereInput ;
  reservations_every?: ReservationWhereInput ;
  reservations_some?: ReservationWhereInput ;
  reservations_none?: ReservationWhereInput ;
  sessions_every?: TableSessionWhereInput ;
  sessions_some?: TableSessionWhereInput ;
  sessions_none?: TableSessionWhereInput ;
  session?: TableSessionWhereInput ;
  users_every?: UserWhereInput ;
  users_some?: UserWhereInput ;
  users_none?: UserWhereInput ;
  code?: string ;
  code_not?: string ;
  code_in?: string[] ;
  code_not_in?: string[] ;
  code_lt?: string ;
  code_lte?: string ;
  code_gt?: string ;
  code_gte?: string ;
  code_contains?: string ;
  code_not_contains?: string ;
  code_starts_with?: string ;
  code_not_starts_with?: string ;
  code_ends_with?: string ;
  code_not_ends_with?: string ;
  capacity?: number ;
  capacity_not?: number ;
  capacity_in?: number[] ;
  capacity_not_in?: number[] ;
  capacity_lt?: number ;
  capacity_lte?: number ;
  capacity_gt?: number ;
  capacity_gte?: number ;
  posX?: number ;
  posX_not?: number ;
  posX_in?: number[] ;
  posX_not_in?: number[] ;
  posX_lt?: number ;
  posX_lte?: number ;
  posX_gt?: number ;
  posX_gte?: number ;
  posY?: number ;
  posY_not?: number ;
  posY_in?: number[] ;
  posY_not_in?: number[] ;
  posY_lt?: number ;
  posY_lte?: number ;
  posY_gt?: number ;
  posY_gte?: number ;
  width?: number ;
  width_not?: number ;
  width_in?: number[] ;
  width_not_in?: number[] ;
  width_lt?: number ;
  width_lte?: number ;
  width_gt?: number ;
  width_gte?: number ;
  height?: number ;
  height_not?: number ;
  height_in?: number[] ;
  height_not_in?: number[] ;
  height_lt?: number ;
  height_lte?: number ;
  height_gt?: number ;
  height_gte?: number ;
  rotation?: number ;
  rotation_not?: number ;
  rotation_in?: number[] ;
  rotation_not_in?: number[] ;
  rotation_lt?: number ;
  rotation_lte?: number ;
  rotation_gt?: number ;
  rotation_gte?: number ;
  AND?: TableWhereInput[] ;
  OR?: TableWhereInput[] ;
  NOT?: TableWhereInput[] ;
}

export interface TableWhereUniqueInput {
  id?: string ;
}

export interface TerminalTransactionCreateManyWithoutPosMetadataInput {
  create?: TerminalTransactionCreateWithoutPosMetadataInput[] ;
  connect?: TerminalTransactionWhereUniqueInput[] ;
}

export interface TerminalTransactionCreateWithoutPosMetadataInput {
  id?: string ;
  archiveId: string;
}

export interface TerminalTransactionScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  archiveId?: string ;
  archiveId_not?: string ;
  archiveId_in?: string[] ;
  archiveId_not_in?: string[] ;
  archiveId_lt?: string ;
  archiveId_lte?: string ;
  archiveId_gt?: string ;
  archiveId_gte?: string ;
  archiveId_contains?: string ;
  archiveId_not_contains?: string ;
  archiveId_starts_with?: string ;
  archiveId_not_starts_with?: string ;
  archiveId_ends_with?: string ;
  archiveId_not_ends_with?: string ;
  AND?: TerminalTransactionScalarWhereInput[] ;
  OR?: TerminalTransactionScalarWhereInput[] ;
  NOT?: TerminalTransactionScalarWhereInput[] ;
}

export interface TerminalTransactionUpdateManyDataInput {
  archiveId?: string ;
}

export interface TerminalTransactionUpdateManyWithWhereNestedInput {
  where: TerminalTransactionScalarWhereInput;
  data: TerminalTransactionUpdateManyDataInput;
}

export interface TerminalTransactionUpdateManyWithoutPosMetadataInput {
  create?: TerminalTransactionCreateWithoutPosMetadataInput[] ;
  connect?: TerminalTransactionWhereUniqueInput[] ;
  set?: TerminalTransactionWhereUniqueInput[] ;
  disconnect?: TerminalTransactionWhereUniqueInput[] ;
  update?: TerminalTransactionUpdateWithWhereUniqueWithoutPosMetadataInput[] ;
  upsert?: TerminalTransactionUpsertWithWhereUniqueWithoutPosMetadataInput[] ;
  deleteMany?: TerminalTransactionScalarWhereInput[] ;
  updateMany?: TerminalTransactionUpdateManyWithWhereNestedInput[] ;
}

export interface TerminalTransactionUpdateWithWhereUniqueWithoutPosMetadataInput {
  where: TerminalTransactionWhereUniqueInput;
  data: TerminalTransactionUpdateWithoutPosMetadataDataInput;
}

export interface TerminalTransactionUpdateWithoutPosMetadataDataInput {
  archiveId?: string ;
}

export interface TerminalTransactionUpsertWithWhereUniqueWithoutPosMetadataInput {
  where: TerminalTransactionWhereUniqueInput;
  update: TerminalTransactionUpdateWithoutPosMetadataDataInput;
  create: TerminalTransactionCreateWithoutPosMetadataInput;
}

export interface TerminalTransactionWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  archiveId?: string ;
  archiveId_not?: string ;
  archiveId_in?: string[] ;
  archiveId_not_in?: string[] ;
  archiveId_lt?: string ;
  archiveId_lte?: string ;
  archiveId_gt?: string ;
  archiveId_gte?: string ;
  archiveId_contains?: string ;
  archiveId_not_contains?: string ;
  archiveId_starts_with?: string ;
  archiveId_not_starts_with?: string ;
  archiveId_ends_with?: string ;
  archiveId_not_ends_with?: string ;
  posMetadata?: PosMetadataWhereInput ;
  AND?: TerminalTransactionWhereInput[] ;
  OR?: TerminalTransactionWhereInput[] ;
  NOT?: TerminalTransactionWhereInput[] ;
}

export interface TerminalTransactionWhereUniqueInput {
  id?: string ;
}

export interface TimeRangeCreateOneWithoutAvailabilitiesInput {
  create?: TimeRangeCreateWithoutAvailabilitiesInput ;
  connect?: TimeRangeWhereUniqueInput ;
}

export interface TimeRangeCreateWithoutAvailabilitiesInput {
  end?: string ;
  id?: string ;
  start?: string ;
}

export interface TimeRangeUpdateOneWithoutAvailabilitiesInput {
  create?: TimeRangeCreateWithoutAvailabilitiesInput ;
  update?: TimeRangeUpdateWithoutAvailabilitiesDataInput ;
  upsert?: TimeRangeUpsertWithoutAvailabilitiesInput ;
  disconnect?: boolean ;
  connect?: TimeRangeWhereUniqueInput ;
}

export interface TimeRangeUpdateWithoutAvailabilitiesDataInput {
  end?: string ;
  start?: string ;
}

export interface TimeRangeUpsertWithoutAvailabilitiesInput {
  update: TimeRangeUpdateWithoutAvailabilitiesDataInput;
  create: TimeRangeCreateWithoutAvailabilitiesInput;
}

export interface TimeRangeWhereInput {
  availabilities_every?: AvailabilityWhereInput ;
  availabilities_some?: AvailabilityWhereInput ;
  availabilities_none?: AvailabilityWhereInput ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  end?: string ;
  end_not?: string ;
  end_in?: string[] ;
  end_not_in?: string[] ;
  end_lt?: string ;
  end_lte?: string ;
  end_gt?: string ;
  end_gte?: string ;
  end_contains?: string ;
  end_not_contains?: string ;
  end_starts_with?: string ;
  end_not_starts_with?: string ;
  end_ends_with?: string ;
  end_not_ends_with?: string ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  start?: string ;
  start_not?: string ;
  start_in?: string[] ;
  start_not_in?: string[] ;
  start_lt?: string ;
  start_lte?: string ;
  start_gt?: string ;
  start_gte?: string ;
  start_contains?: string ;
  start_not_contains?: string ;
  start_starts_with?: string ;
  start_not_starts_with?: string ;
  start_ends_with?: string ;
  start_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  AND?: TimeRangeWhereInput[] ;
  OR?: TimeRangeWhereInput[] ;
  NOT?: TimeRangeWhereInput[] ;
}

export interface TimeRangeWhereUniqueInput {
  id?: string ;
}

export interface ToggleAutoCashEODInput {
  venueIds: string[];
  enable: boolean;
}

export interface TogglePaymentMethodOnAdyenStoreInput {
  storeId: string;
  paymentMethod: string;
}

export interface ToggleSettingOnTerminalInput {
  terminalId: string;
  setting: AdyenSettingInput;
}

export interface TransactionCreateManyWithoutPaymentInput {
  create?: TransactionCreateWithoutPaymentInput[] ;
  connect?: TransactionWhereUniqueInput[] ;
}

export interface TransactionCreateWithoutPaymentInput {
  id?: string ;
  amount: number;
  type: string;
  transactionId?: string ;
  refund?: RefundCreateOneWithoutTransactionsInput ;
}

export interface TransactionScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  amount?: number ;
  amount_not?: number ;
  amount_in?: number[] ;
  amount_not_in?: number[] ;
  amount_lt?: number ;
  amount_lte?: number ;
  amount_gt?: number ;
  amount_gte?: number ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  type?: string ;
  type_not?: string ;
  type_in?: string[] ;
  type_not_in?: string[] ;
  type_lt?: string ;
  type_lte?: string ;
  type_gt?: string ;
  type_gte?: string ;
  type_contains?: string ;
  type_not_contains?: string ;
  type_starts_with?: string ;
  type_not_starts_with?: string ;
  type_ends_with?: string ;
  type_not_ends_with?: string ;
  transactionId?: string ;
  transactionId_not?: string ;
  transactionId_in?: string[] ;
  transactionId_not_in?: string[] ;
  transactionId_lt?: string ;
  transactionId_lte?: string ;
  transactionId_gt?: string ;
  transactionId_gte?: string ;
  transactionId_contains?: string ;
  transactionId_not_contains?: string ;
  transactionId_starts_with?: string ;
  transactionId_not_starts_with?: string ;
  transactionId_ends_with?: string ;
  transactionId_not_ends_with?: string ;
  AND?: TransactionScalarWhereInput[] ;
  OR?: TransactionScalarWhereInput[] ;
  NOT?: TransactionScalarWhereInput[] ;
}

export interface TransactionUpdateManyDataInput {
  amount?: number ;
  type?: string ;
  transactionId?: string ;
}

export interface TransactionUpdateManyWithWhereNestedInput {
  where: TransactionScalarWhereInput;
  data: TransactionUpdateManyDataInput;
}

export interface TransactionUpdateManyWithoutPaymentInput {
  create?: TransactionCreateWithoutPaymentInput[] ;
  connect?: TransactionWhereUniqueInput[] ;
  set?: TransactionWhereUniqueInput[] ;
  disconnect?: TransactionWhereUniqueInput[] ;
  update?: TransactionUpdateWithWhereUniqueWithoutPaymentInput[] ;
  upsert?: TransactionUpsertWithWhereUniqueWithoutPaymentInput[] ;
  deleteMany?: TransactionScalarWhereInput[] ;
  updateMany?: TransactionUpdateManyWithWhereNestedInput[] ;
}

export interface TransactionUpdateWithWhereUniqueWithoutPaymentInput {
  where: TransactionWhereUniqueInput;
  data: TransactionUpdateWithoutPaymentDataInput;
}

export interface TransactionUpdateWithoutPaymentDataInput {
  amount?: number ;
  type?: string ;
  transactionId?: string ;
  refund?: RefundUpdateOneWithoutTransactionsInput ;
}

export interface TransactionUpsertWithWhereUniqueWithoutPaymentInput {
  where: TransactionWhereUniqueInput;
  update: TransactionUpdateWithoutPaymentDataInput;
  create: TransactionCreateWithoutPaymentInput;
}

export interface TransactionWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  amount?: number ;
  amount_not?: number ;
  amount_in?: number[] ;
  amount_not_in?: number[] ;
  amount_lt?: number ;
  amount_lte?: number ;
  amount_gt?: number ;
  amount_gte?: number ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  type?: string ;
  type_not?: string ;
  type_in?: string[] ;
  type_not_in?: string[] ;
  type_lt?: string ;
  type_lte?: string ;
  type_gt?: string ;
  type_gte?: string ;
  type_contains?: string ;
  type_not_contains?: string ;
  type_starts_with?: string ;
  type_not_starts_with?: string ;
  type_ends_with?: string ;
  type_not_ends_with?: string ;
  transactionId?: string ;
  transactionId_not?: string ;
  transactionId_in?: string[] ;
  transactionId_not_in?: string[] ;
  transactionId_lt?: string ;
  transactionId_lte?: string ;
  transactionId_gt?: string ;
  transactionId_gte?: string ;
  transactionId_contains?: string ;
  transactionId_not_contains?: string ;
  transactionId_starts_with?: string ;
  transactionId_not_starts_with?: string ;
  transactionId_ends_with?: string ;
  transactionId_not_ends_with?: string ;
  payment?: PaymentWhereInput ;
  refund?: RefundWhereInput ;
  AND?: TransactionWhereInput[] ;
  OR?: TransactionWhereInput[] ;
  NOT?: TransactionWhereInput[] ;
}

export interface TransactionWhereUniqueInput {
  id?: string ;
}

export interface TranslatedStringCreateOneWithoutCategoryDescriptionInput {
  create?: TranslatedStringCreateWithoutCategoryDescriptionInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutCategoryNameInput {
  create?: TranslatedStringCreateWithoutCategoryNameInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutCompanyReferralBodyInput {
  create?: TranslatedStringCreateWithoutCompanyReferralBodyInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutCompanyReferralShareMessageInput {
  create?: TranslatedStringCreateWithoutCompanyReferralShareMessageInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutCompanyReferralTitleInput {
  create?: TranslatedStringCreateWithoutCompanyReferralTitleInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutContentSubTitleInput {
  create?: TranslatedStringCreateWithoutContentSubTitleInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutContentTextInput {
  create?: TranslatedStringCreateWithoutContentTextInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutContentTitleInput {
  create?: TranslatedStringCreateWithoutContentTitleInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutDeliveryRateMessageInput {
  create?: TranslatedStringCreateWithoutDeliveryRateMessageInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutDeliveryRateNameInput {
  create?: TranslatedStringCreateWithoutDeliveryRateNameInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutExpressPageDescriptionInput {
  create?: TranslatedStringCreateWithoutExpressPageDescriptionInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutExpressPageTitleInput {
  create?: TranslatedStringCreateWithoutExpressPageTitleInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutItemAllergiesInput {
  create?: TranslatedStringCreateWithoutItemAllergiesInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutItemDescriptionInput {
  create?: TranslatedStringCreateWithoutItemDescriptionInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutItemSizeNameInput {
  create?: TranslatedStringCreateWithoutItemSizeNameInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutItemTitleInput {
  create?: TranslatedStringCreateWithoutItemTitleInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutLayoutInput {
  create?: TranslatedStringCreateWithoutLayoutInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutMembershipLevelDescriptionInput {
  create?: TranslatedStringCreateWithoutMembershipLevelDescriptionInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutMembershipLevelTitleInput {
  create?: TranslatedStringCreateWithoutMembershipLevelTitleInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutMenuNameInput {
  create?: TranslatedStringCreateWithoutMenuNameInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutNotifBodyInput {
  create?: TranslatedStringCreateWithoutNotifBodyInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutNotifTitleInput {
  create?: TranslatedStringCreateWithoutNotifTitleInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutOfferDescriptionInput {
  create?: TranslatedStringCreateWithoutOfferDescriptionInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutOfferNameInput {
  create?: TranslatedStringCreateWithoutOfferNameInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutOfferStageDescriptionInput {
  create?: TranslatedStringCreateWithoutOfferStageDescriptionInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutOfferStageTitleInput {
  create?: TranslatedStringCreateWithoutOfferStageTitleInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutOfferYieldNameInput {
  create?: TranslatedStringCreateWithoutOfferYieldNameInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutPageInput {
  create?: TranslatedStringCreateWithoutPageInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutPosCategoryInput {
  create?: TranslatedStringCreateWithoutPosCategoryInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutStampCardDetailsInput {
  create?: TranslatedStringCreateWithoutStampCardDetailsInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutStampCardNameInput {
  create?: TranslatedStringCreateWithoutStampCardNameInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutStampcardDescriptionInput {
  create?: TranslatedStringCreateWithoutStampcardDescriptionInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutUpsellInput {
  create?: TranslatedStringCreateWithoutUpsellInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutVariationGroupNameInput {
  create?: TranslatedStringCreateWithoutVariationGroupNameInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutVariationNameInput {
  create?: TranslatedStringCreateWithoutVariationNameInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateOneWithoutVenueNameInput {
  create?: TranslatedStringCreateWithoutVenueNameInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringCreateWithoutCategoryDescriptionInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutCategoryNameInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutCompanyReferralBodyInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutCompanyReferralShareMessageInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutCompanyReferralTitleInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutContentSubTitleInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutContentTextInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutContentTitleInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutDeliveryRateMessageInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutDeliveryRateNameInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutExpressPageDescriptionInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutExpressPageTitleInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutItemAllergiesInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutItemDescriptionInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutItemSizeNameInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutItemTitleInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutLayoutInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutMembershipLevelDescriptionInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutMembershipLevelTitleInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutMenuNameInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutNotifBodyInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutNotifTitleInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutOfferDescriptionInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutOfferNameInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutOfferStageDescriptionInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutOfferStageTitleInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutOfferYieldNameInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutPageInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutPosCategoryInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutStampCardDetailsInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutStampCardNameInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutStampcardDescriptionInput {
  id?: string ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutUpsellInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutVariationGroupNameInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutVariationNameInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  venueName?: VenueCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringCreateWithoutVenueNameInput {
  id?: string ;
  stampcardDescription?: StampCardCreateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemCreateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemCreateOneWithoutTitleLangInput ;
  itemAllergies?: ItemCreateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateCreateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateCreateOneWithoutNameInput ;
  categoryDescription?: CategoryCreateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryCreateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeCreateOneWithoutNameLangInput ;
  menuName?: MenuCreateOneWithoutNameLangInput ;
  offerDescription?: OfferCreateOneWithoutDescriptionLangInput ;
  offerName?: OfferCreateOneWithoutNameLangInput ;
  variationName?: VariationCreateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupCreateOneWithoutTitleInput ;
  stampCardName?: StampCardCreateOneWithoutNameLangInput ;
  contentTitle?: ContentCreateOneWithoutTitleInput ;
  contentSubTitle?: ContentCreateOneWithoutSubTitleInput ;
  contentText?: ContentCreateOneWithoutTextInput ;
  notifTitle?: NotificationCreateOneWithoutTitleInput ;
  notifBody?: NotificationCreateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelCreateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelCreateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageCreateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageCreateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyCreateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyCreateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyCreateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventCreateOneWithoutNameInput ;
  stampCardDetails?: StampCardCreateOneWithoutDetailsInput ;
  layout?: LayoutCreateOneWithoutNameInput ;
  posCategory?: PosCategoryCreateOneWithoutNameInput ;
  page?: PageCreateOneWithoutNameInput ;
  upsell?: UpsellCreateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageCreateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageCreateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateOneRequiredWithoutExpressPageTitleInput {
  create?: TranslatedStringCreateWithoutExpressPageTitleInput ;
  update?: TranslatedStringUpdateWithoutExpressPageTitleDataInput ;
  upsert?: TranslatedStringUpsertWithoutExpressPageTitleInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneRequiredWithoutLayoutInput {
  create?: TranslatedStringCreateWithoutLayoutInput ;
  update?: TranslatedStringUpdateWithoutLayoutDataInput ;
  upsert?: TranslatedStringUpsertWithoutLayoutInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneRequiredWithoutMembershipLevelDescriptionInput {
  create?: TranslatedStringCreateWithoutMembershipLevelDescriptionInput ;
  update?: TranslatedStringUpdateWithoutMembershipLevelDescriptionDataInput ;
  upsert?: TranslatedStringUpsertWithoutMembershipLevelDescriptionInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneRequiredWithoutMembershipLevelTitleInput {
  create?: TranslatedStringCreateWithoutMembershipLevelTitleInput ;
  update?: TranslatedStringUpdateWithoutMembershipLevelTitleDataInput ;
  upsert?: TranslatedStringUpsertWithoutMembershipLevelTitleInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneRequiredWithoutOfferStageDescriptionInput {
  create?: TranslatedStringCreateWithoutOfferStageDescriptionInput ;
  update?: TranslatedStringUpdateWithoutOfferStageDescriptionDataInput ;
  upsert?: TranslatedStringUpsertWithoutOfferStageDescriptionInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneRequiredWithoutOfferStageTitleInput {
  create?: TranslatedStringCreateWithoutOfferStageTitleInput ;
  update?: TranslatedStringUpdateWithoutOfferStageTitleDataInput ;
  upsert?: TranslatedStringUpsertWithoutOfferStageTitleInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneRequiredWithoutPageInput {
  create?: TranslatedStringCreateWithoutPageInput ;
  update?: TranslatedStringUpdateWithoutPageDataInput ;
  upsert?: TranslatedStringUpsertWithoutPageInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneRequiredWithoutPosCategoryInput {
  create?: TranslatedStringCreateWithoutPosCategoryInput ;
  update?: TranslatedStringUpdateWithoutPosCategoryDataInput ;
  upsert?: TranslatedStringUpsertWithoutPosCategoryInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneRequiredWithoutUpsellInput {
  create?: TranslatedStringCreateWithoutUpsellInput ;
  update?: TranslatedStringUpdateWithoutUpsellDataInput ;
  upsert?: TranslatedStringUpsertWithoutUpsellInput ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneWithoutCategoryDescriptionInput {
  create?: TranslatedStringCreateWithoutCategoryDescriptionInput ;
  update?: TranslatedStringUpdateWithoutCategoryDescriptionDataInput ;
  upsert?: TranslatedStringUpsertWithoutCategoryDescriptionInput ;
  disconnect?: boolean ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneWithoutCategoryNameInput {
  create?: TranslatedStringCreateWithoutCategoryNameInput ;
  update?: TranslatedStringUpdateWithoutCategoryNameDataInput ;
  upsert?: TranslatedStringUpsertWithoutCategoryNameInput ;
  disconnect?: boolean ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneWithoutCompanyReferralBodyInput {
  create?: TranslatedStringCreateWithoutCompanyReferralBodyInput ;
  update?: TranslatedStringUpdateWithoutCompanyReferralBodyDataInput ;
  upsert?: TranslatedStringUpsertWithoutCompanyReferralBodyInput ;
  disconnect?: boolean ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneWithoutCompanyReferralShareMessageInput {
  create?: TranslatedStringCreateWithoutCompanyReferralShareMessageInput ;
  update?: TranslatedStringUpdateWithoutCompanyReferralShareMessageDataInput ;
  upsert?: TranslatedStringUpsertWithoutCompanyReferralShareMessageInput ;
  disconnect?: boolean ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneWithoutCompanyReferralTitleInput {
  create?: TranslatedStringCreateWithoutCompanyReferralTitleInput ;
  update?: TranslatedStringUpdateWithoutCompanyReferralTitleDataInput ;
  upsert?: TranslatedStringUpsertWithoutCompanyReferralTitleInput ;
  disconnect?: boolean ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneWithoutContentSubTitleInput {
  create?: TranslatedStringCreateWithoutContentSubTitleInput ;
  update?: TranslatedStringUpdateWithoutContentSubTitleDataInput ;
  upsert?: TranslatedStringUpsertWithoutContentSubTitleInput ;
  disconnect?: boolean ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneWithoutContentTextInput {
  create?: TranslatedStringCreateWithoutContentTextInput ;
  update?: TranslatedStringUpdateWithoutContentTextDataInput ;
  upsert?: TranslatedStringUpsertWithoutContentTextInput ;
  disconnect?: boolean ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneWithoutContentTitleInput {
  create?: TranslatedStringCreateWithoutContentTitleInput ;
  update?: TranslatedStringUpdateWithoutContentTitleDataInput ;
  upsert?: TranslatedStringUpsertWithoutContentTitleInput ;
  disconnect?: boolean ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneWithoutDeliveryRateMessageInput {
  create?: TranslatedStringCreateWithoutDeliveryRateMessageInput ;
  update?: TranslatedStringUpdateWithoutDeliveryRateMessageDataInput ;
  upsert?: TranslatedStringUpsertWithoutDeliveryRateMessageInput ;
  disconnect?: boolean ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneWithoutDeliveryRateNameInput {
  create?: TranslatedStringCreateWithoutDeliveryRateNameInput ;
  update?: TranslatedStringUpdateWithoutDeliveryRateNameDataInput ;
  upsert?: TranslatedStringUpsertWithoutDeliveryRateNameInput ;
  disconnect?: boolean ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneWithoutExpressPageDescriptionInput {
  create?: TranslatedStringCreateWithoutExpressPageDescriptionInput ;
  update?: TranslatedStringUpdateWithoutExpressPageDescriptionDataInput ;
  upsert?: TranslatedStringUpsertWithoutExpressPageDescriptionInput ;
  disconnect?: boolean ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneWithoutItemAllergiesInput {
  create?: TranslatedStringCreateWithoutItemAllergiesInput ;
  update?: TranslatedStringUpdateWithoutItemAllergiesDataInput ;
  upsert?: TranslatedStringUpsertWithoutItemAllergiesInput ;
  disconnect?: boolean ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneWithoutItemDescriptionInput {
  create?: TranslatedStringCreateWithoutItemDescriptionInput ;
  update?: TranslatedStringUpdateWithoutItemDescriptionDataInput ;
  upsert?: TranslatedStringUpsertWithoutItemDescriptionInput ;
  disconnect?: boolean ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneWithoutItemSizeNameInput {
  create?: TranslatedStringCreateWithoutItemSizeNameInput ;
  update?: TranslatedStringUpdateWithoutItemSizeNameDataInput ;
  upsert?: TranslatedStringUpsertWithoutItemSizeNameInput ;
  disconnect?: boolean ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneWithoutItemTitleInput {
  create?: TranslatedStringCreateWithoutItemTitleInput ;
  update?: TranslatedStringUpdateWithoutItemTitleDataInput ;
  upsert?: TranslatedStringUpsertWithoutItemTitleInput ;
  disconnect?: boolean ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneWithoutMenuNameInput {
  create?: TranslatedStringCreateWithoutMenuNameInput ;
  update?: TranslatedStringUpdateWithoutMenuNameDataInput ;
  upsert?: TranslatedStringUpsertWithoutMenuNameInput ;
  disconnect?: boolean ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneWithoutNotifBodyInput {
  create?: TranslatedStringCreateWithoutNotifBodyInput ;
  update?: TranslatedStringUpdateWithoutNotifBodyDataInput ;
  upsert?: TranslatedStringUpsertWithoutNotifBodyInput ;
  disconnect?: boolean ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneWithoutNotifTitleInput {
  create?: TranslatedStringCreateWithoutNotifTitleInput ;
  update?: TranslatedStringUpdateWithoutNotifTitleDataInput ;
  upsert?: TranslatedStringUpsertWithoutNotifTitleInput ;
  disconnect?: boolean ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneWithoutOfferDescriptionInput {
  create?: TranslatedStringCreateWithoutOfferDescriptionInput ;
  update?: TranslatedStringUpdateWithoutOfferDescriptionDataInput ;
  upsert?: TranslatedStringUpsertWithoutOfferDescriptionInput ;
  disconnect?: boolean ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneWithoutOfferNameInput {
  create?: TranslatedStringCreateWithoutOfferNameInput ;
  update?: TranslatedStringUpdateWithoutOfferNameDataInput ;
  upsert?: TranslatedStringUpsertWithoutOfferNameInput ;
  disconnect?: boolean ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneWithoutOfferYieldNameInput {
  create?: TranslatedStringCreateWithoutOfferYieldNameInput ;
  update?: TranslatedStringUpdateWithoutOfferYieldNameDataInput ;
  upsert?: TranslatedStringUpsertWithoutOfferYieldNameInput ;
  disconnect?: boolean ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneWithoutStampCardDetailsInput {
  create?: TranslatedStringCreateWithoutStampCardDetailsInput ;
  update?: TranslatedStringUpdateWithoutStampCardDetailsDataInput ;
  upsert?: TranslatedStringUpsertWithoutStampCardDetailsInput ;
  disconnect?: boolean ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneWithoutStampCardNameInput {
  create?: TranslatedStringCreateWithoutStampCardNameInput ;
  update?: TranslatedStringUpdateWithoutStampCardNameDataInput ;
  upsert?: TranslatedStringUpsertWithoutStampCardNameInput ;
  disconnect?: boolean ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneWithoutStampcardDescriptionInput {
  create?: TranslatedStringCreateWithoutStampcardDescriptionInput ;
  update?: TranslatedStringUpdateWithoutStampcardDescriptionDataInput ;
  upsert?: TranslatedStringUpsertWithoutStampcardDescriptionInput ;
  disconnect?: boolean ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneWithoutVariationGroupNameInput {
  create?: TranslatedStringCreateWithoutVariationGroupNameInput ;
  update?: TranslatedStringUpdateWithoutVariationGroupNameDataInput ;
  upsert?: TranslatedStringUpsertWithoutVariationGroupNameInput ;
  disconnect?: boolean ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneWithoutVariationNameInput {
  create?: TranslatedStringCreateWithoutVariationNameInput ;
  update?: TranslatedStringUpdateWithoutVariationNameDataInput ;
  upsert?: TranslatedStringUpsertWithoutVariationNameInput ;
  disconnect?: boolean ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateOneWithoutVenueNameInput {
  create?: TranslatedStringCreateWithoutVenueNameInput ;
  update?: TranslatedStringUpdateWithoutVenueNameDataInput ;
  upsert?: TranslatedStringUpsertWithoutVenueNameInput ;
  disconnect?: boolean ;
  connect?: TranslatedStringWhereUniqueInput ;
}

export interface TranslatedStringUpdateWithoutCategoryDescriptionDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutCategoryNameDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutCompanyReferralBodyDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutCompanyReferralShareMessageDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutCompanyReferralTitleDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutContentSubTitleDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutContentTextDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutContentTitleDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutDeliveryRateMessageDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutDeliveryRateNameDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutExpressPageDescriptionDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutExpressPageTitleDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutItemAllergiesDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutItemDescriptionDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutItemSizeNameDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutItemTitleDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutLayoutDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutMembershipLevelDescriptionDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutMembershipLevelTitleDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutMenuNameDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutNotifBodyDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutNotifTitleDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutOfferDescriptionDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutOfferNameDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutOfferStageDescriptionDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutOfferStageTitleDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutOfferYieldNameDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutPageDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutPosCategoryDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutStampCardDetailsDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutStampCardNameDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutStampcardDescriptionDataInput {
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutUpsellDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutVariationGroupNameDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutVariationNameDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  venueName?: VenueUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpdateWithoutVenueNameDataInput {
  stampcardDescription?: StampCardUpdateOneWithoutDescriptionLangInput ;
  itemDescription?: ItemUpdateOneWithoutDescriptionLangInput ;
  itemTitle?: ItemUpdateOneWithoutTitleLangInput ;
  itemAllergies?: ItemUpdateOneWithoutAllergiesInput ;
  deliveryRateMessage?: DeliveryRateUpdateOneWithoutMessageInput ;
  deliveryRateName?: DeliveryRateUpdateOneWithoutNameInput ;
  categoryDescription?: CategoryUpdateOneWithoutDescriptionLangInput ;
  categoryName?: CategoryUpdateOneWithoutNameLangInput ;
  itemSizeName?: ItemSizeUpdateOneWithoutNameLangInput ;
  menuName?: MenuUpdateOneWithoutNameLangInput ;
  offerDescription?: OfferUpdateOneWithoutDescriptionLangInput ;
  offerName?: OfferUpdateOneWithoutNameLangInput ;
  variationName?: VariationUpdateOneWithoutNameLangInput ;
  variationGroupName?: VariationGroupUpdateOneWithoutTitleInput ;
  stampCardName?: StampCardUpdateOneWithoutNameLangInput ;
  contentTitle?: ContentUpdateOneWithoutTitleInput ;
  contentSubTitle?: ContentUpdateOneWithoutSubTitleInput ;
  contentText?: ContentUpdateOneWithoutTextInput ;
  notifTitle?: NotificationUpdateOneWithoutTitleInput ;
  notifBody?: NotificationUpdateOneWithoutBodyInput ;
  membershipLevelTitle?: MembershipLevelUpdateOneWithoutTitleInput ;
  membershipLevelDescription?: MembershipLevelUpdateOneWithoutDescriptionInput ;
  offerStageTitle?: OfferStageUpdateOneWithoutTitleInput ;
  offerStageDescription?: OfferStageUpdateOneWithoutDescriptionInput ;
  companyReferralTitle?: CompanyUpdateOneWithoutReferralTitleInput ;
  companyReferralBody?: CompanyUpdateOneWithoutReferralBodyInput ;
  companyReferralShareMessage?: CompanyUpdateOneWithoutReferralShareMessageInput ;
  offerYieldName?: OfferYieldEventUpdateOneWithoutNameInput ;
  stampCardDetails?: StampCardUpdateOneWithoutDetailsInput ;
  layout?: LayoutUpdateOneWithoutNameInput ;
  posCategory?: PosCategoryUpdateOneWithoutNameInput ;
  page?: PageUpdateOneWithoutNameInput ;
  upsell?: UpsellUpdateOneWithoutNameInput ;
  expressPageTitle?: ExpressPageUpdateOneWithoutTitleInput ;
  expressPageDescription?: ExpressPageUpdateOneWithoutDescriptionInput ;
  en?: string ;
  se?: string ;
  no?: string ;
  es?: string ;
  pt?: string ;
}

export interface TranslatedStringUpsertWithoutCategoryDescriptionInput {
  update: TranslatedStringUpdateWithoutCategoryDescriptionDataInput;
  create: TranslatedStringCreateWithoutCategoryDescriptionInput;
}

export interface TranslatedStringUpsertWithoutCategoryNameInput {
  update: TranslatedStringUpdateWithoutCategoryNameDataInput;
  create: TranslatedStringCreateWithoutCategoryNameInput;
}

export interface TranslatedStringUpsertWithoutCompanyReferralBodyInput {
  update: TranslatedStringUpdateWithoutCompanyReferralBodyDataInput;
  create: TranslatedStringCreateWithoutCompanyReferralBodyInput;
}

export interface TranslatedStringUpsertWithoutCompanyReferralShareMessageInput {
  update: TranslatedStringUpdateWithoutCompanyReferralShareMessageDataInput;
  create: TranslatedStringCreateWithoutCompanyReferralShareMessageInput;
}

export interface TranslatedStringUpsertWithoutCompanyReferralTitleInput {
  update: TranslatedStringUpdateWithoutCompanyReferralTitleDataInput;
  create: TranslatedStringCreateWithoutCompanyReferralTitleInput;
}

export interface TranslatedStringUpsertWithoutContentSubTitleInput {
  update: TranslatedStringUpdateWithoutContentSubTitleDataInput;
  create: TranslatedStringCreateWithoutContentSubTitleInput;
}

export interface TranslatedStringUpsertWithoutContentTextInput {
  update: TranslatedStringUpdateWithoutContentTextDataInput;
  create: TranslatedStringCreateWithoutContentTextInput;
}

export interface TranslatedStringUpsertWithoutContentTitleInput {
  update: TranslatedStringUpdateWithoutContentTitleDataInput;
  create: TranslatedStringCreateWithoutContentTitleInput;
}

export interface TranslatedStringUpsertWithoutDeliveryRateMessageInput {
  update: TranslatedStringUpdateWithoutDeliveryRateMessageDataInput;
  create: TranslatedStringCreateWithoutDeliveryRateMessageInput;
}

export interface TranslatedStringUpsertWithoutDeliveryRateNameInput {
  update: TranslatedStringUpdateWithoutDeliveryRateNameDataInput;
  create: TranslatedStringCreateWithoutDeliveryRateNameInput;
}

export interface TranslatedStringUpsertWithoutExpressPageDescriptionInput {
  update: TranslatedStringUpdateWithoutExpressPageDescriptionDataInput;
  create: TranslatedStringCreateWithoutExpressPageDescriptionInput;
}

export interface TranslatedStringUpsertWithoutExpressPageTitleInput {
  update: TranslatedStringUpdateWithoutExpressPageTitleDataInput;
  create: TranslatedStringCreateWithoutExpressPageTitleInput;
}

export interface TranslatedStringUpsertWithoutItemAllergiesInput {
  update: TranslatedStringUpdateWithoutItemAllergiesDataInput;
  create: TranslatedStringCreateWithoutItemAllergiesInput;
}

export interface TranslatedStringUpsertWithoutItemDescriptionInput {
  update: TranslatedStringUpdateWithoutItemDescriptionDataInput;
  create: TranslatedStringCreateWithoutItemDescriptionInput;
}

export interface TranslatedStringUpsertWithoutItemSizeNameInput {
  update: TranslatedStringUpdateWithoutItemSizeNameDataInput;
  create: TranslatedStringCreateWithoutItemSizeNameInput;
}

export interface TranslatedStringUpsertWithoutItemTitleInput {
  update: TranslatedStringUpdateWithoutItemTitleDataInput;
  create: TranslatedStringCreateWithoutItemTitleInput;
}

export interface TranslatedStringUpsertWithoutLayoutInput {
  update: TranslatedStringUpdateWithoutLayoutDataInput;
  create: TranslatedStringCreateWithoutLayoutInput;
}

export interface TranslatedStringUpsertWithoutMembershipLevelDescriptionInput {
  update: TranslatedStringUpdateWithoutMembershipLevelDescriptionDataInput;
  create: TranslatedStringCreateWithoutMembershipLevelDescriptionInput;
}

export interface TranslatedStringUpsertWithoutMembershipLevelTitleInput {
  update: TranslatedStringUpdateWithoutMembershipLevelTitleDataInput;
  create: TranslatedStringCreateWithoutMembershipLevelTitleInput;
}

export interface TranslatedStringUpsertWithoutMenuNameInput {
  update: TranslatedStringUpdateWithoutMenuNameDataInput;
  create: TranslatedStringCreateWithoutMenuNameInput;
}

export interface TranslatedStringUpsertWithoutNotifBodyInput {
  update: TranslatedStringUpdateWithoutNotifBodyDataInput;
  create: TranslatedStringCreateWithoutNotifBodyInput;
}

export interface TranslatedStringUpsertWithoutNotifTitleInput {
  update: TranslatedStringUpdateWithoutNotifTitleDataInput;
  create: TranslatedStringCreateWithoutNotifTitleInput;
}

export interface TranslatedStringUpsertWithoutOfferDescriptionInput {
  update: TranslatedStringUpdateWithoutOfferDescriptionDataInput;
  create: TranslatedStringCreateWithoutOfferDescriptionInput;
}

export interface TranslatedStringUpsertWithoutOfferNameInput {
  update: TranslatedStringUpdateWithoutOfferNameDataInput;
  create: TranslatedStringCreateWithoutOfferNameInput;
}

export interface TranslatedStringUpsertWithoutOfferStageDescriptionInput {
  update: TranslatedStringUpdateWithoutOfferStageDescriptionDataInput;
  create: TranslatedStringCreateWithoutOfferStageDescriptionInput;
}

export interface TranslatedStringUpsertWithoutOfferStageTitleInput {
  update: TranslatedStringUpdateWithoutOfferStageTitleDataInput;
  create: TranslatedStringCreateWithoutOfferStageTitleInput;
}

export interface TranslatedStringUpsertWithoutOfferYieldNameInput {
  update: TranslatedStringUpdateWithoutOfferYieldNameDataInput;
  create: TranslatedStringCreateWithoutOfferYieldNameInput;
}

export interface TranslatedStringUpsertWithoutPageInput {
  update: TranslatedStringUpdateWithoutPageDataInput;
  create: TranslatedStringCreateWithoutPageInput;
}

export interface TranslatedStringUpsertWithoutPosCategoryInput {
  update: TranslatedStringUpdateWithoutPosCategoryDataInput;
  create: TranslatedStringCreateWithoutPosCategoryInput;
}

export interface TranslatedStringUpsertWithoutStampCardDetailsInput {
  update: TranslatedStringUpdateWithoutStampCardDetailsDataInput;
  create: TranslatedStringCreateWithoutStampCardDetailsInput;
}

export interface TranslatedStringUpsertWithoutStampCardNameInput {
  update: TranslatedStringUpdateWithoutStampCardNameDataInput;
  create: TranslatedStringCreateWithoutStampCardNameInput;
}

export interface TranslatedStringUpsertWithoutStampcardDescriptionInput {
  update: TranslatedStringUpdateWithoutStampcardDescriptionDataInput;
  create: TranslatedStringCreateWithoutStampcardDescriptionInput;
}

export interface TranslatedStringUpsertWithoutUpsellInput {
  update: TranslatedStringUpdateWithoutUpsellDataInput;
  create: TranslatedStringCreateWithoutUpsellInput;
}

export interface TranslatedStringUpsertWithoutVariationGroupNameInput {
  update: TranslatedStringUpdateWithoutVariationGroupNameDataInput;
  create: TranslatedStringCreateWithoutVariationGroupNameInput;
}

export interface TranslatedStringUpsertWithoutVariationNameInput {
  update: TranslatedStringUpdateWithoutVariationNameDataInput;
  create: TranslatedStringCreateWithoutVariationNameInput;
}

export interface TranslatedStringUpsertWithoutVenueNameInput {
  update: TranslatedStringUpdateWithoutVenueNameDataInput;
  create: TranslatedStringCreateWithoutVenueNameInput;
}

export interface TranslatedStringWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  stampcardDescription?: StampCardWhereInput ;
  itemDescription?: ItemWhereInput ;
  itemTitle?: ItemWhereInput ;
  itemAllergies?: ItemWhereInput ;
  deliveryRateMessage?: DeliveryRateWhereInput ;
  deliveryRateName?: DeliveryRateWhereInput ;
  categoryDescription?: CategoryWhereInput ;
  categoryName?: CategoryWhereInput ;
  itemSizeName?: ItemSizeWhereInput ;
  menuName?: MenuWhereInput ;
  offerDescription?: OfferWhereInput ;
  offerName?: OfferWhereInput ;
  variationName?: VariationWhereInput ;
  venueName?: VenueWhereInput ;
  variationGroupName?: VariationGroupWhereInput ;
  stampCardName?: StampCardWhereInput ;
  contentTitle?: ContentWhereInput ;
  contentSubTitle?: ContentWhereInput ;
  contentText?: ContentWhereInput ;
  notifTitle?: NotificationWhereInput ;
  notifBody?: NotificationWhereInput ;
  membershipLevelTitle?: MembershipLevelWhereInput ;
  membershipLevelDescription?: MembershipLevelWhereInput ;
  offerStageTitle?: OfferStageWhereInput ;
  offerStageDescription?: OfferStageWhereInput ;
  companyReferralTitle?: CompanyWhereInput ;
  companyReferralBody?: CompanyWhereInput ;
  companyReferralShareMessage?: CompanyWhereInput ;
  offerYieldName?: OfferYieldEventWhereInput ;
  stampCardDetails?: StampCardWhereInput ;
  layout?: LayoutWhereInput ;
  posCategory?: PosCategoryWhereInput ;
  page?: PageWhereInput ;
  upsell?: UpsellWhereInput ;
  expressPageTitle?: ExpressPageWhereInput ;
  expressPageDescription?: ExpressPageWhereInput ;
  en?: string ;
  en_not?: string ;
  en_in?: string[] ;
  en_not_in?: string[] ;
  en_lt?: string ;
  en_lte?: string ;
  en_gt?: string ;
  en_gte?: string ;
  en_contains?: string ;
  en_not_contains?: string ;
  en_starts_with?: string ;
  en_not_starts_with?: string ;
  en_ends_with?: string ;
  en_not_ends_with?: string ;
  se?: string ;
  se_not?: string ;
  se_in?: string[] ;
  se_not_in?: string[] ;
  se_lt?: string ;
  se_lte?: string ;
  se_gt?: string ;
  se_gte?: string ;
  se_contains?: string ;
  se_not_contains?: string ;
  se_starts_with?: string ;
  se_not_starts_with?: string ;
  se_ends_with?: string ;
  se_not_ends_with?: string ;
  no?: string ;
  no_not?: string ;
  no_in?: string[] ;
  no_not_in?: string[] ;
  no_lt?: string ;
  no_lte?: string ;
  no_gt?: string ;
  no_gte?: string ;
  no_contains?: string ;
  no_not_contains?: string ;
  no_starts_with?: string ;
  no_not_starts_with?: string ;
  no_ends_with?: string ;
  no_not_ends_with?: string ;
  es?: string ;
  es_not?: string ;
  es_in?: string[] ;
  es_not_in?: string[] ;
  es_lt?: string ;
  es_lte?: string ;
  es_gt?: string ;
  es_gte?: string ;
  es_contains?: string ;
  es_not_contains?: string ;
  es_starts_with?: string ;
  es_not_starts_with?: string ;
  es_ends_with?: string ;
  es_not_ends_with?: string ;
  pt?: string ;
  pt_not?: string ;
  pt_in?: string[] ;
  pt_not_in?: string[] ;
  pt_lt?: string ;
  pt_lte?: string ;
  pt_gt?: string ;
  pt_gte?: string ;
  pt_contains?: string ;
  pt_not_contains?: string ;
  pt_starts_with?: string ;
  pt_not_starts_with?: string ;
  pt_ends_with?: string ;
  pt_not_ends_with?: string ;
  AND?: TranslatedStringWhereInput[] ;
  OR?: TranslatedStringWhereInput[] ;
  NOT?: TranslatedStringWhereInput[] ;
}

export interface TranslatedStringWhereUniqueInput {
  id?: string ;
}

export interface UpdateActiveLicenseInput {
  deviceId?: string ;
  venueId?: string ;
  price?: number ;
}

export interface UpdateCategoryMetadataInput {
  categoryId: string;
  companyId: string;
  ukVatRate?: number ;
  icon?: string ;
}

export interface UpdateCompanyMetadataInput {
  id: string;
  country?: string ;
  referralId?: string ;
  isPaymentsOnly?: boolean ;
  showPaymentPrompts?: boolean ;
  modificationGroups?: ModificationGroupInput ;
  useNewLicenses?: boolean ;
  useNewLoyalty?: boolean ;
  notes?: string ;
}

export interface UpdateConfigInput {
  id: string;
  marketplaceId?: string ;
  logoUrl?: string ;
  name: string;
  theme?: any ;
  landingPageBackgroundUrl?: string ;
  landingPageDesktopBackgroundUrl?: string ;
  serviceTypes?: string[] ;
  disableComments?: boolean ;
  disablePickuptime?: boolean ;
  enableTipping?: boolean ;
  collectCustomerContactData?: boolean ;
  enableAnonymousOrders?: boolean ;
  enableInvoicing?: boolean ;
  landingpageSections?: any[] ;
  customText_registrationPrompt?: any ;
  trackingId_googleAnalytics?: string ;
  trackingId_facebook?: string ;
  greetingText?: any ;
  navigationInfoText?: any ;
  showCategoriesInGridView?: boolean ;
  force3DSecure?: boolean ;
  sendSmsOnOrderUpdates?: boolean ;
  landingPageIntro?: any ;
  aboutUs?: any ;
  useNewOnlineOrdering?: boolean ;
  hideEmptyTopLevelCategories?: boolean ;
}

export interface UpdateGiftcardUniverseAccessInput {
  ownerId: string;
  universeId: string;
}

export interface UpdateInvoiceAccountInput {
  legalEntityId?: string ;
  orgNumber?: string ;
  name?: string ;
  country?: string ;
  region?: string ;
  city?: string ;
  postalCode?: string ;
  street?: string ;
  email?: string ;
  additionalEmails?: string[] ;
  paymentStatus?: INVOICE_ACCOUNT_PAYMENT_STATUS ;
  isPOSAccessBlocked?: boolean ;
  isInvoiceWarningActive?: boolean ;
}

export interface UpdateItemMetadataInput {
  id: string;
  companyId: string;
  modificationGroups?: string[] ;
  appendModificationGroups?: string[] ;
  manualName?: boolean ;
  allergyTags?: string[] ;
  appendAllergyTags?: string[] ;
  upsalesSortOrder?: string[] ;
}

export interface UpdateModificationGroupInput {
  id: string;
  type?: MODIFICATION_GROUP_TYPE ;
  preselectedVariations?: string[] ;
  expandedByDefault?: boolean ;
  required?: boolean ;
  variations?: string[] ;
  internalName?: string ;
  externalName?: any ;
  isGridViewEnabled?: boolean ;
  icon?: string ;
}

export interface UpdateOrganizationInput {
  id: string;
  name: string;
}

export interface UpdatePaymentMethodMetadataInput {
  paymentMethodId: string;
  accessLevelIds?: string[] ;
  venueIds?: string[] ;
  isPrimary?: boolean ;
  maxAmount?: number ;
}

export interface UpdatePromoCodeInput {
  venues?: string[] ;
  code: string;
  active: boolean;
  discountType: DISCOUNT_TYPE;
  discountRate: number;
  title: PromoCodeTitleInput;
  useLimit?: number ;
  requiresUser: boolean;
  activatesAt?: string ;
  expiresAt?: string ;
  activeBetweenHours?: string[] ;
  categoryIds?: string[] ;
  serviceTypes?: string[] ;
}

export interface UpdateReleaseInput {
  id: string;
  type: RELEASE_TYPE;
  titleLang?: any ;
  bodyLang?: any ;
  imageUrls?: (string )[] ;
  notes?: NoteInput[] ;
  productTags: PRODUCT_TAG[];
  repository?: string ;
  triggerModal?: boolean ;
}

export interface UpdateTablesData {
  data: TableUpdateInput;
  where: TableWhereUniqueInput;
}

export interface UpdateUpsellMetadataInput {
  upsellId: string;
  enableMultiSelect?: boolean ;
  hideInPOS?: boolean ;
  hideInApp?: boolean ;
  hideInEPOS?: boolean ;
  itemsSortingOrder?: string[] ;
  icon?: string ;
}

export interface UpdateUserPermissionsInput {
  userId: string;
  scopes?: PERMISSION_SCOPE[] ;
  venueIds?: string[] ;
  companyId?: string ;
}

export interface UpdateVenueMetadataInput {
  venueId: string;
  zip?: string ;
  cashFloat?: number ;
  beeperList?: string[] ;
  hasIndividualEOD?: boolean ;
  googlePlaceId?: string ;
  pauseOnlineOrdersUntil?: string ;
  discountExcludedCategoryIds?: string[] ;
  useCoursesInKDS?: boolean ;
  lateAfterMinutesInKDS?: number ;
}

export interface UpsellCreateInput {
  id?: string ;
  name: TranslatedStringCreateOneWithoutUpsellInput;
  company: CompanyCreateOneWithoutUpsellsInput;
  deleted?: boolean ;
  items?: ItemCreateManyWithoutUsedAsUpsellOnInput ;
  usedOn?: ItemCreateManyWithoutUpsellInput ;
  itemsUsedOn?: ItemCreateManyWithoutUpsalesInput ;
  displayOrder?: number ;
}

export interface UpsellCreateManyWithoutCompanyInput {
  create?: UpsellCreateWithoutCompanyInput[] ;
  connect?: UpsellWhereUniqueInput[] ;
}

export interface UpsellCreateManyWithoutItemsInput {
  create?: UpsellCreateWithoutItemsInput[] ;
  connect?: UpsellWhereUniqueInput[] ;
}

export interface UpsellCreateManyWithoutItemsUsedOnInput {
  create?: UpsellCreateWithoutItemsUsedOnInput[] ;
  connect?: UpsellWhereUniqueInput[] ;
}

export interface UpsellCreateOneWithoutNameInput {
  create?: UpsellCreateWithoutNameInput ;
  connect?: UpsellWhereUniqueInput ;
}

export interface UpsellCreateOneWithoutUsedOnInput {
  create?: UpsellCreateWithoutUsedOnInput ;
  connect?: UpsellWhereUniqueInput ;
}

export interface UpsellCreateWithoutCompanyInput {
  id?: string ;
  name: TranslatedStringCreateOneWithoutUpsellInput;
  deleted?: boolean ;
  items?: ItemCreateManyWithoutUsedAsUpsellOnInput ;
  usedOn?: ItemCreateManyWithoutUpsellInput ;
  itemsUsedOn?: ItemCreateManyWithoutUpsalesInput ;
  displayOrder?: number ;
}

export interface UpsellCreateWithoutItemsInput {
  id?: string ;
  name: TranslatedStringCreateOneWithoutUpsellInput;
  company: CompanyCreateOneWithoutUpsellsInput;
  deleted?: boolean ;
  usedOn?: ItemCreateManyWithoutUpsellInput ;
  itemsUsedOn?: ItemCreateManyWithoutUpsalesInput ;
  displayOrder?: number ;
}

export interface UpsellCreateWithoutItemsUsedOnInput {
  id?: string ;
  name: TranslatedStringCreateOneWithoutUpsellInput;
  company: CompanyCreateOneWithoutUpsellsInput;
  deleted?: boolean ;
  items?: ItemCreateManyWithoutUsedAsUpsellOnInput ;
  usedOn?: ItemCreateManyWithoutUpsellInput ;
  displayOrder?: number ;
}

export interface UpsellCreateWithoutNameInput {
  id?: string ;
  company: CompanyCreateOneWithoutUpsellsInput;
  deleted?: boolean ;
  items?: ItemCreateManyWithoutUsedAsUpsellOnInput ;
  usedOn?: ItemCreateManyWithoutUpsellInput ;
  itemsUsedOn?: ItemCreateManyWithoutUpsalesInput ;
  displayOrder?: number ;
}

export interface UpsellCreateWithoutUsedOnInput {
  id?: string ;
  name: TranslatedStringCreateOneWithoutUpsellInput;
  company: CompanyCreateOneWithoutUpsellsInput;
  deleted?: boolean ;
  items?: ItemCreateManyWithoutUsedAsUpsellOnInput ;
  itemsUsedOn?: ItemCreateManyWithoutUpsalesInput ;
  displayOrder?: number ;
}

export interface UpsellScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  displayOrder?: number ;
  displayOrder_not?: number ;
  displayOrder_in?: number[] ;
  displayOrder_not_in?: number[] ;
  displayOrder_lt?: number ;
  displayOrder_lte?: number ;
  displayOrder_gt?: number ;
  displayOrder_gte?: number ;
  AND?: UpsellScalarWhereInput[] ;
  OR?: UpsellScalarWhereInput[] ;
  NOT?: UpsellScalarWhereInput[] ;
}

export interface UpsellUpdateInput {
  name?: TranslatedStringUpdateOneRequiredWithoutUpsellInput ;
  company?: CompanyUpdateOneRequiredWithoutUpsellsInput ;
  deleted?: boolean ;
  items?: ItemUpdateManyWithoutUsedAsUpsellOnInput ;
  usedOn?: ItemUpdateManyWithoutUpsellInput ;
  itemsUsedOn?: ItemUpdateManyWithoutUpsalesInput ;
  displayOrder?: number ;
}

export interface UpsellUpdateManyDataInput {
  deleted?: boolean ;
  displayOrder?: number ;
}

export interface UpsellUpdateManyWithWhereNestedInput {
  where: UpsellScalarWhereInput;
  data: UpsellUpdateManyDataInput;
}

export interface UpsellUpdateManyWithoutCompanyInput {
  create?: UpsellCreateWithoutCompanyInput[] ;
  connect?: UpsellWhereUniqueInput[] ;
  set?: UpsellWhereUniqueInput[] ;
  disconnect?: UpsellWhereUniqueInput[] ;
  update?: UpsellUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: UpsellUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: UpsellScalarWhereInput[] ;
  updateMany?: UpsellUpdateManyWithWhereNestedInput[] ;
}

export interface UpsellUpdateManyWithoutItemsInput {
  create?: UpsellCreateWithoutItemsInput[] ;
  connect?: UpsellWhereUniqueInput[] ;
  set?: UpsellWhereUniqueInput[] ;
  disconnect?: UpsellWhereUniqueInput[] ;
  update?: UpsellUpdateWithWhereUniqueWithoutItemsInput[] ;
  upsert?: UpsellUpsertWithWhereUniqueWithoutItemsInput[] ;
  deleteMany?: UpsellScalarWhereInput[] ;
  updateMany?: UpsellUpdateManyWithWhereNestedInput[] ;
}

export interface UpsellUpdateManyWithoutItemsUsedOnInput {
  create?: UpsellCreateWithoutItemsUsedOnInput[] ;
  connect?: UpsellWhereUniqueInput[] ;
  set?: UpsellWhereUniqueInput[] ;
  disconnect?: UpsellWhereUniqueInput[] ;
  update?: UpsellUpdateWithWhereUniqueWithoutItemsUsedOnInput[] ;
  upsert?: UpsellUpsertWithWhereUniqueWithoutItemsUsedOnInput[] ;
  deleteMany?: UpsellScalarWhereInput[] ;
  updateMany?: UpsellUpdateManyWithWhereNestedInput[] ;
}

export interface UpsellUpdateOneWithoutNameInput {
  create?: UpsellCreateWithoutNameInput ;
  update?: UpsellUpdateWithoutNameDataInput ;
  upsert?: UpsellUpsertWithoutNameInput ;
  disconnect?: boolean ;
  connect?: UpsellWhereUniqueInput ;
}

export interface UpsellUpdateOneWithoutUsedOnInput {
  create?: UpsellCreateWithoutUsedOnInput ;
  update?: UpsellUpdateWithoutUsedOnDataInput ;
  upsert?: UpsellUpsertWithoutUsedOnInput ;
  disconnect?: boolean ;
  connect?: UpsellWhereUniqueInput ;
}

export interface UpsellUpdateWithWhereUniqueWithoutCompanyInput {
  where: UpsellWhereUniqueInput;
  data: UpsellUpdateWithoutCompanyDataInput;
}

export interface UpsellUpdateWithWhereUniqueWithoutItemsInput {
  where: UpsellWhereUniqueInput;
  data: UpsellUpdateWithoutItemsDataInput;
}

export interface UpsellUpdateWithWhereUniqueWithoutItemsUsedOnInput {
  where: UpsellWhereUniqueInput;
  data: UpsellUpdateWithoutItemsUsedOnDataInput;
}

export interface UpsellUpdateWithoutCompanyDataInput {
  name?: TranslatedStringUpdateOneRequiredWithoutUpsellInput ;
  deleted?: boolean ;
  items?: ItemUpdateManyWithoutUsedAsUpsellOnInput ;
  usedOn?: ItemUpdateManyWithoutUpsellInput ;
  itemsUsedOn?: ItemUpdateManyWithoutUpsalesInput ;
  displayOrder?: number ;
}

export interface UpsellUpdateWithoutItemsDataInput {
  name?: TranslatedStringUpdateOneRequiredWithoutUpsellInput ;
  company?: CompanyUpdateOneRequiredWithoutUpsellsInput ;
  deleted?: boolean ;
  usedOn?: ItemUpdateManyWithoutUpsellInput ;
  itemsUsedOn?: ItemUpdateManyWithoutUpsalesInput ;
  displayOrder?: number ;
}

export interface UpsellUpdateWithoutItemsUsedOnDataInput {
  name?: TranslatedStringUpdateOneRequiredWithoutUpsellInput ;
  company?: CompanyUpdateOneRequiredWithoutUpsellsInput ;
  deleted?: boolean ;
  items?: ItemUpdateManyWithoutUsedAsUpsellOnInput ;
  usedOn?: ItemUpdateManyWithoutUpsellInput ;
  displayOrder?: number ;
}

export interface UpsellUpdateWithoutNameDataInput {
  company?: CompanyUpdateOneRequiredWithoutUpsellsInput ;
  deleted?: boolean ;
  items?: ItemUpdateManyWithoutUsedAsUpsellOnInput ;
  usedOn?: ItemUpdateManyWithoutUpsellInput ;
  itemsUsedOn?: ItemUpdateManyWithoutUpsalesInput ;
  displayOrder?: number ;
}

export interface UpsellUpdateWithoutUsedOnDataInput {
  name?: TranslatedStringUpdateOneRequiredWithoutUpsellInput ;
  company?: CompanyUpdateOneRequiredWithoutUpsellsInput ;
  deleted?: boolean ;
  items?: ItemUpdateManyWithoutUsedAsUpsellOnInput ;
  itemsUsedOn?: ItemUpdateManyWithoutUpsalesInput ;
  displayOrder?: number ;
}

export interface UpsellUpsertWithWhereUniqueWithoutCompanyInput {
  where: UpsellWhereUniqueInput;
  update: UpsellUpdateWithoutCompanyDataInput;
  create: UpsellCreateWithoutCompanyInput;
}

export interface UpsellUpsertWithWhereUniqueWithoutItemsInput {
  where: UpsellWhereUniqueInput;
  update: UpsellUpdateWithoutItemsDataInput;
  create: UpsellCreateWithoutItemsInput;
}

export interface UpsellUpsertWithWhereUniqueWithoutItemsUsedOnInput {
  where: UpsellWhereUniqueInput;
  update: UpsellUpdateWithoutItemsUsedOnDataInput;
  create: UpsellCreateWithoutItemsUsedOnInput;
}

export interface UpsellUpsertWithoutNameInput {
  update: UpsellUpdateWithoutNameDataInput;
  create: UpsellCreateWithoutNameInput;
}

export interface UpsellUpsertWithoutUsedOnInput {
  update: UpsellUpdateWithoutUsedOnDataInput;
  create: UpsellCreateWithoutUsedOnInput;
}

export interface UpsellWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  name?: TranslatedStringWhereInput ;
  company?: CompanyWhereInput ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  items_every?: ItemWhereInput ;
  items_some?: ItemWhereInput ;
  items_none?: ItemWhereInput ;
  usedOn_every?: ItemWhereInput ;
  usedOn_some?: ItemWhereInput ;
  usedOn_none?: ItemWhereInput ;
  itemsUsedOn_every?: ItemWhereInput ;
  itemsUsedOn_some?: ItemWhereInput ;
  itemsUsedOn_none?: ItemWhereInput ;
  displayOrder?: number ;
  displayOrder_not?: number ;
  displayOrder_in?: number[] ;
  displayOrder_not_in?: number[] ;
  displayOrder_lt?: number ;
  displayOrder_lte?: number ;
  displayOrder_gt?: number ;
  displayOrder_gte?: number ;
  AND?: UpsellWhereInput[] ;
  OR?: UpsellWhereInput[] ;
  NOT?: UpsellWhereInput[] ;
}

export interface UpsellWhereUniqueInput {
  id?: string ;
}

export interface UserCenterInput {
  id: string;
  name: string;
  venueId: string;
}

export interface UserCommentCreateInput {
  id?: string ;
  deleted?: boolean ;
  author: UserCreateOneWithoutWrittenCommentsInput;
  user: UserCreateOneWithoutCommentsInput;
  comment: string;
}

export interface UserCommentCreateManyWithoutAuthorInput {
  create?: UserCommentCreateWithoutAuthorInput[] ;
  connect?: UserCommentWhereUniqueInput[] ;
}

export interface UserCommentCreateManyWithoutUserInput {
  create?: UserCommentCreateWithoutUserInput[] ;
  connect?: UserCommentWhereUniqueInput[] ;
}

export interface UserCommentCreateWithoutAuthorInput {
  id?: string ;
  deleted?: boolean ;
  user: UserCreateOneWithoutCommentsInput;
  comment: string;
}

export interface UserCommentCreateWithoutUserInput {
  id?: string ;
  deleted?: boolean ;
  author: UserCreateOneWithoutWrittenCommentsInput;
  comment: string;
}

export interface UserCommentScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  comment?: string ;
  comment_not?: string ;
  comment_in?: string[] ;
  comment_not_in?: string[] ;
  comment_lt?: string ;
  comment_lte?: string ;
  comment_gt?: string ;
  comment_gte?: string ;
  comment_contains?: string ;
  comment_not_contains?: string ;
  comment_starts_with?: string ;
  comment_not_starts_with?: string ;
  comment_ends_with?: string ;
  comment_not_ends_with?: string ;
  AND?: UserCommentScalarWhereInput[] ;
  OR?: UserCommentScalarWhereInput[] ;
  NOT?: UserCommentScalarWhereInput[] ;
}

export interface UserCommentUpdateManyDataInput {
  deleted?: boolean ;
  comment?: string ;
}

export interface UserCommentUpdateManyWithWhereNestedInput {
  where: UserCommentScalarWhereInput;
  data: UserCommentUpdateManyDataInput;
}

export interface UserCommentUpdateManyWithoutAuthorInput {
  create?: UserCommentCreateWithoutAuthorInput[] ;
  connect?: UserCommentWhereUniqueInput[] ;
  set?: UserCommentWhereUniqueInput[] ;
  disconnect?: UserCommentWhereUniqueInput[] ;
  update?: UserCommentUpdateWithWhereUniqueWithoutAuthorInput[] ;
  upsert?: UserCommentUpsertWithWhereUniqueWithoutAuthorInput[] ;
  deleteMany?: UserCommentScalarWhereInput[] ;
  updateMany?: UserCommentUpdateManyWithWhereNestedInput[] ;
}

export interface UserCommentUpdateManyWithoutUserInput {
  create?: UserCommentCreateWithoutUserInput[] ;
  connect?: UserCommentWhereUniqueInput[] ;
  set?: UserCommentWhereUniqueInput[] ;
  disconnect?: UserCommentWhereUniqueInput[] ;
  update?: UserCommentUpdateWithWhereUniqueWithoutUserInput[] ;
  upsert?: UserCommentUpsertWithWhereUniqueWithoutUserInput[] ;
  deleteMany?: UserCommentScalarWhereInput[] ;
  updateMany?: UserCommentUpdateManyWithWhereNestedInput[] ;
}

export interface UserCommentUpdateWithWhereUniqueWithoutAuthorInput {
  where: UserCommentWhereUniqueInput;
  data: UserCommentUpdateWithoutAuthorDataInput;
}

export interface UserCommentUpdateWithWhereUniqueWithoutUserInput {
  where: UserCommentWhereUniqueInput;
  data: UserCommentUpdateWithoutUserDataInput;
}

export interface UserCommentUpdateWithoutAuthorDataInput {
  deleted?: boolean ;
  user?: UserUpdateOneRequiredWithoutCommentsInput ;
  comment?: string ;
}

export interface UserCommentUpdateWithoutUserDataInput {
  deleted?: boolean ;
  author?: UserUpdateOneRequiredWithoutWrittenCommentsInput ;
  comment?: string ;
}

export interface UserCommentUpsertWithWhereUniqueWithoutAuthorInput {
  where: UserCommentWhereUniqueInput;
  update: UserCommentUpdateWithoutAuthorDataInput;
  create: UserCommentCreateWithoutAuthorInput;
}

export interface UserCommentUpsertWithWhereUniqueWithoutUserInput {
  where: UserCommentWhereUniqueInput;
  update: UserCommentUpdateWithoutUserDataInput;
  create: UserCommentCreateWithoutUserInput;
}

export interface UserCommentWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  author?: UserWhereInput ;
  user?: UserWhereInput ;
  comment?: string ;
  comment_not?: string ;
  comment_in?: string[] ;
  comment_not_in?: string[] ;
  comment_lt?: string ;
  comment_lte?: string ;
  comment_gt?: string ;
  comment_gte?: string ;
  comment_contains?: string ;
  comment_not_contains?: string ;
  comment_starts_with?: string ;
  comment_not_starts_with?: string ;
  comment_ends_with?: string ;
  comment_not_ends_with?: string ;
  AND?: UserCommentWhereInput[] ;
  OR?: UserCommentWhereInput[] ;
  NOT?: UserCommentWhereInput[] ;
}

export interface UserCommentWhereUniqueInput {
  id?: string ;
}

export interface UserCreateManyWithoutCompanyInput {
  create?: UserCreateWithoutCompanyInput[] ;
  connect?: UserWhereUniqueInput[] ;
}

export interface UserCreateManyWithoutMembershipLevelInput {
  create?: UserCreateWithoutMembershipLevelInput[] ;
  connect?: UserWhereUniqueInput[] ;
}

export interface UserCreateManyWithoutNotificationsInput {
  create?: UserCreateWithoutNotificationsInput[] ;
  connect?: UserWhereUniqueInput[] ;
}

export interface UserCreateManyWithoutOfferYieldEventsInput {
  create?: UserCreateWithoutOfferYieldEventsInput[] ;
  connect?: UserWhereUniqueInput[] ;
}

export interface UserCreateManyWithoutOffersInput {
  create?: UserCreateWithoutOffersInput[] ;
  connect?: UserWhereUniqueInput[] ;
}

export interface UserCreateManyWithoutPreviousSegmentsInput {
  create?: UserCreateWithoutPreviousSegmentsInput[] ;
  connect?: UserWhereUniqueInput[] ;
}

export interface UserCreateManyWithoutPromoCodesInput {
  create?: UserCreateWithoutPromoCodesInput[] ;
  connect?: UserWhereUniqueInput[] ;
}

export interface UserCreateManyWithoutSegmentsInput {
  create?: UserCreateWithoutSegmentsInput[] ;
  connect?: UserWhereUniqueInput[] ;
}

export interface UserCreateManyWithoutStampCardsInput {
  create?: UserCreateWithoutStampCardsInput[] ;
  connect?: UserWhereUniqueInput[] ;
}

export interface UserCreateManyWithoutTableInput {
  create?: UserCreateWithoutTableInput[] ;
  connect?: UserWhereUniqueInput[] ;
}

export interface UserCreateManyWithoutTableSessionsInput {
  create?: UserCreateWithoutTableSessionsInput[] ;
  connect?: UserWhereUniqueInput[] ;
}

export interface UserCreateManyWithoutVenuesInput {
  create?: UserCreateWithoutVenuesInput[] ;
  connect?: UserWhereUniqueInput[] ;
}

export interface UserCreateOneWithoutCommentsInput {
  create?: UserCreateWithoutCommentsInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutCreditBankInput {
  create?: UserCreateWithoutCreditBankInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutLocationsInput {
  create?: UserCreateWithoutLocationsInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutMembershipAssignmentsInput {
  create?: UserCreateWithoutMembershipAssignmentsInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutMembershipCardInput {
  create?: UserCreateWithoutMembershipCardInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutMembershipTradeinsInput {
  create?: UserCreateWithoutMembershipTradeinsInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutOrdersInput {
  create?: UserCreateWithoutOrdersInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutPaymentsInput {
  create?: UserCreateWithoutPaymentsInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutReceiptPointsScansInput {
  create?: UserCreateWithoutReceiptPointsScansInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutRecommendationsInput {
  create?: UserCreateWithoutRecommendationsInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutReferalInput {
  create?: UserCreateWithoutReferalInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutReferralsInput {
  create?: UserCreateWithoutReferralsInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutReservationsInput {
  create?: UserCreateWithoutReservationsInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutSentNotificationsInput {
  create?: UserCreateWithoutSentNotificationsInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutStampsInput {
  create?: UserCreateWithoutStampsInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutTablePaymentSettingsHistoryInput {
  create?: UserCreateWithoutTablePaymentSettingsHistoryInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutTablePaymentSettingsInput {
  create?: UserCreateWithoutTablePaymentSettingsInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutTokensInput {
  create?: UserCreateWithoutTokensInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateOneWithoutWrittenCommentsInput {
  create?: UserCreateWithoutWrittenCommentsInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserCreateWithoutCommentsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutCompanyInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutCreditBankInput {
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutLocationsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutMembershipAssignmentsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutMembershipCardInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutMembershipLevelInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutMembershipTradeinsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutNotificationsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutOfferYieldEventsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutOffersInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutOrdersInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutPaymentsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutPreviousSegmentsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutPromoCodesInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutReceiptPointsScansInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
}

export interface UserCreateWithoutRecommendationsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutReferalInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutReferralsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutReservationsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutSegmentsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutSentNotificationsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutStampCardsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutStampsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutTableInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutTablePaymentSettingsHistoryInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutTablePaymentSettingsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutTableSessionsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutTokensInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutVenuesInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  writtenComments?: UserCommentCreateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateWithoutWrittenCommentsInput {
  creditBank: CreditBankCreateOneWithoutUserInput;
  id?: string ;
  image?: string ;
  meta?: any ;
  name: string;
  venueLimited?: boolean ;
  offers?: OfferCreateManyWithoutUsersInput ;
  orders?: OrderCreateManyWithoutUserInput ;
  payments?: PaymentCreateManyWithoutUserInput ;
  usedOffers?: UserCreateusedOffersInput ;
  language: string;
  company: CompanyCreateOneWithoutUsersInput;
  devices?: DeviceCreateManyWithoutUserInput ;
  stampCards?: StampCardCreateManyWithoutUsersInput ;
  stamps?: StampCreateManyWithoutUserInput ;
  tokens?: OfferTokenCreateManyWithoutUserInput ;
  venues?: VenueCreateManyWithoutUsersInput ;
  locations?: LocationCreateManyWithoutUserInput ;
  creditCards?: CreditCardCreateManyWithoutUserInput ;
  recommendations?: RecommendationCreateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelCreateOneWithoutUsersInput ;
  membershipCard?: MembershipCardCreateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeCreateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationCreateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationCreateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralCreateOneWithoutUserInput ;
  referrals?: UserReferralCreateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventCreateManyWithoutUserInput ;
  logs?: LogCreateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentCreateManyWithoutUsersInput ;
  previousSegments?: UserSegmentCreateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserCreateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventCreateManyWithoutUsersInput ;
  reservations?: ReservationCreateManyWithoutUserInput ;
  table?: TableCreateOneWithoutUsersInput ;
  tableSessions?: TableSessionCreateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingCreateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingCreateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinCreateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentCreateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentCreateManyWithoutUserInput ;
  receiptPointsScans?: ReceiptPointsScanCreateManyWithoutUserInput ;
}

export interface UserCreateaccessInput {
  set?: string[] ;
}

export interface UserCreateusedOffersInput {
  set?: string[] ;
}

export interface UserReferralCreateManyWithoutReferrerInput {
  create?: UserReferralCreateWithoutReferrerInput[] ;
  connect?: UserReferralWhereUniqueInput[] ;
}

export interface UserReferralCreateOneWithoutUserInput {
  create?: UserReferralCreateWithoutUserInput ;
  connect?: UserReferralWhereUniqueInput ;
}

export interface UserReferralCreateWithoutReferrerInput {
  id?: string ;
  user: UserCreateOneWithoutReferalInput;
  code: string;
  activated?: boolean ;
}

export interface UserReferralCreateWithoutUserInput {
  id?: string ;
  referrer: UserCreateOneWithoutReferralsInput;
  code: string;
  activated?: boolean ;
}

export interface UserReferralScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  code?: string ;
  code_not?: string ;
  code_in?: string[] ;
  code_not_in?: string[] ;
  code_lt?: string ;
  code_lte?: string ;
  code_gt?: string ;
  code_gte?: string ;
  code_contains?: string ;
  code_not_contains?: string ;
  code_starts_with?: string ;
  code_not_starts_with?: string ;
  code_ends_with?: string ;
  code_not_ends_with?: string ;
  activated?: boolean ;
  activated_not?: boolean ;
  AND?: UserReferralScalarWhereInput[] ;
  OR?: UserReferralScalarWhereInput[] ;
  NOT?: UserReferralScalarWhereInput[] ;
}

export interface UserReferralUpdateManyDataInput {
  code?: string ;
  activated?: boolean ;
}

export interface UserReferralUpdateManyWithWhereNestedInput {
  where: UserReferralScalarWhereInput;
  data: UserReferralUpdateManyDataInput;
}

export interface UserReferralUpdateManyWithoutReferrerInput {
  create?: UserReferralCreateWithoutReferrerInput[] ;
  connect?: UserReferralWhereUniqueInput[] ;
  set?: UserReferralWhereUniqueInput[] ;
  disconnect?: UserReferralWhereUniqueInput[] ;
  update?: UserReferralUpdateWithWhereUniqueWithoutReferrerInput[] ;
  upsert?: UserReferralUpsertWithWhereUniqueWithoutReferrerInput[] ;
  deleteMany?: UserReferralScalarWhereInput[] ;
  updateMany?: UserReferralUpdateManyWithWhereNestedInput[] ;
}

export interface UserReferralUpdateOneWithoutUserInput {
  create?: UserReferralCreateWithoutUserInput ;
  update?: UserReferralUpdateWithoutUserDataInput ;
  upsert?: UserReferralUpsertWithoutUserInput ;
  disconnect?: boolean ;
  connect?: UserReferralWhereUniqueInput ;
}

export interface UserReferralUpdateWithWhereUniqueWithoutReferrerInput {
  where: UserReferralWhereUniqueInput;
  data: UserReferralUpdateWithoutReferrerDataInput;
}

export interface UserReferralUpdateWithoutReferrerDataInput {
  user?: UserUpdateOneRequiredWithoutReferalInput ;
  code?: string ;
  activated?: boolean ;
}

export interface UserReferralUpdateWithoutUserDataInput {
  referrer?: UserUpdateOneRequiredWithoutReferralsInput ;
  code?: string ;
  activated?: boolean ;
}

export interface UserReferralUpsertWithWhereUniqueWithoutReferrerInput {
  where: UserReferralWhereUniqueInput;
  update: UserReferralUpdateWithoutReferrerDataInput;
  create: UserReferralCreateWithoutReferrerInput;
}

export interface UserReferralUpsertWithoutUserInput {
  update: UserReferralUpdateWithoutUserDataInput;
  create: UserReferralCreateWithoutUserInput;
}

export interface UserReferralWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  user?: UserWhereInput ;
  referrer?: UserWhereInput ;
  code?: string ;
  code_not?: string ;
  code_in?: string[] ;
  code_not_in?: string[] ;
  code_lt?: string ;
  code_lte?: string ;
  code_gt?: string ;
  code_gte?: string ;
  code_contains?: string ;
  code_not_contains?: string ;
  code_starts_with?: string ;
  code_not_starts_with?: string ;
  code_ends_with?: string ;
  code_not_ends_with?: string ;
  activated?: boolean ;
  activated_not?: boolean ;
  AND?: UserReferralWhereInput[] ;
  OR?: UserReferralWhereInput[] ;
  NOT?: UserReferralWhereInput[] ;
}

export interface UserReferralWhereUniqueInput {
  id?: string ;
}

export interface UserScalarWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  image?: string ;
  image_not?: string ;
  image_in?: string[] ;
  image_not_in?: string[] ;
  image_lt?: string ;
  image_lte?: string ;
  image_gt?: string ;
  image_gte?: string ;
  image_contains?: string ;
  image_not_contains?: string ;
  image_starts_with?: string ;
  image_not_starts_with?: string ;
  image_ends_with?: string ;
  image_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  venueLimited?: boolean ;
  venueLimited_not?: boolean ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  language?: string ;
  language_not?: string ;
  language_in?: string[] ;
  language_not_in?: string[] ;
  language_lt?: string ;
  language_lte?: string ;
  language_gt?: string ;
  language_gte?: string ;
  language_contains?: string ;
  language_not_contains?: string ;
  language_starts_with?: string ;
  language_not_starts_with?: string ;
  language_ends_with?: string ;
  language_not_ends_with?: string ;
  facebookId?: string ;
  facebookId_not?: string ;
  facebookId_in?: string[] ;
  facebookId_not_in?: string[] ;
  facebookId_lt?: string ;
  facebookId_lte?: string ;
  facebookId_gt?: string ;
  facebookId_gte?: string ;
  facebookId_contains?: string ;
  facebookId_not_contains?: string ;
  facebookId_starts_with?: string ;
  facebookId_not_starts_with?: string ;
  facebookId_ends_with?: string ;
  facebookId_not_ends_with?: string ;
  email?: string ;
  email_not?: string ;
  email_in?: string[] ;
  email_not_in?: string[] ;
  email_lt?: string ;
  email_lte?: string ;
  email_gt?: string ;
  email_gte?: string ;
  email_contains?: string ;
  email_not_contains?: string ;
  email_starts_with?: string ;
  email_not_starts_with?: string ;
  email_ends_with?: string ;
  email_not_ends_with?: string ;
  password?: string ;
  password_not?: string ;
  password_in?: string[] ;
  password_not_in?: string[] ;
  password_lt?: string ;
  password_lte?: string ;
  password_gt?: string ;
  password_gte?: string ;
  password_contains?: string ;
  password_not_contains?: string ;
  password_starts_with?: string ;
  password_not_starts_with?: string ;
  password_ends_with?: string ;
  password_not_ends_with?: string ;
  referralCode?: string ;
  referralCode_not?: string ;
  referralCode_in?: string[] ;
  referralCode_not_in?: string[] ;
  referralCode_lt?: string ;
  referralCode_lte?: string ;
  referralCode_gt?: string ;
  referralCode_gte?: string ;
  referralCode_contains?: string ;
  referralCode_not_contains?: string ;
  referralCode_starts_with?: string ;
  referralCode_not_starts_with?: string ;
  referralCode_ends_with?: string ;
  referralCode_not_ends_with?: string ;
  phone?: string ;
  phone_not?: string ;
  phone_in?: string[] ;
  phone_not_in?: string[] ;
  phone_lt?: string ;
  phone_lte?: string ;
  phone_gt?: string ;
  phone_gte?: string ;
  phone_contains?: string ;
  phone_not_contains?: string ;
  phone_starts_with?: string ;
  phone_not_starts_with?: string ;
  phone_ends_with?: string ;
  phone_not_ends_with?: string ;
  role?: ROLE ;
  role_not?: ROLE ;
  role_in?: ROLE[] ;
  role_not_in?: ROLE[] ;
  activated?: boolean ;
  activated_not?: boolean ;
  blocked?: boolean ;
  blocked_not?: boolean ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  lastLogin?: any ;
  lastLogin_not?: any ;
  lastLogin_in?: any[] ;
  lastLogin_not_in?: any[] ;
  lastLogin_lt?: any ;
  lastLogin_lte?: any ;
  lastLogin_gt?: any ;
  lastLogin_gte?: any ;
  personalNumber?: string ;
  personalNumber_not?: string ;
  personalNumber_in?: string[] ;
  personalNumber_not_in?: string[] ;
  personalNumber_lt?: string ;
  personalNumber_lte?: string ;
  personalNumber_gt?: string ;
  personalNumber_gte?: string ;
  personalNumber_contains?: string ;
  personalNumber_not_contains?: string ;
  personalNumber_starts_with?: string ;
  personalNumber_not_starts_with?: string ;
  personalNumber_ends_with?: string ;
  personalNumber_not_ends_with?: string ;
  ofLegalAge?: boolean ;
  ofLegalAge_not?: boolean ;
  username?: string ;
  username_not?: string ;
  username_in?: string[] ;
  username_not_in?: string[] ;
  username_lt?: string ;
  username_lte?: string ;
  username_gt?: string ;
  username_gte?: string ;
  username_contains?: string ;
  username_not_contains?: string ;
  username_starts_with?: string ;
  username_not_starts_with?: string ;
  username_ends_with?: string ;
  username_not_ends_with?: string ;
  shouldUpdatePassword?: boolean ;
  shouldUpdatePassword_not?: boolean ;
  AND?: UserScalarWhereInput[] ;
  OR?: UserScalarWhereInput[] ;
  NOT?: UserScalarWhereInput[] ;
}

export interface UserSegmentCreateInput {
  id?: string ;
  company?: CompanyCreateOneWithoutSegmentsInput ;
  name: string;
  startDate?: any ;
  periodType?: SEGMENT_PERIOD ;
  periodNumber?: number ;
  filters?: any ;
  users?: UserCreateManyWithoutSegmentsInput ;
  previousUsers?: UserCreateManyWithoutPreviousSegmentsInput ;
  triggers?: any ;
  history?: any ;
  yieldEvents?: OfferYieldEventCreateManyWithoutSegmentsInput ;
  contents?: ContentCreateManyWithoutSegmentsInput ;
  deleted?: boolean ;
}

export interface UserSegmentCreateManyWithoutCompanyInput {
  create?: UserSegmentCreateWithoutCompanyInput[] ;
  connect?: UserSegmentWhereUniqueInput[] ;
}

export interface UserSegmentCreateManyWithoutContentsInput {
  create?: UserSegmentCreateWithoutContentsInput[] ;
  connect?: UserSegmentWhereUniqueInput[] ;
}

export interface UserSegmentCreateManyWithoutPreviousUsersInput {
  create?: UserSegmentCreateWithoutPreviousUsersInput[] ;
  connect?: UserSegmentWhereUniqueInput[] ;
}

export interface UserSegmentCreateManyWithoutUsersInput {
  create?: UserSegmentCreateWithoutUsersInput[] ;
  connect?: UserSegmentWhereUniqueInput[] ;
}

export interface UserSegmentCreateManyWithoutYieldEventsInput {
  create?: UserSegmentCreateWithoutYieldEventsInput[] ;
  connect?: UserSegmentWhereUniqueInput[] ;
}

export interface UserSegmentCreateWithoutCompanyInput {
  id?: string ;
  name: string;
  startDate?: any ;
  periodType?: SEGMENT_PERIOD ;
  periodNumber?: number ;
  filters?: any ;
  users?: UserCreateManyWithoutSegmentsInput ;
  previousUsers?: UserCreateManyWithoutPreviousSegmentsInput ;
  triggers?: any ;
  history?: any ;
  yieldEvents?: OfferYieldEventCreateManyWithoutSegmentsInput ;
  contents?: ContentCreateManyWithoutSegmentsInput ;
  deleted?: boolean ;
}

export interface UserSegmentCreateWithoutContentsInput {
  id?: string ;
  company?: CompanyCreateOneWithoutSegmentsInput ;
  name: string;
  startDate?: any ;
  periodType?: SEGMENT_PERIOD ;
  periodNumber?: number ;
  filters?: any ;
  users?: UserCreateManyWithoutSegmentsInput ;
  previousUsers?: UserCreateManyWithoutPreviousSegmentsInput ;
  triggers?: any ;
  history?: any ;
  yieldEvents?: OfferYieldEventCreateManyWithoutSegmentsInput ;
  deleted?: boolean ;
}

export interface UserSegmentCreateWithoutPreviousUsersInput {
  id?: string ;
  company?: CompanyCreateOneWithoutSegmentsInput ;
  name: string;
  startDate?: any ;
  periodType?: SEGMENT_PERIOD ;
  periodNumber?: number ;
  filters?: any ;
  users?: UserCreateManyWithoutSegmentsInput ;
  triggers?: any ;
  history?: any ;
  yieldEvents?: OfferYieldEventCreateManyWithoutSegmentsInput ;
  contents?: ContentCreateManyWithoutSegmentsInput ;
  deleted?: boolean ;
}

export interface UserSegmentCreateWithoutUsersInput {
  id?: string ;
  company?: CompanyCreateOneWithoutSegmentsInput ;
  name: string;
  startDate?: any ;
  periodType?: SEGMENT_PERIOD ;
  periodNumber?: number ;
  filters?: any ;
  previousUsers?: UserCreateManyWithoutPreviousSegmentsInput ;
  triggers?: any ;
  history?: any ;
  yieldEvents?: OfferYieldEventCreateManyWithoutSegmentsInput ;
  contents?: ContentCreateManyWithoutSegmentsInput ;
  deleted?: boolean ;
}

export interface UserSegmentCreateWithoutYieldEventsInput {
  id?: string ;
  company?: CompanyCreateOneWithoutSegmentsInput ;
  name: string;
  startDate?: any ;
  periodType?: SEGMENT_PERIOD ;
  periodNumber?: number ;
  filters?: any ;
  users?: UserCreateManyWithoutSegmentsInput ;
  previousUsers?: UserCreateManyWithoutPreviousSegmentsInput ;
  triggers?: any ;
  history?: any ;
  contents?: ContentCreateManyWithoutSegmentsInput ;
  deleted?: boolean ;
}

export interface UserSegmentScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  startDate?: any ;
  startDate_not?: any ;
  startDate_in?: any[] ;
  startDate_not_in?: any[] ;
  startDate_lt?: any ;
  startDate_lte?: any ;
  startDate_gt?: any ;
  startDate_gte?: any ;
  periodType?: SEGMENT_PERIOD ;
  periodType_not?: SEGMENT_PERIOD ;
  periodType_in?: SEGMENT_PERIOD[] ;
  periodType_not_in?: SEGMENT_PERIOD[] ;
  periodNumber?: number ;
  periodNumber_not?: number ;
  periodNumber_in?: number[] ;
  periodNumber_not_in?: number[] ;
  periodNumber_lt?: number ;
  periodNumber_lte?: number ;
  periodNumber_gt?: number ;
  periodNumber_gte?: number ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  AND?: UserSegmentScalarWhereInput[] ;
  OR?: UserSegmentScalarWhereInput[] ;
  NOT?: UserSegmentScalarWhereInput[] ;
}

export interface UserSegmentUpdateInput {
  company?: CompanyUpdateOneWithoutSegmentsInput ;
  name?: string ;
  startDate?: any ;
  periodType?: SEGMENT_PERIOD ;
  periodNumber?: number ;
  filters?: any ;
  users?: UserUpdateManyWithoutSegmentsInput ;
  previousUsers?: UserUpdateManyWithoutPreviousSegmentsInput ;
  triggers?: any ;
  history?: any ;
  yieldEvents?: OfferYieldEventUpdateManyWithoutSegmentsInput ;
  contents?: ContentUpdateManyWithoutSegmentsInput ;
  deleted?: boolean ;
}

export interface UserSegmentUpdateManyDataInput {
  name?: string ;
  startDate?: any ;
  periodType?: SEGMENT_PERIOD ;
  periodNumber?: number ;
  filters?: any ;
  triggers?: any ;
  history?: any ;
  deleted?: boolean ;
}

export interface UserSegmentUpdateManyWithWhereNestedInput {
  where: UserSegmentScalarWhereInput;
  data: UserSegmentUpdateManyDataInput;
}

export interface UserSegmentUpdateManyWithoutCompanyInput {
  create?: UserSegmentCreateWithoutCompanyInput[] ;
  connect?: UserSegmentWhereUniqueInput[] ;
  set?: UserSegmentWhereUniqueInput[] ;
  disconnect?: UserSegmentWhereUniqueInput[] ;
  update?: UserSegmentUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: UserSegmentUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: UserSegmentScalarWhereInput[] ;
  updateMany?: UserSegmentUpdateManyWithWhereNestedInput[] ;
}

export interface UserSegmentUpdateManyWithoutContentsInput {
  create?: UserSegmentCreateWithoutContentsInput[] ;
  connect?: UserSegmentWhereUniqueInput[] ;
  set?: UserSegmentWhereUniqueInput[] ;
  disconnect?: UserSegmentWhereUniqueInput[] ;
  update?: UserSegmentUpdateWithWhereUniqueWithoutContentsInput[] ;
  upsert?: UserSegmentUpsertWithWhereUniqueWithoutContentsInput[] ;
  deleteMany?: UserSegmentScalarWhereInput[] ;
  updateMany?: UserSegmentUpdateManyWithWhereNestedInput[] ;
}

export interface UserSegmentUpdateManyWithoutPreviousUsersInput {
  create?: UserSegmentCreateWithoutPreviousUsersInput[] ;
  connect?: UserSegmentWhereUniqueInput[] ;
  set?: UserSegmentWhereUniqueInput[] ;
  disconnect?: UserSegmentWhereUniqueInput[] ;
  update?: UserSegmentUpdateWithWhereUniqueWithoutPreviousUsersInput[] ;
  upsert?: UserSegmentUpsertWithWhereUniqueWithoutPreviousUsersInput[] ;
  deleteMany?: UserSegmentScalarWhereInput[] ;
  updateMany?: UserSegmentUpdateManyWithWhereNestedInput[] ;
}

export interface UserSegmentUpdateManyWithoutUsersInput {
  create?: UserSegmentCreateWithoutUsersInput[] ;
  connect?: UserSegmentWhereUniqueInput[] ;
  set?: UserSegmentWhereUniqueInput[] ;
  disconnect?: UserSegmentWhereUniqueInput[] ;
  update?: UserSegmentUpdateWithWhereUniqueWithoutUsersInput[] ;
  upsert?: UserSegmentUpsertWithWhereUniqueWithoutUsersInput[] ;
  deleteMany?: UserSegmentScalarWhereInput[] ;
  updateMany?: UserSegmentUpdateManyWithWhereNestedInput[] ;
}

export interface UserSegmentUpdateManyWithoutYieldEventsInput {
  create?: UserSegmentCreateWithoutYieldEventsInput[] ;
  connect?: UserSegmentWhereUniqueInput[] ;
  set?: UserSegmentWhereUniqueInput[] ;
  disconnect?: UserSegmentWhereUniqueInput[] ;
  update?: UserSegmentUpdateWithWhereUniqueWithoutYieldEventsInput[] ;
  upsert?: UserSegmentUpsertWithWhereUniqueWithoutYieldEventsInput[] ;
  deleteMany?: UserSegmentScalarWhereInput[] ;
  updateMany?: UserSegmentUpdateManyWithWhereNestedInput[] ;
}

export interface UserSegmentUpdateWithWhereUniqueWithoutCompanyInput {
  where: UserSegmentWhereUniqueInput;
  data: UserSegmentUpdateWithoutCompanyDataInput;
}

export interface UserSegmentUpdateWithWhereUniqueWithoutContentsInput {
  where: UserSegmentWhereUniqueInput;
  data: UserSegmentUpdateWithoutContentsDataInput;
}

export interface UserSegmentUpdateWithWhereUniqueWithoutPreviousUsersInput {
  where: UserSegmentWhereUniqueInput;
  data: UserSegmentUpdateWithoutPreviousUsersDataInput;
}

export interface UserSegmentUpdateWithWhereUniqueWithoutUsersInput {
  where: UserSegmentWhereUniqueInput;
  data: UserSegmentUpdateWithoutUsersDataInput;
}

export interface UserSegmentUpdateWithWhereUniqueWithoutYieldEventsInput {
  where: UserSegmentWhereUniqueInput;
  data: UserSegmentUpdateWithoutYieldEventsDataInput;
}

export interface UserSegmentUpdateWithoutCompanyDataInput {
  name?: string ;
  startDate?: any ;
  periodType?: SEGMENT_PERIOD ;
  periodNumber?: number ;
  filters?: any ;
  users?: UserUpdateManyWithoutSegmentsInput ;
  previousUsers?: UserUpdateManyWithoutPreviousSegmentsInput ;
  triggers?: any ;
  history?: any ;
  yieldEvents?: OfferYieldEventUpdateManyWithoutSegmentsInput ;
  contents?: ContentUpdateManyWithoutSegmentsInput ;
  deleted?: boolean ;
}

export interface UserSegmentUpdateWithoutContentsDataInput {
  company?: CompanyUpdateOneWithoutSegmentsInput ;
  name?: string ;
  startDate?: any ;
  periodType?: SEGMENT_PERIOD ;
  periodNumber?: number ;
  filters?: any ;
  users?: UserUpdateManyWithoutSegmentsInput ;
  previousUsers?: UserUpdateManyWithoutPreviousSegmentsInput ;
  triggers?: any ;
  history?: any ;
  yieldEvents?: OfferYieldEventUpdateManyWithoutSegmentsInput ;
  deleted?: boolean ;
}

export interface UserSegmentUpdateWithoutPreviousUsersDataInput {
  company?: CompanyUpdateOneWithoutSegmentsInput ;
  name?: string ;
  startDate?: any ;
  periodType?: SEGMENT_PERIOD ;
  periodNumber?: number ;
  filters?: any ;
  users?: UserUpdateManyWithoutSegmentsInput ;
  triggers?: any ;
  history?: any ;
  yieldEvents?: OfferYieldEventUpdateManyWithoutSegmentsInput ;
  contents?: ContentUpdateManyWithoutSegmentsInput ;
  deleted?: boolean ;
}

export interface UserSegmentUpdateWithoutUsersDataInput {
  company?: CompanyUpdateOneWithoutSegmentsInput ;
  name?: string ;
  startDate?: any ;
  periodType?: SEGMENT_PERIOD ;
  periodNumber?: number ;
  filters?: any ;
  previousUsers?: UserUpdateManyWithoutPreviousSegmentsInput ;
  triggers?: any ;
  history?: any ;
  yieldEvents?: OfferYieldEventUpdateManyWithoutSegmentsInput ;
  contents?: ContentUpdateManyWithoutSegmentsInput ;
  deleted?: boolean ;
}

export interface UserSegmentUpdateWithoutYieldEventsDataInput {
  company?: CompanyUpdateOneWithoutSegmentsInput ;
  name?: string ;
  startDate?: any ;
  periodType?: SEGMENT_PERIOD ;
  periodNumber?: number ;
  filters?: any ;
  users?: UserUpdateManyWithoutSegmentsInput ;
  previousUsers?: UserUpdateManyWithoutPreviousSegmentsInput ;
  triggers?: any ;
  history?: any ;
  contents?: ContentUpdateManyWithoutSegmentsInput ;
  deleted?: boolean ;
}

export interface UserSegmentUpsertWithWhereUniqueWithoutCompanyInput {
  where: UserSegmentWhereUniqueInput;
  update: UserSegmentUpdateWithoutCompanyDataInput;
  create: UserSegmentCreateWithoutCompanyInput;
}

export interface UserSegmentUpsertWithWhereUniqueWithoutContentsInput {
  where: UserSegmentWhereUniqueInput;
  update: UserSegmentUpdateWithoutContentsDataInput;
  create: UserSegmentCreateWithoutContentsInput;
}

export interface UserSegmentUpsertWithWhereUniqueWithoutPreviousUsersInput {
  where: UserSegmentWhereUniqueInput;
  update: UserSegmentUpdateWithoutPreviousUsersDataInput;
  create: UserSegmentCreateWithoutPreviousUsersInput;
}

export interface UserSegmentUpsertWithWhereUniqueWithoutUsersInput {
  where: UserSegmentWhereUniqueInput;
  update: UserSegmentUpdateWithoutUsersDataInput;
  create: UserSegmentCreateWithoutUsersInput;
}

export interface UserSegmentUpsertWithWhereUniqueWithoutYieldEventsInput {
  where: UserSegmentWhereUniqueInput;
  update: UserSegmentUpdateWithoutYieldEventsDataInput;
  create: UserSegmentCreateWithoutYieldEventsInput;
}

export interface UserSegmentWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  company?: CompanyWhereInput ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  startDate?: any ;
  startDate_not?: any ;
  startDate_in?: any[] ;
  startDate_not_in?: any[] ;
  startDate_lt?: any ;
  startDate_lte?: any ;
  startDate_gt?: any ;
  startDate_gte?: any ;
  periodType?: SEGMENT_PERIOD ;
  periodType_not?: SEGMENT_PERIOD ;
  periodType_in?: SEGMENT_PERIOD[] ;
  periodType_not_in?: SEGMENT_PERIOD[] ;
  periodNumber?: number ;
  periodNumber_not?: number ;
  periodNumber_in?: number[] ;
  periodNumber_not_in?: number[] ;
  periodNumber_lt?: number ;
  periodNumber_lte?: number ;
  periodNumber_gt?: number ;
  periodNumber_gte?: number ;
  users_every?: UserWhereInput ;
  users_some?: UserWhereInput ;
  users_none?: UserWhereInput ;
  previousUsers_every?: UserWhereInput ;
  previousUsers_some?: UserWhereInput ;
  previousUsers_none?: UserWhereInput ;
  yieldEvents_every?: OfferYieldEventWhereInput ;
  yieldEvents_some?: OfferYieldEventWhereInput ;
  yieldEvents_none?: OfferYieldEventWhereInput ;
  contents_every?: ContentWhereInput ;
  contents_some?: ContentWhereInput ;
  contents_none?: ContentWhereInput ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  AND?: UserSegmentWhereInput[] ;
  OR?: UserSegmentWhereInput[] ;
  NOT?: UserSegmentWhereInput[] ;
}

export interface UserSegmentWhereUniqueInput {
  id?: string ;
}

export interface UserUpdateManyDataInput {
  image?: string ;
  meta?: any ;
  name?: string ;
  venueLimited?: boolean ;
  usedOffers?: UserUpdateusedOffersInput ;
  language?: string ;
  facebookId?: string ;
  email?: string ;
  password?: string ;
  referralCode?: string ;
  phone?: string ;
  role?: ROLE ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserUpdateaccessInput ;
  ofLegalAge?: boolean ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
}

export interface UserUpdateManyWithWhereNestedInput {
  where: UserScalarWhereInput;
  data: UserUpdateManyDataInput;
}

export interface UserUpdateManyWithoutCompanyInput {
  create?: UserCreateWithoutCompanyInput[] ;
  connect?: UserWhereUniqueInput[] ;
  set?: UserWhereUniqueInput[] ;
  disconnect?: UserWhereUniqueInput[] ;
  update?: UserUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: UserUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: UserScalarWhereInput[] ;
  updateMany?: UserUpdateManyWithWhereNestedInput[] ;
}

export interface UserUpdateManyWithoutMembershipLevelInput {
  create?: UserCreateWithoutMembershipLevelInput[] ;
  connect?: UserWhereUniqueInput[] ;
  set?: UserWhereUniqueInput[] ;
  disconnect?: UserWhereUniqueInput[] ;
  update?: UserUpdateWithWhereUniqueWithoutMembershipLevelInput[] ;
  upsert?: UserUpsertWithWhereUniqueWithoutMembershipLevelInput[] ;
  deleteMany?: UserScalarWhereInput[] ;
  updateMany?: UserUpdateManyWithWhereNestedInput[] ;
}

export interface UserUpdateManyWithoutNotificationsInput {
  create?: UserCreateWithoutNotificationsInput[] ;
  connect?: UserWhereUniqueInput[] ;
  set?: UserWhereUniqueInput[] ;
  disconnect?: UserWhereUniqueInput[] ;
  update?: UserUpdateWithWhereUniqueWithoutNotificationsInput[] ;
  upsert?: UserUpsertWithWhereUniqueWithoutNotificationsInput[] ;
  deleteMany?: UserScalarWhereInput[] ;
  updateMany?: UserUpdateManyWithWhereNestedInput[] ;
}

export interface UserUpdateManyWithoutOfferYieldEventsInput {
  create?: UserCreateWithoutOfferYieldEventsInput[] ;
  connect?: UserWhereUniqueInput[] ;
  set?: UserWhereUniqueInput[] ;
  disconnect?: UserWhereUniqueInput[] ;
  update?: UserUpdateWithWhereUniqueWithoutOfferYieldEventsInput[] ;
  upsert?: UserUpsertWithWhereUniqueWithoutOfferYieldEventsInput[] ;
  deleteMany?: UserScalarWhereInput[] ;
  updateMany?: UserUpdateManyWithWhereNestedInput[] ;
}

export interface UserUpdateManyWithoutOffersInput {
  create?: UserCreateWithoutOffersInput[] ;
  connect?: UserWhereUniqueInput[] ;
  set?: UserWhereUniqueInput[] ;
  disconnect?: UserWhereUniqueInput[] ;
  update?: UserUpdateWithWhereUniqueWithoutOffersInput[] ;
  upsert?: UserUpsertWithWhereUniqueWithoutOffersInput[] ;
  deleteMany?: UserScalarWhereInput[] ;
  updateMany?: UserUpdateManyWithWhereNestedInput[] ;
}

export interface UserUpdateManyWithoutPreviousSegmentsInput {
  create?: UserCreateWithoutPreviousSegmentsInput[] ;
  connect?: UserWhereUniqueInput[] ;
  set?: UserWhereUniqueInput[] ;
  disconnect?: UserWhereUniqueInput[] ;
  update?: UserUpdateWithWhereUniqueWithoutPreviousSegmentsInput[] ;
  upsert?: UserUpsertWithWhereUniqueWithoutPreviousSegmentsInput[] ;
  deleteMany?: UserScalarWhereInput[] ;
  updateMany?: UserUpdateManyWithWhereNestedInput[] ;
}

export interface UserUpdateManyWithoutPromoCodesInput {
  create?: UserCreateWithoutPromoCodesInput[] ;
  connect?: UserWhereUniqueInput[] ;
  set?: UserWhereUniqueInput[] ;
  disconnect?: UserWhereUniqueInput[] ;
  update?: UserUpdateWithWhereUniqueWithoutPromoCodesInput[] ;
  upsert?: UserUpsertWithWhereUniqueWithoutPromoCodesInput[] ;
  deleteMany?: UserScalarWhereInput[] ;
  updateMany?: UserUpdateManyWithWhereNestedInput[] ;
}

export interface UserUpdateManyWithoutSegmentsInput {
  create?: UserCreateWithoutSegmentsInput[] ;
  connect?: UserWhereUniqueInput[] ;
  set?: UserWhereUniqueInput[] ;
  disconnect?: UserWhereUniqueInput[] ;
  update?: UserUpdateWithWhereUniqueWithoutSegmentsInput[] ;
  upsert?: UserUpsertWithWhereUniqueWithoutSegmentsInput[] ;
  deleteMany?: UserScalarWhereInput[] ;
  updateMany?: UserUpdateManyWithWhereNestedInput[] ;
}

export interface UserUpdateManyWithoutStampCardsInput {
  create?: UserCreateWithoutStampCardsInput[] ;
  connect?: UserWhereUniqueInput[] ;
  set?: UserWhereUniqueInput[] ;
  disconnect?: UserWhereUniqueInput[] ;
  update?: UserUpdateWithWhereUniqueWithoutStampCardsInput[] ;
  upsert?: UserUpsertWithWhereUniqueWithoutStampCardsInput[] ;
  deleteMany?: UserScalarWhereInput[] ;
  updateMany?: UserUpdateManyWithWhereNestedInput[] ;
}

export interface UserUpdateManyWithoutTableInput {
  create?: UserCreateWithoutTableInput[] ;
  connect?: UserWhereUniqueInput[] ;
  set?: UserWhereUniqueInput[] ;
  disconnect?: UserWhereUniqueInput[] ;
  update?: UserUpdateWithWhereUniqueWithoutTableInput[] ;
  upsert?: UserUpsertWithWhereUniqueWithoutTableInput[] ;
  deleteMany?: UserScalarWhereInput[] ;
  updateMany?: UserUpdateManyWithWhereNestedInput[] ;
}

export interface UserUpdateManyWithoutTableSessionsInput {
  create?: UserCreateWithoutTableSessionsInput[] ;
  connect?: UserWhereUniqueInput[] ;
  set?: UserWhereUniqueInput[] ;
  disconnect?: UserWhereUniqueInput[] ;
  update?: UserUpdateWithWhereUniqueWithoutTableSessionsInput[] ;
  upsert?: UserUpsertWithWhereUniqueWithoutTableSessionsInput[] ;
  deleteMany?: UserScalarWhereInput[] ;
  updateMany?: UserUpdateManyWithWhereNestedInput[] ;
}

export interface UserUpdateManyWithoutVenuesInput {
  create?: UserCreateWithoutVenuesInput[] ;
  connect?: UserWhereUniqueInput[] ;
  set?: UserWhereUniqueInput[] ;
  disconnect?: UserWhereUniqueInput[] ;
  update?: UserUpdateWithWhereUniqueWithoutVenuesInput[] ;
  upsert?: UserUpsertWithWhereUniqueWithoutVenuesInput[] ;
  deleteMany?: UserScalarWhereInput[] ;
  updateMany?: UserUpdateManyWithWhereNestedInput[] ;
}

export interface UserUpdateOneRequiredWithoutCommentsInput {
  create?: UserCreateWithoutCommentsInput ;
  update?: UserUpdateWithoutCommentsDataInput ;
  upsert?: UserUpsertWithoutCommentsInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserUpdateOneRequiredWithoutCreditBankInput {
  create?: UserCreateWithoutCreditBankInput ;
  update?: UserUpdateWithoutCreditBankDataInput ;
  upsert?: UserUpsertWithoutCreditBankInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserUpdateOneRequiredWithoutMembershipAssignmentsInput {
  create?: UserCreateWithoutMembershipAssignmentsInput ;
  update?: UserUpdateWithoutMembershipAssignmentsDataInput ;
  upsert?: UserUpsertWithoutMembershipAssignmentsInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserUpdateOneRequiredWithoutMembershipCardInput {
  create?: UserCreateWithoutMembershipCardInput ;
  update?: UserUpdateWithoutMembershipCardDataInput ;
  upsert?: UserUpsertWithoutMembershipCardInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserUpdateOneRequiredWithoutOrdersInput {
  create?: UserCreateWithoutOrdersInput ;
  update?: UserUpdateWithoutOrdersDataInput ;
  upsert?: UserUpsertWithoutOrdersInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserUpdateOneRequiredWithoutReceiptPointsScansInput {
  create?: UserCreateWithoutReceiptPointsScansInput ;
  update?: UserUpdateWithoutReceiptPointsScansDataInput ;
  upsert?: UserUpsertWithoutReceiptPointsScansInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserUpdateOneRequiredWithoutReferalInput {
  create?: UserCreateWithoutReferalInput ;
  update?: UserUpdateWithoutReferalDataInput ;
  upsert?: UserUpsertWithoutReferalInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserUpdateOneRequiredWithoutReferralsInput {
  create?: UserCreateWithoutReferralsInput ;
  update?: UserUpdateWithoutReferralsDataInput ;
  upsert?: UserUpsertWithoutReferralsInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserUpdateOneRequiredWithoutReservationsInput {
  create?: UserCreateWithoutReservationsInput ;
  update?: UserUpdateWithoutReservationsDataInput ;
  upsert?: UserUpsertWithoutReservationsInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserUpdateOneRequiredWithoutSentNotificationsInput {
  create?: UserCreateWithoutSentNotificationsInput ;
  update?: UserUpdateWithoutSentNotificationsDataInput ;
  upsert?: UserUpsertWithoutSentNotificationsInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserUpdateOneRequiredWithoutTablePaymentSettingsHistoryInput {
  create?: UserCreateWithoutTablePaymentSettingsHistoryInput ;
  update?: UserUpdateWithoutTablePaymentSettingsHistoryDataInput ;
  upsert?: UserUpsertWithoutTablePaymentSettingsHistoryInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserUpdateOneRequiredWithoutWrittenCommentsInput {
  create?: UserCreateWithoutWrittenCommentsInput ;
  update?: UserUpdateWithoutWrittenCommentsDataInput ;
  upsert?: UserUpsertWithoutWrittenCommentsInput ;
  connect?: UserWhereUniqueInput ;
}

export interface UserUpdateOneWithoutLocationsInput {
  create?: UserCreateWithoutLocationsInput ;
  update?: UserUpdateWithoutLocationsDataInput ;
  upsert?: UserUpsertWithoutLocationsInput ;
  disconnect?: boolean ;
  connect?: UserWhereUniqueInput ;
}

export interface UserUpdateOneWithoutMembershipTradeinsInput {
  create?: UserCreateWithoutMembershipTradeinsInput ;
  update?: UserUpdateWithoutMembershipTradeinsDataInput ;
  upsert?: UserUpsertWithoutMembershipTradeinsInput ;
  disconnect?: boolean ;
  connect?: UserWhereUniqueInput ;
}

export interface UserUpdateOneWithoutPaymentsInput {
  create?: UserCreateWithoutPaymentsInput ;
  update?: UserUpdateWithoutPaymentsDataInput ;
  upsert?: UserUpsertWithoutPaymentsInput ;
  disconnect?: boolean ;
  connect?: UserWhereUniqueInput ;
}

export interface UserUpdateOneWithoutRecommendationsInput {
  create?: UserCreateWithoutRecommendationsInput ;
  update?: UserUpdateWithoutRecommendationsDataInput ;
  upsert?: UserUpsertWithoutRecommendationsInput ;
  disconnect?: boolean ;
  connect?: UserWhereUniqueInput ;
}

export interface UserUpdateOneWithoutStampsInput {
  create?: UserCreateWithoutStampsInput ;
  update?: UserUpdateWithoutStampsDataInput ;
  upsert?: UserUpsertWithoutStampsInput ;
  disconnect?: boolean ;
  connect?: UserWhereUniqueInput ;
}

export interface UserUpdateOneWithoutTablePaymentSettingsInput {
  create?: UserCreateWithoutTablePaymentSettingsInput ;
  update?: UserUpdateWithoutTablePaymentSettingsDataInput ;
  upsert?: UserUpsertWithoutTablePaymentSettingsInput ;
  disconnect?: boolean ;
  connect?: UserWhereUniqueInput ;
}

export interface UserUpdateOneWithoutTokensInput {
  create?: UserCreateWithoutTokensInput ;
  update?: UserUpdateWithoutTokensDataInput ;
  upsert?: UserUpsertWithoutTokensInput ;
  disconnect?: boolean ;
  connect?: UserWhereUniqueInput ;
}

export interface UserUpdateWithWhereUniqueWithoutCompanyInput {
  where: UserWhereUniqueInput;
  data: UserUpdateWithoutCompanyDataInput;
}

export interface UserUpdateWithWhereUniqueWithoutMembershipLevelInput {
  where: UserWhereUniqueInput;
  data: UserUpdateWithoutMembershipLevelDataInput;
}

export interface UserUpdateWithWhereUniqueWithoutNotificationsInput {
  where: UserWhereUniqueInput;
  data: UserUpdateWithoutNotificationsDataInput;
}

export interface UserUpdateWithWhereUniqueWithoutOfferYieldEventsInput {
  where: UserWhereUniqueInput;
  data: UserUpdateWithoutOfferYieldEventsDataInput;
}

export interface UserUpdateWithWhereUniqueWithoutOffersInput {
  where: UserWhereUniqueInput;
  data: UserUpdateWithoutOffersDataInput;
}

export interface UserUpdateWithWhereUniqueWithoutPreviousSegmentsInput {
  where: UserWhereUniqueInput;
  data: UserUpdateWithoutPreviousSegmentsDataInput;
}

export interface UserUpdateWithWhereUniqueWithoutPromoCodesInput {
  where: UserWhereUniqueInput;
  data: UserUpdateWithoutPromoCodesDataInput;
}

export interface UserUpdateWithWhereUniqueWithoutSegmentsInput {
  where: UserWhereUniqueInput;
  data: UserUpdateWithoutSegmentsDataInput;
}

export interface UserUpdateWithWhereUniqueWithoutStampCardsInput {
  where: UserWhereUniqueInput;
  data: UserUpdateWithoutStampCardsDataInput;
}

export interface UserUpdateWithWhereUniqueWithoutTableInput {
  where: UserWhereUniqueInput;
  data: UserUpdateWithoutTableDataInput;
}

export interface UserUpdateWithWhereUniqueWithoutTableSessionsInput {
  where: UserWhereUniqueInput;
  data: UserUpdateWithoutTableSessionsDataInput;
}

export interface UserUpdateWithWhereUniqueWithoutVenuesInput {
  where: UserWhereUniqueInput;
  data: UserUpdateWithoutVenuesDataInput;
}

export interface UserUpdateWithoutCommentsDataInput {
  creditBank?: CreditBankUpdateOneRequiredWithoutUserInput ;
  image?: string ;
  meta?: any ;
  name?: string ;
  venueLimited?: boolean ;
  offers?: OfferUpdateManyWithoutUsersInput ;
  orders?: OrderUpdateManyWithoutUserInput ;
  payments?: PaymentUpdateManyWithoutUserInput ;
  usedOffers?: UserUpdateusedOffersInput ;
  language?: string ;
  company?: CompanyUpdateOneRequiredWithoutUsersInput ;
  devices?: DeviceUpdateManyWithoutUserInput ;
  stampCards?: StampCardUpdateManyWithoutUsersInput ;
  stamps?: StampUpdateManyWithoutUserInput ;
  tokens?: OfferTokenUpdateManyWithoutUserInput ;
  venues?: VenueUpdateManyWithoutUsersInput ;
  locations?: LocationUpdateManyWithoutUserInput ;
  creditCards?: CreditCardUpdateManyWithoutUserInput ;
  recommendations?: RecommendationUpdateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelUpdateOneWithoutUsersInput ;
  membershipCard?: MembershipCardUpdateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeUpdateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationUpdateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationUpdateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralUpdateOneWithoutUserInput ;
  referrals?: UserReferralUpdateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventUpdateManyWithoutUserInput ;
  logs?: LogUpdateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentUpdateManyWithoutUsersInput ;
  previousSegments?: UserSegmentUpdateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserUpdateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutUsersInput ;
  reservations?: ReservationUpdateManyWithoutUserInput ;
  table?: TableUpdateOneWithoutUsersInput ;
  tableSessions?: TableSessionUpdateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingUpdateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingUpdateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  writtenComments?: UserCommentUpdateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanUpdateManyWithoutUserInput ;
}

export interface UserUpdateWithoutCompanyDataInput {
  creditBank?: CreditBankUpdateOneRequiredWithoutUserInput ;
  image?: string ;
  meta?: any ;
  name?: string ;
  venueLimited?: boolean ;
  offers?: OfferUpdateManyWithoutUsersInput ;
  orders?: OrderUpdateManyWithoutUserInput ;
  payments?: PaymentUpdateManyWithoutUserInput ;
  usedOffers?: UserUpdateusedOffersInput ;
  language?: string ;
  devices?: DeviceUpdateManyWithoutUserInput ;
  stampCards?: StampCardUpdateManyWithoutUsersInput ;
  stamps?: StampUpdateManyWithoutUserInput ;
  tokens?: OfferTokenUpdateManyWithoutUserInput ;
  venues?: VenueUpdateManyWithoutUsersInput ;
  locations?: LocationUpdateManyWithoutUserInput ;
  creditCards?: CreditCardUpdateManyWithoutUserInput ;
  recommendations?: RecommendationUpdateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelUpdateOneWithoutUsersInput ;
  membershipCard?: MembershipCardUpdateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeUpdateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationUpdateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationUpdateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralUpdateOneWithoutUserInput ;
  referrals?: UserReferralUpdateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventUpdateManyWithoutUserInput ;
  logs?: LogUpdateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentUpdateManyWithoutUsersInput ;
  previousSegments?: UserSegmentUpdateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserUpdateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutUsersInput ;
  reservations?: ReservationUpdateManyWithoutUserInput ;
  table?: TableUpdateOneWithoutUsersInput ;
  tableSessions?: TableSessionUpdateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingUpdateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingUpdateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentUpdateManyWithoutUserInput ;
  writtenComments?: UserCommentUpdateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanUpdateManyWithoutUserInput ;
}

export interface UserUpdateWithoutCreditBankDataInput {
  image?: string ;
  meta?: any ;
  name?: string ;
  venueLimited?: boolean ;
  offers?: OfferUpdateManyWithoutUsersInput ;
  orders?: OrderUpdateManyWithoutUserInput ;
  payments?: PaymentUpdateManyWithoutUserInput ;
  usedOffers?: UserUpdateusedOffersInput ;
  language?: string ;
  company?: CompanyUpdateOneRequiredWithoutUsersInput ;
  devices?: DeviceUpdateManyWithoutUserInput ;
  stampCards?: StampCardUpdateManyWithoutUsersInput ;
  stamps?: StampUpdateManyWithoutUserInput ;
  tokens?: OfferTokenUpdateManyWithoutUserInput ;
  venues?: VenueUpdateManyWithoutUsersInput ;
  locations?: LocationUpdateManyWithoutUserInput ;
  creditCards?: CreditCardUpdateManyWithoutUserInput ;
  recommendations?: RecommendationUpdateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelUpdateOneWithoutUsersInput ;
  membershipCard?: MembershipCardUpdateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeUpdateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationUpdateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationUpdateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralUpdateOneWithoutUserInput ;
  referrals?: UserReferralUpdateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventUpdateManyWithoutUserInput ;
  logs?: LogUpdateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentUpdateManyWithoutUsersInput ;
  previousSegments?: UserSegmentUpdateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserUpdateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutUsersInput ;
  reservations?: ReservationUpdateManyWithoutUserInput ;
  table?: TableUpdateOneWithoutUsersInput ;
  tableSessions?: TableSessionUpdateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingUpdateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingUpdateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentUpdateManyWithoutUserInput ;
  writtenComments?: UserCommentUpdateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanUpdateManyWithoutUserInput ;
}

export interface UserUpdateWithoutLocationsDataInput {
  creditBank?: CreditBankUpdateOneRequiredWithoutUserInput ;
  image?: string ;
  meta?: any ;
  name?: string ;
  venueLimited?: boolean ;
  offers?: OfferUpdateManyWithoutUsersInput ;
  orders?: OrderUpdateManyWithoutUserInput ;
  payments?: PaymentUpdateManyWithoutUserInput ;
  usedOffers?: UserUpdateusedOffersInput ;
  language?: string ;
  company?: CompanyUpdateOneRequiredWithoutUsersInput ;
  devices?: DeviceUpdateManyWithoutUserInput ;
  stampCards?: StampCardUpdateManyWithoutUsersInput ;
  stamps?: StampUpdateManyWithoutUserInput ;
  tokens?: OfferTokenUpdateManyWithoutUserInput ;
  venues?: VenueUpdateManyWithoutUsersInput ;
  creditCards?: CreditCardUpdateManyWithoutUserInput ;
  recommendations?: RecommendationUpdateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelUpdateOneWithoutUsersInput ;
  membershipCard?: MembershipCardUpdateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeUpdateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationUpdateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationUpdateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralUpdateOneWithoutUserInput ;
  referrals?: UserReferralUpdateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventUpdateManyWithoutUserInput ;
  logs?: LogUpdateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentUpdateManyWithoutUsersInput ;
  previousSegments?: UserSegmentUpdateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserUpdateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutUsersInput ;
  reservations?: ReservationUpdateManyWithoutUserInput ;
  table?: TableUpdateOneWithoutUsersInput ;
  tableSessions?: TableSessionUpdateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingUpdateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingUpdateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentUpdateManyWithoutUserInput ;
  writtenComments?: UserCommentUpdateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanUpdateManyWithoutUserInput ;
}

export interface UserUpdateWithoutMembershipAssignmentsDataInput {
  creditBank?: CreditBankUpdateOneRequiredWithoutUserInput ;
  image?: string ;
  meta?: any ;
  name?: string ;
  venueLimited?: boolean ;
  offers?: OfferUpdateManyWithoutUsersInput ;
  orders?: OrderUpdateManyWithoutUserInput ;
  payments?: PaymentUpdateManyWithoutUserInput ;
  usedOffers?: UserUpdateusedOffersInput ;
  language?: string ;
  company?: CompanyUpdateOneRequiredWithoutUsersInput ;
  devices?: DeviceUpdateManyWithoutUserInput ;
  stampCards?: StampCardUpdateManyWithoutUsersInput ;
  stamps?: StampUpdateManyWithoutUserInput ;
  tokens?: OfferTokenUpdateManyWithoutUserInput ;
  venues?: VenueUpdateManyWithoutUsersInput ;
  locations?: LocationUpdateManyWithoutUserInput ;
  creditCards?: CreditCardUpdateManyWithoutUserInput ;
  recommendations?: RecommendationUpdateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelUpdateOneWithoutUsersInput ;
  membershipCard?: MembershipCardUpdateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeUpdateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationUpdateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationUpdateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralUpdateOneWithoutUserInput ;
  referrals?: UserReferralUpdateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventUpdateManyWithoutUserInput ;
  logs?: LogUpdateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentUpdateManyWithoutUsersInput ;
  previousSegments?: UserSegmentUpdateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserUpdateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutUsersInput ;
  reservations?: ReservationUpdateManyWithoutUserInput ;
  table?: TableUpdateOneWithoutUsersInput ;
  tableSessions?: TableSessionUpdateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingUpdateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingUpdateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentUpdateManyWithoutUserInput ;
  writtenComments?: UserCommentUpdateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanUpdateManyWithoutUserInput ;
}

export interface UserUpdateWithoutMembershipCardDataInput {
  creditBank?: CreditBankUpdateOneRequiredWithoutUserInput ;
  image?: string ;
  meta?: any ;
  name?: string ;
  venueLimited?: boolean ;
  offers?: OfferUpdateManyWithoutUsersInput ;
  orders?: OrderUpdateManyWithoutUserInput ;
  payments?: PaymentUpdateManyWithoutUserInput ;
  usedOffers?: UserUpdateusedOffersInput ;
  language?: string ;
  company?: CompanyUpdateOneRequiredWithoutUsersInput ;
  devices?: DeviceUpdateManyWithoutUserInput ;
  stampCards?: StampCardUpdateManyWithoutUsersInput ;
  stamps?: StampUpdateManyWithoutUserInput ;
  tokens?: OfferTokenUpdateManyWithoutUserInput ;
  venues?: VenueUpdateManyWithoutUsersInput ;
  locations?: LocationUpdateManyWithoutUserInput ;
  creditCards?: CreditCardUpdateManyWithoutUserInput ;
  recommendations?: RecommendationUpdateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelUpdateOneWithoutUsersInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeUpdateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationUpdateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationUpdateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralUpdateOneWithoutUserInput ;
  referrals?: UserReferralUpdateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventUpdateManyWithoutUserInput ;
  logs?: LogUpdateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentUpdateManyWithoutUsersInput ;
  previousSegments?: UserSegmentUpdateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserUpdateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutUsersInput ;
  reservations?: ReservationUpdateManyWithoutUserInput ;
  table?: TableUpdateOneWithoutUsersInput ;
  tableSessions?: TableSessionUpdateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingUpdateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingUpdateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentUpdateManyWithoutUserInput ;
  writtenComments?: UserCommentUpdateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanUpdateManyWithoutUserInput ;
}

export interface UserUpdateWithoutMembershipLevelDataInput {
  creditBank?: CreditBankUpdateOneRequiredWithoutUserInput ;
  image?: string ;
  meta?: any ;
  name?: string ;
  venueLimited?: boolean ;
  offers?: OfferUpdateManyWithoutUsersInput ;
  orders?: OrderUpdateManyWithoutUserInput ;
  payments?: PaymentUpdateManyWithoutUserInput ;
  usedOffers?: UserUpdateusedOffersInput ;
  language?: string ;
  company?: CompanyUpdateOneRequiredWithoutUsersInput ;
  devices?: DeviceUpdateManyWithoutUserInput ;
  stampCards?: StampCardUpdateManyWithoutUsersInput ;
  stamps?: StampUpdateManyWithoutUserInput ;
  tokens?: OfferTokenUpdateManyWithoutUserInput ;
  venues?: VenueUpdateManyWithoutUsersInput ;
  locations?: LocationUpdateManyWithoutUserInput ;
  creditCards?: CreditCardUpdateManyWithoutUserInput ;
  recommendations?: RecommendationUpdateManyWithoutUserInput ;
  membershipCard?: MembershipCardUpdateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeUpdateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationUpdateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationUpdateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralUpdateOneWithoutUserInput ;
  referrals?: UserReferralUpdateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventUpdateManyWithoutUserInput ;
  logs?: LogUpdateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentUpdateManyWithoutUsersInput ;
  previousSegments?: UserSegmentUpdateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserUpdateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutUsersInput ;
  reservations?: ReservationUpdateManyWithoutUserInput ;
  table?: TableUpdateOneWithoutUsersInput ;
  tableSessions?: TableSessionUpdateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingUpdateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingUpdateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentUpdateManyWithoutUserInput ;
  writtenComments?: UserCommentUpdateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanUpdateManyWithoutUserInput ;
}

export interface UserUpdateWithoutMembershipTradeinsDataInput {
  creditBank?: CreditBankUpdateOneRequiredWithoutUserInput ;
  image?: string ;
  meta?: any ;
  name?: string ;
  venueLimited?: boolean ;
  offers?: OfferUpdateManyWithoutUsersInput ;
  orders?: OrderUpdateManyWithoutUserInput ;
  payments?: PaymentUpdateManyWithoutUserInput ;
  usedOffers?: UserUpdateusedOffersInput ;
  language?: string ;
  company?: CompanyUpdateOneRequiredWithoutUsersInput ;
  devices?: DeviceUpdateManyWithoutUserInput ;
  stampCards?: StampCardUpdateManyWithoutUsersInput ;
  stamps?: StampUpdateManyWithoutUserInput ;
  tokens?: OfferTokenUpdateManyWithoutUserInput ;
  venues?: VenueUpdateManyWithoutUsersInput ;
  locations?: LocationUpdateManyWithoutUserInput ;
  creditCards?: CreditCardUpdateManyWithoutUserInput ;
  recommendations?: RecommendationUpdateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelUpdateOneWithoutUsersInput ;
  membershipCard?: MembershipCardUpdateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeUpdateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationUpdateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationUpdateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralUpdateOneWithoutUserInput ;
  referrals?: UserReferralUpdateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventUpdateManyWithoutUserInput ;
  logs?: LogUpdateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentUpdateManyWithoutUsersInput ;
  previousSegments?: UserSegmentUpdateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserUpdateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutUsersInput ;
  reservations?: ReservationUpdateManyWithoutUserInput ;
  table?: TableUpdateOneWithoutUsersInput ;
  tableSessions?: TableSessionUpdateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingUpdateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingUpdateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentUpdateManyWithoutUserInput ;
  writtenComments?: UserCommentUpdateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanUpdateManyWithoutUserInput ;
}

export interface UserUpdateWithoutNotificationsDataInput {
  creditBank?: CreditBankUpdateOneRequiredWithoutUserInput ;
  image?: string ;
  meta?: any ;
  name?: string ;
  venueLimited?: boolean ;
  offers?: OfferUpdateManyWithoutUsersInput ;
  orders?: OrderUpdateManyWithoutUserInput ;
  payments?: PaymentUpdateManyWithoutUserInput ;
  usedOffers?: UserUpdateusedOffersInput ;
  language?: string ;
  company?: CompanyUpdateOneRequiredWithoutUsersInput ;
  devices?: DeviceUpdateManyWithoutUserInput ;
  stampCards?: StampCardUpdateManyWithoutUsersInput ;
  stamps?: StampUpdateManyWithoutUserInput ;
  tokens?: OfferTokenUpdateManyWithoutUserInput ;
  venues?: VenueUpdateManyWithoutUsersInput ;
  locations?: LocationUpdateManyWithoutUserInput ;
  creditCards?: CreditCardUpdateManyWithoutUserInput ;
  recommendations?: RecommendationUpdateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelUpdateOneWithoutUsersInput ;
  membershipCard?: MembershipCardUpdateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeUpdateManyWithoutUsersInput ;
  email?: string ;
  sentNotifications?: SentNotificationUpdateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralUpdateOneWithoutUserInput ;
  referrals?: UserReferralUpdateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventUpdateManyWithoutUserInput ;
  logs?: LogUpdateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentUpdateManyWithoutUsersInput ;
  previousSegments?: UserSegmentUpdateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserUpdateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutUsersInput ;
  reservations?: ReservationUpdateManyWithoutUserInput ;
  table?: TableUpdateOneWithoutUsersInput ;
  tableSessions?: TableSessionUpdateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingUpdateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingUpdateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentUpdateManyWithoutUserInput ;
  writtenComments?: UserCommentUpdateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanUpdateManyWithoutUserInput ;
}

export interface UserUpdateWithoutOfferYieldEventsDataInput {
  creditBank?: CreditBankUpdateOneRequiredWithoutUserInput ;
  image?: string ;
  meta?: any ;
  name?: string ;
  venueLimited?: boolean ;
  offers?: OfferUpdateManyWithoutUsersInput ;
  orders?: OrderUpdateManyWithoutUserInput ;
  payments?: PaymentUpdateManyWithoutUserInput ;
  usedOffers?: UserUpdateusedOffersInput ;
  language?: string ;
  company?: CompanyUpdateOneRequiredWithoutUsersInput ;
  devices?: DeviceUpdateManyWithoutUserInput ;
  stampCards?: StampCardUpdateManyWithoutUsersInput ;
  stamps?: StampUpdateManyWithoutUserInput ;
  tokens?: OfferTokenUpdateManyWithoutUserInput ;
  venues?: VenueUpdateManyWithoutUsersInput ;
  locations?: LocationUpdateManyWithoutUserInput ;
  creditCards?: CreditCardUpdateManyWithoutUserInput ;
  recommendations?: RecommendationUpdateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelUpdateOneWithoutUsersInput ;
  membershipCard?: MembershipCardUpdateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeUpdateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationUpdateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationUpdateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralUpdateOneWithoutUserInput ;
  referrals?: UserReferralUpdateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventUpdateManyWithoutUserInput ;
  logs?: LogUpdateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentUpdateManyWithoutUsersInput ;
  previousSegments?: UserSegmentUpdateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserUpdateaccessInput ;
  ofLegalAge?: boolean ;
  reservations?: ReservationUpdateManyWithoutUserInput ;
  table?: TableUpdateOneWithoutUsersInput ;
  tableSessions?: TableSessionUpdateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingUpdateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingUpdateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentUpdateManyWithoutUserInput ;
  writtenComments?: UserCommentUpdateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanUpdateManyWithoutUserInput ;
}

export interface UserUpdateWithoutOffersDataInput {
  creditBank?: CreditBankUpdateOneRequiredWithoutUserInput ;
  image?: string ;
  meta?: any ;
  name?: string ;
  venueLimited?: boolean ;
  orders?: OrderUpdateManyWithoutUserInput ;
  payments?: PaymentUpdateManyWithoutUserInput ;
  usedOffers?: UserUpdateusedOffersInput ;
  language?: string ;
  company?: CompanyUpdateOneRequiredWithoutUsersInput ;
  devices?: DeviceUpdateManyWithoutUserInput ;
  stampCards?: StampCardUpdateManyWithoutUsersInput ;
  stamps?: StampUpdateManyWithoutUserInput ;
  tokens?: OfferTokenUpdateManyWithoutUserInput ;
  venues?: VenueUpdateManyWithoutUsersInput ;
  locations?: LocationUpdateManyWithoutUserInput ;
  creditCards?: CreditCardUpdateManyWithoutUserInput ;
  recommendations?: RecommendationUpdateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelUpdateOneWithoutUsersInput ;
  membershipCard?: MembershipCardUpdateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeUpdateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationUpdateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationUpdateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralUpdateOneWithoutUserInput ;
  referrals?: UserReferralUpdateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventUpdateManyWithoutUserInput ;
  logs?: LogUpdateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentUpdateManyWithoutUsersInput ;
  previousSegments?: UserSegmentUpdateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserUpdateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutUsersInput ;
  reservations?: ReservationUpdateManyWithoutUserInput ;
  table?: TableUpdateOneWithoutUsersInput ;
  tableSessions?: TableSessionUpdateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingUpdateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingUpdateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentUpdateManyWithoutUserInput ;
  writtenComments?: UserCommentUpdateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanUpdateManyWithoutUserInput ;
}

export interface UserUpdateWithoutOrdersDataInput {
  creditBank?: CreditBankUpdateOneRequiredWithoutUserInput ;
  image?: string ;
  meta?: any ;
  name?: string ;
  venueLimited?: boolean ;
  offers?: OfferUpdateManyWithoutUsersInput ;
  payments?: PaymentUpdateManyWithoutUserInput ;
  usedOffers?: UserUpdateusedOffersInput ;
  language?: string ;
  company?: CompanyUpdateOneRequiredWithoutUsersInput ;
  devices?: DeviceUpdateManyWithoutUserInput ;
  stampCards?: StampCardUpdateManyWithoutUsersInput ;
  stamps?: StampUpdateManyWithoutUserInput ;
  tokens?: OfferTokenUpdateManyWithoutUserInput ;
  venues?: VenueUpdateManyWithoutUsersInput ;
  locations?: LocationUpdateManyWithoutUserInput ;
  creditCards?: CreditCardUpdateManyWithoutUserInput ;
  recommendations?: RecommendationUpdateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelUpdateOneWithoutUsersInput ;
  membershipCard?: MembershipCardUpdateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeUpdateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationUpdateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationUpdateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralUpdateOneWithoutUserInput ;
  referrals?: UserReferralUpdateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventUpdateManyWithoutUserInput ;
  logs?: LogUpdateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentUpdateManyWithoutUsersInput ;
  previousSegments?: UserSegmentUpdateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserUpdateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutUsersInput ;
  reservations?: ReservationUpdateManyWithoutUserInput ;
  table?: TableUpdateOneWithoutUsersInput ;
  tableSessions?: TableSessionUpdateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingUpdateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingUpdateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentUpdateManyWithoutUserInput ;
  writtenComments?: UserCommentUpdateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanUpdateManyWithoutUserInput ;
}

export interface UserUpdateWithoutPaymentsDataInput {
  creditBank?: CreditBankUpdateOneRequiredWithoutUserInput ;
  image?: string ;
  meta?: any ;
  name?: string ;
  venueLimited?: boolean ;
  offers?: OfferUpdateManyWithoutUsersInput ;
  orders?: OrderUpdateManyWithoutUserInput ;
  usedOffers?: UserUpdateusedOffersInput ;
  language?: string ;
  company?: CompanyUpdateOneRequiredWithoutUsersInput ;
  devices?: DeviceUpdateManyWithoutUserInput ;
  stampCards?: StampCardUpdateManyWithoutUsersInput ;
  stamps?: StampUpdateManyWithoutUserInput ;
  tokens?: OfferTokenUpdateManyWithoutUserInput ;
  venues?: VenueUpdateManyWithoutUsersInput ;
  locations?: LocationUpdateManyWithoutUserInput ;
  creditCards?: CreditCardUpdateManyWithoutUserInput ;
  recommendations?: RecommendationUpdateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelUpdateOneWithoutUsersInput ;
  membershipCard?: MembershipCardUpdateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeUpdateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationUpdateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationUpdateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralUpdateOneWithoutUserInput ;
  referrals?: UserReferralUpdateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventUpdateManyWithoutUserInput ;
  logs?: LogUpdateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentUpdateManyWithoutUsersInput ;
  previousSegments?: UserSegmentUpdateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserUpdateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutUsersInput ;
  reservations?: ReservationUpdateManyWithoutUserInput ;
  table?: TableUpdateOneWithoutUsersInput ;
  tableSessions?: TableSessionUpdateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingUpdateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingUpdateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentUpdateManyWithoutUserInput ;
  writtenComments?: UserCommentUpdateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanUpdateManyWithoutUserInput ;
}

export interface UserUpdateWithoutPreviousSegmentsDataInput {
  creditBank?: CreditBankUpdateOneRequiredWithoutUserInput ;
  image?: string ;
  meta?: any ;
  name?: string ;
  venueLimited?: boolean ;
  offers?: OfferUpdateManyWithoutUsersInput ;
  orders?: OrderUpdateManyWithoutUserInput ;
  payments?: PaymentUpdateManyWithoutUserInput ;
  usedOffers?: UserUpdateusedOffersInput ;
  language?: string ;
  company?: CompanyUpdateOneRequiredWithoutUsersInput ;
  devices?: DeviceUpdateManyWithoutUserInput ;
  stampCards?: StampCardUpdateManyWithoutUsersInput ;
  stamps?: StampUpdateManyWithoutUserInput ;
  tokens?: OfferTokenUpdateManyWithoutUserInput ;
  venues?: VenueUpdateManyWithoutUsersInput ;
  locations?: LocationUpdateManyWithoutUserInput ;
  creditCards?: CreditCardUpdateManyWithoutUserInput ;
  recommendations?: RecommendationUpdateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelUpdateOneWithoutUsersInput ;
  membershipCard?: MembershipCardUpdateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeUpdateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationUpdateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationUpdateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralUpdateOneWithoutUserInput ;
  referrals?: UserReferralUpdateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventUpdateManyWithoutUserInput ;
  logs?: LogUpdateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentUpdateManyWithoutUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserUpdateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutUsersInput ;
  reservations?: ReservationUpdateManyWithoutUserInput ;
  table?: TableUpdateOneWithoutUsersInput ;
  tableSessions?: TableSessionUpdateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingUpdateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingUpdateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentUpdateManyWithoutUserInput ;
  writtenComments?: UserCommentUpdateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanUpdateManyWithoutUserInput ;
}

export interface UserUpdateWithoutPromoCodesDataInput {
  creditBank?: CreditBankUpdateOneRequiredWithoutUserInput ;
  image?: string ;
  meta?: any ;
  name?: string ;
  venueLimited?: boolean ;
  offers?: OfferUpdateManyWithoutUsersInput ;
  orders?: OrderUpdateManyWithoutUserInput ;
  payments?: PaymentUpdateManyWithoutUserInput ;
  usedOffers?: UserUpdateusedOffersInput ;
  language?: string ;
  company?: CompanyUpdateOneRequiredWithoutUsersInput ;
  devices?: DeviceUpdateManyWithoutUserInput ;
  stampCards?: StampCardUpdateManyWithoutUsersInput ;
  stamps?: StampUpdateManyWithoutUserInput ;
  tokens?: OfferTokenUpdateManyWithoutUserInput ;
  venues?: VenueUpdateManyWithoutUsersInput ;
  locations?: LocationUpdateManyWithoutUserInput ;
  creditCards?: CreditCardUpdateManyWithoutUserInput ;
  recommendations?: RecommendationUpdateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelUpdateOneWithoutUsersInput ;
  membershipCard?: MembershipCardUpdateOneWithoutUserInput ;
  facebookId?: string ;
  email?: string ;
  notifications?: NotificationUpdateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationUpdateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralUpdateOneWithoutUserInput ;
  referrals?: UserReferralUpdateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventUpdateManyWithoutUserInput ;
  logs?: LogUpdateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentUpdateManyWithoutUsersInput ;
  previousSegments?: UserSegmentUpdateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserUpdateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutUsersInput ;
  reservations?: ReservationUpdateManyWithoutUserInput ;
  table?: TableUpdateOneWithoutUsersInput ;
  tableSessions?: TableSessionUpdateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingUpdateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingUpdateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentUpdateManyWithoutUserInput ;
  writtenComments?: UserCommentUpdateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanUpdateManyWithoutUserInput ;
}

export interface UserUpdateWithoutReceiptPointsScansDataInput {
  creditBank?: CreditBankUpdateOneRequiredWithoutUserInput ;
  image?: string ;
  meta?: any ;
  name?: string ;
  venueLimited?: boolean ;
  offers?: OfferUpdateManyWithoutUsersInput ;
  orders?: OrderUpdateManyWithoutUserInput ;
  payments?: PaymentUpdateManyWithoutUserInput ;
  usedOffers?: UserUpdateusedOffersInput ;
  language?: string ;
  company?: CompanyUpdateOneRequiredWithoutUsersInput ;
  devices?: DeviceUpdateManyWithoutUserInput ;
  stampCards?: StampCardUpdateManyWithoutUsersInput ;
  stamps?: StampUpdateManyWithoutUserInput ;
  tokens?: OfferTokenUpdateManyWithoutUserInput ;
  venues?: VenueUpdateManyWithoutUsersInput ;
  locations?: LocationUpdateManyWithoutUserInput ;
  creditCards?: CreditCardUpdateManyWithoutUserInput ;
  recommendations?: RecommendationUpdateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelUpdateOneWithoutUsersInput ;
  membershipCard?: MembershipCardUpdateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeUpdateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationUpdateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationUpdateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralUpdateOneWithoutUserInput ;
  referrals?: UserReferralUpdateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventUpdateManyWithoutUserInput ;
  logs?: LogUpdateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentUpdateManyWithoutUsersInput ;
  previousSegments?: UserSegmentUpdateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserUpdateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutUsersInput ;
  reservations?: ReservationUpdateManyWithoutUserInput ;
  table?: TableUpdateOneWithoutUsersInput ;
  tableSessions?: TableSessionUpdateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingUpdateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingUpdateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentUpdateManyWithoutUserInput ;
  writtenComments?: UserCommentUpdateManyWithoutAuthorInput ;
}

export interface UserUpdateWithoutRecommendationsDataInput {
  creditBank?: CreditBankUpdateOneRequiredWithoutUserInput ;
  image?: string ;
  meta?: any ;
  name?: string ;
  venueLimited?: boolean ;
  offers?: OfferUpdateManyWithoutUsersInput ;
  orders?: OrderUpdateManyWithoutUserInput ;
  payments?: PaymentUpdateManyWithoutUserInput ;
  usedOffers?: UserUpdateusedOffersInput ;
  language?: string ;
  company?: CompanyUpdateOneRequiredWithoutUsersInput ;
  devices?: DeviceUpdateManyWithoutUserInput ;
  stampCards?: StampCardUpdateManyWithoutUsersInput ;
  stamps?: StampUpdateManyWithoutUserInput ;
  tokens?: OfferTokenUpdateManyWithoutUserInput ;
  venues?: VenueUpdateManyWithoutUsersInput ;
  locations?: LocationUpdateManyWithoutUserInput ;
  creditCards?: CreditCardUpdateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelUpdateOneWithoutUsersInput ;
  membershipCard?: MembershipCardUpdateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeUpdateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationUpdateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationUpdateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralUpdateOneWithoutUserInput ;
  referrals?: UserReferralUpdateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventUpdateManyWithoutUserInput ;
  logs?: LogUpdateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentUpdateManyWithoutUsersInput ;
  previousSegments?: UserSegmentUpdateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserUpdateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutUsersInput ;
  reservations?: ReservationUpdateManyWithoutUserInput ;
  table?: TableUpdateOneWithoutUsersInput ;
  tableSessions?: TableSessionUpdateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingUpdateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingUpdateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentUpdateManyWithoutUserInput ;
  writtenComments?: UserCommentUpdateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanUpdateManyWithoutUserInput ;
}

export interface UserUpdateWithoutReferalDataInput {
  creditBank?: CreditBankUpdateOneRequiredWithoutUserInput ;
  image?: string ;
  meta?: any ;
  name?: string ;
  venueLimited?: boolean ;
  offers?: OfferUpdateManyWithoutUsersInput ;
  orders?: OrderUpdateManyWithoutUserInput ;
  payments?: PaymentUpdateManyWithoutUserInput ;
  usedOffers?: UserUpdateusedOffersInput ;
  language?: string ;
  company?: CompanyUpdateOneRequiredWithoutUsersInput ;
  devices?: DeviceUpdateManyWithoutUserInput ;
  stampCards?: StampCardUpdateManyWithoutUsersInput ;
  stamps?: StampUpdateManyWithoutUserInput ;
  tokens?: OfferTokenUpdateManyWithoutUserInput ;
  venues?: VenueUpdateManyWithoutUsersInput ;
  locations?: LocationUpdateManyWithoutUserInput ;
  creditCards?: CreditCardUpdateManyWithoutUserInput ;
  recommendations?: RecommendationUpdateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelUpdateOneWithoutUsersInput ;
  membershipCard?: MembershipCardUpdateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeUpdateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationUpdateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationUpdateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referrals?: UserReferralUpdateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventUpdateManyWithoutUserInput ;
  logs?: LogUpdateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentUpdateManyWithoutUsersInput ;
  previousSegments?: UserSegmentUpdateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserUpdateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutUsersInput ;
  reservations?: ReservationUpdateManyWithoutUserInput ;
  table?: TableUpdateOneWithoutUsersInput ;
  tableSessions?: TableSessionUpdateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingUpdateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingUpdateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentUpdateManyWithoutUserInput ;
  writtenComments?: UserCommentUpdateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanUpdateManyWithoutUserInput ;
}

export interface UserUpdateWithoutReferralsDataInput {
  creditBank?: CreditBankUpdateOneRequiredWithoutUserInput ;
  image?: string ;
  meta?: any ;
  name?: string ;
  venueLimited?: boolean ;
  offers?: OfferUpdateManyWithoutUsersInput ;
  orders?: OrderUpdateManyWithoutUserInput ;
  payments?: PaymentUpdateManyWithoutUserInput ;
  usedOffers?: UserUpdateusedOffersInput ;
  language?: string ;
  company?: CompanyUpdateOneRequiredWithoutUsersInput ;
  devices?: DeviceUpdateManyWithoutUserInput ;
  stampCards?: StampCardUpdateManyWithoutUsersInput ;
  stamps?: StampUpdateManyWithoutUserInput ;
  tokens?: OfferTokenUpdateManyWithoutUserInput ;
  venues?: VenueUpdateManyWithoutUsersInput ;
  locations?: LocationUpdateManyWithoutUserInput ;
  creditCards?: CreditCardUpdateManyWithoutUserInput ;
  recommendations?: RecommendationUpdateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelUpdateOneWithoutUsersInput ;
  membershipCard?: MembershipCardUpdateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeUpdateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationUpdateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationUpdateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralUpdateOneWithoutUserInput ;
  phone?: string ;
  events?: EventUpdateManyWithoutUserInput ;
  logs?: LogUpdateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentUpdateManyWithoutUsersInput ;
  previousSegments?: UserSegmentUpdateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserUpdateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutUsersInput ;
  reservations?: ReservationUpdateManyWithoutUserInput ;
  table?: TableUpdateOneWithoutUsersInput ;
  tableSessions?: TableSessionUpdateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingUpdateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingUpdateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentUpdateManyWithoutUserInput ;
  writtenComments?: UserCommentUpdateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanUpdateManyWithoutUserInput ;
}

export interface UserUpdateWithoutReservationsDataInput {
  creditBank?: CreditBankUpdateOneRequiredWithoutUserInput ;
  image?: string ;
  meta?: any ;
  name?: string ;
  venueLimited?: boolean ;
  offers?: OfferUpdateManyWithoutUsersInput ;
  orders?: OrderUpdateManyWithoutUserInput ;
  payments?: PaymentUpdateManyWithoutUserInput ;
  usedOffers?: UserUpdateusedOffersInput ;
  language?: string ;
  company?: CompanyUpdateOneRequiredWithoutUsersInput ;
  devices?: DeviceUpdateManyWithoutUserInput ;
  stampCards?: StampCardUpdateManyWithoutUsersInput ;
  stamps?: StampUpdateManyWithoutUserInput ;
  tokens?: OfferTokenUpdateManyWithoutUserInput ;
  venues?: VenueUpdateManyWithoutUsersInput ;
  locations?: LocationUpdateManyWithoutUserInput ;
  creditCards?: CreditCardUpdateManyWithoutUserInput ;
  recommendations?: RecommendationUpdateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelUpdateOneWithoutUsersInput ;
  membershipCard?: MembershipCardUpdateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeUpdateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationUpdateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationUpdateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralUpdateOneWithoutUserInput ;
  referrals?: UserReferralUpdateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventUpdateManyWithoutUserInput ;
  logs?: LogUpdateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentUpdateManyWithoutUsersInput ;
  previousSegments?: UserSegmentUpdateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserUpdateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutUsersInput ;
  table?: TableUpdateOneWithoutUsersInput ;
  tableSessions?: TableSessionUpdateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingUpdateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingUpdateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentUpdateManyWithoutUserInput ;
  writtenComments?: UserCommentUpdateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanUpdateManyWithoutUserInput ;
}

export interface UserUpdateWithoutSegmentsDataInput {
  creditBank?: CreditBankUpdateOneRequiredWithoutUserInput ;
  image?: string ;
  meta?: any ;
  name?: string ;
  venueLimited?: boolean ;
  offers?: OfferUpdateManyWithoutUsersInput ;
  orders?: OrderUpdateManyWithoutUserInput ;
  payments?: PaymentUpdateManyWithoutUserInput ;
  usedOffers?: UserUpdateusedOffersInput ;
  language?: string ;
  company?: CompanyUpdateOneRequiredWithoutUsersInput ;
  devices?: DeviceUpdateManyWithoutUserInput ;
  stampCards?: StampCardUpdateManyWithoutUsersInput ;
  stamps?: StampUpdateManyWithoutUserInput ;
  tokens?: OfferTokenUpdateManyWithoutUserInput ;
  venues?: VenueUpdateManyWithoutUsersInput ;
  locations?: LocationUpdateManyWithoutUserInput ;
  creditCards?: CreditCardUpdateManyWithoutUserInput ;
  recommendations?: RecommendationUpdateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelUpdateOneWithoutUsersInput ;
  membershipCard?: MembershipCardUpdateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeUpdateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationUpdateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationUpdateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralUpdateOneWithoutUserInput ;
  referrals?: UserReferralUpdateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventUpdateManyWithoutUserInput ;
  logs?: LogUpdateManyWithoutUserInput ;
  role?: ROLE ;
  previousSegments?: UserSegmentUpdateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserUpdateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutUsersInput ;
  reservations?: ReservationUpdateManyWithoutUserInput ;
  table?: TableUpdateOneWithoutUsersInput ;
  tableSessions?: TableSessionUpdateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingUpdateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingUpdateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentUpdateManyWithoutUserInput ;
  writtenComments?: UserCommentUpdateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanUpdateManyWithoutUserInput ;
}

export interface UserUpdateWithoutSentNotificationsDataInput {
  creditBank?: CreditBankUpdateOneRequiredWithoutUserInput ;
  image?: string ;
  meta?: any ;
  name?: string ;
  venueLimited?: boolean ;
  offers?: OfferUpdateManyWithoutUsersInput ;
  orders?: OrderUpdateManyWithoutUserInput ;
  payments?: PaymentUpdateManyWithoutUserInput ;
  usedOffers?: UserUpdateusedOffersInput ;
  language?: string ;
  company?: CompanyUpdateOneRequiredWithoutUsersInput ;
  devices?: DeviceUpdateManyWithoutUserInput ;
  stampCards?: StampCardUpdateManyWithoutUsersInput ;
  stamps?: StampUpdateManyWithoutUserInput ;
  tokens?: OfferTokenUpdateManyWithoutUserInput ;
  venues?: VenueUpdateManyWithoutUsersInput ;
  locations?: LocationUpdateManyWithoutUserInput ;
  creditCards?: CreditCardUpdateManyWithoutUserInput ;
  recommendations?: RecommendationUpdateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelUpdateOneWithoutUsersInput ;
  membershipCard?: MembershipCardUpdateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeUpdateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationUpdateManyWithoutUsersInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralUpdateOneWithoutUserInput ;
  referrals?: UserReferralUpdateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventUpdateManyWithoutUserInput ;
  logs?: LogUpdateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentUpdateManyWithoutUsersInput ;
  previousSegments?: UserSegmentUpdateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserUpdateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutUsersInput ;
  reservations?: ReservationUpdateManyWithoutUserInput ;
  table?: TableUpdateOneWithoutUsersInput ;
  tableSessions?: TableSessionUpdateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingUpdateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingUpdateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentUpdateManyWithoutUserInput ;
  writtenComments?: UserCommentUpdateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanUpdateManyWithoutUserInput ;
}

export interface UserUpdateWithoutStampCardsDataInput {
  creditBank?: CreditBankUpdateOneRequiredWithoutUserInput ;
  image?: string ;
  meta?: any ;
  name?: string ;
  venueLimited?: boolean ;
  offers?: OfferUpdateManyWithoutUsersInput ;
  orders?: OrderUpdateManyWithoutUserInput ;
  payments?: PaymentUpdateManyWithoutUserInput ;
  usedOffers?: UserUpdateusedOffersInput ;
  language?: string ;
  company?: CompanyUpdateOneRequiredWithoutUsersInput ;
  devices?: DeviceUpdateManyWithoutUserInput ;
  stamps?: StampUpdateManyWithoutUserInput ;
  tokens?: OfferTokenUpdateManyWithoutUserInput ;
  venues?: VenueUpdateManyWithoutUsersInput ;
  locations?: LocationUpdateManyWithoutUserInput ;
  creditCards?: CreditCardUpdateManyWithoutUserInput ;
  recommendations?: RecommendationUpdateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelUpdateOneWithoutUsersInput ;
  membershipCard?: MembershipCardUpdateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeUpdateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationUpdateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationUpdateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralUpdateOneWithoutUserInput ;
  referrals?: UserReferralUpdateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventUpdateManyWithoutUserInput ;
  logs?: LogUpdateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentUpdateManyWithoutUsersInput ;
  previousSegments?: UserSegmentUpdateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserUpdateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutUsersInput ;
  reservations?: ReservationUpdateManyWithoutUserInput ;
  table?: TableUpdateOneWithoutUsersInput ;
  tableSessions?: TableSessionUpdateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingUpdateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingUpdateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentUpdateManyWithoutUserInput ;
  writtenComments?: UserCommentUpdateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanUpdateManyWithoutUserInput ;
}

export interface UserUpdateWithoutStampsDataInput {
  creditBank?: CreditBankUpdateOneRequiredWithoutUserInput ;
  image?: string ;
  meta?: any ;
  name?: string ;
  venueLimited?: boolean ;
  offers?: OfferUpdateManyWithoutUsersInput ;
  orders?: OrderUpdateManyWithoutUserInput ;
  payments?: PaymentUpdateManyWithoutUserInput ;
  usedOffers?: UserUpdateusedOffersInput ;
  language?: string ;
  company?: CompanyUpdateOneRequiredWithoutUsersInput ;
  devices?: DeviceUpdateManyWithoutUserInput ;
  stampCards?: StampCardUpdateManyWithoutUsersInput ;
  tokens?: OfferTokenUpdateManyWithoutUserInput ;
  venues?: VenueUpdateManyWithoutUsersInput ;
  locations?: LocationUpdateManyWithoutUserInput ;
  creditCards?: CreditCardUpdateManyWithoutUserInput ;
  recommendations?: RecommendationUpdateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelUpdateOneWithoutUsersInput ;
  membershipCard?: MembershipCardUpdateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeUpdateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationUpdateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationUpdateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralUpdateOneWithoutUserInput ;
  referrals?: UserReferralUpdateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventUpdateManyWithoutUserInput ;
  logs?: LogUpdateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentUpdateManyWithoutUsersInput ;
  previousSegments?: UserSegmentUpdateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserUpdateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutUsersInput ;
  reservations?: ReservationUpdateManyWithoutUserInput ;
  table?: TableUpdateOneWithoutUsersInput ;
  tableSessions?: TableSessionUpdateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingUpdateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingUpdateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentUpdateManyWithoutUserInput ;
  writtenComments?: UserCommentUpdateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanUpdateManyWithoutUserInput ;
}

export interface UserUpdateWithoutTableDataInput {
  creditBank?: CreditBankUpdateOneRequiredWithoutUserInput ;
  image?: string ;
  meta?: any ;
  name?: string ;
  venueLimited?: boolean ;
  offers?: OfferUpdateManyWithoutUsersInput ;
  orders?: OrderUpdateManyWithoutUserInput ;
  payments?: PaymentUpdateManyWithoutUserInput ;
  usedOffers?: UserUpdateusedOffersInput ;
  language?: string ;
  company?: CompanyUpdateOneRequiredWithoutUsersInput ;
  devices?: DeviceUpdateManyWithoutUserInput ;
  stampCards?: StampCardUpdateManyWithoutUsersInput ;
  stamps?: StampUpdateManyWithoutUserInput ;
  tokens?: OfferTokenUpdateManyWithoutUserInput ;
  venues?: VenueUpdateManyWithoutUsersInput ;
  locations?: LocationUpdateManyWithoutUserInput ;
  creditCards?: CreditCardUpdateManyWithoutUserInput ;
  recommendations?: RecommendationUpdateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelUpdateOneWithoutUsersInput ;
  membershipCard?: MembershipCardUpdateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeUpdateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationUpdateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationUpdateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralUpdateOneWithoutUserInput ;
  referrals?: UserReferralUpdateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventUpdateManyWithoutUserInput ;
  logs?: LogUpdateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentUpdateManyWithoutUsersInput ;
  previousSegments?: UserSegmentUpdateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserUpdateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutUsersInput ;
  reservations?: ReservationUpdateManyWithoutUserInput ;
  tableSessions?: TableSessionUpdateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingUpdateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingUpdateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentUpdateManyWithoutUserInput ;
  writtenComments?: UserCommentUpdateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanUpdateManyWithoutUserInput ;
}

export interface UserUpdateWithoutTablePaymentSettingsDataInput {
  creditBank?: CreditBankUpdateOneRequiredWithoutUserInput ;
  image?: string ;
  meta?: any ;
  name?: string ;
  venueLimited?: boolean ;
  offers?: OfferUpdateManyWithoutUsersInput ;
  orders?: OrderUpdateManyWithoutUserInput ;
  payments?: PaymentUpdateManyWithoutUserInput ;
  usedOffers?: UserUpdateusedOffersInput ;
  language?: string ;
  company?: CompanyUpdateOneRequiredWithoutUsersInput ;
  devices?: DeviceUpdateManyWithoutUserInput ;
  stampCards?: StampCardUpdateManyWithoutUsersInput ;
  stamps?: StampUpdateManyWithoutUserInput ;
  tokens?: OfferTokenUpdateManyWithoutUserInput ;
  venues?: VenueUpdateManyWithoutUsersInput ;
  locations?: LocationUpdateManyWithoutUserInput ;
  creditCards?: CreditCardUpdateManyWithoutUserInput ;
  recommendations?: RecommendationUpdateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelUpdateOneWithoutUsersInput ;
  membershipCard?: MembershipCardUpdateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeUpdateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationUpdateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationUpdateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralUpdateOneWithoutUserInput ;
  referrals?: UserReferralUpdateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventUpdateManyWithoutUserInput ;
  logs?: LogUpdateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentUpdateManyWithoutUsersInput ;
  previousSegments?: UserSegmentUpdateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserUpdateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutUsersInput ;
  reservations?: ReservationUpdateManyWithoutUserInput ;
  table?: TableUpdateOneWithoutUsersInput ;
  tableSessions?: TableSessionUpdateManyWithoutUsersInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingUpdateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentUpdateManyWithoutUserInput ;
  writtenComments?: UserCommentUpdateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanUpdateManyWithoutUserInput ;
}

export interface UserUpdateWithoutTablePaymentSettingsHistoryDataInput {
  creditBank?: CreditBankUpdateOneRequiredWithoutUserInput ;
  image?: string ;
  meta?: any ;
  name?: string ;
  venueLimited?: boolean ;
  offers?: OfferUpdateManyWithoutUsersInput ;
  orders?: OrderUpdateManyWithoutUserInput ;
  payments?: PaymentUpdateManyWithoutUserInput ;
  usedOffers?: UserUpdateusedOffersInput ;
  language?: string ;
  company?: CompanyUpdateOneRequiredWithoutUsersInput ;
  devices?: DeviceUpdateManyWithoutUserInput ;
  stampCards?: StampCardUpdateManyWithoutUsersInput ;
  stamps?: StampUpdateManyWithoutUserInput ;
  tokens?: OfferTokenUpdateManyWithoutUserInput ;
  venues?: VenueUpdateManyWithoutUsersInput ;
  locations?: LocationUpdateManyWithoutUserInput ;
  creditCards?: CreditCardUpdateManyWithoutUserInput ;
  recommendations?: RecommendationUpdateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelUpdateOneWithoutUsersInput ;
  membershipCard?: MembershipCardUpdateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeUpdateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationUpdateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationUpdateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralUpdateOneWithoutUserInput ;
  referrals?: UserReferralUpdateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventUpdateManyWithoutUserInput ;
  logs?: LogUpdateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentUpdateManyWithoutUsersInput ;
  previousSegments?: UserSegmentUpdateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserUpdateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutUsersInput ;
  reservations?: ReservationUpdateManyWithoutUserInput ;
  table?: TableUpdateOneWithoutUsersInput ;
  tableSessions?: TableSessionUpdateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingUpdateOneWithoutUserActiveInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentUpdateManyWithoutUserInput ;
  writtenComments?: UserCommentUpdateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanUpdateManyWithoutUserInput ;
}

export interface UserUpdateWithoutTableSessionsDataInput {
  creditBank?: CreditBankUpdateOneRequiredWithoutUserInput ;
  image?: string ;
  meta?: any ;
  name?: string ;
  venueLimited?: boolean ;
  offers?: OfferUpdateManyWithoutUsersInput ;
  orders?: OrderUpdateManyWithoutUserInput ;
  payments?: PaymentUpdateManyWithoutUserInput ;
  usedOffers?: UserUpdateusedOffersInput ;
  language?: string ;
  company?: CompanyUpdateOneRequiredWithoutUsersInput ;
  devices?: DeviceUpdateManyWithoutUserInput ;
  stampCards?: StampCardUpdateManyWithoutUsersInput ;
  stamps?: StampUpdateManyWithoutUserInput ;
  tokens?: OfferTokenUpdateManyWithoutUserInput ;
  venues?: VenueUpdateManyWithoutUsersInput ;
  locations?: LocationUpdateManyWithoutUserInput ;
  creditCards?: CreditCardUpdateManyWithoutUserInput ;
  recommendations?: RecommendationUpdateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelUpdateOneWithoutUsersInput ;
  membershipCard?: MembershipCardUpdateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeUpdateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationUpdateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationUpdateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralUpdateOneWithoutUserInput ;
  referrals?: UserReferralUpdateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventUpdateManyWithoutUserInput ;
  logs?: LogUpdateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentUpdateManyWithoutUsersInput ;
  previousSegments?: UserSegmentUpdateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserUpdateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutUsersInput ;
  reservations?: ReservationUpdateManyWithoutUserInput ;
  table?: TableUpdateOneWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingUpdateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingUpdateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentUpdateManyWithoutUserInput ;
  writtenComments?: UserCommentUpdateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanUpdateManyWithoutUserInput ;
}

export interface UserUpdateWithoutTokensDataInput {
  creditBank?: CreditBankUpdateOneRequiredWithoutUserInput ;
  image?: string ;
  meta?: any ;
  name?: string ;
  venueLimited?: boolean ;
  offers?: OfferUpdateManyWithoutUsersInput ;
  orders?: OrderUpdateManyWithoutUserInput ;
  payments?: PaymentUpdateManyWithoutUserInput ;
  usedOffers?: UserUpdateusedOffersInput ;
  language?: string ;
  company?: CompanyUpdateOneRequiredWithoutUsersInput ;
  devices?: DeviceUpdateManyWithoutUserInput ;
  stampCards?: StampCardUpdateManyWithoutUsersInput ;
  stamps?: StampUpdateManyWithoutUserInput ;
  venues?: VenueUpdateManyWithoutUsersInput ;
  locations?: LocationUpdateManyWithoutUserInput ;
  creditCards?: CreditCardUpdateManyWithoutUserInput ;
  recommendations?: RecommendationUpdateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelUpdateOneWithoutUsersInput ;
  membershipCard?: MembershipCardUpdateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeUpdateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationUpdateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationUpdateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralUpdateOneWithoutUserInput ;
  referrals?: UserReferralUpdateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventUpdateManyWithoutUserInput ;
  logs?: LogUpdateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentUpdateManyWithoutUsersInput ;
  previousSegments?: UserSegmentUpdateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserUpdateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutUsersInput ;
  reservations?: ReservationUpdateManyWithoutUserInput ;
  table?: TableUpdateOneWithoutUsersInput ;
  tableSessions?: TableSessionUpdateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingUpdateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingUpdateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentUpdateManyWithoutUserInput ;
  writtenComments?: UserCommentUpdateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanUpdateManyWithoutUserInput ;
}

export interface UserUpdateWithoutVenuesDataInput {
  creditBank?: CreditBankUpdateOneRequiredWithoutUserInput ;
  image?: string ;
  meta?: any ;
  name?: string ;
  venueLimited?: boolean ;
  offers?: OfferUpdateManyWithoutUsersInput ;
  orders?: OrderUpdateManyWithoutUserInput ;
  payments?: PaymentUpdateManyWithoutUserInput ;
  usedOffers?: UserUpdateusedOffersInput ;
  language?: string ;
  company?: CompanyUpdateOneRequiredWithoutUsersInput ;
  devices?: DeviceUpdateManyWithoutUserInput ;
  stampCards?: StampCardUpdateManyWithoutUsersInput ;
  stamps?: StampUpdateManyWithoutUserInput ;
  tokens?: OfferTokenUpdateManyWithoutUserInput ;
  locations?: LocationUpdateManyWithoutUserInput ;
  creditCards?: CreditCardUpdateManyWithoutUserInput ;
  recommendations?: RecommendationUpdateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelUpdateOneWithoutUsersInput ;
  membershipCard?: MembershipCardUpdateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeUpdateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationUpdateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationUpdateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralUpdateOneWithoutUserInput ;
  referrals?: UserReferralUpdateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventUpdateManyWithoutUserInput ;
  logs?: LogUpdateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentUpdateManyWithoutUsersInput ;
  previousSegments?: UserSegmentUpdateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserUpdateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutUsersInput ;
  reservations?: ReservationUpdateManyWithoutUserInput ;
  table?: TableUpdateOneWithoutUsersInput ;
  tableSessions?: TableSessionUpdateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingUpdateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingUpdateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentUpdateManyWithoutUserInput ;
  writtenComments?: UserCommentUpdateManyWithoutAuthorInput ;
  receiptPointsScans?: ReceiptPointsScanUpdateManyWithoutUserInput ;
}

export interface UserUpdateWithoutWrittenCommentsDataInput {
  creditBank?: CreditBankUpdateOneRequiredWithoutUserInput ;
  image?: string ;
  meta?: any ;
  name?: string ;
  venueLimited?: boolean ;
  offers?: OfferUpdateManyWithoutUsersInput ;
  orders?: OrderUpdateManyWithoutUserInput ;
  payments?: PaymentUpdateManyWithoutUserInput ;
  usedOffers?: UserUpdateusedOffersInput ;
  language?: string ;
  company?: CompanyUpdateOneRequiredWithoutUsersInput ;
  devices?: DeviceUpdateManyWithoutUserInput ;
  stampCards?: StampCardUpdateManyWithoutUsersInput ;
  stamps?: StampUpdateManyWithoutUserInput ;
  tokens?: OfferTokenUpdateManyWithoutUserInput ;
  venues?: VenueUpdateManyWithoutUsersInput ;
  locations?: LocationUpdateManyWithoutUserInput ;
  creditCards?: CreditCardUpdateManyWithoutUserInput ;
  recommendations?: RecommendationUpdateManyWithoutUserInput ;
  membershipLevel?: MembershipLevelUpdateOneWithoutUsersInput ;
  membershipCard?: MembershipCardUpdateOneWithoutUserInput ;
  facebookId?: string ;
  promoCodes?: PromoCodeUpdateManyWithoutUsersInput ;
  email?: string ;
  notifications?: NotificationUpdateManyWithoutUsersInput ;
  sentNotifications?: SentNotificationUpdateManyWithoutUserInput ;
  password?: string ;
  referralCode?: string ;
  referal?: UserReferralUpdateOneWithoutUserInput ;
  referrals?: UserReferralUpdateManyWithoutReferrerInput ;
  phone?: string ;
  events?: EventUpdateManyWithoutUserInput ;
  logs?: LogUpdateManyWithoutUserInput ;
  role?: ROLE ;
  segments?: UserSegmentUpdateManyWithoutUsersInput ;
  previousSegments?: UserSegmentUpdateManyWithoutPreviousUsersInput ;
  activated?: boolean ;
  blocked?: boolean ;
  deleted?: boolean ;
  lastLogin?: any ;
  personalNumber?: string ;
  access?: UserUpdateaccessInput ;
  ofLegalAge?: boolean ;
  offerYieldEvents?: OfferYieldEventUpdateManyWithoutUsersInput ;
  reservations?: ReservationUpdateManyWithoutUserInput ;
  table?: TableUpdateOneWithoutUsersInput ;
  tableSessions?: TableSessionUpdateManyWithoutUsersInput ;
  tablePaymentSettings?: TablePaymentSettingUpdateOneWithoutUserActiveInput ;
  tablePaymentSettingsHistory?: TablePaymentSettingUpdateManyWithoutUserInput ;
  membershipTradeins?: MembershipTradeinUpdateManyWithoutUserInput ;
  membershipAssignments?: MembershipAssignmentUpdateManyWithoutUserInput ;
  username?: string ;
  shouldUpdatePassword?: boolean ;
  comments?: UserCommentUpdateManyWithoutUserInput ;
  receiptPointsScans?: ReceiptPointsScanUpdateManyWithoutUserInput ;
}

export interface UserUpdateaccessInput {
  set?: string[] ;
}

export interface UserUpdateusedOffersInput {
  set?: string[] ;
}

export interface UserUpsertWithWhereUniqueWithoutCompanyInput {
  where: UserWhereUniqueInput;
  update: UserUpdateWithoutCompanyDataInput;
  create: UserCreateWithoutCompanyInput;
}

export interface UserUpsertWithWhereUniqueWithoutMembershipLevelInput {
  where: UserWhereUniqueInput;
  update: UserUpdateWithoutMembershipLevelDataInput;
  create: UserCreateWithoutMembershipLevelInput;
}

export interface UserUpsertWithWhereUniqueWithoutNotificationsInput {
  where: UserWhereUniqueInput;
  update: UserUpdateWithoutNotificationsDataInput;
  create: UserCreateWithoutNotificationsInput;
}

export interface UserUpsertWithWhereUniqueWithoutOfferYieldEventsInput {
  where: UserWhereUniqueInput;
  update: UserUpdateWithoutOfferYieldEventsDataInput;
  create: UserCreateWithoutOfferYieldEventsInput;
}

export interface UserUpsertWithWhereUniqueWithoutOffersInput {
  where: UserWhereUniqueInput;
  update: UserUpdateWithoutOffersDataInput;
  create: UserCreateWithoutOffersInput;
}

export interface UserUpsertWithWhereUniqueWithoutPreviousSegmentsInput {
  where: UserWhereUniqueInput;
  update: UserUpdateWithoutPreviousSegmentsDataInput;
  create: UserCreateWithoutPreviousSegmentsInput;
}

export interface UserUpsertWithWhereUniqueWithoutPromoCodesInput {
  where: UserWhereUniqueInput;
  update: UserUpdateWithoutPromoCodesDataInput;
  create: UserCreateWithoutPromoCodesInput;
}

export interface UserUpsertWithWhereUniqueWithoutSegmentsInput {
  where: UserWhereUniqueInput;
  update: UserUpdateWithoutSegmentsDataInput;
  create: UserCreateWithoutSegmentsInput;
}

export interface UserUpsertWithWhereUniqueWithoutStampCardsInput {
  where: UserWhereUniqueInput;
  update: UserUpdateWithoutStampCardsDataInput;
  create: UserCreateWithoutStampCardsInput;
}

export interface UserUpsertWithWhereUniqueWithoutTableInput {
  where: UserWhereUniqueInput;
  update: UserUpdateWithoutTableDataInput;
  create: UserCreateWithoutTableInput;
}

export interface UserUpsertWithWhereUniqueWithoutTableSessionsInput {
  where: UserWhereUniqueInput;
  update: UserUpdateWithoutTableSessionsDataInput;
  create: UserCreateWithoutTableSessionsInput;
}

export interface UserUpsertWithWhereUniqueWithoutVenuesInput {
  where: UserWhereUniqueInput;
  update: UserUpdateWithoutVenuesDataInput;
  create: UserCreateWithoutVenuesInput;
}

export interface UserUpsertWithoutCommentsInput {
  update: UserUpdateWithoutCommentsDataInput;
  create: UserCreateWithoutCommentsInput;
}

export interface UserUpsertWithoutCreditBankInput {
  update: UserUpdateWithoutCreditBankDataInput;
  create: UserCreateWithoutCreditBankInput;
}

export interface UserUpsertWithoutLocationsInput {
  update: UserUpdateWithoutLocationsDataInput;
  create: UserCreateWithoutLocationsInput;
}

export interface UserUpsertWithoutMembershipAssignmentsInput {
  update: UserUpdateWithoutMembershipAssignmentsDataInput;
  create: UserCreateWithoutMembershipAssignmentsInput;
}

export interface UserUpsertWithoutMembershipCardInput {
  update: UserUpdateWithoutMembershipCardDataInput;
  create: UserCreateWithoutMembershipCardInput;
}

export interface UserUpsertWithoutMembershipTradeinsInput {
  update: UserUpdateWithoutMembershipTradeinsDataInput;
  create: UserCreateWithoutMembershipTradeinsInput;
}

export interface UserUpsertWithoutOrdersInput {
  update: UserUpdateWithoutOrdersDataInput;
  create: UserCreateWithoutOrdersInput;
}

export interface UserUpsertWithoutPaymentsInput {
  update: UserUpdateWithoutPaymentsDataInput;
  create: UserCreateWithoutPaymentsInput;
}

export interface UserUpsertWithoutReceiptPointsScansInput {
  update: UserUpdateWithoutReceiptPointsScansDataInput;
  create: UserCreateWithoutReceiptPointsScansInput;
}

export interface UserUpsertWithoutRecommendationsInput {
  update: UserUpdateWithoutRecommendationsDataInput;
  create: UserCreateWithoutRecommendationsInput;
}

export interface UserUpsertWithoutReferalInput {
  update: UserUpdateWithoutReferalDataInput;
  create: UserCreateWithoutReferalInput;
}

export interface UserUpsertWithoutReferralsInput {
  update: UserUpdateWithoutReferralsDataInput;
  create: UserCreateWithoutReferralsInput;
}

export interface UserUpsertWithoutReservationsInput {
  update: UserUpdateWithoutReservationsDataInput;
  create: UserCreateWithoutReservationsInput;
}

export interface UserUpsertWithoutSentNotificationsInput {
  update: UserUpdateWithoutSentNotificationsDataInput;
  create: UserCreateWithoutSentNotificationsInput;
}

export interface UserUpsertWithoutStampsInput {
  update: UserUpdateWithoutStampsDataInput;
  create: UserCreateWithoutStampsInput;
}

export interface UserUpsertWithoutTablePaymentSettingsHistoryInput {
  update: UserUpdateWithoutTablePaymentSettingsHistoryDataInput;
  create: UserCreateWithoutTablePaymentSettingsHistoryInput;
}

export interface UserUpsertWithoutTablePaymentSettingsInput {
  update: UserUpdateWithoutTablePaymentSettingsDataInput;
  create: UserCreateWithoutTablePaymentSettingsInput;
}

export interface UserUpsertWithoutTokensInput {
  update: UserUpdateWithoutTokensDataInput;
  create: UserCreateWithoutTokensInput;
}

export interface UserUpsertWithoutWrittenCommentsInput {
  update: UserUpdateWithoutWrittenCommentsDataInput;
  create: UserCreateWithoutWrittenCommentsInput;
}

export interface UserWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  creditBank?: CreditBankWhereInput ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  image?: string ;
  image_not?: string ;
  image_in?: string[] ;
  image_not_in?: string[] ;
  image_lt?: string ;
  image_lte?: string ;
  image_gt?: string ;
  image_gte?: string ;
  image_contains?: string ;
  image_not_contains?: string ;
  image_starts_with?: string ;
  image_not_starts_with?: string ;
  image_ends_with?: string ;
  image_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  venueLimited?: boolean ;
  venueLimited_not?: boolean ;
  offers_every?: OfferWhereInput ;
  offers_some?: OfferWhereInput ;
  offers_none?: OfferWhereInput ;
  orders_every?: OrderWhereInput ;
  orders_some?: OrderWhereInput ;
  orders_none?: OrderWhereInput ;
  payments_every?: PaymentWhereInput ;
  payments_some?: PaymentWhereInput ;
  payments_none?: PaymentWhereInput ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  language?: string ;
  language_not?: string ;
  language_in?: string[] ;
  language_not_in?: string[] ;
  language_lt?: string ;
  language_lte?: string ;
  language_gt?: string ;
  language_gte?: string ;
  language_contains?: string ;
  language_not_contains?: string ;
  language_starts_with?: string ;
  language_not_starts_with?: string ;
  language_ends_with?: string ;
  language_not_ends_with?: string ;
  company?: CompanyWhereInput ;
  devices_every?: DeviceWhereInput ;
  devices_some?: DeviceWhereInput ;
  devices_none?: DeviceWhereInput ;
  stampCards_every?: StampCardWhereInput ;
  stampCards_some?: StampCardWhereInput ;
  stampCards_none?: StampCardWhereInput ;
  stamps_every?: StampWhereInput ;
  stamps_some?: StampWhereInput ;
  stamps_none?: StampWhereInput ;
  tokens_every?: OfferTokenWhereInput ;
  tokens_some?: OfferTokenWhereInput ;
  tokens_none?: OfferTokenWhereInput ;
  venues_every?: VenueWhereInput ;
  venues_some?: VenueWhereInput ;
  venues_none?: VenueWhereInput ;
  locations_every?: LocationWhereInput ;
  locations_some?: LocationWhereInput ;
  locations_none?: LocationWhereInput ;
  creditCards_every?: CreditCardWhereInput ;
  creditCards_some?: CreditCardWhereInput ;
  creditCards_none?: CreditCardWhereInput ;
  recommendations_every?: RecommendationWhereInput ;
  recommendations_some?: RecommendationWhereInput ;
  recommendations_none?: RecommendationWhereInput ;
  membershipLevel?: MembershipLevelWhereInput ;
  membershipCard?: MembershipCardWhereInput ;
  facebookId?: string ;
  facebookId_not?: string ;
  facebookId_in?: string[] ;
  facebookId_not_in?: string[] ;
  facebookId_lt?: string ;
  facebookId_lte?: string ;
  facebookId_gt?: string ;
  facebookId_gte?: string ;
  facebookId_contains?: string ;
  facebookId_not_contains?: string ;
  facebookId_starts_with?: string ;
  facebookId_not_starts_with?: string ;
  facebookId_ends_with?: string ;
  facebookId_not_ends_with?: string ;
  promoCodes_every?: PromoCodeWhereInput ;
  promoCodes_some?: PromoCodeWhereInput ;
  promoCodes_none?: PromoCodeWhereInput ;
  email?: string ;
  email_not?: string ;
  email_in?: string[] ;
  email_not_in?: string[] ;
  email_lt?: string ;
  email_lte?: string ;
  email_gt?: string ;
  email_gte?: string ;
  email_contains?: string ;
  email_not_contains?: string ;
  email_starts_with?: string ;
  email_not_starts_with?: string ;
  email_ends_with?: string ;
  email_not_ends_with?: string ;
  notifications_every?: NotificationWhereInput ;
  notifications_some?: NotificationWhereInput ;
  notifications_none?: NotificationWhereInput ;
  sentNotifications_every?: SentNotificationWhereInput ;
  sentNotifications_some?: SentNotificationWhereInput ;
  sentNotifications_none?: SentNotificationWhereInput ;
  password?: string ;
  password_not?: string ;
  password_in?: string[] ;
  password_not_in?: string[] ;
  password_lt?: string ;
  password_lte?: string ;
  password_gt?: string ;
  password_gte?: string ;
  password_contains?: string ;
  password_not_contains?: string ;
  password_starts_with?: string ;
  password_not_starts_with?: string ;
  password_ends_with?: string ;
  password_not_ends_with?: string ;
  referralCode?: string ;
  referralCode_not?: string ;
  referralCode_in?: string[] ;
  referralCode_not_in?: string[] ;
  referralCode_lt?: string ;
  referralCode_lte?: string ;
  referralCode_gt?: string ;
  referralCode_gte?: string ;
  referralCode_contains?: string ;
  referralCode_not_contains?: string ;
  referralCode_starts_with?: string ;
  referralCode_not_starts_with?: string ;
  referralCode_ends_with?: string ;
  referralCode_not_ends_with?: string ;
  referal?: UserReferralWhereInput ;
  referrals_every?: UserReferralWhereInput ;
  referrals_some?: UserReferralWhereInput ;
  referrals_none?: UserReferralWhereInput ;
  phone?: string ;
  phone_not?: string ;
  phone_in?: string[] ;
  phone_not_in?: string[] ;
  phone_lt?: string ;
  phone_lte?: string ;
  phone_gt?: string ;
  phone_gte?: string ;
  phone_contains?: string ;
  phone_not_contains?: string ;
  phone_starts_with?: string ;
  phone_not_starts_with?: string ;
  phone_ends_with?: string ;
  phone_not_ends_with?: string ;
  events_every?: EventWhereInput ;
  events_some?: EventWhereInput ;
  events_none?: EventWhereInput ;
  logs_every?: LogWhereInput ;
  logs_some?: LogWhereInput ;
  logs_none?: LogWhereInput ;
  role?: ROLE ;
  role_not?: ROLE ;
  role_in?: ROLE[] ;
  role_not_in?: ROLE[] ;
  segments_every?: UserSegmentWhereInput ;
  segments_some?: UserSegmentWhereInput ;
  segments_none?: UserSegmentWhereInput ;
  previousSegments_every?: UserSegmentWhereInput ;
  previousSegments_some?: UserSegmentWhereInput ;
  previousSegments_none?: UserSegmentWhereInput ;
  activated?: boolean ;
  activated_not?: boolean ;
  blocked?: boolean ;
  blocked_not?: boolean ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  lastLogin?: any ;
  lastLogin_not?: any ;
  lastLogin_in?: any[] ;
  lastLogin_not_in?: any[] ;
  lastLogin_lt?: any ;
  lastLogin_lte?: any ;
  lastLogin_gt?: any ;
  lastLogin_gte?: any ;
  personalNumber?: string ;
  personalNumber_not?: string ;
  personalNumber_in?: string[] ;
  personalNumber_not_in?: string[] ;
  personalNumber_lt?: string ;
  personalNumber_lte?: string ;
  personalNumber_gt?: string ;
  personalNumber_gte?: string ;
  personalNumber_contains?: string ;
  personalNumber_not_contains?: string ;
  personalNumber_starts_with?: string ;
  personalNumber_not_starts_with?: string ;
  personalNumber_ends_with?: string ;
  personalNumber_not_ends_with?: string ;
  ofLegalAge?: boolean ;
  ofLegalAge_not?: boolean ;
  offerYieldEvents_every?: OfferYieldEventWhereInput ;
  offerYieldEvents_some?: OfferYieldEventWhereInput ;
  offerYieldEvents_none?: OfferYieldEventWhereInput ;
  reservations_every?: ReservationWhereInput ;
  reservations_some?: ReservationWhereInput ;
  reservations_none?: ReservationWhereInput ;
  table?: TableWhereInput ;
  tableSessions_every?: TableSessionWhereInput ;
  tableSessions_some?: TableSessionWhereInput ;
  tableSessions_none?: TableSessionWhereInput ;
  tablePaymentSettings?: TablePaymentSettingWhereInput ;
  tablePaymentSettingsHistory_every?: TablePaymentSettingWhereInput ;
  tablePaymentSettingsHistory_some?: TablePaymentSettingWhereInput ;
  tablePaymentSettingsHistory_none?: TablePaymentSettingWhereInput ;
  membershipTradeins_every?: MembershipTradeinWhereInput ;
  membershipTradeins_some?: MembershipTradeinWhereInput ;
  membershipTradeins_none?: MembershipTradeinWhereInput ;
  membershipAssignments_every?: MembershipAssignmentWhereInput ;
  membershipAssignments_some?: MembershipAssignmentWhereInput ;
  membershipAssignments_none?: MembershipAssignmentWhereInput ;
  username?: string ;
  username_not?: string ;
  username_in?: string[] ;
  username_not_in?: string[] ;
  username_lt?: string ;
  username_lte?: string ;
  username_gt?: string ;
  username_gte?: string ;
  username_contains?: string ;
  username_not_contains?: string ;
  username_starts_with?: string ;
  username_not_starts_with?: string ;
  username_ends_with?: string ;
  username_not_ends_with?: string ;
  shouldUpdatePassword?: boolean ;
  shouldUpdatePassword_not?: boolean ;
  comments_every?: UserCommentWhereInput ;
  comments_some?: UserCommentWhereInput ;
  comments_none?: UserCommentWhereInput ;
  writtenComments_every?: UserCommentWhereInput ;
  writtenComments_some?: UserCommentWhereInput ;
  writtenComments_none?: UserCommentWhereInput ;
  receiptPointsScans_every?: ReceiptPointsScanWhereInput ;
  receiptPointsScans_some?: ReceiptPointsScanWhereInput ;
  receiptPointsScans_none?: ReceiptPointsScanWhereInput ;
  AND?: UserWhereInput[] ;
  OR?: UserWhereInput[] ;
  NOT?: UserWhereInput[] ;
}

export interface UserWhereUniqueInput {
  id?: string ;
  phone?: string ;
  username?: string ;
}

export interface VariationCreateInput {
  company?: CompanyCreateOneWithoutVariationsInput ;
  id?: string ;
  items?: ItemCreateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryCreateOneWithoutSelectedVariationsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVariationNameInput ;
  orderItems?: OrderItemCreateManyWithoutVariationsInput ;
  removedFrom?: OrderItemCreateManyWithoutRemovedVariationsInput ;
  price: number;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemCreateManyWithoutSizeInput ;
  sizeUses?: ItemSizeCreateManyWithoutVariationsInput ;
  defaultOnItems?: ItemCreateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutVariationInput ;
  recommendations?: RecommendationCreateManyWithoutVariationsInput ;
  articleMap?: ArticleMapCreateOneWithoutVariationInput ;
  group?: VariationGroupCreateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupCreateManyWithoutPreselectedVariationsInput ;
  image?: ImageCreateOneWithoutVariationsInput ;
  asItem?: ItemCreateOneInput ;
  tags?: VariationCreatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationCreateManyWithoutCompanyInput {
  create?: VariationCreateWithoutCompanyInput[] ;
  connect?: VariationWhereUniqueInput[] ;
}

export interface VariationCreateManyWithoutDefaultOnItemsInput {
  create?: VariationCreateWithoutDefaultOnItemsInput[] ;
  connect?: VariationWhereUniqueInput[] ;
}

export interface VariationCreateManyWithoutGroupInput {
  create?: VariationCreateWithoutGroupInput[] ;
  connect?: VariationWhereUniqueInput[] ;
}

export interface VariationCreateManyWithoutImageInput {
  create?: VariationCreateWithoutImageInput[] ;
  connect?: VariationWhereUniqueInput[] ;
}

export interface VariationCreateManyWithoutItemsInput {
  create?: VariationCreateWithoutItemsInput[] ;
  connect?: VariationWhereUniqueInput[] ;
}

export interface VariationCreateManyWithoutMenuEntryInput {
  create?: VariationCreateWithoutMenuEntryInput[] ;
  connect?: VariationWhereUniqueInput[] ;
}

export interface VariationCreateManyWithoutOrderItemsInput {
  create?: VariationCreateWithoutOrderItemsInput[] ;
  connect?: VariationWhereUniqueInput[] ;
}

export interface VariationCreateManyWithoutPreselectedOnGroupsInput {
  create?: VariationCreateWithoutPreselectedOnGroupsInput[] ;
  connect?: VariationWhereUniqueInput[] ;
}

export interface VariationCreateManyWithoutRecommendationsInput {
  create?: VariationCreateWithoutRecommendationsInput[] ;
  connect?: VariationWhereUniqueInput[] ;
}

export interface VariationCreateManyWithoutRemovedFromInput {
  create?: VariationCreateWithoutRemovedFromInput[] ;
  connect?: VariationWhereUniqueInput[] ;
}

export interface VariationCreateManyWithoutSizeUsesInput {
  create?: VariationCreateWithoutSizeUsesInput[] ;
  connect?: VariationWhereUniqueInput[] ;
}

export interface VariationCreateOneWithoutAppliedVariationsInput {
  create?: VariationCreateWithoutAppliedVariationsInput ;
  connect?: VariationWhereUniqueInput ;
}

export interface VariationCreateOneWithoutArticleMapInput {
  create?: VariationCreateWithoutArticleMapInput ;
  connect?: VariationWhereUniqueInput ;
}

export interface VariationCreateOneWithoutNameLangInput {
  create?: VariationCreateWithoutNameLangInput ;
  connect?: VariationWhereUniqueInput ;
}

export interface VariationCreateOneWithoutOrderItemSizesInput {
  create?: VariationCreateWithoutOrderItemSizesInput ;
  connect?: VariationWhereUniqueInput ;
}

export interface VariationCreateWithoutAppliedVariationsInput {
  company?: CompanyCreateOneWithoutVariationsInput ;
  id?: string ;
  items?: ItemCreateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryCreateOneWithoutSelectedVariationsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVariationNameInput ;
  orderItems?: OrderItemCreateManyWithoutVariationsInput ;
  removedFrom?: OrderItemCreateManyWithoutRemovedVariationsInput ;
  price: number;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemCreateManyWithoutSizeInput ;
  sizeUses?: ItemSizeCreateManyWithoutVariationsInput ;
  defaultOnItems?: ItemCreateManyWithoutDefaultVariationsInput ;
  recommendations?: RecommendationCreateManyWithoutVariationsInput ;
  articleMap?: ArticleMapCreateOneWithoutVariationInput ;
  group?: VariationGroupCreateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupCreateManyWithoutPreselectedVariationsInput ;
  image?: ImageCreateOneWithoutVariationsInput ;
  asItem?: ItemCreateOneInput ;
  tags?: VariationCreatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationCreateWithoutArticleMapInput {
  company?: CompanyCreateOneWithoutVariationsInput ;
  id?: string ;
  items?: ItemCreateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryCreateOneWithoutSelectedVariationsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVariationNameInput ;
  orderItems?: OrderItemCreateManyWithoutVariationsInput ;
  removedFrom?: OrderItemCreateManyWithoutRemovedVariationsInput ;
  price: number;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemCreateManyWithoutSizeInput ;
  sizeUses?: ItemSizeCreateManyWithoutVariationsInput ;
  defaultOnItems?: ItemCreateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutVariationInput ;
  recommendations?: RecommendationCreateManyWithoutVariationsInput ;
  group?: VariationGroupCreateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupCreateManyWithoutPreselectedVariationsInput ;
  image?: ImageCreateOneWithoutVariationsInput ;
  asItem?: ItemCreateOneInput ;
  tags?: VariationCreatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationCreateWithoutCompanyInput {
  id?: string ;
  items?: ItemCreateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryCreateOneWithoutSelectedVariationsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVariationNameInput ;
  orderItems?: OrderItemCreateManyWithoutVariationsInput ;
  removedFrom?: OrderItemCreateManyWithoutRemovedVariationsInput ;
  price: number;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemCreateManyWithoutSizeInput ;
  sizeUses?: ItemSizeCreateManyWithoutVariationsInput ;
  defaultOnItems?: ItemCreateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutVariationInput ;
  recommendations?: RecommendationCreateManyWithoutVariationsInput ;
  articleMap?: ArticleMapCreateOneWithoutVariationInput ;
  group?: VariationGroupCreateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupCreateManyWithoutPreselectedVariationsInput ;
  image?: ImageCreateOneWithoutVariationsInput ;
  asItem?: ItemCreateOneInput ;
  tags?: VariationCreatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationCreateWithoutDefaultOnItemsInput {
  company?: CompanyCreateOneWithoutVariationsInput ;
  id?: string ;
  items?: ItemCreateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryCreateOneWithoutSelectedVariationsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVariationNameInput ;
  orderItems?: OrderItemCreateManyWithoutVariationsInput ;
  removedFrom?: OrderItemCreateManyWithoutRemovedVariationsInput ;
  price: number;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemCreateManyWithoutSizeInput ;
  sizeUses?: ItemSizeCreateManyWithoutVariationsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutVariationInput ;
  recommendations?: RecommendationCreateManyWithoutVariationsInput ;
  articleMap?: ArticleMapCreateOneWithoutVariationInput ;
  group?: VariationGroupCreateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupCreateManyWithoutPreselectedVariationsInput ;
  image?: ImageCreateOneWithoutVariationsInput ;
  asItem?: ItemCreateOneInput ;
  tags?: VariationCreatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationCreateWithoutGroupInput {
  company?: CompanyCreateOneWithoutVariationsInput ;
  id?: string ;
  items?: ItemCreateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryCreateOneWithoutSelectedVariationsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVariationNameInput ;
  orderItems?: OrderItemCreateManyWithoutVariationsInput ;
  removedFrom?: OrderItemCreateManyWithoutRemovedVariationsInput ;
  price: number;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemCreateManyWithoutSizeInput ;
  sizeUses?: ItemSizeCreateManyWithoutVariationsInput ;
  defaultOnItems?: ItemCreateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutVariationInput ;
  recommendations?: RecommendationCreateManyWithoutVariationsInput ;
  articleMap?: ArticleMapCreateOneWithoutVariationInput ;
  preselectedOnGroups?: VariationGroupCreateManyWithoutPreselectedVariationsInput ;
  image?: ImageCreateOneWithoutVariationsInput ;
  asItem?: ItemCreateOneInput ;
  tags?: VariationCreatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationCreateWithoutImageInput {
  company?: CompanyCreateOneWithoutVariationsInput ;
  id?: string ;
  items?: ItemCreateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryCreateOneWithoutSelectedVariationsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVariationNameInput ;
  orderItems?: OrderItemCreateManyWithoutVariationsInput ;
  removedFrom?: OrderItemCreateManyWithoutRemovedVariationsInput ;
  price: number;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemCreateManyWithoutSizeInput ;
  sizeUses?: ItemSizeCreateManyWithoutVariationsInput ;
  defaultOnItems?: ItemCreateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutVariationInput ;
  recommendations?: RecommendationCreateManyWithoutVariationsInput ;
  articleMap?: ArticleMapCreateOneWithoutVariationInput ;
  group?: VariationGroupCreateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupCreateManyWithoutPreselectedVariationsInput ;
  asItem?: ItemCreateOneInput ;
  tags?: VariationCreatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationCreateWithoutItemsInput {
  company?: CompanyCreateOneWithoutVariationsInput ;
  id?: string ;
  menuEntry?: MenuEntryCreateOneWithoutSelectedVariationsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVariationNameInput ;
  orderItems?: OrderItemCreateManyWithoutVariationsInput ;
  removedFrom?: OrderItemCreateManyWithoutRemovedVariationsInput ;
  price: number;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemCreateManyWithoutSizeInput ;
  sizeUses?: ItemSizeCreateManyWithoutVariationsInput ;
  defaultOnItems?: ItemCreateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutVariationInput ;
  recommendations?: RecommendationCreateManyWithoutVariationsInput ;
  articleMap?: ArticleMapCreateOneWithoutVariationInput ;
  group?: VariationGroupCreateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupCreateManyWithoutPreselectedVariationsInput ;
  image?: ImageCreateOneWithoutVariationsInput ;
  asItem?: ItemCreateOneInput ;
  tags?: VariationCreatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationCreateWithoutMenuEntryInput {
  company?: CompanyCreateOneWithoutVariationsInput ;
  id?: string ;
  items?: ItemCreateManyWithoutVariationsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVariationNameInput ;
  orderItems?: OrderItemCreateManyWithoutVariationsInput ;
  removedFrom?: OrderItemCreateManyWithoutRemovedVariationsInput ;
  price: number;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemCreateManyWithoutSizeInput ;
  sizeUses?: ItemSizeCreateManyWithoutVariationsInput ;
  defaultOnItems?: ItemCreateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutVariationInput ;
  recommendations?: RecommendationCreateManyWithoutVariationsInput ;
  articleMap?: ArticleMapCreateOneWithoutVariationInput ;
  group?: VariationGroupCreateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupCreateManyWithoutPreselectedVariationsInput ;
  image?: ImageCreateOneWithoutVariationsInput ;
  asItem?: ItemCreateOneInput ;
  tags?: VariationCreatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationCreateWithoutNameLangInput {
  company?: CompanyCreateOneWithoutVariationsInput ;
  id?: string ;
  items?: ItemCreateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryCreateOneWithoutSelectedVariationsInput ;
  name: string;
  orderItems?: OrderItemCreateManyWithoutVariationsInput ;
  removedFrom?: OrderItemCreateManyWithoutRemovedVariationsInput ;
  price: number;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemCreateManyWithoutSizeInput ;
  sizeUses?: ItemSizeCreateManyWithoutVariationsInput ;
  defaultOnItems?: ItemCreateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutVariationInput ;
  recommendations?: RecommendationCreateManyWithoutVariationsInput ;
  articleMap?: ArticleMapCreateOneWithoutVariationInput ;
  group?: VariationGroupCreateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupCreateManyWithoutPreselectedVariationsInput ;
  image?: ImageCreateOneWithoutVariationsInput ;
  asItem?: ItemCreateOneInput ;
  tags?: VariationCreatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationCreateWithoutOrderItemSizesInput {
  company?: CompanyCreateOneWithoutVariationsInput ;
  id?: string ;
  items?: ItemCreateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryCreateOneWithoutSelectedVariationsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVariationNameInput ;
  orderItems?: OrderItemCreateManyWithoutVariationsInput ;
  removedFrom?: OrderItemCreateManyWithoutRemovedVariationsInput ;
  price: number;
  absolutePrice?: boolean ;
  sizeUses?: ItemSizeCreateManyWithoutVariationsInput ;
  defaultOnItems?: ItemCreateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutVariationInput ;
  recommendations?: RecommendationCreateManyWithoutVariationsInput ;
  articleMap?: ArticleMapCreateOneWithoutVariationInput ;
  group?: VariationGroupCreateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupCreateManyWithoutPreselectedVariationsInput ;
  image?: ImageCreateOneWithoutVariationsInput ;
  asItem?: ItemCreateOneInput ;
  tags?: VariationCreatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationCreateWithoutOrderItemsInput {
  company?: CompanyCreateOneWithoutVariationsInput ;
  id?: string ;
  items?: ItemCreateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryCreateOneWithoutSelectedVariationsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVariationNameInput ;
  removedFrom?: OrderItemCreateManyWithoutRemovedVariationsInput ;
  price: number;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemCreateManyWithoutSizeInput ;
  sizeUses?: ItemSizeCreateManyWithoutVariationsInput ;
  defaultOnItems?: ItemCreateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutVariationInput ;
  recommendations?: RecommendationCreateManyWithoutVariationsInput ;
  articleMap?: ArticleMapCreateOneWithoutVariationInput ;
  group?: VariationGroupCreateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupCreateManyWithoutPreselectedVariationsInput ;
  image?: ImageCreateOneWithoutVariationsInput ;
  asItem?: ItemCreateOneInput ;
  tags?: VariationCreatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationCreateWithoutPreselectedOnGroupsInput {
  company?: CompanyCreateOneWithoutVariationsInput ;
  id?: string ;
  items?: ItemCreateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryCreateOneWithoutSelectedVariationsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVariationNameInput ;
  orderItems?: OrderItemCreateManyWithoutVariationsInput ;
  removedFrom?: OrderItemCreateManyWithoutRemovedVariationsInput ;
  price: number;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemCreateManyWithoutSizeInput ;
  sizeUses?: ItemSizeCreateManyWithoutVariationsInput ;
  defaultOnItems?: ItemCreateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutVariationInput ;
  recommendations?: RecommendationCreateManyWithoutVariationsInput ;
  articleMap?: ArticleMapCreateOneWithoutVariationInput ;
  group?: VariationGroupCreateManyWithoutVariationsInput ;
  image?: ImageCreateOneWithoutVariationsInput ;
  asItem?: ItemCreateOneInput ;
  tags?: VariationCreatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationCreateWithoutRecommendationsInput {
  company?: CompanyCreateOneWithoutVariationsInput ;
  id?: string ;
  items?: ItemCreateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryCreateOneWithoutSelectedVariationsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVariationNameInput ;
  orderItems?: OrderItemCreateManyWithoutVariationsInput ;
  removedFrom?: OrderItemCreateManyWithoutRemovedVariationsInput ;
  price: number;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemCreateManyWithoutSizeInput ;
  sizeUses?: ItemSizeCreateManyWithoutVariationsInput ;
  defaultOnItems?: ItemCreateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutVariationInput ;
  articleMap?: ArticleMapCreateOneWithoutVariationInput ;
  group?: VariationGroupCreateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupCreateManyWithoutPreselectedVariationsInput ;
  image?: ImageCreateOneWithoutVariationsInput ;
  asItem?: ItemCreateOneInput ;
  tags?: VariationCreatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationCreateWithoutRemovedFromInput {
  company?: CompanyCreateOneWithoutVariationsInput ;
  id?: string ;
  items?: ItemCreateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryCreateOneWithoutSelectedVariationsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVariationNameInput ;
  orderItems?: OrderItemCreateManyWithoutVariationsInput ;
  price: number;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemCreateManyWithoutSizeInput ;
  sizeUses?: ItemSizeCreateManyWithoutVariationsInput ;
  defaultOnItems?: ItemCreateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutVariationInput ;
  recommendations?: RecommendationCreateManyWithoutVariationsInput ;
  articleMap?: ArticleMapCreateOneWithoutVariationInput ;
  group?: VariationGroupCreateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupCreateManyWithoutPreselectedVariationsInput ;
  image?: ImageCreateOneWithoutVariationsInput ;
  asItem?: ItemCreateOneInput ;
  tags?: VariationCreatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationCreateWithoutSizeUsesInput {
  company?: CompanyCreateOneWithoutVariationsInput ;
  id?: string ;
  items?: ItemCreateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryCreateOneWithoutSelectedVariationsInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVariationNameInput ;
  orderItems?: OrderItemCreateManyWithoutVariationsInput ;
  removedFrom?: OrderItemCreateManyWithoutRemovedVariationsInput ;
  price: number;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemCreateManyWithoutSizeInput ;
  defaultOnItems?: ItemCreateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationCreateManyWithoutVariationInput ;
  recommendations?: RecommendationCreateManyWithoutVariationsInput ;
  articleMap?: ArticleMapCreateOneWithoutVariationInput ;
  group?: VariationGroupCreateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupCreateManyWithoutPreselectedVariationsInput ;
  image?: ImageCreateOneWithoutVariationsInput ;
  asItem?: ItemCreateOneInput ;
  tags?: VariationCreatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationCreatetagsInput {
  set?: string[] ;
}

export interface VariationGroupCreateInput {
  id?: string ;
  company: CompanyCreateOneWithoutVariationGroupsInput;
  title?: TranslatedStringCreateOneWithoutVariationGroupNameInput ;
  type: VARIATION_TYPE;
  variationClass?: VARIATION_CLASS ;
  limitMin?: number ;
  limitMax?: number ;
  required?: boolean ;
  variations?: VariationCreateManyWithoutGroupInput ;
  preselectedVariations?: VariationCreateManyWithoutPreselectedOnGroupsInput ;
  applications?: AppliedVariationCreateManyWithoutGroupInput ;
  deleted?: boolean ;
  order?: number ;
}

export interface VariationGroupCreateManyWithoutCompanyInput {
  create?: VariationGroupCreateWithoutCompanyInput[] ;
  connect?: VariationGroupWhereUniqueInput[] ;
}

export interface VariationGroupCreateManyWithoutPreselectedVariationsInput {
  create?: VariationGroupCreateWithoutPreselectedVariationsInput[] ;
  connect?: VariationGroupWhereUniqueInput[] ;
}

export interface VariationGroupCreateManyWithoutVariationsInput {
  create?: VariationGroupCreateWithoutVariationsInput[] ;
  connect?: VariationGroupWhereUniqueInput[] ;
}

export interface VariationGroupCreateOneWithoutApplicationsInput {
  create?: VariationGroupCreateWithoutApplicationsInput ;
  connect?: VariationGroupWhereUniqueInput ;
}

export interface VariationGroupCreateOneWithoutTitleInput {
  create?: VariationGroupCreateWithoutTitleInput ;
  connect?: VariationGroupWhereUniqueInput ;
}

export interface VariationGroupCreateWithoutApplicationsInput {
  id?: string ;
  company: CompanyCreateOneWithoutVariationGroupsInput;
  title?: TranslatedStringCreateOneWithoutVariationGroupNameInput ;
  type: VARIATION_TYPE;
  variationClass?: VARIATION_CLASS ;
  limitMin?: number ;
  limitMax?: number ;
  required?: boolean ;
  variations?: VariationCreateManyWithoutGroupInput ;
  preselectedVariations?: VariationCreateManyWithoutPreselectedOnGroupsInput ;
  deleted?: boolean ;
  order?: number ;
}

export interface VariationGroupCreateWithoutCompanyInput {
  id?: string ;
  title?: TranslatedStringCreateOneWithoutVariationGroupNameInput ;
  type: VARIATION_TYPE;
  variationClass?: VARIATION_CLASS ;
  limitMin?: number ;
  limitMax?: number ;
  required?: boolean ;
  variations?: VariationCreateManyWithoutGroupInput ;
  preselectedVariations?: VariationCreateManyWithoutPreselectedOnGroupsInput ;
  applications?: AppliedVariationCreateManyWithoutGroupInput ;
  deleted?: boolean ;
  order?: number ;
}

export interface VariationGroupCreateWithoutPreselectedVariationsInput {
  id?: string ;
  company: CompanyCreateOneWithoutVariationGroupsInput;
  title?: TranslatedStringCreateOneWithoutVariationGroupNameInput ;
  type: VARIATION_TYPE;
  variationClass?: VARIATION_CLASS ;
  limitMin?: number ;
  limitMax?: number ;
  required?: boolean ;
  variations?: VariationCreateManyWithoutGroupInput ;
  applications?: AppliedVariationCreateManyWithoutGroupInput ;
  deleted?: boolean ;
  order?: number ;
}

export interface VariationGroupCreateWithoutTitleInput {
  id?: string ;
  company: CompanyCreateOneWithoutVariationGroupsInput;
  type: VARIATION_TYPE;
  variationClass?: VARIATION_CLASS ;
  limitMin?: number ;
  limitMax?: number ;
  required?: boolean ;
  variations?: VariationCreateManyWithoutGroupInput ;
  preselectedVariations?: VariationCreateManyWithoutPreselectedOnGroupsInput ;
  applications?: AppliedVariationCreateManyWithoutGroupInput ;
  deleted?: boolean ;
  order?: number ;
}

export interface VariationGroupCreateWithoutVariationsInput {
  id?: string ;
  company: CompanyCreateOneWithoutVariationGroupsInput;
  title?: TranslatedStringCreateOneWithoutVariationGroupNameInput ;
  type: VARIATION_TYPE;
  variationClass?: VARIATION_CLASS ;
  limitMin?: number ;
  limitMax?: number ;
  required?: boolean ;
  preselectedVariations?: VariationCreateManyWithoutPreselectedOnGroupsInput ;
  applications?: AppliedVariationCreateManyWithoutGroupInput ;
  deleted?: boolean ;
  order?: number ;
}

export interface VariationGroupScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  type?: VARIATION_TYPE ;
  type_not?: VARIATION_TYPE ;
  type_in?: VARIATION_TYPE[] ;
  type_not_in?: VARIATION_TYPE[] ;
  variationClass?: VARIATION_CLASS ;
  variationClass_not?: VARIATION_CLASS ;
  variationClass_in?: VARIATION_CLASS[] ;
  variationClass_not_in?: VARIATION_CLASS[] ;
  limitMin?: number ;
  limitMin_not?: number ;
  limitMin_in?: number[] ;
  limitMin_not_in?: number[] ;
  limitMin_lt?: number ;
  limitMin_lte?: number ;
  limitMin_gt?: number ;
  limitMin_gte?: number ;
  limitMax?: number ;
  limitMax_not?: number ;
  limitMax_in?: number[] ;
  limitMax_not_in?: number[] ;
  limitMax_lt?: number ;
  limitMax_lte?: number ;
  limitMax_gt?: number ;
  limitMax_gte?: number ;
  required?: boolean ;
  required_not?: boolean ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  order?: number ;
  order_not?: number ;
  order_in?: number[] ;
  order_not_in?: number[] ;
  order_lt?: number ;
  order_lte?: number ;
  order_gt?: number ;
  order_gte?: number ;
  AND?: VariationGroupScalarWhereInput[] ;
  OR?: VariationGroupScalarWhereInput[] ;
  NOT?: VariationGroupScalarWhereInput[] ;
}

export interface VariationGroupUpdateInput {
  company?: CompanyUpdateOneRequiredWithoutVariationGroupsInput ;
  title?: TranslatedStringUpdateOneWithoutVariationGroupNameInput ;
  type?: VARIATION_TYPE ;
  variationClass?: VARIATION_CLASS ;
  limitMin?: number ;
  limitMax?: number ;
  required?: boolean ;
  variations?: VariationUpdateManyWithoutGroupInput ;
  preselectedVariations?: VariationUpdateManyWithoutPreselectedOnGroupsInput ;
  applications?: AppliedVariationUpdateManyWithoutGroupInput ;
  deleted?: boolean ;
  order?: number ;
}

export interface VariationGroupUpdateManyDataInput {
  type?: VARIATION_TYPE ;
  variationClass?: VARIATION_CLASS ;
  limitMin?: number ;
  limitMax?: number ;
  required?: boolean ;
  deleted?: boolean ;
  order?: number ;
}

export interface VariationGroupUpdateManyWithWhereNestedInput {
  where: VariationGroupScalarWhereInput;
  data: VariationGroupUpdateManyDataInput;
}

export interface VariationGroupUpdateManyWithoutCompanyInput {
  create?: VariationGroupCreateWithoutCompanyInput[] ;
  connect?: VariationGroupWhereUniqueInput[] ;
  set?: VariationGroupWhereUniqueInput[] ;
  disconnect?: VariationGroupWhereUniqueInput[] ;
  update?: VariationGroupUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: VariationGroupUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: VariationGroupScalarWhereInput[] ;
  updateMany?: VariationGroupUpdateManyWithWhereNestedInput[] ;
}

export interface VariationGroupUpdateManyWithoutPreselectedVariationsInput {
  create?: VariationGroupCreateWithoutPreselectedVariationsInput[] ;
  connect?: VariationGroupWhereUniqueInput[] ;
  set?: VariationGroupWhereUniqueInput[] ;
  disconnect?: VariationGroupWhereUniqueInput[] ;
  update?: VariationGroupUpdateWithWhereUniqueWithoutPreselectedVariationsInput[] ;
  upsert?: VariationGroupUpsertWithWhereUniqueWithoutPreselectedVariationsInput[] ;
  deleteMany?: VariationGroupScalarWhereInput[] ;
  updateMany?: VariationGroupUpdateManyWithWhereNestedInput[] ;
}

export interface VariationGroupUpdateManyWithoutVariationsInput {
  create?: VariationGroupCreateWithoutVariationsInput[] ;
  connect?: VariationGroupWhereUniqueInput[] ;
  set?: VariationGroupWhereUniqueInput[] ;
  disconnect?: VariationGroupWhereUniqueInput[] ;
  update?: VariationGroupUpdateWithWhereUniqueWithoutVariationsInput[] ;
  upsert?: VariationGroupUpsertWithWhereUniqueWithoutVariationsInput[] ;
  deleteMany?: VariationGroupScalarWhereInput[] ;
  updateMany?: VariationGroupUpdateManyWithWhereNestedInput[] ;
}

export interface VariationGroupUpdateOneWithoutApplicationsInput {
  create?: VariationGroupCreateWithoutApplicationsInput ;
  update?: VariationGroupUpdateWithoutApplicationsDataInput ;
  upsert?: VariationGroupUpsertWithoutApplicationsInput ;
  disconnect?: boolean ;
  connect?: VariationGroupWhereUniqueInput ;
}

export interface VariationGroupUpdateOneWithoutTitleInput {
  create?: VariationGroupCreateWithoutTitleInput ;
  update?: VariationGroupUpdateWithoutTitleDataInput ;
  upsert?: VariationGroupUpsertWithoutTitleInput ;
  disconnect?: boolean ;
  connect?: VariationGroupWhereUniqueInput ;
}

export interface VariationGroupUpdateWithWhereUniqueWithoutCompanyInput {
  where: VariationGroupWhereUniqueInput;
  data: VariationGroupUpdateWithoutCompanyDataInput;
}

export interface VariationGroupUpdateWithWhereUniqueWithoutPreselectedVariationsInput {
  where: VariationGroupWhereUniqueInput;
  data: VariationGroupUpdateWithoutPreselectedVariationsDataInput;
}

export interface VariationGroupUpdateWithWhereUniqueWithoutVariationsInput {
  where: VariationGroupWhereUniqueInput;
  data: VariationGroupUpdateWithoutVariationsDataInput;
}

export interface VariationGroupUpdateWithoutApplicationsDataInput {
  company?: CompanyUpdateOneRequiredWithoutVariationGroupsInput ;
  title?: TranslatedStringUpdateOneWithoutVariationGroupNameInput ;
  type?: VARIATION_TYPE ;
  variationClass?: VARIATION_CLASS ;
  limitMin?: number ;
  limitMax?: number ;
  required?: boolean ;
  variations?: VariationUpdateManyWithoutGroupInput ;
  preselectedVariations?: VariationUpdateManyWithoutPreselectedOnGroupsInput ;
  deleted?: boolean ;
  order?: number ;
}

export interface VariationGroupUpdateWithoutCompanyDataInput {
  title?: TranslatedStringUpdateOneWithoutVariationGroupNameInput ;
  type?: VARIATION_TYPE ;
  variationClass?: VARIATION_CLASS ;
  limitMin?: number ;
  limitMax?: number ;
  required?: boolean ;
  variations?: VariationUpdateManyWithoutGroupInput ;
  preselectedVariations?: VariationUpdateManyWithoutPreselectedOnGroupsInput ;
  applications?: AppliedVariationUpdateManyWithoutGroupInput ;
  deleted?: boolean ;
  order?: number ;
}

export interface VariationGroupUpdateWithoutPreselectedVariationsDataInput {
  company?: CompanyUpdateOneRequiredWithoutVariationGroupsInput ;
  title?: TranslatedStringUpdateOneWithoutVariationGroupNameInput ;
  type?: VARIATION_TYPE ;
  variationClass?: VARIATION_CLASS ;
  limitMin?: number ;
  limitMax?: number ;
  required?: boolean ;
  variations?: VariationUpdateManyWithoutGroupInput ;
  applications?: AppliedVariationUpdateManyWithoutGroupInput ;
  deleted?: boolean ;
  order?: number ;
}

export interface VariationGroupUpdateWithoutTitleDataInput {
  company?: CompanyUpdateOneRequiredWithoutVariationGroupsInput ;
  type?: VARIATION_TYPE ;
  variationClass?: VARIATION_CLASS ;
  limitMin?: number ;
  limitMax?: number ;
  required?: boolean ;
  variations?: VariationUpdateManyWithoutGroupInput ;
  preselectedVariations?: VariationUpdateManyWithoutPreselectedOnGroupsInput ;
  applications?: AppliedVariationUpdateManyWithoutGroupInput ;
  deleted?: boolean ;
  order?: number ;
}

export interface VariationGroupUpdateWithoutVariationsDataInput {
  company?: CompanyUpdateOneRequiredWithoutVariationGroupsInput ;
  title?: TranslatedStringUpdateOneWithoutVariationGroupNameInput ;
  type?: VARIATION_TYPE ;
  variationClass?: VARIATION_CLASS ;
  limitMin?: number ;
  limitMax?: number ;
  required?: boolean ;
  preselectedVariations?: VariationUpdateManyWithoutPreselectedOnGroupsInput ;
  applications?: AppliedVariationUpdateManyWithoutGroupInput ;
  deleted?: boolean ;
  order?: number ;
}

export interface VariationGroupUpsertWithWhereUniqueWithoutCompanyInput {
  where: VariationGroupWhereUniqueInput;
  update: VariationGroupUpdateWithoutCompanyDataInput;
  create: VariationGroupCreateWithoutCompanyInput;
}

export interface VariationGroupUpsertWithWhereUniqueWithoutPreselectedVariationsInput {
  where: VariationGroupWhereUniqueInput;
  update: VariationGroupUpdateWithoutPreselectedVariationsDataInput;
  create: VariationGroupCreateWithoutPreselectedVariationsInput;
}

export interface VariationGroupUpsertWithWhereUniqueWithoutVariationsInput {
  where: VariationGroupWhereUniqueInput;
  update: VariationGroupUpdateWithoutVariationsDataInput;
  create: VariationGroupCreateWithoutVariationsInput;
}

export interface VariationGroupUpsertWithoutApplicationsInput {
  update: VariationGroupUpdateWithoutApplicationsDataInput;
  create: VariationGroupCreateWithoutApplicationsInput;
}

export interface VariationGroupUpsertWithoutTitleInput {
  update: VariationGroupUpdateWithoutTitleDataInput;
  create: VariationGroupCreateWithoutTitleInput;
}

export interface VariationGroupWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  company?: CompanyWhereInput ;
  title?: TranslatedStringWhereInput ;
  type?: VARIATION_TYPE ;
  type_not?: VARIATION_TYPE ;
  type_in?: VARIATION_TYPE[] ;
  type_not_in?: VARIATION_TYPE[] ;
  variationClass?: VARIATION_CLASS ;
  variationClass_not?: VARIATION_CLASS ;
  variationClass_in?: VARIATION_CLASS[] ;
  variationClass_not_in?: VARIATION_CLASS[] ;
  limitMin?: number ;
  limitMin_not?: number ;
  limitMin_in?: number[] ;
  limitMin_not_in?: number[] ;
  limitMin_lt?: number ;
  limitMin_lte?: number ;
  limitMin_gt?: number ;
  limitMin_gte?: number ;
  limitMax?: number ;
  limitMax_not?: number ;
  limitMax_in?: number[] ;
  limitMax_not_in?: number[] ;
  limitMax_lt?: number ;
  limitMax_lte?: number ;
  limitMax_gt?: number ;
  limitMax_gte?: number ;
  required?: boolean ;
  required_not?: boolean ;
  variations_every?: VariationWhereInput ;
  variations_some?: VariationWhereInput ;
  variations_none?: VariationWhereInput ;
  preselectedVariations_every?: VariationWhereInput ;
  preselectedVariations_some?: VariationWhereInput ;
  preselectedVariations_none?: VariationWhereInput ;
  applications_every?: AppliedVariationWhereInput ;
  applications_some?: AppliedVariationWhereInput ;
  applications_none?: AppliedVariationWhereInput ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  order?: number ;
  order_not?: number ;
  order_in?: number[] ;
  order_not_in?: number[] ;
  order_lt?: number ;
  order_lte?: number ;
  order_gt?: number ;
  order_gte?: number ;
  AND?: VariationGroupWhereInput[] ;
  OR?: VariationGroupWhereInput[] ;
  NOT?: VariationGroupWhereInput[] ;
}

export interface VariationGroupWhereUniqueInput {
  id?: string ;
}

export interface VariationScalarWhereInput {
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  price?: number ;
  price_not?: number ;
  price_in?: number[] ;
  price_not_in?: number[] ;
  price_lt?: number ;
  price_lte?: number ;
  price_gt?: number ;
  price_gte?: number ;
  absolutePrice?: boolean ;
  absolutePrice_not?: boolean ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  highlighted?: boolean ;
  highlighted_not?: boolean ;
  allergen?: ALLERGEN ;
  allergen_not?: ALLERGEN ;
  allergen_in?: ALLERGEN[] ;
  allergen_not_in?: ALLERGEN[] ;
  order?: number ;
  order_not?: number ;
  order_in?: number[] ;
  order_not_in?: number[] ;
  order_lt?: number ;
  order_lte?: number ;
  order_gt?: number ;
  order_gte?: number ;
  AND?: VariationScalarWhereInput[] ;
  OR?: VariationScalarWhereInput[] ;
  NOT?: VariationScalarWhereInput[] ;
}

export interface VariationUpdateInput {
  company?: CompanyUpdateOneWithoutVariationsInput ;
  items?: ItemUpdateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryUpdateOneWithoutSelectedVariationsInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVariationNameInput ;
  orderItems?: OrderItemUpdateManyWithoutVariationsInput ;
  removedFrom?: OrderItemUpdateManyWithoutRemovedVariationsInput ;
  price?: number ;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemUpdateManyWithoutSizeInput ;
  sizeUses?: ItemSizeUpdateManyWithoutVariationsInput ;
  defaultOnItems?: ItemUpdateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutVariationInput ;
  recommendations?: RecommendationUpdateManyWithoutVariationsInput ;
  articleMap?: ArticleMapUpdateOneWithoutVariationInput ;
  group?: VariationGroupUpdateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupUpdateManyWithoutPreselectedVariationsInput ;
  image?: ImageUpdateOneWithoutVariationsInput ;
  asItem?: ItemUpdateOneInput ;
  tags?: VariationUpdatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationUpdateManyDataInput {
  name?: string ;
  price?: number ;
  absolutePrice?: boolean ;
  tags?: VariationUpdatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationUpdateManyWithWhereNestedInput {
  where: VariationScalarWhereInput;
  data: VariationUpdateManyDataInput;
}

export interface VariationUpdateManyWithoutCompanyInput {
  create?: VariationCreateWithoutCompanyInput[] ;
  connect?: VariationWhereUniqueInput[] ;
  set?: VariationWhereUniqueInput[] ;
  disconnect?: VariationWhereUniqueInput[] ;
  update?: VariationUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: VariationUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: VariationScalarWhereInput[] ;
  updateMany?: VariationUpdateManyWithWhereNestedInput[] ;
}

export interface VariationUpdateManyWithoutDefaultOnItemsInput {
  create?: VariationCreateWithoutDefaultOnItemsInput[] ;
  connect?: VariationWhereUniqueInput[] ;
  set?: VariationWhereUniqueInput[] ;
  disconnect?: VariationWhereUniqueInput[] ;
  update?: VariationUpdateWithWhereUniqueWithoutDefaultOnItemsInput[] ;
  upsert?: VariationUpsertWithWhereUniqueWithoutDefaultOnItemsInput[] ;
  deleteMany?: VariationScalarWhereInput[] ;
  updateMany?: VariationUpdateManyWithWhereNestedInput[] ;
}

export interface VariationUpdateManyWithoutGroupInput {
  create?: VariationCreateWithoutGroupInput[] ;
  connect?: VariationWhereUniqueInput[] ;
  set?: VariationWhereUniqueInput[] ;
  disconnect?: VariationWhereUniqueInput[] ;
  update?: VariationUpdateWithWhereUniqueWithoutGroupInput[] ;
  upsert?: VariationUpsertWithWhereUniqueWithoutGroupInput[] ;
  deleteMany?: VariationScalarWhereInput[] ;
  updateMany?: VariationUpdateManyWithWhereNestedInput[] ;
}

export interface VariationUpdateManyWithoutImageInput {
  create?: VariationCreateWithoutImageInput[] ;
  connect?: VariationWhereUniqueInput[] ;
  set?: VariationWhereUniqueInput[] ;
  disconnect?: VariationWhereUniqueInput[] ;
  update?: VariationUpdateWithWhereUniqueWithoutImageInput[] ;
  upsert?: VariationUpsertWithWhereUniqueWithoutImageInput[] ;
  deleteMany?: VariationScalarWhereInput[] ;
  updateMany?: VariationUpdateManyWithWhereNestedInput[] ;
}

export interface VariationUpdateManyWithoutItemsInput {
  create?: VariationCreateWithoutItemsInput[] ;
  connect?: VariationWhereUniqueInput[] ;
  set?: VariationWhereUniqueInput[] ;
  disconnect?: VariationWhereUniqueInput[] ;
  update?: VariationUpdateWithWhereUniqueWithoutItemsInput[] ;
  upsert?: VariationUpsertWithWhereUniqueWithoutItemsInput[] ;
  deleteMany?: VariationScalarWhereInput[] ;
  updateMany?: VariationUpdateManyWithWhereNestedInput[] ;
}

export interface VariationUpdateManyWithoutMenuEntryInput {
  create?: VariationCreateWithoutMenuEntryInput[] ;
  connect?: VariationWhereUniqueInput[] ;
  set?: VariationWhereUniqueInput[] ;
  disconnect?: VariationWhereUniqueInput[] ;
  update?: VariationUpdateWithWhereUniqueWithoutMenuEntryInput[] ;
  upsert?: VariationUpsertWithWhereUniqueWithoutMenuEntryInput[] ;
  deleteMany?: VariationScalarWhereInput[] ;
  updateMany?: VariationUpdateManyWithWhereNestedInput[] ;
}

export interface VariationUpdateManyWithoutOrderItemsInput {
  create?: VariationCreateWithoutOrderItemsInput[] ;
  connect?: VariationWhereUniqueInput[] ;
  set?: VariationWhereUniqueInput[] ;
  disconnect?: VariationWhereUniqueInput[] ;
  update?: VariationUpdateWithWhereUniqueWithoutOrderItemsInput[] ;
  upsert?: VariationUpsertWithWhereUniqueWithoutOrderItemsInput[] ;
  deleteMany?: VariationScalarWhereInput[] ;
  updateMany?: VariationUpdateManyWithWhereNestedInput[] ;
}

export interface VariationUpdateManyWithoutPreselectedOnGroupsInput {
  create?: VariationCreateWithoutPreselectedOnGroupsInput[] ;
  connect?: VariationWhereUniqueInput[] ;
  set?: VariationWhereUniqueInput[] ;
  disconnect?: VariationWhereUniqueInput[] ;
  update?: VariationUpdateWithWhereUniqueWithoutPreselectedOnGroupsInput[] ;
  upsert?: VariationUpsertWithWhereUniqueWithoutPreselectedOnGroupsInput[] ;
  deleteMany?: VariationScalarWhereInput[] ;
  updateMany?: VariationUpdateManyWithWhereNestedInput[] ;
}

export interface VariationUpdateManyWithoutRecommendationsInput {
  create?: VariationCreateWithoutRecommendationsInput[] ;
  connect?: VariationWhereUniqueInput[] ;
  set?: VariationWhereUniqueInput[] ;
  disconnect?: VariationWhereUniqueInput[] ;
  update?: VariationUpdateWithWhereUniqueWithoutRecommendationsInput[] ;
  upsert?: VariationUpsertWithWhereUniqueWithoutRecommendationsInput[] ;
  deleteMany?: VariationScalarWhereInput[] ;
  updateMany?: VariationUpdateManyWithWhereNestedInput[] ;
}

export interface VariationUpdateManyWithoutRemovedFromInput {
  create?: VariationCreateWithoutRemovedFromInput[] ;
  connect?: VariationWhereUniqueInput[] ;
  set?: VariationWhereUniqueInput[] ;
  disconnect?: VariationWhereUniqueInput[] ;
  update?: VariationUpdateWithWhereUniqueWithoutRemovedFromInput[] ;
  upsert?: VariationUpsertWithWhereUniqueWithoutRemovedFromInput[] ;
  deleteMany?: VariationScalarWhereInput[] ;
  updateMany?: VariationUpdateManyWithWhereNestedInput[] ;
}

export interface VariationUpdateManyWithoutSizeUsesInput {
  create?: VariationCreateWithoutSizeUsesInput[] ;
  connect?: VariationWhereUniqueInput[] ;
  set?: VariationWhereUniqueInput[] ;
  disconnect?: VariationWhereUniqueInput[] ;
  update?: VariationUpdateWithWhereUniqueWithoutSizeUsesInput[] ;
  upsert?: VariationUpsertWithWhereUniqueWithoutSizeUsesInput[] ;
  deleteMany?: VariationScalarWhereInput[] ;
  updateMany?: VariationUpdateManyWithWhereNestedInput[] ;
}

export interface VariationUpdateOneWithoutAppliedVariationsInput {
  create?: VariationCreateWithoutAppliedVariationsInput ;
  update?: VariationUpdateWithoutAppliedVariationsDataInput ;
  upsert?: VariationUpsertWithoutAppliedVariationsInput ;
  disconnect?: boolean ;
  connect?: VariationWhereUniqueInput ;
}

export interface VariationUpdateOneWithoutArticleMapInput {
  create?: VariationCreateWithoutArticleMapInput ;
  update?: VariationUpdateWithoutArticleMapDataInput ;
  upsert?: VariationUpsertWithoutArticleMapInput ;
  disconnect?: boolean ;
  connect?: VariationWhereUniqueInput ;
}

export interface VariationUpdateOneWithoutNameLangInput {
  create?: VariationCreateWithoutNameLangInput ;
  update?: VariationUpdateWithoutNameLangDataInput ;
  upsert?: VariationUpsertWithoutNameLangInput ;
  disconnect?: boolean ;
  connect?: VariationWhereUniqueInput ;
}

export interface VariationUpdateOneWithoutOrderItemSizesInput {
  create?: VariationCreateWithoutOrderItemSizesInput ;
  update?: VariationUpdateWithoutOrderItemSizesDataInput ;
  upsert?: VariationUpsertWithoutOrderItemSizesInput ;
  disconnect?: boolean ;
  connect?: VariationWhereUniqueInput ;
}

export interface VariationUpdateWithWhereUniqueWithoutCompanyInput {
  where: VariationWhereUniqueInput;
  data: VariationUpdateWithoutCompanyDataInput;
}

export interface VariationUpdateWithWhereUniqueWithoutDefaultOnItemsInput {
  where: VariationWhereUniqueInput;
  data: VariationUpdateWithoutDefaultOnItemsDataInput;
}

export interface VariationUpdateWithWhereUniqueWithoutGroupInput {
  where: VariationWhereUniqueInput;
  data: VariationUpdateWithoutGroupDataInput;
}

export interface VariationUpdateWithWhereUniqueWithoutImageInput {
  where: VariationWhereUniqueInput;
  data: VariationUpdateWithoutImageDataInput;
}

export interface VariationUpdateWithWhereUniqueWithoutItemsInput {
  where: VariationWhereUniqueInput;
  data: VariationUpdateWithoutItemsDataInput;
}

export interface VariationUpdateWithWhereUniqueWithoutMenuEntryInput {
  where: VariationWhereUniqueInput;
  data: VariationUpdateWithoutMenuEntryDataInput;
}

export interface VariationUpdateWithWhereUniqueWithoutOrderItemsInput {
  where: VariationWhereUniqueInput;
  data: VariationUpdateWithoutOrderItemsDataInput;
}

export interface VariationUpdateWithWhereUniqueWithoutPreselectedOnGroupsInput {
  where: VariationWhereUniqueInput;
  data: VariationUpdateWithoutPreselectedOnGroupsDataInput;
}

export interface VariationUpdateWithWhereUniqueWithoutRecommendationsInput {
  where: VariationWhereUniqueInput;
  data: VariationUpdateWithoutRecommendationsDataInput;
}

export interface VariationUpdateWithWhereUniqueWithoutRemovedFromInput {
  where: VariationWhereUniqueInput;
  data: VariationUpdateWithoutRemovedFromDataInput;
}

export interface VariationUpdateWithWhereUniqueWithoutSizeUsesInput {
  where: VariationWhereUniqueInput;
  data: VariationUpdateWithoutSizeUsesDataInput;
}

export interface VariationUpdateWithoutAppliedVariationsDataInput {
  company?: CompanyUpdateOneWithoutVariationsInput ;
  items?: ItemUpdateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryUpdateOneWithoutSelectedVariationsInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVariationNameInput ;
  orderItems?: OrderItemUpdateManyWithoutVariationsInput ;
  removedFrom?: OrderItemUpdateManyWithoutRemovedVariationsInput ;
  price?: number ;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemUpdateManyWithoutSizeInput ;
  sizeUses?: ItemSizeUpdateManyWithoutVariationsInput ;
  defaultOnItems?: ItemUpdateManyWithoutDefaultVariationsInput ;
  recommendations?: RecommendationUpdateManyWithoutVariationsInput ;
  articleMap?: ArticleMapUpdateOneWithoutVariationInput ;
  group?: VariationGroupUpdateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupUpdateManyWithoutPreselectedVariationsInput ;
  image?: ImageUpdateOneWithoutVariationsInput ;
  asItem?: ItemUpdateOneInput ;
  tags?: VariationUpdatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationUpdateWithoutArticleMapDataInput {
  company?: CompanyUpdateOneWithoutVariationsInput ;
  items?: ItemUpdateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryUpdateOneWithoutSelectedVariationsInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVariationNameInput ;
  orderItems?: OrderItemUpdateManyWithoutVariationsInput ;
  removedFrom?: OrderItemUpdateManyWithoutRemovedVariationsInput ;
  price?: number ;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemUpdateManyWithoutSizeInput ;
  sizeUses?: ItemSizeUpdateManyWithoutVariationsInput ;
  defaultOnItems?: ItemUpdateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutVariationInput ;
  recommendations?: RecommendationUpdateManyWithoutVariationsInput ;
  group?: VariationGroupUpdateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupUpdateManyWithoutPreselectedVariationsInput ;
  image?: ImageUpdateOneWithoutVariationsInput ;
  asItem?: ItemUpdateOneInput ;
  tags?: VariationUpdatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationUpdateWithoutCompanyDataInput {
  items?: ItemUpdateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryUpdateOneWithoutSelectedVariationsInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVariationNameInput ;
  orderItems?: OrderItemUpdateManyWithoutVariationsInput ;
  removedFrom?: OrderItemUpdateManyWithoutRemovedVariationsInput ;
  price?: number ;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemUpdateManyWithoutSizeInput ;
  sizeUses?: ItemSizeUpdateManyWithoutVariationsInput ;
  defaultOnItems?: ItemUpdateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutVariationInput ;
  recommendations?: RecommendationUpdateManyWithoutVariationsInput ;
  articleMap?: ArticleMapUpdateOneWithoutVariationInput ;
  group?: VariationGroupUpdateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupUpdateManyWithoutPreselectedVariationsInput ;
  image?: ImageUpdateOneWithoutVariationsInput ;
  asItem?: ItemUpdateOneInput ;
  tags?: VariationUpdatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationUpdateWithoutDefaultOnItemsDataInput {
  company?: CompanyUpdateOneWithoutVariationsInput ;
  items?: ItemUpdateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryUpdateOneWithoutSelectedVariationsInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVariationNameInput ;
  orderItems?: OrderItemUpdateManyWithoutVariationsInput ;
  removedFrom?: OrderItemUpdateManyWithoutRemovedVariationsInput ;
  price?: number ;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemUpdateManyWithoutSizeInput ;
  sizeUses?: ItemSizeUpdateManyWithoutVariationsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutVariationInput ;
  recommendations?: RecommendationUpdateManyWithoutVariationsInput ;
  articleMap?: ArticleMapUpdateOneWithoutVariationInput ;
  group?: VariationGroupUpdateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupUpdateManyWithoutPreselectedVariationsInput ;
  image?: ImageUpdateOneWithoutVariationsInput ;
  asItem?: ItemUpdateOneInput ;
  tags?: VariationUpdatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationUpdateWithoutGroupDataInput {
  company?: CompanyUpdateOneWithoutVariationsInput ;
  items?: ItemUpdateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryUpdateOneWithoutSelectedVariationsInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVariationNameInput ;
  orderItems?: OrderItemUpdateManyWithoutVariationsInput ;
  removedFrom?: OrderItemUpdateManyWithoutRemovedVariationsInput ;
  price?: number ;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemUpdateManyWithoutSizeInput ;
  sizeUses?: ItemSizeUpdateManyWithoutVariationsInput ;
  defaultOnItems?: ItemUpdateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutVariationInput ;
  recommendations?: RecommendationUpdateManyWithoutVariationsInput ;
  articleMap?: ArticleMapUpdateOneWithoutVariationInput ;
  preselectedOnGroups?: VariationGroupUpdateManyWithoutPreselectedVariationsInput ;
  image?: ImageUpdateOneWithoutVariationsInput ;
  asItem?: ItemUpdateOneInput ;
  tags?: VariationUpdatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationUpdateWithoutImageDataInput {
  company?: CompanyUpdateOneWithoutVariationsInput ;
  items?: ItemUpdateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryUpdateOneWithoutSelectedVariationsInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVariationNameInput ;
  orderItems?: OrderItemUpdateManyWithoutVariationsInput ;
  removedFrom?: OrderItemUpdateManyWithoutRemovedVariationsInput ;
  price?: number ;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemUpdateManyWithoutSizeInput ;
  sizeUses?: ItemSizeUpdateManyWithoutVariationsInput ;
  defaultOnItems?: ItemUpdateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutVariationInput ;
  recommendations?: RecommendationUpdateManyWithoutVariationsInput ;
  articleMap?: ArticleMapUpdateOneWithoutVariationInput ;
  group?: VariationGroupUpdateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupUpdateManyWithoutPreselectedVariationsInput ;
  asItem?: ItemUpdateOneInput ;
  tags?: VariationUpdatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationUpdateWithoutItemsDataInput {
  company?: CompanyUpdateOneWithoutVariationsInput ;
  menuEntry?: MenuEntryUpdateOneWithoutSelectedVariationsInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVariationNameInput ;
  orderItems?: OrderItemUpdateManyWithoutVariationsInput ;
  removedFrom?: OrderItemUpdateManyWithoutRemovedVariationsInput ;
  price?: number ;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemUpdateManyWithoutSizeInput ;
  sizeUses?: ItemSizeUpdateManyWithoutVariationsInput ;
  defaultOnItems?: ItemUpdateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutVariationInput ;
  recommendations?: RecommendationUpdateManyWithoutVariationsInput ;
  articleMap?: ArticleMapUpdateOneWithoutVariationInput ;
  group?: VariationGroupUpdateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupUpdateManyWithoutPreselectedVariationsInput ;
  image?: ImageUpdateOneWithoutVariationsInput ;
  asItem?: ItemUpdateOneInput ;
  tags?: VariationUpdatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationUpdateWithoutMenuEntryDataInput {
  company?: CompanyUpdateOneWithoutVariationsInput ;
  items?: ItemUpdateManyWithoutVariationsInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVariationNameInput ;
  orderItems?: OrderItemUpdateManyWithoutVariationsInput ;
  removedFrom?: OrderItemUpdateManyWithoutRemovedVariationsInput ;
  price?: number ;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemUpdateManyWithoutSizeInput ;
  sizeUses?: ItemSizeUpdateManyWithoutVariationsInput ;
  defaultOnItems?: ItemUpdateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutVariationInput ;
  recommendations?: RecommendationUpdateManyWithoutVariationsInput ;
  articleMap?: ArticleMapUpdateOneWithoutVariationInput ;
  group?: VariationGroupUpdateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupUpdateManyWithoutPreselectedVariationsInput ;
  image?: ImageUpdateOneWithoutVariationsInput ;
  asItem?: ItemUpdateOneInput ;
  tags?: VariationUpdatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationUpdateWithoutNameLangDataInput {
  company?: CompanyUpdateOneWithoutVariationsInput ;
  items?: ItemUpdateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryUpdateOneWithoutSelectedVariationsInput ;
  name?: string ;
  orderItems?: OrderItemUpdateManyWithoutVariationsInput ;
  removedFrom?: OrderItemUpdateManyWithoutRemovedVariationsInput ;
  price?: number ;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemUpdateManyWithoutSizeInput ;
  sizeUses?: ItemSizeUpdateManyWithoutVariationsInput ;
  defaultOnItems?: ItemUpdateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutVariationInput ;
  recommendations?: RecommendationUpdateManyWithoutVariationsInput ;
  articleMap?: ArticleMapUpdateOneWithoutVariationInput ;
  group?: VariationGroupUpdateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupUpdateManyWithoutPreselectedVariationsInput ;
  image?: ImageUpdateOneWithoutVariationsInput ;
  asItem?: ItemUpdateOneInput ;
  tags?: VariationUpdatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationUpdateWithoutOrderItemSizesDataInput {
  company?: CompanyUpdateOneWithoutVariationsInput ;
  items?: ItemUpdateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryUpdateOneWithoutSelectedVariationsInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVariationNameInput ;
  orderItems?: OrderItemUpdateManyWithoutVariationsInput ;
  removedFrom?: OrderItemUpdateManyWithoutRemovedVariationsInput ;
  price?: number ;
  absolutePrice?: boolean ;
  sizeUses?: ItemSizeUpdateManyWithoutVariationsInput ;
  defaultOnItems?: ItemUpdateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutVariationInput ;
  recommendations?: RecommendationUpdateManyWithoutVariationsInput ;
  articleMap?: ArticleMapUpdateOneWithoutVariationInput ;
  group?: VariationGroupUpdateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupUpdateManyWithoutPreselectedVariationsInput ;
  image?: ImageUpdateOneWithoutVariationsInput ;
  asItem?: ItemUpdateOneInput ;
  tags?: VariationUpdatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationUpdateWithoutOrderItemsDataInput {
  company?: CompanyUpdateOneWithoutVariationsInput ;
  items?: ItemUpdateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryUpdateOneWithoutSelectedVariationsInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVariationNameInput ;
  removedFrom?: OrderItemUpdateManyWithoutRemovedVariationsInput ;
  price?: number ;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemUpdateManyWithoutSizeInput ;
  sizeUses?: ItemSizeUpdateManyWithoutVariationsInput ;
  defaultOnItems?: ItemUpdateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutVariationInput ;
  recommendations?: RecommendationUpdateManyWithoutVariationsInput ;
  articleMap?: ArticleMapUpdateOneWithoutVariationInput ;
  group?: VariationGroupUpdateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupUpdateManyWithoutPreselectedVariationsInput ;
  image?: ImageUpdateOneWithoutVariationsInput ;
  asItem?: ItemUpdateOneInput ;
  tags?: VariationUpdatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationUpdateWithoutPreselectedOnGroupsDataInput {
  company?: CompanyUpdateOneWithoutVariationsInput ;
  items?: ItemUpdateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryUpdateOneWithoutSelectedVariationsInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVariationNameInput ;
  orderItems?: OrderItemUpdateManyWithoutVariationsInput ;
  removedFrom?: OrderItemUpdateManyWithoutRemovedVariationsInput ;
  price?: number ;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemUpdateManyWithoutSizeInput ;
  sizeUses?: ItemSizeUpdateManyWithoutVariationsInput ;
  defaultOnItems?: ItemUpdateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutVariationInput ;
  recommendations?: RecommendationUpdateManyWithoutVariationsInput ;
  articleMap?: ArticleMapUpdateOneWithoutVariationInput ;
  group?: VariationGroupUpdateManyWithoutVariationsInput ;
  image?: ImageUpdateOneWithoutVariationsInput ;
  asItem?: ItemUpdateOneInput ;
  tags?: VariationUpdatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationUpdateWithoutRecommendationsDataInput {
  company?: CompanyUpdateOneWithoutVariationsInput ;
  items?: ItemUpdateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryUpdateOneWithoutSelectedVariationsInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVariationNameInput ;
  orderItems?: OrderItemUpdateManyWithoutVariationsInput ;
  removedFrom?: OrderItemUpdateManyWithoutRemovedVariationsInput ;
  price?: number ;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemUpdateManyWithoutSizeInput ;
  sizeUses?: ItemSizeUpdateManyWithoutVariationsInput ;
  defaultOnItems?: ItemUpdateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutVariationInput ;
  articleMap?: ArticleMapUpdateOneWithoutVariationInput ;
  group?: VariationGroupUpdateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupUpdateManyWithoutPreselectedVariationsInput ;
  image?: ImageUpdateOneWithoutVariationsInput ;
  asItem?: ItemUpdateOneInput ;
  tags?: VariationUpdatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationUpdateWithoutRemovedFromDataInput {
  company?: CompanyUpdateOneWithoutVariationsInput ;
  items?: ItemUpdateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryUpdateOneWithoutSelectedVariationsInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVariationNameInput ;
  orderItems?: OrderItemUpdateManyWithoutVariationsInput ;
  price?: number ;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemUpdateManyWithoutSizeInput ;
  sizeUses?: ItemSizeUpdateManyWithoutVariationsInput ;
  defaultOnItems?: ItemUpdateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutVariationInput ;
  recommendations?: RecommendationUpdateManyWithoutVariationsInput ;
  articleMap?: ArticleMapUpdateOneWithoutVariationInput ;
  group?: VariationGroupUpdateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupUpdateManyWithoutPreselectedVariationsInput ;
  image?: ImageUpdateOneWithoutVariationsInput ;
  asItem?: ItemUpdateOneInput ;
  tags?: VariationUpdatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationUpdateWithoutSizeUsesDataInput {
  company?: CompanyUpdateOneWithoutVariationsInput ;
  items?: ItemUpdateManyWithoutVariationsInput ;
  menuEntry?: MenuEntryUpdateOneWithoutSelectedVariationsInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVariationNameInput ;
  orderItems?: OrderItemUpdateManyWithoutVariationsInput ;
  removedFrom?: OrderItemUpdateManyWithoutRemovedVariationsInput ;
  price?: number ;
  absolutePrice?: boolean ;
  orderItemSizes?: OrderItemUpdateManyWithoutSizeInput ;
  defaultOnItems?: ItemUpdateManyWithoutDefaultVariationsInput ;
  appliedVariations?: AppliedVariationUpdateManyWithoutVariationInput ;
  recommendations?: RecommendationUpdateManyWithoutVariationsInput ;
  articleMap?: ArticleMapUpdateOneWithoutVariationInput ;
  group?: VariationGroupUpdateManyWithoutVariationsInput ;
  preselectedOnGroups?: VariationGroupUpdateManyWithoutPreselectedVariationsInput ;
  image?: ImageUpdateOneWithoutVariationsInput ;
  asItem?: ItemUpdateOneInput ;
  tags?: VariationUpdatetagsInput ;
  deleted?: boolean ;
  highlighted?: boolean ;
  allergen?: ALLERGEN ;
  order?: number ;
}

export interface VariationUpdatetagsInput {
  set?: string[] ;
}

export interface VariationUpsertWithWhereUniqueWithoutCompanyInput {
  where: VariationWhereUniqueInput;
  update: VariationUpdateWithoutCompanyDataInput;
  create: VariationCreateWithoutCompanyInput;
}

export interface VariationUpsertWithWhereUniqueWithoutDefaultOnItemsInput {
  where: VariationWhereUniqueInput;
  update: VariationUpdateWithoutDefaultOnItemsDataInput;
  create: VariationCreateWithoutDefaultOnItemsInput;
}

export interface VariationUpsertWithWhereUniqueWithoutGroupInput {
  where: VariationWhereUniqueInput;
  update: VariationUpdateWithoutGroupDataInput;
  create: VariationCreateWithoutGroupInput;
}

export interface VariationUpsertWithWhereUniqueWithoutImageInput {
  where: VariationWhereUniqueInput;
  update: VariationUpdateWithoutImageDataInput;
  create: VariationCreateWithoutImageInput;
}

export interface VariationUpsertWithWhereUniqueWithoutItemsInput {
  where: VariationWhereUniqueInput;
  update: VariationUpdateWithoutItemsDataInput;
  create: VariationCreateWithoutItemsInput;
}

export interface VariationUpsertWithWhereUniqueWithoutMenuEntryInput {
  where: VariationWhereUniqueInput;
  update: VariationUpdateWithoutMenuEntryDataInput;
  create: VariationCreateWithoutMenuEntryInput;
}

export interface VariationUpsertWithWhereUniqueWithoutOrderItemsInput {
  where: VariationWhereUniqueInput;
  update: VariationUpdateWithoutOrderItemsDataInput;
  create: VariationCreateWithoutOrderItemsInput;
}

export interface VariationUpsertWithWhereUniqueWithoutPreselectedOnGroupsInput {
  where: VariationWhereUniqueInput;
  update: VariationUpdateWithoutPreselectedOnGroupsDataInput;
  create: VariationCreateWithoutPreselectedOnGroupsInput;
}

export interface VariationUpsertWithWhereUniqueWithoutRecommendationsInput {
  where: VariationWhereUniqueInput;
  update: VariationUpdateWithoutRecommendationsDataInput;
  create: VariationCreateWithoutRecommendationsInput;
}

export interface VariationUpsertWithWhereUniqueWithoutRemovedFromInput {
  where: VariationWhereUniqueInput;
  update: VariationUpdateWithoutRemovedFromDataInput;
  create: VariationCreateWithoutRemovedFromInput;
}

export interface VariationUpsertWithWhereUniqueWithoutSizeUsesInput {
  where: VariationWhereUniqueInput;
  update: VariationUpdateWithoutSizeUsesDataInput;
  create: VariationCreateWithoutSizeUsesInput;
}

export interface VariationUpsertWithoutAppliedVariationsInput {
  update: VariationUpdateWithoutAppliedVariationsDataInput;
  create: VariationCreateWithoutAppliedVariationsInput;
}

export interface VariationUpsertWithoutArticleMapInput {
  update: VariationUpdateWithoutArticleMapDataInput;
  create: VariationCreateWithoutArticleMapInput;
}

export interface VariationUpsertWithoutNameLangInput {
  update: VariationUpdateWithoutNameLangDataInput;
  create: VariationCreateWithoutNameLangInput;
}

export interface VariationUpsertWithoutOrderItemSizesInput {
  update: VariationUpdateWithoutOrderItemSizesDataInput;
  create: VariationCreateWithoutOrderItemSizesInput;
}

export interface VariationWhereInput {
  company?: CompanyWhereInput ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  items_every?: ItemWhereInput ;
  items_some?: ItemWhereInput ;
  items_none?: ItemWhereInput ;
  menuEntry?: MenuEntryWhereInput ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  nameLang?: TranslatedStringWhereInput ;
  orderItems_every?: OrderItemWhereInput ;
  orderItems_some?: OrderItemWhereInput ;
  orderItems_none?: OrderItemWhereInput ;
  removedFrom_every?: OrderItemWhereInput ;
  removedFrom_some?: OrderItemWhereInput ;
  removedFrom_none?: OrderItemWhereInput ;
  price?: number ;
  price_not?: number ;
  price_in?: number[] ;
  price_not_in?: number[] ;
  price_lt?: number ;
  price_lte?: number ;
  price_gt?: number ;
  price_gte?: number ;
  absolutePrice?: boolean ;
  absolutePrice_not?: boolean ;
  orderItemSizes_every?: OrderItemWhereInput ;
  orderItemSizes_some?: OrderItemWhereInput ;
  orderItemSizes_none?: OrderItemWhereInput ;
  sizeUses_every?: ItemSizeWhereInput ;
  sizeUses_some?: ItemSizeWhereInput ;
  sizeUses_none?: ItemSizeWhereInput ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  defaultOnItems_every?: ItemWhereInput ;
  defaultOnItems_some?: ItemWhereInput ;
  defaultOnItems_none?: ItemWhereInput ;
  appliedVariations_every?: AppliedVariationWhereInput ;
  appliedVariations_some?: AppliedVariationWhereInput ;
  appliedVariations_none?: AppliedVariationWhereInput ;
  recommendations_every?: RecommendationWhereInput ;
  recommendations_some?: RecommendationWhereInput ;
  recommendations_none?: RecommendationWhereInput ;
  articleMap?: ArticleMapWhereInput ;
  group_every?: VariationGroupWhereInput ;
  group_some?: VariationGroupWhereInput ;
  group_none?: VariationGroupWhereInput ;
  preselectedOnGroups_every?: VariationGroupWhereInput ;
  preselectedOnGroups_some?: VariationGroupWhereInput ;
  preselectedOnGroups_none?: VariationGroupWhereInput ;
  image?: ImageWhereInput ;
  asItem?: ItemWhereInput ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  highlighted?: boolean ;
  highlighted_not?: boolean ;
  allergen?: ALLERGEN ;
  allergen_not?: ALLERGEN ;
  allergen_in?: ALLERGEN[] ;
  allergen_not_in?: ALLERGEN[] ;
  order?: number ;
  order_not?: number ;
  order_in?: number[] ;
  order_not_in?: number[] ;
  order_lt?: number ;
  order_lte?: number ;
  order_gt?: number ;
  order_gte?: number ;
  AND?: VariationWhereInput[] ;
  OR?: VariationWhereInput[] ;
  NOT?: VariationWhereInput[] ;
}

export interface VariationWhereUniqueInput {
  id?: string ;
}

export interface VenueCreateInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateManyWithoutCompanyInput {
  create?: VenueCreateWithoutCompanyInput[] ;
  connect?: VenueWhereUniqueInput[] ;
}

export interface VenueCreateManyWithoutDeliveryRatesInput {
  create?: VenueCreateWithoutDeliveryRatesInput[] ;
  connect?: VenueWhereUniqueInput[] ;
}

export interface VenueCreateManyWithoutImageInput {
  create?: VenueCreateWithoutImageInput[] ;
  connect?: VenueWhereUniqueInput[] ;
}

export interface VenueCreateManyWithoutLocalDeliveriesInput {
  create?: VenueCreateWithoutLocalDeliveriesInput[] ;
  connect?: VenueWhereUniqueInput[] ;
}

export interface VenueCreateManyWithoutOffersInput {
  create?: VenueCreateWithoutOffersInput[] ;
  connect?: VenueWhereUniqueInput[] ;
}

export interface VenueCreateManyWithoutStampCardsInput {
  create?: VenueCreateWithoutStampCardsInput[] ;
  connect?: VenueWhereUniqueInput[] ;
}

export interface VenueCreateManyWithoutUsersInput {
  create?: VenueCreateWithoutUsersInput[] ;
  connect?: VenueWhereUniqueInput[] ;
}

export interface VenueCreateOneWithoutAvailabilitiesInput {
  create?: VenueCreateWithoutAvailabilitiesInput ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueCreateOneWithoutExpensesInput {
  create?: VenueCreateWithoutExpensesInput ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueCreateOneWithoutFloorPlansInput {
  create?: VenueCreateWithoutFloorPlansInput ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueCreateOneWithoutInvoiceTargetsInput {
  create?: VenueCreateWithoutInvoiceTargetsInput ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueCreateOneWithoutLocationInput {
  create?: VenueCreateWithoutLocationInput ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueCreateOneWithoutMenusInput {
  create?: VenueCreateWithoutMenusInput ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueCreateOneWithoutNameLangInput {
  create?: VenueCreateWithoutNameLangInput ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueCreateOneWithoutOrdersInput {
  create?: VenueCreateWithoutOrdersInput ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueCreateOneWithoutPaymentMethodsInput {
  create?: VenueCreateWithoutPaymentMethodsInput ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueCreateOneWithoutPosDevicesInput {
  create?: VenueCreateWithoutPosDevicesInput ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueCreateOneWithoutPosMetadataInput {
  create?: VenueCreateWithoutPosMetadataInput ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueCreateOneWithoutPredefinedMessagesInput {
  create?: VenueCreateWithoutPredefinedMessagesInput ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueCreateOneWithoutReceiptTemplateInput {
  create?: VenueCreateWithoutReceiptTemplateInput ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueCreateOneWithoutTablesInput {
  create?: VenueCreateWithoutTablesInput ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueCreateWithoutAvailabilitiesInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutCompanyInput {
  active: boolean;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutDeliveryRatesInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutExpensesInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutFloorPlansInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutImageInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutInvoiceTargetsInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutLocalDeliveriesInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutLocationInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutMenusInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutNameLangInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutOffersInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutOrdersInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutPaymentMethodsInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutPosDevicesInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutPosMetadataInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutPredefinedMessagesInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutReceiptTemplateInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutStampCardsInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutTablesInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  users?: UserCreateManyWithoutVenuesInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueCreateWithoutUsersInput {
  active: boolean;
  company?: CompanyCreateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateCreateManyWithoutVenuesInput ;
  id?: string ;
  image?: ImageCreateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationCreateOneWithoutVenueInput ;
  name: string;
  nameLang?: TranslatedStringCreateOneWithoutVenueNameInput ;
  orders?: OrderCreateManyWithoutVenueInput ;
  menus?: AppliedMenuCreateManyWithoutVenueInput ;
  availabilities?: AvailabilityCreateManyWithoutVenueInput ;
  stampCards?: StampCardCreateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferCreateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsCreateOneWithoutVenuesInput ;
  tables?: TableCreateManyWithoutVenueInput ;
  reports?: ReportCreateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataCreateOneWithoutVenueInput ;
  posDevices?: POSDeviceCreateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateCreateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetCreateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodCreateManyWithoutVenueInput ;
  floorPlans?: FloorPlanCreateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageCreateManyWithoutVenueInput ;
  expenses?: ExpenseCreateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueScalarWhereInput {
  active?: boolean ;
  active_not?: boolean ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  organizationId?: string ;
  organizationId_not?: string ;
  organizationId_in?: string[] ;
  organizationId_not_in?: string[] ;
  organizationId_lt?: string ;
  organizationId_lte?: string ;
  organizationId_gt?: string ;
  organizationId_gte?: string ;
  organizationId_contains?: string ;
  organizationId_not_contains?: string ;
  organizationId_starts_with?: string ;
  organizationId_not_starts_with?: string ;
  organizationId_ends_with?: string ;
  organizationId_not_ends_with?: string ;
  phone?: string ;
  phone_not?: string ;
  phone_in?: string[] ;
  phone_not_in?: string[] ;
  phone_lt?: string ;
  phone_lte?: string ;
  phone_gt?: string ;
  phone_gte?: string ;
  phone_contains?: string ;
  phone_not_contains?: string ;
  phone_starts_with?: string ;
  phone_not_starts_with?: string ;
  phone_ends_with?: string ;
  phone_not_ends_with?: string ;
  minimumDeliveryFee?: number ;
  minimumDeliveryFee_not?: number ;
  minimumDeliveryFee_in?: number[] ;
  minimumDeliveryFee_not_in?: number[] ;
  minimumDeliveryFee_lt?: number ;
  minimumDeliveryFee_lte?: number ;
  minimumDeliveryFee_gt?: number ;
  minimumDeliveryFee_gte?: number ;
  supportEmail?: string ;
  supportEmail_not?: string ;
  supportEmail_in?: string[] ;
  supportEmail_not_in?: string[] ;
  supportEmail_lt?: string ;
  supportEmail_lte?: string ;
  supportEmail_gt?: string ;
  supportEmail_gte?: string ;
  supportEmail_contains?: string ;
  supportEmail_not_contains?: string ;
  supportEmail_starts_with?: string ;
  supportEmail_not_starts_with?: string ;
  supportEmail_ends_with?: string ;
  supportEmail_not_ends_with?: string ;
  lastSeenOnline?: any ;
  lastSeenOnline_not?: any ;
  lastSeenOnline_in?: any[] ;
  lastSeenOnline_not_in?: any[] ;
  lastSeenOnline_lt?: any ;
  lastSeenOnline_lte?: any ;
  lastSeenOnline_gt?: any ;
  lastSeenOnline_gte?: any ;
  lastSeenVersion?: string ;
  lastSeenVersion_not?: string ;
  lastSeenVersion_in?: string[] ;
  lastSeenVersion_not_in?: string[] ;
  lastSeenVersion_lt?: string ;
  lastSeenVersion_lte?: string ;
  lastSeenVersion_gt?: string ;
  lastSeenVersion_gte?: string ;
  lastSeenVersion_contains?: string ;
  lastSeenVersion_not_contains?: string ;
  lastSeenVersion_starts_with?: string ;
  lastSeenVersion_not_starts_with?: string ;
  lastSeenVersion_ends_with?: string ;
  lastSeenVersion_not_ends_with?: string ;
  bookingServiceId?: string ;
  bookingServiceId_not?: string ;
  bookingServiceId_in?: string[] ;
  bookingServiceId_not_in?: string[] ;
  bookingServiceId_lt?: string ;
  bookingServiceId_lte?: string ;
  bookingServiceId_gt?: string ;
  bookingServiceId_gte?: string ;
  bookingServiceId_contains?: string ;
  bookingServiceId_not_contains?: string ;
  bookingServiceId_starts_with?: string ;
  bookingServiceId_not_starts_with?: string ;
  bookingServiceId_ends_with?: string ;
  bookingServiceId_not_ends_with?: string ;
  openingSoon?: boolean ;
  openingSoon_not?: boolean ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  legalName?: string ;
  legalName_not?: string ;
  legalName_in?: string[] ;
  legalName_not_in?: string[] ;
  legalName_lt?: string ;
  legalName_lte?: string ;
  legalName_gt?: string ;
  legalName_gte?: string ;
  legalName_contains?: string ;
  legalName_not_contains?: string ;
  legalName_starts_with?: string ;
  legalName_not_starts_with?: string ;
  legalName_ends_with?: string ;
  legalName_not_ends_with?: string ;
  staffIdleTimeout?: number ;
  staffIdleTimeout_not?: number ;
  staffIdleTimeout_in?: number[] ;
  staffIdleTimeout_not_in?: number[] ;
  staffIdleTimeout_lt?: number ;
  staffIdleTimeout_lte?: number ;
  staffIdleTimeout_gt?: number ;
  staffIdleTimeout_gte?: number ;
  printBong?: boolean ;
  printBong_not?: boolean ;
  timezone?: string ;
  timezone_not?: string ;
  timezone_in?: string[] ;
  timezone_not_in?: string[] ;
  timezone_lt?: string ;
  timezone_lte?: string ;
  timezone_gt?: string ;
  timezone_gte?: string ;
  timezone_contains?: string ;
  timezone_not_contains?: string ;
  timezone_starts_with?: string ;
  timezone_not_starts_with?: string ;
  timezone_ends_with?: string ;
  timezone_not_ends_with?: string ;
  AND?: VenueScalarWhereInput[] ;
  OR?: VenueScalarWhereInput[] ;
  NOT?: VenueScalarWhereInput[] ;
}

export interface VenueUpdateManyDataInput {
  active?: boolean ;
  name?: string ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  deleted?: boolean ;
  legalName?: string ;
  staffIdleTimeout?: number ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueUpdateManyWithWhereNestedInput {
  where: VenueScalarWhereInput;
  data: VenueUpdateManyDataInput;
}

export interface VenueUpdateManyWithoutCompanyInput {
  create?: VenueCreateWithoutCompanyInput[] ;
  connect?: VenueWhereUniqueInput[] ;
  set?: VenueWhereUniqueInput[] ;
  disconnect?: VenueWhereUniqueInput[] ;
  update?: VenueUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: VenueUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: VenueScalarWhereInput[] ;
  updateMany?: VenueUpdateManyWithWhereNestedInput[] ;
}

export interface VenueUpdateManyWithoutDeliveryRatesInput {
  create?: VenueCreateWithoutDeliveryRatesInput[] ;
  connect?: VenueWhereUniqueInput[] ;
  set?: VenueWhereUniqueInput[] ;
  disconnect?: VenueWhereUniqueInput[] ;
  update?: VenueUpdateWithWhereUniqueWithoutDeliveryRatesInput[] ;
  upsert?: VenueUpsertWithWhereUniqueWithoutDeliveryRatesInput[] ;
  deleteMany?: VenueScalarWhereInput[] ;
  updateMany?: VenueUpdateManyWithWhereNestedInput[] ;
}

export interface VenueUpdateManyWithoutImageInput {
  create?: VenueCreateWithoutImageInput[] ;
  connect?: VenueWhereUniqueInput[] ;
  set?: VenueWhereUniqueInput[] ;
  disconnect?: VenueWhereUniqueInput[] ;
  update?: VenueUpdateWithWhereUniqueWithoutImageInput[] ;
  upsert?: VenueUpsertWithWhereUniqueWithoutImageInput[] ;
  deleteMany?: VenueScalarWhereInput[] ;
  updateMany?: VenueUpdateManyWithWhereNestedInput[] ;
}

export interface VenueUpdateManyWithoutLocalDeliveriesInput {
  create?: VenueCreateWithoutLocalDeliveriesInput[] ;
  connect?: VenueWhereUniqueInput[] ;
  set?: VenueWhereUniqueInput[] ;
  disconnect?: VenueWhereUniqueInput[] ;
  update?: VenueUpdateWithWhereUniqueWithoutLocalDeliveriesInput[] ;
  upsert?: VenueUpsertWithWhereUniqueWithoutLocalDeliveriesInput[] ;
  deleteMany?: VenueScalarWhereInput[] ;
  updateMany?: VenueUpdateManyWithWhereNestedInput[] ;
}

export interface VenueUpdateManyWithoutOffersInput {
  create?: VenueCreateWithoutOffersInput[] ;
  connect?: VenueWhereUniqueInput[] ;
  set?: VenueWhereUniqueInput[] ;
  disconnect?: VenueWhereUniqueInput[] ;
  update?: VenueUpdateWithWhereUniqueWithoutOffersInput[] ;
  upsert?: VenueUpsertWithWhereUniqueWithoutOffersInput[] ;
  deleteMany?: VenueScalarWhereInput[] ;
  updateMany?: VenueUpdateManyWithWhereNestedInput[] ;
}

export interface VenueUpdateManyWithoutStampCardsInput {
  create?: VenueCreateWithoutStampCardsInput[] ;
  connect?: VenueWhereUniqueInput[] ;
  set?: VenueWhereUniqueInput[] ;
  disconnect?: VenueWhereUniqueInput[] ;
  update?: VenueUpdateWithWhereUniqueWithoutStampCardsInput[] ;
  upsert?: VenueUpsertWithWhereUniqueWithoutStampCardsInput[] ;
  deleteMany?: VenueScalarWhereInput[] ;
  updateMany?: VenueUpdateManyWithWhereNestedInput[] ;
}

export interface VenueUpdateManyWithoutUsersInput {
  create?: VenueCreateWithoutUsersInput[] ;
  connect?: VenueWhereUniqueInput[] ;
  set?: VenueWhereUniqueInput[] ;
  disconnect?: VenueWhereUniqueInput[] ;
  update?: VenueUpdateWithWhereUniqueWithoutUsersInput[] ;
  upsert?: VenueUpsertWithWhereUniqueWithoutUsersInput[] ;
  deleteMany?: VenueScalarWhereInput[] ;
  updateMany?: VenueUpdateManyWithWhereNestedInput[] ;
}

export interface VenueUpdateOneRequiredWithoutExpensesInput {
  create?: VenueCreateWithoutExpensesInput ;
  update?: VenueUpdateWithoutExpensesDataInput ;
  upsert?: VenueUpsertWithoutExpensesInput ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueUpdateOneRequiredWithoutFloorPlansInput {
  create?: VenueCreateWithoutFloorPlansInput ;
  update?: VenueUpdateWithoutFloorPlansDataInput ;
  upsert?: VenueUpsertWithoutFloorPlansInput ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueUpdateOneRequiredWithoutPosDevicesInput {
  create?: VenueCreateWithoutPosDevicesInput ;
  update?: VenueUpdateWithoutPosDevicesDataInput ;
  upsert?: VenueUpsertWithoutPosDevicesInput ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueUpdateOneRequiredWithoutPredefinedMessagesInput {
  create?: VenueCreateWithoutPredefinedMessagesInput ;
  update?: VenueUpdateWithoutPredefinedMessagesDataInput ;
  upsert?: VenueUpsertWithoutPredefinedMessagesInput ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueUpdateOneRequiredWithoutTablesInput {
  create?: VenueCreateWithoutTablesInput ;
  update?: VenueUpdateWithoutTablesDataInput ;
  upsert?: VenueUpsertWithoutTablesInput ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueUpdateOneWithoutAvailabilitiesInput {
  create?: VenueCreateWithoutAvailabilitiesInput ;
  update?: VenueUpdateWithoutAvailabilitiesDataInput ;
  upsert?: VenueUpsertWithoutAvailabilitiesInput ;
  disconnect?: boolean ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueUpdateOneWithoutInvoiceTargetsInput {
  create?: VenueCreateWithoutInvoiceTargetsInput ;
  update?: VenueUpdateWithoutInvoiceTargetsDataInput ;
  upsert?: VenueUpsertWithoutInvoiceTargetsInput ;
  disconnect?: boolean ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueUpdateOneWithoutLocationInput {
  create?: VenueCreateWithoutLocationInput ;
  update?: VenueUpdateWithoutLocationDataInput ;
  upsert?: VenueUpsertWithoutLocationInput ;
  disconnect?: boolean ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueUpdateOneWithoutMenusInput {
  create?: VenueCreateWithoutMenusInput ;
  update?: VenueUpdateWithoutMenusDataInput ;
  upsert?: VenueUpsertWithoutMenusInput ;
  disconnect?: boolean ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueUpdateOneWithoutNameLangInput {
  create?: VenueCreateWithoutNameLangInput ;
  update?: VenueUpdateWithoutNameLangDataInput ;
  upsert?: VenueUpsertWithoutNameLangInput ;
  disconnect?: boolean ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueUpdateOneWithoutOrdersInput {
  create?: VenueCreateWithoutOrdersInput ;
  update?: VenueUpdateWithoutOrdersDataInput ;
  upsert?: VenueUpsertWithoutOrdersInput ;
  disconnect?: boolean ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueUpdateOneWithoutPaymentMethodsInput {
  create?: VenueCreateWithoutPaymentMethodsInput ;
  update?: VenueUpdateWithoutPaymentMethodsDataInput ;
  upsert?: VenueUpsertWithoutPaymentMethodsInput ;
  disconnect?: boolean ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueUpdateOneWithoutPosMetadataInput {
  create?: VenueCreateWithoutPosMetadataInput ;
  update?: VenueUpdateWithoutPosMetadataDataInput ;
  upsert?: VenueUpsertWithoutPosMetadataInput ;
  disconnect?: boolean ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueUpdateOneWithoutReceiptTemplateInput {
  create?: VenueCreateWithoutReceiptTemplateInput ;
  update?: VenueUpdateWithoutReceiptTemplateDataInput ;
  upsert?: VenueUpsertWithoutReceiptTemplateInput ;
  disconnect?: boolean ;
  connect?: VenueWhereUniqueInput ;
}

export interface VenueUpdateWithWhereUniqueWithoutCompanyInput {
  where: VenueWhereUniqueInput;
  data: VenueUpdateWithoutCompanyDataInput;
}

export interface VenueUpdateWithWhereUniqueWithoutDeliveryRatesInput {
  where: VenueWhereUniqueInput;
  data: VenueUpdateWithoutDeliveryRatesDataInput;
}

export interface VenueUpdateWithWhereUniqueWithoutImageInput {
  where: VenueWhereUniqueInput;
  data: VenueUpdateWithoutImageDataInput;
}

export interface VenueUpdateWithWhereUniqueWithoutLocalDeliveriesInput {
  where: VenueWhereUniqueInput;
  data: VenueUpdateWithoutLocalDeliveriesDataInput;
}

export interface VenueUpdateWithWhereUniqueWithoutOffersInput {
  where: VenueWhereUniqueInput;
  data: VenueUpdateWithoutOffersDataInput;
}

export interface VenueUpdateWithWhereUniqueWithoutStampCardsInput {
  where: VenueWhereUniqueInput;
  data: VenueUpdateWithoutStampCardsDataInput;
}

export interface VenueUpdateWithWhereUniqueWithoutUsersInput {
  where: VenueWhereUniqueInput;
  data: VenueUpdateWithoutUsersDataInput;
}

export interface VenueUpdateWithoutAvailabilitiesDataInput {
  active?: boolean ;
  company?: CompanyUpdateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutVenuesInput ;
  image?: ImageUpdateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationUpdateOneWithoutVenueInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVenueNameInput ;
  orders?: OrderUpdateManyWithoutVenueInput ;
  menus?: AppliedMenuUpdateManyWithoutVenueInput ;
  users?: UserUpdateManyWithoutVenuesInput ;
  stampCards?: StampCardUpdateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferUpdateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsUpdateOneWithoutVenuesInput ;
  tables?: TableUpdateManyWithoutVenueInput ;
  reports?: ReportUpdateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataUpdateOneWithoutVenueInput ;
  posDevices?: POSDeviceUpdateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateUpdateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutVenueInput ;
  floorPlans?: FloorPlanUpdateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutVenueInput ;
  expenses?: ExpenseUpdateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueUpdateWithoutCompanyDataInput {
  active?: boolean ;
  deliveryRates?: DeliveryRateUpdateManyWithoutVenuesInput ;
  image?: ImageUpdateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationUpdateOneWithoutVenueInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVenueNameInput ;
  orders?: OrderUpdateManyWithoutVenueInput ;
  menus?: AppliedMenuUpdateManyWithoutVenueInput ;
  users?: UserUpdateManyWithoutVenuesInput ;
  availabilities?: AvailabilityUpdateManyWithoutVenueInput ;
  stampCards?: StampCardUpdateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferUpdateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsUpdateOneWithoutVenuesInput ;
  tables?: TableUpdateManyWithoutVenueInput ;
  reports?: ReportUpdateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataUpdateOneWithoutVenueInput ;
  posDevices?: POSDeviceUpdateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateUpdateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutVenueInput ;
  floorPlans?: FloorPlanUpdateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutVenueInput ;
  expenses?: ExpenseUpdateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueUpdateWithoutDeliveryRatesDataInput {
  active?: boolean ;
  company?: CompanyUpdateOneWithoutVenuesInput ;
  image?: ImageUpdateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationUpdateOneWithoutVenueInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVenueNameInput ;
  orders?: OrderUpdateManyWithoutVenueInput ;
  menus?: AppliedMenuUpdateManyWithoutVenueInput ;
  users?: UserUpdateManyWithoutVenuesInput ;
  availabilities?: AvailabilityUpdateManyWithoutVenueInput ;
  stampCards?: StampCardUpdateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferUpdateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsUpdateOneWithoutVenuesInput ;
  tables?: TableUpdateManyWithoutVenueInput ;
  reports?: ReportUpdateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataUpdateOneWithoutVenueInput ;
  posDevices?: POSDeviceUpdateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateUpdateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutVenueInput ;
  floorPlans?: FloorPlanUpdateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutVenueInput ;
  expenses?: ExpenseUpdateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueUpdateWithoutExpensesDataInput {
  active?: boolean ;
  company?: CompanyUpdateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutVenuesInput ;
  image?: ImageUpdateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationUpdateOneWithoutVenueInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVenueNameInput ;
  orders?: OrderUpdateManyWithoutVenueInput ;
  menus?: AppliedMenuUpdateManyWithoutVenueInput ;
  users?: UserUpdateManyWithoutVenuesInput ;
  availabilities?: AvailabilityUpdateManyWithoutVenueInput ;
  stampCards?: StampCardUpdateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferUpdateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsUpdateOneWithoutVenuesInput ;
  tables?: TableUpdateManyWithoutVenueInput ;
  reports?: ReportUpdateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataUpdateOneWithoutVenueInput ;
  posDevices?: POSDeviceUpdateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateUpdateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutVenueInput ;
  floorPlans?: FloorPlanUpdateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueUpdateWithoutFloorPlansDataInput {
  active?: boolean ;
  company?: CompanyUpdateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutVenuesInput ;
  image?: ImageUpdateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationUpdateOneWithoutVenueInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVenueNameInput ;
  orders?: OrderUpdateManyWithoutVenueInput ;
  menus?: AppliedMenuUpdateManyWithoutVenueInput ;
  users?: UserUpdateManyWithoutVenuesInput ;
  availabilities?: AvailabilityUpdateManyWithoutVenueInput ;
  stampCards?: StampCardUpdateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferUpdateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsUpdateOneWithoutVenuesInput ;
  tables?: TableUpdateManyWithoutVenueInput ;
  reports?: ReportUpdateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataUpdateOneWithoutVenueInput ;
  posDevices?: POSDeviceUpdateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateUpdateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutVenueInput ;
  expenses?: ExpenseUpdateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueUpdateWithoutImageDataInput {
  active?: boolean ;
  company?: CompanyUpdateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutVenuesInput ;
  location?: LocationUpdateOneWithoutVenueInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVenueNameInput ;
  orders?: OrderUpdateManyWithoutVenueInput ;
  menus?: AppliedMenuUpdateManyWithoutVenueInput ;
  users?: UserUpdateManyWithoutVenuesInput ;
  availabilities?: AvailabilityUpdateManyWithoutVenueInput ;
  stampCards?: StampCardUpdateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferUpdateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsUpdateOneWithoutVenuesInput ;
  tables?: TableUpdateManyWithoutVenueInput ;
  reports?: ReportUpdateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataUpdateOneWithoutVenueInput ;
  posDevices?: POSDeviceUpdateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateUpdateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutVenueInput ;
  floorPlans?: FloorPlanUpdateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutVenueInput ;
  expenses?: ExpenseUpdateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueUpdateWithoutInvoiceTargetsDataInput {
  active?: boolean ;
  company?: CompanyUpdateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutVenuesInput ;
  image?: ImageUpdateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationUpdateOneWithoutVenueInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVenueNameInput ;
  orders?: OrderUpdateManyWithoutVenueInput ;
  menus?: AppliedMenuUpdateManyWithoutVenueInput ;
  users?: UserUpdateManyWithoutVenuesInput ;
  availabilities?: AvailabilityUpdateManyWithoutVenueInput ;
  stampCards?: StampCardUpdateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferUpdateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsUpdateOneWithoutVenuesInput ;
  tables?: TableUpdateManyWithoutVenueInput ;
  reports?: ReportUpdateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataUpdateOneWithoutVenueInput ;
  posDevices?: POSDeviceUpdateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateUpdateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  paymentMethods?: PaymentMethodUpdateManyWithoutVenueInput ;
  floorPlans?: FloorPlanUpdateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutVenueInput ;
  expenses?: ExpenseUpdateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueUpdateWithoutLocalDeliveriesDataInput {
  active?: boolean ;
  company?: CompanyUpdateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutVenuesInput ;
  image?: ImageUpdateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationUpdateOneWithoutVenueInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVenueNameInput ;
  orders?: OrderUpdateManyWithoutVenueInput ;
  menus?: AppliedMenuUpdateManyWithoutVenueInput ;
  users?: UserUpdateManyWithoutVenuesInput ;
  availabilities?: AvailabilityUpdateManyWithoutVenueInput ;
  stampCards?: StampCardUpdateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferUpdateManyWithoutVenuesInput ;
  deleted?: boolean ;
  tables?: TableUpdateManyWithoutVenueInput ;
  reports?: ReportUpdateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataUpdateOneWithoutVenueInput ;
  posDevices?: POSDeviceUpdateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateUpdateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutVenueInput ;
  floorPlans?: FloorPlanUpdateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutVenueInput ;
  expenses?: ExpenseUpdateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueUpdateWithoutLocationDataInput {
  active?: boolean ;
  company?: CompanyUpdateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutVenuesInput ;
  image?: ImageUpdateOneWithoutDEPRECATEDvenuesInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVenueNameInput ;
  orders?: OrderUpdateManyWithoutVenueInput ;
  menus?: AppliedMenuUpdateManyWithoutVenueInput ;
  users?: UserUpdateManyWithoutVenuesInput ;
  availabilities?: AvailabilityUpdateManyWithoutVenueInput ;
  stampCards?: StampCardUpdateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferUpdateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsUpdateOneWithoutVenuesInput ;
  tables?: TableUpdateManyWithoutVenueInput ;
  reports?: ReportUpdateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataUpdateOneWithoutVenueInput ;
  posDevices?: POSDeviceUpdateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateUpdateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutVenueInput ;
  floorPlans?: FloorPlanUpdateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutVenueInput ;
  expenses?: ExpenseUpdateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueUpdateWithoutMenusDataInput {
  active?: boolean ;
  company?: CompanyUpdateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutVenuesInput ;
  image?: ImageUpdateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationUpdateOneWithoutVenueInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVenueNameInput ;
  orders?: OrderUpdateManyWithoutVenueInput ;
  users?: UserUpdateManyWithoutVenuesInput ;
  availabilities?: AvailabilityUpdateManyWithoutVenueInput ;
  stampCards?: StampCardUpdateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferUpdateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsUpdateOneWithoutVenuesInput ;
  tables?: TableUpdateManyWithoutVenueInput ;
  reports?: ReportUpdateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataUpdateOneWithoutVenueInput ;
  posDevices?: POSDeviceUpdateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateUpdateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutVenueInput ;
  floorPlans?: FloorPlanUpdateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutVenueInput ;
  expenses?: ExpenseUpdateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueUpdateWithoutNameLangDataInput {
  active?: boolean ;
  company?: CompanyUpdateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutVenuesInput ;
  image?: ImageUpdateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationUpdateOneWithoutVenueInput ;
  name?: string ;
  orders?: OrderUpdateManyWithoutVenueInput ;
  menus?: AppliedMenuUpdateManyWithoutVenueInput ;
  users?: UserUpdateManyWithoutVenuesInput ;
  availabilities?: AvailabilityUpdateManyWithoutVenueInput ;
  stampCards?: StampCardUpdateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferUpdateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsUpdateOneWithoutVenuesInput ;
  tables?: TableUpdateManyWithoutVenueInput ;
  reports?: ReportUpdateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataUpdateOneWithoutVenueInput ;
  posDevices?: POSDeviceUpdateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateUpdateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutVenueInput ;
  floorPlans?: FloorPlanUpdateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutVenueInput ;
  expenses?: ExpenseUpdateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueUpdateWithoutOffersDataInput {
  active?: boolean ;
  company?: CompanyUpdateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutVenuesInput ;
  image?: ImageUpdateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationUpdateOneWithoutVenueInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVenueNameInput ;
  orders?: OrderUpdateManyWithoutVenueInput ;
  menus?: AppliedMenuUpdateManyWithoutVenueInput ;
  users?: UserUpdateManyWithoutVenuesInput ;
  availabilities?: AvailabilityUpdateManyWithoutVenueInput ;
  stampCards?: StampCardUpdateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsUpdateOneWithoutVenuesInput ;
  tables?: TableUpdateManyWithoutVenueInput ;
  reports?: ReportUpdateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataUpdateOneWithoutVenueInput ;
  posDevices?: POSDeviceUpdateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateUpdateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutVenueInput ;
  floorPlans?: FloorPlanUpdateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutVenueInput ;
  expenses?: ExpenseUpdateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueUpdateWithoutOrdersDataInput {
  active?: boolean ;
  company?: CompanyUpdateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutVenuesInput ;
  image?: ImageUpdateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationUpdateOneWithoutVenueInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVenueNameInput ;
  menus?: AppliedMenuUpdateManyWithoutVenueInput ;
  users?: UserUpdateManyWithoutVenuesInput ;
  availabilities?: AvailabilityUpdateManyWithoutVenueInput ;
  stampCards?: StampCardUpdateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferUpdateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsUpdateOneWithoutVenuesInput ;
  tables?: TableUpdateManyWithoutVenueInput ;
  reports?: ReportUpdateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataUpdateOneWithoutVenueInput ;
  posDevices?: POSDeviceUpdateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateUpdateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutVenueInput ;
  floorPlans?: FloorPlanUpdateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutVenueInput ;
  expenses?: ExpenseUpdateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueUpdateWithoutPaymentMethodsDataInput {
  active?: boolean ;
  company?: CompanyUpdateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutVenuesInput ;
  image?: ImageUpdateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationUpdateOneWithoutVenueInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVenueNameInput ;
  orders?: OrderUpdateManyWithoutVenueInput ;
  menus?: AppliedMenuUpdateManyWithoutVenueInput ;
  users?: UserUpdateManyWithoutVenuesInput ;
  availabilities?: AvailabilityUpdateManyWithoutVenueInput ;
  stampCards?: StampCardUpdateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferUpdateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsUpdateOneWithoutVenuesInput ;
  tables?: TableUpdateManyWithoutVenueInput ;
  reports?: ReportUpdateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataUpdateOneWithoutVenueInput ;
  posDevices?: POSDeviceUpdateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateUpdateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutVenueInput ;
  floorPlans?: FloorPlanUpdateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutVenueInput ;
  expenses?: ExpenseUpdateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueUpdateWithoutPosDevicesDataInput {
  active?: boolean ;
  company?: CompanyUpdateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutVenuesInput ;
  image?: ImageUpdateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationUpdateOneWithoutVenueInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVenueNameInput ;
  orders?: OrderUpdateManyWithoutVenueInput ;
  menus?: AppliedMenuUpdateManyWithoutVenueInput ;
  users?: UserUpdateManyWithoutVenuesInput ;
  availabilities?: AvailabilityUpdateManyWithoutVenueInput ;
  stampCards?: StampCardUpdateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferUpdateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsUpdateOneWithoutVenuesInput ;
  tables?: TableUpdateManyWithoutVenueInput ;
  reports?: ReportUpdateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataUpdateOneWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateUpdateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutVenueInput ;
  floorPlans?: FloorPlanUpdateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutVenueInput ;
  expenses?: ExpenseUpdateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueUpdateWithoutPosMetadataDataInput {
  active?: boolean ;
  company?: CompanyUpdateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutVenuesInput ;
  image?: ImageUpdateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationUpdateOneWithoutVenueInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVenueNameInput ;
  orders?: OrderUpdateManyWithoutVenueInput ;
  menus?: AppliedMenuUpdateManyWithoutVenueInput ;
  users?: UserUpdateManyWithoutVenuesInput ;
  availabilities?: AvailabilityUpdateManyWithoutVenueInput ;
  stampCards?: StampCardUpdateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferUpdateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsUpdateOneWithoutVenuesInput ;
  tables?: TableUpdateManyWithoutVenueInput ;
  reports?: ReportUpdateManyWithoutVenueInput ;
  legalName?: string ;
  posDevices?: POSDeviceUpdateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateUpdateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutVenueInput ;
  floorPlans?: FloorPlanUpdateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutVenueInput ;
  expenses?: ExpenseUpdateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueUpdateWithoutPredefinedMessagesDataInput {
  active?: boolean ;
  company?: CompanyUpdateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutVenuesInput ;
  image?: ImageUpdateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationUpdateOneWithoutVenueInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVenueNameInput ;
  orders?: OrderUpdateManyWithoutVenueInput ;
  menus?: AppliedMenuUpdateManyWithoutVenueInput ;
  users?: UserUpdateManyWithoutVenuesInput ;
  availabilities?: AvailabilityUpdateManyWithoutVenueInput ;
  stampCards?: StampCardUpdateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferUpdateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsUpdateOneWithoutVenuesInput ;
  tables?: TableUpdateManyWithoutVenueInput ;
  reports?: ReportUpdateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataUpdateOneWithoutVenueInput ;
  posDevices?: POSDeviceUpdateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateUpdateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutVenueInput ;
  floorPlans?: FloorPlanUpdateManyWithoutVenueInput ;
  expenses?: ExpenseUpdateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueUpdateWithoutReceiptTemplateDataInput {
  active?: boolean ;
  company?: CompanyUpdateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutVenuesInput ;
  image?: ImageUpdateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationUpdateOneWithoutVenueInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVenueNameInput ;
  orders?: OrderUpdateManyWithoutVenueInput ;
  menus?: AppliedMenuUpdateManyWithoutVenueInput ;
  users?: UserUpdateManyWithoutVenuesInput ;
  availabilities?: AvailabilityUpdateManyWithoutVenueInput ;
  stampCards?: StampCardUpdateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferUpdateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsUpdateOneWithoutVenuesInput ;
  tables?: TableUpdateManyWithoutVenueInput ;
  reports?: ReportUpdateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataUpdateOneWithoutVenueInput ;
  posDevices?: POSDeviceUpdateManyWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutVenueInput ;
  floorPlans?: FloorPlanUpdateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutVenueInput ;
  expenses?: ExpenseUpdateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueUpdateWithoutStampCardsDataInput {
  active?: boolean ;
  company?: CompanyUpdateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutVenuesInput ;
  image?: ImageUpdateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationUpdateOneWithoutVenueInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVenueNameInput ;
  orders?: OrderUpdateManyWithoutVenueInput ;
  menus?: AppliedMenuUpdateManyWithoutVenueInput ;
  users?: UserUpdateManyWithoutVenuesInput ;
  availabilities?: AvailabilityUpdateManyWithoutVenueInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferUpdateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsUpdateOneWithoutVenuesInput ;
  tables?: TableUpdateManyWithoutVenueInput ;
  reports?: ReportUpdateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataUpdateOneWithoutVenueInput ;
  posDevices?: POSDeviceUpdateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateUpdateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutVenueInput ;
  floorPlans?: FloorPlanUpdateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutVenueInput ;
  expenses?: ExpenseUpdateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueUpdateWithoutTablesDataInput {
  active?: boolean ;
  company?: CompanyUpdateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutVenuesInput ;
  image?: ImageUpdateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationUpdateOneWithoutVenueInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVenueNameInput ;
  orders?: OrderUpdateManyWithoutVenueInput ;
  menus?: AppliedMenuUpdateManyWithoutVenueInput ;
  users?: UserUpdateManyWithoutVenuesInput ;
  availabilities?: AvailabilityUpdateManyWithoutVenueInput ;
  stampCards?: StampCardUpdateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferUpdateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsUpdateOneWithoutVenuesInput ;
  reports?: ReportUpdateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataUpdateOneWithoutVenueInput ;
  posDevices?: POSDeviceUpdateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateUpdateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutVenueInput ;
  floorPlans?: FloorPlanUpdateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutVenueInput ;
  expenses?: ExpenseUpdateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueUpdateWithoutUsersDataInput {
  active?: boolean ;
  company?: CompanyUpdateOneWithoutVenuesInput ;
  deliveryRates?: DeliveryRateUpdateManyWithoutVenuesInput ;
  image?: ImageUpdateOneWithoutDEPRECATEDvenuesInput ;
  location?: LocationUpdateOneWithoutVenueInput ;
  name?: string ;
  nameLang?: TranslatedStringUpdateOneWithoutVenueNameInput ;
  orders?: OrderUpdateManyWithoutVenueInput ;
  menus?: AppliedMenuUpdateManyWithoutVenueInput ;
  availabilities?: AvailabilityUpdateManyWithoutVenueInput ;
  stampCards?: StampCardUpdateManyWithoutVenuesInput ;
  organizationId?: string ;
  phone?: string ;
  minimumDeliveryFee?: number ;
  supportEmail?: string ;
  lastSeenOnline?: any ;
  lastSeenVersion?: string ;
  bookingServiceId?: string ;
  openingSoon?: boolean ;
  offers?: OfferUpdateManyWithoutVenuesInput ;
  deleted?: boolean ;
  localDeliveries?: LocalDeliveryOptionsUpdateOneWithoutVenuesInput ;
  tables?: TableUpdateManyWithoutVenueInput ;
  reports?: ReportUpdateManyWithoutVenueInput ;
  legalName?: string ;
  posMetadata?: PosMetadataUpdateOneWithoutVenueInput ;
  posDevices?: POSDeviceUpdateManyWithoutVenueInput ;
  receiptTemplate?: ReceiptTemplateUpdateOneWithoutVenueInput ;
  staffIdleTimeout?: number ;
  invoiceTargets?: InvoiceTargetUpdateManyWithoutVenueInput ;
  paymentMethods?: PaymentMethodUpdateManyWithoutVenueInput ;
  floorPlans?: FloorPlanUpdateManyWithoutVenueInput ;
  predefinedMessages?: PredefinedMessageUpdateManyWithoutVenueInput ;
  expenses?: ExpenseUpdateManyWithoutVenueInput ;
  printBong?: boolean ;
  timezone?: string ;
}

export interface VenueUpsertWithWhereUniqueWithoutCompanyInput {
  where: VenueWhereUniqueInput;
  update: VenueUpdateWithoutCompanyDataInput;
  create: VenueCreateWithoutCompanyInput;
}

export interface VenueUpsertWithWhereUniqueWithoutDeliveryRatesInput {
  where: VenueWhereUniqueInput;
  update: VenueUpdateWithoutDeliveryRatesDataInput;
  create: VenueCreateWithoutDeliveryRatesInput;
}

export interface VenueUpsertWithWhereUniqueWithoutImageInput {
  where: VenueWhereUniqueInput;
  update: VenueUpdateWithoutImageDataInput;
  create: VenueCreateWithoutImageInput;
}

export interface VenueUpsertWithWhereUniqueWithoutLocalDeliveriesInput {
  where: VenueWhereUniqueInput;
  update: VenueUpdateWithoutLocalDeliveriesDataInput;
  create: VenueCreateWithoutLocalDeliveriesInput;
}

export interface VenueUpsertWithWhereUniqueWithoutOffersInput {
  where: VenueWhereUniqueInput;
  update: VenueUpdateWithoutOffersDataInput;
  create: VenueCreateWithoutOffersInput;
}

export interface VenueUpsertWithWhereUniqueWithoutStampCardsInput {
  where: VenueWhereUniqueInput;
  update: VenueUpdateWithoutStampCardsDataInput;
  create: VenueCreateWithoutStampCardsInput;
}

export interface VenueUpsertWithWhereUniqueWithoutUsersInput {
  where: VenueWhereUniqueInput;
  update: VenueUpdateWithoutUsersDataInput;
  create: VenueCreateWithoutUsersInput;
}

export interface VenueUpsertWithoutAvailabilitiesInput {
  update: VenueUpdateWithoutAvailabilitiesDataInput;
  create: VenueCreateWithoutAvailabilitiesInput;
}

export interface VenueUpsertWithoutExpensesInput {
  update: VenueUpdateWithoutExpensesDataInput;
  create: VenueCreateWithoutExpensesInput;
}

export interface VenueUpsertWithoutFloorPlansInput {
  update: VenueUpdateWithoutFloorPlansDataInput;
  create: VenueCreateWithoutFloorPlansInput;
}

export interface VenueUpsertWithoutInvoiceTargetsInput {
  update: VenueUpdateWithoutInvoiceTargetsDataInput;
  create: VenueCreateWithoutInvoiceTargetsInput;
}

export interface VenueUpsertWithoutLocationInput {
  update: VenueUpdateWithoutLocationDataInput;
  create: VenueCreateWithoutLocationInput;
}

export interface VenueUpsertWithoutMenusInput {
  update: VenueUpdateWithoutMenusDataInput;
  create: VenueCreateWithoutMenusInput;
}

export interface VenueUpsertWithoutNameLangInput {
  update: VenueUpdateWithoutNameLangDataInput;
  create: VenueCreateWithoutNameLangInput;
}

export interface VenueUpsertWithoutOrdersInput {
  update: VenueUpdateWithoutOrdersDataInput;
  create: VenueCreateWithoutOrdersInput;
}

export interface VenueUpsertWithoutPaymentMethodsInput {
  update: VenueUpdateWithoutPaymentMethodsDataInput;
  create: VenueCreateWithoutPaymentMethodsInput;
}

export interface VenueUpsertWithoutPosDevicesInput {
  update: VenueUpdateWithoutPosDevicesDataInput;
  create: VenueCreateWithoutPosDevicesInput;
}

export interface VenueUpsertWithoutPosMetadataInput {
  update: VenueUpdateWithoutPosMetadataDataInput;
  create: VenueCreateWithoutPosMetadataInput;
}

export interface VenueUpsertWithoutPredefinedMessagesInput {
  update: VenueUpdateWithoutPredefinedMessagesDataInput;
  create: VenueCreateWithoutPredefinedMessagesInput;
}

export interface VenueUpsertWithoutReceiptTemplateInput {
  update: VenueUpdateWithoutReceiptTemplateDataInput;
  create: VenueCreateWithoutReceiptTemplateInput;
}

export interface VenueUpsertWithoutTablesInput {
  update: VenueUpdateWithoutTablesDataInput;
  create: VenueCreateWithoutTablesInput;
}

export interface VenueWhereInput {
  active?: boolean ;
  active_not?: boolean ;
  company?: CompanyWhereInput ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  deliveryRates_every?: DeliveryRateWhereInput ;
  deliveryRates_some?: DeliveryRateWhereInput ;
  deliveryRates_none?: DeliveryRateWhereInput ;
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  image?: ImageWhereInput ;
  location?: LocationWhereInput ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  nameLang?: TranslatedStringWhereInput ;
  orders_every?: OrderWhereInput ;
  orders_some?: OrderWhereInput ;
  orders_none?: OrderWhereInput ;
  updatedAt?: any ;
  updatedAt_not?: any ;
  updatedAt_in?: any[] ;
  updatedAt_not_in?: any[] ;
  updatedAt_lt?: any ;
  updatedAt_lte?: any ;
  updatedAt_gt?: any ;
  updatedAt_gte?: any ;
  menus_every?: AppliedMenuWhereInput ;
  menus_some?: AppliedMenuWhereInput ;
  menus_none?: AppliedMenuWhereInput ;
  users_every?: UserWhereInput ;
  users_some?: UserWhereInput ;
  users_none?: UserWhereInput ;
  availabilities_every?: AvailabilityWhereInput ;
  availabilities_some?: AvailabilityWhereInput ;
  availabilities_none?: AvailabilityWhereInput ;
  stampCards_every?: StampCardWhereInput ;
  stampCards_some?: StampCardWhereInput ;
  stampCards_none?: StampCardWhereInput ;
  organizationId?: string ;
  organizationId_not?: string ;
  organizationId_in?: string[] ;
  organizationId_not_in?: string[] ;
  organizationId_lt?: string ;
  organizationId_lte?: string ;
  organizationId_gt?: string ;
  organizationId_gte?: string ;
  organizationId_contains?: string ;
  organizationId_not_contains?: string ;
  organizationId_starts_with?: string ;
  organizationId_not_starts_with?: string ;
  organizationId_ends_with?: string ;
  organizationId_not_ends_with?: string ;
  phone?: string ;
  phone_not?: string ;
  phone_in?: string[] ;
  phone_not_in?: string[] ;
  phone_lt?: string ;
  phone_lte?: string ;
  phone_gt?: string ;
  phone_gte?: string ;
  phone_contains?: string ;
  phone_not_contains?: string ;
  phone_starts_with?: string ;
  phone_not_starts_with?: string ;
  phone_ends_with?: string ;
  phone_not_ends_with?: string ;
  minimumDeliveryFee?: number ;
  minimumDeliveryFee_not?: number ;
  minimumDeliveryFee_in?: number[] ;
  minimumDeliveryFee_not_in?: number[] ;
  minimumDeliveryFee_lt?: number ;
  minimumDeliveryFee_lte?: number ;
  minimumDeliveryFee_gt?: number ;
  minimumDeliveryFee_gte?: number ;
  supportEmail?: string ;
  supportEmail_not?: string ;
  supportEmail_in?: string[] ;
  supportEmail_not_in?: string[] ;
  supportEmail_lt?: string ;
  supportEmail_lte?: string ;
  supportEmail_gt?: string ;
  supportEmail_gte?: string ;
  supportEmail_contains?: string ;
  supportEmail_not_contains?: string ;
  supportEmail_starts_with?: string ;
  supportEmail_not_starts_with?: string ;
  supportEmail_ends_with?: string ;
  supportEmail_not_ends_with?: string ;
  lastSeenOnline?: any ;
  lastSeenOnline_not?: any ;
  lastSeenOnline_in?: any[] ;
  lastSeenOnline_not_in?: any[] ;
  lastSeenOnline_lt?: any ;
  lastSeenOnline_lte?: any ;
  lastSeenOnline_gt?: any ;
  lastSeenOnline_gte?: any ;
  lastSeenVersion?: string ;
  lastSeenVersion_not?: string ;
  lastSeenVersion_in?: string[] ;
  lastSeenVersion_not_in?: string[] ;
  lastSeenVersion_lt?: string ;
  lastSeenVersion_lte?: string ;
  lastSeenVersion_gt?: string ;
  lastSeenVersion_gte?: string ;
  lastSeenVersion_contains?: string ;
  lastSeenVersion_not_contains?: string ;
  lastSeenVersion_starts_with?: string ;
  lastSeenVersion_not_starts_with?: string ;
  lastSeenVersion_ends_with?: string ;
  lastSeenVersion_not_ends_with?: string ;
  bookingServiceId?: string ;
  bookingServiceId_not?: string ;
  bookingServiceId_in?: string[] ;
  bookingServiceId_not_in?: string[] ;
  bookingServiceId_lt?: string ;
  bookingServiceId_lte?: string ;
  bookingServiceId_gt?: string ;
  bookingServiceId_gte?: string ;
  bookingServiceId_contains?: string ;
  bookingServiceId_not_contains?: string ;
  bookingServiceId_starts_with?: string ;
  bookingServiceId_not_starts_with?: string ;
  bookingServiceId_ends_with?: string ;
  bookingServiceId_not_ends_with?: string ;
  openingSoon?: boolean ;
  openingSoon_not?: boolean ;
  offers_every?: OfferWhereInput ;
  offers_some?: OfferWhereInput ;
  offers_none?: OfferWhereInput ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  localDeliveries?: LocalDeliveryOptionsWhereInput ;
  tables_every?: TableWhereInput ;
  tables_some?: TableWhereInput ;
  tables_none?: TableWhereInput ;
  reports_every?: ReportWhereInput ;
  reports_some?: ReportWhereInput ;
  reports_none?: ReportWhereInput ;
  legalName?: string ;
  legalName_not?: string ;
  legalName_in?: string[] ;
  legalName_not_in?: string[] ;
  legalName_lt?: string ;
  legalName_lte?: string ;
  legalName_gt?: string ;
  legalName_gte?: string ;
  legalName_contains?: string ;
  legalName_not_contains?: string ;
  legalName_starts_with?: string ;
  legalName_not_starts_with?: string ;
  legalName_ends_with?: string ;
  legalName_not_ends_with?: string ;
  posMetadata?: PosMetadataWhereInput ;
  posDevices_every?: POSDeviceWhereInput ;
  posDevices_some?: POSDeviceWhereInput ;
  posDevices_none?: POSDeviceWhereInput ;
  receiptTemplate?: ReceiptTemplateWhereInput ;
  staffIdleTimeout?: number ;
  staffIdleTimeout_not?: number ;
  staffIdleTimeout_in?: number[] ;
  staffIdleTimeout_not_in?: number[] ;
  staffIdleTimeout_lt?: number ;
  staffIdleTimeout_lte?: number ;
  staffIdleTimeout_gt?: number ;
  staffIdleTimeout_gte?: number ;
  invoiceTargets_every?: InvoiceTargetWhereInput ;
  invoiceTargets_some?: InvoiceTargetWhereInput ;
  invoiceTargets_none?: InvoiceTargetWhereInput ;
  paymentMethods_every?: PaymentMethodWhereInput ;
  paymentMethods_some?: PaymentMethodWhereInput ;
  paymentMethods_none?: PaymentMethodWhereInput ;
  floorPlans_every?: FloorPlanWhereInput ;
  floorPlans_some?: FloorPlanWhereInput ;
  floorPlans_none?: FloorPlanWhereInput ;
  predefinedMessages_every?: PredefinedMessageWhereInput ;
  predefinedMessages_some?: PredefinedMessageWhereInput ;
  predefinedMessages_none?: PredefinedMessageWhereInput ;
  expenses_every?: ExpenseWhereInput ;
  expenses_some?: ExpenseWhereInput ;
  expenses_none?: ExpenseWhereInput ;
  printBong?: boolean ;
  printBong_not?: boolean ;
  timezone?: string ;
  timezone_not?: string ;
  timezone_in?: string[] ;
  timezone_not_in?: string[] ;
  timezone_lt?: string ;
  timezone_lte?: string ;
  timezone_gt?: string ;
  timezone_gte?: string ;
  timezone_contains?: string ;
  timezone_not_contains?: string ;
  timezone_starts_with?: string ;
  timezone_not_starts_with?: string ;
  timezone_ends_with?: string ;
  timezone_not_ends_with?: string ;
  AND?: VenueWhereInput[] ;
  OR?: VenueWhereInput[] ;
  NOT?: VenueWhereInput[] ;
}

export interface VenueWhereUniqueInput {
  id?: string ;
}

export interface VenuelocationLocation {
  city?: string ;
  lat: string;
  long: string;
  name: string;
  street?: string ;
  zip?: number ;
}

export interface ZoneCreateInput {
  id?: string ;
  name: string;
  deleted?: boolean ;
  tables?: TableCreateManyInput ;
  company: CompanyCreateOneWithoutZonesInput;
}

export interface ZoneCreateManyWithoutCompanyInput {
  create?: ZoneCreateWithoutCompanyInput[] ;
  connect?: ZoneWhereUniqueInput[] ;
}

export interface ZoneCreateOneInput {
  create?: ZoneCreateInput ;
  connect?: ZoneWhereUniqueInput ;
}

export interface ZoneCreateWithoutCompanyInput {
  id?: string ;
  name: string;
  deleted?: boolean ;
  tables?: TableCreateManyInput ;
}

export interface ZoneScalarWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  AND?: ZoneScalarWhereInput[] ;
  OR?: ZoneScalarWhereInput[] ;
  NOT?: ZoneScalarWhereInput[] ;
}

export interface ZoneUpdateDataInput {
  name?: string ;
  deleted?: boolean ;
  tables?: TableUpdateManyInput ;
  company?: CompanyUpdateOneRequiredWithoutZonesInput ;
}

export interface ZoneUpdateInput {
  name?: string ;
  deleted?: boolean ;
  tables?: TableUpdateManyInput ;
  company?: CompanyUpdateOneRequiredWithoutZonesInput ;
}

export interface ZoneUpdateManyDataInput {
  name?: string ;
  deleted?: boolean ;
}

export interface ZoneUpdateManyWithWhereNestedInput {
  where: ZoneScalarWhereInput;
  data: ZoneUpdateManyDataInput;
}

export interface ZoneUpdateManyWithoutCompanyInput {
  create?: ZoneCreateWithoutCompanyInput[] ;
  connect?: ZoneWhereUniqueInput[] ;
  set?: ZoneWhereUniqueInput[] ;
  disconnect?: ZoneWhereUniqueInput[] ;
  update?: ZoneUpdateWithWhereUniqueWithoutCompanyInput[] ;
  upsert?: ZoneUpsertWithWhereUniqueWithoutCompanyInput[] ;
  deleteMany?: ZoneScalarWhereInput[] ;
  updateMany?: ZoneUpdateManyWithWhereNestedInput[] ;
}

export interface ZoneUpdateOneInput {
  create?: ZoneCreateInput ;
  update?: ZoneUpdateDataInput ;
  upsert?: ZoneUpsertNestedInput ;
  disconnect?: boolean ;
  connect?: ZoneWhereUniqueInput ;
}

export interface ZoneUpdateWithWhereUniqueWithoutCompanyInput {
  where: ZoneWhereUniqueInput;
  data: ZoneUpdateWithoutCompanyDataInput;
}

export interface ZoneUpdateWithoutCompanyDataInput {
  name?: string ;
  deleted?: boolean ;
  tables?: TableUpdateManyInput ;
}

export interface ZoneUpsertNestedInput {
  update: ZoneUpdateDataInput;
  create: ZoneCreateInput;
}

export interface ZoneUpsertWithWhereUniqueWithoutCompanyInput {
  where: ZoneWhereUniqueInput;
  update: ZoneUpdateWithoutCompanyDataInput;
  create: ZoneCreateWithoutCompanyInput;
}

export interface ZoneWhereInput {
  id?: string ;
  id_not?: string ;
  id_in?: string[] ;
  id_not_in?: string[] ;
  id_lt?: string ;
  id_lte?: string ;
  id_gt?: string ;
  id_gte?: string ;
  id_contains?: string ;
  id_not_contains?: string ;
  id_starts_with?: string ;
  id_not_starts_with?: string ;
  id_ends_with?: string ;
  id_not_ends_with?: string ;
  name?: string ;
  name_not?: string ;
  name_in?: string[] ;
  name_not_in?: string[] ;
  name_lt?: string ;
  name_lte?: string ;
  name_gt?: string ;
  name_gte?: string ;
  name_contains?: string ;
  name_not_contains?: string ;
  name_starts_with?: string ;
  name_not_starts_with?: string ;
  name_ends_with?: string ;
  name_not_ends_with?: string ;
  createdAt?: any ;
  createdAt_not?: any ;
  createdAt_in?: any[] ;
  createdAt_not_in?: any[] ;
  createdAt_lt?: any ;
  createdAt_lte?: any ;
  createdAt_gt?: any ;
  createdAt_gte?: any ;
  deleted?: boolean ;
  deleted_not?: boolean ;
  tables_every?: TableWhereInput ;
  tables_some?: TableWhereInput ;
  tables_none?: TableWhereInput ;
  company?: CompanyWhereInput ;
  AND?: ZoneWhereInput[] ;
  OR?: ZoneWhereInput[] ;
  NOT?: ZoneWhereInput[] ;
}

export interface ZoneWhereUniqueInput {
  id?: string ;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
